export const RATE_LIST = `
Particulars	MRP	Rate	Tax	Discount	Net Rate
Aristozym	148	105.71	12	7	110.107536
Combliflam	50.65	36.18	12	6	38.090304
Thyrox 62.5	180.32	120	12	7	124.992
Clavam Dry Syrup	68.88	49.2	12	7	51.24672
Clavam BID D/S	67.81	48.44	12	7	50.455104
Sinarest New	120	77.55	12	6	81.64464
Betadine	304	217.14	12	6	228.604992
Roxid-150	211.4	151	12	6	158.9728
Aciloc AD-20	168.6	120.42	12	6	126.778176
Manforce-100	255	22.77	12	7	23.717232
Uprise D3	118	84.29	12	7	87.796464
Dolo-120	40.32	28.8	12	6	30.32064
Livogen	92.07	66.29	12	6	69.790112
Bicosules	110	78.56	12	4	84.467712
Arkamin	87.7	62.7	12	4	67.41504
Ultracet	286.8	204.86	12	4	220.265472
Urimax-D	607.22	433.73	12	4	466.346496
Ursocol-300 MG	632	481.53	5	4	485.38224
Gluconorm G-2	317.2	226.57	12	4	243.608064
Piriton CS	137.25	98.13	12	4	105.509376
Levoflox 500 MG	100.68	71.91	12	4	77.317632
Atarax 10 MG	52.5	37.53	12	4	40.352256
Augmentin Duo	67.54	48.24	12	4	51.867648
Gabaneuron NT 400	269.5	192.5	12	6	202.664
Glipon MF 20/500	164	117.14	12	6	123.324992
Folinext	107	76.43	12	6	80.465504
Gluconorm G-2	249.86	178.43	12	6	187.851104
Thromrophob	145	96	12		107.52
Amlosafe 5	42	647	12	5	688.408
Vertin 16	3578.7	2756.89	12	5	2933.33096
Dolo 650	1080.32	831.05	12	5	884.2372
Benadryl 50 ML	79	65.7	12	12	64.75392
Dexorange	170.3	131.22	12	5	139.61808
Pantocid 40	188	1447.6	12	5	1540.2464
Ornof	155	1193.56	12	5	1269.94784
Aceclo Plus	99.45	765.77	12	5	814.77928
Amlosafe 2.5	601.4	463.16	12	4	497.989632
Ambrodil S	36.15	27.86	12	5	29.64304
Asthalin	176.98	136.37	12	4	146.625024
Benadryl 150 ML	155	128.34	12	12	126.491904
Pantop-D SR	2100	1617.08	12	5	1720.57312
Betnovate-N	60.8	46.83	12	4	50.351616
Cyston	123.56	45.02	12		50.4224
Volini	200	154	12	8	158.6816
T-Bact 5 GM	76	58.52	12	5	62.26528
Kayam-Churan 100 GM	113.6	87.49	5	3	89.108565
Vicks	105.8	86	12	5	91.504
Moov 20 GM	69	57.27	12	5	60.93528
Saridon	99	82.5	12	3	89.628
Becosules	30	38.5	12	4	41.3952
Electral B Powder	60.49	49	12	4	52.6848
Zincovit	22.3	16.99	12	5	18.07736
Mycoderm	110	89.05	12	4	95.74656
Ascabiol 50 ML	104.88	80.32	12	5	85.46048
Calpol 250 MG	45.02	34.67	12	4	37.277184
Lukol	210	148.76	12	8	153.282304
Taxim O CV 200 MG	270	192.86	12	7	200.882976
Taxim O Forte	156.06	111.47	12	7	116.107152
Zerodol SP	130.1	92.93	12	6	97.836704
Zyloric 100 MG	21.17	15.13	12	6	15.928864
A to Z	210	142.37	18	7	156.236838
Noworm	20.05	14.32	12	7	14.915712
Lantus	640.83	512.66	5	7	500.61249
Ondem MD4	57.51	41.08	12	7	42.788928
Lumerax 80	171.43	122.46	12	7	127.554336
Crocin 120	67.2	49.05	12	7	51.09048
Lantus Solostar	769.01	615.21	5	7	600.752565
Betadine	107.52	80.64	12	7	83.994624
Human Mixtard 40	178.29	142.63	5	7	139.278195
Stayfree 6-XL	42	37.5	0	6	35.25
Stayfree 18-XL	124	110.71	0	6	104.0674
Whisper 6-XL	40	33.6	0	0	33.6
Whisper 18-XL	110	99.1	0	6.5	92.6585
BD Pen Needle 4 MM	96	67	12	0	75.04
Amitone 10 MG	21.47	15.34	12	6	16.149952
Candid 120 GM	159	113.57	12	6	119.566496
Rosuvas 5 MG	192	137.14	12	6	144.380992
Candibiotic Plus	101	72.14	12	6	75.948992
Rosuvas 10 MG	339	242.14	12	6	254.924992
Decolic	80	57.14	12	6	60.156992
Azithral 100 MG	55.5	39.64	12	6	41.732992
Azithral 200 MG	57.28	40.91	12	6	43.070048
Glycomet GP 3 Fort	122.85	87.75	12	7	91.4004
Glycomet GP 3 Fort	122.85	87.75	12	7	91.4004
MVI	302.5	216.1	12	7	225.08976
Meftal Spas 60 ML	92	65.71	12	7	68.443536
Meftal Spas	52	37.14	12	7	38.685024
Rosulip 5	191.63	136.88	12	7	142.574208
R.B Tone	199	142.14	12	7	148.053024
KZ Lotion	305	217.86	12	7	226.922976
Montair LC Kid	153.86	109.9	12	7	114.47184
Vidaglo M 50/1000	114	81.43	12	7	84.817488
Strepsils	840	634.33	12	4	682.031616
Veet Cream Dry	99	78.91	18	0	93.1138
Aptamil Gold 2R	975	751.16	18	2	868.641424
Vicks Jar 275	370	277.81	12	4	298.701312
Dettol 60 ML	40.24	32.43	12	0	36.3216
Karvol Plus	151.5	108.21	12	7	112.711536
Zandu Balm 10 GM	45	36.2	12	0	40.544
Savlon 50 ML	29	22.45	12	0	25.144
Dexolac 2	460	354.39	18	2.5	407.725695
Aptamil Gold 1R	975	751.16	18	2	868.641424
Lal Tail 100 ML	135	96.43	12	2	105.841568
Himalaya Baby Powder	55	37.91	18	10	40.26042
Montair LC	370	264.34	12	6	278.297152
Volini Gel 30 GM	156	111.43	12	7	116.065488
Ciplox	17.24	12.34	12	6	12.991552
Monocef-O 100	199	127.96	12	7	133.283136
Betnovate-N	60	43.45	12	6	45.74416
Betnovate-C	70.85	50.63	12	6	53.303264
Allegra M	275.84	197.03	12	6	207.433184
Gabaneuron SR	350	250	12	6	263.2
Voveran Emulgel	165.5	118.22	12	6	124.462016
Clavam 375 MG	218.5	156.07	12	7	162.562512
Nevelon	288	230.4	0	6	216.576
Zifi	34.76	39.11	12	6	41.175008
Bilafav 20 MG	179.68	128.34	12	6	135.116352
Monocef-O 50	109	77.86	12	6	81.971008
Telmed AM	162.5	116.07	12	6	122.198496
Ciplox-D	26.55	18.96	12	6	19.961088
Waxort	115	82.14	12	6	86.476992
Calpol	30.07	21.48	12	6	22.614144
Tryptometer 25 MG	83.5	59.64	12	6	62.788992
CCM	545	389.85	12	6	410.43408
Telma 40	227.14	162	12	6	170.5536
Trenaxa MF	532.4	380.29	12	6	400.369312
Geminor-MP2	286.5	204.64	12	6	215.444992
Johnson Baby	75	65.25	12		73.08
Dr. Ortho 60 ML	248	150	12		168
Cetcip	21.05	5.1	12	10.7	5.100816
Medisalic	63	23	18		27.14
Ketocip	137.5	39.77	18		46.9286
Medisalic	159	53	12		59.36
`;

export const MEDICINE_TYPE = `
Dry Syrup
Tablet
Tablet
Infusion
Syringe
Syringe
Syringe
Syringe
Tablet
Syringe
Syringe
Plaster
Liquid
Syringe
Syringe
Syringe
Syringe
Injection
Injection
Injection
Suspension
Cream
Syringe
Bolus
Injection
Injection
Tablet
Suture
Suture
Injection
Injection
Bolus
Bolus
Syringe
Syringe
Eye Drop
Eye Drop
Eye Ointment
Eye Drop
Eye Drop
Eye Drop
Needle
Suture
Suture
Suture
Tablet Kit
Syringe
Sutures
Shampoo 
Eye Drop
Ors
Air Freshener
DROP
Capsule
DROP
Capsule
Syrup



Syrup
Capsule
Tablet


DROP
DROP


Capsule

Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Belt
Injection


Injection

Tablet




Tablet
Tablet
Syrup
Syrup


Tablet
Tablet
Injection
Drop
Tablet
Tablet
Drop


Capsule
Capsule



Syrup


Syrup
Syrup


Tablet
Capsule
Syrup
Capsule

Injection 




Injection
Cream
Cream
Cream
Cream
Cream
Cream
Syrup
Tablet
Tablet
Syrup
Drops
Suspension (or Syrup)
Injection
Powder (or Granules)
Powder (or Granules)
Powder (or Granules)
Powder (or Granules)
Bolus
Drops
Powder
Powder
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Test Strips
Test Strips
Test Strips
Test Strips
Blood glucose meter kit
Test strips for Accu-Chek Integra
Complete kit for Accu-Chek Integra
Test strips for Accu-Chek Comfort Sensor
Lancing device kit
Lancets for Accu-Chek Softclix
Blood glucose meter kit
Complete kit for AccuCheck Go
Test strips for AccuCheck Go
Test strips for AccuCheck Go
Blood glucose meter
Blood pressure monitor
Blood pressure monitor
Glucose test strips for AccuSure
Tablet
Tablet
Tablet
Powder
Powder
Powder
Powder
Powder
Powder
Powder
Powder
Medical Bolus
Gel
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule 
Syrup 
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Gel
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Gel
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet

Gel
Tablet

Tablet
Tablet
Tablet
Tablet
Gel
Injection
Tablet
Tablet

Capsule
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet

Tablet

Ampoule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Suspension/Oral Solution
Oral Suspension
Powder (Oral)
Oral Suspension
Suspension/Oral Solution
Capsule
liquid
Tablet
Gel
Oral Medicine (Tablet/Capsule)
Oral Medicine (Tablet/Capsule)
Oral Medicine (Suspension)
Oral Medicine (Tablet/Capsule)
Tablet
Injectable/Suspension
Oral Medicine (Liquid)
Gel
Tablet
Tablet
Bolus
Absorbable
Pill
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Bolus
Syrup
Syrup
Tablet
Tablet
Capsule
Tablet
Injection
Injection
Tablet
Liquid
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Ointment
Injection
Tablet
Tablet
Capsule

Soap
Ge
Tablet
Gel
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet


Injection

Syrup

Gel

Gel
Gel


Gel

Capsule
Syrup
Capsule
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Tablet
Tablet
Syrup
Tablet
Tablet
Powder
Tablet
Liquid
Liquid
Tablet
Tablet
Gel
Gel
Syrup
Syrup
Syrup
Tablet
Tablet


Injection
Tablet



Syrup
Injectable (I.V.)
Injectable (I.V.)
Injectable (I.V.)
Suspension (for kids)
Powder for Suspension (likely)
Injection
Injection
Injection
Tablet
Injection
Injection
Tablet
Tablet
Injection
Injection
Tablet
Tablet
Tablet
Not specified
Slow-release Tablet
Tablet
Tablet
Tablet
Eye Drop / Injectable
Injectable / Topical
Tablet
Tablet
Tablet
Tablet
Tablet

Tablet
Tablet
Syrup

Syrup
Syrup
Syrup


Oil
Oil

Gel
Gel
Gel
Gel
Gel
Tablet
Tablet
Gel
Liquid (Syrup/Suspension)
Liquid (Syrup/Suspension)
Tablet (Oral)
Tablet (Oral)
Likely an Eye Drop (E/D)
Capsule
Syrup
Capsule
Capsule
Syrup
Tablet


Capsule
Tablet



Injection
Tablet




Injection
Oil

Tablet
Tablet
Capsule
tablet
Capsule
Tablet

Tablet
Capsule
Capsule
Syrup

Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Capsule
Syrup
Capsule
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Syrup
Liquid
Capsule
Capsule

Tablet
Tablet
Tablet
Tablet
Cream
Soap
Soap
Tablet
Tablet
Tablet



Injection
Syrup
Softgel
Softgel
Capsule/Softgel
Tablet/Capsule
Sachets
Diaper
Diaper (Large Size)
Casule
Syrup
Injection
Injection
Tablet

Injection
Injection
Tablet
Drop
Syrup
Syrup
Syrup
Capsule
Capsule
Tablet
Tablet

Syrup
Tablet
Tablet
Inhaler (Mist)
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler (Respiratory)
Inhaler (Respiratory)
Inhaler (Respiratory)
Tablet
Tablet
Tablet
Tablet

Tablet

Tablet

Tablet
Tablet
Tablet
Lotion



Tablet
Tablet

Syrup
Capsule
Drop
Syrup
Syrup
Syrup


Powder
Powder
Powder
Powder
Powder
Bolus
Syrup
Syrup
Tablet
Skincare
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Tablet
Liquid
Tablet
Airway Plastic
Airway Steel
Air Freshener
Air Freshener
Air Freshener
Air Freshener
Air Freshener
Air Freshener
Air Freshener
Air Freshener
Air Freshener
Tablet
Tablet

Tablet
Dry Syrup
Dry Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Cream
Lotion
Soap
Syrup
Capsule
Capsule
Capsule



Capsule
Tablet
Tablet
Syrup
Tablet
Syrup
Tablet

Tablet

Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Tablet
Syrup
Syrup
Tablet
Tablet


Syrup
Syrup
Syrup
Tablet
Tablet
Liquid (Syrup/Suspension)
Powder 
Liquid (Suspension)
Liquid (Suspension)
Liquid (Suspension)
Likely a Injectable or Oral Bolus
Tablet
Syrup
Injectable (IV Solution)
Injectable (IV Solution)
Liquid (Suspension)
Tabet
Syrup
Liquid
Liquid
Liquid
Liquid
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Drop
Infusion

Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet


Syrup


Syrup
Drop


Syrup
Tabet
Tabet
Tabet

Bolus
Tabet
Tabet
Syrup
Syrup
Syrup
Tabet
Syrup
Tabet

Syrup
Water Jug
Tablet
Tablet
Tablet
Eye Drop
Eye Drop
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Injection
Drop
Drop
Syrup
Tablet

Syrup
Tablet
Tablet
Tablet
Injection
Injection
Injection
Tablet
Tablet
Tablet
Infusion

Drop
Syrup
Tablet
Syrup
Syrup
Drop
Syrup
Suger Free Syrup

Tablet
Capsule

Capsule


Capsule
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet





Tablet
Tablet




Syrup

Tablet
Tablet
Tablet
Capsule

Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Solution (Alkaline)
Syrup
Tablet or Capsule
Tablet or Capsule
Tablet (with B6)
Syrup
Syrup/ Solution
Syrup
Syrup
Tablet or Capsule
Syrup
Syrup
Syrup (Vitamin B6)
Syrup
Syrup
Syrup
Syrup
Bolus (IV/Injection)
Drops (Vitamin D3)
Suspension
Tablet
Tablet
Tablet (Antihistamine)
Tablet (Antihistamine)
Tablet (Antihistamine)
Tablet (Combination)
Suspension (Antihistamine)
Tablet
Tablet (Antihistamine)
Tablet (Cold/Allergy)
Tablet (Decongestant)
Tablet (Decongestant)
Tablet (Antihistamine)
Tablet (Antihistamine)
Tablet (Children’s)
Syrup (Children’s)
Tablet (Children’s)
Syrup (Antihistamine)
Syrup (Antihistamine)
Drops (Allergy relief)
Tablet (Allergy relief)
Tablet (Antihistamine)
Tablet (Antihistamine)
Injection (For allergies)
Syrup
Syrup (Digestive/Health)
Suspension (Digestive)
Tablet (Chronic conditions)
Tablet (Chronic conditions)
Tablet (Chronic conditions)
Tablet (Chronic conditions)
Tablet (Allergy relief)
Surgical instrument
Surgical instrument
Syrup (Digestive)
Drops (Health-related)
Syrup (Health-related)
Product (Health-related)
Tablet (For allergies)
Tablet (Allergy relief)
Capsule (Respiratory)
Reusable pen
Lotion (Skin care)
Capsule (Multivitamin)
Capsule (Multivitamin)
Capsule (Multivitamin)
Syrup
Syrup
Syrup (Health-related)
Syrup (Health-related)
Gel (Digestive health)
Tablet (Digestive)
Drops (Digestive)
Syrup (Digestive)
Tablet (Digestive)
Capsule (Digestive)
Tablet (Digestive/Health)
Tablet (Digestive/Health)
Tablet (Gastrointestinal)
Tablet (Gastrointestinal)
Capsule (Antibiotic)
Tablet (Antibiotic)
Capsule (Antibiotic)
Suspension (Antibiotic)
Capsule (Antibiotic)
Suspension (Antibiotic)
Drops (Antibiotic)
Tablet (Cardiovascular)
Tablet (Cardiovascular)
Tablet (Cardiovascular)
Tablet (Children's Health)
Tablet (Cardiovascular)
Cream (For skin)
Tablet (Pain relief)
Tablet (Pain relief)
Tablet (Pain relief)
Tablet (For pain/relief)
Gel (Oral health)
Tablet (Anti-inflammatory)
Cream (For skin)
Tablet (Pain/inflammation)
Tablet (Pain/inflammation)
Soap (Skin care)
Cream (Skin care)
Gel (For skin)
Body wash (For skin)
Cream (For skin)
Lotion (For skin)
Capsule (Health-related)
Syrup (Health-related)
Tablet (For pain/inflammation)
Tablet (For pain/inflammation)
Cream (For skin)
Treatment (Scalp)
Tablet (For gout)
Tablet (For gout)
Tablet (For respiratory)
Capsule (For health)
Tablet (Anxiety/health)
Liquid (For hair/scalp)
Shampoo (Hair care)
Drops (Health/Medicine)
Syrup (Health/Medicine)
Capsule (Vitamin D3)
Capsule (Vitamin D3)
Capsule (Vitamin D3, Health)
Capsule (Vitamin D3, Health)
Capsule (Pain relief)
Tablet (For blood pressure)
Eye drop (Glaucoma treatment)
Eye drop (Glaucoma treatment)
Eye drop (Glaucoma treatment)
Injection (Vitamins and minerals)
Injection (Vasodilation/vascular)
Tablet (Anxiolytic)
Tablet (Gastrointestinal)
Tablet (Gastrointestinal)
Tablet (Anxiolytic)
Tablet (Anxiolytic)
Tablet (Anxiolytic)
Tablet (Anxiolytic, Extended release)
Tablet (Anxiolytic, Extended release)
Tablet (Anxiolytic, Extended release)
Tablet (Anxiolytic)
Tablet (Anxiolytic)
Cardiac (Medical)
Cardiac (Medical)
Cardiac (Medical)
Tablet (For blood pressure)
Tablet (For blood pressure)
Tablet (For blood pressure)
Tablet
Tablet
Tablet
Tablet
Tablet
Powder
Syrup
Powder
Syrup
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Unknown
Tablet
Tablet
Tablet
Tablet
Unknown
Unknown
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Injection
Tablet
Injection
Tablet
Tablet
Tablet
Syrup
Ointment
Injection/Vial
Injection
Tablet
Syrup
Tablet
Injection
Syrup
Tablet
Tablet
Drop
Tablet
Powder
Syrup
Tablet
Tablet
Syrup
Syrup
Tablet
Dispersible Tablet
Tablet
Syrup
Tablet
Oil
Capsule
Tablet
Tonic
Tonic
Liquid
Powder
Tablet
Syrup
Tablet
Tablet
Tonic
Tonic
Tablet
Tablet
Tablet
Powder
Tablet
Tablet
Syrup
Syrup
Syrup
Capsule
Powder
Tonic
Powder
Powder
Powder
Liquid
Liquid
Tablet
Tablet
Tablet
Syrup
Syrup
Cream/Ointment
Syrup
Tablet
Injection
Powder
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Syrup
Syrup
Injection
Ampoule (Injection)
Syrup
Drops
Drops
Syrup
Syrup
Syrup
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Injection
Powder
Powder
Powder
Powder
Powder
Suspension
Syrup
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Tablet
Injection
Injection
Tablet
Syrup
Drops
Syrup
Syrup
Drops
Syrup
Syrup
Syrup
Capsule
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Tablet
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Tablet
Syrup
Syrup
Equipment
Equipment
Tablet
Tablet
Equipment
Tablet
Tablet
Tablet
Drops
Tablet
Tablet
Capsule
Capsule
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Equipment
Equipment
Equipment
Equipment
Equipment
Equipment
Equipment
Equipment
Equipment
Equipment
Equipment
Equipment
Equipment
Equipment
Equipment
Equipment
Equipment
Capsule
Tablet
Injection
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Tablet
Tablet
Tablet
Injection
Injection
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Softgel
Sachet
Syrup
Tablet
Drops
Capsule
Suspension
Injection
Liquid
Liquid
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Oil
Sachet
Powder
Liquid
Liquid
Oil
Oil
Oil
Oil
Oil
Oil
Oil
Tablet
Paste
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Liquid
Liquid
Liquid
Liquid
Liquid
Drops
Capsule
Tablet
Tablet
Injection
Injection
Tablet
Injection
Injection
Tablet
Tablet
Tablet
Injection
Tablet
Vial
Tablet
Vial
Capsule
Tablet
Vial
Bolus
Injection
Injection
Injection
Capsule
R/U
R/U
WS (Wet Sachets)
Capsule
Capsule
Injection
Injection
Injection
Vial
Injection
Capsule
Capsule
Injection
Capsule
Injection
Tablet
Injection
Tablet
Capsule
Injection
Injection
Syrup
Granules
Tablet
Capsule
Injection
Injection
Injection
Capsule
Injection
Capsule
Injection
Syrup
Tablet
Injection
Capsule
Capsule
Powder
Powder
Powder
Powder
Powder
Capsule
Powder
Tablet
Liquid
Liquid
Powder
Powder
Powder
Powder
-
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
-
Drop
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Softgel Capsule
Syrup
Tablet
Tablet
Capsule
Liquid
Liquid
Capsule
Liquid
Liquid
Capsule
Syrup
Bolus
Powder
Capsule
Tablet
Tablet
Tablet
Drops
Syrup
Liquid
Tablet
-
Suspension
Gel
Tablet
Tablet
Tablet
Syrup
Ampoule
Drop
Tablet
Tablet
Syrup
Tablet
Tablet
Vial
Tablet
-
Injection
Injection
Syrup
Syrup
Ampoule
Injection
Injection
Tablet
-
Bandage
Bandage
Gauze
Liquid
Injection
Injection
Tablet
Liquid
Tablet
Injection
Injection
Injection
Tablet
Tablet
Tablet
Syrup
Tablet
Injection
Injection
Injection
Injection
Syrup
Suspension
Suspension
Tablet
Drops
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Liquid
Bolus
Liquid
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Capsule
Tablet
Injection
Injection
-
-
Injection
Enema
Injection
Injection
Syrup
Injection
Tablet
Tablet
Tablet
Eye Drop
Liquid
Eye Drop
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Tablet
Tablet
Tablet
Syrup
Syrup
Liquid
Liquid
Injection
Powder
Liquid
Liquid
Liquid
Cream
Tablet
Injection
Injection
Injection
Injection
Syrup
Support
Support
Support
Support
Support
Support
Support
Kit
Support
Support
Support
Support
Support
-
Cream
Oil
Oil
Oil
Oil
Oil
Oil
Liquid
Liquid
Cream
Injection
Injection
Injection
Suspension
Suspension
Capsule
Tablet
Syrup
Tablet
Tablet
Syrup
Tablet
Syrup
Bolus
Syrup
-
Cream
Syrup
Suspension
Tablet
Capsule
Syrup
Syrup
Tablet
Capsule
Tablet
Injection
Drop
Tablet
Tablet
Syrup
Tablet
Suspension
Tablet
Syrup
Tablet
Syrup
Syrup
Tablet
Solution
Lotion
Solution
Tablet
-
Tablet
Tablet
Tablet
Syrup
Drop
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
-
-
Tablet
Tablet
Capsule
Capsule
Syrup
Tablet
Capsule
Tablet
Tablet
Syrup
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
-
-
Injection
Capsule
Eye Drop
Eye Drop
Eye Drop
Eye Drop
Eye Drop
Eye Drop
Eye Drop
Eye Drop
Eye Drop
Eye Drop
Tablet
Tablet
Blood Pressure
Blood Pressure
Syrup
Injection
Syrup
Syrup
Syrup
Drops
Syrup
Powder
Bolus
Powder
Powder
Drop
Syrup
Syrup
Cloth
-
Syrup
Syrup
Syrup
Syrup
-
Injection
-
-
Plastic
Plastic
Tablet
Tablet
Tablet
Tablet
Bolus
Cream
Capsule
Injection
Syrup
Syrup
Syrup
Suppository
-
-
-
Gel
Gel
Eye Drops
Capsule
Capsule
Soap
Injection
Syrup
Eye Drop
Gel
Nasal Spray
Cream
Lotion
Lotion
Soap
Capsule
Injection
Injection
Tablet
Tablet
Injection
Injection
Chewable Tablet
Tablet
Tablet
-
Syrup
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Suspension
-
Tablet
Tablet
Tablet
Tablet
Tablet
Drops
Tablet
Tablet
-
-
-
-
-
Cream
Cream
Tablet
Syrup
-
Tablet
Gel
Tablet
Tablet
Sachet
Sachet
Powder
Sachet
Sachet
Sachet
Sachet
Injection
Injection
Tablet
Injection
Syrup
Drops
Tablet
Tablet
Tablet
Syrup
-
Tablet
Capsule
Capsule
Suspension
Drops
Injection
Tablet
Tablet
-
Suspension
-
Suspension
Capsule
Capsule
Drops
Effervescent Tablet
Liquid
-
-
Syrup
Syrup
Syrup
Tablet
Gel
-
Tablet
Tablet
Tablet
Syrup
Injection
Sling
Sling
Sling
Sling
Sling
Sling
Sling Pouch
Sling
-
Syrup
Injection
Tablet
Tablet
Tablet
Tablet
Powder
Tablet
Paper Tape
Paper Tape
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
-
-
Tablet
Tablet
Tablet
Forcep
Forcep
Forcep
Forcep
Forcep
Forcep
Forcep
Injection
Oil
Syrup
Tablet
Capsule
Oil
Oil
Oil
Oil
Oil
Syrup
Capsule
Cast
Cast
Cast
Cast
Cast
Gel
Bandage
Bandage
Tablet
Syrup
Tablet
Tablet
Tablet
Injection
-
Tablet
Tablet
Injection
Injection
Capsule
Gel
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Nasal Spray
Tablet
Tablet
Tablet
Tablet
Liquid
Tablet
Lotion
Liquid
Liquid
Liquid
Liquid
Liquid
Liquid
Liquid
Liquid
Tablet
Syrup
Tablet
Syrup
Syrup
Syrup
Capsule
Syrup
Syrup
Syrup
Tablet
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Pump
Ointment
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Brace
Brace
Brace
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Powder
Powder
Syrup
Syrup
Tablet
Injection
Tablet
Syrup
Syrup
Syrup
Tablet
Syrup
Syrup
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Injection
Drop
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Granules
Granules
Tablet
Tablet
Tablet
Syrup
Injection
Suspension
Syrup
Capsule
-
Capsule
Capsule
Tablet
Tablet
Syrup
Tablet
Syrup
Syrup
Drops
Tablet
Tablet
Tablet
Tablet
Syrup
Inhaler
Solution
Respules
Rotacaps
Tablet
Tablet
Syrup
Syrup
Syrup
Tablet
Syrup
-
Capsule
Inhaler
Respules
-
Syrup
Oil
Capsule
Oil
Powder
Syrup
Tablet
Tablet
Syrup
BOLUS
Capsule
Syrup
Syrup
Syrup
Capsule
Syrup
Tablet
Capsule
Syrup
Syrup
Injection
Drop
Capsule
Capsule
Syrup
Capsule
Drop
Syrup
Drop
Soap
Drop
Capsule
Syrup
Syrup
Tablet
Tablet
Injection
Tablet
Tablet
Drop
Syrup
Injection
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Ointment
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Nasal Spray
Nasal Spray
Nasal Spray
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Injection
Eye Drop
Sutures
Sutures
Eye Drop
Ointment
Injection
Injection
Injection
Tablet
Capsule
Capsule
Ear Drop
Tablet
Dry Syrup
Dry Syrup
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Drops
Suspension
Injection
Injection
Tablet
Tablet
Suspension
Injection
Injection
Injection
Tablet
Tablet
Tablet
Syrup
Tablet
Syrup
Injection
Injection
Injection
Injection
Injection
Prosthesis
Prosthesis
Prosthesis
Prosthesis
Prosthesis
Prosthesis
Cream
Equipment Repair
Equipment
Equipment
Equipment
Equipment
Equipment Repair
Equipment
Equipment
Powder
Capsule
Syrup
Tablet
Drops
Injection
Tablet
Suspension
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Cream
Tablet
Tablet
Tablet
Injection
Tablet
Injection
Tablet
Injection
Eye/Ear Drop
Powder
Powder
Tablet
Tablet
Tablet
Drops
Tablet
Syrup
Tablet
Powder
Syrup
Tablet
Drops
Syrup
-
Drop
Nasal Spray
Nasal Drop
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Capsule
Injection
Injection
Tablet
Tablet
Injection
Capsule
Capsule
Syrup
Injection
Capsule
Capsule
Injection
Tablet
Tablet
Injection
Injection
Capsule
Tablet
Tablet
Tablet
Injection
Capsule
Powder
Powder
Capsule
Capsule
Syrup
Bolus
Syrup
Syrup
Syrup
Tablet
Tablet
Capsule
Syrup
Tablet
Tablet
Syrup
Suspension
Tablet
Tablet
Tablet
Suspension
Suspension
Tablet
Injection
Tablet
Suspension
Tablet
Tablet
Injection
Injection
Tablet
Tablet
Nasal Spray
Injection
Injection
Injection
Tablet
Tablet
Syrup
Nasal Spray
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Suspension
Injection
Injection
Tablet
Tablet
Tablet
Syrup
Syrup
Suspension
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Dispersible Tablet
Tablet
Syrup
Tablet
Tablet
Syrup
Dispersible Tablet
Syrup
Syrup
Tablet
Tablet
Tablet
Drop
Tablet
Tablet
Syrup
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Dispersible Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Dispersible Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Drop
Tablet
Dispersible Tablet
Dry Syrup
Dry Syrup
Dry Syrup
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Suspension
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Oral Suspension
Oral Suspension
Dispersible Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Syrup
Syrup
Tablet
Tablet
Suspension
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Syrup
Capsule
Suspension
Dispersible Tablet
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Drop
Tablet
Tablet
Tablet
Dispersible Tablet
Injection
Drop
Tablet
Tablet
Syrup
Tablet
Tablet
Suspension
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Suspension
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Sachet
Tablet
Syrup
Syrup
Syrup
Tablet
Tablet
Syrup
Injection
Suspension
Tablet
Suspension
Tablet
Tablet
Ophthalmic Solution
Tablet
Tablet
Tablet
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Liquid
Liquid
Tablet
Syrup
Tablet
Tablet
Tablet
Syrup
Ointment
Tablet
Drop
Syrup
Syrup
Tablet
Tablet
Capsule
Tablet
Tablet
Injection
Injection
Digital Instrument
Digital Instrument
Digital Instrument
Digital Instrument
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Syrup
Injection
Injection
Tablet
Tablet
Injection
Syrup
Drop
Syrup
Tablet
Capsule
Syrup
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Suspension
Suspension
Tablet
Dry Syrup
Suspension
Capsule
Capsule
Drops
Drops
Syrup
Softgel Capsule
Syrup
Syrup
Tablet
Tablet
Tablet
Medical Instrument
Medical Instrument
Medical Instrument
Syrup
Injection
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Medical Instrument
Dental Care
Dental Care
Dental Care
Dental Care
Dental Care
Dental Care
Dental Care
Dental Care
Dental Care
Dental Care
Baby Care Equipment
Baby Skincare Product
Baby Skincare Product
Baby Skincare Product
Baby Skincare Product
Baby Skincare Product
Baby Skincare Product
Baby Skincare Product
Baby Skincare Product
Baby Skincare Product
Baby Care Equipment
Baby Care Equipment
Baby Care Equipment
Baby Care Equipment
Baby Care (Syrup)
Baby Gift Pack
Baby Gift Pack
Baby Gift Pack
Baby Gift Pack
Baby Gift Pack
Baby Gift Pack
Pediatric Drop
Baby Care (Medicine)
Medical Support Product
Tonic (Syrup)
Suspension
Suspension
Antibiotic (Injection)
Antibiotic (Injection)
Antibiotic (Injection)
Antibiotic (Injection)
Antibiotic (Tablet)
Antibiotic (Tablet)
Support Product
Support Product
Pain Relief (Injection)
Pain Relief (Tablet)
Lipid Control (Tablet)
Lipid Control (Tablet)
Muscle Relaxant (Tablet)
Muscle Relaxant (Tablet)
Antibiotic (Suspension)
Antibiotic (Suspension)
Antibiotic (Suspension)
Topical Antibiotic
Antibiotic (Tablet)
Antibiotic (Tablet)
Antibiotic (Tablet)
Antibiotic (Injection)
Antibiotic (Tablet)
Antibiotic (Syrup)
Antibiotic (Drop)
Antibiotic (Dispersible)
Antibiotic (Injection)
Antibiotic (Syrup)
Antibiotic (Tablet)
Antibiotic (Tablet)
Antibiotic (Tablet)
Antibiotic (Dispersible)
Antibiotic (Syrup)
Antibiotic (Tablet)
Antibiotic (Tablet)
Antibiotic (Syrup)
Topical Antibiotic
Tablet
Tablet
Bolus
Supplement
Medical Equipment
Tablet
Tablet
Injection
Tablet
Syrup
Capsule
Syrup
Capsule
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Tablet
Medical Equipment
Bandage
Bandage
Bandage
Bandage
Bandage
Bandage
Bandage
Bandage
Bandage
Solution
Suspension
Syrup
Tablet
Tablet
Syrup
Tablet
Bolus
Suspension
Suspension
Suspension
Tablet
Bolus
Tablet
Syrup
Syrup
Syrup
Tablet
Tablet
Suspension
Tablet
Medical Equipment
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Supplement
Injection
Injection
Supplement
Sachet
Medical Equipment
Tablet
Sachet
Medical Equipment
Battery
Battery
Battery
Tablet
Supplement
Capsule
Tablet
Tablet
Tablet
Tablet
Syrup
Injection
Injection
Injection
Tablet
Tablet
Syrup
Syrup
Syrup
Syrup
Syrup
Suspension
Tablet
Suspension
Tablet
Tablet
Tablet
Supplement
Medical Equipment
Syrup
Injection
Syrup
Tablet
Tablet
Bolus
Syrup
Suspension
Syrup
Gel
Tablet
Medical Equipment
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Bolus
Capsule
Inhaler
Capsule
Inhaler
Inhaler
Inhaler
Lotion
Lotion
Cream
Cream
Ointment
Ointment
Capsule
Syrup
Drops
Tablet
Syrup
Syrup
Ointment
Liquid
Liquid
Liquid
Cream
Cream
Tablet
Syrup
Inhaler
Inhaler
Supplement
Capsule
Syrup
Syrup
Capsule
Capsule
Tablet
Ointment
Solution
Syrup
Solution
Solution
Medical Equipment
Medical Equipment
Medical Equipment
Linen
Furniture
Linen
Injection
Syrup
Capsule
Injection
Syrup
Syrup
Capsule
Injection
Liquid
Liquid
Syrup
Tablet
Tablet
Injection
Capsule
Capsule
Tablet
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Tablet
Tablet
Drops
Liquid
Drops
Drops
Syrup
Tablet
Tablet
Tablet
Tablet
Supplement
Supplement
Syrup
Syrup
Equipment
Syrup
Tablet
Syrup
Tablet
Syrup
Syrup
Syrup
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Syrup
Capsule
Syrup
Syrup
Capsule
Sachet
Syrup
Syrup
Tablet
Tablet
Tablet
Capsule
Solution
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Injection
Injection
Injection
Ointment
Injection
Tablet
Supplement
Capsule
Supplement
Supplement
Solution
Solution
Solution
Injection
Injection
Injection
Tablet
Syrup
Syrup
Drops
Tablet
Syrup
Elixir
Elixir
Injection
Tablet
Capsule
Tablet
Solution
Injection
Granules
Granules
Solution
Solution
Softgel Capsule
Syrup
Syrup
Supplement
Supplement
Supplement
Liquid
Liquid
Liquid
Liquid
Liquid
Eye Drops
Capsule
Capsule
Sachet
Injection
Injection
Injection
Injection
Supplement
Supplement
Syrup
Injection
Tablet
Solution
Tablet
Solution
Cream
Syrup
Syrup
Syrup
Capsule
Drops
Syrup
Tablet
Ointment
Ointment
Tablet
Oil
Capsule
Tablet
Tablet
Tablet
Tablet
Drops
Tablet
Tablet
Tablet
Tablet
Drops
Eye Drops
Capsule
Capsule
Capsule
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Shampoo
Cream
Cream
Cream
Gargle Solution
Granules
Ointment
Ointment
Powder
Solution
Solution
Scrub
Solution
First Aid Solution
Lotion
Lotion
Lotion
Tablet
Gel
Powder
Tablet
Foam
Eye Drops
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Gargle Solution
Injection
Injection
Drops
Tablet
Tablet
Cream
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Gargle Solution
Gargle Solution
Ointment
Solution
Drops
Drops
Drops
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Syrup
Syrup
Injection
Syrup
Capsule
Tablet
Drops
Tablet
Tablet
Injection
Drops
Tablet
Ointment
Ointment
Cream
Cream
Cream
Cream
Cream
Cream
Syrup
Syrup
Syrup
Softgel Capsule
Syrup
Injection
Injection
Injection
Drops
Tablet
Syrup
Syrup
Ointment
Ointment
Injection
Injection
Injection
Capsule
Tablet
Drops
Capsule (Soft Gel)
Suspension
Tablet
Eye Drop
Tablet
Tablet
Syrup
Syrup
Syrup
Syrup
Injection
Injection
Injection
Liquid Ayurvedic
Medical Device
Tablet
Tablet
Dispersible Tablet
Dry Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Cream
Tablet
Tablet
Capsule
Dry Syrup
Capsule
Powder Sachet
Powder
Tablet
Tablet
Vial
Tablet
Injection
Ampoule
Syrup
Syrup
Capsule
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Tablet
Injection
Injection
Capsule
Injection
Injection
Tablet
Tablet
Tablet
Eye Drop
Eye Drop
Eye Drop
Eye Drop
Toothbrush
Tablet
Injection
Injection
Injection
Injection
Injection
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Suspension
Tablet
Syrup
Veterinary Product
Injection
Powder
Tablet
Injection
Injection
Dispersible Tablet
Dry Syrup
Injection
Injection
Dispersible Tablet
Injection
Injection
Injection
Injection
Cream
Cream
Ointment
Drops
Drops
Syrup
Syrup
Tablet
Tablet
Bolus
Bolus
Capsule
Powder Sachet
Liquid
Capsule
Dry Syrup
Syrup
Liquid
Liquid
Liquid
Syrup
Eye Drop
Cream
Powder Sachet
Tablet
Powder
Syrup
Syrup
Tablet
Powder Sachet
Injection
Injection
Injection
Tablet
Capsule
Bolus
Bolus
Powder
Syrup
Suspension
Injection
Suspension
Bolus
Powder
Powder
Powder
Capsule
Injection
Tablet
Tablet
Syrup
Beverage
Tablet
Injection
Injection
Injection
Injection
Pediatric Syrup
Syrup
Tablet
Tablet
Syrup
Syrup
Syrup
Suspension
Tablet
Injection
Device
Surgical Blade
Surgical Blade
Surgical Blade
Surgical Blade
Surgical Blade
Surgical Blade
Surgical Blade
Surgical Blade
Surgical Blade
Syrup
Syrup
Syrup
Powder
Powder
Powder
Cream
Tablet
Tablet
Capsule
Tablet
Tablet
Liquid
Syrup
Bolus
Liquid
Medical Equipment
Powder
Syrup
Medical Device
Medical Device
Medical Device
Liquid
Liquid
Supplement
Tablet
Tablet
Bolus
Liquid
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Tablet
Syrup
Tablet
Tablet
Tablet
Capsule
Tablet
Drop
Drop
Syrup
Tablet
Powder
Oil
Supplement
Capsule
Capsule
Tablet
Liquid
Granules
Herbal Medicine
Powder
Shampoo
Liquid
Liquid
Bolus
Bolus
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Suspension
Capsule
Capsule
Suspension
Tablet
Capsule
Capsule
Capsule
Tablet
Syrup
Suspension
Tablet
Tablet
Drop
Syrup
Syrup
Drop
Liquid
Tablet
Tablet
Tablet
Capsule
Tablet
Granules
Bolus
Powder
Bolus
Powder
Bolus
Tablet
Tablet
Syrup
Powder
Powder
Powder
Powder
Powder
Powder
Syrup
Syrup
Tablet
Veterinary
Veterinary
Veterinary
Powder
Powder
Powder
Drops
Powder
Ointment
Lotion
Cream
Cream
Lotion
Lotion
Powder
Glycerin
Eye Drop
Tablet
Tablet
Eye Drop
Eye Drop
Ampoule
Ampoule
Solution
Injection
Tablet
Solution
Powder
Powder
Powder
Liquid
Liquid
Liquid
Tablet
Powder
Powder
Vaccine
Vaccine
Gel
Injection
Bolus
Powder
Veterinary
Equipment
Equipment
Tablet
Tablet
Syrup
Syrup
Suspension
Syrup
Tablet
Liquid
Tablet
Tablet
Powder
Powder
Powder
Liquid
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Tablet
Tablet
Herbal Medicine
Herbal Medicine
Syrup
Herbal Medicine
Syrup
Syrup
Syrup
Tablet
Tablet
Injection
Liquid
Injection
Liquid
Syrup
Syrup
Syrup
Drop
Syrup
Syrup
Syrup
Syrup
Tablet
Tablet
Capsule
Capsule
Capsule
Syrup
Syrup
Syrup
Syrup
Syrup
Medical Device
Syrup
Tablet
Syrup
Syrup
Tablet
Cream
Hygiene Product
Oil
Tablet
Syrup
Syrup
Syrup
Tablet
Tablet
Tablet
Injection
Solution
Syrup
Syrup
Syrup
Syrup
Syrup
Gel
Equipment
Tablet
Syrup
Vial
Powder
Solution
Eye Drop
Test Kit
Eye Drop
Eye Drop
Eye Drop
Tablet
Syrup
Solution
Eye Drop
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Cream
Cream
Eye Drop
Eye Drop
Eye Drop
Powder
Powder
Powder
Powder
Liquid
Syrup
Syrup
Tablet
Syrup
Drop
Injection
Injection
Injection
Tablet
Tablet
Liquid
Injection
Injection
Injection
Capsule
Tablet
Syrup
Syrup
Syrup
Syrup
Drop
Tablet
Eye Drop
Syrup
Syrup
Syrup
Supplement
Syrup
Syrup
Syrup
Syrup
Capsule
Syrup
Syrup
Syrup
Tablet
Tablet
Tablet
Eye Drop
Syrup
Syrup
Syrup
Solution
Tablet
Tablet
Medical Equipment
Syrup
Syrup
Syrup
Syrup
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Gel
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Tablet
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Powder
Powder
Syrup
Ampoule
Powder
Powder
Syrup
Syrup
Capsule
Drops
Powder
-
-
Bolus
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Rotacap
Rotacap
Rotacap
Inhaler
Inhaler
Inhaler
Inhaler
Nasal Spray
Respiratory Powder
Respiratory Powder
Capsule
Inhaler
Capsule
Inhaler
Capsule
Inhaler
Nasal Spray
Tablet
Sachet
Powder
Suspension
Medical Equipment
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Injection
Tablet
Ointment
Ointment
Ointment
Ointment
Capsule
Injection
Tablet
Tablet
Tablet
Tablet
Capsule
Syrup
Syrup
Syrup
Syrup
Syrup
Solution
Solution
Solution
Solution
Solution
Solution
Injection
Injection
Injection
Cream
Cream
Cream
Liquid
Liquid
Liquid
Liquid
Liquid
Injection
Injection
Injection
Syrup
Tablet
Bolus
Medical Equipment
Medical Equipment
Medical Equipment
Injection
Tablet
Tablet
Syrup
Syrup
Syrup
Injection
Injection
Injection
Tablet
Tablet
Drops
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Drops
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection/Combo
Lotion
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Capsule
Sachet
Tablet
Syrup
Tablet
Injection
Injection
Syrup
Syrup
Injection
Injection
Syrup
Tablet
Tablet
Tablet
Syrup
Syrup
Injection
Injection
Syrup
Injection
Injection
Powder
Powder
Injection
Syrup
Capsule
Injection
Capsule
Capsule
Ointment
Tablet
Powder
Powder
Powder
Powder
Powder
Powder
Cream
Tablet
Cleaner
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Herbal
Tablet
Injection
Injection
Syrup
Syrup
Syrup
Capsule
Syrup
Injection
Injection
Injection
Tablet
Tablet
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Drops
Syrup
Suspension
Tablet
Capsule
Drops
Syrup
Drops
Bolus
Bolus
Solution
Solution
Liquid
Syrup
Liquid
Liquid
Powder
Liquid
Liquid
Liquid
Liquid
Liquid
Syrup
Syrup
Tablet
Tablet
Capsule
Sachet
Capsule
Kit
Powder
Powder
Syrup
Tablet
Tablet
Lotion
Lotion
Liquid
Liquid
Liquid
Liquid
Liquid
Tablet
Syrup
Tablet
Lotion
Tablet
Tablet
Tablet
Lotion
Lotion
Lotion
Gems
Syrup
Liquid
Liquid
Liquid
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Gel
Capsule
Tablet
Liquid
Liquid
Liquid
Liquid
Tablet
Liquid
Tablet
Tablet
Granules
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Tablet
Syrup
Bolus
Tablet
Capsule
Tablet
Tablet
Tablet
Syrup
Tablet
Liquid
Bolus
Liquid
Liquid
Liquid
Tablet
Injection
Powder
Capsule
Syrup
Granules
Tablet
Tablet
Granules
Drops
Tablet
Liquid
Softgel
Granules
Granules
Tablet
Suspension
Tablet
Tablet
Liquid
Injection
Tablet
Gel
Capsule
Syrup
Liquid
Liquid
Liquid
Capsule
Tablet
Tablet
Capsule
Tablet
Syrup
Capsule
Tablet
Tablet
Tablet
Liquid
Liquid
Capsule
Sachet
Syrup
Tablet
Granules
Tablet
Capsule
Cream
Solution
Solution
Tablet
Capsule
Syrup
Tablet
Liquid
Liquid
Liquid
Foam
Gel
Lotion
Liquid
Jelly
Tablet
Injection
Kit
Tablet
Drop
Sachet
Capsule
Syrup
Tablet
Tablet
Tablet
Lotion
Lotion
Tablet
Tablet
Capsule
Granules
Granules
Granules
Tablet
Granules
Liquid
Capsule
Capsule
Granules
Liquid
Powder
Suspension
Tablet
Tablet
Tablet
Liquid
Liquid
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Liquid
Liquid
Capsule
Liquid
Liquid
Bolus
Syrup
Liquid
Liquid
Liquid
Tablet
Drop
Syrup
Tablet
Tablet
Tablet
Syrup
Tablet
Syrup
Syrup
Syrup
Syrup
Granules
Granules
Liquid
Liquid
Tablet
Liquid
Liquid
Liquid
Liquid
Liquid
Liquid
Syrup
Tablet
Spray
Tablet
Capsule
Capsule
Syrup
Syrup
Tablet
Capsule
Syrup
Syrup
Syrup
Tablet
Tablet
Capsule
Capsule
Capsule
Gel
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Syrup
Syrup
Chewable Tablet
Drops
Tablet
Powder
Liquid
Liquid
Liquid
Liquid
Injection
Syrup
Bolus
Injection
Tablet
Capsule
Tablet
Tablet
Liquid
Liquid
Tablet
Suspension
Syrup
Capsule
Tablet
Syrup
Tablet
Tablet
Injection
Injection
Injection
Tablet
Suspension
Drops
Capsule
Capsule
Syrup
Tablet
Tablet
Tablet
Drops
Paint
Powder
Powder
Lotion
Tablet
Lotion
Cream
Drops
Drops
Capsule
Cream
Lotion
Ointment
Cream
Capsule
Cream
Cream
Drops
Drops
Drops
Gel
Gel
Lotion
Lotion
Spray
Gel
Paint
Ear Drops
Powder
Powder
Powder
Soap
Shampoo
Tablet
Tablet
Tablet
Vegetable
Cream
Paint
Gel
Ear Drops
Cream
Cream
Capsule
Tablet
Gel
Capsule
Capsule
Cream
Powder
Cream
Vaginal
Cream
Tablet
Tablet
Tablet
Gel
Gel
Liquid
Cream
Ointment
Gel
Capsule
Capsule
Disposable
Tablet
Tablet
Tablet
Liquid
Liquid
Injection
Syrup
Tablet
Injection
Injection
Injection
Injection
Injection
Liquid
Liquid
Liquid
Liquid
Liquid
Liquid
Liquid
Liquid
Liquid
Injection
Syrup
Tablet
Eye Drops
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Drops
Injection
Suspension
Tablet
Tablet
Tablet
Suspension
Capsule
Syrup
Injection
Injection
Capsule
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Paper
Gel
Capsule
Capsule
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Other
Other
Bolus
Bolus
Drops
Injection
Injection
Injection
Injection
Bolus
Injection
Injection
Injection
Bolus
Bolus
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Liquid
Liquid
Liquid
Liquid
Liquid
Tablet
Syrup
Liquid
Bolus
Syrup
Injection
Tablet
Tablet
Injection
Liquid
Liquid
Injection
Drops
Drops
Liquid
Liquid
Liquid
Capsule
Liquid
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Drop
Drop
Syrup
Syrup
Tablet
Supplement
Tablet
Tablet
Capsule
Tablet
Tablet
Syrup
Tablet
Tonic
Injection
Tablet
Syrup
Injection
Capsule
Capsule
Tablet
Capsule
Syrup
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Sachet
Injection
Tablet
Tablet
Tablet
Tablet
Ointment
Tablet
Tablet
Tablet
Tablet
Ointment
Ointment
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Other
Other
Other
Drops
Drops
Syrup
Drops
Syrup
Drops
Powder
Powder
Ointment
Ointment
Surgical
Surgical
Surgical
Surgical
Surgical
Medical
Medical
Solution
Drops
Powder
Powder
Powder
Powder
Powder
Injection
Medical
Tablet
Injection
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Supplement
Tablet
Syrup
Syrup
Tablet
Tablet
Drops
Ampoule
Supplement
Cream
Cream
Supplement
Supplement
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Drop
Tablet
Syrup
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Syrup
Supplement
Supplement
Syrup
Tablet
Tablet
Syrup
Syrup
Syrup
Tablet
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Drop
Injection
Tablet
Drop
Syrup
Tablet
Syrup
Tablet
Syrup
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Syrup
Tablet
Tablet
Injection
Syrup
Drop
Syrup
Tablet
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Kit
Kit
Kit
Syrup
Injection
Injection
Injection
Injection
Tablet
Syrup
Suspension
Suspension
Tablet
Tablet
Tablet
Suspension
Tablet
Tablet
Tablet
Suspension
Suspension
Drops
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Tablet
Tablet
Tablet
Injection
Injection
Injection
Injection
Tablet
Tablet
Tablet
Syrup
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Capsule
Capsule
Tablet
Tablet
Injection
Injection
Injection
Injection
Tablet
Tablet
Tablet
Injection
Injection
Tablet
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Tablet
Tablet
Tablet
Drops
Syrup
Syrup
Syrup
Tablet
Tablet
Syrup
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Tablet
Tablet
Tablet
Syrup
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Tablet
Tablet
Tablet
Syrup
Capsule
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Cream
Drop
Tablet
Drop
Syrup
Syrup
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Injection
Injection
Syrup
Syrup
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Syrup
Tablet
Syrup
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Supplement
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Injection
Injection
Suspension
Syrup
Injection
Tablet
Injection
Syrup
Tablet
Tablet
Tablet
Injection
Injection
Injection
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Supplement
Tablet
Suspension
Injection
Injection
Injection
Tablet
Tablet
Syrup
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Injection
Tablet
Syrup
Tablet
Injection
Tablet
Tablet
Syrup
Syrup
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Injection
Syrup
Injection
Injection
Tablet
Injection
Injection
Injection
Tablet
Injection
Syrup
Tablet
Tablet
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Tablet
Tablet
Injection
Injection
Injection
Injection
Tablet
Tablet
Capsule
Tablet
Capsule
Tablet
Tablet
Tablet
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Syrup
Injection
Injection
Injection
Tablet
Tablet
Tablet
Powder
Syrup
Cream
Capsule
Drop
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Capsule
Injection
Injection
Drop
Injection
Tablet
Injection
Tablet
Tablet
Injection
Injection
Injection
Tablet
Tablet
Syrup
Injection
Injection
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Syrup
Injection
Tablet
Tablet
Capsule
Drops
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Tablet
Drop
Capsule
Tablet
Drops
Syrup
Powder
Capsule
Capsule
Tablet
Capsule
Capsule
Drop
Syrup
Injection
Injection
Injection
Syrup
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Syrup
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Syrup
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Syrup
Cream
Tablet
Injection
Tablet
Tablet
Syrup
Capsule
Tablet
Cream
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Eye Drop
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Aid
Tablet
Tablet
Tablet
Syrup
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Syrup
Syrup
Gel (Topical)
Softgel Capsule
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Suspension
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Syrup
Syrup
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Cream
Syrup
Tablet
Injection
Injection
Injection
Soap
Syrup
Tablet
Tablet
Syrup
Tablet
Syrup
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Dry Syrup
Drop
Surgical Tool
Injection
Injection
Injection
Tablet
Tablet
Suspension
Tablet
Tablet
Supplement
Supplement
Supplement
Supplement
Oil
Oil
Oil
Syrup
Syrup
Tablet
Tablet
Tablet
Ointment
Ointment
Ointment
Ointment
Spray
Tablet
Supplement
Supplement
Supplement
Supplement
Supplement
Supplement
Supplement
Supplement
Supplement
Supplement
Supplement
Supplement
Tablet
Supplement
Toothpaste
Syrup
Tablet
Syrup
Supplement
Supplement
Supplement
Supplement
Supplement
Injection
Injection
Miscellaneous
Syrup
Syrup
Capsule
Syrup
Capsule
Tablet
Syrup
Syrup
Lozenges
Tablet
Syrup
Syrup
Syrup
Polish
Polish
Polish
Polish
Polish
Syrup
Syrup
Tablet
Tablet
Syrup
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Syrup
Syrup
Syrup
Tablet
Tablet
Tonic
Syrup
Drop
Rub
Syrup
Injection
Injection
Tablet
Ear Drop
Capsule
Tablet
Syrup
Tablet
Tablet
Syrup
Syrup
Powder
Powder
Injection
Ointment
Ointment
Injection (Vet)
Injection (Vet)
Drops
Drops
Applicator Caps
Capsule
Ointment
Eye Drop
Tablet
Syrup
Syrup
Eye Drop
Tablet
Tablet
Syrup
Syrup
Syrup
Tablet
Tablet
Napkin
Napkin
Drops
Drops
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Syrup
Sachet
Powder
Powder
Tablet
Injection
Injection
Tablet
Tablet
Tablet
Sutures
Sutures
Tablet
Injection
Injection
Tablet
Syrup
Supplement
Supplement
Supplement
Supplement
Supplement
Tablet
Tablet
Tablet
Tablet
Gel
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Supplement
Tablet
Tablet
Tablet
Drops
Drops
Injection
Inhaler
Inhaler
Inhaler
Inhaler
Injection
Injection
Suspension
Tray
Syrup
Syrup
Syrup
Eye Drop
Tablet
Tablet
Tablet
Eye Drop
Tablet
Suspension
Suspension
Syrup
Tablet
Tablet
Eye Drop
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Injection
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Eye Drop
Ointment
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Syrup
Tablet
Syrup
Tablet
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Drops
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Syrup
Tablet
Tablet
Ointment
Ointment
Ointment
Lotion
Powder
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Ointment
Tablet
Tablet
Eye Drop
Eye Drop
Eye Ointment
Injection
Tablet
Eye Drop
Ointment
Tablet
Tablet
Capsule
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Syrup
[Type]
Syrup
Tablet
Syrup
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Eye Drop
Eye Drop
Eye Drop
Eye Drop
Tablet
Injection
Tablet
Tablet
Tablet
Injection
Injection
Tablet
Injection
Eye Drop
Ointment
Tablet
[Type]
Tablet
Tablet
Tablet
Ointment
Syrup
Tablet
Ointment
Eye Drop
Tablet
Tablet
Syrup
Tablet
Syrup
Eye Drop
Eye Drop
Eye Drop
Syrup
Syrup
Tablet
Tablet
Suspension
Eye Drop
Syrup
Tablet
Eye Drop
Tablet
Tablet
Tablet
Tablet
Liquid
Tablet
Eye/Ear Drop
Eye/Ear Drop
Tablet
Powder
Powder
Eye Drop
Syrup
Tablet
Veterinary Tablet
Drop
Ointment
Drop
Ointment
Vial/Powder
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Shampoo
Syrup
Tablet
Tablet
Syrup
Tablet
Injection
Tablet/Capsule
Gel
Tablet
Tablet
Tablet
Injection
Tablet
Tablet/Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Drop
Tablet
Syrup
Syrup
Tablet
Injection
Injection
Injection
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Granules
Dispersible Tablet
Tablet
Tablet
Dispersible Tablet
Tablet
Skin Care Kit
Face Wash Gel
Face Mask
Ointment
Dry Syrup
Tablet
Tablet
Injection
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Injection
Liquid/Oral Solution
Drops
Syrup
Syrup
Tablet
-
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Syrup
Syrup
Drop
Syrup
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
[Type]
Capsule
Capsule
Syrup
Tablet
Syrup
Injection
Injection
Injection
Tablet
Tablet
Brace
Brace
Brace
Brace
Brace
Brace
Brace
Brace
Brace
Brace
Brace
Brace
Tablet
Tablet
Tablet
Brace
Injection
Injection
Tablet
Tablet
Syrup
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Syrup
Tablet
Ointment
Syrup
Tablet
Syrup
Syrup
[Type]
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Syrup
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Capsule
Lotion
Lotion
Ointment
Tablet
Granules
Facewash
Cream
Gel
Nasal Spray
Nasal Spray
Nasal Spray
Gel
Cream
Cream
Tablet
Suspension
Suspension
Capsule
Liquid
Gel
[Type]
[Type]
[Type]
Gel
Troche
Tablet
Injection
Injection
Nasal Drops
Tablet
Tablet
Ampoule
Gel
[Type]
Tablet
Capsule
Gel
Suspension
Soap
[Type]
[Type]
Liquid
Liquid
Ointment
Tablet
Capsule
Capsule
Tablet
[Type]
Suppository
[Type]
[Type]
Suppository
Thermometer
Gel
Gel
Drops
Gel
Gel
Vaginal Supp.
Ear Drops
Gel
Tablet
Injection
Tablet
Cream
Ointment
Tablet
Tablet
Ointment
Tablet
Tablet
Cream
Ointment
Ointment
Powder
Cream
Cream
Cream
Cream
Ointment
Ear Drop
Ear Drop
Ointment
Ointment
Cream
Ointment
Ointment
Ointment
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Ear Drop
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Mouthwash
Rinse
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Injection
Injection
Capsule
Capsule
Capsule
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Cream
Cream
Cream
Cream
Cream
Cream
Lotion
Cream
Cream
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Mouthwash
Cream
Ointment
Injection
Tablet
Injection
Tablet
Tablet
Injection
Syrup
Syrup
Capsule
Cream
Tablet
Ointment
Oil
Tablet
Tablet
Tablet
Tablet
Ointment
Tablet
Injection
Injection
Syrup
Tablet
Suspension
Suspension
Drop
Drop
Syrup
Cream
Tablet
Tablet
-
Capsule
Tablet
Tablet
Syrup
Cylinder
Cylinder
Cylinder
Syrup
Tablet
Tablet
Tablet
Drop
Syrup
Syrup
Syrup
Capsule
Intramammary Injection
Injection
Capsule
Suspension
Syrup
Syrup
Syrup
-
-
Tablet
-
Injection
Tablet
-
Capsule
Capsule
Tablet
Tablet
Capsule
Splint
Splint
Splint
Splint
Splint
Syrup
Tablet
Capsule
Capsule
Syrup
Syrup
Syrup
Capsule
Capsule
Expectorant Syrup
Syrup
Syrup
Syrup
Capsule
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Tablet
Capsule
Powder
Tablet
Dry Syrup
Dry Syrup
Syrup
Syrup
Expectorant Syrup
Linctus Syrup
Nasal Drops
Expectorant Syrup
Syrup
Syrup
Syrup
-
Tablet
Syrup
Syrup
Powder
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Tablet
Syrup
Syrup
Expectorant
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Capsule
Capsule
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Syrup
Tablet
Tablet
Dry Syrup
Syrup
Syrup
Capsule
Capsule
Syrup
Tablet
Drop
Syrup
Syrup
Syrup
Tablet
Syrup
Syrup
Syrup
Tablet
Syrup
Syrup
Capsule
Syrup
Tablet
Syrup
Drop
Tablet
Syrup
Tablet
Toothpaste
Capsule
Syrup
Tablet
Tablet
Syrup
Capsule
Drop
Syrup
Syrup
Drops
Drop
Drop
Drop
Drop
Syrup
Tablet
Tablet
Syrup
Drop
Syrup
Drop
Drop
Syrup
Tablet
Pump
Product
Product
Trigger
Trigger
Trigger
Product
Trigger
Product
Ointment
Drop
Injection
Tablet
Syrup
Tablet
Drop
Tablet
Suspension
Sulphate
Sulphate
Tablet
Drops
Injection
Tablet
Syrup
Sachet
Sachet
Sachet
Syrup
Syrup
Syrup
Capsule
Capsule
Syrup
Tablet
Bag
Syrup
Product
Tablet
Tablet
Kit
Suspension
Suspension
Capsule
Lotion
Tablet
Tablet
Tablets
Product
Tablet
Tablet
Syrup
Syrup
Syrup
Tablet
Drops
Shot
Capsule
Capsule
Capsule
Drops
Syrup
Tablet
Tablet
Cream
Cream
Suspension
Suspension
Product
Inhaler
Capsule
Inhaler
Rotacaps
Capsule
Inhaler
Inhaler
Rotacaps
Inhaler
Redicaps
Tablet
Capsule
Injection
Injection
Injection
Inhaler
Respicap
Nasal Spray
Tablet
Injection
Tablet
Capsule
Syrup
Forte
Injection
Capsule
Vial
Capsule
Inhaler
Respules
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Tablet
Tablet
Product
Product
Syrup
Chair
Chair
Chair
Chair
Chair
Stool
Stool
-
Ampoule
Tablet
Tablet
Jar
Supplement
Supplement
Supplement
Capsule
Syrup
Tablet
Tablet
Tablet
Tablet
Product
Product
Capsule
Tablet
Capsule
Capsule
Capsule
Capsule
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Powder
Syrup
Syrup
Capsule
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Liquid
Capsule
Capsule
Capsule
Liquid
Liquid
Liquid
Syrup
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Eye Drop
Injection
Injection
Injection
Injection
Injection
Tablet
Tablet
Powder
Liquid
Capsule
Capsule
Medical Device
Medical Device
Medical Device
Ointment/Cream
Capsule
Tablet
Capsule
Cream
Cream
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Capsule
Syrup
Syrup
Tablet
Food Product
Food Product
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Liquid
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Medical Device
Injection
Injection
Injection
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Tablet
Drop
Syrup
Tablet
Syrup
Tablet
Drop
Syrup
Syrup
Tablet
Vaporizer
Expiry
Expiry
Syrup
Syrup
Tablet
Injection
Injection
Tablet
Capsule
Ointment
Drop
Tablet
Suspension
Tablet
Tablet
Injection
Injection
Medical Device
Medical Device
Medical Device
Injection
Tablet
Medical Device
Tablet
Tablet
Tablet
Tablet
Suspension
Tablet
Tablet
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Suspension
Tablet
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Drop
Drop
Syrup
Tablet
Medical Device
Tablet
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Cream
Syrup
Capsule
Injection
Capsule
Cream
Cream
Cream
Cream
Tablet
Tablet
Shampoo
Ointment
Bolus
Bolus
Bolus
Tablet
Medical Device
Cotton
Cotton
Cotton
Cotton
Cotton
Cotton
Cotton
Cotton
Cotton
Cotton
Cotton
Cotton
Gel
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Medical Device
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Powder
Powder
Powder
Powder
Tablet
Capsule
Capsule
Powder
Powder
Tablet
Tablet
Capsule
Powder
Powder
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Drop
Syrup
Nasal Spray
Syrup
Tablet
Syrup
Drops
Injection
Injection
Injection
Injection
Syrup
Syrup
Tablet
Drop
Tablet
Injection
Suspension
Tablet
Liquid
Injection
Injection
Tablet
Tablet
Tablet
Syrup
Capsule
Powder
Capsule
Capsule
Capsule
Tablet
Bandage
Bandage
Bandage
Bandage
Bandage
Bandage
Gel
Lotion
Powder
Powder
Syrup
Syrup
Liquid
Liquid
Syrup
Syrup
Tablet
Capsule
Capsule
Bandage
Bandage
Bandage
Bandage
Bandage
Bandage
Bandage
Bandage
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Powder
Injection
Tablet
Tablet
Tablet
Tablet
Syrup
Injection
Injection
Injection
Injection
Injection
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Powder
Gel
Gel
Tablet
Tablet
Syrup
Syrup
Injection
Injection
Tablet
Tablet
Syrup
Syrup
Eye Drop
Eye Drop
Medical Device
Capsule
Capsule
Syrup
Syrup
Tablet
Syrup
Syrup
Tablet
Cream
Cream
Lotion
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Capsule
Syrup
Capsule
Syrup
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Suspension
Syrup
Syrup
Syrup
Injection
Injection
Injection
Injection
Syrup
Syrup
Syrup
Medical Device
Syrup
Injection
Injection
Capsule
Syrup
Syrup
Tablet
Tablet
Tablet
Bolus
Syrup
Syrup
Bolus
Syrup
Syrup
Syrup
Tablet
Bolus
Tablet
Syrup
Syrup
Syrup
Bolus
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Oil
Syrup
Bolus
Tablet
Syrup
Syrup
Powder
Syrup
Syrup
Tablet
Syrup
Powder
Powder
Bolus
Powder
Bolus
Powder
Syrup
Syrup
Syrup
Injection
Injection
Injection
Syrup
Tablet
Cream
Tablet
Tablet
Tablet
Tablet
Medical Device
Cream
Cream
Dressing
Dressing
Dressing
Dressing
Cream
Cream
Soap
Cream
Dressing
Dressing
Lotion
Cream
Cream
Gel
Tablet
Syrup
Capsule
Capsule
Medical Device
Syrup
Syrup
Syrup
Syrup
Suspension
Tablet
Powder
Drop
Sachet
Tablet
Capsule
Tablet
Capsule
Capsule
Injection
Injection
Injection
Injection
Injection
Injection
Syrup
Syrup
Tablet
Syrup
Bolus
Tablet
Powder
Injection
Capsule
Drop
Tablet
Drop
Bolus
Bolus
Drop
Tablet
Tablet
Syrup
Syrup
Drops
Injection
Tablet
Syrup
Syrup
Tablet
Tablet
Eye Drop
Eye Drop
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Capsule
Syrup
Tablet
Tablet
Testing Kit
Medical Equipment
Drops
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Injection
Tablet
Syrup
Syrup
Tablet
Tablet
Syrup
Tablet
Tablet
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Capsule
Drop
Drops
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Capsule
Syrup
Syrup
Tablet
Injection
Injection
Syrup
Syrup
Tablet
Tablet
Syrup
Syrup
Drop
Injection
Tablet
Capsule
Tablet
Tablet
Tablet
Softgel
Softgel
Capsule
Capsule
Syrup
Gel
Medical Equipment
Tablet/Syrup
Tablet/Syrup
Syrup
Syrup
Syrup
Syrup
Capsule
Syrup
Syrup
Tablet
Powder
Tablet
Tablet
Tablet
Tablet
Medical Equipment
Injection
Injection
Medical Product
Spray
Spray
Ointment
Capsule
Capsule
Inhaler
Syrup
Syrup
Capsule
Capsule
Sachet
Tablet
Capsule
Syrup
Injection
Injection
Syrup
Injection
Injection
Syrup
Gel
Syrup
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Gel
Solution
Tablet
Tablet
Syrup
Soap
Soap
Soap
Soap
Medical Product
Medical Product
Medical Product
Medical Product
Tablet/Syrup
Tablet
Soap
Spray
Gel
Solution
Solution
Medical Product
Solution
Syrup
Syrup
Soap
Cream
Cream
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Soap
Shampoo
Shampoo
Shampoo
Solution
Drops
Granules
Tablet
Tablet
Tablet
Tablet
Drops
Solution
Tablet
Tablet
Tablet
Oil
Oil
Oil
Oil
Oil
Oil
Oil
Oil
Oil
Oil
Lotion
Soap
Powder
Tablet
Tablet
Tablet
Capsule
Capsule
Capsule
Tablet
Injection
Injection
Injection
Injection
Tablet
Syrup
Tablet
Tablet
Syrup
Injection
Injection
Injection
Tablet
Gel
Shampoo
Shampoo
Lotion
Tablet
Tablet
Tablet
Powder
Tablet
Tablet
Tablet
Tablet
Liquid
Liquid
Tablet
Capsule
Capsule
Sachet
Sachet
Sachet
Tablet
Syrup
Syrup
Syrup
Syrup
Ointment
Tablet
Syrup
Syrup
Tablet
Ointment
Medical Product
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Capsule
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Gift Item
Injection
Injection
Injection
Injection
Injection
Suspension
Syrup
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Liquid
Injection
Injection
Injection
Injection
Injection
Medical Product
Cream
Ointment
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Injection
Injection
Tablet
Injection
Tablet
Powder
Tablet
Injection
Tablet
Syrup
Injection
Tablet
Gel
Gel
Drops
Drops
Injection
Syrup
Tablet
Syrup
Supplement
Tablet
Tablet
Injection
Injection
Solution
Solution
Tablet
Tablet
Tablet
Syrup
Injection
Cream
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Syrup
Injection
Gel
Tablet
Gel
Tablet
Vaccine
Capsule
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Tablet
Capsule
Tablet
Syrup
Tablet
Syrup
Syrup
Tablet
Syrup
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Cream
Medical Kit
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Oil
Powder
Powder
Cream
Cream
Tablet
Tablet
Capsule
Capsule
Capsule
Tablet
Syrup
Syrup
Syrup
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Mouthwash
Toothbrush
Gel
Gel
Dental Care Product
Cream
Liquid
Lotion
Powder
Capsule
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Syrup
Tablet
Tablet
Tablet
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Gel
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Cleanser
Tablet
Tablet
Inhaler
Inhaler
Capsule
Injection
Capsule
Capsule
Capsule
Capsule
Capsule
Syrup
Tablet
Inhaler
Inhaler
Tablet
Gel
Gel
Gel
Cream
Cream
Cream
Cream
Cream
Cream
Cream
Cream
Cream
Cream
Cream
Cream
Cream
Powder
Powder
Cream
Tablet
Cream
Lotion
_
Syrup
Cream
Cream
Cream
Cream
Cream
Ointment
Shampoo
Syrup
Ointment
Ointment
Ointment
Tablet
Drops
Tablet
Syrup
Cream
Cream
Injection
Injection
Injection
Tablet
Capsule
Medical Device
Tablet
Tablet
Tablet
Tablet
Drops
Cream
Lotion
Strip
Tablet
Tablet
Tablet
Tablet
Soap
Pouch
Pouch
Pouch
Pouch
Pouch
Injection
Injection
Tablet
Injection
Tablet
System
Liquid
Liquid
Liquid
Liquid
Liquid
Liquid
Liquid
Wash
Wash
Plaster
Plaster
Injection
Medical Device
Tablet
Tablet
Drops
Syrup
Syrup
Bar
Syrup
Tablet
Injection
Ointment
Eye Drop
Injection
Injection
Injection
Injection
Injection
Ointment
Syrup
Injection
Injection
Injection
Injection
Injection
Eye Drop
Injection
Injection
Injection
Drops
Syrup
Syrup
Syrup
Drops
Ointment
Syrup
Injection
Injection
Injection
Injection
Tablet
Tablet
Injection
Injection
Injection
Injection
Eye Drop
Syrup
Capsule
Syrup
Syrup
Tablet
Syrup
Solution
Solution
Solution
Solution
Solution
Solution
Solution
Injection
Solution
Solution
Tablet
Tablet
Tablet
Suspension
Syrup
Soap
Tablet
Gel
Spray
Powder
Powder
Powder
Tablet
Tablet
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Injection
Syrup
Tablet
Tablet
Syrup
Injection
Powder
Powder
Powder
Syrup
Syrup
Tablet
Powder
Tablet
Tablet
Syrup
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Blood Pressure
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Adult Diaper
Diaper
Cream
Cream
Pill
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Bolus
Tablet
Tablet
Cream
Bolus
Bolus
Bolus
Tablet
Capsule
Supplement
Tablet
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Syrup
Syrup
Capsule
Tablet
Bolus
Injection
Tablet
Tablet
Tablet
Tablet
Solution
Injection
Solution
Solution
Tablet
Solution
Bolus
Injection
Injection
Solution
Solution
Injection
Ointment
Injection
Tablet
Eye/Ear Drop
Tablet
Gel
Gel
Injection
Injection
Eye Drop
Tablet
Gel
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Gel
Injection
Tablet
Injection
Tablet
Gel
Injection
Injection
Injection
Tablet
Tablet
Eye/Ear Drop
Tablet
Tablet
Tablet
Injection
Injection
Gel
Tablet
Tablet
Gel
Tablet
Injection
Tablet
Injection
Injection
Gel
Injection
Injection
Liquid
Bolus
Liquid
Liquid
Tablet
Gel
Ointment
Balm
Gel
Gel
Tablet
Gel
Capsule
Liquid
Tablet
Gel
Gel
Injection
Injection
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Liquid (Cough Syrup)
Liquid
Powder
Syrup
Syrup
Capsule
Tablet
Tablet
Tablet
Tablet
Eye/Ear Drop
Eye/Ear Drop
Gel
Ointment
Tablet
Liquid (Antacid)
Gel
Gel
Chewable Tablet
Tablet
Tablet
Tablet
Drops
Syrup
Syrup
Syrup
Tablet
Syrup
Syrup
Capsule
Powder
Powder
Powder
Medical Device
Tablet
Syrup
Syrup
Liquid
Blood Pressure Monitor
Blood Pressure Monitor
Blood Pressure Monitor
Blood Pressure Monitor
Blood Pressure Monitor
Blood Pressure Monitor
Blood Pressure Monitor
Thermometer
Weighing Scale
Drops
Tablet
Capsule
Medical Device
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Unknown
Tablet
Tablet
Tablet
Tablet
Tablet 
Tablet 
Unknown
Syrup
Injection
Injection
Tablet
Gel
Injection
Tablet 
Tablet
Unknown
Unknown
Tablet
Tablet
Liquid
Syrup
Tablet
Syrup
Syrup
Syrup
Gel
Tablet (Sustained Release)
Diluents
Diluents
Diluents
Syrup
Drops
Tablet
Tablet
Capsule (Controlled Release)
Capsule (Controlled Release)
Capsule (Controlled Release)
Injection
Tablet (Sustained Release)
Powder
Syrup (Ready to Use)
Tablet
Syrup
Injection
Drops
Tablet
Capsule
Tablet
Tablet
Injection
Injection
Tablet
Tablet
Syrup
Lotion
Suspension
Suspension
Tablet
Syrup
Tablet
Syrup
Syrup
Syrup
Suspension
Suspension
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Unknown
Syrup
Syrup
Tablet
Cream
Tablet
Tablet (Extended Release)
Tablet (Extended Release)
Tablet (Extended Release)
Tablet (Extended Release)
Cream
Cream
Ointment
Ointment
Lotion
Lotion
Cream
Cream
Ointment
Ointment
Ointment
Lotion
Gel
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Syrup
Tablet
Tablet
Syrup
Drops
Syrup
Tablet
Syrup
Syrup
Syrup
Syrup
Injection
Injection
Syrup
Drops
Syrup
Tablet
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Sachet
Tablet
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Injection
Injection
Injection
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Medical Device
Liquid
Liquid
Tablet
Bolus
Tablet
Bolus
Water
Bolus
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Tablet (Extended Release)
Tablet (Extended Release)
Tablet (Extended Release)
Tablet (Extended Release)
Tablet (Extended Release)
Tablet (Extended Release)
Tablet (Extended Release)
Tablet (Extended Release)
Sprinkles
Tablet
Tablet (Extended Release)
Tablet
Gel
Tablet (Modified Release)
Tablet
Tablet (Extended Release)
Tablet (Extended Release)
Syrup
Injection
Syrup
Tablet
Injection
Tablet
Tablet
Tablet
Unknown
Syrup
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Medical Product
Syrup
Tablet
Tablet
Tablet
Syrup
Syrup
Solution
Solution
Solution
Capsule
Capsule
Cream
Cream
Capsule
Capsule
Injection
Injection
Injection
Syrup
Cream
Tablet
Injection
Syrup
Tablet
Medical Device
Medical Apparel
Cream
Syrup
Syrup
Injection
Injection
Tablet
Unknown
Tablet
Tablet
Syrup
Syrup
Bolus (Veterinary)
Injection
Tablet
Injection
Gel
Tablet (Modified Release)
Gel
Tablet
Tablet
Tablet (Extended Release)
Spray
Tablet
Tablet
Tablet
Injection
Drop
Injection
Suspension
Syrup
Syrup
Tablet
Tablet
Tablet
Liquid (Veterinary)
Liquid (Veterinary)
Injection
Tablet (Modified Release)
Tablet
Tablet (Extended Release)
Tablet
Tablet
Unknown
Tablet
Tablet
Tablet (Modified Release)
Syrup
Injection
Tablet
Tablet
Gel
Tablet
Injection
Injection
Eye Drop
Gel
Gel
Tablet
Tablet
Tablet (Modified Release)
Tablet (Extended Release)
Injection
Tablet
Tablet (Modified Release)
Tablet
Tablet
Tablet
Injection
Injection
Tablet
Gel
Drop
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Gel
Tablet (Modified Release)
Tablet
Tablet (Extended Release)
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Drop
Tablet
Capsule
Injection
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Tablet
Syrup
Tablet
Capsule
Tablet (Extended Release)
Capsule
Suspension
Tablet
Tablet
Gel
Gel
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Eye Drop
Eye Drop
Syrup
Injection
Eye Drops
Eye Drops
Suspension
Bolus
Suspension (Liquid)
Suspension
Suspension
Suspension
Suspension
Suspension (Liquid)
Suspension (Liquid)
Suspension (Liquid, Pet)
Cream
Lotion
Liquid
Injection
Injection
Powder
Powder
Powder
Powder
Powder
Powder
Powder
Powder
Tablet
Powder
Tablet
Tablet
Spray
Spray
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Supplement
Medical Equipment
Soap (Pack)
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Injection
Syrup
Tablet
Cream
Capsule
Capsule
Capsule
Cream
Cream
Supplement
Medical Equipment
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Syrup
Gel
Tablet
Tablet
Oral Rehydration Solution
Tablet
Tablet
Medical Equipment
Liquid (Herbal)
Liquid (Herbal)
Liquid (Herbal)
Liquid (Herbal)
Herbal Supplement
Herbal Supplement
Tablet
Capsule
Cream
Cream
Ear Drop
Wax
Dressing Drum
Dressing Drum
Dressing Drum
Dressing Drum
Dressing Tray
Trolley
Gel
Gel
Syrup
Syrup
Tablet
Syrup
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Drop
Tablet
Tablet
Tablet
Injection
Syrup
Drop
Tablet
Tablet
Injection
Injection
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Eye Drop
Freshener
Tablet
Capsule
Tablet
Tablet
Tablet
Eye Drop
Injection
Tablet
Tablet
Mesh
Mesh
Powder
Liquid
Bolus
Powder
Powder
Tablet
Injection
Tablet
Injection
Tablet
Supplement
Supplement
Supplement
Capsule
Tablet
Tablet
Suspension
Tablet
Tablet
Tablet
Drop
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Suppository
Suppository
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Syrup
Capsule
Bolus
Gel
Syrup
Tablet
Tablet
Syrup
Inhaler
Inhaler
Inhaler
Inhaler
Tablet
Inhaler
Inhaler
Inhaler
Inhaler
Nasal Spray
Tablet
Tablet
Tablet
Tablet
Syringe/Injection
Syringe/Injection
Tablet
Injection
Injection
Tablet
Tablet
Inhaler
Inhaler
Inhaler
Kit
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Syrup
Tablet
Injection
Tablet
Injection
Injection
Capsule
Capsule
Capsule
Tablet
Injection
Injection
Injection
Injection
Injection
Capsule
Powder
Injection
Injection
Syrup
Capsule
Capsule
Injection
Tablet
Eye Drop
Bin
Mask
Tablet
Tablet
Capsule
Injection
Injection
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Capsule
Tablet
Capsule
Tablet
Syrup
Injection
Tablet
Tablet
Tablet
Tablet
Bolus
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Cast
Suppository
Injection
Injection
Ointment
Capsule
Capsule
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Gel
Injection
Tablet
Capsule
Capsule
Gel
Injection
Injection
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Solution
Powder
Powder
Liquid
Powder
Tablet
Injection
Injection
Spray
Tablet
Tube
Equipment
Medical Bulb
Medical Roll
Medical Roll
Medical Roll
Medical Roll
Medical Clamp
Electrode
Medical Roll
Medical Roll
Syrup
Powder
Solution
Tube
Tube
Tube
Tube
Tube
Tube
Tube
Tube
Tube
Tube
Tube
Tube
Tube
Syrup
Ear Drops
Tablet
Syrup
Medical Fixator
Test Strips
Medical Grip
Medical Grip
Medical Grip
Medical Grip
Medical Grip
Medical Grip
Medical Equipment
Medical Equipment
Tablet
Tablet
Suspension
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Capsule
Lotion
Capsule
Capsule
Capsule
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Injection
Medical Equipment
Medical Equipment
Service
Medical Equipment
Medical Equipment
Deodorant
Deodorant
Deodorant
Deodorant
Deodorant
Cream
Cream
Ointment
Ointment
Medical Device
Capsule
Syrup
Tablet
Tablet
Tablet
Syrup
Capsule
Softgel Capsule
Softgel Capsule
Capsule
Capsule
Tablet
Tablet
Tablet
Powder
Medical Equipment
Capsule
Capsule
Sachet
Capsule
Capsule
Ointment
Tablet
Capsule
Capsule
Capsule
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Bolus
Tablet
Tablet
Tablet
Chewable Tablet
Chewable Tablet
Ointment
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Sachet
Injection
Suspension
Cream
Lotion
Capsule
Nasal Drop
Soluble
Tablet
Powder
Powder
Powder
Tablet
Tablet
Tablet
Tablet
Injection
Sachet
Tablet
Sachet
Tablet
Tablet
Tablet
Tablet
Injection
Sachet
Tablet
Tablet
Capsule
Injection
Tablet
Ointment
Eye Drops
Eye/Ear Drops
Syrup
Tablet
Capsule
Tablet
Tablet
Syrup
Tablet
Tablet
Injection
Tablet
Liquid
Liquid
Liquid
Liquid
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Medical Dressing
Bandage
Tablet
Suspension
Crutch
Crutch
Crutch
Crutch
Support
Support
Drops
Elixir
Syrup
Solution
Drops
Solution
Capsule
Tablet
Injection
Injection
Tablet
Syrup
Tablet
Syrup
Injection
Injection
Tablet
Tablet
Cream
Injection
Capsule
Syrup
Syrup
Capsule
Tablet
Syrup
Suspension
Tablet
Suspension
Syrup
Injection
Injection
Injection
Tablet
Tablet
Gel
Tablet
Gel
Tablet
Tablet
Gel
Capsule
Tablet
Suspension
Bolus
Powder
Powder
Powder
Tablet
Pack
Powder
Ready-to-Drink
Ready-to-Drink
Medical Equipment
Inhaler
Sterilizer
Electrolyte
Electrolyte
Electrolyte
Powder
Powder
Powder
Powder
Powder
Liquid
Sachet
Powder
Powder
Powder
Powder
Powder
Syrup
Syrup
Medical Equipment
Syrup
Capsule
Capsule
Tablet
Drops
Support
Tablet
Syrup
Tablet
Tablet
Syrup
Suspension
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Syrup
Capsule
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Bolus
Injection
Injection
Tablet
Tablet
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Capsule
Granules
Cream
Lotion
Ointment
Tablet
Tablet
Tablet
Tablet
Tablet
Lotion
Body Wash
Cream
Cream
Lotion
Lotion
Lotion
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Syrup
Tablet
Injection
Syrup
Syrup
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Syrup
Tablet
Oral Solution
Tablet
Tablet
Cream
Sachet
Syrup
Tablet
Syrup
Syrup
Tablet
Tablet
Drops
Syrup
Syrup
Tablet
Tablet
Tablet
Syrup
Syrup
Granules
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Suspension
Tablet
Tablet
Tablet
Suspension
Tablet
Device
Tablet
Injection
Syrup
Tablet
Tablet
Capsule
Injection
Suspension
Tablet
Drop
Syrup
Syrup
Ointment
Tablet
Tablet
Tablet
Tablet
Drop
Tablet
Injection
Injection
Tablet
Tablet
Suspension
Tablet
Syrup
Syrup
Drop
Injection
Syrup
Tablet
Injection
Syrup
Syrup
Syrup
Tablet
Tablet
Injection
Tablet
Cream
Tablet
Paste
Paste
Paste
Tablet
Tablet
Cream
Injection
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Capsule
Injection
Suspension
Tablet
Tablet
Tablet
Syrup
Nasal Spray
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Supplement
Syrup
Drops
Syrup
Tablet
Tablet
Prefilled Syringe
Prefilled Syringe
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Syrup
Syrup
Syrup
Bolus
Bolus
Suspension
Syrup
Tablet
Suspension
Suspension
Bolus
Bolus
Tablet
Tablet
Tablet
Suspension
Bolus
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Capsule
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Capsule
Tablet
Bolus
Medical Equipment
Enema
Powder
Liquid
Powder
Powder
Medication
Medication
Ointment
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Tablet
Injection
Injection
Dry Syrup
Tablet
Tablet
Tablet
Injection
Injection
Tablet
Supplement
Supplement
Softlet
Tablet
Injection
Injection
Injection
Medication
Drops
Tablet
Tablet
Tablet
Injection
Syrup
Syrup
Syrup
Syrup
Syrup
Injection
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Injection
Syrup
Injection
Tablet
Cream
Cream
Medication
Capsule
Capsule
Syrup
Medical Equipment
Medical Equipment
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Supplement
Capsule
Supplement
Tablet
Tablet
Tablet
Tablet
Drops
Tablet
Tablet
Capsule
Drops
Tablet
Tablet
Capsule
Tablet
Drops
Syrup
Tablet
Syrup
Tablet
Capsule
Sachets
Sachet
Sachet
Sachet
Tablet
Injection
Tablet
Tablet
Tablet
Syrup
Syrup
Supplement
Capsule
Syrup
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Suspension
Tablet
Tablet
Gel
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Gel / Ointment
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Syrup
Syrup
Syrup
Medical Device
Medical Device
Injection
Injection
Tablet
Injection
Medical Device
Medical Device
Medical Device
Medical Device
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Injection
Syrup
Eye Drop
Tablet
Surgical Instrument
Syrup
Syrup
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Injection
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Tablet
Tablet
Tablet
Capsule
Capsule
Injection
Tablet
Tablet
Drop
Eye Drop
Injection
Syrup
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Tablet
Injection
Injection
Tablet
Suspension
Tablet
Bolus
Suspension
Suspension
Suspension
Syrup
Tablet
Syrup
Bolus
Tablet
Tablet
Syrup
Injection
Tablet
Tablet
Injection
Tablet
Injection
Cleanser
Cleanser
Powder
Shampoo
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Injection
Tablet
Suspension
Packet
Syrup
Liquid
Liquid
Injection
Syrup
Tablet
Drop
Syrup
Tablet
Syrup
Tablet
Tablet
Syrup
Tablet
Syrup
Tablet
Cream
Lotion
Tablet
Tablet
Tablet
Tablet
Cream
Tablet
Tablet
Tablet
Capsule
Capsule
Tablet
Injection
Tablet
Powder
Cream
Capsule
Capsule
Capsule
Capsule
Inhaler
Capsule
Powder
Tablet
Tablet
Cream
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Syrup
Tablet
Syrup
Tablet
Injection
Capsule
Tablet
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Tablet
Tablet
Capsule
Syrup
Ointment
Capsule
Syrup
Tablet
Softlet
Tablet
Softlet
Capsule
Bolus
Tablet
Injection
Injection
Bolus
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Injection
Syrup
Bolus
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Injection
Capsule
Supplement
Sachet
Capsule
Tablet
Tablet
Tablet
Capsule
Syrup
Tablet
Eye Drop
Tablet
Suspension
Suspension
Tablet
Syrup
Syrup
Capsule
Sachet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Cream
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Cream
Cream
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Solution
Solution
Ointment
Capsule
Capsule
Powder
Cream
Cream
Cream
Tablet
Cream
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Syrup
Fiber
Powder
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Capsule
Syrup
Syrup
Tablet
Torch (Accessory)
Fiber
Syrup
Tablet
Capsule
Capsule
Capsule
Cream
Drop
Capsule
Tablet
Rotacap
Rotacap
Syrup
Battery
Tablet
Syrup
Injection
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Medical Equipment
Medical Equipment
Medical Equipment
Solution
Bolus
Cream
Cream
Solution
Tablet
Solution
Solution
Solution
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Bolus
Syrup
Suspension
Suspension
Suspension
Suspension
Suspension
Tablet
Syrup
Tablet
Tablet
Syrup
Tablet
Ointment
Ointment
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Bolus
Syrup
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Suspension
Drops
Suspension
Tablet
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Soap
Soap
Soap
Syrup
Eye Drop
Syrup
Tablet
Tablet
Lotion
Tablet
Medical Accessory
Medical Accessory
Medical Accessory
Medical Equipment
Capsule
Eye Drop
Eye Drop
Eye Drop
Gel
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Cream
Cream
Tablet
Tablet
Gel
Tablet
Tablet
Spray
Spray
Inhaler
Cream
Ointment
Enema
Enema
Powder
Powder
Powder
Drops
Syrup
Capsule
Drops
Capsule
Capsule
Eye Drop
Syrup
Syrup
Lactic Solution
Lactic Solution
Lactic Solution
Lactic Solution
Tablet
Tablet
Syrup
Medical Accessory
Medical Accessory
Tablet
Tablet
Tablet
Tablet
Lotion
Lotion
Lotion
Soap
Cream
Injection
Tablet
Vial
Injection
Tablet
Solution
Injection
Injection
Solution
Solution
Tablet
Solution
Injection
Capsule
Capsule
Capsule
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Gift Item
Tablet
Syrup
Tablet
Tablet
Syrup
Syrup
Capsule
Tablet
Supplement
Suspension
Food Supplement
Food
Food
Food
Food Supplement
Food Supplement
Medicine
Syrup
Tablet
Tablet
Supplement
Supplement
Tablet
Tablet
Tablet
Bolus
Syrup
Bolus
Suspension
Tablet
Tablet
Syrup
Bolus
Cream
Cream
Cream
Cream
First Aid
Tablet
Granules
Test Kit
Test Kit
Tablet
Tablet
Tablet
Tablet
Tablet
Bolus
Eye Drops
Tablet
Syrup
Syrup
Syrup
Syrup
Tablet
Syrup
Tablet
Injection
Drop
Syrup
Tablet
Drops
Suspension
Syrup
Syrup
Medical Equipment
Softgel
Tablet
Tablet
Tablet
Tablet
Drops
Syrup
Tablet
Syrup
Tablet
Syrup
Softgel
Drop
Syrup
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Syrup
Bolus
Food Supplement
Lotion
Tablet
Capsule
Suspension
Suspension
Tablet
Syrup
Capsule
Capsule
Tablet
Tablet
Syrup
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Capsule
Tablet
Syrup
Tablet
Syrup
Syrup
Syrup
Supplement
Tablet
Syrup
Syrup
Syrup
Syrup
Syrup
Capsule
Tablet
Supplement
Gel
Syrup
Syrup
Capsule
Powder
Tablet
Gel
Injection
Tablet
Syrup
Injection
Tablet
Tablet
Tablet
Capsule
Bolus
Tablet
Massage Oil
Tablet
Massage Oil
Syrup
Tablet
Tablet
Tablet
Bolus
Bolus
Bolus
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Bolus
Tablet
Tablet
Capsule
Tablet
Bolus
Capsule
Tablet
Bolus
Bolus
Tablet
Capsule
Cream
Tablet
Capsule
Suspension
Bolus
Bolus
Bolus
Tablet
Bolus
Suspension
Tablet
Equipment
Equipment
Equipment
Syrup
Tablet
Syrup
Tablet
Tablet
Infusion
Tablet
Tablet
Syrup
Tablet
Tablet
Syrup
Tablet
Syrup
Tablet
Drops
Syrup
Capsule
Capsule
Syrup
Tablet
Syrup
Tablet
Syrup
Tablet
Tablet
Tablet
Suspension
Tablet
Syrup
Tablet
Syrup
Injection
Syrup
Tablet
Syrup
Injection
Injection
Tablet
Syrup
Tablet
Syrup
Tablet
Syrup
Tablet
Syrup
Powder
Syrup
Suspension
Tablet
Tablet
Drops
Bolus
Injection
Drops
Tablet
Syrup
Tablet
Capsule
Powder
Syrup
Syrup
Tablet
Syrup
Syrup
Tablet
Drops
Syrup
Liquid
Liquid
Liquid
Liquid
Liquid
Injection
Tablet
Tablet
Suspension
Tablet
Syrup
Tablet
Capsule
Tablet
Injection
Injection
Tablet
Drops
Suspension
Syrup
Solution
Syrup
Tablet
Tablet
Syrup
Syrup
Syrup
Syrup
Tablet
Tablet
Tablet
Kit
Tablet
Capsule
Suspension
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Granules
Syrup
Tablet
Syrup
Tablet
Syrup
Tablet
Capsule
Capsule
Syrup
Syrup
Tablet
Tablet
Syrup
Capsule
Syrup
Bolus
Bolus
Tablet
Bolus
Softgel Capsule
Injection
Injection
Bolus
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Solution
Tablet
Tablet
Tablet
Tablet
Syrup
Capsule
Capsule
Elixir
Tablet
Eye Drops
Eye Drops
Tablet
Capsule
Medical Device
Tablet
Suspension
Drops
Suspension
Injection
Syrup
Syrup
Syrup
Drops
Suspension
Drops
Syrup
Syrup
Syrup
Injection
Intravenous
Suspension
Tablet
Tablet
Tablet
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Suspension
Drops
Syrup
Tablet
Capsule
Tablet
Suspension
Tablet
Capsule
Syrup
Syrup
Tablet
Ovules
Tablet
Tablet
Tablet
Powder
Granules
Sachet Powder
Powder
Tablet
Tablet
Powder
Powder
Powder
Tablet
Tablet
Tablet
Capsule
Injection
Injection
Bolus
Tablet
Tablet
Suspension
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Medical Accessory
Tablet
Tablet
Tablet
Tablet
Tablet
Surgical Tool
Surgical Tool
Tablet
Tablet
Syrup
Tablet
Tablet
Dispersible Tablet
Injection
Injection
Injection
Tablet
Syrup
Syrup
Injection
Injection
Injection
Tablet
Tablet
Medical Accessory
Cream
Tablet
Tablet
Fire Safety Equipment
Tablet
Tablet
Tablet
Tablet
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Eye Drops
Tablet
Tablet
Tablet
Nasal Spray
Syrup
Syrup
Syrup
Dispersible Tablet
Tablet
Injection
Tablet
Medical Dressing
Medical Dressing
Medical Dressing
Tablet
Syrup
Dispersible Tablet
Dispersible Tablet
Tablet
Syrup
Injection
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Intravenous
Syrup
Tablet
Tablet
Capsule
Tablet
Ointment
Tablet
Tablet
Tablet
Eye Drops
Tablet
Utility
Utility
Tablet
Tablet
Tablet
Tablet
Oral Suspension
Tablet
Liquid
Capsule
Dispersible Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Dispersible Tablet
Dispersible Tablet
Tablet
Tablet
Tablet
Capsule
Extended Release Tablet
Gel
Capsule
Medical Accessory
Medical Accessory
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Injection
Injection
Capsule
Medical Accessory
Tablet
Cream
Suspension
Tablet
Tablet
Tablet
Capsule
Sachet
Tablet
Tablet
Syrup
Tablet
Nasal Spray
Injection
Capsule
Capsule
Injection
Injection
Tablet
Tablet
Tablet
Respirable Capsule
Inhaler
Inhaler
Tablet
Tablet
Tablet
Tablet
Eye Drop
Eye Drop
Powder
Bolus
Nasal Spray
Tablet
Tablet
Capsule
Bolus
Syrup
Sachet
Bolus
Powder
Bolus
Bolus
Nasal Spray
Tablet
Syrup
Powder
Injection
Syrup
Tablet
Eye Drop
Tablet
Tablet
Tablet
Tablet
Tablet
Device
Device
Device
Device Component
Device Component
Service
Tablet
Syrup
Tablet
Syrup
Syrup
Syrup
Tablet
Injection
Bolus
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Eye Drop
Drop
Eye Drop
Eye Drop
Syrup
Syrup
Tablet
Tablet
Tablet
Syrup
Tablet
Syrup
Syrup
Tablet
Drop
Drop
Syrup
Tablet
Tablet
Syrup
Tablet
Drop
Syrup
Tablet
Tablet
Tablet
Cream
Gel
Lotion
Cream
Cream
Cream
Lotion
Cream
Cream
Cream
Cream
Cream
Powder
Lotion
Tablet
Tablet
Ointment
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Syrup
Bolus
Bolus
Syrup
Suspension
Syrup
Syrup
Eye Drop
Tablet
Tablet
Tablet
Tablet
Cream
Syrup
Capsule
Capsule
Capsule
Syrup
Tablet
Tablet
Tablet
Eye Drop
Tablet
Capsule
Capsule
Capsule
Syrup
Syrup
Drop
Capsule
Tablet
Eye Drop
Eye Drop
Drop
Eye Drop
Powder
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Ointment
Nasal Spray
Nasal Spray
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Cream
Cream
Ointment
Capsule
Inhaler
Capsule
Inhaler
Inhaler
Capsule
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Syrup
Tablet
Dispersible Tablet
Injection
Capsule
Tablet
Eye Drop
Eye Drop
Eye Drop
Capsule
Syrup
Medical Device
Injection
Syrup
Tablet
Tablet
Capsule
Tablet
Tablet
Capsule
Tablet
Injection
Combo Pack
Capsule
Dispersible Tablet
Sachet
Medical Accessory
Medical Accessory
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Tablet
Softgel
Capsule
Capsule
Softgel
Tablet
Capsule
Tablet
Tablet
Catheter
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Softgel
Tablet
Tablet
Tablet
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Supplement
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Catheter
Injection
Catheter
Catheter
Capsule
Capsule
Softgel
Capsule
Tablet
Capsule
Tablet
Tablet
Tablet
Capsule
Capsule
Suspension
Medical Accessory
Cream
Medical Accessory
Medical Accessory
Medical Accessory
Ointment
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Capsule
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Tablet
Tablet
Kit
Tablet
Medical Product
Syrup
Tablet
Injection
Chemical Solution
Chemical Accessory
Tablet
Accessory
Tablet
Tablet
Injection
Injection
Tablet
Injection
Injection
Tablet
Tablet
Syrup
Tablet
Tablet
Chemical Solution
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Inhaler
Inhaler
Inhaler
Inhaler
Respicap
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Respicap
Respicap
Respicap
Respicap
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Suspension
Syrup
Supplement
Syrup
Tablet
Syrup
Injection
Injection
Injection
Injection
Injection
Injection
Tablet
Tablet
Tablet
Syrup
Injection
Cream
Drop
Syrup
Tablet
Tablet
Tablet
Kit
Injection
Tablet
Tablet
Drop
Drop
Capsule
Capsule
Syrup
Supplement
Tablet
Softlet
Tablet
Tablet
Softlet
Tablet
Tablet
Tablet
Product
Tablet
Tablet
Powder
Soap
Odorant
Odorant
Powder
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Capsule
Syrup
Tablet
Tablet
Tablet
Product
Tablet
Syrup
Capsule
Solution
Solution
Tablet
Syrup
Syrup
Tablet
Tablet
Tablet
Kit
Tablet
Cream
Cream
Cream
Cream
Cream
Cream
Cream
Ointment
Tablet
Capsule
Tablet
Tablet
Drops
Drops
Capsule
Capsule
Capsule
Capsule
Injection
Suspension
Tablet
Capsule
Drops
Syrup
Syrup
Suction
Capsule
Tablet
Tablet
Inhaler
Capsule
Inhaler
Inhaler
Tablet
Tablet
Drop
Syrup
Syrup
Tablet
Capsule
Bolus
Bolus
Tablet
Tablet
Tablet
Capsule
Capsule
Cream
Capsule
Injection
Cream
Tablet
Tablet
Tablet
Tablet
Tablet
Cream
Nasal Spray
Powder
Tablet
Solution
Solution
Ointment
Bolus
Tablet
Bolus
Bolus
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Cream
Cream
Ointment
Solution
Suspension
Tablet
Ointment
Powder
Spray
Ointment
Tablet
Cream
Cream
Ointment
Ointment
Tablet
Tablet
Tablet
Kit
Cream
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Cream
Supplement
Syrup
Tablet
Tablet
Syrup
Syrup
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Drop
Drop
Tablet
Tablet
Band
Tablet
Tablet
Tablet
Solution
Injection
Injection
Solution
Tablet
Tablet
Tablet
Drop
Tablet
Syrup
Capsule
Tablet
Syrup
Syrup
Powder
Suspension
Injection
Injection
Injection
Injection
Medical Bolus
Liquid
Liquid
Liquid
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Syrup
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Injection
Injection
Tablet
Tablet
Cream
Supplement
Supplement
Tablet
Tablet
Tablet
Capsule
Capsule
Tablet
Tablet
Capsule
Tablet
Tablet
Supplement
Supplement
Supplement
Supplement
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Supplement
Tablet
Tablet
Capsule
Capsule
Capsule
Syrup
Tablet
Bolus
Gel
Syrup
Drop
Tablet
Syrup
Tablet
Tablet
Tablet
Capsule
Injection
Tablet
Syrup
Syrup
Tablet
Tablet
Syrup
Syrup
Injection
Injection
Injection
Syrup
Syrup
Syrup
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Drop
Tablet
Syrup
Tablet
Bulk
Bulk
Bolus
Powder
Bolus
Tablet
Tablet
Tablet
Tablet
Drop
Syrup
Tablet
Oral Rehydration Salt
Drop
Syrup
Tablet
Tablet
Tablet
Syrup
Injection
Supplement
Tablet
Tablet
Tablet
Tablet
Lotion
Lotion
Soap
Capsule
Capsule
Tablet
Eye Drop
Ayurvedic Product
Ayurvedic Tablet
Eye Drop
Injection
Injection
Syrup
Syrup
Bolus
Tablets
Syrup
Tablet
Tablet
Supplement
Mouthwash
Tablet
Ayurvedic Product
Ayurvedic Powder
Ayurvedic Powder
Supplement
Liquid
Syrup
Tablet
Powder
Powder
Product
Tablet
Product
Product
Liquid
Capsule
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Drop
Syrup
Syrup
Syrup
Drop
Tablet
Liquid
Tablet
Liquid
Tablet
Product
Syrup
Tablet
Syrup
Syrup
Syrup
Tablet
Syrup
Syrup
Tablet
Suspension
Tablet
Capsule
Sachet
Syrup
Liquid
Tablet
Tablet
Product
Product
Product
Product
Eye Drop
Eye Drop
Tablet
Tablet
Eye Drop
Injection
Injection
Injection
Eye Drop
Tablet
Eye Drop
Tablet
Eye Drop
Tablet
Tablet
Injection
Eye Drop
Tablet
Tablet
Injection
Eye Drop
Tablet
Product
Syrup
Tablet
Syrup
Suspension
Eye Drop
Tablet
Injection
Tablet
Tablet
Eye Drop
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Eye Drop
Eye Drop
Eye Drop
Ointment
Eye Drop
Product
Product
Product
Powder
Liquid
Tablet
Tablet
Capsule
Tablet
Tablet
Capsule
Tablet
Tablet
Capsule
Syrup
Tablet
Product
Syrup
Syrup
Syrup
Product
Gel
Product
Tablet
Liquid
Gel
Gel
Syrup
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Spray
Syrup
Product
Product
Product
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Product
Tablet
Product
Product
Tablet
Tablet
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Tablet
Tablet
Tablet
Product
Tablet
Tablet
Capsule
Tablet
Tablet
Eye Drop
Tablet
Capsule
Syrup
Syrup
Syrup
Liquid
Syrup
Capsule
Syrup
Tablet
Capsule
Bolus
Powder
Injection
Injection
Liquid
Eye Drop
Eye Drop
Injection
Injection
Injection
Injection
Ampoule
Vial
Eye Drop
Vial
Eye/Ear Drop
Eye/Ear Drop
Liquid
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Vial
Tablet
Tablet
Eye/Ear Drop
Eye/Ear Drop
Eye Drop
Eye Drop
Gel
Gel
Paint
Eye/Ear Drop
Eye/Ear Drop
Eye Drop
Injection
Shampoo
Shampoo
Soap
Wipes
Wipes
Vial
Vial
Drop
Tablet
Tablet
Tablet
Eye Drop
Orthopedic Device
Orthopedic Device
Orthopedic Device
Orthopedic Device
Orthopedic Device
Eye Drop
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Capsule
Tablet
Tablet
Tablet
Tablet
Suspension
Tablet
Tablet
Syrup
Tablet
Capsule
Tablet
Capsule
Tablet
Capsule
Capsule
Bolus
Tablet
Capsule
Injection
Injection
Capsule
Capsule
Suspension
Suspension
Tablet
Capsule
Capsule
Capsule
Capsule
Injection
Injection
Capsule
Capsule
Capsule
Syrup
Syrup
Gel
Medicine
Medicine
Medicine
Supplement
Product
Tablet
Surgical Tool
Tablet
Ayurvedic Product
Lotion
Medicine
Tablet
Capsule
Tablet
Capsule
Tablet
Tablet
Tablet
Sachet
Tablet
Tablet
Tablet
Cream
Cream
Medicine
Tablet
Medicine
Medicine
Medicine
Medicine
Medicine
Tablet
Medicine
Tablet
Stationery
Lab Equipment
Syringe
Syringe
Syringe
Syringe
Capsule
Capsule
Medicine
Medicine
Tablet
Tablet
Syrup
Tablet
Tablet
Syrup
Tablet
Injection
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Eye/Ear Drop
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Gel
Soap
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Syrup
Tablet
Tablet
Capsule
Capsule
Syrup
Ointment
Capsule
Drops
Syrup
Suspension
Capsule
Syrup
Capsule
Syrup
Syrup
Unknown
Tablet
Unknown
Unknown
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Gloves
Unknown
Cream
Syrup
Syrup
Capsule
Drops
Capsule
Drops
Syrup
Syrup
Tablet
Tablet
Test Strip
Test Strip
Glucometer
Test Strip
Tablet
Tablet
Tablet
Tablet
Sensor
Glucometer
Glucometer
Glucometer
Test Strip
Test Strip
Test Strip
Unknown
Cream
Tablet
Powder
Powder
Powder
Powder
Powder
Powder
Powder
Powder
Powder
Powder
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Eye Drop
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Jar
Jar
Refill
Pack
Pack
Pack
Pack
Pack
Pack
Pack
Pack
Pack
Pack
Pack
Pack
Pack
Pack
Pack
Pack
Pack
Pack
Jar
Jar
Pack
Pack
Pack
Pack
Pack
Pack
Pack
Pack
Pack
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Medicine
Liquid
Liquid
Syrup
Liquid
Tablet
Tablet
Eye Drop
Capsule
Tablet
Ear Drop
Tablet
Tablet
Tablet
Glycerin
Glycerin
Glycerin
Glycerin
Glycerin
Glycerol
Glycerol
Tablet
Tablet
Tablet
Tablet
Liquid
Liquid
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Solution
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Eye Drop
Medicine
Cream
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Eye Drop
Liquid
Eye Drop
Tablet
Injection
Injection
Capsule
Capsule
Syrup
Tablet
Capsule
Tablet
Tablet
Tablet
Syrup
Capsule
Capsule
BOLUS
Tablet
Medicine
Tablet
Tablet
Tablet
Medicine
Capsule
Tablet
Injection
Tablet
Powder
Capsule
Capsule
Tablet
Pack
Pack
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Chocolate
Liquid
Bar
Gel
Powder
Bandage
Bandage
Powder
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Injection
Dispersible Tablet
Syrup
Tablet
Tablet
Injection
Syrup
Syrup
Tablet
Syrup
Tablet
Dry Syrup
Tablet
Dry Syrup
Injection
Injection
Dispersible Tablet
Injection
Tablet
Dispersible Tablet
Tablet
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Syrup
Syrup
Tablet
Capsule
Capsule
Capsule
Tablet
Tablet
Tablet
Dry Syrup
Tablet
Tablet
Injection
Injection
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Suspension
Injection
Syrup
Syrup
Syrup
Capsule/Tablets/Syrup (Unclear)
Tablet
Tablet
Tablet
Tablet
Biscuits/Supplement
Granules
Powder
Granules
Unknown
Medical/Bed Sheet
Syrup/Granules
Tablet
Tablet
Suspension
Tablet
Tablet
Syrup
Drops
Syrup
Tablet
Syrup
Syrup
Syrup
Pediatric Syrup
Syrup
Syrup
Controlled Release Tablet
Liquid (Oral)
Liquid (Oral)
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Granules
Syrup
Tablet
Syrup
Syrup
Powder
Powder
Syrup
Syrup
Tablet
Powder
Powder
Powder
Powder
Syrup
Syrup
Syrup
Nutritional Supplement
Syrup
Controlled Release Tablet
Controlled Release Tablet
Spray
Spray (Pen Form)
Tablet
Unknown
Syrup
Tablet
Tablet
Tablet
Drops
Syrup
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Syrup
Tablet
Injection
Granules
Syrup
Granules
Extended Release Tablet
Extended Release Tablet
Tablet
Medical Device
Syrup
Syrup
Tablet
Tablet
Medical Device
Capsule
Face Pack
Lotion
Lotion
Lotion
Lotion
Cold Cream
Cold Cream
Cold Cream
Cold Cream
Lotion
Lotion
Cold Cream
Syrup
Syrup
Syrup
Syrup
Nutritional Supplement
Herbal Liquid
Syrup
Pediatric Syrup
Tablet
Syrup
Drops
Capsule
Syrup
Vaccine
Vaccine
Vaccine
Vaccine
Chewable Gummies
Chewable Gummies
Herbal Gel/Tablets
Gel
Powder
Capsule
Syrup
Syrup
Syrup
Powder
Capsule
Granules
Solution/Oral Powder
Capsule
Powder
Capsule
Sachet
Suspension
Bolus
Syrup
Granules
Kit
Capsule
Tablet
Tablet
Tablet
Tablet
Cream
Syrup
Tablet
Cream
Tablet
Capsule
Bandage Roll
Bandage Roll
Bandage Roll
Bandage Roll
Bandage Slab
Bandage Slab
Solution
Drops
Tablet
Tablet
Injection
Powder
Powder
Syrup
Tablet
Tablet
Tablet
Syrup
Powder
Powder
Drops
Syrup
Powder
Powder
Powder
Powder
Solution
Solution
Solution
Syrup
Syrup
Capsule
Solution
Solution
Solution
Solution
Tablet
Tablet
IV Solution
Diagnostic Tool
Syrup
Syrup
Syrup
Diagnostic Tool
Diagnostic Tool
Syrup
Syrup
Hair Solution
Hair Solution
Tablet
Digestive Candy
Digestive Candy
Digestive Candy
Digestive Candy
Digestive Candy
Digestive Candy
Digestive Candy
Digestive Candy
Tablet
Capsule
Capsule
Injection
Syrup
Tablet
Tablet
Cream
Cream
Cream
Cream
Ointment
Ointment
Drops
Suspension
Cream
Cream
Lotion
Ointment
Medical Accessory
Medical Accessory
Cream
Lotion
Ointment
Cream
Capsule
Tool
Tool
Tool
Medical Gloves
Medical Gloves
Medical Gloves
Medical Gloves
Non-Sterile Gloves
Non-Sterile Gloves
Non-Sterile Gloves
Liquid Soap
Bandage
Bandage
Bandage
Bandage
Capsule
Capsule
Syrup
Medical Bolus
Capsule
Capsule
Capsule
Tablet
Tablet
Gel
Cream
Powder
Syrup
Syrup
Tablet
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Cleaning Product
Brand
Medication
Syrup
Medication
Syrup
Vapor
Capsule
Tablet
Capsule
Syrup
Syrup
Syrup
Syrup
Syrup
Tablet
Injection
Tablet
Syrup
Syrup
Syrup
Tablet
Syrup
Tablet
Syrup
Supplement
Liquid Supplement
Supplement
Supplement
Tablet
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Equipment
Equipment
Brand
Brand
Brand
Gel
Capsule
Suspension
Syrup
Syrup
Injection
Ointment
Syrup
Syrup
Syrup
Syrup
Brand
Syrup
Supplement
Syrup
Capsule
Syrup
Syrup
Syrup
Medical Device
Medical Device
Capsule
Capsule
Supplement
Supplement
Injection
Syrup
Capsule
Medical Device
Medical Device
Medical Accessory
Medical Accessory
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Medical Device
Service
Medical Device
Medical Device
Service
Accessory
Medical Device
Tablet
Equipment
Equipment
Equipment
Equipment
Equipment
Foot Care
Foot Care
Foot Care
Foot Care
Equipment
Supplement
Capsule
Capsule
Tablet
Medication
Medication
Capsule
Tablet
Tablet
Suspension
Tablet
Syrup
Syrup
Medication
Tablet
Syrup
Syrup
Tablet
Syrup
Syrup
Syrup
Medication
Syrup
Tablet
Capsule
Kit
Capsule
Supplement
Injection
Soft Gel Capsule
Syrup
Syrup
Injection
Tablet
Capsule
Syrup
Syrup
Syrup
Supplement
Soft Gel Capsule
Syrup
Syrup
Capsule
Syrup
Syrup
Tablet
Syrup
Capsule
Syrup
Syrup
Syrup
Syrup
Capsule
Syrup
Tablet
Injection
Tablet
Tablet
Syrup
Syrup
Syrup
Syrup
Tablet
Tablet
Injection
Syrup
Capsule
Tablet
Tablet
Injection
Injection
Syrup
Syrup
Capsule
Drop
Syrup
Liquid
Syrup
Tablet
Powder
Powder
Injection
Tablet
Capsule
Capsule
Capsule
Syrup
Syrup
Tablet
Injection
Syrup
Syrup
Tablet
Syrup
Syrup
Syrup
Capsule
Drops
Powder
Syrup
Syrup
Liquid
Powder
Powder
Liquid
Powder
Powder
Liquid
Syrup
Drop
Syrup
Tablet
Syrup
Injection
Syrup
Tablet
Injection
Capsule
Syrup
Syrup
Syrup
Tablet
Tablet
Tablet
Syrup
Syrup
Syrup
Drop
Drop
Syrup
Syrup
Syrup
Syrup
Syrup
Capsule
Syrup
Syrup
Capsule
Syrup
Drop
Tablet
Syrup
Tablet
Syrup
Capsule
Cream
Injection
Supplement
Supplement
Capsule
Injection
Powder
Powder
Powder
Powder
Kit
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medicine
Tablet
Tablet
Gel
Tablet
Medicine
Cream
Tablet
Tablet
Tablet
Tablet
Ointment
Supplement
Supplement
Supplement
Supplement
Medicine
Kit
Tablet
Tablet
Injection
Tablet
Tablet
Mouthwash
Solution
Injection
Mouthwash
Mouthwash
Syrup
Syrup
Mouthwash
Solution
Solution
Medicine
Tablet
Surgical Instrument
Syrup
Syrup
Tablet
Supplement
Supplement
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Tablet
Tablet
Thermometer
Thermometer
Thermometer
Thermometer
Surgical Accessory
Drops
Cream
Lotion
Soap
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Drops
Medicine
Syrup
Syrup
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Gel
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Kit
Syrup
Tablet
Drops
Syrup
Tablet
Kit
Syrup
Medicine
Medicine
Capsule
Capsule
Syrup
Syrup
Capsule
Syrup
Capsule
Syrup
Syrup
Syrup
Medical Equipment
Syrup
Medicine
Tablet
Tablet
Powder
Injection
Injection
Injection
Supplement
Lotion
Ointment
Liquid
Liquid
Liquid
Gel
Gel
Tablet
Cream
Veterinary Medicine
Tablet
Veterinary Medicine
Liquid
Liquid
Oil
Capsule
Medical Accessory
Medical Accessory
Medical Accessory
Medicine
Medicine
Medicine
Powder
Powder
Churna
Churna
Tablet
Mouthwash
Mouthwash
Mouthwash
Toothpaste
Toothpaste
Gel
Paste
Food
Food
Medicine
Medicine
Capsule
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Supplement
Supplement
Cream
Cream
Injection
Tablet
Tablet
Tablet
Tablet
Medicine
Ampoule
Tablet
Tablet
Tablet
Drops
Syrup
Tablet
Tablet
Tablet
Injection
Syrup
Tablet
Medicine
Syrup
Surgical Instrument
Tablet
Tablet
Tablet
Tablet
Liquid
Syringe
Liquid
Liquid
Injection
Tablet
Liquid
Kit
Syrup
Syrup
Syrup
Injection
Surgical Accessory
Surgical Accessory
Surgical Accessory
Surgical Accessory
Surgical Accessory
Surgical Accessory
Surgical Accessory
Surgical Accessory
Surgical Accessory
Drops
Syrup
Syrup
Tablet
Syrup
Medicine
Kit
Drops
Medicine
Medicine
Food
Food
Food
Food
Food
Food
Food
Food
Food
Syrup
Syrup
Drops
Tablet
Syrup
Drops
Drops
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Tablet
Suspension
Tablet
Injection
Tablet
Capsule
Tablet
Capsule
Medicine
Injection
Injection
Medical Equipment
Injection
Injection
Medicine
Medicine
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Drops
Syrup
Medicine
Kit
Surgical Accessory
Surgical Accessory
Surgical Accessory
Surgical Accessory
Ointment
Syrup
Syrup
Injection
Injection
Syrup
Tablet
Kit
Diaper
Diaper
Diaper
Diaper
Diaper
Diaper
Diaper
Diaper
Medicine
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Equipment
Injection
Injection
Injection
Injection
Medicine
Tablet
Tablet
Suspension
Powder
Tablet
Tablet
Solution
Solution
Solution
Cream
Cream
Lotion
Injection
Tablet
Medicine
Drops
Drops
Drops
Injection
Injection
Medicine
Capsule
Suspension
Syrup
Powder
Medicine
Medicine
Drops
Spray
Spray
Injection
Drops
Syrup
Tablet
Injection
Medical Accessory
Medical Accessory
Medical Accessory
Tablet
Ointment
Ointment
Injection
Tablet
Injection
Tablet
Tablet
Drops
Injection
Injection
Injection
Suspension
Tablet
Injection
Injection
Injection
Suspension
Injection
Injection
Injection
Injection
Tablet
Tablet
Medicine
Powder
Tablet
Injection
Injection
Injection
Injection
Powder
Injection
Injection
Syrup
Tablet
Tablet
Syrup
Tablet
Tablet
Syrup
Capsule
Tablet
Tablet
Tablet
Medicine
Suspension
Tablet
Syrup
Tablet
Drops
Injection
Syrup
Tablet
Medical Accessory
Medical Accessory
Medicine
Drops
Test Kit
Tablet
Tablet
Tablet
Medicine
Drops
Drops
Ointment
Capsule
Medicine
Tablet
Suspension
Suspension
Drops
Syrup
Syrup
Syrup
Capsule
Tablet
Tablet
Tablet
Test Kit
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Medicine
Suspension
Tablet
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Medical Accessory
Injection
Syrup
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Medicine
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Suspension
Tablet
Tablet
Suspension
Tablet
Tablet
Tablet
Suspension
Tablet
Powder
Gel
Cream
Powder
Tablet
Suspension
Tablet
Tablet
Drops
Tablet
Capsule
Tablet
Syrup
Tablet
Tablet
Tablet
Emulsion
Tablet
Tablet
Tablet
Tablet
Medicine
Gel
Germicide
Tablet
Suspension
Suspension
Suspension
Tablet
Tablet
Drops
Syrup
Tablet
Tablet
Tablet
Powder
Tablet
Tablet
Kit
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Capsule
Capsule
Capsule
Suspension
Suspension
Tablet
Injection
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Liquid
Injection
Powder
Cream
Vaginal Suppository
Tablet
Injection
Tablet
Syrup
Syrup
Liquid
Syrup
Tablet
Tablet
Liquid
Tablet
Medicine
Medicine
Tablet
Liquid
Medicine
Syrup
Medicine
Cream
Ointment
Ointment
Capsule
Medicine
Sachet
IV Solution
Tablet
Powder
Powder
Powder
Medical Equipment
Medical Equipment
Powder
Tablet
Sachet
Drops
Medicine
Tablet
Capsule
Tablet
Tablet
Tablet
Medicine
Tablet
Tablet
Injection
Injection
Tablet
Medicine
Medicine
Medicine
Medical Equipment
Medicine
Medicine
Medicine
Veterinary Medicine
Tablet
Syrup
Tablet
Injection
Injection
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Syrup
Tablet
Syrup
Syrup
Tablet
Medicine
Medicine
Syrup
Syrup
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Injection
Suspension
Suspension
Suspension
Liquid
Medicine
Suspension
Syrup
Injection
Injection
Tablet
Tablet
Tablet
Injection
Medicine
Gel
Tablet
Tablet
Suspension
Suspension
Tablet
Tablet
Tablet
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Syrup
Tablet
Gel
Injection
Tablet
Tablet
Tablet
Medical Equipment
Medicine
Medicine
Gel
Tablet
Tablet
Tablet
Tablet
Tablet
Ointment
Tablet
Tablet
Tablet
Tablet
Medicine
Veterinary Medicine
Veterinary Medicine
Veterinary Medicine
Veterinary Medicine
Veterinary Medicine
Tablet
Suspension
Medicine
Drops
Drops
Medical Equipment
Medical Equipment
Inhaler
Mouthwash
Mouthwash
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Syrup
Capsule
Capsule
Capsule
Liquid
Injection
Injection
Tablet
Injection
Veterinary Medicine
Syrup
Tablet
Spray
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Suspension
Tablet
Syrup
Tablet
Suspension
Suspension
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Drops
Suspension
Medical Equipment
Medical Equipment
Injection
Injection
Injection
Injection
Injection
Medicine
Syringe
Syringe
Medicine
Medicine
Medicine
Medicine
Capsule
Capsule
Capsule
Capsule
Injection
Injection
Tablet
Injection
Injection
Liquid
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Injection
Medicine
Capsule
Syrup
Syrup
Tablet
Tablet
Injection
Injection
Medicine
Medicine
Medicine
Medicine
Medicine
Medicine
Medicine
Medicine
Medicine
Medicine
Medicine
Medicine
Medicine
Medicine
Medicine
Medicine
Capsule
Injection
Tablet
Tablet
Tablet
Injection
Injection
Liquid
Liquid
Medical Equipment
Syrup
Tablet
Liquid
Medical Equipment
Medical Equipment
Medicine
Medicine
Tablet
Liquid
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Injection
Injection
Tablet
Medical Equipment
Injection
Drops
Liquid
Veterinary Medicine
Veterinary Medicine
Liquid
Liquid
Tablet
Syrup
Drops
Veterinary Medicine
Veterinary Medicine
Powder
Syrup
Veterinary Medicine
Capsule
Drops
Drops
Drops
Drops
Capsule
Ointment
Cream
Lotion
Tablet
Inhaler
Inhaler
Inhaler
Inhaler
Inhaler
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Capsule
Suspension
Syrup
Tablet
Drops
Drops
Drops
Drops
Capsule
Liquid
Capsule
Drops
Syrup
Tablet
Liquid
Capsule
Syrup
Tablet
Tablet
Medicine
Injection
Injection
Suspension
Medical Equipment
Capsule
Syrup
Capsule
Powder
Powder
Powder
Medicine
Tablet
Syrup
Tablet
Chart
Medicine
Tablet
Tablet
Tablet
Capsule
Tablet
Tablet
Medicine
Injection
Capsule
Capsule
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Card
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Syrup
Lotion
Lotion
Powder
Powder
Powder
Ointment
Cream
Cream
Suspension
Syrup
Syrup
Drops
Veterinary Medicine
Ointment
Injection
Tablet
Drops
Medicine
Tablet
Capsule
Capsule
Capsule
Drops
Ointment
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Medical Equipment
Medical Equipment
Medical Equipment
Injection
Injection
Injection
Injection
Tablet
Tablet
Injection
Injection
Medicine
Medicine
Tablet
Injection
Tablet
Tablet
Liquid
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Injection
Medicine
Tablet
Liquid
Injection
Tablet
Syrup
Injection
Liquid
Tablet
Tablet
Shampoo
Medical Equipment
Syrup
Tablet
Powder
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Tablet
Injection
Liquid
Liquid
Tablet
Cream
Oil
Powder
Powder
Shampoo
Soap
Cotton Buds
Oil
Oil
Drops
Medicine
Medicine
Syrup
Syrup
Syrup
Tablet
Injection
Syrup
Tablet
Syrup
Syrup
Lotion
Tablet
Tablet
Tablet
Syrup
Capsule
Tablet
Tablet
Tablet
Tablet
Powder
Oil
Oil
Oil
Oil
Medicine
Medicine
Drops
Syrup
Tablet
Medicine
Injection
Injection
Injection
Injection
Syrup
Medical Equipment
Medical Equipment
Powder
Powder
Powder
Powder
Medicine
Tablet
Tablet
Liquid
Syrup
Tablet
Gel
Tablet
Tablet
Medicine
Oil
Tablet
Tablet
Tablet
Medicine
Medicine
Medicine
Medicine
Tablet
Tablet
Tablet
Capsule
Cream
Flavor
Syrup
Capsule
Syrup
Tablet
Tablet
Lotion
Oil
Injection
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Sachet
Medicine
Medicine
Medicine
Medicine
Medicine
Medicine
Syrup
Drops
Ointment
Injection
Syrup
Liquid
Injection
Liquid
Tablet
Syrup
Liquid
Powder
Powder
Powder
Powder
Tablet
Syrup
Tablet
Tablet
Liquid
Liquid
Tablet
Tablet
Liquid
Liquid
Liquid
Liquid
Injection
Injection
Tablet
Injection
Tablet
Tablet
Injection
Injection
Liquid
Capsule
Drops
Drops
Tool/Accessory
Tablet
Liquid
Liquid
Powder
Injection
Injection
Injection
Sachet
Syrup
Tablet
Tablet
Tablet/Herbal
Liquid
Bolus/Tablets
Bolus/Tablets
Suspension
Tablet
Tablet
Tablet
Sachet
Drops
Liquid
Syrup
Liquid
Powder
Powder
Powder
Liquid
Liquid
Liquid
Injection
Injection
Tablet
Powder
Oil
Ghee-based
Liquid
Liquid
Injection
Injection
Injection
Powder
Drops
Powder
Syrup
Syrup
Powder
Injection
Powder
Cream
Lotion
Lotion
Powder
Injection
Injection
Injection
Tablet
Syrup
Tool/Accessory
Lotion
Capsule
Syrup/Herbal
Syrup/Herbal
Syrup
Syrup
Tablet
Powder/Herbal
Powder/Herbal
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Capsule
Tablet
Capsule
Syrup
Injection
Tablet
Syrup
Injection
Syrup/Herbal
Tablet
Tablet
Capsule
Gel
Tablet
Capsule
Capsule/Tablet
Injection
Capsule
Injection
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Suspension
Tablet
Tablet
Syrup
Tablet
Syrup
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Syrup
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Suspension
Tablet
Suspension
Injection
Injection
Syrup
Syrup
Tablet
Suspension
Tablet
Capsule
Capsule
Syrup
Capsule
Capsule
Capsule
Syrup
Injection
Capsule
Tablet
Tablet
Suspension
Injection
Paste
Tablet
Injection
Injection
Syrup
Herbal/Supplement
Medical Tape
Medical Tape
Medical Tape
Medical Tape
Hair Serum
Lotion
Tablet
Tablet
Ointment
Tablet
Syrup
Herbal/Supplement
Herbal/Supplement
Powder
Injection
Injection
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Drops
Tablet
Liquid
Shampoo
Tablet
Tablet
Tablet
Eye Drops
Shampoo
Tablet
Gel
Liquid
Liquid
Liquid
Liquid
Soap
Tablet
Gel
Injection
Tablet
Tablet
Injection
Injection
Tablet
Tablet
Syrup
Liquid/Herbal
Liquid/Herbal
Herbal/Supplement
Herbal/Supplement
Herbal/Supplement
Herbal/Supplement
Liquid
Liquid
Liquid
Liquid
Powder
Powder
Syrup
Syrup
Drops
Syrup
Medical Equipment
Oral Care
Supplement
Syrup
Drops
Drops
Syrup
Syrup
Tablet
Tablet
Liquid
Tablet
Tablet
Tablet
Drops
Syrup
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Lotion
Cream
Medical Equipment
Tablet
Syrup
Tablet
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Medical Equipment
Tablet
Tablet
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Suspension
Syrup
Tablet
Tablet
Tablet
Tablet
Medical Equipment
Topical
Tablet
Tablet
Capsule
Syrup
Injection
Tablet
Tablet
Tablet
Tablet
Drops
Tablet
Capsule
Capsule
Injection
Tablet
Bolus
Suspension
Eye/Ear Drops
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Orthopedic Support
Injection
Injection
Tablet
Syrup
Syrup
Tablet
System
Syrup
Syrup
Syrup
Syrup
Syrup
Powder
Powder
Syrup
Syrup
Syrup
Lozenges
Syrup
Syrup
Tablet
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Supplement
Supplement
Supplement
Supplement
Supplement
Supplement
Supplement
Supplement
Drops
Gel
Surgical Tool
Tablet
Tablet
Syrup
Tablet
Tablet
Drops
Syrup
Tablet
Syrup
Suspension
Tablet
Tablet
Tablet
Eye/Ear Drops
Capsule
Tablet
Tablet
Tablet
Tablet
Sanitary Pad
Sanitary Pad
Sanitary Pad
Sanitary Pad
Sanitary Pad
Sanitary Pad
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Drops
Tablet
Tablet
Cream
Gel
Cream
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Cream
Tablet
Syrup
Suspension
Tablet
Syrup
Syrup
Bolus
Syrup
Tablet
Tablet
Tablet
Eye/Ear Drops
Shampoo
Eye/Ear Drops
Drops
Syrup
Syrup
Syrup
Syrup
Tablet
Syrup
Tablet
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Bandage
Bandage
Bandage
Bandage
Syrup
Syrup
Syrup
Oil
Clothing
Powder
Syrup
Tablet
Tablet
Tablet
Tablet
Injection
Injection
Injection
Capsule
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Syrup
Capsule
Capsule
Tablet
Tablet
Capsule
Injection
Syrup
Cream
Syrup
Injection
Injection
Eye/Ear Drops
Injection
Tablet
Suspension
Syrup
Tablet
Syrup
Ointment
Drops
Tablet
Drops
Tablet
Tablet
Tablet
Liquid
Drops
Syrup
Liquid
Liquid
Tablet
Capsule
Medical Equipment
Liquid
Liquid
Liquid
Medical Equipment
Powder
Injection
Injection
Injection
Tablet
Injection
Syrup
Tablet
Injection
Syrup
Medical Equipment
Tablet
Injection
Powder
Powder
Tablet
Tablet
Tablet
Syrup
Liquid
Liquid
Tablet
Tablet
Tablet
Tablet
Ointment
Drops
Drops
Drops
Drops
Drops
Gel
Syrup
Syrup
Liquid
Liquid
Capsule
Granules
Powder
Powder
Powder
Powder
Syrup
Powder
Bolus
Powder
Powder
Powder
Powder
Syrup
Liquid
Powder
Powder
Capsule
Syrup
Syrup
Capsule
Capsule
Sachet
Sachet
Capsule
Syrup
Powder
Capsule
Powder
Tablet
Syrup
Injection
Injection
Injection
Tablet
Syrup
Tablet
Powder
Powder
Powder
Tablet
Powder
Powder
Capsule
Syrup
Powder
Powder
Injection
Powder
Powder
Tablet
Tablet
Tablet
Tablet
Capsule
Liquid
Liquid
Powder
Syrup
Bolus
Capsule
Capsule
Sachet
Softgel
Sachet
Capsule
Syrup
Syrup
Syrup
Capsule
Capsule
Capsule
Tablet
Tablet
Sachet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Powder
Syrup
Powder
Powder
Powder
Powder
Powder
Powder
Powder
Powder
Paste
Paste
Paste
Paste
Paste
Paste
Oil
Oil
Oil
Oil
Oil
Oil
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Cream
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Oral Solution
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Injection
Tablet
Tablet
Capsule
Surgical Instrument
Ointment
Drops
Suspension
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Capsule
Tablet
Cartridge
Set
Kit
Insulin Pen
Capsule
Capsule
Tablet
Surgical Equipment
Suspension
Tablet
Tablet
Tablet
Tablet
Surgical Instrument
Tablet
Tablet
Syrup
Tablet
Syrup
Syrup
Tablet
Injection
Injection
Tablet
Syrup
Tablet
Injection
Tablet
Tablet
Tablet
Injection
Injection
Tablet
Tablet
Syrup
Tablet
Liquid
Tablet
Suspension
Injection
Syrup
Candy
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Drops
Tablet
Syrup
Medical Equipment
Softgel
Syrup
Tablet
Drops
Syrup
Tablet
Drops
Syrup
Medical Equipment
Medical Equipment
Lotion
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Drops
Drops
Drops
Liquid
Syrup
Syrup
Powder
Powder
Tablet
Tablet
Tablet
Syrup
Tablet
Syrup
Tablet
Capsule
Tablet
Tablet
Powder
Syrup
Syrup
Suspension
Granules
Syrup
Syrup
Syrup
Syrup
Syrup
Syrup
Powder
Powder
Powder
Syrup
Syrup
Syrup
Powder
Syrup
Tablet
Powder
Sachet
Powder
Powder
Tablet
Syrup
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Syrup
Tablet
Suspension
Capsule
Tablet
Tablet
Tablet
Tablet
Syrup
Syrup
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Liquid
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Syrup
Capsule
Syrup
Injection
Injection
Medical Equipment
Syrup
Syrup
Tablet
Syrup
Tablet
Powder
Tablet
Drops
Drops
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Medical Equipment
Medical Equipment
Medical Equipment
Injection
Injection
Tablet
Tablet
Tablet
Syrup
Syrup
Tablet
Tablet
Tablet
Liquid
Injection
Tablet
Tablet
Cream
Syrup
Tablet
Powder
Powder
Powder
Drops
Syrup
Drops
Syrup
Tablet
Tablet
Syrup
Syrup
Syrup
Tablet
Syrup
Syrup
Syrup
Syrup
Powder
Powder
Tablet
Powder
Tablet
Tablet
Medical Equipment
Tablet
Syrup
Syrup
Tablet
Tablet
Injection
Injection
Tablet
Syrup
Syrup
Injection
Tablet
Tablet
Syrup
Injection
Injection
Tablet
Suspension
Suspension
Suspension
Syrup
Tablet
Syrup
Bolus
Milk
Milk
Milk
Tablet
Drops
Syrup
Tablet
Suspension
Tablet
Injection
Tablet
Syrup
Tablet
Capsule
Suppository
Granules
Syrup
Capsule
Tape
Tape
Capsule
Capsule
Bandage
Tape
Tablet
Tablet
Syrup
Inhaler
Inhaler
Inhaler
Tablet
Tablet
Suspension
Tablet
Tablet
Tablet
Tablet
Insulin Pen
Tablet
Tablet
Tablet
Injection
Syrup
Tablet
Tablet
Injection
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Eye Drop
Tablet
Tablet
Tablet
Suspension
Tablet
Tablet
Tablet
Syrup
Suspension
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Suspension
Tablet
Tablet
Inhaler
Inhaler
Tablet
Tablet
Tablet
Inhaler
Inhaler
Syrup
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Syrup
Tablet
Drops
Tablet
Capsule
Tablet
Suspension
Tablet
Injection
Syrup
Tablet
Syrup
Tablet
Syrup
Tablet
Drops
Drops
Tablet
Drops
Syrup
Syrup
Tablet
Tablet
Drops
Injection
Capsule
Syrup
Tablet
Tablet
Syrup
Tablet
Capsule
Suspension
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Syrup
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Syrup
Injection
Gel
Gel
Gel
Wash
Tablet
Injection
Bolus
Bolus
Injection
Injection
Injection
Injection
Capsule
Sachet
Syrup
Syrup
Capsule
Kit
Liquid
Liquid
Liquid
Injection
Injection
Injection
Injection
Injection
Tablet
Tablet
Tablet
Tablet
Tablet
Injection
Capsule
Medical Equipment
Medical Equipment
Gel
Gel
Tablet
Tablet
Tablet
Syrup
Tablet
Tablet
Syrup
Syrup
Syrup
Syrup
Syrup
Injection
Syrup
Syrup
Medical Equipment
Injection
Tablet
Injection
Tablet
Injection
Tablet
Injection
Injection
Injection
Injection
Syrup
Tablet
Tablet
Tablet
Liquid
Liquid
Liquid
Syrup
Drop
Injection
Capsule
Capsule
Tablet
Tablet
Tablet
Tablet
Balm
Tablet
Tablet
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Gel
Syrup
Syrup
Tablet
Liquid
Liquid
Liquid
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Mouth Wash
Injection
Injection
Gel
Caplet
Syrup
Capsule
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Tablet
Stethoscope
Syrup
Capsule
Syrup
Syrup
Bolus
Drop
Drop
Tablet
Syrup
Syrup
Syrup
Tablet
Drop
Liquid
Syrup
Syrup
Syrup
Tablet
Syrup
Drop
Syrup
Tablet
Liquid
Liquid
Liquid
Injection
Cream
Tablet
Liquid
Liquid
Syrup
Tablet
Capsule
Suspension
Syrup
Syrup
Syrup
Supplement
Syrup
Tablet
Syrup
Tablet
Injection
Supplement
Tablet
Syrup
Syrup
Tablet
Syrup
Tablet
Syrup
Tablet
Syrup
Capsule
Syrup
Capsule
Syrup
Tablet
Syrup
Injection
Syrup
Capsule
Drop
Capsule
Syrup
Tablet
Liquid
Tablet
Capsule
Syrup
Liquid
Bolus
Injection
Syrup
Injection
Syrup
`

export const parseMedicineTypeExcelData = () => {
    const rows = MEDICINE_TYPE.trim().split('\n'); // Split by new lines
    const headers = rows.shift().split('\t'); // Extract headers
    const result = rows.map((row, index) => {
        const [ProductType] = row.split('\t'); // Split by tabs
        return ProductType;
    });
    const uniqueResult = [...new Set(result)];
    return uniqueResult;
}

export const MEDICINE_LIST = `
Pentid 400 MG Tablet	1x10
Ultracet Tablet	1x15
Combliflam Tablet	1x20
Azithral 200 MG Syrup	1x15
Karvol Plus Capsule	1x15
Aciloc 300 MG Tablet	1x20
Taxim O CV 200 MG Tablet	10 Tab
Taxim O Forte Syrup	60 ML
Zerodol SP Tablet	10 Tab
Zyloric 100 MG Tablet	10 Tab
A to Z Syrup	200 ML
Noworm Suspension	10 ML
Lantus Cartridge	3 ML
Ondem MD4 Tablet	10 Tab
Lumerax 80 Tablet	6 Tab
Crocin 120 Suspension	60 ML
Lantus Solostar Cartridge	3 ML
Betadine Solution	100 ML
Human Mixtard 40 Suspension	10 ML
Stayfree 6-XL Pads	1X1
Stayfree 18-XL Pads	1X1
Whisper 6-XL Pads	1X1
Whisper 18-XL Pads	1X1
BD Pen Needle 4 MM Needle	1X1
Amitone 10 MG Tablet	1X10
Candid 120 GM Powder	1X120 GM
Rosuvas 5 MG Tablet	1X15
Candibiotic Plus Ear Drop	1X5 ML
Rosuvas 10 MG Tablet	1X15
Decolic Suspension	1X50 ML
Azithral 100 MG Syrup	15 ML
Azithral 200 MG Syrup	15 ML
Glycomet GP 3 Fort Tablet	10 Tab
Glycomet GP 3 Fort Tablet	10 Tab
MVI Ampoule	1X10
Meftal Spas 60 ML Syrup	60 ML
Meftal Spas Tablet	1X10
Rosulip 5 Tablet	1X15
R.B Tone Syrup	200 ML
KZ Lotion Lotion	50 ML
Montair LC Kid Syrup	60 ML
Vidaglo M 50/1000 Tablet	1X10
Strepsils Lozenges	12X25
Veet Cream Dry Cream	25
Aptamil Gold 2R Powder	1X24
Vicks Jar 275 Lozenges	32X275
Dettol 60 ML Liquid	6X25
Karvol Plus Capsule	36X18
Zandu Balm 10 GM Balm	20X20
Savlon 50 ML Liquid	12X12
Dexolac 2 Powder	30X400 GM
Aptamil Gold 1R Powder	24 Pcs
Lal Tail 100 ML Oil	60100 ML
Himalaya Baby Powder Powder	72X1
Montair LC Tablet	1X10
Volini Gel 30 GM Gel	1X30
Ciplox Eye/Ear Drop	1X1
Monocef-O 100 Syrup	1X30
Betnovate-N Ointment	1X1
Betnovate-C Ointment	1X1
Allegra M Tablet	1X10
Gabaneuron SR Tablet	1X10
Voveran Emulgel Gel	1X30 GM
Clavam 375 MG Tablet	1X10
Nevelon Tablet	1X21
Zifi Dry Syrup	1X30 ML
Bilafav 20 MG Tablet	1X10
Monocef-O 50 Dry Syrup	1X30 ML
Telmed AM Tablet	1X10
Ciplox-D Eye Drop	5X5
Waxort Ear Drop	10X10
Calpol Ped Drops	1X15 ML
Tryptometer 25 MG Tablet	1X30
CCM Tablet	1X40
Telma 40 Tablet	1X30
Trenaxa MF Tablet	1X6
Geminor-MP2 Tablet	1X15
Johnson Baby Oil	1X1
Dr. Ortho 60 ML Oil	1X1
Cetcip Tablet	10X10
Medisalic Soap	100X1
Ketocip Soap	12X10
Medisalic Ointment	12X20
Bilast FBS-20 Tablet	10X10
Azithral 200 ml Syrup	1x60
Montina L Syrup	1x10
Avomin Tab Tablet	1x10
Mifigest Kit Kit	1
Pan 40 Tablet	1x15
A to Z Syrup	1x200 ml
Bilypsa Tablet	1X10
ZendXA-300 MG Tablet	1x10
ZendXA-600 MG Tablet	1X10
Levera 750 MG Tablet	1X10
Gepride M1 Tablet	1X10
Rifagut 500 MG Tablet	1X10
Istamet XR 100/1000 Tablet	1X10
Amlong MT-50 Tablet	1x15
Nexito Forte Tablet	1x10
Montina L Tablet	1X10
Predmet 4 MG Tablet	1
Carilium Tab	10X1X15
Zerodol P Tab Tab	10x10
Shelcal 500 Syrup	1x15
Nucoxia 90 Tab Tab	1x10
Ultracet NRX Tab	1X15
Taxim-O 200 MG Tab	1x10
Itradila 200 Cap	1x10
Itradila100 Cap	1x10
Alkacitrol 100 ML Syrup	1x100
Montas-L Tab	1x10
Ascoril D Plus Syrup	1x100
PANTOP - D SR CAP 	1 BOX
ROXID 150MG TAB 	1 x 10
COREX DX ( L ) 	100ML
MONTICOPE TAB 	1BOX
MEGAPEN 500MB CAP 	1 B0X
LOMOFEN TAB 	1 B0X
AMLOSAFE AT TAR 	1 B0X
THROMBOPHOB DINT 	1 TUBE
CLAVAM 625 TAB 	1 x 10
MINICYCLIN CAPS 	1BOX
BENADRYL - 150 ML 	1 PH
NIFTAS TAB Tab	1X10
DRUTIN - M TAB Tab	1X10
THYROX 100MG Tab	1X100
THYROX 75MG Tab	1X30
MONTINA L TAB Tab	1x10
QUADRIDERM RF CREAM Cream	1x10
DOXINATE Tab	1x30
CIPLAR LA 20 Tab	1X15
CIPLAR LA 40 Tab	1X15
LIVOGARD TAB.	1x10
LIVOGEN 10ML	VIAL
LIVOGEN 30ML	VIAL
LIVOGEN HEMTONIC 250ML	1x250xMl.
LIVOGEN INJ 1*5AMP	1*5*AMP
LIVOGEN TAB 30*10	1*10*TAB
LIVOGEN Z TAB 30*10	1*10*TAB
LIVOGREEN DROP 60ML	1*60ML
LIVOGREEN SYP 100ML	1*100ML
LIVOGREEN SYP 200ML	1*200ML
LIVOGREEN TAB 10*30	1*30TAB
LIVOHEP SYP	200ML
LIVOHERB BOLUS	1X4
LIVOL 100GM.	PH
LIVOL 1KG	1 KG
LIVOLIFE 500 TAB 10*10	1*10TAB
LIVOLINE-OZ SUS	60ML
LIVOLUK FIBRE POWDER	1x90 GM
LIVOLUK SYRUP	1x100 ML
LIVOLUK SYRUP	1x200 ML
LIVOLUK SYRUP	1x60 ML
LIVOMARC 1 LT	1 LT
LIVOMARC 100 ML	100 ml
LIVOMARC 10ML.	VIAL
LIVOMARC 30ML.	VIAL
LIVOMARC 500 ML	500 ML
LIVOMARC BOLUS	1x4B
LIVOMAT PLUS SYRUP 100ML	100ML[136]
LIVOMAT PLUS SYRUP 200ML	200ML[154]
LIVOMYN DROPS	60ML
LIVOMYN SY.	1X200ML
LIVOMYN SYRUP	100ML
LIVOMYN TAB	1X20
LIVOMYN TAB	1X30T
LIVON 200ML SYP	1*200ML
LIVON 500	1*10
LIVON H.GAIN TONIC	150ML
LIVON MOISTURE MAX	90ML
LIVON PIN STRAIGHT	90ML
LIVON SUPER SHINE	90ML
LIVON VOLUME BOOST	90ML
LIVON-LB	1*10
LIVON-OZ	60ML
LIVOPILL	1X10T
LIVOPLEX CAPSULES	1x10CAPS
LIVOPLEX SYP 200ML	1x200ML
LIVOSPIN SY	200ML
LIVOSPIN TAB	100'S
LIVOTAS 500ML	500ml
LIVOTAS LIQUID 1LIT	1 lit
LIVOTON CAP	1X60 CAP
LIVOVAR 500 TABS	5'S
LIVOVIT 1 LT JAR	1 LT
LIVOVIT 200ML.	PH.
LIVOVIT 450 ML	1 ph
LIVOVIT 5LT.	JAR
LIVOWIN CAP	1X10
LIVRIN A.C. 200 ML.	1 PH.
LIVRIN A.C. 450 ML.	1 PH.
LIVRON 30ML	VIAL
LIVSEE 500 ML	500 ML
LIVSEE LIQ. 100 ML	100 ML
LIVSEE LIQ. 200 ML	200 ML
LIVSEE LIQUID 1000 ML	1000 ML
LIVSHAKTI 1 LITTER	1x1LT
LIVSHAKTI 500ML	1x500ML
LIVSYN ZYME SYP	1 BOT
LIVTAKPLUS SYP	200ML
LIVTONE-Z 1LT	1X1LT
LIVTONE-Z SUS 120ML	1*120ML
LIVZYME FORTE	150 ML
LIVZYME FORTE	500 ML
LIXEN 20GM	1x20GM
LIXEN BOLUS	1x2B
LIXEN IU 4 GM	PH
LIXEN IU BOLUS	1x2B
LIZ 80 TABLET	1x10
LIZ M TABLET	1x6
LIZEMOX -100 D/S	1X30ML
LIZEMOX 600	1X4T
LIZEMOX IV-INJ	1X300ML
LIZOFORC DRY SYP 30ML	1*30ML
LIZOFORCE I.V. 300ML	1x300xMl.
LIZOFORCE-600 TAB 3*4	1x4xTab
LIZOFORCE-600 TAB 4*4	1*4TAB
LIZOKEF	1X10T
LIZOL CITRUS	200ML
LIZOL CITRUS	2LTR
LIZOL CITRUS	500ML
LIZOL CITRUS	975ML
LIZOL CITRUS 30% EXTRA	550ML
LIZOL CITRUS+COLIN	2LTR
LIZOL CITRUS+H.ORNG.	975ML
LIZOL CITRUS+HARP.	2LTR
LIZOL DFC PINE	200ML
LIZOL DFC PINE	2LTR
LIZOL DFC PINE	500ML
LIZOL DFC PINE+HARPIC ORANGE	975 ML
LIZOL DFC PINE+SOAP	500ML
LIZOL DFC PINE+SOAP	975ML
LIZOL FLORAL	200ML
LIZOL FLORAL	2LTR
LIZOL FLORAL	500ML
LIZOL FLORAL	975ML
LIZOL FLORAL +HARPIC	2LTR.
LIZOL FLORAL +HARPIC	975ML
LIZOL FLORAL+33%	550ML
LIZOL FLORAL+COLIN	2LTR.
LIZOL FLORAL+SOAP	500ML
LIZOL FLORAL+SOAP	975ML
LIZOL JAISMINE 30% EXTRA	500ML
LIZOL JASMINE	200ML
LIZOL JASMINE	2LTR
LIZOL JASMINE	500ML
LIZOL JASMINE	975ML
LIZOL JASMINE + HARPIC	975ML
LIZOL JASMINE + HARPIC	975ML
LIZOL LEVENDER	200ML
LIZOL LEVENDER	2LTR
LIZOL LEVENDER	500ML
LIZOL LEVENDER	975ML
LIZOL LEVENDER + 30%	500ML
LIZOL LEVENDER + CP.	2LTR
LIZOL LEVENDER + HARPIC	975ML
LIZOL POWER	500ML
LIZOL SANDAL	2 L
LIZOL SANDAL 30% FREE	500 ML
LIZOLID-600MG TAB	1X4
LIZOMAC	1X4S
LIZOMAC DS D/SYP.	1X30ML.
LIZOMAC IV	1X300ML
LIZOMAC-CX	1X10 TAB.
LIZOMED 300 MG TABS	1*10
LIZOMED 600MG	1X10
LIZOMED DRY SYP	1X30ML
LIZOMED-600 IV	300ML
LIZOMED-C TAB	1*10
LIZOMED-XL DRY SYP	60ML
LIZOSPEY-100 SYP	30ML
LIZOSPEY-400 TAB	1*10
LIZOSPEY-600TAB	1*10
LIZTA DRY SYP	30ML
LIZTA-600 TABS	1*10
LM-510	1X10T
LM-510	1X10T
LMF TAB	1X10
LNZ 600	1X4T
LNZ IV 600	1X300ML
LNZD-600 TAB	1*10
LO- REX 100ML SYU	100ML
LOACHE AMP	3ML
LOBAK TAB	10'S
LOBATE GM NEO CREAME	1*15*GM
LOBATE S OINT 30GM	1*30*GM
LOBATE SKIN CR 30GM	1*30*GM
LOBAZAM 10TAB 15*10	1*10TAB
LOBAZAM 5 TAB 15*10	1*10TAB
LOBAZAM MD 10 TAB 5*10	1*10TAB
LOBAZAM MD 5 TAB 5*10	5*10TAB
LOBET 100MG TAB	20 TAB
LOBET INJ (20MG/4ML)	2 PCS
LOC BOLUS	10X4'S
LOC INJ.30ML	1X30ML
LOC TEARS E/D	1*10ML
LOCID 20MG	1X10
LOCID 40MG	1X10
LOCID D	1X10
LOCID DSR	1X10
LOCKMYCIN 500MG	1 VIA
LOCULA 10%	1 PH.
LOCULA 20%	1 PH.
LOCULA 30%	1 PH.
LODIRIC SR 250 10*10	1x10xTab
LODIRIC TAB 10*10	1x10xTab
LODOZ TAB 2.5MG 3*10	1x10xTab
LODOZ TAB 5MG 3*10	1x10xTab
LOETTE TAB 10*21	1x21xTab
LOFAC BOLUS	1X4
LOFAC MP	30 ML
LOFAC-M BOLUS	1X4
LOGAN -SYRUP	60ML
LOGIDRUF LOTION	1*100ML
LOGIDRUF-S	100ML
LOGIHAIR	15'S
LOHASAAV 450ML	450ML[112]
LOLIP-A TAB	1x10
LOLOCONTIN M-100 TAB 10*10	1*10TAB
LOLOCONTIN M-12.5 TAB 10*10	1*10TAB
LOLOCONTIN M-25 TAB 10*10	1*10TAB
LOLOCONTIN M-50 TAB 10*10	1*10TAB
LOMAC 10MG CAPS	10'S
LOMAC 20MG CAPS	10'S
LOMADOL INJ 2ML	2ML
LOMATICH DS 200 GR	200 GR
LOMELA CREAM	1x15xGm.
LOMELA-18GM ONIT	1*18GM
LOMITACH-DS-100 GR	100 GR
LOMITAS TAB 10*4	1x4xTab
LOMOFEN +	1*20
LOMORIN-NX 40MG/0.4ML	1 VIL
LOMORIN-NX 60MG/0.6ML	1 VIL
LONA SALT 200GM	1*200*GM
LONACEN TAB 0.50MG 1*10	1*10*TAB
LONAZEP 0.25 TAB 20*10	1*10TAB
LONAZEP 0.5 TAB 20*10	1*10TAB
LONAZEP 1.0 TAB 10*10	1*10TAB
LONAZEP 2 TAB 10*10	1*10TAB
LONAZEP MD 0.25 TAB 10*10	1*10TAB
LONAZEP MD 0.5 TAB 10*10	1*10TAB
LONAZEP MD 1.0 TAB 10*10	1*10TAB
LONAZEP MD 2.0 TAB 10*10	1*10TAB
LONEX DT 1*10	1*10
LONGA COUGH SYP	1X100 ML
LONGAC CAP.6'S	1X6
LONGIFEN A SYP	200ML
LONGIFENE	1X10
LONGIFENE	200ML
LONGIFENE SYP	200ML
LONGIFENE SYP 200ML	1*200ML
LONGIFENE TAB10*10	1*10TAB
LONGIFENE-DS SYP	1*200ML
LONGIFENE-DS TAB 10*10	1*10TAB
LOOBID SYP	1x30xMl.
LOOBID TAB 10*10	1*10*TAB
LOOZ SYP 150ML	1x150xMl.
LOOZ SYP 300ML	1x300xMl.
LOOZ SYP 450ML	1x450xMl.
LOOZWELL SYP 100ML	1*100ML
LOPAMIDE TAB	1X10
LOPANG-PLUS TAB	1*10
LOPARIN 40MG 0.4ML INJ	1x1xVl.
LOPARIN 60MG 0.6ML INJ	1x1xVl.
LOPENTA-40 TAB	1*10
LOPENTA-D TAB.	1*10
LOPEZ-3 TAB 10*10	1*10TAB
LOPID 300MG	1*10
LOPIMUNE TAB	1X60
LOPIPEN 2 CAPS	1X10
LOPIPEN TABS	1X10
LOPONET 300MG TAB	1X10
LOPRA.SYU	1.PH
LOPRES 0.5% EYE DROP	1X 5 ML
LOPRESSOR XL TAB 50MG 10*10	1*10*TAB
LOPRIN-75	1X10
LOPRIN-DS	1X10
LOPSAN-P TAB	1X10
LORAHIST TAB	1X10
LORAM-2.5MG TAB	1X10
LORAM-5MG TAB	1X10
LORAM-H-2.5MG TAB	1X10
LORAM-H-5MG TAB	1X10
LORD THERMOMETER	1 PC.
LORETA-P 8	1X10T
LOREXANE 100GM	TUBE
LOREXANE 30GM	TUBE
LOREXANE SPRAY 50 ML	50 ML
LORFAST AM SYP	1x60xMl.
LORFAST AM TAB 10*10	1*10*TAB
LORFAST MELTAB TAB 30*10	1x10xTab
LORFAST MT TAB 10*10	1*10*TAB
LORFEN INJ. 100ML	1X100ML
LORFEN INJ.30ML	1X30ML
LORFIT 4	1*10
LORFIT 8 (10*10)	1*10
LORFIT INJ	1*1
LORFIT P 10*10	1*10
LORFLEX 4	1X10T
LORFLEX 8	1X10T
LORFLEX PLUS 4	1X10T
LORFLEX PLUS 8	1X10T
LORIDIN AM SYRUP 60ML	60ML
LORIDIN AM TAB 10'S	1X10
LORIDIN RAPI TAB 10'T	
LORIDIN-D 10'T	
LORIN SYP 30ML	30ML
LORIN TAB 10MG	1*10
LORISOL INJ 1GM	1x1xVl.
LORISOL INJ 250MG	1x1xVl.
LORISOL INJ 500MG	1x1xVl.
LORISOL S 375MG	1*1*VIAL
LORISOL S INJ 1.5GM	1*1*VIAL
LORISOL TZ INJ 1.125	1*1*VIAL
LORISOL TZ INJ 281.25MG	1x1xVl.
LORMOL T 8	1X10
LORMOL T4	1X10
LORMOL TAB	1X10
LORNA P TAB 10*10	1*10*TAB
LORNA P TAB 10*10	1*10*TAB
LORNA SR 16MG TAB 10*10	1*10*TAB
LORNA SR 16MG TAB 10*10	1*10*TAB
LORNA TAB 4MG 10*10	1x10xTab
LORNA TAB 8MG 10*10	1x10xTab
LORNA TAB 8MG 10*10	1x10xTab
LORNASAFE PLUS TAB 3*10	1*10TAB
LORNICALM PLUS 4	1X10T
LORNICALM PLUS 8	1X10T
LORNICAM 4MG	1X10T
LORNICAM 8MG TAB	1X10T
LORNIFLEX 4MG	1X10T
LORNIFLEX 8MG	1X10T
LORNIFLEX INJ 8MG	1xV
LORNIFLEX PLUS 4	1X10T
LORNIFLEX PLUS 8 TAB	1X10T
LORNIT	1X10T
LORNIT 500MG TAB	1X10
LORNIT IV	1X10ML
LORNIT SY	1X60ML
LORNOXI 8 MG.TAB.	1X10
LORNOXI INJ 8MG	1X1INJ
LORNOXI T 4	1X10
LORNOXI T TAB	1X10
LORNOXI-4 MG.TAB.	H
LORNOXI-P	1X10
LORPIK 1 TAB 20*10	
LORPIK 2 TAB 20*10	
LORQRS-P	1X10T
LORSUMO 4MG	1X10T
LORSUMO 8MG	1X10T
LORSUMO 8MG INJ	1X2ML
LORSUMO FORTE	1X10T
LORSUMO MR 4MG	1X10T
LORSUMO MR 8MG	1X10T
LORSUMO PLUS	1X10T
LORSUMO SR	1X10T
LORTRIO	1X10T
LORVAS	1X10T
LORVAS SR TAB	1X10
LOSACAR A TAB 10*10	1*10*TAB
LOSACAR H TAB 12*10	1x10xTab
LOSACAR WP TAB 25MG 1*30	1*30*TAB
LOSACAR WP TAB 50MG 1*30	1*30*TAB
LOSAKIND-25 TAB 6*10	1x10xTab
LOSAKIND-50 TAB 6*10	1x10xTab
LOSAKIND-H TAB 12*10	1x10xTab
LOSANORM H TAB 25MG 10*10	1x10xTab
LOSANORM H TAB 50MG 10*10	1x10xTab
LOSANORM TAB 25MG 10*10	1x10xTab
LOSANORM TAB 50MG 10*10	1x10xTab
LOSAR A.TAB	1X10
LOSAR BETA	1X10
LOSAR H TAB.	1X10
LOSAR-25MG TAB	1X10
LOSAR-50 30TAB	1X30TAB
LOSAR-50MG TAB	1X10
LOSAR-H 30TAB	1X30
LOSARTAS-25 TAB 10*10	1*10TAB
LOSARTAS-50 TAB 10*10	1*10TAB
LOSARTAS-50 TAB 10*15	1*15TAB
LOSARTAS-HT TAB 10*10	1x10xTab
LOSARTAS-HT TAB 10*15	1*15TAB
LOSIUM H TAB	1x30xTab
LOSIUM TAB 25MG	1x30xTab
LOSIUM TAB 50MG	1x30xTab
LOSTAT-25	1x10
LOSTAT-50	1x10
LOSTAT-H TAB	1x10
LOT H TAB 50MG 10*10	1*10*TAB
LOT TAB 25MG 10*10	1*10*TAB
LOT TAB 50MG 10*10	1*10*TAB
LOT. POVODIN IODIN (500) ML	1 BOT
LOTECHEK DROP	5ML
LOTECHEK LS	5ML
LOTEGATE EYE DROP	1*5ML
LOTEL E/D	1*5ML
LOTEL E/OINT	
LOTEL LS E/D	1*5ML
LOTENSYL 10 TAB 10*10	1*10TAB
LOTENSYL AT TAB 5*10	1*10TAB
LOTEPRED DROP	1*5ML
LOTEPRED-LS DROP	1*5ML
LOTETOB E/D	1*5ML
LOTOR 500MG	1X10T
LOTOR 750MG TAB	1x5 TAB
LOTOR TAB 500MG	1x5TABLET
LOUCOLD DROPS	1*15ML
LOVAX 150	1X10T
LOVAX 300	1X10T
LOVAX 600	1X10T
LOVAX OD 300MG	1X10T
LOVAX OD 600MG	1X10T
LOVELONG SPARY	1*1
LOW-200 DT TAB.1'S	1X1
LOW-400 TAB.1'S/SAT	1'S
LOW-DT	1X1
LOWCAP 0.4ML	0 ML
LOWCAP 0.6ML	0 ML
LOWDEX E/D	1*5ML
LOWER EZ TAB	1x10
LOWER TG TAB	1x10
LOWER-A 10 TAB	1x10
LOWMAN'S BONE HOLDING CLAMP 5"	1 PCS
LOX 10% SPRAY 50 ML	1 50M
LOX 2%	1 VAL
LOXABOL 10 TAB.	1X10
LOXAMOX CAP	1*10
LOXOF AZ TAB 250MG 10*10	1*10*TAB
LOXOF AZ TAB 500MG 10*5	1*5*TAB
LOXOF I.V	1x100xMl.
LOXOF OZ TAB 4*10	1x10xTab
LOXOF TAB 250 MG 10*5	1x5xTab
LOXOF TAB 500MG 10*10	1*10*TAB
LOXOF TAB 500MG 10*5	1x5xTab
LOXOF TAB 750MG 10*5	1x5xTab
LOXOMAC	1X10S
LOXOR P8 TABLETS	10'S
LOXY 100 ML	100 ML
LOXY 250 1*10	1*10
LOXY 30 ML	30 ML
LOXY 500 1*10	1*10
LOXY INJ 50 ML	50 ML
LOXY T 1*10	1*10
LOXY TABS 500 MG	1X4
LOZ.25 TAB.	1x10
LOZEE OINT	1x15xGm.
LOZEE-M OINT	1x15xGm.
LOZICID SUSP	200 ML
LOZIRAB DSR	10'S
LOZIRAB TAB	10'S
LOZISOFT CREAM	1*50GM
LOZISOFT LOTION	1*100ML
LOZISOFT SOAP	75GM
LOZIVATE CREAM	30GM
LOZIVATE F CREAM	10GM
LOZIVATE MF 30GM	1*30GM
LOZIVET S OINT	1*30GM
LPC TAB	1X10
LRN - P TABLET	1X10
LRZIN FORT SACHET 10*15GM	1x15xGm.
LRZIN SACHET 10*10GM	1x10xGm.
LRZIN-BETA SACHET 10*9GM	1*9GM
LTT TENT **	1x10
LTZ-5 TAB	1*10
LUBICON 100MG	1X10
LUBICON 200 CAP	1X10
LUBIMOX DS	1*10ML
LUBIMOX EYE DROPS	10ML
LUBISTAR CMC DROP	1x10xMl.
LUBISTAR CMC-FORT DROPS 10ML	1*10ML
LUBISTAR EYE DROP	1x10xMl.
LUBOWEL-24TAB 5*10	1*10TAB
LUBOWEL-8 TAB 5*10	1*10TAB
LUBREX EYE DROPS	1X5 ML
LUBREX- DS EYE DROPS	1X10 ML
LUBRIGESIC A TAB	1x10
LUBRIGESIC PLUS TAB	1x10
LUBRIJOINT OD TAB 1*30	1*30*TAB
LUBRIJOINT PLUS TAB 1*30	1*30*TAB
LUBRIJOINT TAB 750MG 1*30	1*30*TAB
LUCIARA CREAM	1X50GM
LUCIDERM LOTION	
LUCIPRO-500MG	1X10
LUCIPRO.T.TAB	1X10.
LUCIPRPO-250	1.X10
LUCOF SY.100ML	1X100ML
LUCOLD SYP.	1*60ML
LUCOMYN SYP	250ML
LUCOPLAST 1" **	1PIS.
LUCOPLAST 1/2"**	1 PH.
LUCOPLAST 2"	1
LUCOPLAST 5INCH	1PIS
LUCORIL SY	1X100ML
LUCYNTA 100MG TAB.	1X10 TAB.
LUCYNTA 50 MG	1X10TAB.
LUCYNTA 75 MG TAB.	1X10 TAB.
LUFI TAB 500MG 10*5	1x5xTab
LUFIXCIN 100	1X10T
LUFIXCIN 200	1X10T
LUKOL TAB	1x60xTab
LUKOPLAST 1.25CMX1M	1 PCS
LUKOPLAST 7.5CM	1 PH
LUKOSTATE CAP	1X45
LUKOTAS LC TAB 10*10	1*10TAB
LUKOTAS-3D TAB 10*10	1*10TAB
LUKOTAS-FX TAB 10*10	1*10TAB
LUKOTAS-LC KID TAB 10*10	1*10TAB
LUKURE TAB 10X30	1x30xTab
LUKURE-V TAB 1*10	1*10TAB
LULISPEY CREAM	10GM
LULIWIN CREAM	20GM
LUMACIP CREAM	1TUB
LUMAGLO CREAM	1X20GM
LUMBO PORE M	1 PCS
LUMBO SUPPORT UNI	1 PCS
LUMENAC	1X10C
LUMERAX SUSP	1*60*ML
LUMERAX SYP 30ML	1*30*ML
LUMERAX TAB 20MG	1*6*TAB
LUMERAX TAB 40MG	1*6*TAB
LUMERAX TAB 80MG	1x6xTab
LUMETHER 40 DT 20*6	1*6
LUMETHER DT 10*6	1*8
LUMIGAN 0.03%	3ML
LUMIGAN SOL	3ML
LUMITHER FORTE TAB	1x6
LUMITHER KID DRY SYP	1x30ML
LUMITHER KID SYP	1X15ml
LUMITHER TAB	1x8
LUNGFYL TAB 1*10	1*10
LUP-INH	1X10T
LUPACTIN TAB	1X10
LUPAMIK.100MGVIAL	1VIL
LUPAMIK.250MGVIAL	1VIAL
LUPAMIK.500VIAL	1VIAL
LUPENOX 40MG	1X1
LUPENOX 60MG	1X1
LUPI -HMG 150 IU	1X1
LUPI D3	1X15T
LUPI D3 SACHET	1X1GM
LUPI FSH 150IU	1XAMP
LUPI FSH 75IU	1XAMP
LUPI HCG 10000IU	1XAMP
LUPI HCG 2000IU	1XAMP
LUPI HCG 5000IU	1XAMP
LUPI HMG 75IU	1XAMP
LUPIBAX-SG CAP	1X10
LUPIBEND 400MG TAB	1x1
LUPIBEND.SYU	1PH
LUPIBEND.TAB	1X1
LUPIBLISS	1X10 TAB.
LUPIBOSE 125	1X10T
LUPIBOSE 62.5	1X10T
LUPICAL 500 TAB	1.X15
LUPICAL-B12 SY.	1X200ML
LUPICEF DRY SY	1X30 ML
LUPICEF-DS 30ML.	1X30ML
LUPICET FORTE TAB	1X10
LUPICET TAB	1x10
LUPICET-L TAB	20X10
LUPICLOR 12.5	1X10T
LUPICLOR 6.25	1X10T
LUPICOF SYU	100ML
LUPICOLD TABLET	1X10
LUPICOLD PLUS SYRUP	60ML
LUPIDERM	1X10GM
LUPIDERM G.M.	1
LUPIDERM GM	10GM
LUPIDERM GM PLUS	1X10GMS
LUPIDERM-G	1X10GM
LUPIDERM-M	1X10GM
LUPIDERM-MZ	1X10GM
LUPIDERM-S	10GM
LUPIDERM-SA	1X10GM
LUPIDEXA. .5 TAB	
LUPIDIN SOLU	1PH
LUPIDIN.POWDER	1PH
LUPIDIP 10 MG	1X10T
LUPIDIP 2.5 MG	1X10T
LUPIDIP 5 MG	1X10T
LUPIDIP-A	1X10T
LUPIDOM SUSP 30ML	1
LUPIDOM TAB	1X10
LUPIFIT CAP.	1X10 CAP.
LUPIFIT SYP.	1X110 ML
LUPIFLAM-M.TAB	
LUPIFLEX 4	1X10T
LUPIFLEX 8	1X10T
LUPIFLO 15	1XV
LUPIFLO 7.5	1XV
LUPIFOLIN	1X10T
LUPIFOLIN PLUS	1X10T
LUPIGEST 100 AMP	1X2ML
LUPIGEST 200 AMP	1X4ML
LUPIGEST-100	1X10T
LUPIGEST-200	1X10T
LUPIGEST-300	1X10C
LUPIGEST-400	1X10C
LUPIGRA 100MG TAB	1X5
LUPIGYL IV	100ML
LUPIHALER	1X1
LUPIHIST 100ML SYU	1PH
LUPIHIST 60ML SYU	1PH
LUPIHIST FORTE SY.	1X100ML.
LUPIKRILL	1X10C
LUPILA 10	1X10T
LUPILA 5	1X10T
LUPILIV SYU 100ML	1PH
LUPILIV.200ML.SYU	1PH
LUPILLIN 500MG	1X10
LUPIMEB TAB	1X6
LUPIMOX 250 CAP	1X15
LUPIMOX 500 CAP	1X20
LUPIN CHYAWANPRAS	1X500GM
LUPIN CHYAWANPRASH	1kg
LUPIN-O.R.S.5.76	1PH
LUPINEM 500MG	1XV
LUPINES PALM	1XSET
LUPIN'S "WELLNESS NONI"	450ML
LUPIN'S ORS[LEMON]	1X28.5
LUPIPARA-500 TAB	1.X10
LUPIRTIN	1X10C
LUPIRTIN SR	1X10 TAB.
LUPIRTIN-P	1X10T
LUPISERA-D TAB	1x10
LUPISERA-N TAB	1x10
LUPISPAS* PLUS TAB	1x10
LUPISPAS.30ML.VIL	1VIL.
LUPISPAS.DROP	1PH
LUPISULID-P TAB	1x10TAB
LUPISULIDE -P SUSP	1
LUPISULIDE-D.CAP	1X10
LUPISULIDE.MD.TAB	1X10
LUPISULIN INJ-PEN	1XV
LUPISULIN M 30	1XV
LUPISULIN M 50	1XV
LUPISULIN N 40 IU/ML	1XV
LUPISULIN R	1XV
LUPISULIN-M 30/70 CATRIDG	1XV
LUPISULIN-M 50/50 CATRIDG	1XV
LUPISULIN-N CATRIDGE	1XV
LUPISULIN-R CATRIDGE	1XV
LUPISULUD TAB	1x10
LUPITAX-S 1.5GM	1VIL
LUPITROS 3ML	1X3ML
LUPITUM 1GM INJ	1XV
LUPITUM 500MG INJ	1XV
LUPITUSS	1X100ML
LUPITUSS	1X60ML
LUPIVITAL.CAP	1X10
LUPIZOLE CAP	1X10
LUPIZOX.TAB	1X10
LUPIZYME CAP (1*10)	1*10
LUPIZYME DROP15ML	1DP
LUPIZYME PLUS SYP.	1X200ML.
LUPIZYME SYP.	200 ML
LUPIZYME SYU/MANGO	1PH
LUPIZYME-STRAWBERRY	200ml
LUPIZYME.100ML.SYU	1PH
LUPOXA	1X10 TAB.
LUPREX KID TAB	1X10
LUPREX 150MG	1X10
LUPREX.SYU 30ML	1PH
LUPRIDE DEPOT 3.75MG INJ	1*1VAIL
LUPRIDE-4 INJ 4ML	1*4ML
LUPRODEX 3.75MG INJ	1*1VAIL
LUPROLIDE	1XV
LUTALYSE 10ML.	VIAL
LUTALYSE INJ 5ML	vail
LUTIDERM CREAM	10 GM
LUTROZOLE	1X5T
LUZEN-UP 100ML	1PHI
LUZEN-UP SY	1PHI
LV FLOX E/D	1*5ML
LV FLOX FORTE DROP	1*5ML
LYCAL 200ML SYP	1*200ML
LYCAL D TAB	1x10
LYCAZID M TAB 10*10	1x10xTab
LYCAZID TAB 10*10	1x10xTab
LYCIMAX 30GM	1X1TUBE
LYCO-Q 100 CAP 1*10	1x10xCap
LYCO-Q TAB 1*10	1x10xTab
LYCOBA CAP	1*10
LYCOBA SYRUP	200ML
LYCOBEN S/G CAP	1*10
LYCOBERG SYP	200ML
LYCOBETA CAP	1X10
LYCOBETA SYP	100ML
LYCOCAN CAP	1X10
LYCODOX SYP 200ML	1X200ML
LYCODOX TAB.6'S/MARC	1X6
LYCOFOL	1X10C
LYCOFOL PLUS SYP.	1X200ML
LYCOFORCE CAP	1*10
LYCOFORCE SUSP	200ML
LYCOLIFE 60 ML SYP	60ml
LYCOLIFE CAP 1*10	1*10
LYCOPLAN 400MG	1 VIL
LYCOPOM VEGCAP	1*10
LYCOPROST-SP CAP 3*10	1x10xCap
LYCORED CAP 10*10	1x10xTab
LYCORED SYP	1x200xMl.
LYCORTIN-S 100 INJ.	1X1V
LYCOSTAR CAP 4*10	1x10xTab
LYCOTURE+	200ML
LYCOVIN SUS	200ML
LYCOWEN GOLD CAP	1*10
LYCOWEN SYP	200ML
LYCOXIN	10'S
LYCOZIA SG CAP	3'S
LYCYP SYRUP	200ML
LYKAV CAP	1X10
LYMAZE-M3 BBOLUS	1X4'S
LYMED D TAB	1x10
LYMED FORTE TAB	1*10
LYNAS	1*10
LYNET CAP	1X10
LYNET SYP	1X200ML
LYNIX RUB 10GM	1*10GM
LYNORAL 0.01 MG TAB	1x10
LYNORAL 0.01MG TAB 50*10	1x10xTab
LYNORAL 0.05 MG TAB	1x10
LYNORAL 0.05MG TAB 50*10	1x10xTab
LYNX	1 AMP
LYNX CAP 250MG 5*10	1*10*CAP
LYNX CAP 500MG 5*10	1*10*CAP
LYNX INJ 1ML 50*1VIAL	1*1*ML
LYNX INJ 2ML 50*1VIAL	1*2*ML
LYNX SYP 60ML	1*60*ML
LYOM INJ 40MG	1 VIL
LYPAN INJ 40MG	1 VIL
LYPEX -SB 1.5 GM	1 VIL
LYPEX-SB 1GM INJ	1 VIL
LYPHOZYME SYRUP	1x200ml.
LYPITAZ INJ 2.25GM	1 VIL
LYPITAZ INJ 4.5GM	1 VIL
LYPROVIT SYRUP 200ML	200ML
LYRAB I.V. INJ 20MG	1 VIL
LYRAMYCIN-80MG.INJ	2ML
LYRED PLUS TAB	1x10
LYRED PLUS TAB	1x10
LYRED SYU	200ml
LYRIN-B SYP	100ML
LYROX 30ML SYP	1*30ML
LYSATONE F CAP.	1x10
LYSATONE SYP	1x300 ML
LYSER 20 MG. TAB	1x10
LYSER D GEL	1X6
LYSER D TAB.	1*15
LYSER FORTE TAB.	1x10
LYSER TAB.	1x10
LYSER-D AQ INJ	1ML
LYSER-D NANOTECH GEL	30GM
LYSER-D SPRAY	55GM
LYSER-DP TAB.	1X10
LYSETIK 15ML	PH
LYSETIK 50ML	PH
LYSICAL 500 TAB.	1x10
LYSICAL SYP.	1 PH.
LYSICEPT 100ML	1*100ML
LYSICON-V SYP	1*200ML
LYSO SPAS TAB 10*10	1*10*TAB
LYSOFLAM AQ INJ 50*1ML	1*1*ML
LYSOFLAM MR TAB 10*10	1*10*TAB
LYSOFLAM TAB 10*10	1x10xTab
LYSOL	450 ML
LYSOL 400ML.	400 ML.
LYSOL TRAY 8 X 3	1 PCS
LYSONE 100ML	100ML
LYSONE 200ML SYP	1x200ML
LYSOVIT 100ML	1*100ML
LYSOVIT 200ML	1*200ML
LYSUNATE INJ 60 MG	1 VIL
LYTIX-10 TABS	1*10
LYTIX-15 DP TABS	1*10
LYTIX-2.5 TABS	1*10
LYTIX-20 TABS	1*10
LYTIX-5 TABS	1*10
LYTIX-D TABS	1*10
LYTIX-DGEL	30GM
LYTIX-RXTABS	1*10
LYTIX-SUPER TAB	1*10
LYTO CAP.	1X10
LZO-30 CAP.	1x10
M CEFT 1500 MG	1500 MG
M CIN	1X5T
M CIN-IV	1X100ML
M COLD SYP	1x60ML
M KAST 10MG	1X10
M&M LIQUID	1 LTR
M&M LIQUID	5 LTR
M-CEFT 2500 MG	2500 MG
M-FIT BOLUS	1X4X5'S
M-HIST 16 TABS	1*10
M-HIST 8 TABS	1*10
M-KAST 4MG	1X10
M-KAST 5MG	1X10
M-LORAX 25GM	TUBE
M-LORAX 25GM	TUBE
M-NOR O SYP	1X60ML
M-NOR SYP	1X60ML
M-TRIN 25MG	1X10
M-ZIDE-500 TAB.	1X10
M-ZIDE-750MG.TAB.10'S	1X10
M. NAT.GARD FIK	625ML
M.A.I.K.	150ML
M.A.I.K.+(C.P)	225ML
M.A.I.K.+(C.P)	425ML
M.AIK (CP)	625 ML
M.AIK GOLD TARGET	225ML
M.AIK GOLD TARGET	320ML
M.AIK GOLD TARGET	425ML
M.AIK GOLD TARGET	625ML
M.ALKALINE GRANULES 200GM	200GM[114]
M.ANTACID SYRUP 200ML	200ML[90]
M.B FORTE -OD	1x10
M.B.FORTE TAB	1X10TAB
M.BOOSTER COIL	10'S
M.C. PAINT 20 ML	1 NO
M.C.I 100MG VIAL	1VIAL
M.C.I 500 MG VAIL	1VAIL
M.C.I.250MG VAIL	1VAIL
M.C.PAINT (CRISTAL)	5 GM
M.FIK NG 100 RS OFF	225 ML
M.FIK NG.CP	225 ML
M.FIK NG.CP	425 ML
M.FIK.NG(CP)	625 ML
M.GREEN COIL	10'S
M.M.S CREAM 10GM	1TUBE
M.M.S CREAM 30 GM	1X30 GM
M.MAX COIL	10'S
M.MAX COIL 8HR+4FREE	10 S
M.MAX POWER 40%	12HRS
M.NAT.GARD FIK Rs.10/-OFF	225ML
M.NAT.GARD FIK Rs.20/-OFF	425ML
M.NAT.RIFFILE+BATTERY	45NGT
M.NG COIL	LOW SMOK
M.PG 45NGT+BATTERY	45NGT
M.PG COMBI PACK	45 NIGHT
M.PG GREEN+4FREE	10'S+4'S
M.PG REFFIL+HARPIC 500	2*45 NIGHT
M.PG.BOOSTER COIL+4 FREE	10'S
M.PG.JAMBO+4COIL FREE	12HR
M.POWER CREAM 5 GM	1 TUBE
M.RED COIL	10'S
M.RED COIL(CP)	10+4
M.RED LIGHT	45NGT
M.RED LIGHT NG Rs.8/-OFF	45NGT
M.REFFIL NG	45NIGHT
M.RIFFILE	60NGT
M.RIFFILE P.G	45NGT
M.RIFFILE+BATTERY	60NGT
M.T.BOOST	1*4
M.V SET (110ML)	1 PCS
M.V SET(150ML)	1 PCS
M.V.A-ASPIRATOR	1 PCS
M.V.I AMP 1*10AMP	1x10xAmp
M.V.SET	1 PCS
M/S ACEMOVE 150MG	1XV
M2 TONE	1X30T
M2 TONE SY.	1X200ML
M2 TONE SY.	1X450ML
MAATRI SY	1PHI
MACALVIT SYP	1x200xMl.
MACALVIT TAB 15*15	1*15*TAB
MACBERY	1X100ML
MACBERY COLD	1X10S
MACBERY P	1X60ML
MACBERY XT	1X100ML
MACBUTIN	1X6C
MACCROAZI 250 MG TABLET	1X6
MACCROAZI 500 MG TABLE	1X6
MACFAST 125 SYP.	1X60 ML
MACFAST 250 SYP.	1X60 ML
MACFAST 500 TAB.	1X10 TAB.
MACFAST 650	1X10T
MACFLOX TAB.	1X10 TAB.
MACFOLATE	1X10TAB
MACFOLATE CAP. OLV	1X10 TAB.
MACFOLATE PLUS	1X10C
MACFREE TAB.	1X10 TAB.
MACGEST 100	1X10T
MACGEST 100 INJ	1X2ML
MACGEST 200	1X10T
MACGEST 200 INJ	1X2ML
MACGILL'S FORCEPS	1 PCS
MACHALER	1XDEVICE
MACIRON-XT TAB	1*10
MACMASK	1XDEVICE
MACMIKA 500	1XV
MACORATE 200 TAB 5*10	1*10TAB
MACORATE 400 TAB 5*10	1*10TAB
MACORATE CR 200 TAB 5*10	1*10TAB
MACORATE CR 300 TAB 10*10	1*10TAB
MACORATE CR 300 TAB 5*10	1*10TAB
MACORATE-CR 400 TAB 5*10	1*10TAB
MACORATE-CR 500 TAB 5*10	1*10TAB
MACORATE-CR 600 TAB 5*10	1*10TAB
MACOX PLUS	1X6
MACOX PLUS 600MG	1X6T
MACOX PLUS KID	1X10T
MACOX PLUS-150	1X6T
MACOX ZH	1X6
MACOX ZH KID	1X10
MACOX ZH-150	1X6
MACPARIN 40	1XA
MACPARIN 60	1X60MG
MACPHYLLINE	1X10S
MACPHYLLINE SYP	1X100ML
MACPOD -O 100DT	1X10TAB.
MACPOD 100 D/SY	1X30ML
MACPOD 100DT	1X10T
MACPOD 200	1X10S
MACPOD 50 D/SY	1X30ML
MACPOD 50 DT	1X10T
MACPOD AZ	1X10T
MACPOD CV 100 DT	1X6T
MACPOD CV 200	1X6T
MACPOD CV 50 DT	1X6T
MACPOD CV 50 SYP.	1X30ML
MACPOD DROP	1X10ML
MACPOD-O	1X10S
MACPRED 16	1X10T
MACPRED 4	1X10S
MACPRED 8	1X10S
MACPRIL 1.25	1X10S
MACPRIL 2.5	1X10S
MACPRIL 5	1X10S
MACPRIL H 2.5	1X10T
MACPRIL H 5	1X10T
MACPROT	1X200GM
MACPROX	1X10T
MACRABARIN FORTE TAB	1*10
MACRABERIN M	1X10
MACRABERIN FORTE INJ	1x2ML
MACRABERIN FORTE INJ	2ML
MACRABERIN P CAP	1X10
MACRABERIN-FORTE	1X10T
MACRABERIN-P (HARDGEL)	1X10T
MACRALFATE O SYRUP	200ML
MACROAZI 500 MG TAB	1X3
MACROGOL	
MACROMYCIN	1X10 TAB.
MACROTOR 500	1X3T
MACROZIDE 1000 MG	1X6
MACROZIDE 1200 MG	1X6T
MACROZIDE 1500 MG	1X10
MACROZIDE 500MG	1X6
MACROZIDE 750 MG	1X10
MACSART 20	1X10T
MACSART 40	1X10T
MACSART 80	1X10TAB
MACSART AM	1X10S
MACSART BETA 25	1X10 TAB.
MACSART BETA 50	1X10 TAB.
MACSART CH 40	1X10 TAB.
MACSART H	1X10T
MACSORALEN TAB	1*10
MACSPACER	1XDEVICE
MACSPACER KIT	1XDEVICE
MACTOR 10	1X10T
MACTOR 20	1X10T
MACTOR 40	1X10T
MACTOR ASP 75	1X10S
MACTOR EZ	1X10T
MACTOR F	1X10S
MACUCHEK CAP	1*10
MACUCHEK FORTE	1'10
MACUGOLD TAB	1*10
MACVESTIN	1X10T
MACZEAL	1X10T
MACZONE 1GM	1XV
MACZONE 250	1XVIAL
MACZONE 500	1XV
MACZONE PLUS 1.5GM	1XV
MACZONE PLUS 375	1XV
MACZONE PLUS 750	1XV
MACZONE XP 1GM	1XV
MACZONE XP 250	1XV
MACZONE XP 500	1X1VIAL
MACZORB	1X10T
MACZORB FORTE	1X10T
MACZORB PLUS	1X10T
MADHU 50GM	1*50GM
MADHU MEHARI CAPSULE 10CP	10CAP[145]
MADHUBANI 150GM	1PH
MAFIX 100DT TAB	1x10
MAFIX 200DT TAB	1x10
MAFIX 50DT TAB	1x10
MAFIX DRY SYP	1x30ML
MAFIX-O TAB	1x10
MAGANCENT 75	1XV
MAGGACITE 100 ML	100 ML
MAGGACITE-50ML	50ML
MAGNACENT 150 INJ.	1X1 VIAL
MAGNACILLIN 1GM INJ	1x1xVl.
MAGNACILLIN 250MG INJ	1x1xVl.
MAGNACILLIN 500MG INJ	1x1xVl.
MAGNACILLIN CAP 10*10	1x10xCap
MAGNAFFIN SUP	1*200ML
MAGNALUP-S INJ	1VIAL
MAGNAMYCIN 1 GM	1*1
MAGNAMYCIN 250 INJ	1*1
MAGNATE -D DROP 30ML	30ML
MAGNATE KID SACCHET 1*1	1SACCHET
MAGNATE- 200ML	200ML
MAGNATE-D 200ML	200ML
MAGNATE-P100ML	100ML
MAGNATUSS SYP 100ML	1*100ML
MAGNIFI POWDER 200GM	1*200GM
MAGNOCEF 162.5	1*1
MAGNOCEF 325	1*1
MAGNOVA 1GM	1XV
MAGNOVA 250MG	1XV
MAGNOVA 500MG	1XV
MAGNSIUM SULPHATE	1PH
MAGOUT WH 100 ML	100 ml
MAGPROL CR 200 TAB 10*10	1*10TAB
MAGPROL CR 300 TAB 10*10	1*10TAB
MAGPROL CR 400 TAB 10*10	1*10TAB
MAGPROL CR 500 TAB 10*10	1*10TABT
MAGSULF 20 GM	1
MAGSULF 400GM.**	1PH
MAGTAM 0.5GM INJ	1XV
MAGTAM 1GM INJ	VIAL
MAHA SUDARSAN 500GM	500 GMS
MAHA SUDARSAN CHURN 30GM	30 GMS
MAHA SUDARSAN CHURN 60GM	60 GMS
MAHABEND SYU	10ml
MAHABEND TAB	1x1
MAHABHIRINRAJ TAIL 100ML	100ML[129]
MAHACEF 100 TAB 6*10	1x10xTab
MAHACEF 200 TAB 6*10	1x10xTab
MAHACEF 50 TAB 6*10	1x10xTab
MAHACEF CV 100 TAB 3*6	1x6xTab
MAHACEF CV 200 TAB 3*6	1x6xTab
MAHACEF CV KID TAB 3*10	1x10xTab
MAHACEF CV KID TAB 4*10	1*10TAB
MAHACEF CV SYP	1x30xMl.
MAHACEF DROP	1x10xMl.
MAHACEF OZ TAB 6*10	1x10TAB
MAHACEF PLUS SYP 30ML	1*30ML
MAHACEF PLUS TAB 6*10	1*10TAB
MAHACEF PLUS-100 TAB 3*10	1*10TAB
MAHACEF SB 1.5GM INJ	1x1xVl.
MAHACEF SYP 30ML	1x30xMl.
MAHACEF XL 200 TAB 3*10	1x10xTab
MAHACIP-TZ TAB	1x10
MAHACLOXIN CAP	1X10
MAHACORT DZ SYP	1*30ML
MAHACORT DZ-6 TAB 3*10	1*10TAB
MAHADOL	1X10T
MAHADRYL-100ML SYU	100ml
MAHAFLOX DROP 5ML	1x5xMl.
MAHAFLOX-400 TAB 4*5	1*5TAB
MAHAFLOX-IV 100ML	1*100ML
MAHAFLOX-KT DROP 5ML	1*1*5ML
MAHAFLOX-LP DROP	1*5ML
MAHAGABA-M 75 3*10	1x10xTab
MAHAGENTA 30ML	30ML
MAHAGENTA-10ML	10ml
MAHAGENTA-D DROP	10ML
MAHAMANJISTHARISTHA 450	1*450ML
MAHAMARICHADI TAIL 60ML	1 PH
MAHAMASH TAIL 60 ML	1 PH
MAHANARAYAN 100ML	1*100ML
MAHANARAYAN TAIL 100ML	100ML[130]
MAHANARAYAN TAIL 60 ML	1 PH
MAHANARAYAN TAIL 60ML	60ML[33]
MAHAPOD SYU	30ML
MAHAPORT 200ML	200ml
MAHAPROT GRU	200gm
MAHARASNADI KWATH 450ML	1 PH
MAHARSHI POWER CAPSULE	20CAP[143]
MAHASHANKH VATIATI	1x40
MAHASUDARSHAN CHURNA 60GM	1 PH.
MAHAVATVIDVASAN RAS	1x40 TAB
MAHAVITAL CAP	1x10
MAHAYOGRAJ GUGUL	1*70TAB
MAHAZONE-1GM	vial
MAHAZONE-250 VIL	250mg
MAHAZONE-500 VIL	500mg
MAHAZONE-SB VIL	1.5 mg
MAINTAIN INJ 250MG	1x1xAmp
MAINTAIN INJ 500MG	1x1xAmp
MAINTAIN TAB 20*10	1x10xTab
MAJNISTHADI 50GM	50GM[70]
MAJUN DABIDULWARD	125GR
MAJUN FALASFA PAK	125GR
MAJUN MOCHRAS PAK	125GR
MAJUN NANKHAH	125GR
MAJUN SUPARI PAK	125GR
MAJUN SURANJAN	125GR
MAKARDHAWAJ	1x10 TAB
MAKENTOSH (ORBIT)	1 MTR
MALA POWDER 250 GM.	PH
MALA POWDER 500 GM.	PH
MALACID MPS 170ML	1*170ML
MALARIA CARD ASPEN	1 STP
MALE CATH (L)	1 PCS
MALE CATH (M)	1 PCS
MALE CATH (METAL)	1 PCS
MALE CATH (S)	1 PCS
MALE CATH (XL)	1 PCS
MALICOT CATHATER	1 PCS
MALICURE AMP	1X2ML
MALICURE TAB	1X4
MALIRID 45 TAB 10*1TAB	1*1*TAB
MALIRID DS TAB 20*7	1x7xTab
MALIRID TAB 20*7	1*7*TAB
MALOCIDE	1X4T
MAMARKHA 28ML	1
MAMARKHA 56ML	1
MAMARKHA114ML	1
MAMICEF 250MG	1X1X250MG
MAMICURE 5GM	1X5GM
MAMIDIUM 200GM	
MAMMAL 5 GR TUBE	5 GR
MAMMIDIUM 50GM	50GM
MAMMITEL INFUSION 10 GM .	TUBE
MAMOMETER	1 PCS
MAMRIT	1X200GM
MANDUR BHASMA	5 GMS
MANEZ 20 MG TABLET	1X10
MANEZ 40 MG TABLET	1X10
MANFORC-100 TAB 6*4	1x4xTab
MANFORCE 50 TAB 7*9	1x9xTab
MANFORCE BUBLE CONDOM(2PC)	1x2xPc.
MANFORCE BUBLE CONDOM(4PC)	1x4xPc.
MANFORCE BULL CONDOM(3PCS)	1x3xPc.
MANFORCE CONDOM(10PC) STRAW	1x10xPc.
MANFORCE CONDOM(10PC)BANANA	1x10xPc.
MANFORCE DOTD.COND(3PC)BANAN	1x3xPc.
MANFORCE DOTD.COND(3PC)STRAW	1x3xPc.
MANFORCE KALOREE-1 TAB 1*100	1x100xTab
MANFORCE MORE CONDOM(10)PC	1x10xPc.
MANFORCE MORE CONDOM(2PC)	1x2xPc.
MANFORCE MORE CONDOM(4PC)	1x4xPc.
MANFORCE PAN CONDOM(2PC)	1x2xPc.
MANFORCE PAN CONDOM(4PC)	1x4xPc.
MANGO TWIST 200ML	1*200ML
MANGOLIDE SYP.	60 ML.
MANGOLIDE TAB. DT	1x10
MANITOL (AXATOL) 100ML	1 PCS
MANITOL 20% 100ML	350 ML.
MANIX CAP-2*10	1x10xCap
MANKINDS HEALTH OK TAB 3*10	1*10TAB
MANNITIOL 20% (GLASS)	100 ML.
MANNITOL 100 ML PDPL	100ML
MANNITOL 20% I.V.350ML.	1x350xMl.
MANNITOL 300ML PDPL	300ML
MANOGYL INJECTION	100ML
MANOLL	1X450GM
MANWISH -MDF	1
MANWISH CAPS	30CAPS
MANWISH CONDOM	1
MANWISH-MDF	1
MAOULINA SHEETS	1 PCS
MAP 20	1X10T
MAP 20MG TAB	1X10
MAPDION AMP	1AMP
MAPDOX 50MG	30ML
MAPHYL TAB	1X10
MAPIME 250	VIAL
MAPRATONE SYP	1x200xMl.
MAPRAZYME SYP	1x200xMl.
MAPRO	1X10C
MAPRO	1X10C
MARCOBUTOL-800 TAB.	1X10
MARCOCILLIN 2.5GM.	VIAL
MARCOCILLIN 2GM.	VIAL
MARCODEX 6 ML	VIAL
MARCODIN 60 ML	60 ML
MARCOFLOX 100 ML	100 ML
MARCOFLOX 30 ML	30 ml
MARCOGENTA 10ML.	VIAL
MARCOGENTA 30ML.	VIAL
MARCOGESIC 100 ML	100 ML
MARCOGESIC 30 ML.	VIAL
MARCOGESIC BOLUS 1X4	1x4
MARCOGESIC OIL 30ML/MC	M
MARCOGESIC OIL.60ML/MA	M
MARCOGESIC PLUS TAB	1X10
MARCOGYL BOLUS.	1x4B
MARCOGYL TZ BOLUS	1X4
MARCOGYL-LM BOLUS.	1x4B
MARCOPRIM BOLUS.	1x4B
MARCOSID 10ML.	VIAL
MARCOSYL 250MG.TAB.10'S	1X10
MARCOZYME 200ML.SYP/MC	M
MAREX CAP.	1X20CAP
MARIBOST TAB	1X4
MARMOLITA 4"	1 PCS
MARMOLITA 6"	1 PCS
MARO FAT CAP	1*10
MARO TAB	1*10
MARO-D3	1*10
MARO-SP	1*10
MAROCAL-D	1*10
MAROCAL-D SUP	200ML
MAROCAL-D TAB	1*10
MAROCAL-K-2-7	1*10
MAROCAL-K27 SYP	200ML
MAROCORT-6	1*10
MAROFAR XT TAB 1*10	1*10
MAROFAST-D INJ	AMP
MAROFAST-D TAB	1*10
MAROFER XT	1*10
MAROLEX SYP	100ML
MAROLIV SYP	200ML
MAROLIV TAB	1*10
MAROLIV TAB 1*10	1*10
MAROMET-PG1 TAB	1*10
MAROMET-PG2 TAB	1*10
MARONERV PLUS	1*10
MARONERVV-FORT AMP	AMP
MAROVILD MF-1000	1*10
MAROVILD-MF500 TAB	1*10
MAROWEL IV	100ML
MAROWEL TAB	1*10
MAROWEL TAB 1*10	1*10
MARTIDECA 25 INJ	1x1 ML
MARTIDECA 50 INJ	1x1 ML
MARTIFLAM TAB	1X10
MARTIFLAM-AMP	3ML
MARTIFLAM-MRTAB	1X10
MARTIFLAM-S TAB	1X10
MARTIFLOX 200MG	1X10
MARTIFLOX M SUSP	30ML
MARTIFLOX SUSP	60ML
MARTIFLOX TZ TAB	1X10
MARTIFUR 100 TAB	1x10
MARTIFUR MR TAB	1x10
MARTIGYL N 30ML	1*30ML
MARTIGYL N 60ML	1*60ML
MARTILONE 25 INJ	1x1 ML
MARTINOR TABLET	1x10
MARTIVIT 100ML	1PH
MARTIVIT 200ML	1PH
MARTIVIT DROP	1PH
MARZON DUO TAB 1*6	1*6*TAB
MARZON TAB 10*10	1*10*TAB
MASALA DIBBA	1X1
MASHYNE 60 K CAP 1*4	1*4*CAP
MASHYNE DROPS	1*10*ML
MASHYNE SACHET 8*1PC	1*1*PC
MASHYNE TAB 1000 5*10	1*10*TAB
MASHYNE TAB 3*10	1*10*TAB
MASK CASHMET	1 PCS
MASTERCLAV DS 30ML	30 ML
MASTERCLAV TAB	1X10
MASTERPOD 50DS SYP	30 ML
MASTERTAZ 250 MG INJ	VIAL
MASTI-CARE 60GM	1X60gm
MASTICIN Cream .	TUBE
MASTICLEAR 60GM	1X60GM
MASTIJET FORT INTAMAMORY	TUBE
MASTILEP 125 GM.	TUBE
MASTITIS KIT	
MASTIWOK SYRINGE	1X1
MASTIZYME 1KG	1X1KG
MASTIZYME 500GM	PUUCH
MASTIZYME-2.5KG	2.5KG
MASTURIN SY	100ML
MATADOR ADULT SYP	200ML
MATADOR KID	150ML
MATADOR SOFT GEL	1*10
MATADOR SUPER SOFT GEL	1*10
MATADOR SUPER SYP	200ML
MATADOR-ACE TAB	1*10
MATADOR-HG SACH	1
MATARI TAB	1X10
MATCH-2ML INJ 5*2ML	1x2xMl.
MATILDA 500MG TAB	1X10
MATILDA AF	1X10C
MATILDA ER	1X10T
MATILDA FORTE HARD CAPS	1X10C
MATILDA INJ	1X1AMP
MATILDA PG ER	1X10T
MATILDA PLUS HARD CAP	1X10
MATRICARE I.U 100 ML	100 ml
MATRICARE I.U. 30 ML	30 ML
MATTRESS	1 PCS
MAXAGABIN ME TABLET	1X10
MAXAPEN.1GM.VIL	1VIL
MAXAPEN.500VIL	IVIL
MAXCAL GEL	250ML
MAXCORT 6 TAB	1x10
MAXCORT 6 TABLET	1X10
MAXCPROL	1X10 CAP.
MAXEPA CAP 1*30	1*30*CAP
MAXFLO 100DT TAB	1x10
MAXFLO 200 TAB	1x10
MAXFLO OZ TAB	1x10
MAXFLUR E/D	1 5ML
MAXGAIN TAB	1x10
MAXGALIN 150 TAB 5*10	1*10TAB
MAXGALIN 50 TAB 5*10	1*10TAB
MAXGALIN 75 TAB 10*10	1*10TAB
MAXGALIN ER 150 5*10	1*10TAB
MAXGALIN ER 75 TAB 10*10	1*10TAB
MAXGALIN-M 150 TAB 5*10	1*10TAB
MAXGALIN-M 75 TAB 10*10	1*10TAB
MAXICAL 500 TAB 6*15	1*15TAB
MAXICEF 1 GM	1XV
MAXICEF 250MG	1XV
MAXICEF 500MG	1XV
MAXICEF-O CAP	1X6
MAXICEF-O D S 125MG	1X30ML
MAXICORT SUSP	1x30ML
MAXIFER LIQUID	1x200 ML
MAXIFLAM-SP TAB 10*10	1x10xTab
MAXIFLO 100 R/C	30'S
MAXIFLO 125 120MDI	VIAL
MAXIFLO 250 INH	120MD
MAXIFLO 250 R/C	30'S
MAXIFLO FORT R/C	1X30
MAXILANIC 625MG TAB	1x6
MAXILANIC DRY SYP 228.50G	1x30ML
MAXILANIC DUO DRY 457	30ML
MAXIMIN DROP	1x15 ML
MAXIMIN FORTE TAB	1x15
MAXIMIN INJ.AMP	1x10 ML
MAXIMIN POWD 1 KG	1 KG
MAXIMO 100 MG TAB	1*10
MAXIMO 200MG TAB	1*10
MAXIMO 50MG TAB	1*10
MAXIMO DRY SYP	1*30ML
MAXIPIME INJ. 1GM	VIAL
MAXIPIME INJ. 2GM	VIAL
MAXITHRAL DT 100	1X3T
MAXITHRAL ORAL SUSP.	1X15ML
MAXLUB E/D	1 10M
MAXMALA TAB 5*10	1*10TAB
MAXO FE CAP	1x10
MAXO-FE SYP	200ML
MAXOCYL PLUS E/D	1 VUL
MAXODYL SYP BIG 100ML	1
MAXOFALM MR TAB	1X10
MAXOFEROL DROPS	15ML
MAXOFLAM GEL	30GM
MAXOFLAM TAB	1X10
MAXOFLAM-A TAB	1x10
MAXOFLAM-D TAB	1x10
MAXOFLAM-T TAB	1x10
MAXOGLOBIN DROP	30ML
MAXOGLOBIN SYP	200ML
MAXOLID	1X4T
MAXOLID I.V	1X300ML
MAXONE 1GM INJ	1X1
MAXONE INL 250	1X1
MAXONE INL 500	1X1
MAXONIM-P SYP	60ML
MAXONIM-P TAB	1x10
MAXOPEN 125MG	1 VAL
MAXOPEN 500 GM	1 VIL
MAXOPEN INJ 1GM	1 VIL
MAXORANGE CAPS	1X10
MAXOTAZ 4.5 GM	VIAL
MAXOTAZ PS-1.125GM	1XV
MAXOTAZ-2.25GM	1XV
MAXOZA SACHET 1*10	1*10PC
MAXOZA-L SACHET 1*10	1*10SACHET
MAXOZYME 100ML	100ML
MAXOZYME 200ML	200ML
MAXPLEX INJ.30ML	1X30ML
MAXREL TABLET	1x10
MAXTIB TAB 5*14	1*14TAB
MAXTOL 100ML	100ML
MAXTRA NASAL DROP	10ML
MAXTRA NASAL DROPS	1X10ML
MAXTRA ORAL DP.	1X15ML
MAXTRA P ORAL/DP	1X15ML
MAXTRA P SYP	1X60ML
MAXTRA P TAB 10'S	1X10
MAXTRA SYRUP	1X60ML
MAXTRA-S NASAL SPRAY	1X20ML
MAXUM TAB 10*10	1*10*TAB
MAXVIT- 200ML SAY	200ML
MAXXIO TAB	1X10
MAXXTOL 30ML	30ML
MAXZOLAM 0.25MG TAB	1x10
MAXZOLAM 0.50MG TAB	1x10
MAXZONE	VIAL
MAYDINE 1 TAB	10'S
MAYDINE 2 TAB	10'S
MAYDINE 4 TAB	10'S
MAYDINE M SR 1	10'S
MAYDINE M SR 2	10'S
MAYOGYL 30 ML	30 ML
MAZETOL TAB 200MG 10*10	1x10xTab
MAZOCAN 300	1X7
MAZZAL ZABI	
MB OC INJ.	1x2ML
MB ROX TAB	1*10
MBCID DSR	10'S
MCBM 69 FE TAB	1X10
MCBM AMP	1AMP
MCBM- DHA CAP	3*10
MCNASA NASAL DROP	1 5ML
MCQS 200MG	1X10T
ME 12	1X10T
ME- PLUS TABS	10'S
ME-12 INJ	1'S
ME-12 OD TABS	10'S
ME-PR	10'S
MEASURING JAR	1 PCS
MEBASPA TAB 10*10	1x10xTab
MEBENTH SYP.	1 PH.
MEBENTH TAB.	1x6
MEBENZOLE 30ML SYP	1
MEBEX GRANULES	5GR.
MEBEX PLUS TABS	2'S
MEBEX SYR	30ML
MEBEX TABS	6'S
MEBOLIV 1LTR	1000ML
MEBOLIV 220ML	220MLM.
MEBOLIV 225 ML	PH
MEBOLIV 500 ML	500ML
MEBOLIV AFS 1LTR.	PH
MEBOLIV AFS 500ML	
MECCIP-TZ TAB	1*10
MECO FORT TAB.10'S/SAT	S
MECO INJ.1ML/SAT	1ML
MECO-12 TAB.10'S/SAT	S
MECO-OD TAB.10'S	1X10
MECOBA PLUS INJ	3ml
MECOBION- OD TABS	10'S
MECOBION-P 75MG TAB	10,S
MECOBIONE-P 150MG	10'S
MECOLIFE-G TAB 6*10	1x10xTab
MECOLIN 200ML	200ML
MECOMAX OD TAB	1*10
MECOMORE OD 1500MCG	1X10T
MECON FORT INJ	AMP
MECON OD CAP	1X10
MECONERV PLUS CAP 10*10	1*10*CAP
MECONERV Z SYP	1*200*ML
MECONERVE FORTE CAP 10*10	1*10*CAP
MECOPAC FORTE INJ	1*2ML
MECOVON	1X10C
MECOVON 1GM	1XAMP
MECOVON 500MG	1XA
MECOVON OD	1X10C
MECOVON-G	1X10C
MECTIN 10 ML	10 ML
MECTIN 1ML.	1x2VIAL
MECTIN 20 ML{NEW} VIAL	20 ML
MECTIN 7 ML	7 ML
MEDAPINE AC GEL 0.1%	1*15*GM
MEDI STRIP	1 PIS
MEDIASTAT 250 MG.	1x10
MEDIASTAT 500 MG.	1x10
MEDICATH 18,20,22,G	1 PIECE
MEDICEF 1000MG VIAL	1*1
MEDICEF 250MG VIAL	1*1
MEDICEF 500MG VIL	1*VIL
MEDICEF SB 375MG	1 VIAL
MEDICEF-SB 750MG	1 VIAL
MEDICET-L TAB	1X10TAB
MEDICID GEL	1x200ML
MEDICLOX PLUS .500MG.	1X10
MEDICLOX-PLUS CAP	1X10
MEDICOF SYP	1*100ML
MEDIDERM 5GM OIN	5gm
MEDIDERM 10GM OIN	10gm
MEDIFLOX 500MG TAB	1*10
MEDIGOLD DEVELOPER	1 PCS
MEDILICE CREAM	1*30ML
MEDIMIK 500MG VIAL	1*1VIAL
MEDIMIK-100MG VIAL	1*1
MEDINASE 0.5 LACK INJ	1x1xVL.
MEDISPAS TAB 1*10	1*10
MEDITRAX 1GM INJ	1 VAIL
MEDITRAX 250MG	VIAL
MEDITRAX 500MG VAIL	1 VAIL
MEDITRAX SB 1.5GM INJ	1 VAIL
MEDITRAX SB 375MG INJ	1 VAIL
MEDLER NEW TAB	1x10
MEDLER PLUS SUS	60ML
MEDLER SYP	60ML
MEDLER-AF SYP	60ML
MEDOXY BOLUS.	1x4B
MEDROL 16MG	1X14T
MEDROL 4MG	1X10
MEDROL 8	1*10
MEEZYME 100ML SYP	1*100ML
MEEZYME 200ML	1*200ML
MEFAST 100	1X60ML
MEFAST D	1X10T
MEFAST P	1X10T
MEFAST P SUS.	1X60ML
MEFCID TA TAB	1X10
MEFCID TAB	1X10
MEFETRAC TAB	1X1
MEFGAL SPAS TAB	1x10
MEFGAL-SPAS.TAB	1X10
MEFKIND FORTE SYP 60ML	1*60ML
MEFKIND SPAS TAB 10*10	1*10TAB
MEFKIND-P SYP 60ML	1*60ML
MEFLIAM PLUS	1X6
MEFLOC 250MG TAB	1X4
MEFNIL 200MG	1X1T
MEFNIL D TAB	1x10
MEFOMIN P-15	1X10T
MEFOMIN P-30	1X10T
MEFOMIN-1000 SR	1X10T
MEFOMIN-500 SR	1X10T
MEFTAL 250 MG.	1x10
MEFTAL 500 MG.	1x10
MEFTAL FORTE CREAM 50GM	1x50GM
MEFTAL FORTE CREEM 25GM	1TUB
MEFTAL FORTE TAB	1x10
MEFTAL M.R TAB	1x10
MEFTAL P SUSPENSION	1PH
MEFTAL P TAB	1x10
MEFTAL SPAS DROP	1 PH.
MEFTAL SPAS DS TAB	1x10
MEFTAL SPAS INJ.	1 AMP
MEFTAL SPAS SYP	1x30ML
MEFTAL SPAS TAB	1x10
MEFTAL TX TAB	1x6
MEFTRAN TABS	1*10
MEGA DICLOX CAP	1X10
MEGA CV 600 INJ.	1X1 VIAL
MEGA CV 625MG	1X6T
MEGA CV D/S 228.5MG	1X30ML
MEGA CV DP 1.7GM/10	1X10ML
MEGA CV DT 228.5	1X6T
MEGA CV DT 228.5	1X6 TAB.
MEGA CV DUO 1 GM	1X6 TAB.
MEGA CV FORTE D/S	1X30ML
MEGA CV FORTE DT 457M	1X6S
MEGA CV INJ 1.20GM	1XVIAL
MEGA CV INJ 150MG	1XVIAL
MEGA CV INJ 150MG	VIAL
MEGA CV INJ 150MG	VIAL
MEGA CV INJ 300MG	1XV
MEGA CV TAB 375MG	1X6T
MEGA FREEFLEX TAB	1X10
MEGA FREEPLEX	1X10T
MEGA OMEGA CAP.	1X10C
MEGA SHELCAL	1X10
MEGA SHELCAL	1X30
MEGA-3 TAB	1x15
MEGA-PRED 16MG	1x10
MEGA-PRED 4MG TAB	1x10
MEGA-PRED 8MG TAB	1x10
MEGABEX 200ML SYP	1x200ML
MEGABEX SYP	1x100ML
MEGABION 100 ML	1x100ML
MEGABION-200ML	1x200ML
MEGABOSE 0.2 TAB.	1X10 TAB.
MEGABOSE 0.3 TAB.	1X10 TAB.
MEGABOSE MF 0.2/500	1X10 TAB.
MEGABOSE MF 0.3/500	1X10 TAB.
MEGABROM EYE DROP	1*5ML
MEGACEF 100MG TAB	1*10
MEGACEF 1GM VILE	1GM
MEGACEF 200MG TAB	1*10
MEGACEF 250 VILE	250VILE
MEGACEF 500 VILE	500VILE
MEGACEF DRY SYP.	1*30ML
MEGACHOLIN SOFT GEL CAP	1X7C
MEGACID GEL	200 ML.
MEGACIP 250	1X10
MEGACIP 500MG TAB	1x4
MEGACIP TZ TAB	1X10
MEGACLAV SYP	1*30*ML
MEGACLAV TAB 625MG 1*10	1*10*TAB
MEGACLOX 500MG VAIL	1VAIL
MEGACLOX CAPS	1X10
MEGACLOX.250DT.TAB	1X10.
MEGACOLD KID SUS	60ML
MEGACOLIN PASTILLE	1X10S
MEGADIC TAB	1X10
MEGADIC-P TAB	1X10
MEGADIN M CREAM	1 TUB
MEGADINE CREAM	1TUB
MEGAGOLD (NF)	1x15
MEGAGOLD DROP	1x30ML
MEGAGOLD SYP	100ML
MEGAGOLD SYP 200ML	1x200ML
MEGAHEAL GEL	1X15GM
MEGAHEAL GEL	1X50GM
MEGAKUF EXP.	100 ML.
MEGAKUF PLUS SYP	1x100ML
MEGALIFE EG CAP	1x10
MEGALIFE EG CAP 10*10	1*10CAP
MEGALIFE TAB	1x15
MEGALIS-10	1X4C
MEGALIS-20	1X4T
MEGAMAC 100 SYP 1*15ML	1x15xMl.
MEGAMAC 250 TAB 10*6	1x6xTab
MEGAMAC 500 TAB 10*3	1x3xTab
MEGAMOM POW 200GM	1*200*GM
MEGAMOST	1X10
MEGAMOST SOFTGEL	1X10
MEGAMOX CV TAB 625MG 10*6	1*6*TAB
MEGAMOX DX TAB 10*10	1x10xTab
MEGANEURON CAPS	1X10
MEGANEURON INJ 500MG	1XAMP
MEGANEURON OD PLUS	1X10C
MEGANEURON-OD------------	1X10C
MEGANOR SUSPENSION	30ML
MEGANOR TAB	1X10T
MEGANOR-OZ TAB	1X10T
MEGAPEN CAP	1X10C
MEGAPEN INJ 1GM	1XV
MEGAPEN INJ 250MG	1XV
MEGAPEN INJ 500MG	1XV
MEGAPEN KID	1X10T
MEGAPEN NENOTAL 75MG	1XV
MEGAPEN-XP	1X10C
MEGAPEPTIN DROP	15ML
MEGAPEPTINE SYU	60ML
MEGAPIME INJ 1GM	VIAL
MEGAPIME INJ 250MG	VIAL
MEGAPIME INJ 500MG	VIAL
MEGAPIME XP 1GM	1XV
MEGAPIME XP 250MG	1XV
MEGAPIME XP 500MG	1XV
MEGAPRAZ-D CAPS	1x10
MEGARICH.CAP	1X10
MEGARICH.SYU	1PH
MEGARON-XT SYRUP	200ML
MEGARON-XT TAB	1*10
MEGASLIM CAP 1*10	1*10
MEGASOFT FORTE	1X10C
MEGASOFT-E CAP	1X10
MEGASTAR CAP 1*15	1*15
MEGATONE CAPSULE 20CAP	20CAP[146]
MEGATONE GRANULES 200GM	200GM[118]
MEGATONE Z SYP.	200 ML.
MEGAVAC-6 MONOPACK	1X1ML
MEGAVAC-R 1ML	1X1ML
MEGAVOG 0.2	1x10T
MEGAVOG 0.2--------------	10T
MEGAVOG 0.3	1X10T
MEGAVOG MF 0.2/500	1X10
MEGAZID -XP 250	VIAL
MEGAZIDE 125MG INJ	1x1xVl.
MEGAZIDE 1GM INJ	1x1xVl.
MEGAZIDE 250MG INJ	1x1xVl.
MEGGACITE LOTION 50ML	50ML
MEGO INJECTION	1 AMP
MEGO SUBLETS	1x10
MEGO XL INJ	1x2ML
MEGO-XL-CAPS	1X10
MEKAV CAP	1X10
MEKDIAR BOLUS	1X2'S
MEL-OD 15MG TAB	1X10'T
MEL-OD 7.5MG TAB 10'S	
MELABEST CREAM 15GM	1*15GM
MELABEST-F CREAM 15GM	1*15GM
MELACARE (N)	20GM
MELACARE FORT	15 GM
MELACARE HC	15 GM
MELACARE OINT	1*15GM
MELALITE 15 CREAM 30GM	1x30xGm.
MELALITE FORT CREAM	1*30*GM
MELALITE XL CREAM	1*15*GM
MELALONG	1*15GM
MELALONG PLUS	1*20GM
MELANOCYL OINT(F-India)	1TUB
MELANOCYL TABLET	1X40T
MELANOCYL- SOLUTION	1TUB
MELANORM- 30GM	30GM
MELANORM-2 15GM	15GM
MELANORM-4 15GM	15GM
MELANORM-HC 15GM	15GM
MELANORM-MS 15GM	15GM
MELBONE PLUS	1X10
MELBONE TAB	1X10
MELCOVIT GOLD CAP 3*10	1*10*CAP
MELGAIN	1X2ML
MELGAIN	1X5ML
MELICURE AMP	AMP
MELMET SR TAB 1000MG 10*10	1*10*TAB
MELMET SR TAB 500MG 15*15	1*15*TAB
MELOBEST-P 30ML	1X30ML
MELONEX 4 BOLUS	1*4
MELONEX INJ.	100ML
MELONEX INJ.	15ML
MELONEX INJ.	30ML
MELONEX PLUS 4 BOLUS	1*4
MELONEX PLUS INJ	30 ML
MELONEX PLUS INJ.	100 ML
MELONEX POWER 50ML	50ML
MELONEX POWER INJ.	10 ML
MELONEX POWER INJ.	30 ML
MELOPRAX-0.25 TAB 6*10	1x10xTab
MELOPRAX-0.50 TAB 3*10	1x10xTab
MELOSE EYE DROP	1x5 ML.
MELOSE EYE OIT	1TUBE
MELOSET 3MG	1X10T
MELOX 100 ML	100 ML
MELOX 100ML	1VIAL
MELOX 30 ML	30 ML
MELOXI 100ML	1X100ML
MELOXI INJ 30ML	1X30ML
MELRIO CREM	20 GM
MELTHIX	1X10T
MELTOLAN 10	1X10T
MELTOLAN 15	1X10T
MELTOLAN 2.5	1X10T
MELTOLAN 5	1X10T
MELTOLAN 7.5	1X10T
MELTOLON 20 TAB.	1X10TAB.
MELZAP 0.25 MD	1X10T
MELZAP 0.50 MD	1X10T
MELZAP 1 MD	1X10T
MELZAP 2 MD	1X10T
MEM.TAB	1X10
MEME DROP	30ML
MEMLINE ING	1ML
MEMLINE TABLET	1*10
MEMO PLUS 200ML	200ML
MEMO PLUS 200ML SY	1x200ML
MEMOBOLIV225ML	225ML
MEMOFEN CAP	1X10
MEMPIL 100	1X10T
MEMROGIZER CAP 1*10	1*10
MEMTONE SYP 200 ML	200 ML
MENABOL TAB 10*10	1*10*TAB
MENABOL TAB 10*10	1*10*TAB
MENO HRT TAB	1x10
MENOASE CAP	1X10
MENOFIT PLUS	10'S
MENOFIT TAB	1*10
MENOFLAV CAP 10*10	1*10*CAP
MENOHELP SYP	300ML
MENOPACE CAP 2*15	1*15*CAP
MENOPACE ISO TAB 3*10	1*10*TAB
MENOREG	1X300ML
MENORID TAB 1*15	1*15
MENOSAN TAB	1x60xTab
MENOSPA CAP	1x10
MENOVIT 30ML	1X30ML
MENSIL N TAB	1X10
MENSONORM 200 ML.	1 PH.
MENSONORM 500ML.	1 PH.
MENSOSET SYP	200ML
MENSTA 200ML	1*200ML
MENSUTONE CAPSULE 12CAP	12CAP[140]
MENTAT SYP	1x200xMl.
MENTAT TAB	1x60xTab
MENTAT-DS SYP 100ML	1x100xMl.
MENTHO PLUS BALM	4GM.
MENTHO PLUS BALM	9GM
MEPROGEL OIT	1x30GM
MERACAL-AD3 1LTR	1 LET
MERBROMIN SOLUTION	1 PCS
MERCAL PLUS	1.LT
MERCAL TAB.10'S/SAT	S
MERCAL-OB	1X10
MERCURY CHAMBER	1 PCS
MERGIN TAB 20*10	1*10TAB
MERICAL 1LIT.	PH
MERICAL 6 LT	JAR
MERICAL PET BRISKET 50	50 BISK
MERICAL PET BRISKIT	1X50
MERICAL PLUS 1.2 LT	1.2LT
MERICAL PLUS 6.00LT	6.00LT
MERICOBAL VIVA TAB 10*10	1*10TAB
MERIFLOX 15 ML	15 ML
MERIQUIN 100 ML INJ	100 ML
MERIQUIN 15ML INJ.	VIAL
MERIQUIN 5 LT	5 LT
MERIQUIN ORAL SOL 100ML.	PH
MERIQUIN ORAL SOL 500ML.	PH
MERIQUIN TABS	1X10
MERISPAS AMP	1AMP
MERISPAS SYP 30ML	30ML
MERISPAS TAB	1*10
MERITUS DC	100ML
MERITUS EX	100ML
MERIZYME DROPS	15ML
MERIZYME TAB	1*10
MERO 1 GM	1XV
MERO 250 MG	1XV
MERO 500 MG	1XV
MERO SB 1.5GM	1X1VIAL.
MEROFER-XT SYP	200ML
MEROGRAM-1G	1 VIL
MEROJET INJ 1000 MG	1 VIL
MEROJET INJ 500MG	1 VIL
MEROMAC 125	1XV
MEROMAC 1GM	1XV
MEROMAC 500MG	1XV
MEROMAC PS	1XV
MEROPENEM INJ	1 100
MEROTEC -125 MG	1X1 VIAL
MEROTEC 1GM	1XV
MEROTEC I.V 250MG	1X1VIAL
MEROTEC-250MG	1XV
MEROTIVA	1 AMP
MEROTROL 0.25GM	1XV
MEROTROL 0.5GM	1XV
MEROTROL 125MG	1XV
MEROTROL 1GM	1XV
MEROTUM 1GM INJ	
MERRYDOL 450ML	1*450ML
MERSILK 1/0 , 0	1 PCS
MERSILK 2/0	1 PCS
MESACOL 800 TAB 5*10	1*10TAB
MESACOL ANEMA 60ML	1*60ML
MESACOL OD TAB 5*10	1*10TAB
MESACOL TAB 10*10	1*10TAB
MESITE XR 1000MG	1X10S
MESITE XR 500MG	1X10S
MESOPAM -LITE TAB	1*20
MESOPAM PLUS	1*10
MET XL 100MG	1*10
MET XL 12.5	1*10
MET XL 25	1*10
MET XL 50	1*10
MET XL AM25/5	1*10
MET XL AM50/5	1*10
MET XL H25	1*10
MET XL H50	1*10
MET XL R 25/2.5	1*10
MET XL R 25/5	1*10
MET XL R 25/5.	1*10
MET XL R50/5	1*10
MET XL R50/5.	1*10
MET-STAMLO 25 TAB 10*10	1*10TAB
MET-STAMLO TAB 10*10	1*10TAB
METABOL INJ 25MG	1x1xAmp
METABOLIS TAB 3*10	1*10*TAB
METABOLITE 50 GR	50 GR
METABUTADEC TAB.	1x10
METACIN DROP	1 PH.
METACIN SYP.	1 PH.
METACIN TAB.	1x10
METACORTIL C	1X10GM
METACORTIL CREAM	1X10GM
METACORTIL LITE	1X15GM
METADAY-1000 TAB 10*10	1x10xTab
METADAY-500 TAB 10*10	1x10xTab
METADEC INJ 25MG	1x1xAmp
METADEC INJ 50MG	1x1xAmp
METADIN M OINT	1X15GM
METADIN500ML K PHARMA	500 ML.
METADINE M OINT 15GM	
METADOZE IPR 500 TAB	1x10
METADOZE IPR 850 TAB	1x10
METADRATE SUSP	200ML
METADRATE SYP. 200 ML	200 ML
METADRATE SYU	200ML
METADRATE TAB (1*10)	1*10
METAFORT G 851 10*10	1*10*TAB
METAFORT G 852 10*10	1*10*TAB
METAFORT G1 CP TAB 1*30	1*30*TAB
METAFORT G2 CP TAB 1*30	1*30*TAB
METAGARD CR 35MG 10*10	1x10xTab
METAGARD CR 60MG 10*10	1x10xTab
METAGARD TAB 10*10	1x10xTab
METAGLEZ FORTE	1X10T
METAGLEZ TAB	1X10
METAL CATHETER	1 PCS
METALIKA SUSP	100ML
METALIN-Z TAB 10*10	1x10xTab
METALJIN SUSP	1X60ML
METALOC XL TAB 25MG 10*10	1*10*TAB
METALOC XL TAB 50MG 10*10	1*10*TAB
METANORM 1GR	1X10
METAPLEX SYP.	1 PH.
METAPRO XL TAB 25MG 10*10	1*10*TAB
METAPRO XL TAB 50MG 10*10	1*10*TAB
METASPAN TAB	1*10
METASPRAY AQ	100MD
METATOP NASAL SPRAY	1x1xPc.
METAVIT SYRUP	100ML
METECH-G1 TABLET	1*15
METECH-PG 1 TAB	1*15
METECH-PG 2 TAB	1*15
METGLAR TAB 1MG 10*10	1x10xTab
METGLAR TAB 2MG 10*10	1x10xTab
METGLI 1MG	1X30S
METGLI 2MG	1X30S
METHARGAL TAB	1X10
METHARGO TAB	1x10
METHERCIP TAB	1x10
METHERCIP AMP	1AMP
METHERGIN INJ 1AMP	1x1xMl.
METHERGIN TAB 12*10	1x10xTab
METHIMEZ-10 TAB 5*10	1*10TAB
METHIMEZ-5 TAB 5*10	1*10TAB
METHOCIN INJ 10*1ML	1x1xMl.
METHORHYL- AMP	1'S
METHRMET INJ 0.2MG	0.2mg
METHS OD TAB	1X10
METHYCAL TAB	10'S
METHYCOBAL INJ 2*5*1ML	1x1xAmp
METHYCOBAL TAB 20*10	1x10xTab
METHYL ERGOMETRINE TAB	1x10
METHYLERGOMETRIN AMP	1 AMP
METHYMED TAB	1*10
METHYPREG	1X10T
METHYPREG DS	1X10T
METLEAD 500 SR	10'S
METLEAD FORTE SR	10'S
METLONG 500 TAB	1x10
METLONG DS TAB	1x10
METLONG P 15 TAB	1x10
METNEUROBION CAP 10*10	1*10*CAP
METNEUROBION OD CAP 10*10	1*10*cap
METO AM 25 MG TABLET	1X10
METO AM 50 MG TABLET	1X10
METO ER 12.5 MG TABLET	X10
METO ER 25 MG TBALET	1X10
METO ER 50 MG TABLET	1X10
METO ER HT 25 TABLET	1X10
METO ER HT 50 TABLET	1X10
METOCARD XL 100	1X10T
METOCARD XL 12.5	1X10T
METOCARD XL 25	1X10T
METOCARD XL 50	1X10T
METOCLOPRAMIDE 10ML	1 VAL
METOCLOPRAMIDE INJ 2ML	1 AMP
METOCONTIN TAB 10*10	1x10xTab
METOFIX XL TAB 1000MG 10*10	1*10*TAB
METOFIX XL TAB 500MG 10*10	1*10*TAB
METOLAR 25MG	1X10
METOLAR 50MG	1X15
METOLAR AM 25 TAB	10'S
METOLAR AM 50 TAB	10'S
METOLAR XR 50	1X15
METOLAR-25MG TAB	10'S
METOLAR-50MG TAB	10'S
METOLAR-XR 100 CAP.	10'S
METOLAR-XR 12.5 CAP	10'S
METOLAR-XR 25 CAP	10'S
METOLAR-XR 50 CAP	10'S
METOMAC 25	1X10T
METOMAC 50	1X10S
METOPAR SYP	1x60xMl.
METOPAR SYP	1x60xMl.
METOPAR TAB 25*10	1x10xTab
METOPAR TAB 25*10	1x10xTab
METOSARTAN-25 TAB 10*10	1*10TAB
METOSARTAN-50 TAB 10*10	1*10TAB
METOXIM DT TAB 100MG 10*10	1x10xTab
METOXIM DT TAB 50MG 10*10	1x10xTab
METOXIM SYP 50MG	1x30xTab
METOXIM TAB 200MG 10*10	1*10*TAB
METOZYME 100ML SYP	1*100ML
METOZYME DROP	1PH
METPURE AM 2.5 TAB	1X10TAB
METPURE AM 5 TAB	1x10
METPURE H TAB	1x10
METPURE IR 50 TAB	1X10TAB
METPURE XL 12.5 TAB	1x10
METPURE XL 25 TAB	1x10
METPURE XL 50 TAB	1x10
METRA	500ml
METRA 1LTR	1 LTR
METRALKA SYP	1 PH
METRATONE LIQUID 450 ML	450 ML
METRO IV 100 ML	1 BOT
METRO IV 100ML	1 PCS
METRO.IV	100 ML.
METROCARE IV	100ml
METRODIF MPS	1x60ML
METRODIF-MPS TAB	1x10
METROFURAL BOLUS	1x4B
METROGYL 200MG TABS	10'S
METROGYL 400MG TABS	10'S
METROGYL COMP PLUS	10'S
METROGYL DG GEL	1TUB
METROGYL F SYRUP	60ML
METROGYL INFUSION	100ML
METROGYL OINT	1TUB
METROGYL P + OINT	15 GM
METROGYL P LOTION	1PHI
METROGYL P OINT	1TUB
METROGYL SYRUP	60ML
METROGYL V GEL	30 GM
METROGYL- COMPOUND	15'S
METROKIND PLUS ONIT 15GM	1*15gm
METROKIND-PV ONT 1*15GM	1x15xGm.
METROLA SYP 3ML	30ML
METRON 200MG	1X10T
METRON DF TAB	1X10
METRON FORTE	1X10T
METRON I.V INJ	100ML
METRON SUSP	60ML
METRONANIDAZOL.400MG.TAB	1X10
METRONIDAZOLE	1 TAB
METRONIDAZOLE I.V.PANTAGN	1 PH.
METROQUIN O SYP	1 PH
METROQUIN-O TAB	1X10
METROQUINE TAB	1x10
METSOL-4	1*10
METSOL-4	1X10
METSPOT XL TAB 25MG 10*10	1*10*TAB
METSPOT XL TAB 50MG 10*10	1*10*TAB
METUP-25 INJ	KIT
METVIO CR TAB 25MG 10*10	1*10*TAB
METVIO CR TAB 50MG 10*10	1*10*TAB
METWIN XL 25	1X10
METWIN XL 50	1X10
METZOK TAB 25MG 10*10	1x10xTab
MEVA C CAP 10*10	1x10xCap
MEVA SR CAP 10*10	1x10xCap
MEVADEX FORTE 30ML	1x30ml
MEXT F TAB 7.5MG 10*28	1*28*TAB
MEXT INJ 15MG	1*1*ML
MEXT INJ 50MG	1*2*ML
MEXT TAB 10MG 10*10	1*10*TAB
MEXT TAB 15MG 10*10	1*10*TAB
MEXT TAB 2.5MG 10*10	1*10*TAB
MEXT TAB 5MG 10*10	1*10*TAB
MEXT TAB 7.5MG 10*10	1*10*TAB
MEZOL E/D	1*10ML
MEZOLAM	1 1
MF-ONE ING	2ML
MFC DROP	1*5ML
MFENAC-P TABS	1*10
MFENAC-SP TABS	1*10
MFENAC-TH TABS	1*10
MFORTAN D TAB 24*10	1*10*TAB
MFQ SOFTGEL CAP	1*10
MFRESH TAB	1X10
MFX-72	450ML
MGD 80MG TAB	1X10
MGD 80MG TAB	1X10
MIBRONIC DROPS	15ML
MIBRONIC-L CAPS	1*10
MIBRONIC-L SYRUP	200ML
MIBRONIC-L200ML	200ML
MICA-500MG	1VIAL
MICLOGENTA 10GM	10GM
MICO F CREAN	1X15GM
MICODIN SHAMPOO	100 ML
MICOGRAM CREAM 15G	1 TUBE
MICOMIX 2ML	2ML
MICOMIX CAPS	1*10
MICOMIX CAPS	1*10
MICOVATE -CN CREAM	1 TUB
MICOVATE CREAM	1 TUB
MICOVET CREEM	1X10GR
MICRO COVER SLIDES	1 BOX
MICRO IV SET	1 PCS
MICRO-POWER LIQ.	250ML
MICROAZI 250 MG TABLET	1X10
MICROCEF CVTAB 100MG 3*10	1*10*TAB
MICROCEF CVTAB 200MG 5*10	1*10*TAB
MICROCEF DT 50MG 1*10	1*10*TAB
MICROCEF DT TAB 100MG 3*10	1*10*TAB
MICROCEF SYP 50MG	1*30*ML
MICRODOX LBX CAP 5*10	1*10*CAP
MICROFLOX D/X DROPS	1X10 ML
MICROFLOX E/E DROPS	1X5 ML
MICROFLOX TAB 250MG 30*10	1*10*TAB
MICROFLOX TAB 500MG 30*10	1*10*TAB
MICROGAT EYE DROPS	1X10 ML
MICROGAT EYE OINTMENT	1X5 G
MICROGEST 100 CAPS	1x10
MICROGEST 100 INJ.	1x2 ML
MICROGEST 200 CAPS	1x10
MICROGEST 200 INJ.	1x2 ML
MICRON	1 PCS
MICRONAC EYE DROP	1X5 ML
MICROPIME INJ 1 GM	1*1*VL
MICROPIME INJ 250MG	1*1*VL
MICROPIME INJ 500MG	1*1*VL
MICROPOR 1" **	1
MICROPOR .5"(1/2)**	1
MICROPOR 2" **	1
MICROTAZ INJ 4.5GM 1*1VAIL	1*1*VAIL
MIDASPRAY 1*5ML	1*5ML
MIDFAST 10MG/10ML	1 VIA
MIDFAST 5MG/ML	1 AMP
MIDICLO	1X6T
MIFEGEST KIT 10*1	1*1*KIT
MIFEGEST TAB 1*1	1x1xTab
MIFEMISO KIT 1+4	1 STP
MIFEPRIN KIT 1*5TAB	1*5TAB
MIFEX 450ML.	PH
MIFEX ORAL 1LITT	PH
MIFEX ORAL 5LITT	1x5LITT
MIFOCAL 450ML	VAIL
MIFTY	1XKIT
MIFTY 200MG TAB	1X1
MIGARID 10	1X10
MIGARNIL 10MG	1X10
MIGAVIS 5MG	10'S
MIGAVIS TAB	1*10
MIGAZIN 10	1X10T
MIGAZIN 5	1X10T
MIGHTY	1X10 CAP.
MIGNAR 50 TABLET	1X15
MIGNAR-25MG TAB	1X10
MIGNAR-50MG TAB	1X10
MIGON TAB 10MG 21*10	1x10xTab
MIGON TAB 5MG 12*10	1x10xTab
MIGRABETA A TAB.	1X10T
MIGRABETA PLUS	1X10T
MIGRABETA TR-20MG	1X10C
MIGRABETA TR-40MG	1X10T
MIGRABETA TR-60MG	1X10C
MIGRABETA TR-80MG	1X10C
MIGRALGIN TAB	10'S
MIGRAZE-10 MG	1*10
MIGRAZE-5 MG	1*10
MIGSET 25 CAP.	10'S
MIGSET 50 CAP.	10'S
MIGTON TAB	1X10
MIGTOR 25	1X10T
MIGTOR 50	1X10T
MIK 100 MG INJ.	1 VIAL
MIK 100 MG.	1 VIAL
MIK 250 MG.	1 VIAL
MIK 250 MG.	1 VIAL
MIK 500 MG.	1 VIAL
MIK 500 MG.	1 VIAL
MIKA-BEST 100 VILE	1VILE
MIKA-BEST 500	1*2ML
MIKABEST 250 VILE	1 VILE
MIKACIN INJ 100MG	1XV
MIKACIN INJ 250MG	1XV
MIKACIN INJ 500MG	1XV
MIKAROM -250 INJ	1'S
MIKAROM -500 INJ	1'S
MIKASTAR 100 INJ	1x2xMl.
MIKASTAR 250 INJ	1x2xMl.
MIKASTAR 500 INJ	1x2xVl.
MIKATAX 100 INJ	1X2ML
MIKATAX 250 INJ	1X2ML
MIKATAX 500 INJ	1X2ML
MIKATOP 100MG VAIL	
MIKAVAS-500 ING	2ML
MIKMOR VIAL 500	
MILBORN 25 TAB 5*10	1*10TAB
MILBORN 50 TAB 5*10	1*10TAB
MILCEF 125 MG	1x4
MILCEF 250 MG.	1*10
MILCEF 500 MG.	1*10
MILCEF-CV 250TAB	1*6
MILCEF-CV 500TAB	1*6
MILCHEND 250 GR	250 GR
MILCHEND BOLUS 1X4	1x4
MILCHY 100TAB	100TAB
MILEGE EXTRA GR	1*200*GM
MILFLOX DM DROP	1*5ML
MILFLOX DROP	1*5ML
MILFLOX PLUS DROP	1*5ML
MILFLOX-DF DROPS 5ML	1*5ML
MILIBACT 375MG INJ	1X1VAIL
MILIBEND 400 TAB	1x1
MILIBEND SYP 10 ML	1X10 ML
MILICAL TAB	1X15
MILICAL XP TAB	1X10
MILICLAV 375 TAB	1X6
MILICLAV 625 TAB	1X6
MILICLAV DRY SYP	1X30ML
MILICOR 10MG/10ML	1 VIA
MILIOM D CAP	1x10
MILIVO 250 MG TABLET	1X5
MILIVO 500 MG TABLET	1X5
MILIVO 750 MG TABLET	1X5
MILIXIM 100 DT TAB	1x10
MILIXIM 50DT TAB	1X10
MILIXIM CV 200 MG TABLET	1X6
MILIXIM DLX 200MG TAB	1X10
MILIXIM DRY 30ML SYP	1X30ML
MILIXIM LX 100 TAB	1x10
MILIXIM LX 200 TAB	1x10
MILIXIM O TABLET	1X10
MILIXIM OZ TABLET	1X6
MILIXIM TAB 200	1x10
MILK BOOSTER 2LT	JAR
MILK BOOSTER-5LT	5LT JAR
MILK HI MILK (VET)	1X1KG
MILK HI MILK 5KG	1X5KG
MILK HI MILK POWDER	1x1KG
MILK O PLUS 500ML	1x500ML
MILK O PLUS LIQUID	1x1LT
MILK OF MAGNESIA SYP	1x110 ML
MILK SACCAD3 1KG	1X1KG
MILK TONE 50ML	1X50ML
MILK-GROW 100TAB	1X100TAB
MILKIT 30GM	30 GM
MILKMIN 1KG.	1KG
MILKOFAT 1KG	
MILKOGEL SYP.	1 PH.
MILNACE 25	1X10C
MILNACE 50	1X10T
MILZA 25 CAP 10*10	1x10xCap
MIMORANGE L LIQ. 200ML	1*200*ML
MINAGEST 100MG CAP	1X10
MINAGEST 200MG CAP	1X10
MINAL FORTE 1 KG.	1 PH.
MINAL FORTE 10 KG.	PH
MINAMIL 1KG.	BAG
MINAMIL 25 KG	25 KG
MINAMIL 250GM.	SACHET
MINAMIL 5KG.	BAG
MINCET TAB	1X10
MINEREX BOLUS.	1x4B
MINEREX FORT.POW.	5K.G
MINEREX FORTE POWDER 1KG	1KG
MINEREX FORTE POWDER250GM	1 PACKET
MINFA GOLD	10KG
MINFA GOLD	30KG
MINFA GOLD 1.2KG	1.2kg
MINFA GOLD 6KG	6KG
MINFA POWDER	1 KG
MINFA POWDER 10KG	10 KG
MINI-CITIZOL 550MG	1X10
MINICYCLINE CAP 10*10	1x10xCap
MINIDEX EYE DROP	1x5 ML.
MINILACTON TAB 10*10	1*10*TAB
MINIPHOS SYR	1X200ML
MINIPRESS XL 2.5MG	1X15T
MINIPRESS XL 5MG	1X15T
MINIREX FORTE POWDER 2.5K	1x2.5K.G
MINISUL TAB	1X10
MINMIN DROP	1x15ML
MINOCORT TABLET	1X10
MINOFOL PLUS SYP 300ML	300ML
MINOGEN DROP	1x15ML
MINOGEN SYP	1x200ML
MINOGEN SYP 100ML	1x100ML
MINOKEM 2%	1X60ML
MINOKEM 5%	1X60ML
MINOKEM SPRAY 2%	1X60ML
MINOKEM SPRAY 5%	1X60ML
MINOKEM-N 2%	1X60ML
MINOKEM-N 5%	1X60ML
MINOLAST 10MG 1*10	1*10.
MINOLAST KID 1*10	1*10
MINOR DRAPE	1 PCS
MINOSPAS	1*10
MINOSTA D3	1X10T
MINOSTA TABS	1X10T
MINOTAS 4BOLUS	1X4
MINOTAS 7 BOLUS	BOLUS
MINREX-L 1 KG.	PH
MINSUGAR G1 TAB 10*10	1*10*TAB
MINSUGAR G2 TAB 10*10	1*10*TAB
MINTHAL BOLUS 3 GR	3 GR
MINTHAL BOLUS 600MG.	1x4B
MINTOP 10% LOTION	1x100xMl.
MINTOP FOAM LOTION	1*60ML
MINTOP FORTE LOTION	1x50xMl.
MINTOVIT	1X10
MINTOVIT-L	1X10
MINTTRUS CAPLETS	1X10'S
MIOFREE 4	1XAMP
MIOFREE 4MG	1X10T
MIOFREE 8MG	1X10T
MIOFREE-A 4MG	1X10S
MIOFREE-A 8MG	1X10S
MIPRO-P	200GM
MIRACAL D3 SYP	30ML
MIRACAL SYP 200ML	1x200xMl.
MIRACAL TAB 10*10	1x10xTab
MIRANO HAIR SOFTNER	100 ML
MIRFAST 15 TABLET	1X10
MIRFAST 30 10*10	1*10
MIRGLOW 30 TABLET	1X10
MIRNITE MT-15 TAB 10*10	1x10xTab
MIRNITE MT-30 TAB 10*10	1x10xTab
MIRNITE MT-7.5 TAB 10*10	1x10xTab
MIRNITE-15 TAB 10*10	1x10xTab
MIRNITE-30 TAB 10*10	1x10xTab
MIRNITE-7.5 TAB 10*10	1x10xTab
MIRTAZ 15 TAB 15*10	1*10TAB
MIRTAZ 30 TAB 5*10	1*10TAB
MIRTAZ 7.5 TAB 10*10	1*10TAB
MIRZA 15	1X10
MIRZA 30 MG TAB	1X10
MIRZA 7.5 MG TAB	1X10
MISO-200 1*4	1*4
MISOBIT 25	1X10T
MISOBIT 50	1X10T
MISOBIT MD 25	1X10T
MISOBIT MD 50	1X10T
MISOBIT PLUS 50	1X10T
MISOCLEAR TAB	1X4
MISOGEN 200MG TAB	1X4
MISOGEST TAB 200MG	1X4
MISOGYN 200 TAB 1*4	1*4TAB
MISOLUP TAB	1X4
MISONAC	1X10S
MISONAC SR	1X10S
MISONIL 200MCG	2X4T
MISOPROST 100 TAB	4
MISOPROST 200 TAB	4
MISOPROST 25	10'S
MISOPROST 600	1'S
MISOPT EYE DROP	1 PHY
MISTORAX 200MG	1X4S
MITEOUT 250 ML SPRAY	250 ML
MITO PLUS CAPSULES	1x10
MITONIC-L-SUSP	200ML
MITS LINTUS 100 ML	100ML
MITS LINTUS DX 100ml	100ml
MITS LINTUS DX 60ML	60ML
MIXOGEN INJ	1x1xAmp
MIXOGEN INJ.AMP.	1x1 ML
MIXOGEN TAB 50*10	1x10xTab
MIXOGEN TABLET	1x10
MIXTARD 30 FLEXIPEN	1*3*ML
MIXTARD 30HM PENFILL	1x3xMl.
MIXTARD 50HM NOVOLET	1x3xMl.
MIXTARD 50HM PENFILL	1x3xMl.
MIZOLAST TAB 10*4	1x4xTab
MK-500 VIAL	1vial
MK-CIN 100 VIAL	1vial
MK-CIN 250 VIAL	1vial
MKAST L SUS	60ML
MKASTE-FX TABS	1*10
MKASTE-L TABS	1*10
MKGEL SYU	170ml
ML-2D	1*10
MLEVO M SYP	1X30ML
MLEVO OZ SYP	1X30ML
MLEVO SYP	1X60ML
MM03 CAP 10*10	1*10CAP
MMA CAP	1X10
MMA DROP	30ML
MMA SYP	100ML
MMA SYP	200ML
MO-FLOREN BF DROP	5ML
MO-FLOREN EYE DROP	1*5ML
MO-FLOREN KT	1*5ML
MOBICAL* TABS	10'S
MOBICAM DT	1X10
MOBIGEL CREAM	25GM
MOBILE SP-TAB	1X12
MOBILI GEL OINT	1*15GM
MOBILI TAB	1*10
MOBISWIFT D TAB 450MG 10*10	1*10*TAB
MOBISWIFT D TAB 450MG 10*10	1*10*TAB
MOBIWOK INJ 10*2ML	1*2ML
MOBIWOK PLUS-8 CAP 5*8	1x8xTab
MOBIWOK-4 TAB 10*10	1x10xTab
MOBIWOK-8 TAB 5*10	1x10xTab
MOBIZOX TAB 15*10	1*10
MODLIP 10	1X10T
MODLIP 20 TAB	1X10T
MODLIP ASG 75	1X10C
MODLIP CAD	1X10C
MODLIP F TAB.	1X10 TAB.
MODUS-10MG TAB	10'S
MOFLA O SYP 60 ML	60 ML
MOFLA O TABLETS	1*10
MOFLOREN LP DROP	1*5ML
MOFLOX TZ 200/TAB.10'S/MR	M
MOFLOX-200MG.TAB.10'S/MC	M
MOFLOX-OZ TAB.10'S/MA	M
MOFULAG GRANULES 100 GR	100 GR
MOFULAG GRANULES 30 GR	30 GR
MOFULOG LIQUID 100 ML	100 ml
MOFULOG LIQUID 500 ML	500 ml
MOISOL DROP	1x5xMl.
MOISTE 50GM	1X50GM
MOISTUREX CREAM	1*100*GM
MOISTUREX CREAM 1*150GM	1*150*GM
MOISTUREX CREAM 1*150GM	1*150*GM
MOISTURIZING BABY SOAP 125GM	1*125GM
MOISTURIZING BABY SOAP 75GM	1*75GM
MOLAR LACTED PDPL 500ML	500ML
MOLINEA PLUS 60X60	1X2
MOLSLIDE-P.TAB	1X10
MOLUKAST KID	10
MOLUKAST L TABS	1*10
MOM PLUS SUSP.	1x100 ML
MOMACTIN ONT 15GM	1*15GM
MOMACTIN ONT 5GM	1*5GM
MOMATE CREAM 15GM	1TUBE
MOMATE CREAM 5GM	1TUBE
MOMATE LOTION 15ML	1X15ML
MOMATE S CREAM 10GM	1TUBE
MOMEFLO	1X10ML
MOMESONE 25GM	1x25xGm.
MOMESONE OINT 5GM	1x5xGm.
MOMESONE-T CREAM 10GM	1*10GM
MOMISOFT CREAM	1X15GM
MOMISOFT-F CREAM	1X10 GM
MOMOZ 30GM	1X30GM
MOMOZ F 10GM	1X10GM
MOMOZ S 15GM	1X15GM
MOMOZ T 10GM	1X10GM
MOMSAID P SY	60ML
MOMSTAR CREAM 10GM	1x10xGm.
MOMSTAR-T OINT	1x10xGm.
MONCITRA KID TAB	1*10
MONCITRA TAB	1*10
MONDESLOR	1X10T
MONET LC	30ML
MONEV-LC TAB	1*10
MONIT GTN 2.6 TAB 1*30	1*30TAB
MONIT GTN 6.4 TAB 1*25TAB	1*25
MONIT-10 TAB 20*10	1x10xTab
MONIT-10 TAB 20*15	1*15TAB
MONIT-20TAB 20*15	1*15TAB
MONIT-OD TAB 10*10	1x10xTab
MONIT-SR30 TAB 12*15	1*15TAB
MONIT-SR60 TAB 10*10	1x10xTab
MONITOR-3 TAB	1x6
MONITOR-4 TAB	1x6
MONIZOX TAB	1x10
MONKEZIN TAB 10*10	1*10*TAB
MONLEVO TAB	1X10
MONLEVO JUNIOR	1X10
MONNIHANS FORCEPS	1 PCS
MONO ISORDIL SR 30MG 10*10	1x10xCap
MONO ISORDIL TAB 20MG 10*10	1x10xTab
MONO SORBITRATE TAB 20 14*10	1x10xTab
MONOBACT 1.5GM	1XV
MONOBACT 375MG	1XV
MONOBACT 750MG	1XV
MONOBACT KID INJ	1X1V
MONOCEF INJ 125MG	1XV
MONOCEF INJ 1GM	1XV
MONOCEF INJ 250MG	1XV
MONOCEF INJ 500MG	1XV
MONOCEF O 50 SYRUP	30ML
MONOCEF O KID 50MG	1X10T
MONOCEF SB 1 GM	1X1 VIAL
MONOCEF SB 250 MG	1XV
MONOCEF-O 100MG	1X10T
MONOCEF-O 200MG	1X10T
MONOCEF-O CV 200	1X6S
MONOCEF-O CV D/SY	1X30ML
MONOCEF-O CV DT	1X6T
MONOCEF-O D/S 100MG	1X30ML
MONOCEF-O D/S 50MG	1X30ML
MONOCORTIL-10MG.TAB.10'S/MR	M
MONOCORTIL-20MG.TAB.10'S/MR	M
MONOCORTIL-5MG.TAB.10'S/MR	M
MONOCORTIL-M16 TAB.	1X10
MONOCORTIL-M4 TAB.	1X10
MONOCORTIL-M80 INJ.	2ML
MONODEC 25MG AMP	1 AMP
MONOFRESH (MOUTHWA)	100ML
MONOLOSIN TAB	1 TAB
MONOPAS	1X6T
MONOPAS GRANULES	1X100GM
MONOSPRIN 30 TAB 10*10	1*10TAB
MONOSPRIN 60 TAB 10*10	1*10TAB
MONOTRATE 10 TAB 20*10	1*10TAB
MONOTRATE 20 TAB 20*10	1*10TAB
MONOTRATE-OD 25 TAB 10*10	1*10TAB
MONOTRATE-OD TAB 10*10	1*10TAB
MONOTRATE-SR 30 TAB 10*10	1*10TAB
MONOTRATE-SR 60 TAB 3*10	1*10TAB
MONRO MD 25 TAB	1X10
MONRO MD 50MG	1x10
MONTAIR 10 MG TAB	10'S
MONTAIR 10MG	7'S
MONTAIR 4 MG	7'S
MONTAIR 5	10'S
MONTAIR 5 MG	7'S
MONTAIR FX TAB	10'S
MONTAIR GRANULES	100'S
MONTAIR LC	10'S
MONTAIR LC KID	10'S
MONTAIR LC KID SY	1PHI
MONTAIR PLUS KID	10 TAB
MONTAIR PLUS TABS	10'S
MONTAIR-4 MG TAB	10'S
MONTAZ 250MG	1XV
MONTAZ INJ 125MG	1X1V
MONTAZ INJ 1GM	VIAL
MONTAZ INJ 500MG	1XV
MONTECARLO SYRUP	60ML
MONTECARLO TAB	1*10
MONTECH-B TABLET	1*10
MONTECH-L TABLET	1*10
MONTEK-10 TAB 10*10	1*10TAB
MONTEK-4 TAB 1*10	1*10TAB
MONTEK-5 TAB 3*10	1*10TAB
MONTEK-LC TAB 10*10	1*10TAB
MONTEK-PLUS TAB 10*10	1*10TAB
MONTELAST 10MG	1X10
MONTELAST 4	1X10T
MONTELAST L	1X10T
MONTEMAC 10	1X10T
MONTEMAC 5	1X10T
MONTEMAC L KID	1X10S
MONTEMAC L SY	1X30ML
MONTEMAC PLUS	1X10S
MONTEMAC-4DT	1X10T
MONTEMAC-FX	1X10
MONTEMAC-L	1X10T
MONTEWIN-F	1X10T
MONTI FX TAB 5*10	1*10*TAB
MONTICOPE 30ML SYP	1*30ML
MONTICOPE 60ML SYP	1*60ML
MONTICOPE KID TAB 3*10	1*10TAB
MONTICOPE TAB 6*10	1*10TAB
MONTICOPE-A TAB 3*10	1*10TAB
MONTILEX KID SYP	60ML
MONTIWEN SYP	60ML
MONTO 2 KID TAB	1x10
MONTO 2 TAB	1x10
MONTO 3 TAB.	1X10TAB
MONTO 4 TAB.	1x2
MONTOKOF SYP 100ML	1x100xMl.
MONTOKUF PLUS SYP 1*100ML	1*100*ML
MONTONEX FORTE TAB.	1x10
MONTONEX KID TAB.	1x10
MONTORIP FORTE TAB.	1x10
MONTORIP KID TAB	1x10
MONTRAL KID TAB 5*10	1*10*TAB
MONTRAL SYP	1*60*ML
MONTRAL TAB 10*10	1*10*TAB
MONTUS BL	1X10
MONUROL SACHET 1*3GM	1*3GM
MOOD-ON CAP	1X10
MOOSLI PAK 125GM	125GM[34]
MOOSLI PAK 250GM	250GM[35]
MOOV GEL B.N.M.	15GM
MOOV GEL B.N.M.	30GM
MOOV OINTMENT	15GM
MOOV OINTMENT	25GM
MOOV OINTMENT	50GM
MOOV SPRAY	35GM
MOOV SPRAY	80GM
MOOV-24 TAB	1*10
MOPADAY HS TAB 10*10	1x10xTab
MOPADAY-15 CAP 10*15	1x15Cap
MOPADAY-30 CAP 10*15	1x15xCap
MOPRY OINT	1X5GM
MORAMOX-CV	1X30ML
MORCECAL 500	1X10
MORCECAL SYP	1X175ML
MORCLOX 500 MG {AA}	500 MG
MORDRIL 100 ML	100 ML
MORDRIL 100 ML	100 ML
MORECAL SYP 150 ML	150 ML
MORECAL TABS	1X15
MORECLOX CAPS	
MOREPLEX CAP	1X10
MOREVITAL SOFT CAPS	1X10 CAPS
MOREX AP 100 ML	100 ML
MOREXIM O TABS	1*10
MOREZOLE TAB	1 TAB
MOREZYME SYP	200 ML
MOREZYME TABS	10X10
MORFET CAP	1X15
MORFET Z SYP	200ML
MORGEL SYP	200ML
MORMOX DRY SYP	30 ML
MORMOX DT 125 MG	1X30
MORMOX DT 250 MG	1X10
MORMOX500 MG CAPS	1X10
MORNING AFTER PILL	1 STP
MOROFER 300 ML	300ML
MORPRAZOLE DSR CAP.	1*10
MORR 12.5% LOTION	1*60ML
MORR 7.5% 60ML	1*60ML
MORR FORTE SOL	1x60xMl.
MORR LOTION 60ML	1x60xMl.
MORR-3% LOTION	1x60xMl.
MORR-F LOTION 60ML	1*60ML
MORTILIV 200ML	1PH
MORZOL 20MG	1X10
MORZOL D TAB	1X10
MORZYME DROPS	15ML
MORZYME SYP	100ML
MORZYME SYP	200ML
MOSAFE TAB	1X10
MOSAGEN TAB	10'S
MOSI EYE DROP	1x5xMl.
MOSI-D DROP	1x10xMl.
MOSID MPS TAB	1X10T
MOSID OD TAB 10'S	1X10'T
MOSQUITO ARTERY 5"	1 PCS
MOSS E/D	1*10ML
MOSS PLUS E/D	1*10ML
MOSTCAL	1X10
MOTILIUM M TAB 30*10	1x10xTab
MOTINORM DROP	1PHI
MOUTH GAG	1 PCS
MOUZ CAP.	1X10
MOVACE 100	1X10T
MOVACE MR 4MG	1X10T
MOVACE MR 8MG	1X10T
MOVACE SP	1X10T
MOVACE-P	1X10T
MOVEXOL 0.25	1X10T
MOVEXOL 0.5	1X10T
MOVEXX-PLUS TAB	1x10
MOVICOL	
MOVIZ- 3D TABS	10'S
MOVIZ- XP TABS	10'S
MOVON CR TAB 10*10	1x10xTab
MOVON MR TAB 10*10	1x10xTab
MOVON P TAB 10*10	1x10xCap
MOVON TAB 10*10	1x10xTab
MOVORON INJ	3ml
MOVORON-30ML VIAL	30ml
MOVORON-GEL	30GRAM
MOVORON-P TAB	1x10
MOVORON-S TAB	1x10
MOX BD TAB 200MG 10*10	1x10xTab
MOX BD TAB 400MG 10*10	1x10xTab
MOX CAP 250MG 20*15	1x15xCap
MOX CAP 500MG 20*15	1x15xCap
MOX CLAV BD SYP	1x30xMl.
MOX CLAV DROP	1x10xMl.
MOX CLAV DS SYP	1x30xMl.
MOX CLAV INJ 1.2GM	1x1xVl.
MOX CLAV SYP	1x30xMl.
MOX CLAV TAB 625MG 1*10	1x10xTab
MOX CONNECTION	1 PCS
MOX CONNECTION PIPE	1 PCS
MOX INJ 250MG 1*1	1*1*VAIL
MOX INJ 500MG	1x1xVl.
MOX KID TAB 125MG 30*15	1x15xTab
MOX KID TAB 250MG 30*15	1x15xTab
MOX P TAB 500MG 10*15	1*15*TAB
MOX R.M.SYP 125MG 30ML	1x30xMl.
MOX R.M.SYP 125MG 60ML	1x60xMl.
MOX R/M DR	1x10xMl.
MOX SERVICE	1 SET
MOX SYP 30ML	1x30xMl.
MOX SYP 60ML	1x60xMl.
MOXAL 500 TAB	1x10
MOXAL PLUS CAP	1X10
MOXAM	1X5T
MOXAM I.V 400MG	1X100ML
MOXBRO 250 MG.	1x10
MOXBRO 500 MG.	1x10
MOXBRO DRY SYP	1x60ML
MOXCENT 0.2MG TAB.	1X10
MOXCENT 0.3MG TAB.	1X10
MOXEF INJ 2 GR	2 GR
MOXEF INJ 250 MG	250 MG
MOXEF INJ 3GR	3 GR
MOXEL 2.5 GR	2.5 GR
MOXEL 2GM.	VIAL
MOXEL 3GM.	VIAL
MOXEL 4 GR	4 GR
MOXEL 500MG.	VIAL
MOXEL 600 MG	600 MG
MOXEL D 2.5 GR	
MOXEL D 3 GR	3 GR
MOXEL D 4 GR	
MOXEL D 4 GR	
MOXEL D 500 MG	500 MG
MOXIBIOTIC 3 GR	
MOXIBIOTIC 300 MG	
MOXIBIOTIC S 3 GR	3 GR
MOXIBLU 0.5%	1X1
MOXIBLU-D 0.5%	1X10ML
MOXIBLU-KT E/D	1X5ML
MOXICIP 400MG	1X5
MOXICIP DROP	1PHI
MOXICIP EYE OINT	1TUB
MOXICIP IV	1BOT
MOXICURE 3GM	VIAL
MOXICURE 500MG	VIAL
MOXIF 400 TAB	1X5
MOXIF IV	1X100ML
MOXIFAX DROP	1PH
MOXIFAX DROP	1X5ML
MOXIFEX EYE OIT	1X5GRM
MOXIFORC CV SYP 30ML	1*30ML
MOXIFORCE-CV 375 TAB 4*6	1*6TAB
MOXIFORCE-CV KID TAB 4*6	1*6TAB
MOXIFORCE-CV-625 TAB 4*6	1*6TAB
MOXIGEM CV 625	1*6
MOXIGEM CV DRY SYP	30ML
MOXIGEM-625	1X6T
MOXIGOOD TAB 20*5	1*5*TAB
MOXIGRAM EYE DROPS	1X5 ML
MOXIGRAM I.V. 100ML	1*100*ML
MOXIGRAM TAB 10*5	1*5*TAB
MOXIGRAM-P EYE DROP	1X5 ML
MOXIKIND PLUS CAP 6*10	1*10*CAP
MOXIKIND-250 TAB 6*10	1x10xTab
MOXIKIND-500 TAB 6*10	1x10xTab
MOXIKIND-CLAV 3.6 GM	VIAL
MOXIKIND-CV 375 4*6	1x6xTab
MOXIKIND-CV 625 4*6	1x6xTab
MOXIKIND-CV DROP 10ML	1*10ML
MOXIKIND-CV KID TAB 6*6	1x6xTab
MOXIKIND-CV SYP 30ML	1x30xMl.
MOXIKIND-DXL	4GM
MOXIKIND-DXL3GM	3GM
MOXIKIND-TZ TAB 3*10	1x10xTab
MOXIKIND-XL 3GM	3GM
MOXIKIND-XL 4GM	4GM
MOXILA-375 TAB	1x10
MOXILA-625 TAB	1x10
MOXILA-DRY SYP	1x30ML
MOXILANIC DROPS	10ML
MOXILANIC-625 TAB	1x6
MOXILONG TAB 0.2MG 3*10	1*10*TAB
MOXILONG TAB 0.30MG 3*10	1*10*TAB
MOXIMAC	1X10T
MOXIMAC EYE DROP	1X5ML
MOXIMAC IV	1X100ML
MOXIMON 500 1*10	1*10
MOXIMON 60 60ML	60ML
MOXIN EYE DROP	5 ML
MOXIN KT	1*5ML
MOXIN LP	
MOXIPUNCH 400 TAB	1*5
MOXISEN EYE DROP	5ML
MOXISEN-CV625 TAB	1*6
MOXIVISION EYE DROP	10ML
MOXIWEN EYE DROPS	5ML
MOXMENTIN 625 TAB	1X10
MOXOCARD 0.2	1X10T
MOXOCARD 0.3	1X10T
MOXON-CV LB	1*10
MOXOVAS 0.2	1X10T
MOXOVAS 0.3	1X10T
MOXOVAS A	1X10T
MOXOVAS H	1X10T
MOXVAR 125 KID	1*10
MOXVAR 250 CAP	1*10
MOXVAR 500 CAP	1*10
MOXYCARE DRY SYP	1X30ML
MOXYCARE-625TAB	1X6
MOXYCLOX 3GR	1x3GR
MOXYLAC 125MG DT	1x10TAB
MOXYLAC 250MG CAP	1x10CAP
MOXYLAC 250MG DT	1x10TAB
MOXYLAC 500MG CAP	1x10CAP
MOXYLAC-DX CAP	1x10
MOXYLAR 1000 MG. TAB	1x10
MOXYLAR 250 MG. TAB	1x10
MOXYLAR 400 MG. TAB	1x10
MOXYLAR 500 MG. TAB	1x10
MOXYLAR 600 MG. TAB	1x10
MOXYLAR 800 MG. TAB	1x10
MOXYLAR DROP	1 PH.
MOXYLAR SYP.	1 PH.
MOXYZYME SYP	200ML
MOZA PLUS CAP 10*10	1x10xCap
MOZA-5 TAB 21*10	1x10xTab
MOZA-MPS TAB 15*10	1x10xTab
MOZA-SR TAB 10*10	1x10xTab
MOZAC TAB.10'S/MC	M
MP-LONE-6MG	1*10
MP3 INJ 100ML	
MP3 INJ 30ML	
MPENEX 500MG	1 PCS
MPLOX - LB CAP	1X10
MPOWERVIT TAB	1*10
MPX CV 1.2 VIL	1X1
MPX CV 300MG VIL	1X1
MPX CV 375	1X10
MPX CV FORTE DRY SYRUP	30ML
MPX CV KIT DT	1X6
MPX CV SYP	1X30
MPX-CV 625	1X6
MRESTOR-FR	1*10
MSBETA 12	1X10
MSBETA 6	1X10
MSHECURE BOLUS	1 STRIP
MT PILL	1 TAB
MT-WORM TAB	1x1
MTAZ CREAM	1*15*GM
MTP KIT	1 KIT
MTPROST KIT	1KIT
MTRIN 10MG	1X10
MUCAINE GEL	1x200xMl.
MUCARYL PLUS SYP	1X100ML
MUCARYL-AX SYP 100ML	1X100ML
MUCINAC 600 TAB	10'S
MUCINAC INJ 2ML	1AMP
MUCO X SY	1PHI
MUCOBRON 250MG.	1X10
MUCOBRON 500MG.	1X10
MUCOCLAV 625	1X6S
MUCOCLAV D/S	30ML
MUCOGEN TAB 10'S	1X10
MUCOLITE DROP	1x15xMl.
MUCOLITE SR TAB 10*10	1x10xCap
MUCOLITE SYP	1x100xMl.
MUCOLITE TAB 36*10	1x10xTab
MUCOMELT-A TAB	1x10
MUCOMELT-FORTE TAB	1x10
MUCOMELT-XP SYRUP	100ML
MUCOMIX 600 MG TAB	1 STP
MUCOMIX INJ 400MG 2ML.	2 ML.
MUCOMIX SYRUP 100ML	1 PCS
MUCOMIX TAB	10 TAB
MUCOPRES SY	1PHI
MUCORIS PED DROP 0.05%	1*5ML
MUCORIS-ADULT DROP 0.01%	1*5ML
MUCOS EXTTRACTOR	1 PCS
MUCOTAB PLUS CAP 3*10	1*10*CAP
MUCOTAB TAB 10*10	1*10*TAB
MUCOUS EXTRACTOR	1 PCS
MUCOVENT SYP	1x100ML
MUCRASE SYRUP 100ML	
MUCUS EXTRACTOR	1 PCS
MULMIN DROP	1 PH.
MULMIN F CAP	1x10
MULMIN INJ	1 AMP.
MULMIN PLUS CAP	1x10
MULMIN PRO 200GM	1x200GM
MULMIN SYP.	1 PH.
MULTANI MATTI	1 KGS
MULTI POWER 200ML SYP	1
MULTIBERRY SYRUP	1x200ML
MULTICACH 200ML	200
MULTICARE BOLUS	1*4
MULTICLAV 228.5 SY	1X30ML
MULTICLAV 375	1x6S
MULTICLAV 625	1X6S
MULTICLAV KID	1X10T
MULTILOAD 250	1x1xPc.
MULTILOAD 375	1x1xPc.
MULTILOAD CU 250	1 Pc
MULTILOAD CU 375	1 Pc
MULTIPOWER CAP	1x10
MULTIPOWER DROP	1PH
MULTIPOWER.100ML.	1PH
MULTIRICH CAP	1x10
MULTIROSE 200ML	200ml
MULTISAFE.DROP.	1PH
MULTISTAR LIQ	500ML
MULTISTAR LIQ.	100 ML
MULTITAK SYP	200ML
MULTIVA CAP	1X15
MULTIVA.DROP	1PH
MULTIVET 50 ML	50 ML
MULTIVET INJ 30 ML	30 ML
MULTIVIT DROP	1*1
MULTIVIT.200ML.SYU	1PH
MULTIVITA	
MULTIVITA.100ML.SYU	1PH
MULTIVITAL.CAP	1X7
MULTIVITE GOLD	1X15
MULTIVITE CD (SOFT GEL)	1X15C
MULTIVITE FM OMEGA	1X30
MULTIVITE FM OMEGA(S GEL)	1X30C
MULTIVITE GOLD (SOFTGEL)	1X15C
MULTIVITE VISION	1X15
MULTIVITE VISION(SOFTGEL)	1X15C
MULTIVITE WOMAN	1X15
MULTIVITE WOMAN(SOFTGEL)	1X15C
MULTIWINTA CAP	1x10
MUMFAR TAB	1X10
MUMFER DROP	1PH
MUMFER SYP 150ML	150ML
MUMFER Z TAB	1X10
MUMFER- F TAB	1X10
MUNNAKOF SYP	1X100ML
MUNOMYCIN FORTE	VIAL
MUPIMET CREAM	1X5GR
MUPIRON OINT	1*5*GM
MUPRICON OINT	1x5xGm.
MUPRICON-FM OINT	1x5xGm.
MUSAFIR WATER FILTER	1x1PIS
MUSCAL FORTE (1*30)	1*30
MUSCODAC GEL	1x30xGm.
MUSCODAC TAB 10*10	1x10xTab
MUSCODAC-MR TAB 10*10	1x10xTab
MUSCODEC GEL	30GM
MUSCODEC TAB	1*10
MUSCOFLEX TAB	1*10
MUSLAX OIT	1 TUB
MUSTAKARISHTRA 450	1PH
MUSTONG TAB 3*20	1x20xTab
MUTIMAX-Z SYRUP 200 ML	1X200 ML
MUTIVIT Z SYRUP 200 ML	1X200 ML
MUTIVIT-Z CAPSULES	1X10
MUTIVIT-Z SYRUP	1X100 ML
MUVUP TAB	1X10
MUVUP-MR 10*10	1*10
MVI AMP MARTIN BROWN	1AMP
MVITAL 200ML SYP	1*200ML
MVITAL-100ML SYP	1*100ML
MYAMLO AT TAB	1X10
MYBEND SYP	10 ML
MYC0TIC EAR DROP	5ML
MYCET-10MG TAB	1X10
MYCIDEX EYE DROP	1 VIAL
MYCLAV 375	1X10
MYCLAV 625	1X10
MYCLAV SYP 30ML	1X60ML
MYCLIN EYE DROP	1*10ML
MYCLIN-O DROP	1*5ML
MYCOBAL FORT TAB.10'S/MC	M
MYCOBAL INJ.1ML/MC	M
MYCOBAL PLUS 2ML/INJ/MC	M
MYCOBAL PLUS TAB.10'S/MC	M
MYCOBAL TAB.10'S/MC	M
MYCOBET-GM	10 GR
MYCOBUTOL TAB 400MG 10*10	1x10xTab
MYCOBUTOL TAB 600MG 10*10	1x10xTab
MYCOBUTOL TAB 800MG 25*10	1x10xTab
MYCOCCL IN CREAM	20 GM
MYCOCCL IN LOTTION	
MYCODERM (C) POWDER	1x100*GM
MYCODERM POWDER	1x100xGm.
MYCODERM POWDER 150GM	1*150GM
MYCOMIN PLUS CAP	1X10
MYCONAT DROP	1PH
MYCONIL POWDER 100 GR	100 GR
MYCOPAS GRANUALS	100GM
MYCOPAS TAB	1X10T
MYCOSPOR CREAM	1X10GM
MYCOSTAT 800	1X10T
MYCOTUSS SYP	100ML
MYCOTUSS-DX SYP	100ML
MYDERM 5 GR	5 GR ML
MYDRYL 100 ML	100 ML
MYDRYN EYE DROP	1*5ML
MYELOGEN FORTE CAP	1x10
MYELOGEN PG 7.5 TAB	1x10
MYELOGEN POWDER	1x200 GM
MYFERIN XT SYP 150ML	1*150ML
MYFERIN XT TAB 10*10	1*10TAB
MYGLO CAP 10*10	
MYGLO SYRUP 200 ML	
MYHALER	1XINH
MYHALER DEVICE	1XSET
MYLAMIN	1X10S
MYLO TAB	1x10
MYLOXIN D SPARY	35GM
MYLOXIN OINT	15GM
MYLOXIN-D OINT	15GM
MYNBURRY'S COMPOUND	1 PH.
MYNURON 500MG TAB	1X10
MYNURON TAB	1*10
MYO-PYROLATE	1 AMP
MYOCYST SACHET 30*3GM	1*3GM
MYOGREL AP 150 6'S	1X6
MYOGREL AP 75	1X6
MYOLAXIN ONT 30GM	30GM
MYOLAXIN-D GEL	15GM
MYOLIN OIL	1X60ML
MYONAC-IV	VAIL
MYONAC-MR TAB	1*10
MYONAC-NT TAB	1*10
MYONAC-P TAB	1*10
MYONAC-SP TAB	1*10
MYONE DEPOT INJ 1ML	1*1ML
MYONIT 5ML AMP	1 VIAL
MYONIT INSTA TABLET	1X30
MYONIT SR 2.6TAB	1X30
MYONIT SR 6.4 TAB	1x30
MYOPROL XL 100MG	1X10T
MYOPROL XL 50MG	1X10T
MYOPROL-XL 25 MG	1X10T
MYOPROL-XL AM 50/5MG	1X10S
MYOPROL-XL H 50/12.5	1X10S
MYORIL 4	1X10C
MYORIL 8	1X10C
MYORIL INJ	1X1ML
MYORIL PLUS 4	1X10C
MYORIL PLUS 8	1X10C
MYOSONE	1X10S
MYOSONE PLUS	1X6S
MYOSONE SR	1X10T
MYOSPAS D TAB	1*10
MYOSPAS FORTE 1*10	1*10
MYOSPAS TAB 1*10	1*10
MYOSPAS TH4	3*10
MYOTOP -450 SR	1X10T
MYOTOP P	1X10T
MYOTOP-150	1X10T
MYPANT-D TAB	1X10
MYPAR SUSP	60 ML
MYPAR TABS	1X10
MYPILL TAB	1X21
MYPRED 1GM	1 VAL
MYPRED-125 INJ	1 VAL
MYPRED-40 INJ	1 VAL
MYPRED-500 MG	1 PCS
MYSIP LIQUID	200ML
MYTIC INJ	2ML
MYTIC SYP 30ML	30ML
MYTIC-MD TAB	1x10
MYTRIP PLUS TAB	1X10
MYTXIM-100 TAB	1x10
MYTXIM-O SYU	30ml
MYTXIM-O 200 TAB	1x10
N ABLE SYP 50MG	1*30*ML
N ABLE TAB 200MG 10*10	1*10*TAB
N T ZOLE BOLUS	1X4
N T ZOLE SOAP	1X1
N V TAB.	1x10
N-CID 170ML	170ML
N-FLOX D EYE DROP	1x10ML
N-FLOX EYE DROP	1x10ML
N-FLOX TZ TAB	1x10TAB
N-GESIC 15ML	1X15ML
N-GESIC 50ML	1X30ML.
N-GESIC VIAL	1VIAL
N-LIV 200ML	200ML
N-TRA 5MG TAB	1X10
N-ZER 200ML	200ML
N. T.NATAL 250	1ML
N. T.NATAL 500	1ML
N.P.GESIC SYP	60ml
N.P.GESIC TAB	1X10
N.S. 500 ML (P)	500 ML.
N.S.10ML.	10ml
N.T.Z.TAB	1X6
N.T.ZTAB	1x10
N/10 HYDROCLORIC ACID	500 ML.
N2O A TYPE CYL (NEW)	1 PCS
N2O A TYPE CYL(FAULTY)	1 PCS
N2O A-TYPE CYL	1 CYL
N2O AA-TYPE CYL	1 CYL
N2O D TYPE BULK CYL (NEW/EMPTY)	1 CYL
N2O D-TYPE BULK CYL	1 CYL
N4N TAB	1X10
NABLE A DS SYP	1*30*ML
NABLE A TAB 375MG 10*6	1*10*TAB
NABLE A TAB 625MG 10*6	1*6*TAB
NAC -50 MG TABS	10'S
NAC AQ INJECTION	1ML
NAC GEL	1'S
NAC INJ	3 ML
NAC PLUS TAB	10'S
NAC SR 100	1X10T
NAC SR 75	1X10T
NAC SR- 150MG TABS	10'S
NACFIL TAB	1X10
NACIVENT TAB.10'S	1X10
NACL-5 EYE DROP	1x5 ML.
NACTAL TAB 10*10	1x10xTab
NADIBACT 10GM	1TUB
NADIKEM CREAM	1X10GM
NADIMIX CREAM	1*7.5GM
NADISKIN CREAM 10GM.	10GM
NADOXIN-C OINT	1x10xGm.
NADOXYN OINT	1x10xGm.
NADOXYN POWDER	1x10xGm.
NADROSOL-25 INJ	1*1
NADROSOL-50 INJ	1*1
NAF	1X30
NAFODIL TAB 10*10	1*10TAB
NALFY 10 MG INJECTION	1 AMP
NALFY 20 MG INJECTION	1 AMP
NALGIS SYP	1x60 ML
NALGIS TAB	1x10
NALOX .4 MG/ML INJ	5:00 AM
NALTIMA 50 TAB 1*10	1x10xTab
NAM P TABLET	1X10
NAMCOLD FORTE SYP	1X60ML
NAMCOLD L TAB	1x10
NAMCOLD SYP	1X60ML
NAMCOLD TAB	1X10
NAMCOLD-NS-AD DROP	1X10ML
NAMCOLD-NS-DROP	1X10ML
NAMCOLD-ORAL DROP	1X15ML
NAMCOLD-Z SYP	1X60ML
NAMPLUS TAB	1X10
NAMSAFE SYP	1X60ML
NAMSAFE TAB	1X10
NAMSAFE-KID TAB	1X10
NANCO EYE DROP	VAIL
NANDROSPEY INJ KIT 50mg	1
NANO NISE SYU	60ML
NANO NISE TAB	1X15
NANO- P SUSP	60ML
NANO-NISE 30ML	30ML
NANOCOLD 60ML	60ML
NANOCOLD DROP 10ML	10ML
NANODRYL 100 ML	100ML
NANOKOF 100 ML	100ML
NAPILEX SYP 100ML	1*100ML
NAPPY PAD	1
NAPPY PAD 16*20	16*20
NAPPY PAD 32x10	1
NAPPY PAD 64x6	1
NAPROSYN P TAB 20*10	1*10*TAB
NAPROSYN P TAB 550MG 20*10	1*10*TAB
NAPROSYN SR TAB 10*10	1*10*TAB
NAPROSYN TAB 250MG 20*15	1*15*TAB
NAPROSYN TAB 500MG 10*15	1*15*TAB
NARAYANI CHURN 250.	PH
NARI JIWAN 227ML	1
NARI JIWAN 455ML **	1
NARICARE 200ML	1*200ML
NARICARE 400ML	1*400ML
NARVION TAB	1*10
NASELIN NASEL	10ML
NASIVION AD NASAL SPRAY	1x10xMl.
NASIVION MINI DROP	1x10xMl.
NASIVION PD DROP	1x10xMl.
NASIVION S DROP	1x10xMl.
NASOCLEAR GEL	1*1
NASOCLEAR N DROP 20ML	1PH
NASOCLEAR PLUS DROP	1X15ML
NASOCLEAR-ALEO GEL	1TUBE
NASOCLIN	10ML
NASOL NASAL	1*10ML
NASOLIN JR.	10ML
NASOPHARYNGEAL AIRWAY	1 PCS
NASOPHARYNGEAL AIRWAY 8	1 PCS
NASOPHARYNGEAL AIRWAY 8.5	1 PCS
NASOREST PLUS TAB 10*10	1*10*TAB
NASORYL TAB	1x10
NASOWIKORYL NASAL DROP 0.10%	1*10*ML
NASOWIKORYL PED NAS.DR 0.05%	1*1*PH
NATA DROP	1PHI
NATACIN E/D	1*5ML
NATAFORCE EYE DROPS	1*5ML
NATAMET 5% SYP 3ML	1*3ML
NATCAL-D3 TAB 10*10	1*10TAB
NATCOF LIQUID	300 ML
NATIVE C-200MG	1X10CAP
NATIVE C-400MG	1X10T
NATRALKA SYP	1x100 ML
NATRIEM 30 TABLET	1x10
NATRIEM 60 TABLET	1x10
NATRILIX SR TAB	1X10
NATRISE TAB 1*4	1*4TAB
NATRISE-30 TAB 1*4	1*4TAB
NATRON 200 TAB	1X10
NATURAL BATISA	50GM
NATURAL BATISA 1KG	1KG
NATURALIV LIQ.	1 LTR
NATURE SWEET	90 TAB
NATURECARE 100 GMS D/A	1PH
NATUROGEST CAP 100MG 10*10	1*10*CAP
NATUROGEST CAP 200MG 10*10	1*10*CAP
NATUROGEST INJ 100MG 10*2ML	1*2*ML
NATUROGEST INJ 200MG 10*2ML	1*2*ML
NATUROGEST VT TAB 200MG 10*10	1*10*TAB
NATUROLAX GR 100 GM	1x100xGm.
NATUROLAX GR 300 GM	1x300xGm.
NATUROLAX POWDER	1x300 GM
NATVIE C-400MG(FOOD)	1X10
NATVIE FORT CAP	1X10
NAUNEHAL SYP	100ML
NAUSDOME DROP	1PH
NAUSEAFREE	10'S
NAUSEHEXT	1X10T
NAUSIFAR MPS TAB	1x10
NAUSIFER MPS TAB 50*10	1x10xTab
NAUSIHEXT INJ	1X2ML
NAVALIN 200	1X10T
NAVALIN 300	1X10T
NAVALIN 500	1X10T
NAVALIN CHRONO 200	1X10T
NAVALIN CHRONO 300	1X10T
NAVALIN CHRONO 500	1X10T
NAVGUN DROP	30ML
NAVRATAN OIL	100ML
NAVRATAN OIL	200ML
NAVRATAN OIL	300ML
NAVRATNA OIL	50ML
NAXDOM 250 TAB 5*10	1*10TAB
NAXDOM 500 TAB 5*10	1*10TAB
NAXEN CR TAB	1X10
NAZE 200 TAB 10*10	
NAZE SR 200 TAB 10*10	
NAZODROP	1X10ML
NAZOMAC-AF	1XSPRAY
NAZOMAC-F	1XSPRAY
NAZOMAK M	1XSPRAY
NAZON NASAL SPRAY 1*100ML	1*100*ML
NAZONE NASAL DROP	1*10*ML
NAZOPAR NOSAL DROP	10ML
NAZOPAR-S NASAL SPRE	10ML
NBE PLUS BOLUS	1x6
NC-DERM+	15GM
NCC-COLD TAB	1X10
ND+IB 1000 DS	1000 DS
ND+IB 500 DS	500DS
NDC 25	1X1
NDC 50	1X1
NDR-25 INJ	1*1ML
NDVH 250 DS	250 DS
NDVH 1000 DS	1000DS
NDVH 500 DS	500 DS
NE 200 CAP 10*10	1x10xCap
NE 400 CAP 10*10	1x10xCap
NE C TAB 10*10	1*10*TAB
NE POWDER 200GM	1*200*GM
NEBASULF POWDER	1*1
NEBI 2.5	1X10T
NEBI 5	1X10T
NEBI-AM	1X10T
NEBI-H	1X10T
NEBICARD 2.5MG	1X10
NEBICARD H TAB	1X10
NEBICARD SM	1X10T
NEBICARD-5MG TAB	1X10
NEBICIP 2.5	1X10
NEBICIP 5	1X10
NEBIMAC 2.5MG	1X10T
NEBIMAC 5MG	1X10C
NEBIMAC-H	1X10C
NEBINAX-2.5MG TAB	1X10
NEBINAX-5MG TAB	1X10
NEBIPIL 2.5MG	1X10T
NEBIPIL 5MG	1X10T
NEBIPIL H	1X10T
NEBIPIL-SA	1X10T
NEBIRING 5 TABLET	1X10
NEBISTAR 10	1X10T
NEBISTAR 2.5	1X10T
NEBISTAR 5	1X10T
NEBISTAR SA	1X10T
NEBISTAR-H	1X10T
NEBITROY 5MG 10*10	1*10
NEBITROY H 10*10	1*10
NEBLON 100GM	100GM
NEBLON 100GM	PH
NEBRACIN EYE DROP	1*5ML
NEBRACIN OINT.	1*3GM
NEBRACIN-DM DROP	5ML
NEBRACIN-F	1*5ML
NEBULILIZER KIT (A) PARAMOUNT	1 PCS
NEBULIZER	1 PCS
NEBULIZER "E MED"	1 SET
NEBULIZER (DR.MORPEN)	1 SET
NEBULIZER AEROMAC	1 PCS
NEBULIZER NUNEB PRO	1 PCS
NEBULIZER RESPICARE	1 PCS
NEBULIZER SERVICE	1 SET
NEBZMART B 0.5	1*7
NECK $ SOULDER CRE	20GM
NECRID TUBE	1X15T
NECTERA POW.	1X90GM
NECTRA POWDER	1x3GM
NEDAX-5 LOTION	40GM
NEDEC-25	1AMP
NEE DT	1X10
NEED CAP	1X10
NEED XT SYRP 200ML	1*1
NEEDLE 22	1 PC.
NEEDLE 23	1 PC.
NEEDLE 24	1 PC.
NEEDLE 26	1 PC.
NEEDLE DESTROYER	1 PCS
NEEDLE DESTROYER REPAIR	1 PCS
NEEDLE DISPO 24	1 PCS
NEEDLE FOR PRICKING	1 PCS
NEEDLE FOR PRICKLING	1 PCS
NEEDLE HOLDER 6" ST & CRB	1 PCS
NEEDLE HOLDER 8" ST & CRB	1 PCS
NEEDLE SAFTI 22	1 PCS
NEEDLE VET 18X0.5 "	1
NEEDLE VET.DISPO 18X1X1/5	1x12.
NEEDLES 23 DISPOVAN	1 PCS
NEEDLES DISPO VAN 26	1 PCS
NEEDLES SAFTI 23	1 PCS
NEEDLES SAFTI 24	1 PCS
NEERI 100 ML.	100 ML.
NEERI 200 ML SYP.	1*200 ML
NEERI TAB (1*30)	1*30
NEETAM SYP 100ML	1*100ML
NEFDYL 100ML	100ML
NEFDYL-50ML	50ML
NEFROSAVE FORT TAB	1X10TAB
NEFROSAVE TAB	1X10
NEFROZEN TAB 3*10	1*10TAB
NEGASUNT 20GM	1X20GM
NEGASUNT 40 gm	PH
NEKO BOUQUET SHOP 75GM	1PICE
NEKSIUM 20 1*7	1*7
NEKSIUM 40 1*7	1*7
NEL	15ML
NEL CATH 8"	1 PCS
NEL CATH FG 06	1 PCS
NEL CATH FG 10	1 PCS
NEL CATH FG 12	1 PCS
NEL CATH FG-14	1 PCS
NEL CATH FG-16	1 PCS
NEL PLUS TAB	1X10
NEL- MR TAB	1X10
NEL-100 TAB	1X10
NEL-N TAB	1X10
NEL-PLUS SYU	60ML
NELATON CATHATER 14	1 PCS
NELATON CATHATER 18	1 TAB
NELBACT	5GM
NELBRO SYRUP	100ML
NELBRO-D SYRUP	100ML
NELCET 60ML	60ML
NELCID SUS	200ML
NELCID-O SUS	200ML
NELDAN 30ML	30ML
NELDEN 2ML	2ML
NELDRAL 25MG AMP	1ML
NELDRAL 50MG AMP	1ML
NELGEN TAB 1*9	1*9
NELITRA-100	1*10
NELITRA-200	1*10
NELMET-500 TAB	1*10
NELMINO SYP	200ML
NELNAC -S TAB 1*10	1*10
NELNAC MR 1*10	1*10
NELNAC-100 1*10	1*10
NELNEC 200 SR 1*10	1*10
NELNEC-P 1*10	1*10
NELPOD 200	1X10TAB
NELPOD-CV 50MG SYP	1 PH
NELTAL CAP 1*10	1*10
NELVIT DROP	15 ML
NELVIT SYRUP	200ML
NELZYME DROP	1PH
NELZYME SYP 100ML	1 PH
NELZYME SYP200ML	1PH
NELZYME TAB 1*10	1*10
NEMO 100 TAB	1X10
NEMO 60ML SYP	1
NEMO KID TAB	1X10
NEMO PLUS SYP	1X60ML
NEMO-FEN CAP	1X10
NEMOCID SYP	1x10xMl.
NEMOCID TAB 10*3	1x3xTab
NEMOCLOX VET POWDER	1X50GMS
NEMOLIDE-PLUS.TAB	1X10
NEMU P SYRUP	60ML
NEMU SUSPENSION	1'S
NEMU-P TABS	10'S
NEO HEPATEX 10 ML. VIAL	1 VIAL
NEO HEPATEX 2 ML. AMP.	1 AMP.
NEO MERCAZOLE TAB 10MG	1x100xTab
NEO MERCAZOLE TAB 20MG	1*100*TAB
NEO MERCAZOLE TAB 5MG	1x100xTab
NEO TAB	1X75T
NEO-CORDIAL SYP	1x200 ML
NEO-CORDIAL SYP 450ml	1x450 ML
NEOBLOOM BOLUS	1X4BOLUS
NEOCALM PLUS TAB 20*10	1x10xTab
NEOCHLOR 30 ML	VIAL
NEOCHLOR FORTE 50 GM.	PH
NEOCHLOR FORTE 50 GM.	PH
NEOCID SYP.	1*170ML
NEOCIP.250MG.TAB	1X10
NEOCYCLIN BOLUS.	1x4B
NEODEX SYU	200ml
NEODOX BOLUS	TAB
NEODOX FORTE 50 GM.	1x50GM
NEODOX FORTE 50 GM.	1x50GM
NEOFAX TAB	1*3
NEOFORTAN D TAB.	1X10 T
NEOGADINE ELIXIR	1x300 ML
NEOGADINE MIKROS	1x100 ML
NEOGADINE SG SYRUP	1x300 ML
NEOMAC 10ML	10ML
NEOMAC 50ML	50ML
NEOMAC SX 10ML	10ML
NEOMEC INJ.1ML.	1ML
NEOMEC INJ.20 ML	20 ML
NEOMEC INJ.7ML	7 ML
NEOMECTAB	
NEOMET 4 MG	1 2ML
NEOMYCIN.OIT	1PH
NEOPAM VAIL	2VAIL
NEOPAN FORT	1X10TAB
NEOPAN FORT TAB	1X10
NEOPAN TAB	1X10
NEOPAR MD 1*10	1*10
NEOPEP SYP 60ML	1PH
NEOPEP.DROP	1PH
NEOPEPTINE CAPSULES	1x10
NEOPEPTINE DROPS	1x15 ML
NEOPEPTINE LIQUID	1x100 ML
NEOPEPTINE LIQUID	1x60 ML
NEOPRENE KNEE BRACE	1 PCS
NEOPRIDE INJ 3*2ML	1*2ML
NEOPRIDE MPS TAB 10*10	1*10TABt
NEOPRIDE TAB 10*10	1*10*TAB
NEOPRIDE TOTAL CAP 10*10	1*10CAP
NEOPRIDE-50 TAB 10*10	1*10TAB
NEOPRIDE-SR TAB 10*10	1*10TAB
NEOPROFEN 100 ML	100 ML
NEOPROFEN 15ML	15ML
NEORELAX A TAB 4MG 10*10	1*10*TAB
NEORELAX MR TAB 4MG 10*10	1*10*TAB
NEORELAX MR TAB 8MG 10*10	1*10*TAB
NEOREX JUNIOR 60ML	1*60ML
NEOSORALEN FORTE TAB	1*10
NEOSPORIN	1 PCS
NEOSPORIN OINT	5GM
NEOSPORIN POWDER	1 PCS
NEOSPORIN POWDER	10GM
NEOSPORIN SKIN OINT	20GM
NEOSPORIN-H DROP	5ML
NEOSPORIN-H OINT	5GM
NEOSULF H EAR DROP	5ml
NEOSULF-H POWDER	10gm
NEOSULIDE SUS	1x60ML
NEOSULIDE PLUS SUS	1x60ML
NEOSULIDE PLUS TAB	1x10
NEOSULIDE PLUS TAB	1x10
NEOSULIDE TAB	1x10
NEOTRXATE TAB	10
NEOVAC 4MG INJ	5:00 AM
NEOZEET EXPT	1x60xMl.
NEOZIDE BOLUS.[HAWA]	1X4B
NEOZIDE PLUS 4BOLUS	4BOLUS
NEOZIDE PLUS SUS.	90ML
NEOZIDE SUSP 90 ML.	PH
NEOZIDE SUSP. 1000ML	1 LITER
NEPABLU	1X5ML
NEPACHEK DROP	5ML
NEPAFLAM E/D	1*5ML
NEPAFLAM OD	1.7 ML
NEPALACT DROP	1*10ML
NEPATOP EYE DROP	1*5ML
NEPCURE EYE DROP	5ML
NEPHONE E/D	1 10M
NEPHROCAPS CAP	1X15
NEPOCLOX VET INJ 4GMS	VIAL
NERV DX 20	1X10C
NERVE DX 30	1X10C
NERVERICH AMP 5*2ML	1x2xMl.
NERVERICH CAPS 10*10	1x10xTab
NERVIBRAIN 100MG CAP	1X10
NERVIC + INJ	1AMP
NERVIC G TAB	1*10
NERVIC P CAP	1*10
NERVIC PLUS TAB	1*10
NERVIC SYP	200ML
NERVIC SYP 200ML	200ML
NERVIC TAB	1*10
NERVINO CAP	1X10
NERVINO INJ	1AMP
NERVINO SY	1PHI
NERVIRICH PG-150 TAB 10*10	1x10xTab
NERVITOP GEL	30GM
NERVITOP-AP TAB	1*10
NERVITOP-MD3 TAB	1*10
NERVMAX	1X10C
NERVMAX SR 150MG	1X10T
NERVMAX SR 75MG	1X10T
NERVO BIN	1*10
NERVO-NT	1*10
NERVO-NT SYP	200ML
NERVUP OD CAP 5*10	1x10xCap
NERVZ CAP 10*10	1x10xCap
NERVZ INJ 5*3ML	1*3ml
NERVZ-B CAP 10*10	1x10xCap
NERVZ-G TAB 10*10	1x10xTab
NESTACORT 30MG	1X10
NESTACORT 6MG	1X10
NESTOGEN 1 1/2	HALF KG
NESTOGEN 2 1/2	HALF KG
NETCARDINE TAB.	1x10T
NETICIN 200MG/2ML	1 PCS
NETICIN INJ (300MG/3ML)	1 AMP
NETILMAC 150	1XV
NETILMAC 25	1X1V
NETILMAC 10	1X1V
NETILMAC 300	1X1V
NETILMAC 50	1X1V
NETROMAX 10MG	1XV
NETROMAX 150MG	1XV
NETROMAX 25MG	1XV
NETROMAX 300MG	1XV
NETROMAX 50 MG	1X1ML
NETROMYCIN 10 MG.	1 AMP.
NETROMYCIN 200 MG.	1 AMP.
NETROMYCIN 25 MG.	1 AMP.
NETROMYCIN 300 MG.	1 AMP.
NETROMYCIN 50 MG.	1 AMP.
NETSAFE 10MG	1 VIL
NETSAFE 25MG/1ML	1 AMP
NETSPAN 10 INJ.	1ML
NETSPAN 200 INJ.	2ML
NETSPAN 25	1AMP
NETSPAN 300 INJ	1AMP
NETSPAN 50 INJ.	1ML
NETWORM DS TAB	1x1
NETWORM SYP	10ML
NETWORM TAB	1x1
NEUBA 2ML AMP.	1X5ML
NEUBA CAP	1X10
NEUBA DP CAP	1X10
NEUBA SYP	1X100ML
NEUBA SYP	1X200ML
NEUCAM 4MG	1X10T
NEUCAM 8MG	1X10T
NEUCAM-P	1X10T
NEUCHOLINE TABLET	1X10
NEUCOBAL FORTE TAB 5*10	1*10TAB
NEUGABA ER 150 5*10	1*10TAB
NEUGABA ER 75 TAB 5*10	1*10TAB
NEUGABA-75 TAB 10*10	1*10TAB
NEUGABA-M 75 TAB 10*10	1*10TAB
NEUGALIN CAP 75MG 5*10	1x10xCap
NEUGALIN M CAP 10*10	1x10xCap
NEUGESIC SYP 60 ML	1PH
NEULAB-100MG TAB	1x10TAB
NEULAB-ACTIVE TAB	1x10 TAB
NEURACTIN-1500	1X10T
NEURACTIN-500	1X10C
NEURACTIN-FORTE	1X10T
NEURACTIN-PLUS	1X10
NEURO PLUS - 200ML SYU	200ML
NEURO CREME	1X30GM
NEURO GARDIAN TABS	10'S
NEUROBEX.SG.CAP	
NEUROBION FORTE TAB 75*10	1*10*TAB
NEUROBION PLUS TAB 10*10	1*10*TAB
NEUROBION RF INJ 10*7 AMP	1*7*AMP
NEUROCAL INJ	2ML
NEUROCAL INJ	4ML
NEUROCETAM	15ML
NEUROCETAM 800	
NEUROCETAM AMP 4*15ML	1*15*ML
NEUROCETAM CAP	
NEUROCETAM CAP 400MG 10*10	1*10*CAP
NEUROCETAM I.V.	1*100*ML
NEUROCETAM INJ	60ML
NEUROCETAM PLUS	
NEUROCETAM PLUS TAB 3*10	1*10*TAB
NEUROCETAM SYP	100ML
NEUROCETAM SYP 100ML	1*100*ML
NEUROCETAM TAB 1200MG 10*10	1*10*TAB
NEUROCETAM TAB 800MG 3*10	1*10*TAB
NEUROCOZY CAP 10*10	1*10*CAP
NEUROGAB 150	1X10T
NEUROGESIC TAB	1X10
NEUROGOLD ING	2ML
NEUROGOLD ING	2ML
NEUROKEM 75	1X10C
NEUROKEM M	1X10C
NEUROKEM PLUS	1X10C
NEUROLINK AMP	1*2ML
NEUROLINK CAP	1*10
NEUROMACK INJ.3ML	1
NEUROMET CAP 5*10	1x10xCap
NEUROMIN EA	1X10T
NEUROMIN INJ	1X1ML
NEUROMIN LIQ	120ML
NEUROMIN M	1X100ML
NEUROMIN M TAB	1X10T
NEUROMIN VIAL	3ML
NEUROMIN-OD	1X10T
NEUROPENTIN 300	1X10
NEUROPENTIN M CAP	1X10
NEUROPILL 100	1X10T
NEUROPILL TAB	1X10
NEUROSEN-PG CAPS	1*10
NEUROSTRONG-PLUS	1X1AMP
NEUROSTRONS PLUS TAB	10X6
NEUROTAB -M FORTE	1x1ML
NEUROTAB-M INJ	1x1ML
NEUROTAB>B6 TAB	1x10
NEUROTECH AMP	1*1
NEUROTECH TAB	1*10
NEUROTRAT CAP 20*10	1x10xCap
NEUROTRAT INJ 25*1*1AMP	1x1xAmp
NEUROVAL	1*10
NEUROVAL AMP	1x2ML
NEUROVOL CAPSULE	1x10
NEUROWEN CAP	1*10
NEUROXETIN 30	1X10S
NEUROXETIN 60	1X10S
NEUROXIME 250MG	1X10
NEUROXIN 10ML INJ	1X10ML
NEUROXIN-12 10ML	VIAL
NEUROXIN-12 30ML	VIAL
NEUROZAN TAB 3*10	1*10*TAB
NEUTION TAB	10*10
NEUTRAL BOLUS	1X10'S
NEUTRIZYME P	1*10
NEUTROSEC LIQUID 200ML	200ML
NEUTROSEC TAB	1*10
NEUVITAL SYP	1X200ML
NEVANAC E/D	1*5ML
NEVIMUNE TAB	10'S
NEVIRIN	10'S
NEW AGLOZYME DROP	15ML
NEW AIROMOL PD SYP	1X100
NEW ANOFER TAB 10*10	1*10TAB
NEW B-N-C CAP------------	1X30C
NEW B-N-C SYP------------	100ML
NEW BABY MASK	1 UNIT
NEW BRETHESE COUGH EXP	1 PH.
NEW CALMORE 1LITRES	1LITERS
NEW CALMORE 5LITERS	5LITERS
NEW D'COLD TOTAL TAB	2*6
NEW DELETUS D SYP 100ML	1*100*ML
NEW EPEXYL EXPECTORANT	1x100ML
NEW EPIXYL LD. 60 ML.	1x60ML
NEW FLUCOMB SYP 60ML	1*60ML
NEW FLUCOMB TAB 10*10	1*10TAB
NEW HI-FE SYRUP	1X200ML
NEW LIVFIT SYP	1x200xMl.
NEW LIVFIT TAB 10*10	1x10xTab
NEW MASK	1X1
NEW MOTHER'S MILAGE POWDER	1x200xGm.
NEW OKACET TAB	1x10
NEW PROTEN Z	1x200ML
NEW REVOLIZER	1PIC
NEW SAMOLOC	400 GR
NEW THRIVE CAP	10X10
NEW TRICLAZONE-80 TAB 10*10	1*10TAB
NEW TRIPLEACAL CAP 15*10	1*10*CAP
NEW VANIS ZIPPER 20% EXTRA	240 GM
NEW VANIS ZIPPER 20% EXTRA	450 GM
NEW VANISH ZIPPER	120GM
NEW VANISH ZIPPER	240GM
NEW VANISH ZIPPER	450GM
NEW ZEPHROL - D SY	100ML
NEW ZEPHROL COLD	60ML
NEW ZEPHROL COLD TAB	1X5
NEWBONA	1X10
NEWBONA ONE IV 100 ML	100 ML
NEWBONA PLUS	1X10
NEWCAL FORTE TAB	1x10
NEWCITA 10MG	1X10T
NEWCITA 5	1X10T
NEWCITA PLUS	1X10T
NEWQUIN EYE DROPS	5ML
NEWQUIN TAB	5'S
NEWTAP 100MG T	1X10 T
NEWTAP 50MG T	1X10 T.
NEWTAP 75MG T	1X10 T
NEXCET 5MG TAB	1X10
NEXCOLD 100ML SYP	100ML
NEXCOLD 60MLSYP	60ML
NEXCOLD TAB 1*10	1*10
NEXDOL P	1X10T
NEXDOL SR	1X10T
NEXDOL-100	1X2ML
NEXFOLIN TAB 10*10	1*10TAB
NEXI INJ	1 VAIL
NEXIPRIDE 100 TAB 5*10	1*10TAB
NEXIPRIDE 25 TAB 5*10	1*10TAB
NEXIPRIDE 50 TAB 10*10	1*10TAB
NEXIPRIDE INJ 5*2ML	1*2ML
NEXITO 10 TAB 10*10	1*10TAB
NEXITO 20 TAB 10*10	1*10TAB
NEXITO 5 TAB 10*10	1*10TAB
NEXITO FORTE TAB 10*10	1*10TAB
NEXITO LS TAB 10*10	1*10TAB
NEXITO PLUS TAB 10*10	1*10TAB
NEXOVAS 10	1X10T
NEXPAN DSR	1X10T
NEXPAN IV	1XV
NEXPAN-20	1X10T
NEXPRO 20	1X15T
NEXPRO 40	1X15T
NEXPRO FAST 20	1X10T
NEXPRO FAST 40	1X10T
NEXPRO IT	1X10C
NEXPRO IV 40MG	VIAL
NEXPRO L	1x10 TAB.
NEXPRO RD 20	1X10
NEXPRO RD 40 CAP	1X10C
NEXRET CREAM	1*15GM
NEXT TIME	1.5GM
NEXVENLA -OD 50	1X10 TAB.
NEZEN-DPTAB	1X10
NFLOX-D.DROP	1PH
NIATROY SR TABLET	1X10
NICARDIA CD 30MG	1X10
NICARDIA RET 10MG	1X10
NICARDIA RET 20MG	1X10
NICARDIA-XL30MG TABS	10'S
NICET PLUS	1X10
NICIP SUPER GEL	1PH
NICIP SYU	60ml
NICIP.100MG.TAB	1X10
NICLOMAR BOLUS.	1x4B
NICOFER SYP 300ML	1x300xMl.
NICOFLOX IV 100ML	1
NICOFLOX TAB 200MG	1x10 TAB
NICOGLOBIN TONIC	1x200ML
NICOGUM 4 SF	1X10
NICOPENTA 40MG TAB	1x10
NICOSTAR 10MG	1X20T
NICOSTAR 5MG	1X20T
NICOSTAR OD 10	1X10T
NICOTEX 4 CHEW GUM	1X4
NICOTEX 4 SF	1X10
NICTUM ST TAB	10
NICTUM-P TAB.	1*10
NIDAGEN-100MG	10'S
NIDAGEN-200MG	10'S
NIDAGEST- TABS	10'S
NIDDLE	1
NIDDLE VET 18 X 1'	1
NIDDLE VET DISPO 16*1.50	1
NIDE-L BOLUS	1X6'S
NIDE-L SUSP 110ML	1X1X110ML
NIDIL 18 VET	1*1
NIDOTRON 50ML INJ	1x50ML
NIDOTRON INJ	1x30ML
NIDRA TAB 5MG 10*10	1*10*TAB
NIFABOL INJ	1AMP
NIFABOL TAB	1X10
NIFAZYME SY	1PHI
NIFTAS TAB 10*10	1x10xTab
NIFTAS-50 TAB 10*10	1*10TAB
NIFTRAN CAP 100MG 1*20	1*20*CAP
NIFUTIN TAB 10*10	1*10*TAB
NIK THOMOMETRE	1 PIS
NIKETHAMIDE AMP**	1 AMP
NIKOMOX CV TAB 625MG 10*6	1*6*TAB
NIKORAN 10	1X20T
NIKORAN OD 10	1X10T
NIKORAN OD 20	1X10T
NIKORAN-5MG TAB	1X20
NIKOREX SYP.	1*100ML
NILBERRY 30 ML	30 ML
NILBERY INJ 90ML	90ML
NILBYE SYP	15ML
NILBYE TAB	1TAB
NILE TAB	1x10TAB
NILFLUX-20	1*10
NILOL TAB 18*10	1x10xTab
NILORVIT CAP	1X10
NILORVIT SYP	200ML
NILPAIN TAB	1X10
NILSOFIL FORTE TAB.	1x10
NILSOFIL PLAIN TAB.	1x10
NILVERM 100GM	PH
NILZAN 100ML	PH
NILZAN 1LIT	PH
NILZAN BOLUS	VB019
NIMAC 60ML SYP	1*60ML
NIMAC PLUS TAB	1*10
NIMAC TAB	1*15
NIMAC TAB	1X15
NIMBLE DT TAB.	1x10
NIMBOLIN RAKATSHODHAK	100ML[55]
NIMBOLIN RAKATSHODHAK	200ML[54]
NIMCET JUCIY TAB 1*10	1*10
NIMCOLD TAB	1*10
NIMDASE TAB	1X10
NIMDASE-P TAB	1X10
NIMDEX TAB	1x10
NIMDEX-P TAB	1x10
NIMECT-P TAB	1X10
NIMESEL P TAB	1x10
NIMESEL SYP	1x60ML
NIMESEL TAB	1x10
NIMESEL-P SYP	1x60ML
NIMESULIDE	1 TAB
NIMFAST TAB 10'S	
NIMI MD TAB 10*10	1*10*TAB
NIMIGESIC IR TAB 10*10	1x10xTab
NIMIGESIC P TAB 20*10	1x10xTab
NIMIGESIC PR SYP	1*60*ML
NIMIGESIC SYP 30ML	1x30xMl.
NIMIGESIC TAB 10*10	1x10xTab
NIMIN ID TAB	1*10
NIMIN KID TAB	1*10
NIMIN PLUS SUSP	1*60ML
NIMIN PLUS TAB	1*10
NIMIN SYP.	1*60ml
NIMIZ DT	1*10
NIMIZ PLUS TAB	1*10
NIMLEE-P SYP	1*30ML
NIMLID TAB	1*10
NIMLID SUSP.	1*60ML
NIMLIDE 60ML SYU	60ml
NIMMI SYU	60ml
NIMMI TAB	1x15
NIMO-P SYU	60ML
NIMO.60ML.SYU	1PH
NIMO.DROP 30ML	
NIMODIP TAB 30MG 10*10	1x10xTab
NIMODOL 100MG	1X10T
NIMODOL SUSPN	60ML
NIMOL COLD TAB	1X10
NIMOLIDE.MD.TAB	1X10
NIMOLINE JR TAB 1*10	1*10
NIMOLINE PLUS TAB 1*10	1*10
NIMOLINE TAB 1*10	1*10
NIMOPEN 100 MG TABS	1X10
NIMOPEN FORTE TABS	1X10
NIMOPEN KID TABS	1X10
NIMOPEN MD TABS	1X10
NIMOPEN PLUS TABS	1X10
NIMOPEN SUSP	60 ML
NIMOPEN-P SUSP	60 ML
NIMOPLUS.60ML.SYU	1PH
NIMOPLUS.DROP	1PH
NIMORAZOL 500	1X10 TAB.
NIMORI PLUS TAB.	1x15
NIMORI TAB.	1x10
NIMOS SYU	60ml
NIMOS TAB	1X10
NIMOS- P SYU	60ML
NIMOS-KID TAB	1x10
NIMOS-P TAB	1x10
NIMOSOL SYP.	1 PH.
NIMOSOL TAB	1x10
NIMOTIZ MR TAB	1X10
NIMOVAC PLUS TAB	1X10
NIMOVET 1ML	1ML
NIMOVET INJ 15ML.	VAIL
NIMOVET INJ. 50ML	1X50ML
NIMPA TAB	1X10
NIMPARA TAB	1x10
NIMPIC 60 ML	60ML
NIMPREX SRTAB	1X10
NIMPREX TAB	1X10
NIMPREX-P SYP	1X60ML
NIMPREX-PTAB	1X10
NIMREST PLUS SUSPENSION	60ML
NIMSAID-P SY 125 MG	60 ML
NIMSAID-P SY 250 MG	60 ML
NIMSPA TAB	1X10
NIMSUN PLUS TAB	1X10
NIMSUN SUS	60ml
NIMSUN TAB	1X10
NIMTECH	1X10T
NIMTECH PLUS	1X10S
NIMTECH SP	1X10S
NIMTECH SUSP	60ML
NIMTEX PLUS TAB	1*10
NIMU FAST PLUS TAB	1X10
NIMUJET BCD TAB	1x10TAB
NIMUJET GEL 30GM	1TUB
NIMUJET INJ	1x1ML
NIMULASE TAB 10*10	1x10xTab
NIMULASE TAB 15*10	1*10TAB
NIMULASE-P TAB 10*10	1x10xTab
NIMULID HF TAB	1x10
NIMULID MD KID TAB	1x10
NIMULID MD TAB	1x10
NIMULID MR TAB.	1x10
NIMULID NUGEL	1x30 GM
NIMULID SP CAP	1x10
NIMULID SYRUP	1x60 ML
NIMULID TAB	1x10
NIMULIDE MDTAB	1X10
NIMULITE PLUS BOLUS	1X4'S
NIMUMAC - MR TAB	1X10
NIMUMAC.PLUS.TAB	1X10
NIMUTAL PLUS SUSP	60ML
NIMUTAL SUSP	60ML
NIMUTID.30ML.DROP	1PH
NIMUTID.60ML.SYU	1PH
NIMUTID.PLUS.60ML.SYU	1PH
NIMUTOP 1*20	1*20
NIMUTOP KID 1*10	1*10
NIMUTOP KID 1*10	1*10
NIMUTOP P 1*10	1*10
NIMUTOP S 1*10	1*10
NIMUTOP S 1*10	1*10
NIMVAR PLUS SYRUP	60ML
NIOMOX CV 625 TAB 10*6	1*6TAB
NIORET NANOGEL	1*1
NIPAR PLUS TAB	1*10
NIPAR TAB	1*10
NIPCAN TAB 150MG 4*1TAB	1*1*TAB
NIPRESS 50 MG INJ	1 VIL
NIRCEF- 1GM INJ	1'S
NIRCEF- S 1.5G	1'S
NIRCIP 100ML	1 PCS
NIRFLOX IV	100 ML.
NIRLITE-M IV	1*500ML
NIRLITE-P IV	1*500ML
NIRLYTE-M	500 ML.
NIRMAFLOX-OZ TABS	10'S
NIRMET I.V. 100 ML	100 ML.
NIRMOL BOLUS	1X6'S
NIRMOX CL 625	10'S
NIRMOX-CL 1.2GM VIAL	1'S
NIROG SANJIVANI SYRUP 100	100ML[135]
NIRPRO POWDER	200 GM
NISE GEL	1x30xGm.
NISE MR TAB 10*10	1x10xTab
NISE TAB 50*15	1*15TAB
NISE-MDT TAB 35*10	1*10TAB
NISUVAR-P TAB	1*10
NITARID 500 TAB.	6 'S
NITAZED DT TAB	1X6
NITAZET 200MG DT TAB	1X10
NITAZET 500 MG TABLET	1x6
NITAZET 500MG TAB	1X6
NITAZET O TAB	1X6
NITAZET O TABLET	1x6
NITAZET SUSPENSION	1x30 ML
NITAZET SYP 30ML	1X30ML
NITFUR TAB	10'S
NITO TAB	1x10
NITOFIX SR TAB 30MG 30*10	1*10*TAB
NITR0GESIC CREAM	1x30 GM
NITRA GEL 100GM	1*100*GM
NITRA HEX M/W	1*100*ML
NITRAVATE 10 MG TAB	1x15
NITRAVATE 5 TAB	1x15
NITREST 10 TAB 10*10	1*10TAB
NITREST 5 TAB 10*10	1*10TAB
NITRO 2.6	1X30
NITRO 6.4	1X30
NITROCIN 25MG/5ML	5 5ML
NITROCIN SPRAY 0.4MG	5 ML
NITROCONTIN TAB 2.6MG 1*25	1x25xTab
NITROCONTIN TAB 6.4MG 1*25	1x25xTab
NITROFUR SR	1X10T
NITROGESIC ONIT	1*30GM
NITROLIFE 2.6 TAB	1x25xTab
NITROLIFE 6.4 TAB	1x25xTab
NITROLONG 2.6 TAB	1x25xTab
NITROLONG 6.4 TAB	1x25xTab
NITROSUN 10 TAB 10*10	1*10TAB
NITROSUN-5 TAB 10*10	1*10TAB
NITYAM CHURNA	50GMS
NIX-150	1*1
NIXIA MR	1X10T
NIXICAN 150MG	1
NIXIPER CREAM	1*30GM
NIXIPER LOTION	1*100ML
NIZANOF TAB.	1X6T
NIZER D TAB 10*10	1x10xTab
NIZER GEL	1x30xGm.
NIZER P TAB 10*10	1x10xTab
NIZER TAB 10*10	1x10xTab
NIZINIDE 500MG TAB	1x6
NIZONIDE	1X6T
NIZONIDE DT	1X6T
NIZONIDE SUSP	30ML
NIZONIDE-O	1X10T
NIZONIDE-O SUSP	1X50ML
NIZRAL CREAM	1x15xGm.
NIZRAL SHAMPOO	1x50xMl.
NIZRAL TAB 10*10	1x10xTab
NMF E BAR	75 GM
NMYCIN DROP	5ML
NO SORES GEL	10gm
NO TOUCH LHW CUCUM	KIT
NO TOUCH LHW ORIGINAL	KIT
NO TOUCH LHW ORIGINAL RFFIL	250
NOACID SYP	1*170ML
NOBEL COLD RUB	30G
NOBEL COLD TAB 3*10	1*10TAB
NOBEL GEL 30GM	1x30xGm.
NOBEL MR TAB 10*10	1x10xTab
NOBEL PLUS SYP 60ML	1*60ML
NOBEL PLUS TAB 12*10	1x10xTab
NOBEL SPAS INJ 10*3ML	1x3xMl.
NOBEL SPAS TAB 10*10	1x10xTab
NOBEL SPAS VIAL 15ML	1x15xMl.
NOBEL TAB 15*10	1x10xTab
NOBIVAC DHPPI 7	VIAL
NOBIVAC LEPTO 1DOSE	VAIL
NOBIVAC R 1 ML.	1 ML.
NOBLOK AF DROP	15ML
NOCAD CAP 10MG 10*10	1x10xCap
NOCK 2 S	1X10T
NOCK 2 SUSP	60ML
NOCK 2 TAB	1X10
NOCK 2 TAB 10*10	1*10
NOCK-3 TAB	1*10
NOCO SYP	60ML
NOCO TAB	1X10
NOCOLD DROP	1PH
NOCOLD SYU	1PH
NOCOLIC DM TAB	1X10
NOCOLIC DROP	1 PH.
NOCOLIC TAB	1x10
NOCTACID TAB.	1*10
NOCTURIN 2.5	1*10
NOCTURIN 5	1*10
NODD SUSP.	1*30ML
NODD TAB.	1x10
NODEP TAB 1*10	1*10
NODI CAP.	1X10
NODIMOX 500 DT TAB	1X10
NODIMOX PLUS 250DT	1X10T
NODIMOX PLUS 500 CAP	1X10C
NODIMOX PLUS-LB 250MG	1X10
NODIMOX PLUS-LB 500MG	1X10C
NODIMOX-LB 125MG	1X10
NODIMOX-LB 250MG	1X10
NODIMOX-LB 500MG	1X10
NODON AM 5/5 TAB 20*10	1*10*TAB
NODON H TAB 20*10	1*10*TAB
NODON TAB 2.5MG 20*10	1*10*TAB
NODON TAB 5MG 20*10	1*10*TAB
NOFAT	1X10
NOFGYL SUSP.	30 ML.
NOFLOCIN.EYE.DROP	1PH
NOFLOX TZ TAB	1*10
NOGERM SYP.	10 ML.
NOGERM TAB.	1 TAB
NOKLOT	1X10T
NOKLOT CV 150	1X10C
NOKLOT CV 75	1X10T
NOKLOT PLUS 150	1X10T
NOKLOT PLUS 75	1X10T
NOKLOT TAB+++++++++++++++	1X10T
NOLDY 25 INJ	1AMP
NOLE M .SYU	1PH
NOMARK 12G	1TUBE
NOMARK 25GRM	1TUBE
NOMBRE OD 100MG	1X10T
NOMBRE OD 50 MG	1X10T
NOMINTH SYP.	1 PH.
NOMINTH TAB.	1x1
NOMISH SYRUP	1x100ML
NOMISH SYRUP	1x200ML
NOMISH-M DROP	30ML
NOMISH-M SYP	100ML
NOMISH-M SYP	200ML
NOMISH-M TAB	1X10TAB
NOMOSIC TAB 1*10	1*10*TAB
NON ST.GLOVES 6"	50 PAI
NON ST.GLOVES 6.5"	1 PCS
NON ST.GLOVES 7"	1 PCS
NON ST.GLOVES 7.5"	1 PCS
NON ST.GLOVES 8"	1 PCS
NONAVIT FORTE	
NONAVIT PLUS	30ML
NOOSPORIN POWDER	1 PCS
NOOTROPIL 1200MG	1X10
NOOTROPIL INJ	15ML
NOOTROPIL INJ	1X60ML
NOOTROPIL SYP	1X100ML
NOOTROPIL TAB	1X30
NOPILE CAP. (1X45)	1 PH.
NOPLAQ AS-150 MG	1X10S
NOPLAQ AS-75 MG	1X10S
NOR KID	1x10
NOR METROGYL PLUS TABLETS	10'S
NOR-B CAP	1X10
NOR-B PED TAB	1X10
NOR-B SYP	200 ML
NOR-C SYRUP	1x170 ML
NOR-D SYP	200 ML
NORAL SYRUP	30 ML
NORAL SYRUP	90 ML
NORCID GEL	1x170ML
NORE-T TAB	1*10
NORESTRIN	1X10
NORFAGYL SYP 60ML	1x60xMl.
NORFAGYL TAB 20*10	1*10TAB
NORFAZOLEA SYP 30ML	1PH
NORFLED-400 TAB	1X10
NORFLED-TZ TAB	1X10
NORFLED-TZ TAB	1X6
NORFLOX 100MG DT	10'S
NORFLOX 200MG TABS	10'S
NORFLOX 400MG TABS	10'S
NORFLOX E/E DROPS	10ML
NORFLOX EYE OINTMENT	5GR
NORFLOX EYE/EAR DROP	5ML
NORFLOX M TAB	10&
NORFLOX TZ	10'S
NORFLOX TZ TABS	6'S
NORFLOX-TZ	1 TAB
NORFLOXIN.DROP	1PH
NORGEST TAB 10*10	1*10*TAB
NORGIP M SUSP 60ML	1 60M
NORGLEN 5MG TAB	1X10
NORGLY.60MLSYU	1PH
NORGYL SUSP. 30ML	1 PH
NORHO TAB	1*10
NORILET-400 TAB 30*10	1x10xTab
NORILET-A TAB 10*10	1x10xTab
NORILET-O TAB 10*10	1*10TAB
NORIP TZ TAB	10
NORKEM TZ	1*10
NORLAC-TZ TAB	1*6
NORLUP-TZ	10X10
NORMABRAIN	1X6C
NORMABRAIN 800	1X10T
NORMABRAIN INJ	1X15ML
NORMABRAIN SYP	1X100ML
NORMAGUT CAP 10*10	1x10xCap
NORMAGUT SACHET 10*1GM	1x1xGm.
NORMAL SLINE PDPL 500ML	500ML
NORMAL TAB	1X10
NORMAPROST TAB	1X10
NORMATONE SYP 210ML	1*210ML
NORMAXIN MB	10'S
NORMAXIN RT	1X10T
NORMAXIN- TABS	10'S
NORMENS CAP	1x6
NORMET	1X10T
NORMET IV	1X100ML
NORMET R 30 SACHET	1x3GM
NORMET R CAPSULES	1x10
NORMET R SACHET	1x1GM
NORMET SUSPENSION	1X30ML
NORMET SYP 30ML	1x30ML
NORMET SYP. 60 ML.	1x60ML
NORMET TAB	10'S
NORMET XT SUSPENSION	1x30ML
NORMETROGYL 400MG	1X10
NORMETROGYL SY	1PHI
NORMIX TAB 1*10	1*10
NORMO 60ML SYP	60 ML.
NORMO SYP 30ML	30ML
NORMOPRIL 2.5MG TAB	1X10
NORMOPRIL 5MG TAB	1X10
NORMOSYS TAB 10*10	1x10xTab
NORMPRO TAB	1x10
NORPEN EYE/EAR DROP 10 ML	10 ML
NORPER SUSP. 200 ML.	1 PH.
NORPER TAB.	1x10
NORPEX-400 TAB	1X10
NORSPAN -M DT TAB	1x10
NORSPAN -M SUSP.	1 PH.
NORSPAN 200 DT	1x10
NORSPAN 400	1x10
NORSPAN TN	1x10
NORTIN 100GM	100GM
NORTINI 30ML	30ml
NORTINI TAB	1x10
NORTINI SUSP 30ML.	1X30ML
NORTINI TAB.	1x10
NORVENT EXP	1x100xMl.
NORVENT-D EXP	1x100xMl.
NORZEE TZ TAB.	1x10
NOSCARB.OIN	1PH
NOSCOTUSS SYP 100ML	1*100ML
NOSCOTUSS SYP 60ML	1*60ML
NOSIB XR	1X10
NOSIC TAB	1x10
NOSIL MPS 170ML	170ML
NOSOBAC INJ 1GM	VIAL
NOSOBAC-XP 1.5GM	VIAL
NOSOMIK 100MG	1XV
NOSOMIK 250MG	1XV
NOSOMIK 500MG	1XV
NOSULE 30 ML SYP.	1 PH.
NOSULE 60 ML SYP.	1 PH.
NOTIX FORTE 120 GM.	PH
NOTIX GREEN SOAP	PH
NOTIX SCRUB-LIQ. 150GM	PH
NOTIX TALC	PH
NOTUS TAB	1X10
NOTUS-A SYP	1x100ML
NOTUS-D SYP	100ML
NOTUS-D SYRUP	1x200ML
NOTUS-P 100ML	1x100ML
NOTUS-P 60ML	1x60ML
NOTUS-P SYRUP	1x200ML
NOUL OS SYP	100ML
NOUL-20 CAP	1x10
NOUL-D CAP	1x10
NOURISHING BABY OIL 300ML	1*300ML
NOURISHING BABY SOAP 125GM	1*125GM
NOURISHING BABY SOAP 75GM	1*75GM
NOVA 150 TAB	10'S
NOVA 75 TAB	10'S
NOVA PLUS 75 CAP	10'S
NOVA SR 150 TAB	10'S
NOVA SR 75 TAB	10'S
NOVA-M 75	1X10
NOVACLOX -500 INJ.	5ML
NOVACLOX CAPS	9'S
NOVACLOX LB CAPS	9'S
NOVACLOX PED TABS	15'S
NOVACLOX--LB CAPS	6'S
NOVACLOX-1000GR INJ.	10ML
NOVACOLD SYP	1*1
NOVACOLD TAB	1*10
NOVACOR OINT.	1 TUBE
NOVAFAR 100ML	1*100ML
NOVAFEN-P	1X10
NOVAFEN-SP	1X10
NOVAFEN-SR	1X10
NOVAFORAN OZ SYP	1x30ML
NOVALE CT	
NOVALGIN	1X10T
NOVALGIN AMP	1X2ML
NOVALGIN VIAL	1X30ML
NOVAMOX 125 RU	30ML
NOVAMOX 125 RU	60ML
NOVAMOX 125MG DT	15'S
NOVAMOX 250 LB	10'S
NOVAMOX 250 REDIUSE	60ML
NOVAMOX 250MG CAPS	15'S
NOVAMOX 250MG DT	15'S
NOVAMOX 500 LB	6'S
NOVAMOX 500MG CAPS	6'S
NOVAMOX AX 250MG TAB	15'S
NOVAMOX AX 500MG TAB	6'S
NOVAMOX CV 1.2GM	1VAIL
NOVAMOX CV 375	6'S
NOVAMOX CV 375MG TAB	10'S
NOVAMOX CV 625	6'S
NOVAMOX CV DRY SYR	30ML
NOVAMOX DROPS	10ML
NOVAMOX DRY SYR	30ML
NOVAMOX DRY SYR	60ML
NOVAMOX REDIUS DROPS	10ML
NOVAMOX REDIUSE SYR	60ML
NOVAPHONE HG B.P	1 PCS
NOVAPIME 1GM	VIAL
NOVAPIME 250MG	1XV
NOVAPIME 500MG	VIAL
NOVARGERMINA SUSP	5ML
NOVASTAT 10	1X10T
NOVASTAT 40	1X10T
NOVASTAT 5	1X10T
NOVASTAT EZ	1X10T
NOVASTAT TG 10	1X10T
NOVASTAT TG-5	1X10T
NOVASTAT-20	1X10T
NOVAVIT 200ML	200ML
NOVAVIT DROP 15ML	15ML
NOVAZYME 200ML	200ML
NOVELAN TAB	1x21xTab
NOVELTIN TAB 10*10	1*10TAB
NOVIZAC	
NOVOFINE NIDDLE	1x1xPc.
NOVOMIN CAP	1X10
NOVOMIX 30 FLEXIPEN	1x1xPc.
NOVOMIX 30 PENFILL	1x1xPc.
NOVONORM TAB 0.5MG 1*30	1x30xTab
NOVONORM TAB 1MG 1*30	1x30xTab
NOVONORM TAB 2MG 1*30	1x30xTab
NOVOPEN 4	1*1*PC.
NOVOPIME 250	1VAIL
NOVORAPID FLEXIPEN	1x1xPc.
NOVORAPID PENFILL	1*1
NOVORET	10'S
NOVORET.	30'S
NOVOSPAR TAB 10'S	
NOWORM 400MG TAB	1X1T
NOWORM SUSP	1X10ML
NOXTIN TAB	1x10
NOZIA INJ 1*2ML	1*2*ML
NOZIA TAB 0.1MG 10*2	1*2*TAB
NOZOSTAT 1GM	1 VIL
NOZUKA	1X10T
NOZUKA AF DROPS	1X15ML
NOZUKA AF SYP.	1X60ML
NOZUKA NASAL SPRAY	1X20ML
NOZUKA SY	1X60ML
NRT -2MG M.P	1X10
NRT -2MG MINTFLAVOUR	1X10
NS (P)	500 ML.
NS 1000 ML NIRMA	1 ML.
NS 1000ML (P)	1 BOT
NS 3%	100 ML.
NS 500ML.	500 ML.
NS-15 TAB	1x10
NS-AID E/D	1*5ML
NSAID-K E/D	1*5ML
NSOSULIDE TAB	1x100
NT WORM SYP 100ML	1X100ML
NT WORM SYP 30ML	1X30ML
NT-WORM BOLUS	1x1 BOLUS
NT-WORM SYP 100ML	1x100NL
NT-WORM SYP 30ML	1x30ML
NTD 30 ML SY	1
NTD SPAS TAB	1X10
NTD TAB	1X10
NTINI TAB	1x10
NTINISPAS TAB	1x10
NTT [BARELY]	1 PACK
NTT 1*1	1*1
NU FLEXILOR TABLET	1X10
NU-B12 INJ	1AMP
NU-B12 SY	1PHI
NU-B12 TAB	1X10
NUBASE GEL	1X200ML
NUBETA H TAB 10*10	1x10xTab
NUBETA SM TAB 10*10	1x10xTab
NUBETA TAB 2.5MG 10*10	1*10*TAB
NUBETA TAB 5MG 10*10	1*10*TAB
NUCARNIT 500MG TAB	1x6
NUCLONA 0.25	1X10
NUCLONA 0.50	1X10
NUCOOL MPS	1X170ML
NUCOOL TAB	1X9T
NUCORT-M16 TAB 6*10	1*10TAB
NUCORT-M4 TAB 10*10	1x10xTab
NUCORT-M8 TAB 10*10	1x10xTab
NUCOXIA MR 8 TAB 12*10	1*10*TAB
NUCOXIA MR TAB 12*10	1x10xTab
NUCOXIA P TAB 15*10	1*10*TAB
NUCOXIA SP TAB 10*10	1x10xTab
NUCOXIA TAB 120MG 15*10	1x10xTab
NUCOXIA TAB 60MG 15*10	1*10*TAB
NUCOXIA TAB 90MG 15*10	1x10xTab
NUDICLO INJ	1X1ML
NUDICLO PLUS	1X6T
NUDICLO-100	1X10T
NUFENAC 30 ML.	VIAL
NUFORCE CD SUPP 7 TAB	1x7xTab
NUFORCE CD-3 CAP 1*3	1*3cap
NUFORCE MOUTH PAINT	1x15xMl.
NUFORCE PLUS TAB 10*1	1*1TAB
NUFORCE POWDER 75GM	1*75GM
NUFORCE SHAMPOO 75ml	1x75ml
NUFORCE SOAP	1*1PC
NUFORCE-150 TAB 30*1	1*1 TAB
NUFORCE-200 TAB 15*1	1x1xTab
NUFORCE-3 KIT 1'S	1x1xKit
NUFORCE-400 TAB 5*1	1*1TAB
NUFORCE-50 10X1	1x1xTab
NUFORCE-GM OINT 15GM	1x15xGm.
NUFORCE-KIT 1KIT	1x1xKit
NUFORCE-SZ KIT	1*1KIT
NUGESIC MD	1X10
NUGESIC syp	1X30ML
NUGESTRON INJ.	2 ML
NUGICA CAP	1*10
NUGLIM 4	1X10
NUGLIM M 1	1X10
NUGLIM M 2	1X10
NUGLIM PM 1	1X10
NUGLIM PM 2	1X10
NUGLIM-1	1X10
NUGLIM-2	1X10
NUKAST-10	1X10T
NUKAST-4	1X10T
NUKAST-4 SYP	1X60ML
NUKOX TAB	1*10
NULIFE GOODKHA 4MG	1X4
NULIFEGOODKHA 2MG	1X20GUMS
NULIFEGOODKHA 4MG	1X20GUMS
NULIV INJ. 30ML	1X30ML
NULOC 10 MG TAB	1X10
NULOC 20MG TAB	1X10T
NULOC 40MG TAB	1X10
NULOC D CAP	1X10
NULOC I V INJ	VIAL
NULOX 100 ML	100 ML
NULOX 15 ML	15 ML
NULOX 30 ML	30 ML
NUMBCAINE 20MG 4ML	1 AMP
NUMBCAINE INJ 20ML	1 VIA
NUMBLO-AT TAB	1x10
NUMBRICAL SPLINT FOR HAND	1 PCS
NUMECET GOLD TAB	1X10
NUMED TAB	1x10
NUMELIN 75 CAP 10*10	1x10xCap
NUNOCK SUSPENSION	60ML
NUPANT-40 TAB	1x10TAB
NUPANT-D	1*10
NUPANT-D TAB	1x10
NUPATCH 200 EACH PATCH	1*1*PATCH
NUPENTA	1X10T
NUPENTA ITR	1X10T
NUPENTA IV	1MG
NUPENTA LS	1X10S
NUPENTA-DSR	1X10T
NURIL TAB 2.5MG 10*10	1x10xTab
NURIL TAB 5MG 10*10	1x10xTab
NURIN POWDER	1*1
NURO M CAP	1X10
NURO-B INJ.	1X1X30ML
NURO-M SYP	1X100ML
NURO-ON 1*10	1*10
NUROBANK PLUS	1*10
NUROBEST CAP 5*10	1x10xCap
NUROBEST GOLD TAB 10*10	1*10TAB
NUROBEST INJ 5*2ML	1x2xMl.
NUROBEST OD CAP 10*10	1x10xCap
NUROBEST-KIT INJ	1*1PC
NUROBEST-MD TAB 10*10	1*10TAB
NUROBEST-XL CAP 3*10	1x10xCap
NUROCOL INJ	2ML
NUROCOL INJ 5*2ML	1*2*ML
NUROCOL INJ 5*4ML	1*4*ML
NUROCOL INJ..	4ML
NUROCOL TAB	10'S
NUROCOL TAB 5*10	1*10*TAB
NURODAY CAP 10*10	1x10xCap
NURODAY-H TAB 10*10	1*10TAB
NURODAY-P TAB 10*10	1*10TAB
NURODINE 2ML AMP	2ML
NUROGAB 75	1X10T
NUROGABIN TABLET	1X10
NUROGRAND ING	VIAL
NUROGRAND-OD CAP	1*10
NUROKIND FORT INJ 4*2ML	1*2ML
NUROKIND FORTE TAB 10*10	1*10TAB
NUROKIND GOLD CAP 4*10	1x10xCap
NUROKIND GOLD INJ 4*2ml	1*2ML
NUROKIND INJ 4*1ML	1x1xMl.
NUROKIND MORE TAB 6*10	1x10xTab
NUROKIND NEXT CAP 3*10	1*10CAP
NUROKIND OD INJ 4*2ML	1*2ML
NUROKIND OD TAB 6*20	1x20xTab
NUROKIND PLUS AMP 4*2ML	1x2xMl.
NUROKIND PLUS CAP 6*10	1*10CAP
NUROKIND PLUS VET	5ML
NUROKIND SYP 210ML	1*210ML
NUROKIND-D3 TAB 6*10	1*10TAB
NUROKIND-G 100 TAB 3*10	1*10TAB
NUROKIND-G TAB 6*10	1x10xTab
NUROKIND-GOLD TAB	1*10
NUROKIND-LC TAB 6*10	1*10TAB
NUROLIP-OD TAB	1x10
NUROSTAR TAB 6*10	1x10xTab
NUROTROY 10*10	1*10
NUROZ FORT CAP 5*10	1*10*CAP
NUROZ INJ 1*4AMP	1x4xAmp
NUROZ OD TAB 10*10	1x10xTab
NURTURE CHOCLATE	1X175GM
NURTURE LIQ	1X100ML
NUSAID 100	1X10T
NUSAID 200 SR	1X10T
NUSAID GEL	1X30GM
NUSAID MR	1X10T
NUSAID P	1X10T
NUSAID SP	1X10T
NUSAM 200 TAB 1*10	1*10TAB
NUSAM 400 TAB 1*10	1*10TAB
NUSAR 25 MG TAB	1x10
NUSAR 50 MG TAB	1x10
NUSAR H TAB	1x10
NUSOWIN CHILD	1*100GM
NUSTAT-10	1X25T
NUTAM 1200	1X10T
NUTAM 200 INJ	1X15ML
NUTAM 400	1X10C
NUTAM 500 SYP	1X100ML
NUTAM 500 SYP	1X200ML
NUTAM 800	1X10T
NUTAM BOLUS 200	1X60ML
NUTAM FORTE TAB.	1X10 TAB.
NUTAM PLUS	1X10T
NUTAXIN 1GM INJ	VIAL
NUTAXIN 250MG INJ	VIAL
NUTAXIN 500MG INJ	VIAL
NUTAXIN-S 1.5GM	1XVIAL
NUTAXIN-S 750 INJ	1XV
NUTRA PLUS(CHOCLATE)POWD	1*200GRMS
NUTRAMIDE DROP	1PHI
NUTRAMIDE SY	1PHI
NUTRAMIDE TAB	1X10
NUTRAMUST DROP 30ML	30ML
NUTRAMUST POW 200GM	200GM
NUTRAMUST SYP 200ML	200MNL
NUTRAMUST TAB 1*10	1*10
NUTRAWIN CAP	1X10
NUTRI-COAT 200 GM.	PH
NUTRIBIX ECO.	SACHET
NUTRICA CAPSULE	1x10
NUTRICA SYP. 100 ML.	1x100ML
NUTRICELL CAP 3*10	1*10CAP
NUTRICOM CAP	1X10
NUTRICOM SYP	200 ML
NUTRIFIL CAP.	1x15
NUTRIFIL SYP.	1 PH.
NUTRIGOLD(+) TAB 2*15	1*15TAB
NUTRIKIT CAP 1*15	1*15*CAP
NUTRILIV 30 ML.	VIAL
NUTRILIV FORTE 500 ML.	PH
NUTRIMAX DRP	1*15ML
NUTRIMAX SYP	1*100ML
NUTRIMAX SYP.	1*200ML
NUTRIMILK 10KG	BAG
NUTRIMILK 1KG.	1x1KG
NUTRIMILK 5KG	1X5KG
NUTRIMILK GOLD 1KG	1X1KG
NUTRIMILK GOLD 5KG	1X5KG
NUTRIMUNE TAB	10'S
NUTRIPET FOOD BOOSTER	200GM
NUTRIPROT 400GM	1x400xGm.
NUTRISACC 1 KG.	1KG
NUTRISACC BOLUS.	1x30B
NUTRISAM PET BRISKIT	1X50
NUTRIVA DROP 15ML	15ML
NUTRIVA MOM 1*10	1*10
NUTRIVA SYP 200ML	200ML
NUTRIVA TAB 1*15	1*15
NUTRIWON SUSP	200ML
NUTRIYEAST POWDWR 500 GR	500 GR
NUTROCAL-DM 400GM	1x400xGm.
NUTROLIN B CAP(1*10)	1*10
NUTROLIN B CAPS	10'S
NUTROLIN B PED TABS	10'S
NUTROLIN B SYR	60ML
NUTROLIN-B PLUS	10'S
NUTROSEC SYP.200 ML.	1 PH.
NUTROSEC TAB.	1x10
NUTRRIGHT TAB	1x10
NUTRRIGHT-W TAB	1x10
NUVARING VAG 1*1PC	1*1PC
NUZEN GOLD HAIR OIL	1X100 ML
NUZEN HERBAL SHAMPOO	1X100 ML
NUZIDE-M TAB 10*10	1x10xTab
NUZYME DROP	1PHI
NUZYME SY	1PHI
NUZYME SY 200ML	1PHI
NUZYME TAB	1X10
NVDOX PLUS TAB	1*10
NVM FORTE AMP	1X2ML
NVM FORTE TAB.	1x10
NVM TAB	1X10
NVM-M12 AMP	1X5
NVM-M12-OD TAB	1X10
NVMM12TAB	1X10
NVTAB	1X10
NW 2407	1 PCS
NW 4228EP	1 PCS
NYDE SYP	1 PH.
NYLON THREAD	1 PCS
NYLON THREAD DIAMOND	1 PCS
NYLUP PLUS TAB	1X10
NYOX TAB 8MG 10*10	1*10*TAB
NZYME DROP	15ml
NZYME SYP 200ML	1X200ML
NZYME.100ML.SYU	1PH
NZYME.CAP	1X10
O-A 100 MG TAB	1x10
O-A 200 MG TAB	1x10
O-A 300 MG TAB	1x10
O-A 400 MG TAB	1x10
O-A F-SUS	1x30ML
O-A M-SUS	1x30 ML
O-A SUS	1x30 ML
O-A TZ	1x10
O-ANXIT	1X10 TAB.
O-CARB EAR DROP	1x5 ML.
O-CEBRAN 200	1X10
O-CEBRAN 400 TAB	1X10
O-CEBRAN EYE DROP	1PH
O-CEBRAN OZ TAB	1x10
O-D CAP	1x10
O-FLOW-OZ TAB	1*10
O-LB 100 TAB	1X10
O-LB 200 TAB	1X10
O-LOX-OZ TAB	1*10
O-MYCIN EAR DROP	1x5 ML.
O-PPI CAP	1x10
O-STAT 120MG	1X10C
O-STAT 60MG	1X10C
O.R.S 4.2 GM	1PH
O.R.S SBP	1PH
O.R.S.	
O.R.S.POWDER	1PH
O.T LIGHT 12"	1 PCS
O.T.BOLOS	
O.T.SLIPPERS	1 PAI
O2 A TYPE CYL(NEW)	1 PCS
O2 A-TYPE CYL	1 CYL
O2 AA-TYPE CYL	1 CYL
O2 B TYPE CYL (COMPLIT SERVICE)	1 SET
O2 B TYPE CYL (SECURITY)	1 PCS
O2 B TYPE CYL (XL)	1 CYL
O2 B TYPE CYL(NEW)	1 PCS
O2 B-TYPE CYL	1 CYL
O2 CYLINDER DISPOSIBLE	1 PCS
O2 D TYPE BULK CYL(NEW)	1 PCS
O2 D TYPE BULK CYL(SECURITY)	1 PCS
O2 D-TYPE BULK CYL	1 CYL
O2 DERM TUBE	10GM
O2 FLOW METER SUNNY	1 PCS
O2 FLOWMETER	1 PCS
O2 FLOWMETER GAZE SET (LEONEX)	1 PCS
O2 FLOWMETER REG	1 PCS
O2 FLOWMETER WITH BOTTLE	1 PCS
O2 INFUSION	100ML
O2 KEY WRENTCH	1 PCS
O2 MOX REGULATER	1 SET
O2 NUT & NEEPLE	1 SET
O2 SY	1PHI
O2 TAB	1X10
O2 TROLLY	1 PCS
O2 WRENCH	1 PCS
O2"B"TYPE (XL)	1 PCS
O2H TABS	10'S
OANEM TAB	30T
OASOFT TAB 1*10	1x10xTab
OB-12 FORTE TAB	1X10
OB-12 TAB	1X10
OB-CAL 3 SACH	1GM
OB-CAL SYP	1X200ML
OB-CAL TAB	1X10
OB-CAL-A TAB	1X10
OBAX TAB 10*10	1*10TAB
OBEDERM-N CREAM	10GM
OBEFEX-100	1*10
OBEFEX-200	1*10
OBEFEX-50	1*10
OBEFEX-O	1*10
OBELIT 120 CAP 1*10	1*10*cap
OBELIT-60 CAP 1*10	1x10xCap
OBESTAT-10MG CAPS	10'S
OBESTAT-5MG CAPS	10'S
OBID ER	1X10
OBIMET GX 1 FORTE 10*10	1*10*TAB
OBIMET GX 2 FORTE 10*10	1*10*TAB
OBIMET GX1 TAB 10*10	1x10xTab
OBIMET GX2 TAB 10*10	1x10xTab
OBIMET SR TAB 1000MG 10*10	1x10xTab
OBIMET SR TAB 500MG 10*10	1x10xTab
OBIMET TAB 500MG 10*15	1*15*TAB
OBRA D E/D	5ML
OBRA D E/OINT	1*3GM
OBRA E/D	1*5ML
OBRA E/OINT	1*3GM
OBRA-F E/D	1*5ML
OC 21 TAB 10*21	1*21*TAB
OC GEL MPS SUSP	1x170ML
OC-CLAV 625	1X6CAP
OC-DOL AMP	1x2ML
OC-OTIC EYE DROP	1x10ML
OC-TONE SYP	1x200ML
OCAL 250 MG. TAB	1x30
OCAL 500 MG TAB	1x15
OCAL C TAB	1X10
OCAL SYP	1X1
OCAL-OS TAB	1X10
OCALB DS SYP	10ml
OCALB TAB	1TAB
OCCLO-GM OIT	1 TUBE
OCCUFRESH DROP	10ML
OCCUMOX EYE DROP	1*5ML
OCCUMOX-DM DROP	1*10ML
OCCUMOX-KT DROP	5ML
OCCUMOX-P DROP	1*5ML
OCDINE-M	1x20GM
OCEFT 1GM VAIL	1VAIL
OCEFT 250MG VAIL	1VAIL
OCEFT-S 1.5GM	1 VAIL
OCEFT-S 375 INJ	1 VAIL
OCEPH 300MG CAP	1X4
OCEPH D/S	30ML
OCEPRED DROP	1*5ML
OCID CAP 20MG 20*15	1x15xCap
OCID DSR CAP 15*10	1*10*CAP
OCID QRS TAB 20*15	1*15
OCIDAR 20MG CAP	1*10
OCIDAR-D CAP	1*10
OCIDOL INJ	1X2ml
OCIM 5MG DROP	1PH
OCIMEL CODINE	1x100ML
OCIMEL LINCTUS	1x100 ML
OCIMEL PED SYP.	1x50 ML
OCIMEL PLUS SYP.	1x100 ML.
OCIMEL SYP.	1x100 ML
OCIMIX TABLET	1x10
OCIPHYLIN SYP	1x60ML
OCIZOX 250MG	1VAIL
OCIZOX VIAL	2MLVIAL
OCIZOX-PZ	VIAL
OCIZOX-SB 1.5 INJ	1 VAIL
OCIZOX-SB 187.5	1 vail
OCIZOX-SB 375 INJ	1 VAIL
OCLAC CAPS	1x10
OCLAC DRY SYP	1x60ML
OCLIV SYP	1x200ML
OCMENTIN 375 1*6	1*6
OCMENTIN 625 1*6	1*6
OCOSS E/E DROP	1 PH
OCROX D SYRUP	1x100ML
OCROX SYRUP	1x100ML
OCROX-T SYRUP	1X100ml
OCTACE P	1X10TAB
OCTACE PLUS	1x10
OCTACE SR	1X10TAB
OCTACE-MR TAB	1X10TAB
OCTACE-PC TAB	1x10
OCTAMOP LOTION	30ML
OCTAMOP TAB	1*20
OCTIPLEX POWDER	1x200GM
OCTIZYME 200ML SYP	1x200ML
OCTIZYME DROP	1x15ML
OCTO-FOL TAB	1x10
OCTRIDE INJ 100MCG 1*1	1*1AMP
OCTRIDE-50MCG INJ 1ML	1*1ML
OCUCLEAR EYE DROP	5ML
OCUFLUR DROP	1x5xMl.
OCUGOLD PLUS	1*30
OCUGOLD TAB	1*30
OCULAN INJ	1ML
OCULAST E/D	1*5ML
OCULERGY EYE DROPS	10ML
OCUMOIST E/D	1*10ML
OCUPOL D E/D	1*5ML
OCUPOL D E/OINT	1*5GM
OCUPOL E/D	1*5ML
OCUPOL E/OINT	1*5GM
OCUREST E/D	1*10ML
OCUREST-AH E/D	1*10ML
OCUSOOTHE EYE DROP	10ML
OCUTOB-D E/D	1*5ML
OCUVIR 200 TAB 5*10	1x10xTab
OCUVIR 400 TAB 5*5	1x5xTab
OCUVIR 800 TAB 5*5	1x5xTab
OCUVIR EYE OINT	1x5xGm.
OCUVIR-SR 1200 TAB 5*3	1*3TAB
OD-PEP CAP	1x10
ODANSE 4MG TAB 10*10	1x10xTab
ODANSE MD-4 TAB 10*10	1*10TAB
ODANSE SYP	1x30xMl.
ODEON SYP	1*30 ML
ODEON TAB	1*10
ODICEF 1 GM.	1 VIAL
ODICEF 125 MG.	1 VIAL
ODICEF 250 MG.	1 VIAL
ODICEF 2GM VAIL	1 VAIL
ODICEF 500 MG.	1 VIAL
ODICEF O 100DT	1x10
ODICEF T140	VIAL
ODICEF-0 50DT	1x10
ODICEF-CV 200MG TAB	1x10
ODICEF-O 200	1x10
ODICEF-O DROPS	1x10ML
ODICEF-O DRY SYP	1x30ML
ODICEF-S 1.5INJ	1 VAIL
ODICEF-S 375INJ.	1 VAIL
ODICEF-S 750MG INJ.	1 VAIL
ODICEF-S KID INJ	1 VAIL
ODICEF-T 1GM INJ	1 VAIL
ODICEF-T 250MG INJ	1 VAIL
ODICEF-T 500MG INJ	1 VAIL
ODICEF-T140	VIAL
ODIFLOX SYP	60ML
ODIFLOX 200	1*10
ODIFLOX 200MG TAB	1x10
ODIFLOX NZ SYP	60ML
ODIFLOX-OZ TAB	1x10TAB
ODIMONT AL TAB 10*10	1*10*TAB
ODIMONT FX TAB 10*10	1*10*TAB
ODIMONT LC SYP	1*60*ML
ODIMONT LC TAB 10*10	1x10xTab
ODIN DROP	1PH
ODIPRIL 2.5MG CAP	1x10
ODIPRIL 5MG CAP	1x10
ODIPRIL-H-CAPS	1X10CAP
ODIZOX TAB	1x10
ODOFLUR DROP	5ML
ODOGATE DROP	5ML
ODOGATE P EYE DROP	5ML
ODOKUL DROP	10ML
ODOMOS COIL 10HRS RED	1 PICE
ODOMOS COIL 12HRS	1*12HRS
ODOMOS COIL 8 HRS GREEN	1PICE
ODOMOS LOTION 40ML	1*40ML
ODOMOS MOSQITO CREAM	1*50GM
ODOMOXI DROP	5ML
ODOMOXI OINT	5ML
ODOMYCETIN DROP	5ML
ODOMYCETIN-D DROP	5ML
ODONAC E/D	1*5ML
ODONIL 100GM	1*100GM
ODONIL 75GM	1*75GM
ODONIL BLOCK	1*50GM
ODOPAT DROP	5ML
ODOPIC BAR 2+1	1+2
ODOPIC BAR 200GM	1*200GM
ODOPIC BAR 400GM	400GM
ODOPIC BAR 600GM	600GM
ODOSOL N DROP	5ML
ODOVIN N DROP	10ML
ODOXIL 125 DT	1X10T
ODOXIL 250 DT	1X10
ODOXIL 500MG	1X10
ODOXIL OD 1GM	1X5T
ODOXIL PREMIX	30ML
ODOXIL SUSP	1X30ML
ODRIZOL PLUS	5ML
ODULUB PLUS DROP	10ML
OESTROVET BOLUS	1x5
OF INFUSION	100 ML
OF 200MG	1X10
OF 400 MG TABS	10'S
OF DERM CREAM	15 GM
OF M SUSPENSION	30ML
OF PLUS IV	100 ML
OF SY	1PHI
OF-PAX-OZ TAB	1x10
OFAL E/E DROP	10ML
OFAL E/E DROP	5ML
OFAL SUSP	30ML
OFAL SYRUP	60ML
OFAL-1	1X10
OFAL-2	1X10
OFAL-3	1X10
OFAL-4	1X10
OFAL-IV	100ML
OFAL-M SUSP	30ML
OFAL-TZ	1X10
OFAX DX DROP	1 PH
OFAX EYE DROP	1x5 ML.
OFAXIM-M 30ML	1*30ML
OFAXIN 200MG TAB	1X10
OFAXIN 30ML	1*30ML
OFAXIN 30ML SY	1PH
OFAXIN 400 MG TAB	1X10
OFAXIN 60ML SYP	1*60ML
OFAXIN-M 60ML	1*60ML
OFBACT OZ	10'S
OFBID 200 TAB 10*10	
OFBID OZ 10*10	1*10
OFCEF -TABS	10'S
OFCID-D SY	1PHI
OFCINTA 200 TAB	1x10
OFCINTA OZ TAB	1x10
OFCOL 200 MG TAB	1X10
OFCOL E/ED	10ML
OFCOL ORD SUSP	30ML
OFCOL-M SYR	30ML
OFCOL-ORD TAB	1X10
OFDAZ SYS	1X30ML
OFDAZ TAB	1X10
OFDIAR 200 1*10	1*10
OFDIAR TZ 1*10	1*10
OFDIAR-OZ TAB 1*10	1*10
OFELDER E DROP	5ML.
OFELDER D EYE DROP	5ML
OFELDER EYE DROP	5ML
OFELDER PA	1X5ML
OFEN-OZ SUSP	30 ML
OFEX EYE OIT	1X5GRM
OFFICE 100	1X10
OFFICE 200	1X10
OFFICE 50DRY SYP	1X30ML
OFGON-OZ TAB	1x10
OFGYL O TAB	1X6
OFGYL TAB	1X10
OFLA 100 MG TAB	1x10
OFLA 200 TABLET	1x10
OFLA OZ SUSP.	1x30 ML
OFLA OZ TABLET	1x10
OFLA SUSPENSION	1x30 ML
OFLAB OZ SYP	1*60ML
OFLAB OZ TAB 10*10	1x10xTab
OFLAB SYP	1x60xMl.
OFLAB TAB 100MG 10*10	1x10xTab
OFLAB TAB 200MG 10*10	1x10xTab
OFLAB TAB 300MG 10*10	1x10xTab
OFLAB TAB 400MG 10*10	1x10xTab
OFLACARE E/D	1 PCS
OFLACIN DX E/E DROPS	1X5 ML
OFLACIN E/E DROPS	1X5 ML
OFLADEX 400MG	1*10
OFLAMED 200	1X10T
OFLAMED 400 MG	1X10
OFLAMED OZ SUSP.	1X30ML
OFLAMED TZ TAB	1X10
OFLAMED-MN SUSP	1X30ML
OFLAMED-OZ	1X10T
OFLASET-OZ SYP	1*30ML
OFLATOON-DT TABLET	1X10
OFLATOON-MZ SYP	1X30ML
OFLATOON-OD 400MG TABLETS	1X5
OFLATOON-OZ TABLET	1X10
OFLAWIN 200MG TAB	1*10
OFLAWIN-OZ TAB	1*10
OFLER 200	1X10T
OFLER 400MG	1X10
OFLER INFUSION	100ML
OFLER OZ	1X10T
OFLER TZ	1X10T
OFLIN O TAB 10*10	1*10*TAB
OFLIN TAB 200MG 20*10	1x10xTab
OFLINE -OZ TAB 1*10	1*10
OFLINE 200 1*5	1*5
OFLO DROP	1*5ML
OFLO-DM DROP	1*10ML
OFLO-P	
OFLODEX 200MG	1*10
OFLOGYL OZ SUS	30ML
OFLOGYL-OS TAB	1*10
OFLOGYL-OZ TAB	1*10
OFLOKEM SYP	1*10
OFLOKEM TZ TAB	1*10
OFLOKIND OZ IU60ML	
OFLOKIND TAB.	1*2
OFLOKIND-OZ	BOLUS
OFLOMAC 100MG	1X10
OFLOMAC 200MG	1X10
OFLOMAC 300MG	1X10T
OFLOMAC 400MG	1X10
OFLOMAC CX DS	1X30ML
OFLOMAC EYE/EAR DROPS	1X5ML
OFLOMAC I.V	1X100ML
OFLOMAC M FORTE	1X30ML
OFLOMAC M SY	1X30ML
OFLOMAC MN SUSP 30ML	
OFLOMAC MN SUSP 60ML	60ML
OFLOMAC OD	1X5
OFLOMAC OZ	1X10
OFLOMAC OZ IV	1X100ML
OFLOMAC OZ SUSP	1X30ML
OFLOMAC SUSP	1X60ML
OFLOMAC SYP.	1X30ML
OFLOMAC TZ TAB	1X6
OFLOMAC-CX-100DT	1X10T
OFLOMAC-CX-200	1X10S
OFLOMIL 200 TAB	1X10
OFLOMIL 400 TAB	1x10
OFLOMIL 60ML SYP	1X60ML
OFLOMIL OZ SYP 30ML	1X30ML
OFLOMIL OZ TAB	1x10
OFLON M SYP	1*60ML
OFLONA.200MG.TAB	1X10
OFLONA.400MG.TAB	1X10
OFLOPEN M 30 ML	30 ML
OFLOPEN M 60 ML	60 ML
OFLOPEN OR 30 L	30 ML
OFLOPEN OR TAB	1X10
OFLOPEN TZ 30 ML	30 ML
OFLORAN OZ TAB	1X10
OFLOREN 200 TAB	1x10
OFLOREN 400 TAB	1x10
OFLOREN DT TABS	1X10
OFLOREN TZ TAB	1x10
OFLOSUN TAB	1X10TAB
OFLOSYN 200MG	1X10
OFLOSYN OZ TAB	1X10
OFLOTEC-OZ SUS	30ML
OFLOTIC -D; E/E DROP	1X5ML
OFLOTIC E/E DROP	1X5ML
OFLOX OZ SY	1X30ML
OFLOX-200 TAB	10'S
OFLOX-400 TAB	10'S
OFLOX-50 R/U	60ML
OFLOX-OZ TAB	10'S
OFLOX.D.DROP	1PH
OFLOXACIN I.V (AXA)	100 ML.
OFLOXAMAC.30ML.SYU	1PH
OFLOZEN E/D	1*5ML
OFLOZEN-D E/D	1*5ML
OFLUP INFUSION	100ML
OFLUPZ 200 TAB	1x10
OFMOR-OZ SYP	60ML
OFMOR-OZ TAB	1X10
OFNEW OZ	1*10
OFNIDA SUSP.	1x60ML
OFNIDA-LB TAB	1x10
OFOCUS-O SYP 60ML	60ML
OFOCUS-O TAB 1*10	1*10
OFODAM 200MG TAB	1x10
OFODAM OZ TAB	1x10
OFODAM-OZ SYP	1x30ML
OFORD TAB 10*10	1x10xTab
OFORD-H TAB 10*10	1x10xTab
OFORD-LB TAB 10*10	1*10TAB
OFORON TAB.	1x10
OFPAX EYE DROP	10ML
OFRAMAX FORTE INJ 1.5GR	1x1xVl.
OFRAMAX FORTE INJ 375MG	1x1xVl.
OFRAMAX INJ 1GM	1x1xVl.
OFRAMAX INJ 250MG	1x1xVl.
OFRAMAX INJ 500MG	1x1xVl.
OFROLAC E/D	1*5ML
OFRON 200 TAB	1 10T
OFRON OZ TAB	1 10T
OFRON SUSPENSION 30ML	1 ML.
OFSUN 200MG TAB	1x10
OFT TAB	1X10
OFTACIN-200 TAB	1X10
OFTACIN-OZ SUSP	30ML
OFTACIN-OZ TAB	1X10
OFTEX 60ML	60ML
OFTEX-O SYP	60ML
OFUSION CAP	10'S
OFVISTA-200 TAB	1X10
OFZEN CL EAR DROP	5 ML
OFZEN-DX EYE DROP	1*10ML
OGEST-100 MG	1X10
OGEST-200 MG	1X10
OGLIBO MD 0.2 TAB	1x20
OGLIBO MD 0.3 TAB	1x20
OGLO 15 MG TAB	1x10
OGLO 30 MG TAB	1x10
OJUS SY	1X200ML
OK0-OZ TAB	1*10
OKAFLOX 200MGTAB	1X10
OKAFLOX-M 30 ML.SYP	1PH
OKAFLOXM (L) 60 ML	1x60 ML
OKAGYL SYP	1x30ML
OKAREB TAB	1*10
OKAREB-D TAB	1*10
OKIL-200 TAB	1x10
OKIL-OZ-TAB	1X10
OKIT 20 MG CAP	1x10
OKO (L) 60 ML SY	1x60 ML
OKO 30ML	30ml
OKO OZ ALU ALU TAB	1*10
OKO OZ TAB	1*10
OKO-30ML SYP	1*30ML
OKO-60ML SYP	1*60ML
OKO-M (L) 60 ML	1x200
OKO-OZ 30ML	30ml
OKO-OZ 60ML	60ml
OKO-OZ TAB. ALU.ALU.	1x10
OKO-OZ TAB	IGAA01
OKS OZ TAB	1*10
OKS SYP	60 ML
OLAMAX 40 TABLET	1X10
OLANEX F TAB 10*10	1x10xTab
OLANEX TAB 10MG 10*10	1x10xTab
OLANEX TAB 2.5MG 10*10	1x10xTab
OLANEX TAB 5MG 10*10	1x10xTab
OLANEX TAB 7.5MG 10*10	1x10xTab
OLANOF 10MG	1X10
OLANOF 5MG	1X10
OLANZAPIK 10 TAB 20*10	
OLANZAPIK 10 TAB 20*10	
OLANZAPIK 15 TAB 10*10	
OLANZAPIK 20 TAB 10*10	
OLANZAPIK 5MG TAB	
OLAZM 2.5 TABLET	1X10
OLAZM 5 TABLET	1X10
OLAZM-10 TABLET	1X10
OLBY 200MG	1X10
OLBY SYP	30ML
OLBY-100TAB	1X10
OLBY-OZ SYP	1X60
OLBY-OZ TAB	1X10
OLEANZ 10 TAB 10*10	1*10TAB
OLEANZ 2.5 TAB 10*10	1*10TAB
OLEANZ 5 TAB 15*10	1*10TAB
OLEANZ 7.5 TAB 5*10	1*10TAB
OLEANZ FORTE TAB 5*10	1*10TAB
OLEANZ INJ. 10MG	1*1VAIL
OLEANZ PLUS TAB 10*10	1*10TAB
OLEANZ RAPITAB-10 TAB 5*10	1*10TAB
OLEANZ RAPITAB-15 TAB 5*10	1*10TAB
OLEANZ RAPITAB-2.5 TAB 5*10	1*10
OLEANZ RAPITAB-20 TAB 5*10	1*10TAB
OLEANZ RAPITAB-5 TAB 5*10	1*10TAB
OLEPTAL DT 150	1X10T
OLEPTAL DT 300	1X10T
OLEPTAL DT 450	1X10T
OLEPTAL OD 150	1X10T
OLEPTAL OD 300	1X10T
OLEPTAL OD 450	1X10T
OLEPTAL OD 600	1X10T
OLEPTAL OD 900	1X10T
OLESOFT LOTION	1X60ML
OLESOFT LOTION 200ML	1X200ML
OLESOFT PH 5.5	1X75GMS
OLESOFT* CREAM	1X60GM
OLESOFT* MOISTURIZING CR.	1X60GM
OLEVON SOFT GEL	1X10C
OLFI POD TAB 200MG 10*10	1*10*TAB
OLFI-O SUSP. 50/125	1*30*ML
OLGIPREG SACHET	10GM
OLGO 30 ML SYP	30ML
OLGO-200 1*10	1*10
OLGO-M 60ML	60ml
OLIC 5 MG.TAB	1x10
OLIC B6 TAB	1x10
OLIFE 100 TAB 10*10	1*10*TAB
OLIFE 200 MG. TAB	1x10
OLIFE 200 TAB 20*10	1*10*TAB
OLIFE 400 TAB 10*10	1*10TAB
OLIFE SYP 60ML	1x60xMl.
OLIFE-M SYP 60ML	1x60xMl.
OLIFE-OZ SYP 60ML	1x30xMl.
OLIFE-OZ TAB 10*10	1x10xTab
OLIFIX 100TAB	1x10
OLIFIX SUSPENSION	1X60ML
OLIGOCARE FORTE TAB 10*6	1*6*TAB
OLIGOCARE TAB 10*15	1*15*TAB
OLIGRO OIL 100ML	100ML
OLIMELT-10 TAB 14*10	1x10xTab
OLIMELT-15 TAB 7*10	1x10xTab
OLIMELT-2.5 TAB 21*10	1x10xTab
OLIMELT-20 TAB 7*10	1x10xTab
OLIMELT-5 TAB 21*10	1x10xTab
OLIMELT-7.5 TAB 14*10	1x10xTab
OLISENSE 10	1X10T
OLISENSE 2.5	1X10T
OLISENSE 5	1X10T
OLISTU OIL	100ML
OLISTU OIL 200ML	200ML
OLISUR 10 MG TAB	1*10
OLISUR 15 MG TAB	1*10
OLISUR 2.5 MG TAB	1*10
OLISUR 5 MG TAB	1*10
OLISUR 7.5 MG TAB	1*10
OLITAB 10MG.TAB.10'S	1X10
OLITAB 7.5 TAB.10'S	1X10
OLITAB-5 TAB.10'S	1X10
OLITABS 2.5	1X10
OLITABS F20	1X10
OLIVATE 10 MG TABLET	1X10
OLIVATE 2.5 MG TABLET	1X10
OLIVATE 5 MG TABLET	1X10
OLIVATE 7.5 MG TABLET	1X10
OLIVE OIL 100ML	1x100ML
OLIZA-10 TAB 10*10	1x10xTab
OLIZA-15 TAB 10*10	1x10xTab
OLIZA-2.5 TAB 10*10	1x10xTab
OLIZA-20 TAB 10*10	1x10xTab
OLIZA-5 TAB 10*10	1x10xTab
OLIZA-7.5 TAB 10*10	1x10xTab
OLKEM 20 AM	1X14T
OLKEM 20 H	1X14T
OLKEM 20 MG	1X14T
OLKEM 40 AM	1X14T
OLKEM 40 H	1X14T
OLKEM 40 MG	1X14T
OLLFIX OZ TAB	1x10
OLLFIX-200 TAB	1x10
OLLHART	1X10 CAP.
OLMARK-10 TAB 10*10	1*10TAB
OLMARK-20 TAB 10*10	1*10TAB
OLMARK-40 TAB 10*10	1*10TAB
OLMARK-A 40 TAB 10*10	1*10TAB
OLMARK-A TAB 10*10	1*10TAB
OLMARK-AH TAB 10*10	1*10TAB
OLMARK-H 40 TAB 10*10	1*10TAB
OLMARK-H TAB 10*10	1*10TAB
OLMAT AM TAB 20MG 5*10	1*10*TAB
OLMAT AM TAB 40MG 5*10	1*10*TAB
OLMAT AMH TAB 20MG 10*10	1*10*TAB
OLMAT AMH TAB 40MG 3*10	1*10*TAB
OLMAT H (20MG) TAB 10*10	1*10*TAB
OLMAT H TAB 40MG 10*10	1*10*TAB
OLMAT TAB 20MG 10*10	1*10*TAB
OLMAT TAB 40MG 10*10	1*10*TAB
OLMAX 20 TABLET	1X10
OLMAX 3D 20MG TBALET	1X10
OLMAX 40 H TABLET	1X10
OLMAX 40 TABLET	1X15
OLMAX AM TABLET	1X10
OLMAX AM TABLET	1X15
OLMECIP 20 TAB	10'S
OLMECIP 40 TAB	10'S
OLMECIP AM TAB	10'S
OLMECIP H TAB	10S
OLMECIP H-40	1X10
OLMECIP TRIO	1X10
OLMEGLARE TAB 20MG 10*10	1*10*TAB
OLMEGLARE TAB 40MG 10*10	1*10*TAB
OLMESAFE 10	1X10T
OLMESAFE 20	1X10T
OLMESAFE 40 MG	1X10T
OLMESAFE-AM	1X10T
OLMESAFE-H 20/12.5	1X10T
OLMESAFE-H 40/12.5	1X10T
OLMESAR 10	1X10T
OLMESAR 20	1X10T
OLMESAR 40	1X10T
OLMESAR 40 A	1X10T
OLMESAR AV	1X10T
OLMESAR CH 20	1X10T
OLMESAR CH 40	1X10T
OLMESAR H40	1X10T
OLMESAR-A	1X10S
OLMESAR-H	1X10T
OLMETIME-AM 40 TAB 2*10	1*10TAB
OLMETIME-AMH 20 TAB 2*10	1*10TAB
OLMETIME-H 20 TAB 3*10	1*10TAB
OLMETIME-H 40 TAB 3*10	1*10TAB
OLMETOR -20	1X10 TAB.
OLMETOR -40	1X10 TAB.
OLMEZEST 10 TAB 10*10	1*10TAB
OLMEZEST 20 TAB 10*10	1*10TAB
OLMEZEST 40 TAB 10*10	1*10TAB
OLMEZEST AM TAB 10*10	1*10TAB
OLMEZEST AM-40 TAB 5*10	1*10TAB
OLMEZEST BETA-25 TAB 5*10	1*10TAB
OLMEZEST BETA-50 TAB 5*10	1*10TAB
OLMEZEST H-20 TAB 10*10	1*10TAB
OLMEZEST-CH 20 TAB 5*10	1*10TAB
OLMEZEST-CH 40 TAB 5*10	1*10TAB
OLMEZEST-H20 TAB 5*10	1*10TAB
OLMEZEST-H40 TAB 10*10	1*10TAB
OLMIGO C20 TAB	10'S
OLMIGO C40 TAB	10'S
OLMIN 20A TAB 10*10	1*10*TAB
OLMIN 20AH TAB 10*10	1*10*TAB
OLMIN 20H TAB 10*10	1*10*TAB
OLMIN 40H TAB 10*10	1*10*TAB
OLMIN CH TAB 20MG 10*10	1*10*TAB
OLMIN CH TAB 40MG 10*10	1*10*TAB
OLMIN TAB 20MG 10*10	1*10*TAB
OLMIN TAB 40MG 10*10	1*10*TAB
OLOBLU 0.1%	1X1
OLOBLU 0.2%	1X1
OLONE BOLUS	10X2'S
OLONE DS 15ML	1X15ML
OLONE-TZ BOLUS	10X2'
OLONE-TZ I.U. 60ML.	1X60ML
OLOPAT E/D	1*5ML
OLOPAT KT	1*5ML
OLOPAT OD E/D	1*3ML
OLOPAT TAB	1*10
OLOPAT TAB.	1*10
OLOPATE KT 5ML	1*5ML
OLOTAD E/D	1*5ML
OLOTOP EYE DROP	1*5ML
OLOX 100 REDIUSE	60ML
OLOX 200 TAB	10'S
OLOX 400 TAB	10'S
OLOX OE TABS	10'S
OLOX OZ	10'S
OLSAR 10	1X10
OLSAR 20	1X10
OLSAR 40	1X10
OLSAR A	1X10
OLSAR A20	1X10
OLSAR AH	1X10
OLSAR H 40	1X10
OLSAR M 25 - 10C	1X10
OLSAR M 50 - 10C	1X10
OLSAR-H 20MG TAB	1X10
OLSAR-H TAB	1X10
OLSAVAS 20 MG TABLET	1X10
OLSAVAS 3 TABLET	1X10
OLSAVAS 3D TABLET	1X10
OLSAVAS 40 TABLET	1X10
OLSAVAS AM TABLET	1X10
OLSAVAS H 40 TABLET	1X10
OLSAVAS-M 25 TABLET	1X10
OLSAVAS-M 50 TABLET	1X10
OLSERTAIN ACTIV-20 1*30	1*30TAB
OLSERTAIN ACTIV-40 1*30	1*30TAB
OLSERTAIN ACTIV-AM 1*30	1*30TAB
OLSERTAIN ACTIV-H20 1*30	1*30TAB
OLSERTAIN ACTIV-H40 1*30	1*30TAB
OLSERTAIN-20 TAB 10*10	1*10TAB
OLSERTAIN-40 TAB 10*10	1*10TAB
OLSERTAIN-AM TAB 10*10	1*10TAB
OLSERTAIN-H20 TAB 10*10	1*10TAB
OLSERTAIN-H40 TAB 10*10	1*10TAB
OLVAS AM TAB 10*10	1*10*TAB
OLVAS H TAB 10*10	1*10*TAB
OLVAS TAB 20MG 10*10	1*10*TAB
OLVAS TAB 40MG 10*10	1*10*TAB
OLX TAB	1X10
OLYSMIN GOLD ING	1ML
OLYSMIN SYP	200ML
OLZEP 20 MG	1X10
OMAC-100	2ML VAIL
OMALASOFT TAB	10'S
OMAN 20	1X10
OMAS-20 CAP	1X15
OMAS-20MG CAP	1*15
OMAS-20MG CAP	1*15
OMAS-D CAP	1X15
OMCEF 100 DT	1X10T
OMCEF 200MG	1X10T
OME-PPI 20 CAPS	1x10
OMECARE SYP 450ML	1x450ML
OMECARE SYRUP	1x200ML
OMECIP-20 CAP	1X15
OMECIP-D CAP	1X15
OMEFLOX BM E/OINT	3GM
OMEFLOX E/D	1*5ML
OMEFLOX-DX E/D	1*5ML
OMEFLOX-KT E/D	1*5ML
OMEGACHEK CAP.	1*15
OMEGRAN SACHET	1X15GM
OMELINE CAP 1*10	1*10
OMELINE D CAP 1*10	1*10
OMELIV CAP	1X10CAP
OMELIV SYRUP 100ML	1x100ML
OMELIV SYRUP 200ML	1x200ML
OMEN AM	10'S
OMEN CT	10'S
OMEN-20	10'S
OMEN-40	10'S
OMEPRAN HP KID	1x6
OMEPRAZ 20	1X15C
OMEPRAZ-D CAP	1*10
OMEPRED E/D	1*5ML
OMESEC 20MGTAB	1x10
OMESEC RD CAP	1x10
OMESUN 20MG TAB	1X10
OMESUN D TAB	1X10
OMET 200 TAB	1X10T
OMET SUSP.	1X30ML
OMET TZ TAB	1X10
OMET-M SUSP	1X30ML
OMET-M SUSP	1X60ML
OMETIC SYP	30ML
OMEZ FF20 TAB 10*10	1x10xTab
OMEZ FF40 TAB 10*10	1x10xTab
OMEZ INJ 10ML	1x10xMl.
OMEZ INSTA SACHET 1*10	1*10PC
OMEZ INSTAUSE 1*5PC	1x5xPc.
OMEZ-10 CAP 20*10	1x10xCap
OMEZ-20 CAP 20*15	1x15xCap
OMEZ-40 TAB 10*10	1x10xTab
OMEZ-DSR CAP 10*15	1*15cap
OMEZET D 1*10	1*10
OMIDOM CAP 10*6	1x6xCap
OMIKAV 20MG CAP	1X10
OMILCAL FORT	1X15CAP
OMILCAL SYP.	1 PH.
OMINAX 125MG INJ	1x1xVl.
OMINAX 1GM INJ	1x1xVl.
OMINAX 250MG INJ	1x1xVl.
OMINAX 500MG INJ	1x1xVl.
OMIND 20MG CAP	1x10
OMIPAX-D	1*10
OMIPEN 20 MG	1X15
OMISAT-20MG.TAB.10'S/SM	S
OMISEC 20 MG.CAP.	1x10
OMISEC RD CAPSULE	1X10
OMISEC.20MG.CAP	1X15
OMISHZYME 200ML	1x200ML
OMISHZYME SYRUP	1x100ML
OMIT-D CAP	1*10
OMNAC GEL	16GM
OMNAC GEL 30GM	30GM
OMNAC-P TAB	1x10
OMNAC-SP TAB	1x10
OMNACORTIL 10MG	1X10T
OMNACORTIL 2.5MG	1X10T
OMNACORTIL 20MG	1X10T
OMNACORTIL 30MG	1X10T
OMNACORTIL 40MG	1X10T
OMNACORTIL 5MG	1X10T
OMNACORTIL CREAM	1X10GM
OMNACORTIL DROP	1X10ML
OMNACORTIL FORTE	1X60ML
OMNACORTIL INJ	1X2ML
OMNACORTIL MD 10	1X10T
OMNACORTIL MD 5	1XX10T
OMNACORTIL SOLU.	1X60ML
OMNACORtil e dp	
OMNATAX CV TAB 200MG	1*10*TAB
OMNATAX O TAB 200MG 10*10	1x10xTab
OMNI.GEL.10GM.TUB	1PH
OMNI.GEL.30GM.TUB	1PH
OMNIBACT INJ 1GM	1XV
OMNICAL 500 TAB	15'S
OMNICEF 125MG	1XV
OMNICEF 1GM	1XV
OMNICEF 250MG	1XV
OMNICEF INJ 500MG	IXV
OMNICEF O 100MG DT	1X10T
OMNICEF O 200MG	1X10T
OMNICEF O CV 100DT	1X10T
OMNICEF O CV 200	1X10T
OMNICEF-AZ 200/250T	1X10 TAB.
OMNICEF-AZ FORTE 200 T	1X10 TAB.
OMNICID GEL	170ML
OMNICIDE 500 ml	500 ml
OMNICLAR R/U	30ML
OMNICOLD TABS.	10'S
OMNIDASE 1500IU	
OMNIGRA TAB	4'S
OMNIKACIN 100 INJ	2ML
OMNIKACIN 250 INJ	2ML
OMNIKACIN 500 INJ	2ML
OMNIM SYRUP	200ML
OMNIM XT DROPS	15ML
OMNIM XT SUSPENSION	150ML
OMNIM XT TABS	10'S
OMNISEC D SR CAPS	10'S
OMNISEC TAB	15'S
OMNISET 4 TAB	10'S
OMNITAN 25 TAB	1X15T
OMNITAN 50 TAB	1X15T
OMNITAN H TAB	1X15T
OMNIVIT DROP	1PH
OMNIX - O TAB	10'S
OMNIX 100MG TABS	10'S
OMNIX 200 MG DT TAB	10'S
OMNIX 50 DRY SYR	50ML
OMNIX CV 200 TAB	10'S
OMNIX ST TAB	1X10
OMNIX XT SY	1PHI
OMNIX XT TAB	1X10
OMNIXIM 250 TAB	4'S
OMPAZ 20MG CAPS	1X10
ON-OFF.OZ TAB	1x10
ON-STOP INJ	1x2ML
ON-STOP SUSP	1x30ML
ON-STOP TAB	1x10
ONABET CREAM	1X10 GM
ONABET LOTION	1X15 ML
ONABET V1 TABLET	1X1
ONAZIT SUSP	15ML
ONBAVE SYP	30ML
ONBREZ BREEZHALER 150 MCG	1X30S
ONBREZ BREEZHALER 300 MCG	1X30S
ONCIN OZ 1*10	1*10
ONCIN OZ 60MK	60ML
ONCIN SYP	30ML
ONCIN TAB 1*10	1*10
ONCIN-200 MG	1*10
ONCIN-M 1*10	1*10
ONDABIC SYP	1*30*ML
ONDAMAC INJ	1X2ML
ONDAMAC MD	1X10T
ONDAMAC ORAL SY	1X30ML
ONDAMAC-4	1X10T
ONDANBIC TAB 10*10	1*10*TAB
ONDANZ INJ	2ML.
ONDAR -SURYP	30ML
ONDAR DROP	30 ML
ONDAR INJ	2 ML
ONDAR TABS	10'S
ONDAR TABS	10'S
ONDEM 2ML INJ	1X2ML
ONDEM 4MG TABS	1X10T
ONDEM 4ML INJ	1X4ML
ONDEM 8MG TABS	1X10
ONDEM OF	1X6SACHET
ONDEM SYRUP	30ML
ONDEM-MD 4	1X10T
ONDEM-MD 8MG	1X10
ONDEM-P SY	30ML
ONDEM-P TAB	1X10
ONDENORM 4MG TAB	1X10
ONDENORM DROPS	30ML
ONDENORM INJ	2ML
ONDERM CREM	1X10GM
ONDI DROP	1PH
ONDI MB DROP	1*15ML
ONDICURE SYP	30ML
ONDIMAC DROP	30ml
ONDOT 2ML VAIL	1VAIL
ONDRON DROP	30ML
ONDRON TAB	1X10
ONDVA-XL	1*10
ONE CLAV TAB 625MG	1x6
ONE BE CAP. (1*10)	1*10
ONE BE FORTE CAP	1x10
ONE BE SY	1X200ML
ONE UP GOLD++++++++++++++	1X10T
ONE-UP GOLD D	1X10T
ONE-UP+++++++++++++++++++	1X10T
ONECAN TAB 150MG 10*1	1*1*TAB
ONEEDA SYP 30ML	30ML
ONFEED BOLUS 1X4	1X4
ONO INJ 4 MG	10 2ML
ONOFF SUSP	30ML
ONOFF 200 MG	1X10
ONOFF M SYP	1PH
ONOFF TAB 100MG	1X10
ONOFF-TZ TAB	1x10
ONSETRIN INJ	10ML
ONSURGE ING	2ML
ONTAC 75MG INJ	3ML
ONTAC GEL	30GM
ONYLAC NAIL LACQUER	3.3 ML
OPAM-15 TAB 10*10	1x10xTab
OPAM-30 TAB 10*10	1x10xTab
OPARA SEMI TAB 10*10	1*10*TAB
OPARA TAB 1000MG 10*10	1*10*TAB
OPEC SYP 60ML	1*60ML
OPEC-OZ TAB 10*10	1*10TAB
OPERA DROP.	1*15ML
OPERA SYP	1*60ML
OPERA SYP.250MG	1*60ML
OPERA-S 1.5GM	1VAIL
OPERA-S 375MG	1VAIL
OPERA-S 750MG	1VAIL
OPEXA GEL	15GM
OPHTHACARE DROP	1x10xMl.
OPI - OT 37.5MG TAB	1X10
OPLONE E/D	1*5ML
OPOX 100DT	1X10
OPOX 100MG DRY SYP	1X100MG
OPOX 200	1X10
OPOX 50DRY SYP	1X30ML
OPOX 50DT	1X10
OPOX CV 100 DRY SYP	1X30ML
OPOX CV 100DT	1X10
OPOX CV 200	1X10
OPOX CV 50DRY SYP	1X50
OPOX CV 50DT	1X10
OPOX DROP	1X10ML
OPOX FX 100	1X10
OPOX FX 200	1X10
OPPONANCE SPLINT	1 PCS
OPTHODEX EYE DROP	1x5 ML.
OPTHODEX N EYE DROP	1x5 ML.
OPTHODEX S EYE DROP	1x5 ML.
OPTHOMYCETIN EYE DROP	1x5 ML.
OPTHOMYCETIN PLUS EYEDROP	1x5 ML.
OPTHOPIN EYE DROP	1x5 ML.
OPTHOPIN EYE OINT.	1x3 GM.
OPTHOSULF EYE DROP	1x10 ML.
OPTICAL GOLD 5LT	1X5LT
OPTICAL LIQ.1LT	1X1LT
OPTICAL LIQ.5LT	1X5LT
OPTICAL PLUS BOLUS	1X1'S
OPTICOOL E/D	1*5ML
OPTIEX_COUGH SYP.	1*100ML
OPTIHIST E/D	1*5ML
OPTIHIST PAT E/D	1*5ML
OPTIHIST PLUS E/D	1*5ML
OPTIHIST-AZ E/D	1*5ML
OPTIMOX 250MG VAIL	1VAIL
OPTIMOX 500MG VAIL	1VAIL
OPTIMOX CAP	1 PH
OPTIMOX PLUS TAB	1X10
OPTINEURAON.FORT AMP	1AMP
OPTINEURON	1X10T
OPTINEURON FORTE	1X10T
OPTINEURON INJ	1X3ML
OPTINEURON SY 200ML	1X200ML
OPTINEURON SYP100ML	1X100ML
OPTINEURON.AMP	1.AMP
OPTINRON.AMP	1AMP
OPTIPRES EYE DROPS	5ML
OPTIPRES-S E/DROPS	5ML
OPTISULIN CAP 30*15	1x15xCap
OPTITHROCIN E/OINT	1*5GM
OPTIVE	10ML
OPTIVIN	10'S
OPTIVIRAL E/OINT	1*5GM
OPTOGEST 100 TAB	10*10
OPTOGEST 200 TAB	10*10
ORA -G	15ML
ORA-SORE GEL	1*10GM
ORA-SORE GEL 10GM	1TUB
ORABLISS GEL	10GM
ORAC CAPSULES	1X10
ORAC TAB	1x10
ORACET TAB	1X10
ORAFLOX 400 MG. TAB	1x10
ORAGEL	15ML
ORAHELP GEL 15GM	1*15GM
ORAHEX PLUS SOLUTION	1*150*ML
ORALYTE READY-P	1X200ML
ORANGEMOL SUSPENSION	1x60 ML
ORAPASTE CREAM	5GM
ORATIL 125 DT	1X10T
ORATIL 250	1X10T
ORATIL 500	1X10T
ORATIL CV 250	1X10T
ORATIL CV 50 DT	1X6T
ORATIL CV 500	1X6T
ORATIL INJ 1.5GM	1XVIAL
ORATIL INJ 250 MG	1XVIAL
ORATIL INJ 750 MGJ	1XVIAL
ORAWAYS BUCCAL PASTE 5GM	1*5GM
ORBITAL SYP 200 ML	1PH
ORCAL-P 500GM	25X500GM
ORCALMIN VET SUSP 200ML	200ML
ORCERIN	1X10S
ORCERIN GM	1X10S
ORDENT TAB 10*10	1x10xTab
ORECURE PLUS E/D	1*5ML
ORELED-XT SYU	150ML
ORELED-XT TAB	1X10
OREX CREAM 10GM	10GM
OREX LO 10GM	10GM
OREX M GEL 20GM	20GM
ORFIN 10 -WS	100 GR
ORFIX 200 MG TAB	1X10
ORFIX CV TABLET	1X10
ORFIX DT 100 MG TAB	1X10
ORFIX-DT 50 MG TABLET	1X10
ORFIX-O 100 DT TABLET	1X10
ORFIX-O TABLET	1X10
ORFLAZ KIT	1KIT
ORFLOCTIN WS 100 GR	100 GR
ORGAMED TAB	1x10
ORGAMED TAB 5*10 TAB	1x10xTab
ORGEN DEVLOPER	1 PCS
ORICAL inj 30ml	VIAL
ORICITRAL SYP	1x100xMl.
ORIEL TAB 10*10	1x10xTab
ORIEL-M TAB 10*10	1*10TAB
ORIN-O SYP	1X30ML
ORIN-O TAB	1X10
ORINASE A N/D	1*10ML
ORINASE MICROMIST	1*9.8ML
ORION TAB	1X10
ORIP-TZ TAB	1*10
ORIPRIM BOLUS.	1x4B
ORIPRIM POWD 100 GR	100 GR
ORIPRIM POWD.	25
ORIPRIM U BOLUS	1X4
ORKID-S OINT	1x10xGm.
ORLE-60MG CAPS	1x10CAP
ORLEAN CAP 120MG 10*10	1*10*CAP
ORLEAN CAP 60MG 10*10	1*10*CAP
ORLIMAC	1X10C
ORLIV SYP	1X200ML
ORNAMAC	1X10T
ORNAMAC IV	1X100ML
ORNAMAC SUSP	1X30ML
ORNI O IV	1*100*ML
ORNI O TAB 10*10	1x10xTab
ORNI TAB 500MG 10*10	1x10xTab
ORNICEF	1X10T
ORNICEF DT	1X6T
ORNIDA 500MG	1X10T
ORNIDA IV	1X100ML
ORNIDOHEXT	1X6T
ORNIF SUSP	60ML
ORNIF TAB	1X10
ORNIGYL IV	100ML
ORNIGYL.O.SYU	1PH
ORNILIV INJ 5*10ML	1x10xMl.
ORNILIV TAB 10*10	1x10xTab
ORNIMAX TAB	1X10
ORNIQUIN SYP 30ML	30ML
ORNIQUIN TAB 10*10	10*10
ORNISTAR	1X10
ORNIVIL SUSP	1*30ML
ORNIVIL TAB	1*10
ORNIWELL TABLET	1X10
ORNIWELL TABLET	1X10
ORNOF 700MG	1X10T
ORNOF IV	1XV
ORNOF SUSP.	1X30ML
ORNOXIN TAB 10*10	1*10*TAB
OROCEPH 250 MG. TAB	1x10
OROCEPH 500 MG. TAB	1x10
OROCEPH DROP	1 PH.
OROCEPH KID	1x10
OROCEPH SYP.	1 PH.
ORODAZOL OZ TAB	10'S
ORODAZOL-OZ SUS	30ML
OROFER CAP	10'S
OROFER DROP	15ML
OROFER SYP	150ML
OROFER XT DROP	1x15ML
OROFER XT KIT	1x7KIT
OROFER XT SUSPENSION	1x150ML
OROFER XT TAB	1X10
OROFER XT TATOL TAB	1x10
OROFER XTM TAB	1x10
OROFER-S INJ	1x30ML
OROGARD M/WASH	150ML
OROGARD MOUTH WASH	1X60ML
OROPRAZ 40 TAB 10*10	1*10TAB
OROVIT ACTIV	1X10
OROVIT DROP	1X15ML
OROVIT MAX TAB	1X10
OROVIT SYP	1X200ML
OROVIT TAB	1X10
OROZINC DROP 15ML	1*15*ML
OROZINC SYP 60ML	1*60*ML
ORPRO	1X10S
ORS	1 PKT
ORS 28.5GM	1X28.5GM
ORS L FOS(APPLE)	1x200ML
ORS POWDER(ORANGE)	21.8GRAM
ORS-L APPLE	1x200ML
ORS-L LEMON DRINK	1x200ML
ORS-L PLUS ORANGE	200ML
ORTAN 20	1*10
ORTAN 40 TAB	1*10
ORTAN AM5	1*10
ORTAN H 40	1*10
ORTAN H20	1*10
ORTHO-AID 1*10	1*10
ORTHOCORT 12	1X6T
ORTHOCORT 18MG	1X6S
ORTHOCORT 24 MG	1X10S
ORTHOCORT 6 MG	1X6S
ORTHOFIT GEL 30GM/MC	M
ORTHOFIT-G TAB.6'S	1X6
ORTHOLIFE CAP	1*30
ORTHORUN MR	1x10
ORTHORUN PLUS	1x10
ORVAS 10MG	10'S
ORVIN ADULT DROP	1x10ML
ORVIN P	10ml
ORVIN PED DROP	1x10ML
OSEX CAP.	1x10
OSEX FORTE TAB.	1x10
OSEX SUSP.200ML.	1 PH.
OSICARE PLUS	10'S
OSIL CAP	1x10
OSIL CREAM	1X30GRM
OSIP 200 MG. TAB.	1x10
OSIP 30ML	1x30ML
OSIP 400MG TAB	1x15TAB
OSIP 60ML SYP.	60 ML.
OSIP M SYP.	60 ML.
OSIP TZ TAB.	1x10
OSIP-OD SUSP.30ML	1x30ML
OSIP-OD SUSP.60ML	1x60ML
OSIP-OD TAB	1x10
OSKAR-20 CAP 12*10	1x10xCap
OSKAR-DSR CAP 6*10	1x10xCap
OSL-B 100SYP	100ML
OSL-B 200MLSYP	200ML
OSLO 25MG TAB	1x10
OSLO 50MG TAB	1x10
OSMEGA 300MG	10'S
OSMOPRES(MANNITOL)100ML	1 PCS
OSRA SPA TAB	1X10
OSRA-500	1X10
OSRA-SPAS DS	1X10
OSSICARE- DS TABS	10'S
OSSILIFE TAB 5*10	1x10xTab
OSSOFEZ CAP 12*10	1x10xTab
OSSOFEZ SYP	1x200xMl.
OSSOMIN VET 450ML	PH
OSSOPAN 1000 TAB 10*10	1x10xTab
OSSOPAN 500 TAB 10*10	1x10xTab
OSSOPAN 500 TAB 10*15	1*15TAB
OSSOPAN 500(+)TAB 10*15	1*15TAB
OSSOPAN ALFA 10*15	1*15TAB
OSSOPAN BMD TAB 10*15	1*15TAB
OSSOPAN MCM TAB 1*30	1x30xTab
OSSOPAN MOM SYP 200ML	1*200ML
OSSOPAN OS KIT 1*31	1*31TAB
OSSOPAN PLUS TAB 10*15	1*15TAB
OSSOPAN-D SYP	1x200xMl.
OSSOWIN FORTE	1*10
OSTEBON 400MG	1X10T
OSTEBON PLUS	1X20S
OSTEBON SUSP	200ML
OSTEBON-M	1X10
OSTEFIT C PLUS	1*10
OSTEIW0N CAP	1X10
OSTEOCERIN TAB	1X10T
OSTEOCID CAP	1X10C
OSTEOCID-D CAP	1X10C
OSTEOFIT- XT 10*10	1*10
OSTEOFIT-C CAP 10*10	1*10
OSTEOFLEX TAB	1X10
OSTEOFOS 5MG TABS	10'S
OSTEOFOS 70MG TABS	4'S
OSTEOGOLD CAP	1*10
OSTEOHEAL CAP	1*10
OSTEOKIT 1*30	1*30
OSTEOKIT PLUS	1*10
OSTEONURON CAP	1X10C
OSTEOPHOS 10MG TABS	10'S
OSTEOSET CAP 10*10	1*10*CAP
OSTEOSET CAP 10*10	1*10*CAP
OSTEOSOLVE TAB 10*10	1*10*TAB
OSTEOVIN FORTE CAP	1X10
OSTEOVIN SUS	150 ML
OSTEOVIN-XT CAP	1X10
OSTICER(50MG)	1X10T
OSTIFLAV TAB 10*10	1*10*TAB
OSTIUM K2 TAB	1*15
OSTIWEL FORTE TAB 10'S	1X10
OSTO-B12 SYP	200ML
OSTOBONE TAB 3*10	1*10*TAB
OSTOCAL SYP	200ML
OSTOCAL TAB	1*10
OSTOCALCIUM TAB	60'S
OSTOCALCIUM-Z TAB	30'S
OSTOCALCUM FORTE	15'S
OSTOLIEF NUTRA	1X30T
OSTOPHOS LIQUID CONCENTRA	1KG
OSTOPOLYBION-D SYP	1*200*ML
OSTOREL TAB	1X10
OSTOROL SUSP	200ML
OSTOVET 1 LT	1 LT
OSTOVET 2LT.	1 PH.
OSTOVET 5 LT	5 LT
OSTOVET 500 ML	500 ML
OSTOVET FORTE 1 LT	1 LT
OSTOVET FORTE 5 LT	5 LT
OSTOVET FORTE 500 ML	500 ML
OSTOVIT DM TAB	10'S
OSUN -200MG TAB	1x10
OSUN-OZ TAB	1x10
OSYFEN-S TAB	1*10
OSYNAC-MR TAB	1*10
OTEK AC PLUS DROP	1x5xMl.
OTICHEK EAR DROP	1*5ML
OTIFLAM E/D	1*5ML
OTINA DROP	5ML
OTIS D CAP	1x15
OTIS 20 MG TAB	1x10
OTISAFE EAR DROP	1x5ML
OTIWEN EAR DROPS	5ML
OTOBIOTIC E/D	1*5ML
OTOBIOTIC PLUS E/D	1*5ML
OTOBIOTIC-SF E/D	1*5ML
OTOCIN DROP	1x5xMl.
OTOCIN-O DROP	1x5xMl.
OTOCLEAN EAR DROP	1*10
OTOFLU DROP	5ML
OTOGESIC DR	1x5xMl.
OTOREX E/D	1*5ML
OTOSCOPE 3000 MINI HEINS	1 PCS
OTOSCOPE HEINE MINI 2000	1 PCS
OTOSTAR DROP 10ML	1*10ML
OTOTIC DROP	1PHI
OTRIM BOLUS.	1x6BOLUS
OUT SUSP.	1*10ML
OUT TAB	1*1
OUTLET DROP	15ML
OVABLESS TAB	1*10
OVACARE FORTE TAB 10*6	1*6*TAB
OVACARE TAB 10*15	1*15*TAB
OVAFLO TAB 2X10	1*10TAB
OVAGEN 25 MG TAB	1x10
OVAGEN 50 MG TAB	1x10
OVAPRIM 10 ML	10 ML
OVARAL G TAB 10*20	1x20xTab
OVARAL L TAB 20*21	1x21xTab
OVARES CAP 5*10	1*10CAP
OVARYL FORTE SYP	200ML
OVARYL TAB	1*20
OVATONE CAPS 1X6	1X6
OVEL OZ TAB	1x10
OVEL-500 TAB	1x10
OVEL-500 TAB 20*10	1*10TAB
OVEL-750 TAB	1X10
OVEL-OZ SYP 30ML	1*30ML
OVEL-OZ TAB 20*10	1*10TAB
OVEM FORCEP 10" ST & CRB	1 PCS
OVIGYN D CAP 10*10	1*10*CAP
OVIGYN DSR TAB 10*7	1*7*TAB
OVIPHEN-25MG	1X10T
OVIPHEN-50MG	1X10T
OVITROP HP-75 INJ	1*1VAIL
OVOFAR 100MG TAB 30*5	1x5xTab
OVOFAR 50 MG TAB	1x5
OVOFAR TAB 50*5	1x5xTab
OVOUTOLINE SYP	200ML
OVSTORE	1X10T
OVULANTA KIT	KIT
OX BOLUS	1X6'S
OX KID FORTE TAB	1X10
OX-CL DRY SUS	30ML
OX-PLUS CAP	1x10
OXA 100 MG TAB	1x10
OXA 200 MG TAB	1x10
OXA 300 MG TAB	1x10
OXA 400 MG TAB	1x10
OXA M 60ML SUSP	1x60ML
OXA M SYP.30 ML.	1 PH.
OXA OZ SYP 30ML	1x30ML
OXA OZ SYP 60ML	1x60ML
OXA OZ TAB	1x10
OXA SYP.30 ML.	1 PH.
OXA SYP.60 ML.	1 PH.
OXA TZ TAB	1x10
OXA-C TAB	1x10
OXA-M SUSP 60ML (*)	1X60ml
OXACILIN L.A.50ML	VIAL
OXACLIN LA 30ml	VAIL
OXALGIN DP TAB 50*10	1x10xTab
OXALGIN DS BOLUS.	1x4B
OXALGIN DSP TAB 10*10	1*10*TAB
OXALGIN NANO GEL 1*30GM	1*30*GM
OXALGIN NP 15 ML	15 ML
OXALGIN NP BOLUS 1X4	1X4
OXALGIN-DS 30 ML	VIAL
OXALOBACT CAP	1X10
OXAPRO	1X10T
OXCARB 300	1X10
OXCIN OR SUSPN 30ML	1PH
OXCIN-M.SYU	1PH
OXCQ TAB 200MG 10*10	1*10*TAB
OXCQ TAB 400MG 10*10	1*10*TAB
OXECRAL SUSP	1*10
OXEE CHECK	1 PCS
OXERUTE CD	1X10
OXERUTE CREAM	1TUB
OXET 100 TAB	1x10
OXET 200 TAB	1x10
OXET OZ TAB	1x10
OXET SUSP	1x60ML
OXET-CF TAB	1x10
OXET-OZ SYP	1x60ML
OXETOL 150 TAB 10*10	1*10TAB
OXETOL 300 TAB 10*10	1*10TAB
OXETOL 450 TAB 10*10	1*10TAB
OXETOL 600 TAB 10*10	1*10TAB
OXETOL XR 150 TAB 10*10	1*10TAB
OXETOL XR 300 TAB 10*10	1*10TAB
OXETOL XR 450 TAB 5*10	1*10TAB
OXETOL XR 600 TAB 5*10	1*10TAB
OXI-2M GRANULES	1x200GM
OXI-2M TAB	1X10
OXIDEX CAP.10'S/SB	S
OXIGAT DROP	5ML
OXIMET (PAEDIATR)	1X10ML
OXIMET PP CAP	1X10
OXIN 100 TAB	1X10
OXIN PLUS TAB	1X10
OXINAM AMP	1ML
OXIPOD 100 DT	1X6
OXIPOD 200	1X6
OXIPOD 50	1X30ML
OXIPOD 50 DT	1X10
OXIPOD DROP	1PH
OXIRON 300ML	1PH
OXIRON CAP	1*15
OXIRON JR SYP	100ML
OXIRON SYP	200ML
OXIRON Z DROPS	15ML
OXITARD CAP 3*10	1*10CAP
OXIVIT CAP	1x15
OXOFERIN SOLUTION	30ML
OXOP E/D	1*10ML
OXOP-D E/D	1*10ML
OXRING 150	1X10 TAB.
OXRING OD 300MG	1X10T
OXRING OD 600MG	1X10 T
OXUM SOLN.	1X250ML
OXUM SOLUTION	1X100ML
OXUM SOLUTION	1X500ML
OXWAL OZ TAB 10*10	1*10*TAB
OXWAL TAB 400MG 10*10	1*10*TAB
OXY 100 ML	100 ML
OXY 100 ML.	VIAL
OXY 100 ml	vial
OXY 100ML	
OXY 100ML	1VIL
OXY 100ML	VIAL
OXY 30 ML	30 ML
OXY 30 ML.	VIAL
OXY 30ML	1*30ML
OXY 30ML	VIAL
OXY 30ML MARK	1VIL
OXY 50 ML.	VIAL
OXY 50ML	VIAL
OXY LA 30ML.	VIAL
OXY SET SAFTI	1 PCS
OXY-G CAP	1X10
OXY-MASK (C) PARA	1 PCS
OXY-MASK(A)	1 PCS
OXYGEN BULK	1 CUM
OXYGEN CONCENTRATOR SINGLEFLOW OCJA	1 PCS
OXYGEN CYLINDER COMPLIT SET	1 SET
OXYGEN CYLINDER SET	1320 LTR
OXYGEN RIGULATOR DOUBLE GAUGE	1 PCS
OXYGEN TROLY	1 PCS
OXYGLOW TAB	1*10
OXYGON CAP	1x10
OXYLIFE CAP	1X10
OXYMAC BOLUS	1X2
OXYMARK CD 1*10	1*10
OXYMET NASAL DROP	1x10 ML.
OXYNEX 100ML	100 ML
OXYPUR SYRUP	60ML
OXYPUR TAB	1x10
OXYRON 100 CAP	1x10
OXYRON 100 INJ	1x2ML
OXYRON 200 CAP	1X10
OXYSET ADULT	1 PCS
OXYSET C	1 PCS
OXYSPAS 2.5	1X10
OXYSPRAY NASAL SPREY	1*1*PC
OXYTADOL-P TAB	1*10
OXYTAFLAM	1*10
OXYTET HYDRO SKIN OINT	1 TUBE
OXYTETCYL.500MG	1x4
OXYTETRA.VET	1X4
OXYTOCINE INJ.	1x1AMP
OXYTOXIN 2ML AMPL INJ	1 AMP
OXYVES 50MG 100ML	PH
OXYVES-125 IU 20ML	20ML
OXYVIT-19 CAP	1x10
OXZOL SUS.15ML	1X15ML
OXZOLE BOLUS	1X1'S
OYCAL-D TAB	1*10
OZ- 60ML SYU	60ML
OZ.30ML.SYU	1PH
OZAFLO 200	1X10T
OZICIN DROP	30ML
OZOCAL SOFT GELATIN CAP	1X10
OZOLAB D.T.	1X10
OZOLAB POW 1*30	1*1
OZOLID 1200 SR	1X5 TAB.
OZOMET 500	1*10
OZOMET G1 TAB	1*10
OZOMET G2 TAB	1*10
OZOMET PG 1	1*10
OZOMET PG1 TAB	1*10
OZOMET PG2 TAB	1*10
OZORED SYP	1*1
OZORED TAB	1X10
OZOTEL TAB	1*10
OZOTRON MD 10*10	1*10
OZOTRON SYP	1*1
OZOVAS 10 TAB	1*10
OZOVAS F TAB	1*10
OZOWITE TAB	1X10
P 40 TAB 10*10	1x10xTab
P DEPOT AMP 3 ML	3 ML
P R B CAP	1X10C
P-125 DROP	1x10xMl.
P-125 SYP 60ML	1x60xMl.
P-125 TAB 25*10	1x10xTab
P-20	10'S
P-250 SYP	1x60xMl.
P-250 TAB 50*10	1x10xTab
P-500 SYP 60ML	1*60ML
P-500 TAB 20*10	1*10TAB
P-650 TAB 10*10	1x10xTab
P-750 TAB 10*10	1x10xTab
P-BIOTICS CAP 10*10	1*10CAP
P-BIOTICS KID SACHET 10*1GM	1*1GM
P-CAINE E/D	1*5ML
P-COL EAR DROP	1x5 ML.
P-DOM SR CAP 10*10	1*10
P-DON TAB	1x10TAB
P-FIXIM 50 DRY SYP	30ML
P-FIXIM CV 200TAB	1*10
P-GABA PLUS CAP	1X10
P-LONE E/D	1*5ML
P-PPI TAB	1x10
P-THRIN CREAM	1X30GM
P-TOP 40MG	1*10
P-TOP D CAP	1*10
P-TOP D TAB	1*10
P-TOP-40MG INJ	1*1
P. DEPOT 2 ML	2 ML
P.D.CAL	1X10
P.N.V. TAB 1*0	1*10
P.O.P 1 KG.**	1 PH.
P.O.P 1/2 KG.**	1 PH.
P.O.P 1KG JAR (NEELKANTH)	1 KG
P.O.P 2KG**	1
P.O.P 5KG.	1x5KG
P.P.C TAB	1X10
P.PLEX.10ML	1VIL
P.PLEX.30ML.	1VIL
P.PPI 40MG TAB	1x10
P.TRACTION BELT 28"	1 PCS
P.TRACTION BELT 30"	1 PCS
P.TRACTION BELT 32"	1 PCS
P.TRACTION BELT 34"	1 PCS
P.TRACTION BELT 36"	1 PCS
P.TRACTION BELT 38"	1 PCS
P.TRACTION BELT 40"	1 PCS
P.TRACTION BELT 42"	1 PCS
P.TRACTION BELT 44"	1 PCA
P.U.C	1X10T
P.U.C 250 SUSP.	1X60ML
P.U.C 650	1X10T
P.U.C SUSP.	1X60ML
P.V.6 VIZ.TAB/SB	S
P2 IL	1X10 TAB.
P2I	1X10T
P2I D	1X10C
P2I FAST	1X10T
P2I PLUS	1X10C
P2I-IV	1XV
PABADIN 4 BOLUS.[HAWA]	1x4B
PACHOPLUS BOLUS.	1x4B
PACIMOL DROP	1x15xMl.
PACIMOL DS SYP	1x60xMl.
PACIMOL PLUS TAB 10*10	1x10xTab
PACIMOL SYP	1x60xMl.
PACIMOL TAB 20*10	1x10xTab
PACIMOL TAB 650MG 10*10	1x10xTab
PACIMOL XP TAB 20*10	1*10*TAB
PACITANE TAB 98*10	1x10xTab
PACROMA CREAM	1*10MG
PACTIV 10MG	1*100ML
PACYL TAB 0.25MG 20*10	1x10xTab
PADMINI TAB	1X10
PAIN KILLER OIL 100ML	100ML[131]
PAIN RELIEF TAB	1*10
PAIN RELIEF TAB	1x10
PAINCARE 100ML	1X100ML
PAINCARE 30ML	1X30ML
PAINCARE VAIL 100ML	1x100ML
PAINCARE VAIL 30ML	1x30ML
PAINGARD.OIN	
PAINIL PLUS TAB	10'S
PAINIL TAB	10'S
PAINTROL TAB 1*10	1x10xTab
PALIDO-OD 3	1X10T
PALIDO-OD 6	1X6T
PALIDO-OD 9	1X10T
PALIF TAB.10'S	1X10
PALIF-SP TAB.10'S	1X10
PALIO TAB	1x10
PALIO-D CAP	1x10
PALIRIS 3 TAB 1*14	1*14TAB
PALIRIS-6 TAB 1*14	1*14TAB
PALITEX TAB 10*10	1*10*TAB
PALLRYWYN SILVER TAB	1X30
PALOZAC	5'S
PALOZAC 0.50	1PH
PAMAGIN C SYP	1*60*ML
PAMAGIN C TAB 10*10	1*10*TAB
PAMAGIN GOLD 1*10	1*10
PAMAGIN GOLD 60ML	60NL
PAMAGIN P TAB 1*10	1*10
PAMAGIN PLUS TAB 10*10	1x10xTab
PAMPER XL TAB	1x10
PAN 20MG	1X10T
PAN 40MG	1*15
PAN IT	1X10C
PAN IV	1XV
PAN MPS O SUS	200ML
PAN MPS(200ML)	200ML
PAN-D	1X10C
PAN-L	1X10C
PAN-OFF BOLUS	1*10
PANACT 250MG SYP	1x60ML
PANACURE 1.5 GM. BOLUS	5x2
PANACURE 150 MG. TAB.	5x10
PANACURE 6 GM. POWDER	1x10
PANBROM E/D	1*5ML
PANCEF 125MG INJ	1XVIAL
PANCEF 1GM INJ	1X1V
PANCEF 250MG INJ	VIAL
PANCEF 500MG INJ	1XV
PANCEF DT 100MG	1X10T
PANCEF O LB 200	1X10C
PANCEF O LB D/S	1X30ML
PANCEF-AZ 100 TAB	1*10
PANCEF-AZ TAB	1*10
PANCEF-O 100MG DT	1X10
PANCEF-O 200MG	1X10S
PANCEF-O D/S	30ML
PANCEF-O LB 100MG	1X10C
PANCEF-O100D/S30ML	30ML
PANCEF-OF TAB	1*10
PANCEF-S 1.5GM	1XV
PANCEF-S 375MG INJ	1XV
PANCEF-S 750MG INJ	1XV
PANCH TULSI DROP	
PANCH TULSI DROP	1PH
PANCHARISHTA SY	450ML
PANCHASKAR CHURN 20GM	20GM
PANCHSAKAR CHURNA	30 GMS
PANCHSAKAR CHURNA	60G
PANCIP 500MG	10
PANDEC-40 ING	VIAL
PANDEC-GEL	170GM
PANDERM +	1X15GM
PANDON TAB	1X10
PANDOSTAL CAPS	1x10
PANDOSTAL OD CAP	1x10
PANDOSTAL OD CAP	1x10
PANDOX 200MG TAB	1X6T
PANDOX DRY SY	1X30ML
PANFAST 40	1X10T
PANFAST 40MG VIAL	1X1V
PANFAST DSR TAB	1X10
PANFUGAL BOLUS	1x1B
PANGAS AT	1*10
PANGORAL GEL	1*15GM
PANINOX DSR	1*10
PANIVO-40	1*10
PANKREOFLAT TAB 10*10	1*10*TAB
PANLIFE-DSR	1*10
PANLIPASE	1X10S
PANMIC TABS	1*10
PANOC 40INJ	1 VAIL
PANOC DXR	1X10TAB
PANOPAZ IV INJ 40MG	1XVIAL
PANOPAZ TAB	1X10
PANOPAZ-D CAPS	1X10
PANOPRAZ DSR	10'S
PANPAX-DSR	1x10
PANPLUS D CAP 40MG 10*10	1*10*CAP
PANPLUS L TAB 10*10	1*10*TAB
PANPLUS TAB 40MG 10*10	1*10*TAB
PANPREZOL-DSR	1*10
PANSA D	1X10T
PANSA I V 40MG	1XVIAL
PANSA TAB 40MG	1X10T
PANSA-DSR	1X10C
PANSAFE TAB 1*10	1*10
PANSAFE-D 1*10	1*10
PANSEC DSR	1X10
PANSEC IV 10ML	10ML
PANSEC RH TAB	10S
PANSEC RX TABS	10'S
PANSEC TAB 40MG	10'S
PANSORAL GEL	1*15GM
PANSTAL CAPS	10'S
PANSTRIKE 40MG	VIAL
PANSTRIKE TAB	1x10
PANSTRIKE-D CAP	1x10
PANSUN-40MG TAB	1X10
PANTA TAB	1x10TAB
PANTA D PLUS TAB	1x10TAB
PANTA-D	1X10
PANTABION 100ML SY.	1X100ML
PANTABION CAP	1x10
PANTABION SYP 200ML	1X200ML
PANTAC DSR CAPSULES	1X10
PANTAC TABLET	1X10
PANTACID TAB	1*10
PANTACIN INJ 1ML	1ML
PANTACOL TAB	1X10
PANTAGON	1X10T
PANTAGON DM	1X10C
PANTAGON INJ	1X10ML
PANTAKIND DSR TAB 6*10	1x10xTab
PANTAKIND FAST TAB 4*10	1x10xTab
PANTAKIND INJ	1x1xVl.
PANTAKIND TAB 8*10	1x10xTab
PANTAKIND-FLUX CAP 3*10	1*10CAP
PANTAL 40 10S	1*10
PANTAL-D TAB. 10S	1*10
PANTALED-40 TAB	1X10
PANTALED-D TAB	1X10
PANTALKA 40MG	1X10
PANTALOC 40MG	1X10
PANTALOC DSR	1X10
PANTANAM TAB	1x10
PANTANAM-D TAB	1x10
PANTASUR 10 INJ	1*1
PANTASUR DSR TAB	1*10
PANTASUR TAB	1*10
PANTAVON-D CAP	1x10
PANTAVON-IV	1 VAIL
PANTAWIN D CAP 1*10	1*10
PANTAX 40 INJECTION	1 VIAL
PANTAZ	10'S
PANTEC DSR CAP 10*10	1x10xCap
PANTEC I.V.	1x1xVl.
PANTEC PLUS CAP 10*10	1x10xCap
PANTEC-20 TAB 10*10	1x10xTab
PANTEC-40 TAB 10*10	1x10xTab
PANTEC-D CAP 10*10	1x10xTab
PANTHEGEL E/GEL	1*5GM
PANTHOR DX SYP	1x100ML
PANTHOR PLUS SYP.	1 PH.
PANTHOR SYP.100 ML.	1 PH.
PANTHOR SYP.450 ML.	1 PH.
PANTIN 40MG TAB	1X10
PANTIN D TAB	1X10
PANTIN FR	1X10
PANTIN IV	1X1
PANTIN L CAP	1X10
PANTIN Z CAP	1X10
PANTIUM 40 TAB 10*10	1x10xTab
PANTIUM DSR CAP 10*10	1x10xCap
PANTOCALAM D CAP	1X10
PANTOCALM I.V	1VAIL
PANTOCID 20TAB 15*10	1*10TAB
PANTOCID 40 TAB 15*10	1*10TAB
PANTOCID HP KIT 7*6	1*6TAB
PANTOCID I.V.	1*1VAIL
PANTOCID IT CAP 10*10	1*10CAP
PANTOCID-D TAB 10*10	1*10TAB
PANTOCID-DSR TAB 10*10	1*10TAB
PANTOCID-L TAB 5*10	1*10TAB
PANTODAC DSR CAP 10*10	1x10xCap
PANTODAC I.V. 40MG	1x1xVl.
PANTODAC IT CAP 10*10	1x10xCap
PANTODAC TAB 20MG 20*10	1x10xTab
PANTODAC TAB 40MG 25*10	1*10*TAB
PANTOFIT DSR TAB	1X10
PANTOFIT-20MG TAB	1X10
PANTOGEM I.V	1VIAL
PANTOGEM-40MG.TAB	1X10
PANTOGEM-D.TAB	1X10
PANTOGEM-D.TAB	1X10
PANTOGEM-DSR CAP	1x15
PANTOKEM-40TAB	10*10
PANTOLINE 40 1*10	1*10
PANTOLINE D301*10	1*10
PANTOLINE-D SR CAPSULE	1*10
PANTOLIP TAB	1X10
PANTOLIP-D TAB	1X10
PANTOLIP-IV40MG	1X1
PANTOLUP -40 TAB	1X10
PANTOLUP INJ.	1 AMP
PANTOMIL-DSR	1*10
PANTOP 20	1X10T
PANTOP 40MG	1X15T
PANTOP 40MG INJ	1XV
PANTOP FAST	1X10T
PANTOP IT	1X10C
PANTOP LS	1X10C
PANTOP PLUS	1X10C
PANTOP-D	1X10T
PANTOP-DSR	1X10C
PANTOP-HP	1XKIT
PANTOP-M CAP	1X10
PANTOPIK 40 TAB 10*10	
PANTOPIK DSR CAP 10*10	
PANTOSPEY TAB	1*10
PANTOSPEY VIAL	40 MG
PANTOSPEY-D CAPS	10
PANTOSPEY-DSR	1*10
PANTOSPEY-L TAB	1*10
PANTOTAB DSR CAP 10*10	1*10*TAB
PANTOTAB TAB 40MG 10*10	1*10*TAB
PANTOVAR 40MG INJ	1 VAIL
PANTOVAR DSR TABLET	
PANTOXID TAB	1x10
PANTOXID-D TAB	1x10
PANTOXID-DSR CAP	1x10
PANTOZAM-L	1*10
PANTOZAM-SR CAP	1*10
PANTOZE 40 TABLET	1X10
PANTOZE DSR CAPSULES	1X10
PANTOZE I.V INJECTION	1X40 MG
PANTRA -D TABS	10'S
PANTRA- IV	1'S
PANTRA-100MG INJ. 2ML	
PANTRA-40MG	10'S
PANTRA-50MG CAP. 10'S	
PANTRA-50MG INJ. 1ML	
PANTUS-40 TAB	1*10
PANTUS-DSR CAP	1*10
PANVATE DSR CAPSULES	1X10
PANVET BOLUS	1X5'S
PANVET-80 inj.	1X1VIAL
PANVISTA 20MG TAB	1X10
PANVISTA 40MG TAB	1X10
PANVISTA D TAB	1X10
PANZ 40MG INJECTION	1 VIAL
PANZA 40 TAB	1x10
PANZA DSR CAPS	1x10
PANZEN-40 1*10	1*10
PANZEN-D 1*10	1*10
PANZEN-DSR 1*10	1*10
PANZER -40MG TAB	1*10
PANZER 40MG TAB	1*12
PANZER D TAB	1*12
PANZER DSR	1*10
PANZER IV	1*1
PANZER-DSR CAP	1*10
PANZOLE TAB	1x10
PANZYME-N	1X10
PANZYNORM HS TAB 1*10	1*10*TAB
PAPER TAPE	1 PCS
PAPITAZYME SYP	1x200 ML
PAPULAX CREAM 20GM	1*20GM
PARA-ME PLUS BOLUS	6X4'S
PARACAIN DROP	5ML
PARACETAMOL	1 TAB
PARACETOL 30ML.	VIAL
PARACIN OVAL TABS	1X30
PARACIN TABS(R)	1X15
PARACIP IV	1PHI
PARACIP TAB	1X10
PARACOD TAB	4'S
PARACOLD.DROP.	1PH
PARACON SYP	1*60ML
PARACON TAB	1*15
PARADIL-S TAB	1X10
PARADISE XR 12.5	1X10T
PARADISE XR 25	1X10T
PARAFAST DROPS	15ML
PARAFAST SUSP.	60ML
PARAFAST TAB	4'S
PARAFENAC TAB	1X10
PARAFFIN WAX (PHYSIO)	400 GM.
PARAFIZZ 650 TAB	1X4
PARAGESIC-SP	1*10
PARALAPS TAB	100'S
PARALDIM 125 SY	1PHI
PARALGIN DP-BOLUS	1x6BOLUS
PARALGIN N-P BOLUS	1x6 BOLUS
PARALITOL 200	200ML
PARALITOL 30	30ML
PARALITOL100	100ML
PARALITOL112	112ML
PARALITOL400	400ML
PARALITOL50	50ML
PARAMET TAB 25*10	1*10*TAB
PARANAC PLUS TAB	1x10
PARANAC-S TAB	1x10
PARANDIAL 0.2	1X10
PARANDIAL 0.3	1X10
PARANDIAL M 0.2	1X10
PARASAFE 650 TAB	10*10
PARASAFE DROP	15 ML
PARASAFE SUSP	60 ML
PARASAFE TAB	20*10
PARASAFE-250 SUSP	60 ML
PARASUIT SUSP.	1x30ML
PARASUIT SYP 60ML	1x60ML
PARASUIT-125	1x60ML
PARASUIT-250	1x60ML
PARATOP-650 TAB	1X10
PARAXIN CAP 250MG 30*10	1x10xCap
PARAXIN CAP 500MG 20*6	1x6xCap
PARAXIN SYP 100ML	1*100*ML
PARCEF INJ 10ML	1x10ML
PARCOUGH 100ML	1
PARDIFEN A SUSP	60 ML
PARDIFEN A TAB	1*10
PARDIFEN ACTIVE GEL	30GM
PARDIFEN AQUA ING	1ML
PARDIFEN-650 TAB	1*10
PARDIFEN-MR TAB	1*10
PARDIFEN-SP	1*10
PARDOM DP 30 ML	1
PARGLY-F30ML.SYU	1PH
PARGYL -FD TAB	1x10
PARI CR TAB 12.50MG 10*10	1*10*TAB
PARI CR TAB 25MG 10*10	1*10*TAB
PARID INJ.1ML	1X1ML
PARID POR-ON 50ML	1X50ML
PARIT D CAP	10'S
PARIT TAB	10'S
PARKITIDIN TAB 5*10	1*10TAB
PARMOL TAB	1X15
PARMOL 60ML SYP	1PH
PARMOL TAB	1x10
PAROVI TAB 10'S	1X10
PARPROVIT 200ML SYP	1PH
PARTOCIN INJ 10 1ML	1ML
PARTOCIN INJ 1ML;	1ML
PARVIT 30 ML DP	1DP
PARXYL 250 DT TAB	1X10
PARXYL 500 TAB	1x10
PASER-D TAB	1x10
PASFLAM TAB	1X10
PASHU RAKSHA 500 GM.	PH
PASHUPAIN INJ 50 ML	50 ML
PASHUPAIN N INJ 50 ML	50 MLL
PASM TAB	1*10
PASM-80	1X10
PASM-P	1X10
PASUGEN 10	1X10
PASUGEN 5	1X10
PATADAY E/D	1*2.5ML
PATADIN TAB	1*10
PATALO E/D	1*5ML
PATANOL E/D	1*5ML
PATERNIA + TAB 10*10	1*10*TAB
PATERNIA TAB 10*10	1*10*TAB
PATH 15	1X10T
PATH 30	1X10T
PATH 7.5	1X10T
PATIENT STOOL	1 PCS
PATRANGASAVA 450 ML	1 PH
PAUSE 500 MG TAB	1x10
PAUSE 5ML INJ.	1*1AMP
PAUSE D TAB	1x10
PAUSE INJECTION	1x5ML
PAUSE MF TABLET	1x6TAB
PAUSE XT TAB	1x10
PAXEM DRY SYP	1X30ML
PAXID-S SYRUP	1X200ML
PAXIDEP CR 12.5 TAB 10*10	1*10TAB
PAXIDEP CR 25 TAB 10*10	1*10TAB
PAXIDEP CR 37.5 TAB 5*10	1*10TAB
PAXIN TABLET	1x10
PAXMAX	1X10T
PAXOL MR TAB.	1X10
PAXUM INJ.	1x10AMP.
PAXUM TAB.	1x10
PAXY CR 25 MG TBALET	1X10
PAXZYME 100ML	100ML
PAXZYME SYRUP	200ML
PAYAPRO BOLUS.	1x4B
PAZACE 500	1X100ML
PAZES 40 TABLET	1x10
PAZOM 40MG TAB	1X10
PAZOM D TAB	1X10
PAZUMAC	1X100ML
PD CAP	1*10
PD FLAM TAB 1*10	1*10
PD MOX 250 LB 1*10	1*10
PD-ROX 150 1*10	1*10
PDN DROP	1x15 ML
PEALL-120 SUS	60ML
PEALL-125 SUS	60ML
PEALL-250 SUS	60ML
PEALL-500MG	1*10
PEALL-DROP	15ML
PEALL-MF 250	60ML
PEALL-MF SUS	60ML
PECEF 100 SYP	1x30xMl.
PECEF 100 TAB 10*10	1x10xTab
PECEF 200 TAB 10*10	1x10xTab
PECEF 50 SYP	1x30xMl.
PECEF 50 TAB 10*10	1x10xTab
PECEF DUO 200 TAB 1*10	1*10TAB
PECEF DUO 50 SYP	1*30ML
PECOUGH SYP	100ML
PECTICLO-P 1*10	1*10
PED-OZ SUSP	30ML
PEDCAL TAB	1x10
PEDCOF SYU	60ml
PEDIA DRIP (SAFETY)	1 PCS
PEDIA SYP	1x50xMl.
PEDIA-DRIP	1 PCS
PEDIALYTE 90	1PH
PEDIATOTAL CHOCO.	1X200 GM
PEDIATOTAL VANILA	1X200GM
PEDIATRIC SET	1 PCS
PEDIC DROP 15ML	15ML
PEDIC SYP 200ML	20ML
PEDICLORYL SYP	1x30xMl.
PEDIGREE 1 KG	1 KG
PEDIGREE 1.2KG ADULT	1x1.2kg
PEDIGREE 1.2KG PUPPY	
PEDIGREE ACTIVE ADULT 3KG	3 KG
PEDIGREE ADULT 500GM	500GM
PEDIGREE ADULT 1.2 KG	1.2 KG
PEDIGREE ADULT 3 KG	3 KG
PEDIGREE ADULT 3KG	3KG
PEDIGREE CHICK / VEG 10KG	10 KG
PEDIGREE CHICK/VEG 3 KG	3 KG
PEDIGREE CHICKEN$VEG 500	500 GR
PEDIGREE MEAT/RICE 3 KG	3 KG
PEDIGREE MEAT/RICE 500 GR	500 GR
PEDIGREE PUPPY 1.2 KG	1.2 KG
PEDIGREE PUPPY 3KG	3 KG
PEDIGREE PUPPY 3KG	3KG
PEDIGREE PUPPY 500GM	500GM
PEDIGREE PUPPY{R} 500 GR	500 GR
PEDIGREE SMALL ADULT500GR	500 GR
PEDIGREE\MILK\RICE\VEG 3K	
PEDIGREE\MILK\RICE\VEG 3K	3 kg
PEDIXIM 100MG TAB(1x10)	1x10
PEDIXIM 200	1*10
PEDIXIM 200MG TAB(1x4)	1x4
PEDIXIM SYP	30ML
PEDPRO DAILY	1X200GM
PEDPRO POWDER	1X200GM
PEDPRO POWDER	1X400GM
PEG SR TAB 75MG 10*10	1*10*TAB
PEGMOVE	1X119GM
PEKTOCIDE	15 ML
PEKTOCIDE 50 ML	50 ML
PELOX 400 TAB 10*10	1x10xTab
PELVIC TRACTION BELT 30	1 PCS
PELVIC TRACTION BELT 34"	1 PCS
PELVIC TRACTION BELT 36"	1 PCS
PELVIC TRACTION BELT 38"	1 PCS
PELVIC TRACTION BELT 40"	1 PCS
PELVIC TRACTION BELT 42"	1 PCS
PELVIC TRACTION BELT(L)	1 PCS
PELVIC TRACTION BELT(M)	1 PCS
PELVIC TRACTION BELT(S)	1 PCS
PELVIC TRACTION BELT(XL)	1 PCS
PELVIC TRACTION KIT	1 PCS
PELWIN TAB	1X4
PEN D TAB	1X10
PEN TAB	1X10
PEN-JA OIL	50ML
PENCIP LAC 2 TAB	1x6
PENCIP LAC 4 TAB	1x6
PENCIP LAC 8 TAB	1x6
PENCOM LA12 1*5	1*5*VIAL
PENCOM LA6 1*5	1*1*VAIL
PENDISTRIN SH	TUBE
PENEGRA XPR 50MG 25*4	1x4xTab
PENETAL TAB 30MG 10*4	1*4*TAB
PENHANCE 150MG	1XV
PENHANCE 228.5 DP	1X30ML
PENHANCE 300MG	1XV
PENHANCE 625	1X6T
PENHANCE DD	1X6T
PENHANCE INJ 1.2GM	1XV
PENIDURE LA-12	1x5xVl.
PENIDURE LA-6	1x5xVl.
PENORID 100 INJ	2ML
PENSBIOTIC MD 2.5 GR	2.5 GR
PENTACON 40MG TAB	1*10
PENTACON D TAB	1*10
PENTAFLOX (OFLOXACIN) 100 ML	1 ML.
PENTAFOL- DSR 1*10	1*10
PENTALAB	1 AMP
PENTALINK 40IV INJ	1X1
PENTALINK TAB	1X10
PENTALINK-D CAP	1X10
PENTALYTE-M 500ML	1 BOT
PENTALYTE-P (P)	500 ML.
PENTANERV -M	1X10 TAB.
PENTANERV -NT	1X10 TAB.
PENTANERV 450 SR	1X10T
PENTANERVE 100	1X10T
PENTANERVE TAB	1X10
PENTATE 40 MG	1X10
PENTAZOL METRONIDAZOL (P)	100 ML.
PENTIDS TAB 200MG 30*6	1x6xTab
PENTIDS TAB 400MG 30*6	1x6xTab
PENTIDS TAB 800MG 30*4	1x4xTab
PENTO-D TAB	1X10
PENTO.40MG.TAB	1X10
PENTOCID 1*10	1*10
PENTOCIP-D 1*10	1*10
PENTOD TAB	1X10
PENTOPEN 40	1X10
PENTOPEN INJ 10ML	
PENTRA-40	1x10
PENVIR 250	1X10
PENVIR 250	1X6
PENVIR 500	1X10
PENVIR 500	1X10
PEOPEPTIN DROP	15ml
PEOPEPTIN SYU	60ml
PEP-D CAP	1x10CAP
PEPAMINO TAB	1X10
PEPAR -15MG TAB	1X10
PEPAR -30MG TAB	1X10
PEPCIA-10 TAB 10*10	1x10xTab
PEPCIA-20 TAB 10*10	1x10xTab
PEPCIA-D CAP 10*10	1x10xTab
PEPFIZ JAR	25STP
PEPLIN 100ML	100ML
PEPLIN 500ML	1X500ML
PEPMARK-SRD TAB	1*10
PEPP 40MG TAB	1x10
PEPRAZINE SYP 30 ML	1x30 ML
PEPSID 10 ML.	VIAL
PEPSID 30 ML.	VIAL
PEPSID C 10 ML	10 ML
PEPSID C 30 ML	30 ML
PEPTARD FAST TAB 10*10	1x10xTab
PEPTARD-20 TAB 20*10	1x10xTab
PEPTARD-D TAB 20*10	1x10xTab
PEPTICA GEL	200ML
PEPTICA TAB	10'S
PEPTICA Z CAPS	10'S
PEPTICAIN GEL	120 ML.
PEPTTARD-IT CAP 20*10	1x10xCap
PERCIN	1X5T
PERDAY CAPSULES	1*10
PERDAY DROP	30ML
PERDAY POWER	200GM
PERFALGAN	100ML
PERFALGAN 0.5GM/50ML	1 BOTT.
PERFECT DROPS	15ML
PERFECT-OD TAB	1X10
PERFECTIL TAB 5*6	1*6*CAP
PERIARK-DSR CAP	1*10
PERIGARD 2MG TAB	1X10
PERIGARD D TAB	1X10
PERIGARD DF TAB	1X10
PERIGARD-4MG TAB	1X10
PERINORM 2ML INJ	1 AMP
PERINORM AMP 1*5 AMP	1*5*AMP
PERINORM CD CAP 20*10	1*10*CAP
PERINORM SYP/DROP	1x30xMl.
PERINORM TAB 20*10	1x10xTab
PERINORM VIAL	1x10xMl.
PERISET INJ 10*2ML	1*2*AMP
PERISET MD TAB 10*10	1x10xTab
PERISET SYP	1x30xMl.
PERISET TAB 4MG 10*10	1x10xTab
PERISET VAIL 1*10ML	1*10*ML
PERITOL PED DROP	1x30ML
PERITOL SYP	1x200ML
PERITOL TAB 25*10	1*10
PERITOL-G SYP	1x200ML
PERIVELAN	10
PERMISAFE CAP	1X10C
PEROBAR 2.5%	1PH
PEROBAR 5% BAR	75GM
PERODUO GEL	15GM
PEROWASH 2.5	50GM
PERSANTIN TAB 100MG 10*10	1x10xTab
PERSANTIN TAB 25MG 10*10	1x10xTab
PERSOL AC 2.5% GEL	1*20*GM
PERSOL AC 5% GEL	1*20*GM
PERTUM INJ 4.5GM	1x1xVl.
PERUM SYRUP	100ML
PESULIN MFL BOLUS	1X4
PESUREA BOLUS	1X4
PETBACIN OINT.	TUBE
PETHIDE TAB	1X10
PETIN CR 12.5	1X10T
PETIN CR 25	1X10T
PETIN CR 37.5	1X10T
PETMOSOL ADORE SOAP	1X1
PETMOSOL SOAP.	PH
PETROMOX 3GM	1X3GM
PEVESCA PLUS CAP 10*10	1*10*CAP
PEXCEP CR 12.5 10*10	1x10xTab
PEXCEP CR 25 TAB 10*10	1x10xTab
PEXCEP CR 37.5 TAB 5*10	1x10xTab
PEXCEP-10 TAB 10*10	1x10xTab
PEXCEP-20 TAB 10*10	1x10xTab
PEXONE S 1.5	
PEXTI-CR 12.5	1*10
PEXTI-CR 25	1*10
PFIZER MILK FEVER FORMULA	450ML
PG 15	1X25S
PG 30	1X25T
PH 4 SYP.	1 PH.
PH 4 TAB	1x10
PH.DIGEST 500ML	1X500ML
PH.LIV VET 1LT	1X1LT
PH.LIV VET 500ML	1X500
PH.MORE MILK TAB	1X100TAB
PH.UTEROL 500ML	1X500ML
PH.UTEROL SYP 1LT	1X1LT
PH4 800-CHOC TAB	1*10
PH4 LIQUID.	170ML
PHALA GHRIT 100GM	100GM[147]
PHALIN 100MG	1X10T
PHALIN 300MG	1X10T
PHARCEF 50 DRY SYP	30ML
PHARCEF 50 DT TAB	10TAB
PHARCEF-200 TAB 10*10	1*10TAB
PHELADELPHIA COLLER	1 PCS
PHEMINEX FORTE	1x10
PHENARGAN AMP 1*12AMP	1x12xAmp
PHENARGAN PLUS SUSP.	1*60*ML
PHENARGAN SYP 100ML	1x100xMl.
PHENARGAN TAB 10MG 50*10	1x10xTab
PHENARGAN TAB 25MG 50*10	1x10xTab
PHENCODIN 100ML	100ML
PHENERGAN INJ	2 AMP
PHENICOL.60ML.SYU	1PH
PHENIL EYE DROP	1*5ML
PHENIRAMINE MALEATE 30 ML	30 ML
PHENOBARBITONE INJ 1*6AMP	1x6xAmp
PHENSICOD SYP 100 ML	1X100 ml
PHENYKEM 100	1X10T
PHENYKEM 300	1X10T
PHENYKEM INJ.	1X2ML
PHENYKEM SYP.	1X200ML
PHENYTOL-30 TAB 10*10	1x10xTab
PHENYTOL-50 TAB 10*10	1x10xTab
PHETAL DOPPLER	1 PCS
PHEXIN 500MG	10,S
PHEXIN BD-375MG	10'S
PHEXIN CAPS 250MG	10'S
PHEXIN DROP	10ML
PHEXIN DRY SY	30ML
PHEXIN DT250MG	10'S
PHEXIN KID TAB	10'S
PHEXIN REDISYP 125MG	30ML
PHEXIN REDSY 250MG	60ML
PHEXIN-BD/750MG	10'S
PHEXIROM -500MG	10'S
PHEXIROM 250 DT	10'S
PHIL POWDER	10KG
PHIL POWDER 1KG	1KG
PHIL POWDER 2.5KG	
PHILADELPHIA COLLAR S/M/L	1 PCS
PHOS 10ML	VAIL
PHOS INJ 30ml	vail
PHOSFOMIN IRON SYP	1x150xMl.
PHOSFOMIN SYP	1x240xMl.
PHOSFOMIN XT TAB 10*10	1*10*TAB
PHOSPHOLIP TF	1*10
PHOSPHOLIP-TF (SOFTGEL)	1X10C
PHOSPHOVET 10 ML	10 ML
PHOSPHOVET 30 ML	10 ML
PHOSTAT TAB 20*10	1x10xTab
PHYLIN-1TAB	1X10
PHYLIN-A	1*10
PHYLLOCONTIN 225 TAB 10*10	1x10xTab
PHYLLOCONTIN 350 TAB 10*10	1x10xTab
PHYLOBID 200 TAB 10*10	1x10xTab
PHYNYL	1 LTR
PHYTO BATISA 200GM	2X100GM
PHYTO BATISA 500GM	5X100GM
PHYTO COOL	500ML
PHYTO DIARONIL 100GM	100GM
PHYTO DIARONIL 500GM	500GM
PHYTO DIGEST 1LT	PH
PHYTO DIGEST 250ML	PH
PHYTO DIGEST BOLUS	1X4S
PHYTO LIV VET 250ML	PH
PHYTO LIV VET TAB	1X100TAB
PHYTO MORE MILK 200GM	200GM
PHYTO MORE MILK 500GM	500GM
PHYTO REPEAT PLUS 500GM	500GM
PHYTOCAL 1LTR	1 LTR
PHYTOCAL LIQ.	1 ltrs
PHYTOCAL LIQUID	5 LTR.
PHYTOCAL PLUS	1LITER
PHYTOCAL PLUS 5LIT	
PHYTOCOOL LIQUID	100ML
PHYTOFLAM TAB 3*10	1*10*TAB
PHYTOMEGA	1X10
PHYTOMEGA TAB.	1X15
PHYTYL TAB.10'S	1X10
PICHROMET	1X10T
PICROLAX CAP 10*10	1x10xCap
PICROLAX SYP 120ML	1*120ML
PIDIMOL INJ 100 MG	100 ML
PIDLET 75 TABLET	1X10
PIDLET EQ TABLET	1X10
PIDLET PLUS TABLET	1X10
PIGMENTO	1X40T
PIGMENTO OINTMENT	50GM
PIK-Z TAB	1X10
PIKER -D CAP	1*10
PIKER 40 TAB	1*10
PILES CURE OIN	30GM
PILES CURE TABLET	1X60
PILESLESS CAPSULE 20CAP	20CAP[144]
PILESWIN TAB	1X30
PILEX OINT	1x30xGm.
PILEX TAB	1x60xTab
PILOCAR-1% DROP	1x5xMl.
PILOCAR-2% DROP	1x5xMl.
PILOCAR-4% DROP	1x5xMl.
PILOGON GRANULES 200GM	200GM[115]
PILOGRO PLUS SOLU.	1 PHY.
PILOGRO SOLU.	1X60 ML.
PILORUTE CREAM 30GM	1*30GM
PINKOJET 10ML.	VIAL
PINKOJET 30ML.	VIAL
PINKOJET L 10 ML	10 ML
PINKOJET L 30 ML	30 ML
PINKOJET L 50 ML	50 ML
PINNACLE SYP	1X100ML
PINNACLE TAB	1X10
PINOM 10MG	1X10T
PINOM 20MG	1X10T
PINOM 40 MG	1X10T
PINOM A 20MG	1X10T
PINOM A 40	1X10T
PINOM-H 20MG	1X10T
PINOM-H 40 MG	1X10T
PINOM-M 25	1X10T
PINOM-M 50	1X10T
PIO -M30 TAB	10;S
PIO-OINTMENT	30GM
PIOCON FORTE TABLET	1X10
PIOCON GM 1	1X10
PIOCON GM 2	1X10
PIOCON PLUS TABLET	1X10
PIODOT 15	1X10
PIODOT 30	1X10
PIOFIX MF TAB 15MG 5*10	1x10xTab
PIOFIX MF TAB 30MG 5*10	1x10xTab
PIOFIX TAB 15MG 5*10	1x10xTab
PIOFIX TAB 30MG 5*10	1x10xTab
PIOGLIT 15 TAB 20*10	1*10TAB
PIOGLIT 30 TAB 10*10	1*10TAB
PIOGLIT MF 15 TAB 15*10	1*10TAB
PIOGLIT MF 30 TAB 5*10	1*10TAB
PIOGLIT-G TAB 5*10TAB	1*10TAB
PIOGLU-15	1x10
PIOGLU-30	1x10
PIOGLU-M 15 TAB	1x10
PIOLAX SYP	200ML
PIOMED M TAB 15MG 10*10	1*10*TAB
PIOMED M TAB 30MG 10*10	1*10*TAB
PIOMED MG 1 TAB 10*10	1x10xTab
PIOMED MG 2 TAB 10*10	1x10xTab
PIOMED TAB 15MG 20*10	1*10*TAB
PIOMED TAB 30MG 20*10	1*10*TAB
PIONORM M TAB 15MG 10*10	1*10*TAB
PIONORM M TAB 30MG 10*10	1*10*TAB
PIONORM M TAB 7.5MG 3*10	1*10*TAB
PIONORM TAB 15MG 10*10	1*10*TAB
PIONORM TAB 30MG 10*10	1*10*TAB
PIOPLUS 1MG	10'S
PIOPLUS 2MG	10'S
PIORYL 1 TABLET	1x10
PIORYL 2 TABLET	1x10
PIOSAFE 15	1X10T
PIOSAFE 30	1X10T
PIOSAFE MF 15/500	1X10T
PIOSAFE MF 30/500	1X10T
PIOSYS 15MG TABS	10'S
PIOSYS-30 MG TABS	10'S
PIOVIT B SYP	1*1
PIOVIT CAP 10*10	1*10
PIOZ MF G 1 TAB 10*10	1*10*TAB
PIOZ MF G 2 TAB 10*10	1*10*TAB
PIOZ MF TAB 15MG 10*10	1x10xTab
PIOZ MF TAB 30MG 10*10	1x10xTab
PIOZ MF TAB 7.5MG 10*10	1*10*TAB
PIOZ TAB 15MG 10*10	1x10xTab
PIOZ TAB 30MG 10*10	1x10xTab
PIOZOL DSR TAB 10*10	1*10
PIOZOLE 40 TAB 10*10	
PIOZOLE INJ	
PIPCOL DROP	10ML
PIPERAZINE 30 ML.	PH
PIPLAR DROP	1 PH.
PIPRATAX 4.5GM INJ	1 VIAL
PIPRAZINE 30 ML 45%	30 ML
PIPRAZINE 5 LT	5 LT
PIPRAZINE CITRATE SYP	1PH
PIPRAZINE CITRATE SYP.	30 ML.
PIPTAZONE INJ 4.5GM	1 VAIL
PIPTAZONE INJ.1.125GM	1 VAIL
PIPZO 1.125MG INJ	VIAL
PIPZO 2.25GM	1XV
PIPZO 4.5 INJ	VIAL
PIRANULIN TAB 3*10	1*10TAB
PIRATON VAIL	1*1
PIRATONE 400 MG TAB 10*10	1*10
PIRAZOLE CAP 12*10	1*10*CAP
PIRAZOLE D CAP 12*10	1*10*CAP
PIRAZOLE DSR CAP 12*10	1*10*CAP
PIRIPEN 100 ML	100 ML
PIRITON CS	100ML
PIRITON EXPT.	100ML
PIRITON EXPT.460	460ML
PIRITON MUCO EXP.	100ML
PIROTAZ 1.125GM	1 VIL
PIROTAZ INJ 4.5MG	5 GM
PIROX 2ML	1AMP
PIROX GEL	30GR
PIROX-20 MG CAP	10'S
PITIREX LOTION	1PHI
PITOCIN INJ.1ML	1 AMP.
PIVIPOL OINT	15GM
PIVIPOL SOLUTION	100ML
PIVIPOL VEG TAB	1X10
PIYAGRA 50 MG	1X4
PLACENTRAX GEL	1x20xGm.
PLACENTRAX INJ 40*2ML	1x2xMl.
PLACIDA TAB 12*10	1x10xTab
PLACIDIN 100	1X10T
PLACIDIN 200	1X10T
PLACIDIN XR 200	1X10T
PLACIDIN XR 300	1X10T
PLACIDIN XR 50	1X10T
PLACIDOX 2	1X15T
PLACIDOX 5	1X10T
PLAIN DISSECTING 8"	1 PCS
PLAIN TOWEL	1 PCS
PLAN X CONDOM	1*1
PLANE RUBBER CATHATER	1 PCS
PLANEP 25 MG	1X10T
PLANOKUF SYP.110 ML.	1X100ml
PLANOKUF-D SYP	1x60ML
PLANOKUF-XP-SYP	1x100ML
PLASMORID 20 TAB	1X8
PLASMORID 80 TAB	1X6
PLASTER CUTTING SAW BLADE	1 PCS
PLASTER OF PARIS I.P 2 KG	1 2KG
PLASTER OF PARIS I.P 5KG(BAG)	1 5KG
PLASTIC SHEET PVC CLEAR 180CM	1 PCS
PLATIN-20 TAB 5*14	1*14TAB
PLATLIFE TAB	1*10
PLAVAS TAB 150MG 10*10	1*10*TAB
PLAVAS TAB 75MG 10*10	1*10*TAB
PLAXIA TAB	10'S
PLAXIA-A75	10'S
PLEAZ-LS CAP	1*10
PLEMOR TAB	1X10
PLETOZ 100	1X10
PLETOZ 50	1X10
PLEXIN DROP	1PH
PLEXIN KID 200ML	1x200ML
PLEXIN KID SYP.	1 PH.
PLEXIN SYP.	1 PH.
PLEXY-L SY	1X200ML
PLEXYKAV SYP	200ML
PLEZMOR OD TAB	1x10
PLEZMOR TAB	1x10
PLOZINE TABLETS	1X6
PLUG MF TAB 10*6	1*10*TAB
PLUGCIN 100MG	1 SYP
PLUGCIN 500MG TAB	1 TAB
PLUGFIX 100 MG 30ML	1 PCS
PLUGFIX 100DT TAB	1 STP
PLUGFIX 200DT TAB	1 STP
PLUGFIX 50MG 30ML	1 PCS
PLUGTAZ 4.5GM	1 PCS
PM-O-LINE	1 PCS
PML-125MG SYP	1x60ML
PML-250MG SYP	1x60
PML-500MG TAB	1x10
PML-650MG TAB	1x10
PMUTE TAB	1X10T
PNEUMATIC TOURNIQUET	1 SET
PNZ D CAP 10*10	1*10*CAP
PNZ TAB 20MG 10*10	1x10xTab
PNZ TAB 40MG 10*14	1*14*TAB
PNZ VIAL 40MG	1x1xVl.
POD AZ 125 DT	1X10
POD AZ 250 TAB	1X10
POD AZ 500 TAB	1X10
PODCEF 100DRY SY	1PH
PODCEF 100DT TAB	1x10
PODCEF 200 TAB	1x6
PODCEF 50 DRY SY	1 PH
PODCEF 50DT TAB	1x10
PODEX DRY SYP	60ML
PODO-100DT	1X10T
PODO-200	1X10T
PODO-50 D/S	1X30ML
PODO-50DT	1X10T
PODOWIN-CV TAB	1*10
PODOX 100	1X10S
PODOX 200	1X10
PODOX D/SY	1X50ML
PODOX KID	1X10
PODPLUS 325	1X10
PODPLUS DRY SYP	1X30ML
POLARAMINE SYP.	60 ML.
POLARES 100 D/S	1X30ML
POLARES 100DT	1X10T
POLARES 200	1X10T
POLARES 200DT TAB 10'S	1X10
POLARES 50DT	1X10T
POLARES D/S	1X30ML
POLARES DP	1X10ML
POLBOOST BOLUS 1X4	1X4
POLCAL 1 LT	
POLCAL GOLD 1 LT	1 LT
POLCAL GOLD 10 LT	10 LT
POLIBIN-L 200ML	200ml
POLMIN FORTE 5 KG	5 KG
POLMIN FORTE POWDWER25 KG	25 KG
POLMIN POWDER 25 KG	25 KG
POLRAMINE 2 MG	1x10
POLVIT L 500 ML	500 ML
POLVIT L 60 ML	60 ML
POLY B CAP.	1x10
POLY B DROP	1 PH.
POLY B SYP. 100 ML.	1 PH.
POLY B SYP. 200 ML.	1 PH.
POLY B SYP. 60 ML.	1 PH.
POLY MV SYRUP	100ML
POLY MV TAB	1X10
POLY SUCTION SET	1 PCS
POLYBION CAP 10*15	1*15*CAP
POLYBION INJ 100*2ML	1*2*ML
POLYBION LC SYP 100ML	1*100*ML
POLYBION LC SYP 250ML	1*250*ML
POLYBION SF SYP 100ML	1*100*Ml
POLYBION SF SYP 250ML	1*250*ML
POLYBION SF SYP 400ML	1*400*ML
POLYBROWN 100ML SYP	1*100ML
POLYCAP CAP 1*15 CAP	1*15*CAP
POLYCAP CAP 3*10	1*10*CAP
POLYCLAV 156.25 D/S	1X30 ML
POLYCLAV 375	1X6T
POLYCLAV 625	1X6T
POLYCLAV BD SUSP	1X30ML
POLYCLAV DROP	1X10 ML
POLYCLAV KID TAB	1X10T
POLYCLAV SUSP	1X30ML
POLYCOF-D SYP	100 ML
POLYCOF-D SYP	60ML
POLYCOF-LS	100ML
POLYCOF-P SYP	100 ML
POLYCOF-P SYP	60ML
POLYCROL + 170ML	
POLYCROL + 60ML	
POLYCROL 170ML	
POLYCROL 50+20% EXTRA ML	
POLYDRAIN	1 PCS
POLYGESIC 30ML	VIAL
POLYGESIC PLUS BOLUS	1x4B
POLYMED ULTRACATH NOVO (TROCAR) 24	1 PCS
POLYMOX CAP.	1x10
POLYMOX KID	1x10
POLYNET DROP	1PH
POLYNET SYP	1PH
POLYNET TAB	1x10
POLYNOVA	1X10T
POLYNOVA TAB	1X10
POLYPLEX 200ML	1*200ML
POLYPLEX-100ML	1*100ML
POLYPOD 100 DT	1X10T
POLYPOD 200	1X10S
POLYPOD 50 D/S	1X30ML
POLYPOD 50 DT	1X10T
POLYPOD CV 100 DT	1X6T
POLYPOD CV 200	1X6T
POLYPOD CV 50	1X30ML
POLYPOD CV 50 DT	1X6T
POLYPOD DROP	1X10ML
POLYPOD-O	1X10S
POLYPOD-O 100 DT	1X10 TAB.
POLYTORVA KIT 2.5MG	1*1*KIT
POLYTORVA KIT 5MG 1KIT	1*1*KIT
POLYVAC 12	1 PCS
POLYVAC 14	1 PCS
POLYVAC 16	1 PCS
POLYVAC 18NO	1 PCS
POLYVET INJ.10ML	1x10ML
POLYVET INJ.30 ML.	1 PH.
POLYVIN 100ML SYP	1X100ML
POLYVIN 200ML SY	1X200ML
POLYVIN EYE DROP	1x5 ML.
POLYVIN N DROP	1PH
POMED-EX CAP	1x10
POMISOL EAR DROPS	30 ML
POMOSOL EAR DROPS	15 ML
PONSTAN 250	1X10 TAB
PONSTAN 500 MG.	1x10
PONSTAN SUSPENSION 6OML	60ML
PONTRA 40 TAB	1*10
PONTRA D CAP	1*10
PONTRA-L	1*10
PONY-DSR	1X10
POP 2KG	1
POP BANDAGE 10CM	1 PCS
POP BANDAGE B.P 15CM	1 PCS
POP IN DPRAY	150.ML
POPNIL-DSR CAP	1*10
POPSON TAB 10*10	1*10TAB
PORON 50 ML	50 ML
PORTEL SOLUTION	1X200ML
POSTERIOR SLAB FOR LEG	1 PCS
POSTPIL TAB	1*1
POT-TAB.	1x10
POTACEF-S 3GM	VIAL
POTACEF-S 600MG	600MG VIAL
POTASH 20GM **	1x20GM
POTASIM SYP	1X100ML
POTASSIUM PERMANGA	1PH
POTASSIUM PERMANGANATE I.P	20 GM
POTAZ 4.5MG	1 VA
POTCHLOR 10MG INJ	1 AMP
POTENTOX INJ	1.25GM
POTENTOX INJ	625MG
POTEX PD SYP	60ML
POTEX-DM COUGH SYP	100ML
POTEX-DM JR SYP	60ML
POTIMAX GRANULES	1*250GM
POTKLOR SYRUP	1x200 ML
POTRATE MB6 SYP 200ML	1*200ML
POTRATE MB6 TAB 10*10	1*10*TAB
POTRATE SF SYP 200ML	1*200ML
POTRATE SYP 200ML	1x200xMl.
POTRATE-10 TAB 10*10	1x10xTab
POTRATE-M SYP 200ML	1x200xMl.
POTRATE-M TAB 10*10	1x10xTab
POTTER M SYP	1X200ML
POUCH ARM SLING (L)	1 PCS
POUCH ARM SLING (M)	1 PCS
POUCH ARM SLING (S)	1 PCS
POUCH ARM SLING (XL)	1 PCS
POUCH ARM SLING CLS(L)	1 PCS
POUCH ARM SLING CLS(M)	1 PCS
POUCH ARM SLING L	1 PCS
POUCH ARM SLING M	1 PCS
POVICLEAN LOTION	100ML
POVICLEAN OINT	1X15G
POVIDE FR 50GM	
POVIDINE IODINE SOLUTION 5%	500 ML.
POVIDONE IODINE SOLUTION	100 ML.
POVIMAC OIN	10gm
POVIPEN 500 ML	500 ML
POVIPEN CREAM 15 GR	15 GR
POVIPEN SOLN 100 ML	100 ML
POWER D3 1000 CAP.	1X10
POWER D3 60K	1X4
POWER FORCE TAB.	1X1X2 TAB.
POWER FREE GLOVES	1 PCS
POWER TONE F16	1 SET
POWER-Z POWDER	15GM
POWERCAL TAB	1x10
POWERFLAM INJ	3ML
POWERFLAM TAB	1X10
POWERFLOX TZ TAB	1X10
POWERGYL.30ML.SYP	1PH
POWERGYL.60ML.SYP	1PH
POWERGYL.TAB	1X10.
POWERMET TABLET	1X10
POWERVIT TABS	1*10
POXIL-200TABS	1*10
POZ-D 1*10	1*10
POZINEG 1G	1 VAL
POZITIV 15MG	1X10T
POZITIV 30MG	1X10T
PPD TAB	1X10
PRACIDEP PLUS TAB 10*10	
PRACTIN SYP 1*200	1x200xMl.
PRACTIN TAB 150*10	1x10xTab
PRACTIN-EN SYP	1x200xMl.
PRADARANTAK 50GM	50GM [73]
PRADO 50	1*10
PRADO INJ	1*1
PRADO PLUS	1*10
PRAGMA INJ 2ML	2ml
PRAJANA (1TAB)	1
PRAJANA HS.	20x6CAP
PRAMIPEX 0.125 TAB 10*10	1*10TAB
PRAMIPEX 0.25 TAB 10*10	1*10TAB
PRAMIPEX 0.5 TAB 10*10	1*10TAB
PRAMIPEX 1.0 TAB 3*10	1*10TAB
PRAMIPEX ER-0.375 TAB 3*10	1*10TAB
PRAMIPEX ER-0.75 TAB 3*10	1*10TAB
PRANDIAL 0.2MD TAB	10'S
PRANDIAL 0.3MD TAB	10'S
PRANDIAL M 0.2 TAB	10'S
PRANDIAL M 0.3 TAB	10'S
PRASARNI TAIL 60 ML	1 PH
PRASILEX 10	1X10T
PRASILEX 20	1X10T
PRASILEX 5	1X10T
PRASILEX PLUS	1X10T
PRASUDOC 10MG	1X10T
PRASUDOC 5MG	1X10T
PRASUREL 10	1X10T
PRASUREL 5	1X10T
PRATHAM 100 DT	1X3T
PRATHAM 100 REDIUSE	1X15ML
PRATHAM-200 REDIUSE	1X15ML
PRATHAM-250	1X6T
PRATHAM-500	1X3T
PRAX 10	1X10T
PRAX 5	1X10T
PRAXIS INJ 40MG	
PRAZDON-40 TABS	1*10
PRAZDON-D CAPS	1*10
PRAZI PLUS BOLUS	1x10
PRAZIFEN TAB	1x2TAB
PRAZISAM PLUS TABS	1X2
PRAZISAM TABS	1x12
PRAZITAL PLUS	1X2'S
PRAZOHEXT	1X10S
PRAZOHEXT D	1X10S
PRAZOPILL XL-2.5 10*10	1*10TAB
PRAZOPILL XL-5 10*10	1*10TAB
PRAZOPRESS XL 2.5 TAB 5*14	1*14TAB
PRAZOPRESS XL 5 TAB 5*14	1*14TAB
PRAZOTEL 4.5 MG	1 VIL
PRAZOTEL 40MG	1 VIL
PRB SUS	5ML
PRD CAP	1x10
PRE-PRO CAP	1X10
PRE-PRO HS	1X10
PRE-PRO KID SACHET	1PIC
PRED FORTE	10ML
PREDFAX 5ML	1X5ML
PREDFEX 5ML	1X5ML
PREDINISOLONE 10 ml	VIAL
PREDLINE-4 TABLET	1*10
PREDLINE-8 TABLET	1*10
PREDMET 16	1X10
PREDMET 24	1X10T
PREDMET 4	1X10T
PREDMET 8	1X10T
PREDMET DROP 5ML	1*5ML
PREDMET-16 TAB 10*10	1*10TAB
PREDMET-8 TAB 10*10	1*10TAB
PREDMOX DROP	1PH
PREDNI BEST - 5 TAB	1X10
PREDNISOLAN VET VIAL M&B	1VIAL
PREDNISOLONE 10 ML. VIAL	1 VIAL
PREDNISOLONE ACETATE E/D	1*5ML
PREDOM-40INJ	1VILE
PREDONE FORTE SYRUP	60ML
PREDONE SYR	60 ML
PREDONE SYRUP	60ML
PREDSOL E/D	1*5ML
PREFER-DHA POW	200GM
PREFER-FE	1*10
PREGABA M 150MG	1X10
PREGABA M 75	1X10
PREGABA M SR 75MG TAB	1X10
PREGABA SR 75	1X10
PREGABID 150 CAP 5*10	1*10CAP
PREGABID FORTE 75 10*10	1x10xTab
PREGABID OD 100 TAB 10*10	1*10TAB
PREGABID OD 150 TAB 10*10	1*10TAB
PREGABID-75MG CAP 10*10	1x10xCap
PREGABID-ME 150 CAP 10*10	1*10CAP
PREGABID-ME 75 10*10	1x10xTab
PREGABID-MOD 100 TAB 10*10	1*10TAB
PREGABIN 150MG	1X10T
PREGABIN PLUS 150	1X10T
PREGABIN PLUS 75	1X10T
PREGACOR 150MG	1X10
PREGACOR 75	1X10
PREGACOR-M	1X10
PREGADOC M SR 150MG	1X10T
PREGADOC M SR 75MG	1X10T
PREGADOC PLUS	1X10C
PREGADOC SR 150MG	1X10T
PREGADOC#CAPS 150MG	1X10C
PREGADOC#CAPS 75MG	1X10C
PREGADOC-M 150MG	1X10T
PREGADOC-M 75MG	1X10C
PREGAIN ME TAB	1*10
PREGALEX 150 MG 10*10	1*10
PREGALEX 75 10*10	1*10
PREGALEX M CAPSULES	1X10
PREGALIN 75	1X10C
PREGALIN M 75	1X10C
PREGALIN PLUS 75	1X10T
PREGAMI-NT TABS	1*10
PREGASTAR 150	1X10T
PREGASTAR 75	1X10T
PREGASTAR OD 150	1X10T
PREGASTAR OD 75	1X10T
PREGASTAR PLUS	1X10C
PREGASTAR PLUS SR 75	1X10 TAB.
PREGASTAR-M 75	1X10C
PREGASTAR-M OD 150	1X10TAB.
PREGASTAR-M OD 75	1X10TAB.
PREGATOR CAP 5*10	1*10*CAP
PREGAVATE M CAPSULES	1X10
PREGCIUM	1X15T
PREGCLEAR TAB	1X4T
PREGCOLAR TEST DEVICE	1 KIT
PREGCOLOR CARD GOLD 1PC.	1x1xPc.
PREGCOLOR TEST STRIP	1KIT
PREGEB 150	1X10C
PREGEB 75	1X10C
PREGEB M 150	1X10 TAB.
PREGEB M 75	1X10 TAB.
PREGEB M OD 75	1X10 TAB.
PREGMATE -M TAB	1*10
PREGMATE TAB	1X10
PREGNA CREAM CR. 50GM	1*50*GM
PREGNACARE FORTE + CAP 2*15	1*15*CAP
PREGNAFOL-DHA CAP	1*10
PREGNANCY TEST CARD	1 PCS
PREGNANCY TEST STRIP	1 PCS
PREGNASAFE TAB 10*10	1*10*TAB
PREGNAVIT CAP 1*10	1*10
PREGNENCY TEST STRIP	1 PCS
PREGNIDOXIN	1X15T
PREGNIN	1X10T
PREGNIN RETARD	1X10
PREGNOT KIT	1X5
PREGNOT TAB	1X1
PREGNYL 1500 INJ.	1x1xAmp
PREGNYL 5000 INJ.	1x1xVl.
PREGSOX SR	10'S
PREGTAIN 100 MG	10'S
PREGTAIN 200 MG	10'S
PREGTEST-CARD	1pec
PREGWHEY POUDER 35GM.	35GM.
PREJUNATE PLUS 75	1X10C
PRELEAD-M TAB	1X10
PRELIN-75 CAP 5*10	1*10CAP
PRELIN-M 75 10*15	1*15TAB
PRELIN-M 75 CAP 10*10	1*10CAP
PRELOGIC CAP 10*10	1*10*CAP
PREMARIN TAB 0.30MG	1x28xTab
PREMARIN TAB 0.625MG	1x28xTab
PREMENCE PLUS CAP 2*15	1*15*CAP
PREMISOL 125 INJ	1XV
PREMISOL 16MG	1X10T
PREMISOL 1GM	1XV
PREMISOL 30 (NEW)	1X30T
PREMISOL 40 INJ	1XV
PREMISOL 4MG	1X10T
PREMISOL 6 (NEW)	1X10T
PRENEUROLIN- PLUS	1X10
PRENEUROLIN-150	1X10
PRENEUROLIN-75MG	1X10
PRENOXID 200 TAB	1x10
PREPOST CAP 10*10	1x10xCap
PRESAFE 2ML	1X2ML
PRESCUF D 60ML	1PHI
PRESCUF D SY	1PHI
PRESCUF XP DROP	1PHI
PRESCUF XP SY	1PHI
PRESOLAR CAPS	10'S
PRESOLONE E/D	1*5ML
PRESON H 250MG AMP	1AMP
PRESPAR 200MG TAB	1X6
PRESS CAL 200ML	1'S
PRESS CALL-100ML	1'S
PRESSCAL TABS	10'S
PRESSCLAV 228.5 DT	1X6
PRESSCLAV 375	1X6
PRESSCLAV 375	1X6
PRESSCLAV 625	1X6
PRESSCLAV 625 MG	1X6
PRESSMOX 250 TAB	1x10
PRESSMOX 500 CAP	1x10
PRESSMOX P TAB	1x10
PRESSURY RING 2"	1 PCS
PRESSURY RING 2.5"	1 PCS
PRESSURY RING 3"	1 PCS
PRESTAKIND-200 TAB 10*4	1x4xTab
PRESZYME SYP	150ML
PREVA TAB 10*10	1x10xTab
PREVA-AS 150 TAB 10*10	1x10xTab
PREVA-AS 75 TAB 10*10	1x10xTab
PREVALON TAB.	1x10
PREXAN LIQUID	1X200ML
PREXAN TAB	1X15
PREXARON 500 TAB 10*10	1x10xTab
PREXARON ING-4ML 5*4ML	1x1xAmp
PREXARON INJ-2ML 5*2ML	1x2xMl.
PREXARON PLUS TAB 10*10	1*10TAB
PREXARON SR 1GM TAB 10*10	1*10*TAB
PREXARON SYP	1x60xMl.
PREXON TAB	1*10
PRICKLY HOT SOAP	75GMS
PRID-GM 1 TAB	1*10
PRID-GM 2 TAB	1*10
PRIDE 100	1*10
PRIDE 50	1*10
PRIGASURE-ME 150 CAPSULES	1X10
PRIGASURE-ME 75 TABLET	1X10
PRIMACAL AT CAP	1X10
PRIMACORT 100MG	1XV
PRIMACORT 200MG	1XV
PRIMACORT 400MG	1XV
PRIMACORT+CREAM	1X5 GM
PRIMACURE 250MG INJ	1 VAIL
PRIMARID 15	1*7
PRIMARID 2.5	1*7
PRIMARID 7.5	1*7
PRIMASURE 1GM INJ	1 VAIL
PRIMODIL 2.5MG TABS	10'S
PRIMODIL 5MG TABS	10'S
PRIMODIL AT TABS	10'S
PRIMODIL L TABS	10'S
PRIMOGEM-800 CAP	1*10
PRIMOLUT-N TAB 20*10	1x10xTab
PRIMOSA 1000	1X15
PRIMOSA 1000(SOFTGEL)	1X15C
PRIMOSA 1000MG CAP	1*10
PRIMOSA 500MG CAP	1X15
PRIMOSA DN	1*10
PRIMOSA(SOFTGEL)	1X15C
PRIMOX 25 TAB 10*10	1*10TAB
PRIMOZYM-P SYP	60ML
PRIMOZYN SYP	1X60ML
PRINCICAL	1X10T
PRIVENT DT TAB 40*10	1*10*TAB
PRO-TZ BOLUS	1x4
PRO-Z PW	1PHI
PROBAC DROP	1 PH.
PROBAC SYP. 60 ML.	1 PH.
PROBEFIX CAP	10'S
PROBEFIX DRY SYP	1*30ML
PROBEFIX DRY SYR	30ML
PROBIOS TAB.10'S/SAT	S
PROBIOS-C	1X10
PROBIOSET CAPS	1*10
PROBLAST CAPS	1x10
PROBLAST GRO SYP	1x200ML
PROCALYS ENEMA	1X100ML
PROCILLUS GG SACHET	1GM
PROCOTOSCOPE ADULT (HEAVY)	1 PCS
PROCOTT SHAMPOO 200ML	
PROCTINAL 1.25 TAB	10'S
PROCTINAL TAB	10'S
PROCTONIL	1x5.6GM
PROCTOSEDYL OINT	10GM
PRODAMP POWDER	1x200GM
PRODEP 20 TAB 10*10	1*10TAB
PRODEP 60 TAB 5*10	1*10TAB
PRODEX POWDER	200GM
PRODIUM 20	1X10T
PRODRYL EXP. 100 ML.	1 PH.
PRODUCTIV-F 3*10	1*10
PRODUCTIV-F TAB	1X10T
PRODUCTIV-H TAB	1XKIT
PRODUCTIV-M TAB	1XKIT
PRODYL-C	1x100ML
PRODYL-X EXP	1X100ml
PROFECAL GR	1PHI
PROFECAL GR	1X35GR
PROFECAL GRAN	1X35GR
PROFECAL SY	1PHI
PROFICENT 10000	1XV
PROFICENT 2000	1XV
PROFICENT 5000	1XV
PROFIGRAN 10 MG	1X10T
PROFIGRAN 5 MG	1X10T
PROFIMIN FORTE	1KG.
PROFIMIN FORTE 5KG	1X5KG BAG
PROFINE 100MG CAP	1X10
PROFINE 200MG CAP	1X10
PROFINE INJ	1X2ML
PROFIT SYP.	1 PH.
PROGENTA 30ML	VAIL
PROGOD ELAICHI POWDER	1x200GM
PROGUT TAB	1X10
PROLAM-10	1X10TAB
PROLAPSE-IN.	PH
PROLAPSYN 450GM	450GM JAR
PROLAPSYN POWDER	21
PROLIN-100 CAP	1X10
PROLIN-200 CAP	1X10
PROLIN-250 INJ	VIAL
PROLIN-500 INJ	
PROLINATE 25MG INJ 5*1ML	1*1ML
PROLINIUM POWDER	200GM
PROLITA SYP	1x200ML
PROLIV TAB	1*10
PROLOC-DSR CAP	1*10
PROLOL-10	1X10
PROLOL-40	1X10
PROLOMET AM 25 TAB 10*10	1*10TAB
PROLOMET AM 50 TAB 10*10	1*10TAB
PROLOMET R 25 TAB 5*10	1*10TAB
PROLOMET R 50 TAB 5*10	1*10TAB
PROLOMET XL 12.5 TAB 5*10	1*10TAB
PROLOMET XL 25 TAB 10*10	1*10TAB
PROLOMET XL 50 TAB 10*10	1*10TAB
PROLUS MESH (6 X 11)	1 PCS
PROLUS MESH (7.6 X 15)	1 PCS
PROLUS,0, LNW 842(70CM)	12 BOX
PROLUS-40MG TAB	1*10
PROLUTON DEP INJ 500MG 5*1AMP	1*1*AMP
PROLYTE 21GM	1PH
PROLYTE 4.2 GM	1PH
PROMET.SYU	1PH
PROMIN TAB	1x10
PROMISEC 20MG	1X10
PROMOLACT CAP	1*10
PROMOLACT GRANULES	200GM
PRONAC INJ.30ML	1X30ML
PROPAX EYE PAD	1 PCS
PROPRAZOLAM TAB	1X10
PROPRAZOLAM-M	1X10
PRORAB-20 TAB 10*10	1x10xTab
PRORAB-D TAB 10*10	1x10xTab
PROSANTI 0.25 TAB.10'S/SAT	S
PROSANTI 0.5 TAB.10'S/SAT	S
PROSOMA POWDER 200GM/SB	S
PROSOYAL 200GM	1x200xGm.
PROSOYAL 400GM	1x400xGm.
PROSPAN COUGH SYR	1x100xMl.
PROSTAGEN 100	1X10
PROSTAGEN 200	1X10
PROSTAGEN VT 200	1X10
PROSTAMAX TAB	1*10S
PROSTANORM 320 TAB 10'S	1X10
PROSTANORM TAB	1X10
PROSTAWON CAP	1X10
PROSTEEZ	1X20T
PROSTINA CAP.	1x10
PROSTODIN AMP 5ML	2ML
PROSTODIN INJ 125MCG	1ML
PROSTONIL	1X10C
PROTECTO GLOVES	1 PCS
PROTECTONE LIQ	200ML
PROTEIN.100ML.SYU	1PH
PROTEINPLUS.100ML.SYU	1PH
PROTEL 200ML	200ML
PROTEN POWDER	1 PH
PROTERA 20	1X10 TAB.
PROTERA D 20	1X10 TAB.
PROTERA FAST	1X10T
PROTERA TAB	1X10T
PROTERA-D	1X10C
PROTERA-I	1X10C
PROTERA-IV	1XV
PROTERA-L	1X10C
PROTHIADEN 25 MG TAB	AX10
PROTHIADEN TAB 25MG 30*10	1x10xTab
PROTHIADEN TAB 75MG 30*10	1x10xTab
PROTHIADIN 75 MG. TAB	1x10
PROTIBEST POW 200GM	200GM
PROTIFOL SYU	200ml
PROTIKING GRNU	200ml
PROTIKING SYU	200ml
PROTIMAX GLASS POWDER	1PH
PROTIMAX GRU	1PH
PROTINEX DIABETES	200GM
PROTINEX JUNIOR	150GM
PROTINEX MAMA	200GM
PROTINEX ORIGINAL	200GM
PROTINEX ORIGINAL	400GM
PROTINEX VANILLA	200GM
PROTINEX {VANILLA}	1X200 GR
PROTINULES BUTTERSCOTH GR	1*200*GM
PROTINULES GR	1*175*GM
PROTINULES PL GR	1*200*GM
PROTION GRU	200GM
PROTION- TIN GRU	200GM
PROTIPEN 200 GR	200 GR
PROTIPEN 200 ML	200 ML
PROTIRON PLUS GRU	200GM
PROTIRON PLUS SYU	200GM
PROTIRON GRAN 200GM	1
PROTIRON POWDER (CHOCOLE)	200GM
PROTIRON POWDER (ELAICHI)	200GM
PROTIRON TONIC	1x200ML
PROTIRON TONIC	1x200ML
PROTIVIT POWDER	1PH
PROTO CREAM	20GM
PROTOBEX- SG CAP	1X10
PROTOCOL 100ML	100ML
PROTOCOL CAP	1X10
PROTOCOL POWDER	200GM
PROTOCOL SYR	200ML
PROTODEX POWDER	200GM
PROTOGEN MOM POWDER 200GM	1*200GM
PROTOGEN-G GRN.	1x200xGm.
PROTOL AM TAB 10*10	1*10*TAB
PROTOL XL TAB 25MG 10*10	1*10*TAB
PROTOL XL TAB 50MG 10*10	1*10*TAB
PROTOLEAN POWDER	1PH
PROTOMARK 25 INJ	1 ML
PROTOMARK 50 INJ	1INJ
PROTOMEG TABLET	1X10
PROTOMID	1X10T
PROTONE INJ.	30 ML
PROTONE LIQUID	200ML
PROTONE MOM	1X200 GM
PROTONIL R.T.U.	30ML
PROTORID FORTE TAB	1x10
PROTOTAL POWDER	1x400GM
PROTUSSA PLUS SYP	1X60ML
PROTUSSA SYP	1x60xMl.
PROVANOL 10 TAB 10*10	1x10xTab
PROVANOL 20 TAB 10*10	1x10xTab
PROVANOL 40 TAB 10*00	1x10xTab
PROVANOL SR 40 TAB 10*10	1x10xTab
PROVAR 1GM	1GM
PROVAR FORT CAPS	10'S
PROVICAL 1litt	PH
PROVICAL FORTE 5LT	1X5LT
PROVIDAC CAP	1x10xCap
PROVISACC BOLUS	BOLUS
PROVITAL SYP	1*200ML
PROWEIGHT POWER	200GM
PROWEL	1X10C
PROWEL D/SY	1X30ML
PROWEL POW SACH	1X1GM
PROXI TZ 2.25	VIAL
PROXIL 50 MG DRY SYP	1PH
PROXTL 100 MG	1X10
PROXTL 50 MG	1X10
PROXTL SYP	1X30ML
PROXYVET MP BOLUS	1X2
PROXYVET MP INJ 30 ML	30 ML
PROXYVET-DS 30ML.	VIAL
PROXYVET-DS BOLUS.	1x2B
PROXYVON CAP 18*8	1x8xCap
PROXYVON FORTE 10*10	1*10
PROXYVON PLUS CAP 18*8	1*8CAP
PROZANT VET INJ.	30ML
PROZOMIN 30ML.	VIAL
PROZYME 200ML SYP	200ML
PRUF CAP 10*10	1*10CAP
PRUFLOX TAB	5'S
PRUGO TAB 25MG 20*10	1x10xTab
PRUGO TAB 25MG 20*10	1x10xTab
PRULIBACT TAB 10*5	1*5*TAB
PRULIF CAP	1X10
PRUTIS TAB5S	1X5
PRYLAX CAP.	1X10 CAP.
PRYNERVE-M 75	1X10 T
PSORAWIN CAP	1X10
PSORAWIN CREAM	1X15GRM
PSORINO 50GRM	1TUBE
PSORVATE OINTMENT	30GM
PTOP-40 MG TAB	1*10
PTU	1X100T
PUC DROP	30ML
PUDIN HARA 10 ML.	1 PH.
PUDIN HARA 30ML	1PH
PUDIN HARA FIZZ 5GM	1*5GM
PUDIN HARA G	1 PC.
PUDIN HARA PEARLS	1x10
PUDINHARA.TAB	
PULMAX SYP	1*100ML
PULMICORT RESPULES 0.5	2ML
PULMO-RESST EXP 100ML	100ML
PULMOCEF 1500INJ	INJ
PULMOCEF 250INJ	INJ
PULMOCEF 250mg	10's
PULMOCEF 500mg	10'S
PULMOCEF CV TAB 250MG 5*4	1*4*TAB
PULMOCEF CV TAB 500MG 5*4	1*4*CAP
PULMOCEF CV250	4'S
PULMOCEF CV500	4'S
PULMOCEF TAB 250MG 5*10	1*10*TAB
PULMOCEF TAB 500MG 3*10	1*10*TAB
PULMOCEF VIAL 1500MG	1*1*VL
PULMOCEF VIAL 250MG	1*1*VL
PULMOCLEAR SY 60ML	1PIC
PULMOCLEAR TAB	1X10T
PULMOCOD CG 200ML	20ML
PULMOCOD PLAIN 200ML	20ML
PULMOREST EXP	60ML
PULMOREST S EXP	100ML
PULMOREST TAB 1*10	1*10
PULMORIL-LS DROP	15ML
PULMORIL-LS FORTE SYP	100ML
PULMORIL-LS SYRUP	100ML
PULSE OXY METER	1 PCS
PULSE OXY METER P1 FINGER TIP	1 SET
PULVOLAX GRANUS 100 GM	100GM
PUMPAN 40	1*10
PUNARJAL 21.8GM POWDER	1*21.8GM
PUNARJAL POWDER 4.5GM 1*6PC	1*6PC
PUNERJAL LIQUID 100ML	1*100ML
PUOCEF TAB	1X10
PURADANE 10GM POW	10GM
PURADANE M 10GM POW	10GM
PURAK 1KG	1 KG
PURBIN FORT	1*10
PURBIN FORT SYP	200ML
PURBIN PLUS SYP	200ML
PURBIN PLUS TAB	1*10
PURBIN PLUS TAB 1*10	1*10
PURE D3 2000 IU	1X10 TAB.
PURE D3 6000 IU	1X4 TAB.
PURE MCT	1X40GMS
PURECEF -S INJ.	1 GM.
PURECEF 1 GM INJ	1 VIL
PUREGEST-200 CAP 3*10	1*10CAP
PUREHANDS 100ML	1*100ML
PURGOCARE 100 GR	100 GR
PURGOCARE BOLUS	1x4B
PURIM TAB	1x60xTab
PURITY BARLEY	100GM
PURITY BARLEY	400GM
PURITY BARLEY	50GM
PURODIL SYP 200ML	200ML
PURODIL TAB 1*30	1*30
PURON GEL	1X30GM
PURON INJ	1X2ML
PURON PLUS	1X10T
PURON-25	1X10T
PUSHYANUG 100GM	100GM[71]
PUSHYANUG 50GM	50GM [58]
PUSNAYADI CHURN 60GM	1PH
PVRTAB-15	1X10
PYCOLIFE CAP	1*10
PYLOFAST-DSR	1*10
PYLOKIT	6'S
PYLOREX 30 MG CAP	1x10
PYMEX -500MG TABS	10'S
PYMEX 750 TABS	10'S
PYOGIN K GEL	1TUBE
PYOGIN KF GEL	1 TUBE
PYOGIN OIT	1TUBE
PYRALFIN SUSP	10ML
PYRALFIN TAB	1X2T
PYRALFIN-A	1X4T
PYRALFIN-A INJ	1XV
PYRALFIN-AL	1X6T
PYRANIL 30ML	VIAL
PYREX 500 1*10	1*10
PYREX KID 1*20	1*20
PYRICONTIN TAB 10*10	1x10xTab
PYRICONTIN-F TAB 10*10	1x10xTab
PYRICORT DROP	1x5xMl.
PYRIDIUM 200	1x10
PYRIFEN PLUS CAP	1*10
PYRIGESIC 1000 MG	1X10T
PYRIGESIC 650MG TAB	1X10
PYRIGESIC DROP	1 PH.
PYRIGESIC DS SYP	1X60ML
PYRIGESIC SYP.	1 PH.
PYRIGESIC TAB.	1x10
PYRIKEM DROP	1*15ML
PYRIKEM TAB	1*10
PYRIMIDE 60ML SYP	1PH
PYRIMIDE DROP	1PH
PYRIMIDE DT TAB	
PYRIMIDE TAB	1*10
PYRIMON DROP	1x5xMl.
PYRINEX	
PYRISTAT DROP	1PH
PYRISTAT GEL	1TUB
PYRISTAT SYP. 60 ML.	1 PH.
PYRISTAT TAB.	1x10
PYROLET	1 10
PYROXIN BOLUS.	1x4B
PYZINA 1000	1X10T
PYZINA 500	1X10T
PYZINA 750	1X10T
PYZINA KID	1X10
PZIDE TAB 1000MG 10*10	1x10xTab
PZIDE TAB 500MG 20*10	1x10xTab
PZIDE TAB 750MG 10*10	1x10xTab
Procillus GG SACHET	1GM
Prolus Mesh 10*15cm	
Q PAS	1X100GM
Q PRESS 10MG	1X10
Q PRESS 20MG	1X10
Q PRESS 5MG	1X10
Q-FOXIN-OZ TAB	1X10
Q-GOLD CAP	1X10
Q-LEVO 500 1*5	1*5
Q-MIND 100	1X10T
Q-MIND 50	1X10T
Q-MIND SR 100 TAB	1X10T
Q-MIND SR 200 TAB	1X10T
Q-MIND SR 300	1X10T
Q-MIND SR 50 TAB	1X10T
Q-PIN SR 100MG	1X10 TAB.
Q-PIN SR 200MG	1X10 TAB.
Q-PIN SR 50MG	1X10 TAB.
Q-PRESS-H TAB 10/12.5MG	1X10
Q-PRESS-H TAB 20/12.5MG	1X10
Q-PRIL 10MG TAB	1X10
Q-PRIL 20MG TAB	1X10
Q-PRIL 5MG TAB	1X10
Q-PRIL-H 10MG	1X10
QDMRD 200 (10*10)	1*10
QDMRD 400 (10*10)	1*10
QIK 15 ML	15 ML
QINET 300 TAB	1X20
QKNOWN-LC	1*10
QMONT 10MG1*10	1*10
QMONT KID 1*10	1*10
QUADARY POD WK 420	1 PCS
QUADIDERM AF	1 TUBE
QUADIDERM RF 10 GM	1TUBE
QUADRIDERM RF 5GM.	1TUBE
QUADRIPORD STICK	1 PCS
QUADRYPOD STICK	1 PCS
QUALDRIDERM.5GM	1PH
QUALIDROPS 450ML	450ML PH
QUALINOX 40MG PFS	1XAMP
QUALINOX 60MG PFS	1XAMP
QUARD CREAM	1x5GM
QUEEN DERM 5GM	1PH
QUEL SR TAB 100MG 10*10	1*10*TAB
QUEL SR TAB 50MG 10*10	1*10*TAB
QUERET	1 PCS
QUEZO SR-100	1*10
QUEZO SR-200	1*10
QUEZO SR-50MG	1*10
QUGAT E/D	1*5ML
QUGRIDERM.OIN	1PH
QUICK ACTION-500 TAB	1x8TAB
QUICK CHEK CARD	1 PCS
QUICK CHEK PREG STRIP	1 PCS
QUICKHALER 1PC	1*1PC
QUIDO DERM OINT	1*5GM
QUIET BR SYP 100ML	1*100*ML
QUIET SYP	1x100xMl.
QUIKHALE FF 100 R/CAPS	1*40CAP
QUIKHALE FF 125 INHALER	1*1PC
QUIKHALE FF 250 INHALER	1*1PC
QUIKHALE FF 250 R/CAPS	1*40CAP
QUIKHALE-FB 100 R/CAP	1*40CAP
QUIKHALE-FB 200 R/CAP	1*40CAP
QUIKHALE-FB 400 R/CAP	1*40CAP
QUIKHALE-FB100 INHALER	1*160MTD
QUIKHALE-FB200 INHALER	1*160MTD
QUIKHALE-FB400 INHALER	1*160MTD
QUIKHALE-SF 100 R/CAP	1*40CAP
QUIKHALE-SF 250 R/CAP	1*40CAP
QUIKHALE-SF125 INHALER	1*160MTD
QUIKHALE-SF250 INHALER	1*160MTD
QUIKHALE-T R/CAPS 1*15	1*15CAP
QUIKSPACER 1PC	1*1PC
QUINHEXT	1X5T
QUININTAS INJ.	15ML
QUININTAS INJ.	30ML
QUININTAS INJ.	50ML
QUINO OZ TAB	1x10
QUINO-OZ SUSP	1x30ML
QUINODERM	5GM
QUINOFLOX E\E DROP	1x10ML
QUINOFLOX TAB	1x10
QUINOMAC 100 10'S	
QUINOMAC 300	1X10T
QUINOMAC 300MG INJ	2ML
QUINOMAC SUSP.	1X60ML
QUINOXIN INJ 100ML	1x100ml
QUINOXIN INJ 15ML	1X15ML
QUINOXIN INJ 50ML	1X50ML
QUINROCIN INJECTION	100ML
QUINTAS 100ML	
QUINTEGA-CF OIT 10GM	1TUB
QUINTOR I.V	100ML
QUINTOR-500MG TAB	1X10
QUIT SYP	1*100*ML
QUITANX TAB	1X10T
QULANTA SUSPENSION	1X170 ML
QULANTA TABLET	1X10
QULEF OZ TAB.	1X10
QULEF POD	1X10
QULEF Z 250	1X10
QULEF Z 500	1X10
QULEF-250MG TAB	1X5
QULEF-500MG TAB	1X5
QULEF-750MG TAB	1X5
QUPEX 100 10*10	1*10
QUPEX 200 10*10	1*10
QUPEX 25 TABLET	1X10
QUPEX 50 MG TABLET	
QUPEX SR 100 TAB 10*10	1*10
QUPEX SR 200 10*10	1*10
QUPEX SR 300 10*10	1*10
QURE 750MG	1X10T
QURE IV 500MG	100ML
QURE OZ	1X10T
QURE-250MG	1X10T
QURE-500MG	1X10T
QURS KUSHTA MARJAN JAWA	1*20
QUTAN-100 TAB 10*10	1x10xTab
QUTAN-200 TAB 10*10	1x10xTab
QUTAN-25 TAB 10*10	1x10xTab
QUTAN-300 TAB 5*10	1x10xTab
QUTAN-50 TAB 10*10	1x10xTab
QUTAN-SR 100 TAB 10*10	1x10xTab
QUTAN-SR 200 TAB 10*10	1x10xTab
QUTAN-SR 300 TAB 10*10	1x10xTab
QUTAN-SR 400 TAB 10*10	1x10xTab
QUTE 120MG CAP 1*10	1*10
QUTIPIN 100 TAB 10*10	1*10TAB
QUTIPIN 200 TAB 5*10	1*10TAB
QUTIPIN 25 TAB 10*10	1*10TAB
QUTIPIN 300 TAB 5*10	1*10TAB
QUTIPIN 50 TAB 10*10	1*10TAB
QUTIPIN SR 100 TAB 5*10	1*10TAB
QUTIPIN SR 200 TAB 5*10	1*10TAB
QUTIPIN SR 300 TAB 5*10	1*10TAB
QUTIPIN SR 400 TAB 5*10	1*10TAB
QUTIPIN SR 50 TAB 5*10	1*10TAB
QUVAST SOFTGEL CAPS	10'S
R-DICLO.30ML.VIL	1VIL;
R-DIN 150 MG. TAB	1x10
R-FLOX 200	1*10
R-FLOX SYP.	1*60ML
R-LIV DROP	1*30ML
R-LIV DS CAP	1*10
R-LIV SYP.	1*100ML
R-LIV SYP.	1*200ML
R-PPI TAB	1x10
R-PURE D CAP	1X10C
R-PURE TAB	1X10T
R-PURE TABLETS	1x10
R. C. 2.5 GR	2.5GR
R.B TONE DROPS	30ML
R.B TONE FORTE TAB	10'S
R.B TONE INJ	1AMP
R.B TONE SY	200ML
R.B TONE XT	10'S
R.C.FORTE 4gm	VIAL
R.L GLASS PANTAGOAN	1 X 500 ml
R.L PLASTIC PENTAGON	1 ph
R.L(NIRLIFE)	1*500ML
R.L. PDPL 500ML	500ML
R.LOC INJ 1*7	1x7xAmp
R.LOC TAB 150MG 10*30	1*30*TAB
R.LOC TAB 150MG 15*30	1*30*TAB
R.P.FORTE	1x6
R2 TAB 10MG 10*10	1*10
RA MEX TAB 15MG 10*10	1*10*TAB
RA-MEX TAB 2.5MG 10*10	1*10*TAB
RA-MEX TAB 7.5MG 10*10	1*10*TAB
RA-NEX TAB 5MG 10*10	1*10*TAB
RA-QUIN TAB 200MG 10*10	1*10*TAB
RA-QUIN TAB 400MG 10*10	1*10*TAB
RA-ZIN TAB 1000MG 10*10	1*10*TAB
RA-ZIN TAB 500MG 10*10	1*10*TAB
RAB 20 MG TAB	1x10
RAB D CAPSULES	1x10
RABBLE 20	1X10
RABBLE DSR	1X10
RABCER-D TAB	1*10
RABCER-DSR CAP	1*10
RABCY DSR	1*10
RABDOMAN 1 ML.	VIAL
RABDOMUN 1ML	VIAL
RABEDEX-20 TAB	1*10
RABEDEX-DSR CAPS	1*10
RABEDEX-L CAPS	1*10
RABEDIF	1X10C
RABEFINE DSR CAP	1X10
RABEFINE FAST 20MG TAB	1X10
RABEFIT-20 TAB.10'S	1X10
RABEFIT-DSR	1X10
RABEGARD-D SR TAB	1x10
RABEKIND DSR CAP 6*10	1x10xTab
RABEKIND PLUS TAB 3*10	1*10TAB
RABEKIND-20 TAB 8*10	1x10xTab
RABEKIND-CP CAP 3*10	1*10CAP
RABEKIND-FAST TAB 6*10	1x10xTab
RABELEX TAB	1X10
RABELEX-D TAB	1X10
RABEMAC 10MG TAB	1X10
RABEMAC 20	1X10T
RABEMAC FAST	1X10T
RABEMAC INJ	1X1
RABEMAC ITR	1X10T
RABEMAC LS	1X10S
RABEMAC-DSR	1X10
RABENTA DSR CAP	1x10
RABENTA TAB	1x10
RABEPAX 20MG TAB	1x10
RABEPHEX 20	1X10T
RABEPHEX D	1X10C
RABETERO L TAB.	1X10
RABEZ 20	1X10
RABEZ 20	1X10
RABEZ D CAP	1X10
RABEZ FR TAB	1X10
RABEZ FR TAB	1X10
RABEZ L TAB.	1X10
RABEZ Z	1X10
RABEZOL 20	1X10T
RABEZOL DSR	1X10T
RABEZOLE-IT	1X10C
RABICARE-DSR CAP	1*10
RABICIP 20 MG	10'S
RABICIP 20MG TAB	15'S
RABICIP D CAPS	10'S
RABICIP IV	2.5 ML
RABICIPFAST TAB	10'S
RABICOL TAB	1X10
RABICOL - D TAB	1X10
RABICON D 1*10	1*10
RABIDOZ-SR 1*10	1*10
RABIFAST 10MG TAB	1X10
RABIFAST 20	1X10T
RABIFAST XL CAP.	1X10C
RABIFAST-DSR	1X10T
RABIGAL DSR CAP	1X15
RABIGAL- DSR CAP	1X10
RABIGAL-20 TAB	1X10
RABIGAL-D TAB	1X10
RABIKAV 20 TAB	1X10
RABIKEM-DSR CAPS	1x10
RABIKON 1*10	1*10
RABIKON-D CAP 1*10	1*10
RABILAST CAP	1*10
RABILEX 20MG TAB	1*10
RABILEX DSR CAP	1*10
RABILINE 20 TABLET	1*10
RABILINE-DSR CAP	1*10
RABILINE-L CAP	1*10
RABILOC PLUS CAP 10*10	1*10*CAP
RABILOC RD CAP 10*10	1x10xCap
RABILOC TAB 20MG 10*10	1x10xTab
RABIMER Z	1X10
RABINA-20 TAB	1*10
RABINA-D CAPS.	1*10
RABIO CAP	1X10
RABIPEN 20	1X10T
RABIPEN-DSR	1X10C
RABIPLUS	1X10C
RABIPLUS I.V.	1XVIAL
RABIPLUS-D	1X10C
RABIPLUS-XT	1X10C
RABIPUR	1X1ML
RABIPUR INJ	1*1*VIAL
RABIQUIN-DSR CAP	1*10
RABISAL DSR CAP 10*10	1*10*CAP
RABISAL TAB 20MG 10*10	1*10*TAB
RABISIN 1ML	VIAL
RABISUN TAB	1X10
RABITECH-DSR CAPSULE	1*10
RABITION DSR CAPS	1*10
RABITOP 20MG	1X10
RABITOP D	1X10C
RABITOP DSR CAP	1X10
RABITOP FAST 20MG	1X10T
RABITOP-10MG.TAB	1X10
RABITOP-20MG.TAB	1X10
RABIUM DSR CAP 20*10	1x10xCap
RABIUM FAST TAB 10*10	1x10xTab
RABIUM PLUS CAP 10*10	1x10xCap
RABIUM XL 10*10	1*10TAB
RABIUM-20 TAB 15*15	1x15xTab
RABIWIN IT TAB	1x10
RABIWIN-DSR CAPS	1X10CAP
RABLET 10	1X10T
RABLET 40	1X10T
RABLET IT	1X10C
RABLET IV	VIAL
RABLET-20	1X10T
RABLET-D	1X10C
RABLET-L	1X10 CAP.
RABLET-Z	1X10C
RABNEW-DSR	1*10
RABNEW-L	1*10
RABNEXT DSR CAP	1x10
RABNEXT TAB	1x10
RABNIL-20	1*10
RABNIL-20 TAB	1*10
RABNIL-DSR CAP	1*10
RABNIL-LS	1*10
RABOC DXR	1x10
RABOC-20	1X10TAB
RABOMISH 20MG TAB	1x10
RABONIK DSR 40MG 10*10	1*10*CAP
RABONIK DSR CAP 10*10	1*10*CAP
RABONIK PLUS TAB 10*10	1*10*TAB
RABONIK PLUS TAB 40MG 10*10	1*10*TAB
RABONIK TAB 20MG 10*10	1*10*TAB
RABONIK TAB 40MG 10*10	1*10*TAB
RABOPEP-DSRTAB	1X10
RABOSURE 10*10	1*10
RABSET-20MG TAB	1*10
RABSET-D TAB	1*10
RABULCER-20 TAB 10*10	1x10xTab
RABULCER-D CAP 10*10	1x10xCap
RABUS-20	1X10TAB
RABUS-D CAP	1X10CAP
RABUSE 20MG	1X10
RABZER D TAB 10*10	1*10*TAB
RABZER TAB 20MG 10*10	1*10*TAB
RACE - P SUSP	60ML
RACE 1.25	1X10C
RACE 2.5MG	1X10C
RACE 4.5GM INJ.	1X4.5GM
RACE 5	1X10C
RACE H 2.5	1X10C
RACE H 5	1X10C
RACE-F SACCHET	1SACHET
RACEDOT 10	1X10MG
RACETRIL SACHET	1PIC
RACID SYP	1x170ML
RACIGYL SACHET 12*1PC	1x1xPc.
RACIGYL-O SYP 30ML	1*30ML
RACIGYL-O TAB 3*10	1*10TAB
RACIGYL-SB SACEHET 12*1GM	1*1GM
RACIPER D CAP 20MG 10*10	1*10*CAP
RACIPER D CAP 40MG 10*10	1*10*CAP
RACIPER I.V. 40MG	1*1*VIAL
RACIPER L CAP 10*10	1*10*CAP
RACIPER TAB 20MG 15*10	1x10xTab
RACIPER TAB 40MG 15*10	1x10xTab
RACOTIL 100MG TAB	10'S
RACTOFLAM MR TAB	1*10
RACTORANGE SYP.	1*200ML
RADIAL TONIC	200 ML
RADIANCE CAP	1X15
RADIANCE H CAP	1X15
RADIC TAB	1x10
RADIC AMP	1X2ML
RAF TAB	1X10
RAFFOLEV PLUS SUSP.	100ML
RAHAT.OIL	1.PH
RAIM 30MG CAP	1X10
RAJET-D 1*10	1*10
RAJPRAVARTINI VATI	1x20
RAJPRAVARTINI VATI	1x60
RAKNIM S TAB	1*10
RAKSHA FMD	30ML
RAKSHA-OVAC TRIVALENT	1X30ML
RAKSHARAB 1 ML.	VIAL
RAKTINA SYRUP 100ML	100ML[91]
RAKTOPAN D TAB	1*10
RAKTORANGE SYP.	1*200ML
RAKTOREX SYP.	1*100ML
RAKTOVIT PLUS TAB	1*10
RAKZINE TAB	1*10
RALCIDIN EXP	1x100xMl.
RALIO-D CAP	1x10
RALISTA	1X10
RALLIDEX D IV	1x500xMl.
RALOP CAP 10*10	1x10xCap
RALOP SYP 30ML	1x30xMl.
RALOP SYP 60ML	1*60*ML
RAMADOL INJ	1X2ML
RAMCEF O DRY SYP	
RAMCEF O DRY SYP	1*1
RAMCOR CAP 1.25MG 10*10	1x10xCap
RAMCOR CAP 10MG 10*10	1x10xCap
RAMCOR CAP 2.5MG 10*10	1x10xCap
RAMCOR CAP 5MG 10*10	1x10xCap
RAMCOR H 2.5 CAP 10*10	1x10xCap
RAMCOR H 5 CAP 10*10	1x10xCap
RAMICARD .25MG TAB	1X10
RAMICARD .5 MG TAB	1X10
RAMICARD 1.25MG TAB	1X10
RAMIHART-2.5 TAB 6*7	1x7xTab
RAMIHART-5 TAB 4*7	1x7xTab
RAMIHART-H 5 TAB 2*10	1x10xTab
RAMIPPRES 1.25 CAPS	10'S
RAMIPPRES 2.5 CAPS	10'S
RAMIPPRES 5MG CAPS	10'S
RAMIPRES H5 MG TAB.	10'S
RAMIPRES 10	1X10
RAMIPRES H TAB	10'S
RAMIPRO CAPS 2.5	1x10
RAMIPRO CAPS 5MG	1x10
RAMISAVE H5 TAB 10*10	1*10*TAB
RAMISAVE TAB 2.5MG 10*10	1*10*TAB
RAMISAVE TAB 5MG 10*10	1*10*TAB
RAMISTAR 1.25	1X10T
RAMISTAR 10MG	1X10C
RAMISTAR 2.5	1X10T
RAMISTAR 5MG	1X10T
RAMISTAR M XL 25	1X10 TAB.
RAMISTAR M XL 50	1X10 TAB.
RAMISTAR-A 2.5	1X10C
RAMISTAR-H 10	1X10T
RAMISTAR-H 2.5MG	1X10
RAMISTAR-H 5	1X10C
RAMITORVA CAP 10*10	1*10*CAP
RAMIZYL-H TAB	1X10
RAMY24 10 CAP	1x10
RAMY24 2.5 CAP	1x10
RAMY24 5 CAP	1x10
RANBAMYCIN 100 ml.	VIAL
RANBAMYCIN 30 ml	PH
RANBAXY OXY 100 ML	100 ML
RANBAXY OXY 3O ML	3O ML
RANBIDONE I.U 60ML	
RANBIOTIC INJ 20ML	1X20ML
RANBIOTIC VIAL 10 ML.	1 VIAL
RANBIOTIC VIAL 2 ML.	1 VIAL
RANBISOLONE 25MG AMP	1AMP
RANCAD	1X10T
RANCAD OD	1X10TAB.
RANCET CAP.	1x10
RANCET GEL	1TUB
RANCOF SYRUP	100ML
RANCORT	1X1
RANCOTRIM DS TAB	1x10
RANEME INJ	2X2ML
RANIDOM SYP 170ML	1x170xMl.
RANIDOM TAB(NF) 12*20	1x20xTab
RANIDOM-O SYP 200ML	1x200xMl.
RANIDOM-ON+RANITIDINE 1+1AMP	1*2AMP
RANIDOM-RD TAB 10*10	1*10TAB
RANIGEM-PD SYP	60ML
RANIKHET 'F' 200 DOSE	1X10
RANIKHET 'F'100 DOSE	1X10
RANIKHET 'F'1000 DOSE	1X10
RANIKHET 'F'500 DOSE	1X10
RANIKHET LASOTA 200DOSE	1X10
RANIKHET LASOTA 500DOSE	1X10
RANILOC.TAB	1X10
RANILUP-D CAP	1X10
RANISPAS TAB 10*20	1x20xTab
RANITIDINE 10ML	1 VAL
RANITIDINE 2ML	2 ML
RANITIDINE INJ 2ML	1 AMP
RANITIDINE INJ 30ML	1 VAL
RANITIDINE.150MG.TAB	
RANITIN-150MG TAB	1X10
RANITIN-150MG TAB	1X10
RANIZAC 150 1*10	1*10
RANMAX SYP. 100 ML.	1 PH.
RANMAX SYP. 200 ML.	1 PH.
RANMIX 25 KG	25 KG
RANMIX TOTAL 1 KG	1 KG
RANMIX TOTAL 5 KG	5 KG
RANOCIN CAP.	1x10
RANOLAZ 500	1X10T
RANOLAZ OD	1X10T
RANOPILL TAB 10*10	1*10TAB
RANOPILL TAB 3*10	1*10TAB
RANOPLAN TAB 2*10	1*10TAB
RANOXYL.250.CAP	1X10
RANOZEX TAB 10*10	1*10TAB
RANPHENICOL 250MG TAB	1X10
RANPHENICOL 500MG TAB	1X10
RANQUIL SUSPENSION 60ML	1 PH
RANSET DT	1x10
RANTAC 150MG	1X20
RANTAC 300MG	1X10
RANTAC D PLUS	10'S
RANTAC D TABS	10'S
RANTAC INJ	2 ML
RANTAC MPS LA SYRUP	170 ML
RANTAC- MPS SY	170ML
RANTOP SYRUP	100ML
RANVIDONE SPRAY	
RANVIDONE-IU	60 ML
RANX 1000MG.TAB	1X10
RANX 500MG. TAB	1X10
RANZ 500 TAB 3*10	1x10xTab
RANZEC TAB	1X10
RANZEC- 30ML VIAL	30ml
RANZEC.10ML.VIAL	1VIAL
RAPCO-10 TAB.	1X10
RAPCO-20 TAB.	1X10
RAPCO-D TAB.	1X10
RAPEED 20	1X10T
RAPEED 20MG--------------	1X10
RAPEED IT	1X10C
RAPEED-D	1X10C
RAPEED-L	1x10C
RAPER-D TAB	1X10
RAPIAR INJ.4GM	1X4GM
RAPIDON EYE DROP	1X5 ML
RAPIDOXYN TAB.	1x10TAB
RAPIDTESTRIPS.	1PH
RAPIDUCE SYP 100ML	1*100ML
RAPIDUR (10CM) 4"	1 PCS
RAPIDUR (15CM) 6"	1 PCS
RAPILIF CAP 8MG 10*10	1*10*CAP
RAPIROL 20	1X10T
RAPIROL-D	1X10C
RAPITEST KIT	1 PCS
RAPITHER INJ 1*5	1*5*AMP
RAPITUS	1X60ML
RAPITUS PLUS	1X100ML
RAPITUS SYP	1X100ML
RAPKOSTAT CAP	1x10
RAPKOSTAT GEL	1x20 GM
RAPPETITE SYRUP	1x150 ML
RAPTUS SYP	100ML
RAPTUS-D SYP	100ML
RAPTUS-E SYP	100ML
RARRITOL 200ML SYP.	200ML
RARRITOL TAB.10'S	1X10
RAS PIPRI	1x10 TAB
RASALECT 0.5TAB 10*10	1*10TAB
RASALECT-1 TAB 5*10	1*10TAB
RASE SPAS	1X10
RASE TAB	1X10
RASE-1 SACCHET	1SACCHET
RASE-3 SACHET	1 SAC
RASHNIL OINT	1X30GM
RASMIN	1X26T
RASMINKYA RAS 10GM	1*10
RASOL 250GM	PH
RASOL 450GM	PH
RASOTAN AM TAB	1x10
RASOTAN AM 5 TAB	1x10
RASOTAN BETA 25 TAB	1x10
RASOTAN H 20 TAB	1x10
RASOTAN-20 TAB	1x10
RASP FOR BIPOLAR PROSTHESIS	1 PCS
RASRAJ RAS GOLD	1*10
RAT KILL	100GM
RAT KILL	2BAITS
RATIO-10 TAB	1X10
RATIO-10 TAB	1x10
RAVIANSN TAB	1X10
RAVIBEX CAP.	1x10
RAVIBEX PLUS SYP	1x100ML
RAVIBEX PLUS TAB	1x10TAB
RAVIBEX SYP.200 ML.	1 PH.
RAVICORT VIAL	1 VIAL
RAVIKAV DSRTAB	1X10
RAXITID 150MG TAB	1X10
RAYKAVIT FA SYP	1X150ML
RAYKAVIT SYP	1X200ML
RAZ 20 TAB	1X10
RAZEL 10	1X10
RAZEL 10MG TAB	1X10
RAZEL 20	1X10
RAZEL 5	1X10
RAZEL 5MG TAB	1X10
RAZEL F 10	1X10
RAZEL F 5	1X10
RAZO I.V.20MG	1*1VAIL
RAZO-20MG TAB 10*10	1x10xTab
RAZO-D TAB 10*10	1x10xTab
RAZO-L TAB 10*10	1*10CAP
RAZOVA-DSR CAP	1*10
RAZOVA-LS CAP	1*10
RB-PLEX SYP	200ML
RBC RED CAP	1X15
RBC RED 100ML	100ML
RBC RED SYR	200ML
RBC RED SYR 300ML	300ML
RBC ING	2ML
RBC RF TAB	1*10
RBC-XL 500 TAB	1*10
RBC-XL ING	AMP
RBS ZYME SYP	200ML
RBX-AID	1PICE
RC FORTE D	4GM
RCC TAB	1x10
RCCALVIT VIL	15ml
RCID PLUS CAP 12*10	1x10xCap
RCID RF TAB 20MG 12*10	1*12*TAB
RCIFAX	1X10T
RCIFAX 400	1X10T
RCIFAX 550	1X10T
RCIFAX SYP.	1X60ML
RCIN 150	1X10
RCIN 300	1X10
RCIN 450	1X10
RCIN 600	1X3C
RCIN SUSP	1X200ML
RCINEX 450	1X10
RCINEX 600	1X3
RCINEX DT	1X10T
RCINEX E	1X6T
RCINEX EZ	1X6
RCINEX KID	1X10
RCINEX Z	1X2T
RCINEX Z KID	1X10T
RCLONAC	1X10T
RD-150 TAB	1X10
RD-S TAB	1X10
RD-V TAB	1X10
RE-FLEX 1.5GM POW	1.5GM
RE-MOOV 10GM.	1X10GM.
RE-MOOV OINT.	20MG
RE-MOVE-5GM*	1TUBE
RE-TURN	1 AMP
REACTIN 30ML	1VIAL
REACTIN 3ML	1AMP
REACTIN-GEL 30GM	1PH
REACTIN.100SR.TAB	1X10
REACTIN.50MG.TAB	1X10.
REACTINE TAB	1x10TAB
REACTINE-PLUS TAB	1x10
REAL CAST POP BANDAGE 10 CM	1 PCS
REAL CAST POP BANDAGE 15CM	1 PCS
REAL CAST(GYPSONA) 4"	1 PCS
REAL CAST(GYPSONA) 6"	1 PCS
REALVIT SYP	1x200
REBAGEN	1X10T
REBALANZ SACHET 50*1	1*1*PC
REBEN-AL SYP	10ML
REBEN-AL TAB	1x1
REBILEX-20MG TAB	1*10
REBONE	1X10S
REBONE FORTE	1X10
REBONE PLUS	1X10S
RECAGON INJ	1x1xVl
RECAL TAB	1*10
RECARTIX CAP.	1x10
RECEPTAL 10 ML. VIAL	1 VIAL
RECEPTAL 2.5ML	1X2.5ML
RECHARGE 200 GR	200 GR
RECHARJE FORT CAP	1X10
RECHARJE PLUS CAP	1X10
RECITA FORT TAB 10*10	1*10*TAB
RECITA LITE TAB 10*10	1*10*TAB
RECITA TAB 10MG 10*10	1*10*TAB
RECLIDE 30MR TAB 10*10	1x10xTab
RECLIDE 60MR 10*10	1x10xTab
RECLIDE 80 TAB 20*15	1x15xTab
RECLIDE XR-60 TAB 10*10	1*10TAB
RECLIDE-40MG TAB 20*10	1x10xTab
RECLIMET TAB 30*15	1x15xTab
RECMIN TAB 1*10	1*10
RECOBAL 150 TAB 5*10	1x10xTab
RECOBAL 75 TAB 10*10	1x10xTab
RECOBAL-M 75 CAP 10*10	1x10xCap
RECOCETAM SY	1PHI
RECOFAST PLUS SYP.	1X60ml
RECOFAST PLUS TAB.	1x10
RECOFAST SYP.	1X60ml
RECOFAST TAB.	1x10
RECOMBANT TEST KIT	1 PCS
RECOSULIN M 30 INJ.	1x1xVl.
RECOSULIN M 50 INJ	1x10xMl.
RECOSULIN N INJ.	1x1xVl.
RECOSULIN R INJ.	1x1xVl.
RECOVA 360"A.D+F.DAY	30ML
RECOVA 360"A.D+F.NIGHT	50ML
RECOVA 360'AGE DEFY+FAIR	50ML
RECOVA 360.AGE UNDR EYE CR.	15ML
RECOVIN CAP	1X10CAP
RECOVIT	1X10
RECOVIT 1 LT	1 LT
RECOVIT 120 ML	120 ML
RECOVIT 500 ML	500 ML
RECOVIT NP	1X10T
RECOVIT TOTAL	1X15C
RECOVITAL SYU	200ML
RECOVITAL CAP	1X10
RECUTIN 100DT 10'S	1X10
RECVIT CAP	1X10
RED GEL TOOTH PASTE 40GM	1PICE
RED GEL TOOTH PASTE 80GM	1PICE
RED-2 TAB	1x10
RED-TZ TAB	1x10
REDCLOX DL CAP 10*9	1*9*CAP
REDCLOX LB CAP 20*6	1x6xCap
REDEFINE TAB 10*10	1x10xTab
REDEX INX AMP	1x2ML
REDEX INX VIEL	1x2ML
REDEX INX VIEL	1x2ML
REDFAST TAB.10'S/MC	M
REDFAST-MR TAB.10'S/MC	M
REDHOM TAB.10'S/SAT	S
REDICATE 200 TAB 10*10	1*10TAB
REDICATE CLAV 200 TAB 10*10	1*10TAB
REDICATE DS SYP	1*30ML
REDIF EYE DROP	10ML
REDIHEALTH SYP 150ML	1*150ML
REDIHEALTH TAB 10*10	1*10TAB
REDIMOL INJ AMP	1x1ML
REDIMOL INJ AMP	1x2ML
REDIMOL TAB	1x10
REDIOUT SYP 10ML	1*10ML
REDIOUT TAB 20*1	1*1TAB
REDIPLEX TAB	1x10
REDIRINSE SYRUP	120ML
REDOTIL-10 POWDER 30*1GM	1x1xGm.
REDOTIL-30 POWDER 20*3GM	1x3xGm.
REDPRO PLUS DROP	20ML
REDPRO PLUS SYP	200ML
REDRESS CREAM	10GM
REDSUN C	1X10
REDUCE 10MG	1X10T
REDUCE 15MG	1X10T
REDVIT CAP	1*10
REDZOX-H TAB.6'S/MC	M
REED-RD SYP	100ML
REESHAPE CAP 120MG 3*10	1*10*CAP
REESHAPE CAP 60MG 3*10	1*10*CAP
REESHAPE SLIM GR 400GM	1*400*GM
REEVAC SY	100 ML
REFIRM	1X10
REFIRM CT	1X10C
REFLO-Z	1X10
REFRESH LIQUIGEL	10ML
REFRESH SYP	1x60ML
REFRESH TAB	1x10
REFRESH TEARS	10ML
REFRESHING BABY SAOP 125GM	1*125GM
REFRESHING BABY SOAP 75GM	1*75GM
REFZIL O DROP	1x10xMl.
REFZIL O DROP	1x10xMl.
REFZIL O SYP 125MG	1x30xMl.
REFZIL O SYP 125MG	1x30xMl.
REFZIL O SYP 250MG	1*30*ML
REFZIL O TAB 250MG	1x10xTab
REFZIL O TAB 250MG	1x10xTab
REFZIL O TAB 500MG	1x6xTab
REFZIL O TAB 500MG	1x6xTab
REGAIN 25MG TAB	1X10
REGAIN 25MG TAB	1X10
REGAIN BOLUS	1x6
REGAIN- CAP	1x10
REGAN TAB	1*10
REGESTRONE TAB 10*10	1x10xTab
REGESTRONE TAB 20*10	1*10*TAB
REHEPTIN CAP 4*6	1*6CAP
REHEPTIN SUP	100ML
REHIDRATA T ORANGE SACHET	1*50*ML
REHIDRATA T PINEAPPLE SACHET	1*50*ML
REIDIN PLUS CAP	1X30
REIDIN PN 450ML	1PHI
REINFORCE CAP	1*10
REINFORCE G	1*10
REINFORCE SUSP	200 ML
REJ INJECTION	1X 2ML
REJ OD TABLET	1X10
REJOICE INJECTION	1 VAIL
REJOICE OD CAPSULES	1X10
REJOICE SYP	1*1
REJOLLY CAP 10*10	1*10*CAP
REJUKAST TAB	1X10
REJULIV PLUS SYP	1x100ML
REJULIV SUSP	1x100ML
REJULONG INJ	1AMP
REJULONG-OD	1X10
REJUNATE PLUS	1X10T
REJUNEURON AMP	1AMP
REJUNEURON DL CAP	1X10
REJUNEURON OD	1X10
REJUNEURON PLUS	1AMP
REJUNEX CAP 10*10	1x10xCap
REJUNEX INJ 1AMP	1x1xMl.
REJUNEX PLUS CAP 5*7	1x7xCap
REJUNEX-OD CAP 10*10	1x10xCap
REJUNURON CAP	1X30
REJUNURON PL	1X10
REJUNURON PLUS CAP	1X10
REJURON 300	1X10C
REJURON PLUS	1X10T
REJUSITE	1X10T
REJUVATE INJECTION	1 VAIL
REJUVATE OD CAPSULES	1X10
REKOOL D CAP 10*10	1x10xCap
REKOOL L TAB 10*10	1*10*TAB
REKOOL TAB 20MG 15*15	1*15*TAB
RELAX COUGH SYU	1PH
RELAX-F	1x10
RELAXOGESIC OINT	1TUB
RELAXURO TAB	1X10
RELAXYL DA	1TUB
RELAXYL GEL.	1 TUBE
RELAXYL OINT.	1 TUBE
RELAXYL PLUS TAB	1x10
RELAXYL SR	1x10
RELAXYL TAB.	1x10
RELAXYL-S	1X10TAB
RELAXYL-T	1X10TAB
RELCER GEL 180 ML	1X180 ML
RELEEF COUGH SYU	60ML
RELEFF.TAB	1X10
RELENT PLUS SYP	1*60ML
RELENT TAB *50*10	1x10xTab
RELENT-OD CAP 10*10	1*10CAP
RELEX	1
RELEXYL SPRAY	35GR
RELICUFF-CANDY	1*250PCS
RELIDOL CAPSULES	1x10
RELIDOL INJECTION	1x1ML
RELIEF -30GM.OIN	IPH
RELIEF TAB	1x10TAB
RELIFE OIN SMALL	1PH
RELUX SACCHET 23GM	23GM
RELYSIN Z DROP	1x15ML
RELYTE RTU LIQ	1x200xMl.
RELYTE SACHET 4.2GM 1*5PC	1*5*4.2GM
REM CC SYP	1x60xMl.
REM UP SUSP.	1*300ML
REMAC INJECTION	1*2ML
REMAC OD	1*10
REMOKUF TAB	1*10
REMOL TAB	1*10
REMOVER INJ 10 ML	10 ML
REMYLIN TAB 10*10	1*10*TAB
REMYLIN D TAB 10*10	1*10*TAB
RENALKA SYP	1x100xMl.
RENALKA SYP 1*200ML	1*200ML
RENERGY TAB	1X10
RENERVOL P 800 TAB	1X10
RENERVOL TAB.10'S/K.C.	1X10
RENERVOL-P SUS.100ML	100ML
RENICOL E/D	1*10ML
RENICOL E/OINT	1*5GM
RENICOL PX E/D	1*5ML
RENIDEX E/D	1*5ML
RENOL 500 ML	500 ML
RENOL TAB	1X10
RENOLEN DROP	1*10ML
RENORVAL SYP	1X100
RENOX-4TAB	10X10
RENT , 02 BULK CYL(JUNE 09-MARCH10)	8 CYL
RENT FOR 20 NOS O2 BULK CYL	1 DAY
RENT FOR 6 NOS N2O D TYPE CYL	1 DAY
RENT FOR CO2 CYLINDER	1 DAY
RENT FOR O2 B TYPE	1 DAY
RENT FOR O2 D TYPE CYL	1 DAY
RENT PATLI BULK	3 CYL
REO TZ TAB	1x10
REO-OZ TAB	1x10
REON 100ML	100ML
REON 200 ML	200ML
REOSTO TAB	1x60xTab
REPACE 100 TAB 5*10	1*10TAB
REPACE 25 TAB 20*10	1*10TAB
REPACE 50 TAB 20*10	1*10TAB
REPACE-A TAB 10*10	1*10TAB
REPACE-AF TAB 10*10	1*10TAB
REPACE-H TAB 20*10	1*10TAB
REPALOL TAB 10*10	1*10TAB
REPALOL-H TAB 10*10	1*10TAB
REPEPSA	1X10
REPEPSA-D	1X10
REPITEST KIT	1 PCS
REPLANTA 100 GM.	100 GM.
REPLANTA 500GM	
REPLENTA 100GM	PH
REPRAL 20MG TAB	1X10
REPRAL 20MG TAB 15'S	1X15
REPRAL-D	1X10
REPROMAX bolus..	1x4
REPRONOL INJ 10 ML	10 ML
REPRONORM 10 ML	10 ML
REPTILASE AMP	1AMP
REQCAL SYP	1x200ML
REQCAL TAB	1x15
RESERA-DP	10'S
RESICA-KIT	1X1KIT
RESILAC CAP	1X6
RESILAC SACHET	1X1
RESNER INJ	1X1ML
RESNER SOFT CAP	1X10
RESOCHIN 250MG	1X10T
RESOCHIN-DS 500 MG	1X5T
RESODIM 15 TAB.	1X4 TAB.
RESOPHYL TAB	1x10
RESOPHYL FORTE	1x10
RESOPHYL-150 TAB	1x10
RESOREX EXPECTORANT	1*110ML
RESOUND BTE	1 SET
RESPICURE D SYP 1*100ML	1*100*ML
RESPICURE D SYP 1*60ML	1*60*ML
RESPICURE P SYP 1*60ML	1*60*ML
RESPICURE SYP 1*100ML	1*100*ML
RESPICURE SYP 1*60ML	1*60*ML
RESPICURE TAB 10*10	1*10*TAB
RESPIDON 4	1X10T
RESPIDON-1MG TAB	1X10
RESPIDON-2MG TAB	1X10
RESPIDON-3MG TAB	1X10T
RESPIGAT-SR TABLET	1X5
RESPIGO A NASAL DROP	1*1*PH
RESPIGO BABY NASAL DROP	1*20*ML
RESPIGO P NASAL DROP	1*1*PH
RESPILIFE 100ML SYP	100ML
RESPILIFE-D SYP	100ML
RESPILIFE-P SYP	100ML
RESPIRA LIQ	100ML
RESPIRA TAB	10'S
RESPIRA-ACE CAPS	10'S
RESPIRA-D LIQ	100ML
RESPIRAYORY EXCERCISER	1 PCS
RESPIRO METER	1 PCS
RESPIROMETER	1 PCS
RESPIVIT CAP.	1*10
RESRA -DP TABS	10'S
REST AID	1X10T
REST AID PLUS	1X10T
RESTASIS 0.05% 30*40.4ML	
RESTECLIN CAP 250MG 10*10	1x10xCap
RESTECLIN CAP 500MG 10*10	1x10xCap
RESTFULL	1X10T
RESTOBAL 500ML	PH
RESTORA 250ML	1*250ML
RESTORA 500ML SYP	1PH
RESTYL 0.25MG	1X10
RESTYL 0.5MG	1X15
RESTYL 1MG	1X10
RESVITA	1X10C
RESWAS SYP 120ML	1*120ML
RETAREL CREAM	1*10MG
RETAREL CREAM 5MG	1*5MG
RETAREL OINT	1*10GM
RETENSE OD TAB 5*10	1*10TAB
RETENSE TAB 5*10	1*10TAB
RETINO A OINT .25%	1x20xGm.
RETINO A OINT .50%	1x20xGm.
RETINOX CAP	1*10
RETORLIX 10	1X10T
RETORLIX 100	1X10T
RETORLIX 20	1X10T
RETORLIX 5	1X10T
RETORLIX SP-10	1X10T
RETORLIX SP-5	1X10T
RETOZ-120 TAB 10*10	1x10xTab
RETOZ-60 TAB 10*10	1x10xTab
RETOZ-90 TAB 10*10	1x10xTab
RETROLIX INJ	1X2ML
RETUNE 50MG TAB	1X10
RETUNE LS TAB.	1X10TAB.
REUMAWIN CAP	1X10
REVALDO 20MG TAB	
REVALDO GEL INJ	1XVIAL
REVALDO QR 10'T	10X10
REVALDO-P 40 INJ	
REVAS AM TAB 2.50MG 10*10	1x10xTab
REVAS AM TAB 5MG 10*10	1x10xTab
REVAS AT TAB 10*10	1*10*TAB
REVAS H TAB 25*10	1*10*TAB
REVAS R TAB 2.50MG 3*10	1x10xTab
REVAS R TAB 5MG 3*10	1x10xTab
REVAS TAB 25MG 25*10	1x10xTab
REVAS TAB 50MG 25*10	1*10*TAB
REVELOL 25 H TAB 3*10	1x10xTab
REVELOL 50 H TAB 3*10	1x10xTab
REVELOL AM 25/2.5 10*7	1*7*TAB
REVELOL AM 25/5 TAB 10*7	1*7*TAB
REVELOL AM 50/5 TAB 10*7	1*7*TAB
REVELOL SA 25 TAB 10*10	1*10TAB
REVELOL SA 50 TAB 10*10	1*10TAB
REVELOL XL TAB 100MG 10*10	1x10xTab
REVELOL XL TAB 12.5MG 10*10	1*10*TAB
REVELOL XL TAB 25MG 10*10	1x10xTab
REVELOL XL TAB 50MG 10*10	1x10xTab
REVICI E250	1*10
REVICI E500	1*10
REVICI ING	5ML
REVIMINE TAB	1x10
REVITAL CAP.	60CAP
REVITAL CAPSULES	10CAP
REVITAL CAPSULES	30CAP
REVITAL LIQUID	100ML
REVITAL SENIOR	10CAP
REVITAL WOMAN	10CAP
REVITAL WOMEN	10CAP
REVITAL WOMEN	30CAP
REVIZE CREAM 1.0% 50G	1X50G
REVLAMER 400 TAB 5*10	1*10TAB
REVLAMER 800 TAB 3*10	1*10TAB
REVLIN M SR TAB 150MG 10*10	1*10*TAB
REVLIN M SR TAB 75MG 10*10	1*10*TAB
REVOCAL TAB	1X15T
REVOCAL-XL TAB	1X10T
REVOCON TAB 10*10	1*10TAB
REVODOL	1X10
REVOLIZER	1UNIT
REVOLVING STOOL	1 PCS
REVOTAZ 1.125 GM	1XV
REVOTAZ 4.5GM	1XV
REVOTRIL TAB 0.5MG 50*10	1*10*TAB
REVULANT TAB 500MG 10*10	1*10*TAB
REVULANT TAB 500MG 10*10	1*10*TAB
REVUP CAP	1X10
REVUP PLUS CAP	1X10
REXCOF 50ML	1PH
REXCOF.100ML	1PH
REXFLORA CAP 1*10	1*10
REXFLORA POWDER 4.6GM	1*10
REXFLORA-KID 1*10	1*10
REXIDIN MW	1*100ML
REXIDIN-M GEL	1*10GM
REXIDINE PLUS MW	1*175ML
REXIPRA-10 TAB 10*10	1x10xTab
REXIPRA-20 TAB 10*10	1x10xTab
REXIPRA-5 TAB 10*10	1x10xTab
REXONE S 1.5GM	1VIAL
REXONE S 375 VIAL	1 VIAL
REXOTUSS SYP 100ML	1X100ML
REZ-Q INJ 300MG	1x2ML
REZ-Q SUSP	1x60ML
REZART E INJ 1ML	1x1ML
REZATRIN FORTE TAB	1x6
REZATRIN TAB	1x6
REZIZ FORTE TAB.	1x2
REZIZ SYP.	1X10ml
REZIZ TAB.	1x2
REZIZ-S COMBIK	1x1
REZQ 300 MG. TAB.	1x10
REZQ 600 MG. TAB.	1x10
REZTOR DZ SACHET	1*1
REZTOR SACHET	1*1
RG NEED	20GM
RHAGINYL TAB	1X10
RHE FD-150	1X6
RHE KIT	1X4
RHE-FD	1X6
RHEUMABIN GEL	1X50GRM
RHINASE N/D	1*10ML
RHINO- TABS	10'S
RHINOCORT AQUA64MCG/DOSE	1*200
RHINOCORT NASEL 50MCG	50MCG
RHINOFEX TAB 120 1*10	1*10
RHINOFEX TAB 180 1*10	1*10
RHINOFIT NASAL SPRAY	1*10ML
RHINOMAX TAB 10/5 1*10	1*10
RHINOMAX TAB 4/2.5 1*10	1*10
RHINOREST TAB	1X10
RHINORYL 60ML SYU	1PH
RHNICAL -500MG TABS	15'S
RHOCLONE INJ 150MG	1x1xVl.
RHOCLONE INJ 300MG	1x1xVl.
RHUMACORT AMP	1x1AMP
RHUMACORT GEL 30GM	30GM
RHUMACORT MR	1x10
RHUMACORT TAB.	1x10
RHUMACORT TAB.	1x10
RHUMANIM FORTE TAB	1X10
RHUMANIM PAIN OIL	60ML
RHUMANIM 30GM OIN	30gm
RHUMANIM PLUS TAB	1X10
RHUMANIN GEL 10GM	1x10 GM
RHUMASYL OIL	100ML
RHUMASYL OIL	60ML
RHUMASYL OINT	25GR
RHUMAYOG GOLD TAB	30TAB
RHUMAYOG TAB	1*30
RHZ	1X10
RHZ FORTE	1X10
RHZ KID FORTE	1X10T
RHZ PLUS	1X6
RHZ-KID	1X10
RIB - BELT L	1 PCS
RIB - BELT M	1 PCS
RIB - BELT S	1 PCS
RIB BELT	1 PCS
RIB BELT (L)	1 PCS
RIB BELT (S)	1 PCS
RIB BELT (WIN) S,M,L	1 PCS
RIB BELT 28"	1 PCS
RIB BELT 30"	1 PCS
RIB BELT 32"	1 PCS
RIB BELT 34"	1 PCS
RIB BELT 36"	1 PCS
RIB BELT 38"	1 PCS
RIB BELT 40	1 PCS
RIB BELT 40"	1 PCS
RIB BELT ROMSON	1 PCS
RIB BELT Z PLUS	1 PCS
RIB BELT(L).	1 PCS
RIB BELT(M).	1 PCS
RIB BELT(S)	1 PCS
RIB BRACE MEDIUM	1 PCS
RIBAFIT TAB	1X10T
RIBAVIN 200MG	1X4C
RIBOFLAVIN TAB 50*10	1x10xTab
RIBUTIN	1X6C
RICH ORANGE 200 ML	200 ML
RICH ZYME DROP	1PH
RICH-MIND 200GM	250 GM
RICH-MIND POWDER	200gm
RICHAR XT SYP	1x150xMl.
RICHAR XT TAB 10*10	1x10xCap
RICHGLO-Z.PED.60ML.SYU	
RICHGLOW CAP 10*10	1*10*CAP
RICHNEURON	1X10 TAB.
RICHZYME 200ML	1PH
RICHZYME SYP.	1 PH.
RICLOFEN TAB 10MG.	10 TAB
RICOBAL PLUS CAP	1X10
RICOF-T SYP	100ML
RICONIA G TAB 5*10	1x10xTab
RICONIA LP TAB 6*15	1x15xTab
RICONIA SILVER TAB 10*15	1x15xTab
RIDALPHIN INJ 30 ML	30 ML
RIDALPIN30ML	VIAL
RIDAR CAPS	10'S
RIDAZIN 10 TAB 10*10	1*10TAB
RIDAZINE 25 TAB 10*10	1*10TAB
RIDAZINE 50 TAB 10*10	1*10TAB
RIDCOF EXP	1x60ML
RIDD tm VIAL	6ML
RIDDOF 1ML	1 AMP
RIDEMA 10ML.	VIAL
RIDEX	1x4
RIDOF SYP	1*60ML
RIDOF SYP	100ML
RIDSTON SYRUP	200ML
RIDWORM 1*1	1*1
RIFA I6 (A) TAB 10*10	1x10xTab
RIFA I6 FORTE TAB 10*10	1x10xTab
RIFA I6-E KIT 30*1KIT	1x1xKit
RIFA I6KID FORTE TAB 10*10	1x10xTab
RIFA I6KID TAB 10*10	1x10xTab
RIFACEPT KID-3 TAB 10*10	1x10xTab
RIFACEPT-3 TAB 10*10	1x10xTab
RIFACUM 450	1x10 TAB
RIFACUM EZ	1 KIT
RIFAGUT 400 TAB 10*10	1*10TAB
RIFAGUT TAB 10*10	1*10TAB
RIFATER	1X10
RIFAXIMAX-200	1X10 TAB.
RIFAXIMAX-400	1X10 TAB.
RIFLUX FORT GEL	1x200xMl.
RIGHT ANGLE FORCEPS	1 PCS
RILAM 0.25MG	1*10
RILAM 0.5MG TAB	10
RIMACTAZIDE + E TAB 1*10KIT	1x10xKit
RIMACTAZIDE + E TAB 1*20KIT	1*20*KIT
RIMACTAZIDE DISPED TAB 10*10	1x10xTab
RIMACTAZIDE PLUS TAB 10*10	1*10*TAB
RIMACTAZIDE PLUS TAB 25*4	1x4xTab
RIMACTAZIDE TAB 450/300MG 20*4	1x4xTab
RIMACTAZIDE TAB 450MG 10*10	1*10*TAB
RIMAL INJ	2 ML
RIMOBEST 20MG	1X10T
RIMOVER TAB	1X1
RIMPEK-PLUS TABS	10'S
RIMSTAR 4 FDC TAB 10*6	1x6xTab
RIMSTAR 4FDC 10*15	1*15*TAB
RIMTHREE FDC 10*6	1x6xTab
RIMTHREE FDC TAB 10*15	1*15*TAB
RIMTRIM	1X10 T
RING GONE GEL	30gm
RING GUARD	12GM
RING GUARD	20GM
RING GUARD	5GM
RING PRASARY **	1
RING PRESSERY	1 PCS
RING-RING 10GM	1*10GM
RINGWORM CUTTER POT	1x14 GM
RINIZIDE FORTE DT	1X10
RINOLISER SYRUP	200ML
RINOLISER-100ML	100ML
RINOLISER-MB6 SUS	200ML
RINTAX AZ TAB	1x10
RINTAX PLUS TAB	1x10
RINTAX-O DRY SYP	1x30ML
RINTOSE 1 LT	1 LT
RINTOSE 500ML.	PH
RIOMONT TAB	10,S
RIOZ-20MG TABLET	1X10
RIOZ-DMP TABLET	1X10
RIPACAL TAB	1*10
RIPALEX SYP	1*100ML
RIPAZYME DRP.	1*30ML
RIPAZYME SYP	1*100ML
RIPAZYME SYP	1*200ML
RIPE FD TAB 15*4	1*4TAB
RIPE KIT FORTE TAB 30*1KIT	1x1xKit
RIPE-KIT TAB 30*1KIT	1x1xKit
RIPO CAP	10
RIPO PLUS CAP.	1*10
RIPTON CAP.	1*10
RIPTON SYP	200ML
RISDON-LS TAB 10*10	1*10TAB
RISDONE FORTE TAB 14*10	1x10xTab
RISDONE PLUS TAB 14*10	1x10xTab
RISDONE-1 TAB 21*10	1x10xTab
RISDONE-2 TAB 21*10	1x10xTab
RISDONE-3 TAB 14*10	1x10xTab
RISDONE-4 TAB 14*10	1x10xTab
RISE TUBE 18	1 PCS
RISE TUBE 8	1 PCS
RISOBIN CAPS	1x10CAP
RISOBIN-SF SUSP.	1x200ML
RISOFOS 35MG	4
RISOFOS KIT	1KIT
RISORINE CAP 5*6	1*6*CAP
RISORINE KIT 1*10	1*10*TAB
RITE O CEF SYP	1*30*ML
RITE O CEF TAB 100MG 10*10	1*10*TAB
RITE O CEF TAB 200MG 10*10	1*10*TAB
RITEBEAT 200	1X10T
RITODINE TAB	1X10
RITOLAN TAB.	1x10
RITOX CAP	1x10
RIXMIN 200MG	1X10
RIXMIN 400MG	1X10
RIZ 1	1X10 TAB.
RIZ 2	1X10 TAB.
RIZ LS	1X10T
RIZ PLUS	1X10T
RIZ-F10 TAB	1*10
RIZ-F5 TAB	1*10
RIZI TAB.	1X10
RIZI-D TAB.	1X10
RL 1000ML	1 BOT
RL 500 ML (P)	500 ML.
RL 500ML.	500 ML.
RL PENTAGON	500 ML.
RL PSL	500 ML.
ROBEZOLE-D CAP	1X10
ROBIFLAM 400 TAB	1x10
ROBIN BLEACH	500ML
ROBIN BLUE	100GM
ROBIN BLUE	200GM
ROBIN BLUE	375GM
ROBIN BLUE	50GM
ROBIN BLUE	950GM
ROBIN BLUE+SOAP	375GM
ROBIN BLUE+SOAP	950GM
ROBIN DAZZLING	100ML
ROBIN DAZZLING	200ML
ROBIN LIQ.2-IN-1	150ML
ROBIN LIQ.2-IN-1	75ML
ROBINEX INJECTION	1x10 ML
ROBINEX TABLET	1x10
ROBINI GEL	1x30 GM
ROBINOXOL D TAB.	1x10
ROBINOXOL TAB.	1x10
ROCALTROL CAP 10*10	1x10xTab
ROD-M TAB	1x10
RODASE TAB.	1X2TAB
RODHAK	1 PH.
ROFACLO TAB	1X10
ROFACT RT 50 /SOLARES	
ROFCOM 25 MG.	1x10
ROFCOM 50 MG.	1x10
ROFEB 12.5MG TAB	1X10
ROFEX 500CAP	1X10
ROFEX KID 125MG(1x10)	1x1
ROFEX KID 250MG (1x10)	1x10
ROFIB 50MG TAB 10'S/ARIST	
ROFIXX 50	10'S
ROFIXX-12.5MG TABS	10'S
ROFIXX-25MG TABS	10'S
ROFLOX 15ML.	VIAL
ROFORT CAP	1X10
ROGHAN KAHU OIL	50ML
ROGHAN LABOOB SABA	25ML
ROGHAN LABUB SABA	50ML
ROGLIN 2MG TAB	1X10
ROGLIN 4MG TAB	1X10
ROGLIN-M2 TAB	1X10
ROGLIN-M4 TAB	1X10
ROHITAKARISHTA 450 ML	1 PH
ROKO KIT	1 KIT
ROLAZIN	1X10T
ROLES D CAP 10*10	1*10*CAP
ROLES D CAP 10*10	1*10*CAP
ROLES L TAB 10*10	1*10*TAB
ROLES L TAB 10*10	1*10*TAB
ROLES TAB 20MG 10*15	1*15*TAB
ROLES TAB 20MG 10*15	1*15*TAB
ROLIP 10 MG TABLET	1X10
ROLIP 20 MG TABLET	1X10
ROLL BANDAGE 14CM*4MTR 6"	1 PCS
ROLL BANDAGE 15CMX5MTR 6"	1 DOZ
ROLL BANDAGE 10CM X 5MTR 4"	1 DOZ
ROLL BANDAGE 10CMX5MTR 4"	1 DOZ
ROLL BANDAGE 15CM X 5MTR 6"	1 DOZ
ROLL BANDAGE 2''	1 DOZ
ROLL BANDAGE 4"	1 DOZ
ROLL BANDAGE 4INCH	1 DOZ
ROLL BANDAGE 5CM*5MTR=2 INCH	1 DOZ
ROLL BANDAGE 6 INCH	1 DOZ
ROLL BANDAGE 6"	12 PCS
ROLL BANDAGE 7.5CM*5MTR=3 INCH	1 DOZ
ROLL BANDAGE 7.5CMX5MTR 3"	1 DOZ
ROLL BANDAGE 9CM*4MTR 4"	1 PCS
ROLLBANDAGE 15X3	1 DOZ
ROLLBANDAGE 4''	1 DOZ
ROMBIFLOX OZ	10'S
ROMBIFLOX SY 60 ML	60 ML
ROMBIFLOX- 200MGTAB	10'S
ROMBIFLOX- OZ SYRUP	60ML
ROMBIFLOX- SYRUP	30'ML
ROMBIFLOX-M SY	30ML
ROMBIPLEX SY 100ML	100 ML
ROMBIPLEX SYRUP	200ML
ROMBIZYME 100ML SY	100ML
ROMBIZYME-200ML	200 ML
ROMESEC CAP 20MG 5*15	1*15*CAP
ROMESEC D CAP 10*10	1*10*CAP
ROMILAST TAB 10MG 2*15	1x15xTab
ROMILAST TAB 5MG 2*15	1x15xTab
ROMO 10 URIN BAG	1 PCS
ROMO ADK	1 SET
ROMO DRAIN	1 PCS
ROMO JET 10 ML SYR	1 PCS
ROMO JET 1ML	1 PCS
ROMO JET 2 ML SYR	1 PCS
ROMO JET 3 ML SYR	1 PCS
ROMO JET 5 ML SYR	1 PCS
ROMO JET 50ML W/N	1 PCS
ROMO VAC SET 18	1 PCS
ROMO VAC SET FG-10	1 PCS
ROMO VAC SET FG-12	1 PCS
ROMO VAC SET FG-14	1 PCS
ROMO VAC SET FG-16	1 PCS
ROMO VAC SET FG-18	1 PCS
ROMOLENE NO-16	1 PCS
ROMOLENE NO-18	1 PCS
ROMOLINE FG 16	1 PCS
ROMOVAC HI-TEC 18"	1 PCS
ROMOX -CV TABS	6'S
ROMOX CV SYRUP	30ML
ROMOX INJ.3GM	1X3GM.
ROMOX INJ.4GM	1X4GM
ROMOX-CV TABS	6'S
ROMPY TAB	1X10
RONCAL TAB	10'S
RONCAL-CT TAB	10'S
RONEMOX CAP 500MG	1x10 CAP
RONFLOX 200	1X10T
RONFLOX 400	1X10T
RONFLOX FORTE SYP.	1X30ML
RONFLOX OZ	1X10T
RONFLOX SUSP	1X30ML
RONFLOX SYP.	1X60ML
RONFLOX-OZ SUS	1X30ML
RONFLOX-OZ---------------	1X6T
RONIN 100MG TAB	1X3
RONIN 250MG TAB	1X6
RONIN FM	1X1
RONIN-500MG TAB	1X3
ROOTASIN TAB	1*10
ROPARK 0.25 TAB 10*10	1*10TAB
ROPARK 0.5 TAB 10*10	1*10TAB
ROPARK-1 TAB 10*10	1*10TAB
ROPARK-2 TAB 5*10	1*10TAB
ROSAVE F TAB 10MG 10*10	1*10*TAB
ROSAVE F TAB 5MG 10*10	1*10*TAB
ROSAVE TAB 10MG 10*10	1*10*TAB
ROSAVE TAB 20MG 10*10	1*10*TAB
ROSAVE TAB 5MG 10*10	1*10*TAB
ROSCILLIN 2.5GM	VIAL
ROSCILLIN INJ 250MG 1*1	1*1*VAIL
ROSEDAY TAB 5MG 1*10	1*10*TAB
ROSEVIT 200ML	1*200ML
ROSHO CAPS	1x10
ROSI-MOX INJ.	4.5 GM
ROSICON 2 MG TAB	1X10
ROSICON 4MG TAB	1X10
ROSICON G TABLET	1x10
ROSICON-2MG TAB	1X10
ROSICON-4MG TAB	1X10
ROSICON-MF TAB	1X10
ROSIMET TAB	1X10
ROSITA SUSP	1X150ML
ROSITA TAB	1X10T
ROSITA XT	1X10T
ROSITA XT SUSP	1X150ML
ROSIUM CAP.	1*10
ROSPIUM XR CAPS	10'S
ROSSER DP TAB	1X10
ROSUFIT 10	1*10
ROSUFIT 20	10'S
ROSUFIT 40MG	10'S
ROSUFIT 5 TAB	1*10
ROSUFIT CV-5	10'S
ROSUFIT CV10	1*10
ROSUFIT F 5/160	1*10
ROSUFLO TAB 10MG 10*10	1*10*TAB
ROSUFLO TAB 20MG 10*10	1*10*TAB
ROSUFLO TAB 5MG 10*10	1*10*TAB
ROSUKAA 10 MG TABLET	1X10
ROSUKAA 20 MG TABLET	1X10
ROSUKEM -A	1X10 TAB.
ROSUKEM 10	1X10 TAB.
ROSUKEM 20	1X10 TAB.
ROSUKEM 5	1X10 TAB.
ROSULIP -F 5 TAB	10'S
ROSULIP 10 TAB	10'S
ROSULIP 20 TAB	10'S
ROSULIP 5 TAB	10'S
ROSULIP F-10	1X10
ROSUMAC 10	1X10S
ROSUMAC 5	1X10T
ROSUMAC F	1X10T
ROSUMAC F 5 TAB.	1X10 TAB.
ROSUTEC 10 TAB	10'S
ROSUTEC 20	10'S
ROSUTEC 5 TAB	10'S
ROSUTOR A10	10'S
ROSVIN 10 MG	10'S
ROSVIN 20 MG	10'S
ROSVIN 5 MG	10'S
ROSVIN F	10'S
ROSVIN F 5MG TABS	10'S
ROSYFER SYP	1*200ML
ROSYFER SYP.	1*300ML
ROTAHALER	1UNIT
ROTASPAS 40 MG	1*2ML
ROTASPAS M TAB	1*10
ROTEM 150MG TABLET	1X10
ROTEM 50MG TABLET	1X10
ROTEM SYP	1X30ML
ROTO-CARB	1X10
ROTOHEAL TAB 3*10	1*10TAB
ROTOHEAL-D TAB 3*10	1*10TAB
ROV-H 120ML	1X120ML
ROV-H 250ML	1X250ML
ROVANSA D TAB	1*10
ROVITAR SYP	200ML
ROVOMYCIN FORT TAB 5*10	1x10xTab
ROWASA SACHET 1*25*PC	1*25*PC
ROXCOL SYRUP	30ML
ROXEE-50DT TAB	1X10
ROXEM 150MG TAB	1X10
ROXEM 50MG SUSP	30ML
ROXEM KID TABS	1X10
ROXEPTIN SYP	1x30xMl.
ROXEPTIN TAB 150MG 10*10	1x10xTab
ROXET 150 TAB	1x10TAB
ROXIBEST 150 MG.	1x10
ROXIBEST A TAB	1x10
ROXIBEST DROP	1PH
ROXIBEST P	1x10
ROXIBEST SUSP. 30 ML.	1 PH.
ROXICOR-150MG TAB	1X10
ROXID DROP	1x10xMl.
ROXID KID TAB 50MG 10*10	1x10xTab
ROXID M TAB 10*10	1x10xTab
ROXID SYP	1x30xMl.
ROXID TAB 150MG 25*10	1x10xTab
ROXID TAB 300MG 12*10	1*10*TAB
ROXIDASE	1X10T
ROXIGARD- 50DT TAB	1X10
ROXIKEM 30ML	30ML
ROXIKIND-150 TAB 6*10	1x10xTab
ROXILINE-150 1*10	1*10
ROXIMAX 150MGTAB	1X10
ROXIME D/SY	1X30ML
ROXIMET-150 TAB	1X10T
ROXIN 150 TAB	1X10
ROXINA 150 MG	1x10
ROXINA.DROP	
ROXITA 30ML SYU	1PH
ROXITA.DROP	1PH
ROXITAS SYP.100ML	1 PH
ROXITON 150	1x10
ROXIWIN 150MG TAB	1*10
ROXIWIN KID TAB	1*10
ROXIWIN SYP	1*30ML
ROXIYA 150	1X10L
ROXIYA SUS	1X30ML
ROXMED 150 TAB	1x10
ROXON -1GM VIAL	1'S
ROXON 500MG	1 VIAL
ROXYBEST A TAB.	1x10
ROXYCIN 150MG TAB	1x10
ROXYCIN AX TAB	1x10
ROXYCON 150MG TAB	1*10
ROXYPAX-150 MG TAB	1X10
ROXYPEN SUSP 30 ML	30 ML
ROXYPEN-150MGTAB	1X10
ROXYROL 150 TAB 10*10	1x10xTab
ROXYROL 75MG TAB 10*10	1x10xTab
ROXYROL-KID TAB 10*10	1x10xTab
ROXYROL-RT 75 TAB 10*10	1x10xTab
ROXYROL-RT TAB 10*10	1x10xTab
ROXYTIDE KID	1x10
ROXYTIDE SYP.	1 PH.
ROXYTIDE TAB.150 MG.	1x10
ROYAL PLUS CAP	1*10
ROYAL PLUS SYP.	1*200ML
ROZADIN TAB	1X10
ROZAVEL 10 TAB 5*10	1*10TAB
ROZAVEL 20 TAB 3*10	1*10TAB
ROZAVEL 5 TAB 5*10	1*10TAB
ROZAVEL-A 150 TAB 5*10	1*10TAB
ROZAVEL-A TAB 5*10	1*10TAB
ROZAVEL-F TAB 5*10	1*10TAB
ROZAVEL-F5 TAB 5*10	1*10TAB
ROZIL-250 MG	1*6
ROZIL-500 MG	1*3
ROZINTA CAP	1X10
ROZIRICH PLUS TAB 10*10	1*10*TAB
ROZLIP TAB 10*10	1*10*TAB
ROZUCOR 10MG TAB	1X10
ROZUCOR 20	1X10T
ROZUCOR 5	1X10T
ROZUCOR F 10	1X10T
ROZUSTAT 10	1X10T
ROZUSTAT 20	1X10T
ROZUSTAT 40	1X10 TAB
ROZUSTAT 5	1X10T
ROZUSTAT F	1X10T
ROZUSTAT F 5	1X10T
ROZUXIA 10MG	10'S
ROZUXIA 20MG	10'S
ROZUXIA 5MG	10'S
ROZUXIA F10MG	10'S
ROZUXIA F5MG	10'S
ROZZ SYP	1*150ML
RQABLET-Z CAP	1X10
RR SENSOFORM DENTAL GEL	1*80GM
RR SENSOFORM DENTAL GEL 40GM	1*40GM
RRD CAPS	1x10
RT SUNATE SP 100 KIT	1*1
RT SUNATE SP 200 KIT	1*1
RT SUNATE SP 50 KIT	1*1
RTIST	1X4C
RTIST DT 100	1X10T
RTIST DT 150	1X10T
RTIST SUSP	1X30ML
RTSUN TAB	1X6
RTSUNATE INJ	1*1
RUAZI 500MG TAB	1X3
RUAZI 250MG TAB	1X6
RUBBER CATHATER	1 PCS
RUBBY DSR	1*10
RUBELA 20MG	1X10
RUBELA DSR	1X10
RUBIRED	1X10T
RUBIRED DROPS	1X15ML
RUBIRED S	1XV
RUBIRED S 5 INJ	1X5ML
RUBIRED SUSP	1X150ML
RUBRAMAX TAB.10'S/SM	1X10
RUBRAPLEX SYP	1x240xMl.
RUBYROZ TAB 10*10	1*10*TAB
RUCHAMAX VET.	1 PC.
RUCHAMEX 15GM.	36x15GM
RUCHAMEX 300GM.	1X300GM
RUCHAMEX 60GM.	12x60GM
RUCHI BOOST	15GM
RUCHINA A 1 KG	1 KG
RUCHINA A 100 GR	100 GR
RUCHINA A 15 GR	15 GR
RUCHINA A 200 GR	200 GR
RUCHINA A 400 GR	400 GR
RUCHIZYME SYP	1X100ML
RUCIP-500 TAB	1X10TAB
RUDECORT -6	1X10TAB
RUDICET LM JR TAB	1x10
RUDICET LM TAB	1X10TAB
RUDICOFF-DX	100ML
RUDINAC INJ	1 AMP
RUDIZYME DROP	1x15ML
RUFFY-10 INJ 5*1ML	1*1ML
RUFFY-20 INJ 5*1ML	1*1ML
RULIDE AZ 250MG	1X6T
RULIDE AZ 500	1X3T
RULIDE AZ SY	1X15ML
RUMALAYA 50gm	TUBE
RUMALAYA FORTE TAB	1x60xTab
RUMALAYA GEL	1x30xGm.
RUMALAYA LINIMENT	1*60ML
RUMALAYA TAB	1x60xTab
RUMALAYA VET BOLUS.	1x4B
RUMANIL PLUS TAB	1x10
RUMANIL TAB	1x10
RUMATAB PLUS TAB.10'S/SB	S
RUMATAB TAB	1X10
RUMATIL GEL	1*30GM
RUMATIL OIL 60ML	1PH
RUMATIL TAB	1*90TAB
RUMATIN SP TAB	1X10
RUMATIN-P TAB	1X10
RUMAX 50ML OIL	50ML
RUMAX OIL	100ML
RUMBION BOLUS 1*4	1*4
RUMBION BOLUS.	1x4
RUMEN BOLUS	1X4
RUMEN FS BOLUS	1X4
RUMENTAS BOLUS.	1x4B
RUMENTO PLUS 15 GR	15 GR
RUMENTO PLUS LUX SOAP	1X1
RUMENTO PLUS TEA PKT	1X1
RUMENTON TAB.	1x50TAB
RUMIBEST 200GM	200GM.
RUMIBEST 30GM	POUCH
RUMIBEX 170ML SYP	1
RUMICARE 125 GM	125 GM
RUMIGEST 100 GM	PH
RUMIGEST 200 GM	PH
RUMIGEST 500 GM.	PH
RUMILAC BOLUS	1x4B
RUMIPRO 6 BOLI	6 BOLI
RUMISACC-BOLUS	4*10
RUMISTIM-FS PD	60GM
RUMISTRONG POWD 10 GR	10 GR
RUMISTRONG POWD 100 GR	100 GR
RUNAC SYP	60ML
RUP-AL TAB.10'S	1X10
RUPAHIST TAB 6*10	1x10xTab
RUPANEX TAB 10*10	1x10xTab
RUPANEX-M TAB 10*10	1*10TAB
RUPIZ TAB	1X10
RUPROVIT POWDER	1PH
RUSICOXIB 25 TAB	1X10
RUSICOXIB MD 50MG TAB	1x10
RUSIFLAM FORTE	1x10
RUSIGRA 100MG	1X6
RUSIGRA 50MG TAB	1X4
RUSIGYL N SYP. 30 ML.	1 PH.
RUSIPRO 250 MG. TAB	1x10
RUSIPRO 500 MG. TAB	1x10
RUSITON CAP	1X10
RUSITONE SYP.	1 PH.
RUSIZYME SYP	1X200ML
RUTALINE-BR TAB	1*10
RUTICOOL	1XTUBE
RUTIN	1X10T
RUTOVALUE TABS	1*10
RUTOVALUE-A	1*10
RUTOVALUE-D	1*10
RUZET XT	1X10
RX PLUS DROP	1*15*ML
RX PLUS SYP	1*200*ML
RX PLUS TAB 1*15	1*15*TAB
RX-JUNIOR	60ML
RXD SYP	1*60ML
RXTOR F TAB 10MG 10*10	1*10*TAB
RXTOR F TAB 5MG 10*10	1*10*TAB
RXTOR TAB 10MG 10*10	1*10*TAB
RXTOR TAB 20MG 10*10	1*10*TAB
RXTOR TAB 5MG 10*10	1*10*TAB
RYLE'S TUBE (ROMSONS)	1 PCS
RYLE'S TUBE 10"	1 PCS
RYLE'S TUBE 11"	1 PCS
RYLE'S TUBE 12"	1 PCS
RYLE'S TUBE 13"	1 PCS
RYLE'S TUBE 14"	1 PCS
RYLE'S TUBE 15"	1 PCS
RYLE'S TUBE 16"	1 PCS
RYLE'S TUBE 17"	1 PCS
RYLE'S TUBE 18"	1 PCS
RYLE'S TUBE FG-10	1 PCS
RYLE'S TUBE FG-12	1 PCS
RYLE'S TUBE FG-14	1 PCS
RYLE'S TUBE FG-18	1 PCS
RYLE'S TUBE FG-20	1 PCS
RYLE'S TUBE FG-8	1 PCS
RYLES TUBE 10	1 PCS
RYLES TUBE 12	1 PCS
RYLES TUBE 14	1 PCS
RYLES TUBE 14 HITECH	1 PCS
RYLES TUBE 14NO.	1 PCS
RYLES TUBE 16	1 PCS
RYLES TUBE 18	1 PCS
RYLES TUBE**	1
RYTHMIX XT	1X10C
RYTOFIN CREAM	1TUB
RYTOFIN TAB	1X10
RYTOFIN-M CRERAM	1TUB
RYTOPOD 100MG	1X6
RYTOPOD 200MG	1X6
RYTOPOD SY	1PHI
Re-MOVE CAP	1x10
S -B WORM SYU	10ML
S 2215	1 PCS
S 2216	1 PCS
S AMLOSAFE 2.5	1X10T
S AMLOSAFE 5	1X10T
S AMLOSAFE AT 2.5/25MG	1X10
S AMLOSAFE AT 2.5/50MG	1X10
S AMLOVAS 2.5	1X10T
S AMLOVAS 5	1X10T
S B CAL SYU	150ML
S B KID GR 25*IPC	1*1*PC
S-CITADEP 10	1X10
S-CITADEP 20	1X10
S-CITADEP 5	1X10
S-FON OZ TAB	1*10
S-GEL	1X25GM
S-LYSINE SYP	200ML
S-LYSINE-SF SYP	200ML
S-MOX 60ML	60ml
S-MUCOLITE SYP 100ML	1*100ML
S-MUCOLITE SYP 60ML	1*60ML
S-NUMBLO 2.5MG TABLET	1x10
S-NUMBLO 5MG TABLET	1x10
S-OMEPRAN 40MG TAB	1x10
S-OMEPREN 20MG TAB	1x10
S. S. TRAY 9 X 6 WITH COVER	1 PCS
S.B.MOX DRY SYP.30ML/SB	S
S.B.MOX DRY SYP.60ML/SB	S
S.B.MOX-250MG.CAP.10'S/SB	S
S.B.MOX-500MG.CAP.10'S/SB	S
S.D.M. 100 ML.	VIAL
S.E.Z. VIAL	1 VIAL
S.S TRAY 11 X 7	1 PCS
S.S. NEEDLE	1 PCS
S.S. TRAY 10 X 12	1 PCS
S.S. TRAY 8"X3"	1 PCS
S.S. TRAY 8X10"	1 PCS
S.S.TRAY 8 X 8	1 PCS
S.V SET 23NO.	1 PCS
S.V SET FG-20	1 PCS
S.V SET FG-21	1 PCS
S.V SET FG-22	1 PCS
S.V SET FG-23	1 PCS
S.V SET FG-24	1 PCS
S.V. SET 22	1 PCS
S.V.SET 20G	1 PCS
S.V.SET, 18	1 PCS
SAAF OIL 50 ML	50 ML
SAAFKIT 200ML	PH
SAAZ DS TAB 10*10	1x10xTab
SAAZ TAB 10*10	1x10xTab
SACBOMA 100ML LOTION	1X100ML
SACRO LUMBAR BELT 32	1 PCS
SACRO LUMBER BELT	1 PCS
SACRO LUMBER BELT 34	1 PCS
SACROLYTE PLUS SACHET 10*1GM	1*1*GM
SADURI SYP	100ML
SAF PID	1KIT
SAF-AZ 250	1X6
SAF-AZ 500	1X3
SAFE CAP	1X4
SAFEACT TAB 1*10	1*10
SAFEDOL CAPS	1X10
SAFEGEST CAP 200MG	1x10
SAFELAX SACHETS	17.1
SAFELINE-M SR TAB	1X10TAB
SAFEMYCIN SKIN OIN	15GM
SAFETY BELT KARMA	1 PCS
SAFEVET 3 GR	3 GR
SAFEVET 500 MG	500 MG
SAFEVET FORTE 3 GR	3 GR
SAFF OIL 100 ML	100 ML
SAFI SYRUP	100NL
SAFI SYRUP	200ML
SAFIRON OD CAP	1x10
SAFLAB KIT	1*1KIT
SAFRON 100ML	1*10
SAFRON 200ML	200ML
SAFRON.100ML.SYU	1PH
SAICAZOLE 400 MG. TAB	1 TAB.
SAICAZOLE SYP.	1 PH.
SAIGEL SUSP	1x170ML
SAIKA 0.25	1x10
SAIKOF SYP	1x100ML
SAINDHWADI TAIL 30ML	1*30ML
SAIZINE TAB	1x10
SAJANI CAP	1x6
SALAM PAK 125GM	125GM[92]
SALBAIR I NEB .63MG	4X5X2.5ML
SALBAIR I NEB 1.125	1X21x2.5ML
SALBAIR I TC	1X1
SALBAIR I TH	1X1
SALBAIR NEB.TP .63	3X7X2
SALBAIR TC	1X30C
SALBAIR TH	1X1
SALBAIR TP	3X7X2.5ML
SALBAIR-B FORTE TC	1X30C
SALBAIR-B TC	1X30C
SALBAIR-B TH	1X1
SALBROCIN 100 ML	1PH
SALBROCIN SYP 60ml	1PH
SALBRON TAB	1X10
SALCARE LOTION	100 ML
SALFATE O SYP 100ML	1x100xMl.
SALFATE SYP	1x200xMl.
SALGI GEL 10GM	1*10*GM
SALGI GEL 20GM	1*20*GM
SALIC 60 ML	1*1
SALICAL POT	1PH
SALICYLIX-SF 12% OINT	1x30xGm.
SALIFACE F/WASH 60ML	1*60ML
SALISIA FACE CLENSER	50 GM
SALISIA KT SHAMPOO	60 ML
SALISIA SOAP	75 GM
SALKEF TAB 500MG 1*10	1*10*TAB
SALMODIL EXP 60ML	1x60xMl.
SALMODIL PLUS SYP 100ML	1x100xMl.
SALMONCAL INJ 5*1ML	1x1xMl.
SALMOZYME DROP	1x15xMl.
SALMOZYME SYP	1*200*ML
SALTOL EXP	1 PH.
SALTOL KID 100ML	1x10
SALTOL KID SYP.60ML	1x60ML
SALTOL(+)PLUS EXP.	1x100ML
SALTOL(+)PLUS KID.	1x60ML
SALTOL-D SYP	1x100ML
SALTOL-PD SYP	1x60ML
SALTOPIC - LOTION	30ML
SALTUM	1X10T
SALTUM INJ 1.5GM	
SALTUM KID TAB	1X4
SALTUMAX INJ 1GM	VIAL
SALTUMAX INJ 1GM	VIAL
SALUDERM CR 15GM	1*15*GM
SALUDOXIM-50MG SYRUP	30ML
SALUTYL OINT	20GM
SALZONE 1.5GM INJ	
SALZONE 4.5 GR	4.5 GR
SALZONE VIAL 3 GR	3 GR
SAMGLOW SHAMPOO	185ML
SAMGLOW SOAP	1X1
SAMLODON AT TAB 10'S	1X10
SAMLOKIND-2.5 TAB 10*10	1x10xTab
SAMLOKIND-AT TAB 10*10	1x10xTab
SAMLOL 10ML	1 AMP
SAMMY 200 TAB 15TAB	1x15xTab
SAMMY 400 TAB 10TAB	1x10xTab
SAMPLUS TAB	1X10
SAMPURE 200 TAB.	1X10
SAMPURE 400	1X10
SAMURAI CAP	1X10
SAMVEC-10 INJ	10 MG
SAMVIT-B00ST POWER	200GM
SAN-DT	1X10T
SANBAX 1GM	VIAL
SANCAL 15ML.	VIAL
SANCAL 45ML.	VIAL
SANCAL VET FORTE 1LT	1X1LT
SANCAN TAB	1X10
SANCEF O 100MG	1X10
SANCEF O 200MG	1X10
SANCEF O SY	1PHI
SANEURON(75MG)	1X10T
SANGOXIN 0.25 MG 14'T	
SANIFERES LIQUID 200ML	1*200ml
SANIFRESH LIQU.500ML	1*500 ML
SANITARY PAD	1 PC.
SANITARY PAD	1 PCS
SANIVIDOL SYP	200 ML
SANIVIDOL SYP	360ML
SANJEEVNI DHARA SY	1x10 ML
SANJEEVNI-DHARA TAB	1x10
SANKH-D	200ML
SANKOF-DMR SYP	100ML
SANYAM CHURN 100GM	100GM[36]
SAP TAB	1 PH.
SARBYANA TAB	1x10
SARDI JA	1PH
SARDI JA	2.5GM
SARDI JAA VAPORUB	
SARE DROP	1*15ML
SAREF & SABUN	1X1
SARFARAZ 15GM OIN	15GM
SARGING CAP 10*10	1*10*CAP
SARIDON TABS 5'S CARTON PACK	
SARIL I.V 100ML	1*100*ML
SARIL SYP	1x30xMl.
SARIL TAB 10*10	1x10xTab
SARIVADHYASAVA 450 ML	1 PH
SARPEN OIL 55ML	1x55ML
SARSWATARISTHA 450ML	1PH
SARTEL-20 TAB 10*15	1*15TAB
SARTEL-40 TAB 10*15	1*15TAB
SARTEL-80 TAB 5*10	1*10TAB
SARTEL-80 TAB 5*15	1*15TAB
SARTEL-AM 10*15	1*15TAB
SARTEL-AM80 TAB 10*10	1*10TAB
SARTEL-C 40 10*10	1*10TAB
SARTEL-C 80 10*10	1*10TAB
SARTEL-H TAB 10*15	1*15TAB
SARTEL-H80 TAB 10*15	1*15TAB
SASECOF SYP.	1*100ML
SASLIC DS FACE WASH	60ML
SASLIC FACE WASH	60ML
SAT ISABGOL 100GMS	1PH
SAT ISABGOL 50GMS	1PH
SATAVAREX GRANULES	200GR
SATAVARI CHURANA 100GMS	100GMS[163
SATAVARI GHRIT 100GM	100GM[148]
SATMAX SYRUP	100ML
SATOMAX 10 MG TABLET	1X10
SATOMAX 20 MG TABLET	1X10
SATOMAX 5 MG TABLET	1X10
SATOMAX PLUS TABLET	1X10
SATOXIN TAB	1x10
SATROGYL O D/SY	1X30ML
SATROGYL TAB 300MG	1X10
SATROGYL-O TAB	1X10
SAUBHAGYA VATI(PRASUTI)	1x40
SAVLON	1 LT.
SAVLON 1LTR	1000ML
SAVLON 50ML	50ML
SAZO TAB 1000MG 10*10	1*10*TAB
SAZO TAB 500MG 10*10	1*10*TAB
SB NIMU TAB	1x10
SB ZYME TAB	1x15
SB-CAL 500MG	1*15
SB-CAL 500MG	1X15
SB-CAL 500MG TAB	1*10
SB-CID 170ML	1*170ML
SB-CID 170ML	1*170ML
SB-DRYL -L	100ml
SB-FLU TAB	1X1
SB-GATT-OZ SYU	30ml
SB-NANDRO-25	1AMP
SB-NANDRO-50 AMP	1AMP
SB-NIMU TAB	1*10
SB-PLEX-L 100ML	100ml
SB-ROX SYU	30ml
SB-SPASMO TAB	1X10
SB-WORM	1X1
SB-ZYME 100ML	100ml
SB-ZYME 100ML	1*100ML
SB-ZYME 100ML	100ml
SB-ZYME 200ML	1*200ML
SB-ZYME 200ML	1x200 ML
SB-ZYME-DROP	15ml
SBCET-10 TAB	1X10
SBZKID DRY SYP	60ML
SC-TALO 10MG TAB	1X10
SC-TALO 20 MG TAB	1X10
SC-TALO 5MG TAB	1X10
SCABANCA-C2%	1*100ML
SCABELICE 100ML LOTION	1x100xMl.
SCABELICE 50ML LOTION	1*50ML
SCABELICE SOAP	1x75xGm.
SCABEX 50 ML. LOTION	1 PH.
SCABEX 50ML LOTION	1X50ML
SCABEX LOTION 100ML	1 PH.
SCABEX S OINT	1X20 GRM
SCABICID LOTION 100ML	1PH
SCABICIT LOTION 50ML	1PH
SCABIL 30ML	30ML
SCABIL LOTION 60ML	60ML
SCABIL POWDER	1*1
SCABISIN.LOTION.	1PH
SCABISOL INJ 5ML	VIAL
SCABISOL LOTION	1PH
SCABOMA 50ML LOTION	1X50ML
SCABOMA C LOTION	1X100 ML
SCABOMA C LOTION	1X50 ML
SCABOMA CREAM	1 TUBE
SCABOMA CREAM 25GM	1TUBE
SCABOMA LOTION 100ML	1PH
SCABOMA LOTION 50ML	1PH
SCABOZEN LOTION	100ML
SCABOZEN LOTION 50ML	50ML
SCALP VAN SET 22(HMD)	1 PCS
SCALP VEIN SET 18	1 PCS
SCALP VEIN SET 20	1 PCS
SCALP VEIN SET 21	1 PCS
SCALP VEIN SET 22	1 PCS
SCALP VEIN SET 24	1 PCS
SCALP VEIN SET NG-23	1 PCS
SCALPAL BLADE	1 PCS
SCALPVEN SET 23 NO.	1PIS
SCALVEN SET 20 NO.	1 PC.
SCALVEN SET 22 NO.	1 PC.
SCALVEN SET 24 NO.	1 PC.
SCALVEN SET 26 NO.	1 PC
SCANIL OINT	20 GM
SCARAB LOTION	1X100ML
SCAVISTA 12	1X4T
SCAVISTA 12A	1X1T
SCAVISTA 3 DT	1X4T
SCAVISTA 6 DT	1X4T
SCAVISTA 6A TAB	1X1T
SCAVISTA TAB 6MG 6'S	1X6
SCAVON VET CREAM	TUBE
SCAVON VET SPRAY 120ml	PH
SCHIZOL 5MG.TAB.10'S	1X10
SCISSIOR 6" SH/SH CRB & ST	1 PCS
SCISSIOR CUTICAL 4" CRB & ST	1 PCS
SCISSOR 6" SH/BL CRB & ST	1 PCS
SCISSOR 8" SH X BL	1 PCS
SCISSOR CHNNE 6"	1 PCS
SCISSOR FINE	1 PCS
SCISSOR MAYO 6" T & CRB	1 PCS
SCISSOR MAYO 8" ST & CRB	1 PCS
SCISSORS 6"**	1
SCISSORS APISTOMY	1 PCS
SCLAPE LOTION 60ML	1X60ML
SCOLEAN CAP	1*10
SCOLEAN CAP	1*10
SCORPIO GEL	1PH
SCRATCH CARD	IX1
SCREEN 15	1*10
SCREEN 30	1*1
SCREENE- SPF -30ML LOTION	1X30ML
SCREMPILL-100	1 STRIP
SCUD 1GM	1XVIAL
SCUD 250MG	1XVIAL
SCUD 500 MG INJ	VIAL
SCUD XP 1GM	1XV
SCUD XP 250MG	1XV
SCUD XP 500MG	1XV
SDM 100 ML	100 ML
SE-15 TAB	1X10
SE-DICLO TAB	1X10
SE-FLY-50 TAB	1X10
SE-FLY-O-100 TAB	1X10
SE-FLY-O-200 TAB	1X10
SEACAL 500MG TAB	1X10
SEACIP 500 1*10	1*10
SEACIP TZ 1*10	1*10
SEACOD (SOFTGEL)	1X100C
SEACOD ACTIVE (SOFTGEL)	1X15C
SEACOD ACTIVE CAP	1X30
SEACOD CAP	1X10
SEACOD CAP	1X100
SEACOD OIL	100ML
SEANIM P 1*10	1*10
SEARIZ 10 1*10	1*10
SEAZOL-20 1*10	1*10
SEBOWASH SHAMPOO	1PIC
SECEF SYP	1x30xMl.
SECEF TAB 100MG 4*10	1x10xTab
SECEF TAB 200MG 10*10	1*10*TAB
SECEF TAB 200MG 4*10	1x10xTab
SECEF TAB 400MG 4*10	1x10xTab
SECLOPAR S	1X10
SECLOPAR TAB	1X10
SECNAC-3 KIT 1KIT	1*1KIT
SECNIL FORT TAB 8*2TAB	1x2xTab
SEDAL-D	10'S
SEDAL-D INJ	10*3ML
SEDATE-P TAB	1x10
SEDORIL-DCP	60ML
SEDORIL-P DROP	1PH
SEFATOX 2GM	1X1VIAL
SEFATOX 3GM	1X1X3GM
SEFDIN SUS.30ML.	30ML
SEFDIN TAB	1X10
SEFSTART	1X10C
SEFTRIVET 3GM INJ.	1X3GM
SEGO A .B BELT LARGE	1 PCS
SEGO A .B BELT SIZE MEDIUM	1 PCS
SEGO A .B BELT SIZE SMALL	1 PCS
SEGO ANKLE SUPPORT S ,M ,L	1 PCS
SEGO KNEE CAP S,M,L,XL	1 PCS
SEGO WRIST SUPPORT S ,M L	1 PCS
SEIZLAC 100MG	1X10T
SEIZLAC 50MG	1X10T
SEIZURONE-200 TAB.10'S	1X10
SELACE FORTE (SOFTGEL)	1X15C
SELACE FORTE	1*15
SELACE I	1*15
SELDAN K SHAMPOO	1X60ML
SELDAN SHAMPOO	1X60ML
SELF CILING ADOPTOR	1 PCS
SELGIN TAB 10*10	1x10xTab
SELHEXIN EXP.	1 PH.
SELHEXIN PD SYP.	1 PH.
SELOMAX 25MG /2.5MG 1*7	1*7
SELSUN SUSP-120ML	1*120ML
SELSUN SUSP-60ML	1 PH
SELVIE-WD 200 GM	200 ML
SELZIC TAB 150MG 10*10	1x10xTab
SELZIC TAB 300MG 5*10	1x10xTab
SELZIC TAB 600MG 10*10	1x10xTab
SEMENTO TAB. (1*9)	1*9
SEMI DAONIL 2.5MG	1X10
SEMI RIGUID C .C .S ,M , L .	1 PCS
SEMI TRIGEM 1	10'S
SEMI TRIGEM 1 FORTE	10'S
SEMI TRIGEM 2	10'S
SEMI TRIGEM 2 FORTE	10'S
SEMI-GLYCIGON	1X10T
SENASOF TAB	1X10
SENOLIN	1*100GM
SENOLIN	1*50GM
SENOLIN SF 50GM	50GM
SENORM INJ 5MG 5*1ML	1*1ML
SENORM LA INJ 50MG 5*1ML	1*1ML
SENQUIL AD 100ML	1x100xMl.
SENQUIL OINT 100GM	1x100xGm.
SENQUIL-F OINT 100GM	1x100xGm.
SENQUIL-F OINT 50GM	1x50xGm.
SENSA FORTE CAP	1*10
SENSA FX	1*30
SENSA ROYAL	1*10
SENSA SPUR CAP	1*30
SENSEAL KF ORAL GEL	100GM
SENSICLAV 1.2	1X1 VIAL
SENSICLAV 150MG	1X1 VIAL
SENSICLAV 300MG	1X1 VIAL
SENSICLAV 375	1X6S
SENSICLAV 625	1X6S
SENSICLAV BD D/S	1X30ML
SENSICLAV DROP	1X10 ML
SENSICLAV DS D/S	1X30ML
SENSICLAV KID DT	1X10T
SENSIVAL TAB 25MG 25*10	1*10*TAB
SENSODENT K 100MG	1*100MG
SENSODENT K 50MG	1*50MG
SENSODENT KF	50GM
SENSODENT-KF	1*100GM
SENSOFORM	1*50GM
SENSOFORM 100MG	1*100MG
SENSOFORM GUM PAINT	1*15ML
SENSOSEAL - F OIN	100 GM
SENSOSEAL.	1PH
SENSUR GEL	1X30 GM
SENSUR LOTION 50ML	1X50ML
SENSUR OIL 10ML	1PH
SENSUR RUB 10GM	1TUBE
SENTA-100MG.TAB.10'S	1X10
SENTA-50MG.TAB.10'S	1X10
SEPGARD AR GEL	1x20GM
SEPGARD GEL	1x15GM
SEPMAX-DS TAB	10'S
SEPTIDINE DROP	1*5ML
SEPTILIN DROPS 60ML	1*60ML
SEPTILIN SYP	1x200xMl.
SEPTILIN TAB	1x60xTab
SEPTILOC LOTOIN	50ML
SEPTRAN ADULT TAB	10'
SEPTRAN PAED SYP	50ML
SEPTRAN PEAD TAB	10'S
SERACEMOL TABS	10'S
SERADIC TAB	1X10
SERADIC-A TAB	1X10
SERADIC-AP TAB	1X10
SERADIC-GEL	1X30GM
SERADIC-MR TAB	1X10
SERADIC-P TAB	1X10
SERADIC-PLUS	1*10
SERAGESIC TAB	1X10
SERAGESIC TAB	1X10
SERAKIND BOLUS	1*2
SERALIDE FORT	1X10
SERAMER-10MG.TAB.10'S/SM	S
SERATEAH-D TAB	1*10
SERATODASE-N TAB.10'S	M
SERATODOSE FORT TAB.10'S/MC	M
SERATODOSE-D TAB.10'S/MARC	M
SERAX FORTE TAB	1X10
SERAZEN FORTE TAB	1*10
SERECON D TAB	1*10
SERECON TAB	1*10
SERENACE AMP 50*1ML	1*1*ML
SERENACE LIQ	1*30*ML
SERENACE TAB 0.25MG 80*10	1*10*TAB
SERENACE TAB 0.50MG 10*10	1*10*TAB
SERENACE TAB 1.50MG 70*10	1*10*TAB
SERENACE TAB 5MG 60*10	1*10*TAB
SERENATA 100	1X10T
SERENATA 50	1X10T
SERETIDE AC 50/500	1PH
SERETIDE ACC 50/250	1PH
SEREZON FORTE TAB	1X10
SERIDOSE-DP TAB	1*10
SERIP PLUS TAB	1X10
SERITID -D TAB	1x10
SERIZ 15 TAB 10*10	1x10xTab
SERLIFT TAB 100MG 10*10	1x10xTab
SERLIFT TAB 25MG 15*10	1x10xTab
SERLIFT TAB 50MG 30*10	1x10xTab
SERLIFT-50 @ 30*10	
SERNIM	1X10S
SEROBID INHALER	17GR
SEROBID ROTACAPS	30'S
SEROFLO 100 MULTIHLR	30 DOSE
SEROFLO 100 R/C	30'S
SEROFLO 125 AUTOHALER	1PHI
SEROFLO 125 INH	120MD
SEROFLO 250 AUTOHALER	1PHI
SEROFLO 250 INH.	120MD
SEROFLO 250 MULTIHLR	120 MD
SEROFLO 250 R/C	30'S
SEROFLO 50 INHALER	VIAL
SEROFLO 500 MULTIHLR	30 DOSE
SEROFLO 500 R/C	30 CAPS
SERRADASE-K 1*10	1*10
SERRANAC K TAB	1*10
SERRI D BOLUS	1X4
SERRI D FORTE BOLUS	1X4
SERRINAC GEL	30GM
SERRINT-D	1*10
SERRINT-P	1*10
SERRINT-P TAB	1X10
SERTAZOL CR 10GM	1*10*GM
SERTAZOL CR 10GM	1*10*GM
SERTAZOL V TAB 1*1	1*1*TAB
SERTAZOL V TAB 1*1	1*1*TAB
SERTIFEN-D TAB	1X10
SERTIMA 100 TAB 10*10	1x10xTab
SERTIMA 25 TAB 10*10	1x10xTab
SERTIMA 50 TAB 10*10	1x10xTab
SERUTAN TAB 5X30	1x30xTab
SET WET COOL	100ML
SET WET COOL	10ML
SET WET COOL	50ML
SET WET DEO ADVENTURE	150GM
SET WET DEO CASANOVA	150ML
SET WET DEO COOL	150ML
SET WET DEO MACHO	150ML
SET WET DEO ROMEO	150ML
SET WET DEO SEXY	150ML
SET WET H. CREAM ANTI DANDRAF	50ML
SET WET RESTYLENGH-GEL	100ML
SET WET RESTYLENGH-GEL	50ML
SET WET VERTICAL	100ML
SET WET VERTICAL	10ML
SET WET VERTICAL	50ML
SET WET WET LOOK	100ML
SET WET WET LOOK	10ML
SET WET WET LOOK	50ML
SETAIR-KID TAB	1X10
SETAIR-LC TAB	1X10
SETCAL 250MG	1X30
SETCAL 500MG	1X30
SETCAL M TAB 10'S	1X10
SETCAL MOM	1X10
SETMOL FORTE CAP	1*10
SETOLAC 300 ER	1X10T
SETOLAC P	1X10T
SETOVA 0.25MG	1XVIAL
SETROL	1 AMP
SETROL INJ 60MG/2ML	2 BOX
SETWET CL SHAVING CREAM	70GM
SETWET HAIR CREAM ANT.DANDRUFF	100GM
SEUMOL PLUS SYP	60ML
SEUMOL PLUS TAB	1*10
SEVCEPT 400	1X10 TAB.
SEVENSEAS CAP 1*100	1*100*CAP
SEVERON- CAP	10'S
SEVISTA	1X8T
SF NATURA GINGER	1X25X1GM
SF NATURA LEMON	1X25X1GM
SF-O 100ml susp.	1x100ml
SFOD-200MG TAB. 6'S	
SFT GEL 200ML	200ML
SFT O SUSP 100ML	1*100ML
SHADBINDU TAIL 30ML	1 PH
SHADBINDU TAIL 60ML	1*60ML
SHADE LOTION 100 ML.	1 PH.
SHADE LOTION 40 ML.	1 PH.
SHAKTI PLUS 100ML	100ML[121]
SHAKTI PLUS 200ML	200ML[37]
SHAKTI RASYAN 500GM	500GM
SHAMAK INJ 3ML	3ML
SHANKH PUSPI 225ML	1PH
SHANKHPUSPI SYRUP 100ML	100ML[39]
SHANKHPUSPI SYRUP 200ML	200ML[38]
SHAPE UP CAP	1X10
SHARASHVATA RISTHA 450ML	450ML[113]
SHARBAT ANJBAR SYP	500ML
SHARBAT BAZORI MOTADIL SYP	500ML
SHARBAT DINAR SYP	500ML
SHARBAT SANDAL SYP	500ML
SHARBAT-E-AZAM	1PH
SHARKOFERROL 200 GR PET	200 GR PET
SHARKOFERROL 450GM.	PH
SHARKOFERROL MALT	1x450xGm.
SHAW EC 100ML	1 BOT
SHAW EC 450ML	1 BOT
SHE BOOST BOLUS	1x4
SHECOF 400ML SYP	1x400ML
SHEILD OINT	15GM
SHEKHAR GOLD 1KG	1x1KG
SHELCAL -K TAB	1X15
SHELCAL 250 TAB	30TAB
SHELCAL 500MG TAB	1X15
SHELCAL M TAB	1*15B
SHELCAL OS	1*15
SHELCAL SYR	110ML
SHELCAL SYRUP	200ML
SHELCAL-CT	1X15
SHELCAL-HD TAB	1X15
SHELINC-250MG CAP. 10'S	
SHELINC-300MG INJ. 1ML	
SHELINC-500MG CAP. 10'S	
SHELINC-600MG INJ. 2ML	
SHELL CALCIUMCTABS	1X15
SHEPHOS BOLUS	1x1
SHICEF SYP	30ML
SHICEF-200MG	1X10
SHILAJEET ASHWAGANDHA+	450ML[7]
SHILAJEET GOLD CAP	1*10
SHILAJIT ASHWAGANDHA +	100ML[41]
SHILAJIT ASHWAGANDHA +	200ML[40]
SHILAJIT CAP	1x10
SHILAJIT CAPSULE 20CAP	20CAP[159]
SHINCIN 200	1X10
SHINCIN 400	1X10
SHINNAC CZ TAB	1X10
SHINNAC MR TAB	1X10
SHINNAC PLUS TAB	1X10
SHINNAC SE TAB	1X10
SHINNAC SP TAB	1X10
SHINNAC SR TAB	1X10
SHINNAC TAB	1X10
SHITON SYP.	1*200ML
SHIVCAL TABLET	1x15
SHNAKH PUSPI 450+225ML	1*450ML
SHOE PVC STICK,CRUTCH,WALKER	1 PCS
SHOLDER IMMOBILIZER (WINTECH)	1 PCS
SHOTMAX SPRAY	1*1PC
SHOULDER IMMOBILISER (L)	1 PCS
SHOULDER IMMOBILISER (XL)	1 PCS
SHOULDER IMMOBILISER(M)	1 PCS
SHOULDER IMMOBILISER(S)	1 PCS
SHOULDER IMMOBILIZER M	1 PCS
SHOULDER IMMOBILIZER ROMSON	1 PCS
SHOULDER IMMOBILIZER S/M/L	1 PCS
SHRI GOPAL TAIL 30ML	30ML[42]]
SHRINIVAS HAND SANITIZER	500ML
SHRINIVAS HAND SANITIZZER	100ML
SHUIT TAB	1*10
SHUIT-M TAB	1*10
SI-FIXIM 100DT 1*10	1*10
SI-FIXIM 200DT	1*10
SI-FIXIM 50DT 1*10	1*10
SI-FIXIM SYP 30ML	30ML
SI-FIXIM XL 100 1*10	1*10
SI-FIXIM XL 200 1*10	1*10
SI-FIXIM XL KID 50 1*10	1*10
SI-FIXIM-O 1*10	1*10
SIBELIUM TAB 10MG 15*10	1x10xTab
SIBELIUM TAB 5MG 15*10	1x10xTab
SIBET - P CAPSULES	1X10
SIBET 300MG TAB	1X10
SIBET-400MG TAB	1X10
SIBOFIX 200 TAB 10*10	1X10TAB
SIBOFIX 400 TAB 10*10	1*10TAB
SICEF 250 INJ	1 VILE
SICEF 5000 INJ	1
SIDE SCREEN	1 PCS
SIFIXIM CV 200 1*10	1*10
SIFOTAXIM 1GM	1
SIFOTAXIM 250 VILEI	1
SIGMA CT 1*10	1*10
SIGMA CTH 1*10	1*10
SIGMA PANTHONETE 10ML	10ML
SIGMA PANTHONETE TAB 1*10	1*10
SIGMADERM 5GM	5gm
SIGMADERM N CREAM	10GM
SIGNOFLAM	1X10T
SIGNOFLAM P	1X10T
SIGNOFLAM-SR TAB	1X10
SILBOSTIN	1X10T
SILENSER COUGH SYP 100ML	100ML
SILHEX JAR	1*250
SILHEX ONIT	1*1
SILICON FOLEY CATH FG-16	1 PCS
SILICON FOLEY CATH FG-18	1 PCS
SILICON FOLLYES 12"	1 PCS
SILICON FOLYES 16	1 PCS
SILICONE INSOLES(REMOVABLE)S,M,L,XL	1 PCS
SILIMIX SY	1PHI
SILIMIX TAB	1X10
SILIPLEX 200ML	200ML
SILIPLEX AMP	5ML
SILIWIN SUS	200ML
SILK THREAD	1 PCS
SILKOCATH 20	1 PCS
SILKUS, 4-0 ,LNW 5001(16MM)	12 BOX
SILKUS,0, LNW 5037(45MM)	12 BOX
SILKUS,1, LNW 5062(60MM)	12 BOX
SILNEX G CREEM	1X25GR
SILODERM CREAME	1x20xGm.
SILODERM MIXI CREAM	1*10*GM
SILOFAST 4MG	1X10
SILOFAST 8MG	1X10
SILOVIN NASAL DROPS	1X15ML
SILVANOIR 10 GM.	1 TUBE
SILVANOIR JAR	1 PH.
SILVER COIN	1 PC.
SILVER SULPHADIGINE JAR	1 PH.
SILVEREX CR 20GM	1*20*GM
SILVEREX IONIC JAR 1*240GM	1*240*GM
SILVERKIND NANOFINE GEL	1*10GM
SILVEZ CREAM	1x20GM
SILVIPEN 15 GR	15 GR
SILVIPEN CREAM 15 GR	15 GR
SILYBON SYP 1*200ML	1*200*ML
SILYBON TAB 140MG 10*10	1*10*TAB
SILYBON TAB 70MG 10*10	1*10*TAB
SILYDOC SYP	100ML
SILYDOC SYP	200ML
SILYHEP CAP	1X10
SILYHEP SYP	100ML
SILYHEP SYP	1X200ML
SILYLIV 140MG TAB	1X10
SILYWIN SUS	200ML
SIMCARD 10MG TABS	10'S
SIMCARD 20MG TABS	10'S
SIMCARD EZ TABS	10'S
SIMENDA 12.5MG/5ML	1XV
SIMPLOVIR OINT	5GM
SIMPLYONE 160 INH	200MD
SIMPLYONE 200 R/C	30'S
SIMPLYONE 400 R/C	30'S
SIMPLYONE 80 INH	80 MD
SIMS SPECULUM	1 PCS
SIMVITAL DROP	1x15ML
SIMVITAL SYP	1x100ML
SIMVITAL TAB	1x10
SIMYL MCT 200GM	1x200xGm.
SIMYL MCT 400GM	1*400GM
SIMYL MCT OIL 50ML	1x50xMl.
SIMYL-LBW GR. 200GM	1*200GM
SIMZYME SYRUP	1x200ML
SIMZYME-SYP 60ML	60ML
SINAREST ORAL DROP	1*15ML
SINAREST SYP	1*60ML
SINAREST TAB	1x10
SINGLOR	1X10T
SINGULAR-10 TAB 4*10	1*10TAB
SINGULAR-4 TAB 4*10	1*10TAB
SINGULAR-5 TAB 4*10	1*10TAB
SINKOF 100 ML. SYP.	1 PH.
SINMOX DRY SYP	60ML
SINOCLEAR COUGH SYP	1X60ML
SINOCLEAR P SYP	1 PH
SINOCLEAR TABLET	1X10
SINOCOLD SYP	1*60ML.
SINOCOLD TAB	1*10
SINODRYL 100ML SYP	1*100ML
SINOMARIN SOLUTION	30ML.
SINOSAM 200MG	1X15T
SINOSAM 400MG	1X10T
SINUS FORCEPS	1 PCS
SINZOCAST M SYP	60ML
SINZOCAST M TAB	1*10
SIOBAN SYP	1x10xMl.
SIOBAN TAB 50*1	1x1xTab
SIOCARE 450ML	1*450ML
SIOCITRATE SYP 100ML	1*100ML
SIOLYSIN-L 200ML	200ml
SIONEURON FORTE INJ 40*2ML	1x2xMl.
SIONEURON FORTE TAB 30*10	1x10xTab
SIOOXY CAP 10*10	1x10xCap
SIOPLEX-L SYP 200ML	1x200xMl.
SIOTONE CAP 10*10	1x10xCap
SIOZIDE SYP	1x200xMl.
SIPRAL 60 ML.	1 VIAL
SIPRAL TZ TAB	1x10
SIPROZOLE TAB.	1x10
SIQUIL 5ML.	VIAL
SIRAN FORTE TAB.	1x10
SIRDALUD TAB 10*6	1x6xTab
SIRFEK TABS	1'S
SIRILEPT-25 TAB 5*10	1*10TAB
SISEF 1GM	1GM
SITCOM CREAM	1x30 GM
SITCOM TAB	1x7
SITELODIP 2.5MG	1X10T
SITELODIP 5MG	1X10T
SITESTAT 10MG	1X10T
SITESTAT F	1X10T
SITOPLADI 100GM	100 [74]
SITOPLADI CHURNA(30GM)	30 GMS
SITOPLADI CHURNA(60GM)	60 GMS
SITRUS-LA TAB	1X10
SIXAPP SYP	1PH
SIZODON LS TAB 10*10	1*10TAB
SIZODON MD 0.5 TAB 10*10	1*10TAB
SIZODON MD 1.0 TAB 10*10	1*10TAB
SIZODON MD 2.0 TAB 10*10	1*10TAB
SIZODON PLUS TAB 10*10	1*10TAB
SIZODON-1 TAB 10*10	1*10TAB
SIZODON-2 TAB 10*10	1*10TAB
SIZODON-3 TAB 10*10	1*10TAB
SIZODON-4 TAB 5*10	1*10TAB
SIZODON-FORTE TAB 10*10	1*10TAB
SIZOPIN 100 TAB 10*10	1*10TAB
SIZOPIN 200 TAB 5*10	1*10TAB
SIZOPIN 25 TAB 10*10	1*10TAB
SIZOPIN 50 TAB 10*10	1*10TAB
SKAB CREAM	1*30*GM
SKAB L CREAM	1*60*GM
SKE-MECILINE SYU	60ml
SKE-MICELINE-500	1x10
SKEEN HEAL CREAM SPRAY.	100ML
SKIFI AZ TAB 250 MG 10*10	1*10*TAB
SKIFI AZ TAB 500 MG 10*10	1*10*TAB
SKIFI CV TAB 10*10	1*10*TAB
SKIFI DRY SYP 100MG	1*15*ML
SKIFI DRY SYP 50MG	1*15*ML
SKIFI DT TAB 100MG 10*10	1*10*TAB
SKIFI MD TAB 200MG 10*10	1*10*TAB
SKIFI TAB 200MG 10*10	1*10*TAB
SKIFI TAB 50MG 10*10	1*10*TAB
SKIN GRAFT BLADES	1 PCS
SKIN HEAL SPRAY	100ML
SKIN TRACTION BELT	1 PCS
SKIN TRACTION KIT	1 SET
SKIN/FOOT TRACTION KIT	1 PCS
SKINLIT EVER OINT	1*1
SKINLITE CREAM	1X20GM
SKIZOLEV 25	1X10 TAB.
SKIZOLEV 50	1X10 TAB.
SKIZORIL-100 TAB 10*10	1x10xTab
SKIZORIL-200 TAB 10*10TAB	1*10TAB
SKIZORIL-25 TAB 10*10	1x10xTab
SKIZORIL-50 10*10	1x10xTab
SLEEVO-MD	1X10
SLEP DROP	1x15xMl.
SLEP SYP	1x30xMl.
SLICE P TAB	1*10
SLICE SP TAB	1*10
SLICE-MR	1*10
SLICE.TAB	1X10
SLIDE BOX FOR 25 SLIDES	1 PCS
SLIMEX CAPSULE 20CAP	20CAP[161]
SLIMEX FORTE CAPSULE	10CAP[158]
SLIMEX POWDER 125GM	125GM[59]
SLIMTONE CAP 10*10	1*10*CAP
SLINE SET (D.M.S)	1 PH.
SLINE SET (MECCA)**	1 PC.
SLINE SET (OYSTER)	1 PC.
SLINE SET (SAFETY)	1 PC.
SLINE SET PED.	1 PH.
SLINE SET(JIMIT)	1PIS
SLINE SET(POPULAR)	1PIS
SMARTI M TAB 1*10	1*10*TAB
SMARTI TAB 10'S	
SMARTI TAB 10*10	1x10xTab
SMARTICAL CAP	1x10
SMFIBRO CAP	10'S
SMS-XL 12.5	1X10T
SMS-XL 25	1X10T
SMS-XL 50	1X10T
SMULAX LIQ	1X100ML
SMULAX LIQ.	1X200ML
SMULAX POWDER	1X7.25GM
SMUTH	1X10C
SMUTH CREAM	30GM
SMUTH SUSP	110ML
SMYLE COUGH	1PH
SN 2317	1 PCS
SN 2338	1 PCS
SN 2341	1 PCS
SN 2345	1 PCS
SN 2346	1 PCS
SN 2347	1 PCS
SN 2347DA	1 PCS
SN 3318	1 PCS
SN 3328	1 PCS
SN 3336	1 PCS
SN 3338	1 PCS
SN 3390	1 PCS
SN 4221	1 PCS
SN 4226	1 PCS
SN 4228	1 PCS
SN 4241	1 PCS
SN 4242	1 PCS
SN 4244	1 PCS
SN 4259	1 PCS
SN 4271	1 PCS
SN 5002	1 PCS
SN 645	1 PCS
SN 842	1 PCS
SN 843	1 PCS
SN 9371	1 PCS
SNAKE ANTI-VENINIOM	1*10ML
SNEPDOL	1X10T
SNOWDENT	1*100GM
SOBIRIUM TAB 10MG 10*10	1x10xTab
SOBIRIUM TAB 5MG 10*10	1x10xTab
SOBREX SYP	1x100ML
SODA LIME	1 KGS
SODABICARB INJ	1 PCS
SODAF VIAL	30 ML
SODAPHOS 60 GR	60 GR
SODAPHOS-500gm	500 GM
SODIUM ANTIMONY GL. INJ	1x30xMl.
SODIUM CITRATE SOLUTION	1 BOT
SODIUM STIBOGLUCONAT VAIL	30ML
SODYME	1X10T
SOFALCO	1X10C
SOFARIN 5MG TAB	10 TAB
SOFDERM CREAM	50GR
SOFIA-100 CAP 1*10CAP	1x10xCap
SOFIA-200 CAP 1*10CAP	1x10xCap
SOFINOX CREAM 10GM	1*10GM
SOFRACIIN.OIN.	1PH
SOFRACORT E/E DP	1X5ML
SOFRADERM CREAM	15gm
SOFRADEX CREAM	20GM
SOFRADEX F CREAM	1X15GM
SOFRAGAL CREM 15 GM	1x15 GM
SOFRAHEXT CREAM	1X5GM
SOFRAKING OIN	15GM
SOFRAMYCIN	1 PCS
SOFRAMYCIN EYE DROP	1X5ML
SOFRAMYCIN SKIN CR	1X100GM
SOFRAMYCIN SKIN CR.	1X30GM
SOFT C .C S ,M ,L .	1 PCS
SOFT C.C (L)	1 PCS
SOFT C.C (M)	1 PCS
SOFT C.C (S)	1 PCS
SOFT C.C (XL)	1 PCS
SOFT CERVICAL COLLER (WIN)	1 PCS
SOFTAS SOAP	75GMS
SOFTDROP LIQUIGEL	
SOFTDROPS E/D	1*10ML
SOFTERON	1X10C
SOFTERON-Z	1X10C
SOFTINA 10 CAP	1X10
SOFTOVAC	1X100GM
SOFTOVAC SF	1X100GM
SOFTVISC E/D	1*10ML
SOFZID GOLD TAB 1*30	1x30xTab
SOFZID NS SYP	1x100xMl.
SOFZID NS SYP 180ML	1*180ML
SOKRENA 100 ML	100 ML
SOKRENA WS 5 LT	5 LT
SOKRENA WS 500	500ML
SOLACID O SUSP.	1x170 ML
SOLACID SUSP.	1x170 ML
SOLACID SUSP.	1x340 ML
SOLACID TABLET	1x12
SOLAMPI 1 GR	1 GR
SOLARPAK TAB.	1X4 TAB.
SOLASE -20 TABS	1*10
SOLBAC SP	1x200GM
SOLECARE OINT 40GM	1*40GM
SOLFE TAB 10*10	1*10*TAB
SOLICEPT 10	1X10T
SOLICEPT 5	1X10T
SOLIDAIR-LM TAB	1*10
SOLIDOSE DROP	1PH
SOLIDOSE SYP 60ML	1PH
SOLIDOSE TAB	1X10
SOLOKAST 10	1X10T
SOLOKAST 4 TAB.	1X10 TAB.
SOLOKAST 5 TAB.	1X10 TAB.
SOLONEX 300MG	1X10
SOLONEX DT	1X10T
SOLOPOSE PLUS TAB 3*10	1*10TAB
SOLOPOSE-0.5 TAB 3*10	1*10TAB
SOLOPOSE-BETA 0.5 TAB 3*10	1*10TAB
SOLPRATE CR 200 10*10	1*10
SOLPRATE CR 300 TABLET	1X10
SOLPRATE SYRUP	1X100 ML
SOLPRETE CR 200 TABLET	1X10
SOLPRETE CR 500 TABLET	1X10
SOLSPRE NASAL SPRAY 1*100ML	1*100*ML
SOLTUS 300 TAB 10*10	1*10TAB
SOLTUS-100 TAB 10*10	1x10xTab
SOLTUS-200 TAB 10*10	1x10xTab
SOLTUS-400 TAB 10*10	1x10xTab
SOLTUS-50 TAB 10*10	1x10xTab
SOLTUS-OD 100 TAB 10*10	1*10TAB
SOLTUS-OD 200 TAB 10*10	1*10TAB
SOLTUS-OD 300 TAB 10*10	1*10TAB
SOLUDINE-10%	1X100ML
SOLUDINE-M-10GM	1X10GM
SOLUDINE-M-20GM	1X20GM
SOLUFER DP	1X15ML
SOLUFER SY	1X150ML
SOLUFER TAB	1X10T
SOLUFER XT DP	1X15ML
SOLUFER-XT	1X10T
SOLUFER-XT SY	1X150ML
SOLUMEDROL 1 GM	1 VIL
SOLUMEDROL 125 VIAL	1 VIAL
SOLUMEDROL 40 VIAL	1 VIAL
SOLUMEDROL 500 MG	1 VIAL
SOLUS 910 ,1,LNW 2359-910(70CM)	12 BOX
SOLUS 910 2 2351	1 PCS
SOLUS 910,1,LNW 2160 GF-910(160CM)	12 BOX
SOLUS 910,1,LNW 2421-910(90CM)	12 BOX
SOLVIN COLD AF DROP	1*15*ML
SOLVIN COLD AF SYP	1*60*ML
SOLVIN COLD DROP	1x15xMl.
SOLVIN COLD SYP	1x60xMl.
SOLVIN COLD TAB 10*10	1x10xTab
SOLVIN NASAL SPRAY	1*1*PH
SOMAFRESH TAB 6*10	1*10
SOMASAV SYP	1x200ML
SOMASTAT 0.25	1XAMP
SOMASTAT 3	1XAMP
SOMAZINA O.S	60ML
SOMAZINA INJ 1GM	1GM
SOMAZINA INJ 500MG	1X4ML
SOMAZINA OD	1X12
SOMAZINA PLUS TAB	1X10
SOMAZINA TAB	1X10
SOMI TAB	1X10
SOMIWIN CAP	1X10
SOMOW TAB	1*10
SOMPRAZ D 20 TAB	1X10
SOMPRAZ D 40	1X10C
SOMPRAZ FAST 40	1X10C
SOMPRAZ HP	1XKIT
SOMPRAZ IT	1X10S
SOMPRAZ IV	1XV
SOMPRAZ L	1X10T
SOMPRAZ-20	1X10S
SOMPRAZ-20 TAB 10*10	1*10TAB
SOMPRAZ-40	1X10S
SOMPRAZ-40 TAB 15*10	1*10TAB
SOMPRAZ-D 20 TAB 10*10	1*10TAB
SOMPRAZ-D 40 TAB 10*10	1*10TAB
SOMPRAZ-L TAB 5*10	1*10TAB
SONA CHANDI CHWAN	1KG
SONACHANDI 8GM	8GM
SONADERM CREAME	1x10GM
SONADERM G.M OIT	1TUB
SONADERM NM CREAM	1x10GM
SONAT -GT 200ML	200ML
SONOF-200 1*10	1*10
SONOF-OZ 1*10	1*10
SOPARIN KID	1*20
SORBACID LIQ	1X170ML
SORBACID O LIQ.	1X170ML
SORBACID TAB	1X10
SORBIDIOL 150	1X10TAB
SORBIDIOL 300	1X10TAB
SORBIKIND-T SYP 200ML	1x100xMl.
SORBILUP.200ML.SYU	1PH
SORBITRATE TAB 10MG 30*50	1x50xTab
SORBITRATE TAB 5MG 30*50	1x50xTab
SORBOLINE SYP.100ML	100 ML.
SORBOLINE SYP.200 ML.	1 PH.
SOREST TAB 50MG 5*10	1x10xTab
SORLIV LIQ 200ML	1*200*ML
SOUREX 100ML SYP	1*100ML
SOVE IT TAB 12.50MG 10*10	1*10*TAB
SOVE IT TAB 6.25MG 10*10	1*10*TAB
SOVE TAB 10MG 10*10	1*10*TAB
SOVE TAB 5MG 10*10	1*10*TAB
SOVENTUS DC SYP.	1X100ML
SOVENTUS SYRUP	1X100ML
SOVENTUS-D SY	100ML
SOVENTUS-JR SY	1X60ML
SOYGROWTH GR 200GM	1*200GM
SPADO INJ.	1 AMP.
SPAM DROP	1PHI
SPANTITAB	1X10
SPAR-OD 200MG.TAB.10'S/MC	M
SPARBID 200 1*10	1*10
SPARC TAB	1X10
SPARCON 200MG TAB	1*6
SPARDEX 200 1*6	1*6
SPARFLIN TAB 1*6	1*6
SPARGEM 200MG TAB	1x6
SPARKEM TAB	1*10
SPARKIND 200 TAB 10*6	1x6xTab
SPARLACTAB	1*15
SPARLEX 200MG TAB	1*10
SPARLIN 200MG TAB	1*10
SPARLINE 200 1*10	1*10
SPARLON TAB.	1*10
SPARLON TAB.	1*10
SPARQUIN 100MG	1X10T
SPARQUIN 200	1X10T
SPARSUN TAB	1x10
SPARTAN KIT	1*10*TAB
SPARX-100 TAB 10*6	1x6xTab
SPARX-200 TAB 10*6	1x6xTab
SPARYAN TAB	1x6
SPAS DROP 10ML	1 PH
SPASAN TAB 1*10	1*10
SPASFIZ TAB	1X10
SPASFIZ TAB.	1x10
SPASGUN TAB	1*10
SPASGUN TAB	1x10
SPASLINE DROP	15ML
SPASMART DROP	1PH
SPASMINDON AMP 1*7AMP	1x7xAmp
SPASMINDON DROPS 10ML	
SPASMINDON N TAB 10*10	1*10*TAB
SPASMINDON TAB 25*10	1x10xTab
SPASMIZ TAB	1X10
SPASMO PRIMYVON CAP	1X8
SPASMO TABLET	1X10
SPASMO DART TAB	1x10
SPASMO FLEXON TABS	1X10
SPASMO PROXYVON CAP 18*8	1x8xCap
SPASMO PROXYVON INJ 10*2ML	1x2xMl.
SPASMO PROXYVON PLUS CAP 18*8	1*8CAP
SPASMO PXVN.FORTE INJ. 10*2M	1x2xMl.
SPASMOGEM DROP	15ML
SPASMOGIL TAB	1X10
SPASMOKEM TAB	1*10
SPASMOL D TAB	1X10
SPASMOL DROP.10ML/SB	S
SPASMOL SUSP.	30ML
SPASMOL TAB.10'S/SB	S
SPASMOLAR TAB	1x10
SPASMOLAX DROP	1x15ML
SPASMOLIFE TAB	1*10
SPASMONIL DP 10 ML	1x10 MLDP
SPASMONIL.TAB	1X10.
SPASMONIM BOLUS	1x6 BOLUS
SPASMONORM INJ	1x2 ML
SPASMOVER- TAB 1*10	1*10
SPASMOVER-P 1*10	1*10
SPASMOVET 30ML.	VIAL
SPASNIL 30ML	1X30ML
SPASNIL BOLUS	1X6'
SPASNIL DROP	
SPASNIL DROP	15ml
SPASNIL TAB	1x10
SPASRAX	1X10T
SPASTECH DROP	15ML
SPASTONE-RM 1*10	1*10
SPAXIN 200MG	1x10
SPAZOF SUS 60ML	60ML
SPAZWIN TAB	1*10
SPECIAL SLIMEX POWDER	125GM[153]
SPECTACEF FORTE INJ 1.5	1VIAL
SPECTACEF 1000MG	1X1VIL
SPECTACEF INJ 250MG	1VIL
SPECTACEF INJ 500MG	1VIL
SPECTRA CAP 25MG 10*10	1x10xCap
SPECTRA CAP 75MG 10*10	1x10xCap
SPECTRATIL 50 SYP	1x30xMl.
SPECTRATIL 50 TAB 10*10	1*10TAB
SPECTRAXIME 500 TAB 10*6	1*6TAB
SPECTRAZOLE 20 GR	20 GR
SPEEDO 30 ML	30 ML
SPEMEN TAB	1x60xTab
SPERIDON 1	1X10T
SPERIDON 2	1X10T
SPERIDON 3	1X10T
SPERIDON 4	1X10T
SPERIDON PLUS MD	1X10T
SPERMI Q CAP	1X10C
SPERMIQ SG	1X10C
SPERTINAX CAPS	1*15
SPEYCEF 250MG ING	1VIAL
SPEYCEF IGM ING	1VIAL
SPEYCEF-O FORTE DRY SYP	30ML
SPEYCEF-O TAB	10
SPEYCEF-S 1.5GM V	VIAL
SPEYCEF-S 1500 ING	1VIAL
SPEYCEF-S 375MG	VIAL
SPEYRAFT SUSP	150ML
SPEYZYME SYP	200ML
SPEYZYME TAB	1*10
SPHYGNOMANOMETER ANAROID	1 PCS
SPIC 150MG TAB	1*10
SPIKALON-DVER 250	1X10
SPILACTONE	1X10T
SPILACTONE 50	1X10T
SPILACTONE T	1X10T
SPINAL NEEDLE NG 23	1 PCS
SPINAL NEEDLE NG 25	1 PCS
SPINAL NEEDLE NG 27	1 PCS
SPINECAL	1X10
SPINECAL PLUS	1X10
SPINECAL TAB	1X10
SPINFREE TAB 10*10	1*10TAB
SPINOBAK-10 TAB 2*10	1*10TAB
SPINOCAN 22"	1 PCS
SPINOCAN 23"	1 PCS
SPINOCAN 25"	1 PCS
SPINOCAN 26"	1 PCS
SPIRATOX TAB	1*10
SPIRIT	1 LTR
SPIRIT	1 PC.
SPIRIT 100ML	1 PCS
SPIRIT 450ML	1 ML.
SPIRIT 5 LTR	1 JAR
SPIRIT LAMP	1 PCS
SPIROCO SACHET	15GM
SPIROMIDE TAB 30*10	1*10*TAB
SPLANZ 30MG CAP	1X10
SPOC M TAB	1x10
SPOC-D TAB	1x10
SPOLIN SY	1PHI
SPONJ HOLDER 10"	1 PCS
SPORIDEX AF TAB 375MG 10*10	1x10xTab
SPORIDEX AF TAB 750MG 10*10	1x10xTab
SPORIDEX CAP 500MG 24*10	1x10xCap
SPORIDEX DROP	1x10xMl.
SPORIDEX KID TAB 125MG 10*10	1x10xTab
SPORIDEX R/M DR	1x10xMl.
SPORIDEX R/M SYP 125MG	1x30xMl.
SPORIDEX SYP	1x30xMl.
SPORLAC POWDER	1 PIS
SPORLAC TAB.	1x10
SPORONUTRIN PED TAB	1X10
SPORONUTRIN SYP	1PHI
SPOROTIC CAP	1X10
SPOROTIC POW.SACH.1GM	1X1GM
SPORT PLUS TAB	1*10
SPROT (N) SYP 30ML	1x30xMl.
SPROT (N) TAB 10*10	1x10xTab
SPROT TAB 10*10	1x10xTab
SPROVIT DRY SYP	1x60ML
SQUARE TRAY KARMA	1 PCS
SQUIZEE CREAM	1X15
SSUPRAXONE-375 VIAL	1VIAL
ST PILLS	1X500
ST WORT	1X10T
ST-DOL 2ML	1AMP
STABLON TAB	1X10
STABOSE-0.2 TAB	1x10
STABOSE-0.3 TAB	1x10
STABRIC TAB	1X10
STAFCURE 1.5 ING.	1X1 VIAL.
STAFCURE 250	1X10S
STAFCURE 500	1X6S
STAFCURE 750 INJ.	1XV
STAFCURE CV 250	1X10T
STAFCURE CV 500	1X10T
STAFCURE SB 1.5	1X1 VIAL
STAFCURE SB 750	1X1 VIAL
STALFATE SUSPIONS	10ML
STALIA 20	1X10T
STALIA 40	1X10T
STALIA A 10	1X10T
STALIA A 20	1X10T
STALIN 100 TABLET	1X10
STALIN 50 TABLET	1X10
STALOPAM 10	1X10T
STALOPAM 20	1X10T
STALOPAM 5	1X10T
STALOPAM LITE TAB.	1X10 TAB.
STALOPAM MINI PLUS	1X10T
STALOPAM PLUS	1X10T
STAMACE TAB 10*10	1x10xCap
STAMACE-5 TAB 10*10	1x10xTab
STAMIN BOLUS	1X6'S
STAMINAID CAPS	10'S
STAMLO BETA TAB 20*15	1x15xTab
STAMLO-10 TAB 20*15	1x15xTab
STAMLO-2.5 TAB 20*15	1x15xTab
STAMLO-5MG TAB 20*15	1x15xTab
STAMLO-D TAB 10*10	1x10xTab
STAMLO-T TAB 10*10	1*10TAB
STANCEF 250MG VIAL	1VIAL
STANCEF INJ 1GM.	1VIAL
STANCEF INJ 500MG.	1 VIAL
STANCEF O DRY SYP 30ML	1 PH
STANCILLIN 2GM.	VIAL
STANHIST	1x10
STANLIP TAB 145MG 15*10	1*10*TAB
STAPHLOX INJ	1 VIA
STARBLEND 20% 200 GR	200 GR
STARCET 5MG	1X10
STARCET COLD TAB	1X10
STARCET TAB	1x10
STARCET-A TAB	1X10
STARCLAV 100 TAB 5*10	1x10xTab
STARCLAV 200 TAB 10*10	1x10xTab
STARCLAV 625 TAB 10*10	1*10TAB
STARCLAV BID SYP 30ML	1*30ML
STARCLAV DS	30ML
STARCLAV-50DT TAB 5*10	1x10xTab
STARMUNE GOLD CAP	1X10
STARMUNE GOLD SYP	200 ML
STARMUNE OS	1X10
STARPILL TAB	10'S
STARPRESS -T 25 XL	1X10T
STARPRESS -T 50 XL	1X10T
STARPRESS H 25 XL	1X10T
STARPRESS H 50 XL	1X10T
STARPRESS XL 100	1X10T
STARPRESS XL 12.5	1X10T
STARPRESS XL 25	1X10T
STARPRESS XL 50	1X10T
STARPRESS-AM XL 50	1X10T
STARPRESS-MN XL 30MG	1X10C
STARPRESS-MN XL 60	1X10T
STARPRESS-R XL 25	1X10T
STARPRESS-R XL 50	1X10T
STARSTAT 10MG T	1X10T
STATOR AM TAB 10*10	1*10*TAB
STATOR ASP TAB 75MG 10*10	1*10*TAB
STATOR F TAB 10*10	1x10xTab
STATOR TAB 10MG 30*10	1x10xTab
STATOR TAB 10MG 30*15	1*15*TAB
STATOR TAB 20MG 24*15	1*15*TAB
STATOR TAB 20MG 30*10	1x10xTab
STATOR TAB 40MG 3*10	1x10xTab
STAYFREE SECURE **(S)	1 PKT.
STAYFREE (L)	1X20PADS
STAYFREE COTTONY 20 PCS	20PCS
STAYFREE COTTONY 8 PCS	8 PCS
STEAM INHALER ELECTRIC	1 PCS
STEAM VAPORIZER	1 PCS
STEAM.CAP	1X10
STECLIN BOLUS 500 MG	1x4B
STEDICIN 25MG	1X10
STEDICIN 75 MG	1X10
STEDIDOM	1X10T
STEF INJ 1GM	1 VIL
STELABID-2MG TAB	10'S
STELBID TAB	10'S
STEMETIL AMP 1*12AMP	1x12xAmp
STEMETIL MD TAB 50*10	1*10*TAB
STENMENPIN & STUREM	1 SET
STENOT 1LIT	
STENOT 300ML	
STENOT BOLUS	
STEP FOR O.T.	1 PCS
STEPZA TAB	1X10
STERALIZER REPAIRING	1 PCS
STERDU CAP	1X10
STERDU-L	1X10T
STERI PAD 10CM X 10CM	1 PCS
STERI PAD 10CM X 20CM	1 PCS
STERI SWAB	1 PCS
STERIL GAUZE	12 DOZ
STERIL GAUZE 7.5 X 7.5	1 PCS
STERILE DILUENT 10 ML	10 ML
STERILE DILUENT 20 ML	20 ML
STERILE PENICILLINE G.INJ	10 ML
STERILE WATER 10MLK	10ML
STERILE WATER 5ML	5ML
STERILIUM	0 ML.
STERIMAX 500ML.	1 ML.
STERIO-16 TAB	1X10T
STERIO-4	1X10T
STERIO-8 TAB	1X10T
STETHESCOPE DELUXE	1 PCS
STETHESCOPE LIFE LINE	1 PCS
STETHESCOPE OMEX	1 PCS
STETHO (MEDICO)	1 PCS
STETHO (SIMRAN TONE)	1 PCS
STETHO ACCORD	1 PCS
STETHO DIAFAM	1 PCS
STETHO DIAMOND S.S	1 PCS
STETHO DOCTOR'S	1 PCS
STETHO EXCEED	1 PCS
STETHO FRAME	1 PCS
STETHO INNOVATION CARDIO S.S	1 PCS
STETHO LITTMAN S.S	1 PCS
STETHO MEDILINE TWIN	1 PCS
STETHO PLATINUM CLASSIC 2	1 PCS
STETHO REPEARING	1 NO
STETHO TIP	1 PAR
STETHO TUBE RUBBER	1 PCS
STETHO TUBE SINGLE	1 PCS
STETHO TWIN CARE	1 PCS
STETHOSCOP **	1 PIS
STETHOSCOPE DR MORPEAN	1 PCS
STETHOSCOPE DUAL (H.MUKHERJEE)	1 PCS
STETHOSCOPE DUO SONIC	1 PCS
STETHOSCOPE MAX	1 PCS
STETHOSCOPE OXFORD	1 PCS
STIBIS POWDER	1PIC
STIBS SACHET	10'S
STICH NIDDL	1x6
STICH THRED 22MITER	1
STICH THRED NYLON	1
STICK ALUMINIUM	1 PCS
STICK FOLDING ALUMINIUM KARMA	1 PCS
STICK PLAIN	1 PCS
STICK PLAIN (KARMA)	1 PCS
STILNOCT 12.5	1X10T
STILNOCT 6.25MG	1X10T
STILOZ 100 MG TABLET	1X10
STILOZ 50MG TAB	1X10
STIMOGON 2000 INJ	1 VIAL
STIMOGON 5000 INJ.	1+1 AMP
STIMULAC 200G POWDER	200GM
STIMULEX CAP	1X10
STIMULIV SYP. 100 ML.	1 PH.
STIMULIV SYP. 200 ML.	1 PH.
STIMULIV TAB.	1X60
STITCH CUTTING SCISSOR	1 PCS
STOLIN G.PAINT	1x15xMl.
STOLIN OINT 100GM	1x100xGm.
STOLIN-R OINT 100GM	1x100xGm.
STOLIN-R OINT 50GM	1x50xGm.
STOMACH FIT SYU	450ML
STOMAFIT 100	1PH
STOMAFIT 200	1PH
STOMAFIT 450ML	1PH
STOMAFIT TAB	
STOMAGEL PLUS SYP	175ML
STOMAGEL SYP	175ML
STOMAQUAR 100ML	1X100ml
STOMAQUAR 200ML	1X200ml
STOMAQUAR 450ML	1x450ML
STOMAREST 100ML	100ML
STOMAREST 200ML	200ML
STOMECK 10	1X10
STOMECK 20	1X10
STOMECK DSR	1X10
STON 1 ORAL SOLN	200ML
STON 1 SYP	450ML
STON HOLDING FORCEP	1 PCS
STONE 1 B6 ORAL SOLN	200ML
STONIL SYRUP 100ML	100ML[137]
STONIL SYRUP 200ML	200ML[126]
STOPIT INJ	5ML
STOPIT-500 TAB	1*10
STORAX 2ML INJ 5*2ML	1*2ML
STORAX 4ML INJ 5*4ML	1*4ML
STORAX 500 TAB 10*10	1*10TAB
STORAX PLUS TAB 10*10	1*10TAB
STORAX PR TAB 10*10	1*10TAB
STORAX SR 1G TAB 10*10	1*10TAB
STORAX SYP 60ML	1*60ML
STORVAS EZ TAB 10MG 10*10	1x10xTab
STORVAS EZ TAB 10MG 10*10	1x10xTab
STORVAS TAB 10MG 15*10	1x10xTab
STORVAS TAB 10MG 15*10	1x10xTab
STORVAS TAB 20MG 15*10	1x10xTab
STORVAS TAB 20MG 15*10	1x10xTab
STORVAS TAB 40MG 10*10	1x10xTab
STORVAS TAB 40MG 10*10	1x10xTab
STORVAS TAB 5MG 15*10	1x10xTab
STORVAS TAB 5MG 15*10	1x10xTab
STORVAS TAB 80MG 10*10	1*10*TAB
STORVAS TAB 80MG 10*10	1*10*TAB
STOZIC-100 TAB 10*10	1*10TAB
STPSL AYURVEDIC	100'S
STPSL AYURVEDIC	50'S
STPSL CORE MIXED	110JAR
STPSL MIXED JAR	8'S
STPSL REG. JAR	8'S
STPSL SINGLES MED.	100'S
STREPLIFE-15 LAC INJ.	1x1xVl.
STREPSILS STRIPS LOZ ORNG	200
STREPSILS LOZ.	1x8
STREPSILS SOOTHING JAR	200 S
STREPSILS WAM JAR	200 S
STREPTOMAC 0.75	1XV
STREPTOMAC 1GM	1XV
STREPTOMYCIN INJ 0.75GM	1x1xVl.
STRESNIL 0.25MG	1X10T
STRESNIL 0.5MG	1X10T
STRESROAK 500 ml	PH
STRESS CHECK LIQ	250ML
STRESSCARE 1 LT	1 LT
STRESSCARE 500 ML	500 ML
STRESSOL 1 LT	1 LT
STRESSVIT LIQ 500ML	1x500ML
STRESSVIT LIQ. 60 ML.	1 PH.
STRESSWON CAP	1X6
STRETCHER	1 PCS
STRETCHER TROLLY	1 PCS
STRIKER CAP.	1x10
STROCIT -CR 1*10	1*10TAB
STROCIT 2ML INJ 5*2ML	1*2ML
STROCIT 4ML INJ 5*4ML	1*4ML
STROCIT 500MG TAB5*10	1*10TAB
STROCIT PLUS TAB 5*10	1*10TAB
STROCIT-M TAB 3*10	1*10TAB
STROLIFE MONO INJ 5*2ML	1*2ML
STROLIFE MONO-500 TAB 5*10	1*10TAB
STROLIFE TAB 1*10	1*10TAB
STROLIN P 400	1X4 TAB.
STRONE 1*10	1*10
STRONG KIT 1*15TAB	1x15xTab
STRONIC 100ML	
STRONIC 30ML	VIAL
STROX TZ TAB	1*10
STRPSL MIXD JAR	220 S
STRPSL ORANGE SHOW BOX	200
STRRONG GRANULES 250GM	1*250GM
STUF CAPS	1x10
STUGERON FORTE TAB 20*20	1x20xTab
STUGERON TAB 26*25	1x25xTab
STUGIL TAB 10*6	1x6xTab
STUKINASE 15 LAC 1U	1 VIL
STYLE CONDOM	1*5
STYPLON TAB	1x30xTab
STYPLON VET BOLUS	1X4B
STYPTOCHROME INJ 100*2ML	1x2xMl.
STYPTOVIT-E TAB 40*10	1*10TAB
STYPTOVIT-K TAB 40*10	1x10xTab
SUB ACT 3GM.	1X3GM
SUBHI	1X10
SUBHI-GOLD	1X10
SUBMAX 3GM.	1X3GM
SUBSTITUTE TAB	100'S
SUBSYDE CR CAP	1x10
SUCCICORT	1 VAL
SUCOL	1 VAL
SUCRA-FAST SUSP.	1x200ml.
SUCRADAY SYP 100ML	1x100xMl.
SUCRADEX-O SYP	100 ML
SUCRADY-O SYP	1*100ML
SUCRAFIL O SY	1PHI
SUCRAFIL SY	1PHI
SUCRAL (S) CRM	20GM
SUCRAL MU CRM	15GM
SUCRAL SUSP	200ML
SUCRAL-ANO CRM	20GM
SUCRAL-D SYP	100ML
SUCRAL-KID SUSP	100ML
SUCRAL-MU CRM	5GM
SUCRAL-O SUSP	200ML
SUCRAL-POVI CRM	20GM
SUCRALKO-O SUS	200ML
SUCRAMAX 0 SUSP	100 ML
SUCRAMAX-O SUSP	100ML
SUCRAMOUNT SYP	1X200ML
SUCRAPEN-O SYP	1X100ML
SUCRAZOL SYP	1X100ML
SUCRO O SYP	1X100ML
SUCRO SYP	1X200ML
SUCTION ADOPTOR	1 PCS
SUCTION CANULA SS	1 PCS
SUCTION CATHATER 10	1 PCS
SUCTION CATHATER 8"	1 PCS
SUCTION CATHERTER	1 PCS
SUCTION CATHETAR 6"	1 PCS
SUCTION CATHETER (PLAIN) FG-12	1 PCS
SUCTION CATHETER (PLAIN) FG-14	1 PCS
SUCTION CATHETER (PLAIN) FG-16	1 PCS
SUCTION CATHETER (PLAIN) FG-18	1 PCS
SUCTION CATHETER (PLAIN) FG-8	1 PCS
SUCTION MACHINE (HMT)	1 PCS
SUCTION MACHINE (M.S. BODY)	1 PCS
SUCTION MACHINE 1/4HP	1 PCS
SUCTION MACHINE FULL REPEARING	1 NO
SUCTION MACHINE JAR WITH CAP	1 SET
SUCTION PIPE	1 MTR
SUDEX AR EX.	1 PH.
SUDEX BR	1 PH.
SUDROX 125MG	1X10
SUDROX 250MG	1X10
SUDROX 250MG SY	1PHI
SUDROX 30ML	1PHI
SUDROX 500MG	1X10
SUDROX 500MG	1X4
SUFRATE CREAM 35GM	35GM
SUFRATE 200GM CREAM JAR	200GM
SUFRATE 200ML SYP	200ML
SUFRATE 35GM SSD CREAM	35GM
SUFRATE DENTAL CREAM 80G	80GM
SUFRATE HAIR CREAM 70GM	70GM
SUFRATE LA 35GM	35GM
SUFRATE PZ SACCHET 1 SAC	1
SUFRATE TP 40GM	40GM
SUFRATE TP LOTION 100ML	100ML
SUFRATE TP POWDER 10GM	10GM
SUFRATE-200ML	200ML
SUFRATE-O 100ML	100ML
SUFRATE-P 100ML	100ML
SUGANRIL TAB 10*10	1x10xTab
SUGAR FREE GOLD	1X110T
SUGAR FREE GOLD	1X25+10X1G
SUGAR FREE GOLD	1X300T
SUGAR FREE GOLD	1X40T
SUGAR FREE GOLD	1X500T
SUGAR FREE GOLD POWDER	1X100GM
SUGAR FREE NATURA	1X100T
SUGAR FREE NATURA	1X200T
SUGAR FREE NATURA	1X25X1GM
SUGAR FREE NATURA	1X300T
SUGAR FREE NATURA	1X500T
SUGAR FREE NATURA 1KG	1X1KG
SUGAR FREE NATURA DIET SU	1X80GM
SUGAR FREE NATURA DP	1X200DP
SUGAR FREE NATURA POW CON	1X100GM
SUGARCHECK METER 1SET	1*1P
SUHIT-M SYRUP	60ML
SULABH ENEMA	50ML
SULBACTAMOX 3GM	3GM
SULCOPRIM 100 GM.	PH.
SULCOPRIM BOLUS	10x4B
SULFEX BOLUS	1x5 BOLUS
SULFOX BOLUS	1X4'S
SULID-P SYP	1*60ML
SULMET 500 ML.	PH
SULPHA BOLUS	10x2TAB
SULPHA BOLUS 1X4	1X4
SULPHA-Z BOLUS	6X4'
SULPHACURE BOLUS	1X4B
SULPHADIMIDINE 100ML	1x100ML
SULPHADIMIDINE TAB.	1x50TAB
SULPHADIMIDINE.100ML.VIL	1VIL
SULPHAGUANIDINE.TAB	1X10
SULPHAGUT BOLUS 1X4	1X4
SULPHAGUT BOLUS.	1x5B
SULPHATRIM 30ML	VAIL
SULPHAZIN DROP	10ML
SULPITAC 100 TAB 10*10	1*10TAB
SULPITAC 100 TAB 5*10	1*10TAB
SULPITAC 200 TAB 5*10	1*10TAB
SULPITAC 300 TAB 5*10	1*10TAB
SULPITAC 400 TAB 3*10	1*10TAB
SULPITAC 50 TAB 10*10	1*10TAB
SULPITAC OD-100 TAB 5*10	1*10TAB
SULPITAC OD-200 TAB 5*10	1*10TAB
SULPRIM-24 30ML.	1X30ML
SULTRIN.DS	
SUMO	1X10T
SUMO COLD PCF AF SY	1X60ML
SUMO COLD PCF DROP	1X10ML
SUMO COLD PCF SY	1X60ML
SUMO COLD(NEW)	1X10T
SUMO GEL	1X30GM
SUMO INJECTION	1ML
SUMO L 100MG DP	1X15ML
SUMO L 125 SUSP	1X60ML
SUMO L 250MG DS SYP.	1X60ML
SUMO L 650 ER	1X10T
SUMO L IV INJ.	1X100ML
SUMO L PLUS SYP.	1X60ML
SUMO MF SYP.	1X60ML
SUMO SPRAY	1X50GM
SUMO SUSPENSION	60ML
SUMO-SPAS TAB	1X10
SUMOFLAM TAB	1X10
SUMOW-TAB	1*10
SUN- O2 SYP	1 PH
SUNCET TAB	1x10
SUNCHEK SUNSCREEN LO.	1X100ML
SUNCOBAL FORTE TAB	1X10
SUNCOLD JR. SUS	60ML
SUNCOLD SUS	60ML
SUNCOLD TAB	1x10
SUNCORIL T SYP	100ML
SUNDARI FORT SYRUP 200ML	200ML[43]
SUNDE	1 GM
SUNDE 60K TABS	4'S
SUNDRI KALP	200ML
SUNLID - PLUS TAB	1X10T
SUNLIDE - MD TAB	1X10T
SUNLYTE SUCHET	1 SUCHET
SUNPODOX DRY POWDER 100MG	30ML
SUNPODOX DRY POWDER 50MG	30ML
SUNPODOX-200MG TAB	1X10
SUNPROGEST 250MG	1x1
SUNPROGEST 500MG	1x1
SUNRIN KALP SYP.	450ML
SUNSTOP 30 SPRAY	100 GM
SUNSTOP AQUAGEL	
SUNSTOP-19 CREAM	50 GM
SUNSTOP-30 CREAM	50 GM
SUNTHYADI PAK 125GM	125GM[94]
SUNTUSS EXP	1PH
SUPACEF/1.5GM INJ	1'S
SUPACEF/250MG INJ	1'S
SUPACEF/750MG INJ	1'S
SUPAKEM	1X10 TAB.
SUPAMOVE CREAM 30GM	1*30GM
SUPAMOVE-4 CAP 3*10	1*10CAP
SUPAMOVE-8 CAP 3*10	1*10cap
SUPANAC TAB 5*10	1*10TAB
SUPARCARBAZINE FORT TAB	1X10
SUPARI PAK 125GM	125GM[44]
SUPARI PAK 250GM	250GM[45]
SUPER GYL PLUS SYR	30ML
SUPER D3 2000 I.U	1X10S
SUPER D3 60000 I.U	1X10S
SUPERCARE BOLUS	1x4
SUPERCARE LIQ 1 LIT.	1 LITER
SUPERCOX 100GM.	SACHET
SUPEREYEZ EYE DROP	10ML
SUPERGYL 30ML SYP	1
SUPERHIST	1X100ML
SUPERMET AM TAB 10*10	1*10
SUPERMET H TAB 10*10	1*10
SUPERMET XL TAB 25MG 10*10	1*10
SUPERMET XL TAB 50MG 10*10	1*10
SUPERMUNE 100 GR	100 GR
SUPERNIM PLUS TAB	10'S
SUPERNIM TAB	10'S
SUPERSPAS AMP	1X3ML
SUPERSPAS TAB.	1x10
SUPERSPAS VAIL	1X30ML
SUPIME	1 PCS
SUPIROCIN B PLUS OINT 5MG	1TUBE
SUPIROCIN OINT 5GM	1TUBE
SUPIROCIN OINTMENT	1X5G
SUPKOF-T SYP	100ML
SUPLO TAB 400MG 10*10	1x10xTab
SUPLO-S 200 TAB 10*6	1x6xTab
SUPPLEVITE M 1KG.	1KG
SUPPLIVITE M 250 GR	250 GR
SUPPLIVITE-M2.5KG	BAG
SUPRA CATH FG-16	1 PCS
SUPRA CATH FG-18	1 PCS
SUPRABENZ 0.25	1X10T
SUPRABENZ 0.50	1X10T
SUPRABENZ PLUS 10	1X10T
SUPRABENZ PLUS 5MG	1X10T
SUPRACAL SYP.	1 PH.
SUPRACAL TAB.	1x10
SUPRACAL-OS CAP	1X10
SUPRACLOX VET INJ.	1VAIL
SUPRACTIV COMPLETE MAN 30'S	
SUPRACTIV COMPLETE MAN 8'S	
SUPRADYN TAB 30*15	1x15xTab
SUPRAFER CAP	1X10
SUPRAMOX-CV VAIL	1 VAIL
SUPRANET TAB	1X10TAB
SUPRANET-D CAPS	1X10
SUPRAPLEX-L INJ.	30 Ml.
SUPRAPOD 100DT TAB 10*10	1*10TAB
SUPRAPOD 200 TAB 10*10	1*10TAB
SUPRAPOD 50DT TAB 10*10	1*10TAB
SUPRATE LA 30GM	30GM
SUPRATE PZ SACCET	1
SUPRATE TP 40GM	40GM
SUPRAXONE 1GM	1GM
SUPRAXONE-375 VIAL	1VIAL
SUPRAXONE-S-1.5 GM	1.5GM
SUPRAZOLE 30 ML	30 ML
SUPRAZOLE 3gm	1x1B
SUPRAZOLE 90ml	PH
SUPRIM D.S. TAB	1*10
SUPRIM SYP.50ML	50ML
SUPRIMOX KID TAB 10*10	1x10xTab
SUPRIMOX PLUS CAP 10*10	1*10*CAP
SUPRIN TABLET	1x30
SURBEX GOLD CAP 10*10	1*10*CAP
SURBEX OSTEO TAB 1*10	1*10*TAB
SURBEX STAR CAP 10*10	1*10*CAP
SURBEX XT TAB 30*15	1x15xTab
SURCAL M SYRUP	1X200 ML
SURCAL-M TABLET	1X10
SURECAL CAP 1*10	1*10
SURECLAV DRY SYRUP	30ML
SURECLAV-625	1*6
SURECLAV228.5 TAB	1*10
SURFAZ B CREM	15GR
SURFAZ CREAM	1 TUBE
SURFAZ EAR DROP	1 PH.
SURFAZ POWDER	1 PC.
SURFAZ SN	1 TUBE
SURFAZ SOLUTION	1 PH.
SURFAZ VEG. TAB.	1x6
SURFAZ-O TAB	1TAB
SURFINAC-P TABLET	1X10
SURGEON'S APPERON (PLASTIC)	1 PCS
SURGEON'S GOWN CASEMENT	1 PCS
SURGICAL GLOVES	1 PCS
SURGICAL GLOVES 6.5 STERLISED	1 PAI
SURGICAL GLOVES 7 STERLISED	1 PAI
SURGICAL GLOVES STER 6.5	1 PAI
SURGICAL GLOVES STER 7	1 PAI
SURGICAL GLOVES STERLITE	1 PCS
SURGICAL SPIRIT 1000ML	1 ML.
SURGICAL SPIRIT 450 ML	1 ML.
SURGICAL SPIRIT 500 ML	1 PCS
SURGICAL SPIRITB.P.C. 100ML.	100 ML.
SURGICAL SPIRT 100(KABRA)	1
SURGICAL SPRIT BPC (100ML)	100 ML.
SURGICAL SPRIT BPC (400ML)	400 ML.
SURGICARE FORTE TAB	1x10
SURGICARE-D TAB	1x10
SURRAL 250 MG	250 MG
SURTALO 5 MG TABLET	1X10
SURTALO FORTE TABLET	1X10
SURTALO PLUS TABLET	1X10
SURTALO-10 MG TABLET	1X10
SURUCHI BOLUS	1x4B
SURUCHI POWDER 50 GM.	1x50GM
SURVI SOFLETS	1X10
SURVI SYP	100ML
SUSPENSORY BANDAGE XL	1 PCS
SUSTAMET AM TAB 10*10	1*10*TAB
SUSTAMETO TAB 25MG 10*10	1*10*TAB
SUSTAMETO TAB 50MG 10*10	1*10*TAB
SUSTANON 100 INJ	1x1xAmp
SUSTANON 250 INJ	1x1xAmp
SUSTEN 100 CAP 10*10	1*10CAP
SUSTEN 100 TAB 5*10	1*10TAB
SUSTEN 200 CAP 10*10	1*10CAP
SUSTEN 300 TAB 5*10	1*10
SUSTEN INJ 100MG 5*1ML	1*1ML
SUSTEN INJ 200MG 5*2ML	1*2ML
SUSTEN-SR 200 CAP 1*10	1*10CAP
SUSTEN-SR 300 CAP 1*10	1*10CAP
SUSTEN-VT 100 VAG TAB 1*6	1*6TAB
SUSTEN-VT 200 VAG TAB 1*6	1*6TAB
SUTCHER NEEDLE	1 PCS
SUTCHER NEEDLE 5" 1/2 CIRCLE CUTTIN	1 PCS
SUVIDA -72 TAB 1TASB	1TAB
SUVIDHA TAB 1*28	1*28
SVIFTA BOLUS	1x4B
SVIZCODIN SYU	1PH
SVIZFLAM TAB	1X10
SVIZMOX-500 CAP	1x10
SVIZPLOX 500MG TAB	1x10
SW CASANOVA DEO S.P.	150ML
SWALOBEE	1X10S
SWAS CHINTAMANI RAS	1PH
SWASTHYA VARDHAK CAP	1X10
SWEEPLINE SYP 10ML	10ML
SWEEPLINE TAB 1*10	1*10
SWEET DREAM CREAM	1x30GM
SWEETELA TAB 1*100	1*100*TAB
SWEETELA TAB 1*200	1*200*TAB
SWETCARE CAPS	1x10
SWICH 100 MG D/S	1X30ML
SWICH 200 TAB	1X10T
SWICH 50 DT	1X10T
SWICH 50MG D/S	1X30ML
SWICH DROP 25MG/ML	1X10ML
SWICH DT 100MG	1X10
SWICH PLUS TAB	1X10T
SWICH-CV 100MG D/SY	1X50ML
SWICH-CV 325MG	1X10T
SWICH-CV 50MG D/S	1X30ML
SWICH-O	1X10T
SWICH-XP 1000MG	1XV
SWICH-XP 125MG	1XV
SWICH-XP 250 MG	1XV
SWICH-XP 500MG	1XV
SWIFTOLAC SYP 100ML	1x100xMl.
SYCID 170 ML	170ML
SYFUN-150 TAB.1'S/SAT	S
SYL 2ml AMP	1x2ml
SYL FORTE TAB	1X10
SYL PLUS	1X10
SYL TAB	1X10
SYLINE TAB	1X10
SYLKAM 0.25 TAB 10*10	1*10TAB
SYLKAM 0.5 TAB 10*10	1*10TAB
SYMBAL 20	1X10T
SYMBAL 30	1X10T
SYMBAL 40MG TAB	1X10
SYMBICORT TURBULER160MCG	1*60
SYMBIOTIC P TAB 10*10	1x10xTab
SYMBIOTIK CAP 20*6	1x6xCap
SYMBIOTIK XL TAB 625MG 5*6	1x6xTab
SYMOXYL CALF BOLUS.	1x4B
SYNABRON DC SYP 100ML	1*100ML
SYNABRON PLUS EXP 100ML	1x100xMl.
SYNABRON-D SYP	1x100xMl.
SYNAC-N TAB	1*10
SYNACOLD ORAL DROP	1*15ML
SYNACOLD SYP.	1*60ML
SYNAPTOL-100 TAB 5*10	1*10TAB
SYNAPTOL-150TAB 5*10	1*10TAB
SYNAPTOL-50TAB 5*10	1*10TAB
SYNASMA AX TAB 10*10	1*10*TAB
SYNASMA TAB 10*15	1*15*TAB
SYNCAPONE 100 TAB 10*10	1*10TAB
SYNCAPONE 150 TAB 5*10	1*10TAB
SYNCAPONE 50 TAB 5*10	1*10TAB
SYNCEFIX CAPSULES	1*10
SYNCLAR 250MG TABS	10'S
SYNCLAR DRY SYR	30ML
SYNCROSPAS CAP	1x10
SYNDOL	1X10 TAB.
SYNDOL DS	1X10T
SYNDOL DS TAB	1X10
SYNDOL TAB.	1X10
SYNDOPA 110 TAB 15*10	1*10TAB
SYNDOPA 275 TAB 10*10	1*10TAB
SYNDOPA-CR TAB 10*10	1*10TAB
SYNDOPA-PLUS TAB 15*10	1*10TAB
SYNERTIC 500MG CAP 10'S	
SYNKRON 4 GR	4 GR
SYNOGEL SYP	170ML
SYNOM DX SYP	100ML
SYNOM EXP SYP	100ML
SYNOX NASAL DROP	1*10ML
SYNPOD CAPSULES	1*10
SYNRIAM TAB 1*3	1*3*TAB
SYNTAC 40 TAB	1X10
SYNTAC D TAB	1X10
SYNTAC DSR TAB	1X10
SYNTHERGIN INJ.	1X5AMP(BO)
SYNTHERGIN TAB	1x10
SYNTOCINON INJ 1AMP	1x1xAmp
SYNTOXIN AMP	1ml
SYNTOXIN INJ	1ml
SYNULOX 40ml	VAIL
SYPE TAB.	1X10 TAB.
SYRACID GEL	1*170ML
SYRAPAN-40 TAB	1*10
SYRAPAN-D TAB	1*10
SYRING 3ML 24G	1 PCS
SYRINGE 3ML	1 PCS
SYRINGE 5ML.	1 PCS
SYRINGE CASE	1 PC.
SYRINGS 10ML	1 PCS
SYSCAN-150	1X1C
SYSCAN-CL	1X3C
SYSFOL- TABS	30'S
SYSRON- N TABS	10'S
SYSTAFLAM GEL	1TUB
SYSTAFLAM GEL 50 GM	50 GM
SYSTAFLAM MR	10'S
SYSTANE E/D	1*10ML
SYSTANE ULTRA	10ML
Speycef-O dry syp	30ML
Supraplex Injection	30 Ml.
T & PLANE DISECTING FORCEP 6"	1 PCS
T G CEF 1GM	VAIL
T G CEF 250GM	VAIL
T MART H TAB 40MG 10*10	1*10*TAB
T MART R TAB 10*10	1*10*TAB
T MART TAB 40MG 10*10	1*10*TAB
T TOP FORTE OINT 0.10%	1*10*GM
T TOP OINT 0.03%	1*10*GM
T-1	1*10ML
T-98 DROP	1x15xMl.
T-BACT CREAM	7.5GM
T-BACT OINT	5GM
T-BET EYE DROP	1*3ML
T-FLOX DROPS	1 PH
T-LAC E/D	1*5ML
T-STAT INJ	5ML
T-STAT-1000 TAB	1*10
T-SYL 250 TAB	1x10
T-SYL 500 TAB	1x10
T-SYL-MF TABS	1X6
T. PHOS 10 ML	10 ML
T. PHOS 30 ML	30 ML
T.M.100 ML. INJ	VIAL
T.M.250 MG. CAP.	1x4
T.M.30 ML.INJ	VIAL
T.M.60 ML.HCL LIQ	PH
T.M.LA 30 ML.	VIAL
T.M.TAB 500MG.	1x4
T.R P TAB	1x4
T.TUBE (ROMSONS)	1 PCS
T.TUBE FG-10	1 PCS
T.TUBE FG-12	1 PCS
T.TUBE FG-14	1 PCS
T.TUBE FG-16	1 PCS
T.TUBE FG-18	1 PCS
T.U.R SET	1 PCS
T.U.R. SET	1 PCS
TAB. SORBITRATE	1 TAB
TABLE CLOTH	1 PCS
TABROL D S	1X10T
TABROL S.S TABS	1X10
TABROL SUSP	50ML
TACALSIS OINT	10GM
TACALSIS OINT 20GM	1*20GM
TACEHEXT 1GM	1XV
TACEHEXT 500	1XV
TACHYRA 200 MG TAB.	10'S
TACHYRA INJ.	3ML
TACIL D TAB 10*10	1*10*TAB
TACIL TAB 10*10	1*10*TAB
TACRAL FORTE	1*10
TACRAL OINT	1*1
TACROKID ONT0.03	1X10GM
TACROZ 10GM ONITMET	1TUBE
TACROZ FORTE 10GM TUB	1TUBE
TACROZ FORTE OINTMENT	1X10 GM
TACROZ ONITMENT 10GM	1C10 G
TAF-GM OINT	1
TAG KIT-TAB	1KIT
TAGNUM 1.5	1XV
TAGON-6 TAB 6*10	1x10xTab
TAH-40 TAB 10*10	1*10TAB
TAH-5 TAB 10*10	1*10TAB
TAIBU COUGH SYP	1X100 ML
TAILOR SCISSOR 10"	1 PCS
TAIN OFF TAB	1*10
TAIYU LOTION	1*100*ML
TAKS LYCOTAK SYP	200ML
TAKTIC 12.5% 50ML	1x50ML
TAKTIC 5% 25 ML.	1x30
TALEKT SYP	1x120xMl.
TALEKT TAB 1*60	1x60xTab
TALISADI 100GM	100GM[76]
TALISADI 50GM	50GM[75]
TALSIL SYP	1x170ML
TALSIL TAB	1x10
TAM 1200 TAB	1X10TAB
TAM 800 TAB	1x10
TAM SYRUP	1x100ML
TAM-60ML IV	1x60ML
TAMCONTIN 0.2 TAB 10*10	1x10xTab
TAMCONTIN 0.4 TAB 10*10	1x10xTab
TAMCONTIN-D TAB 10*10	1*10TAB
TAMDURA TAB 10*10	1*10TAB
TAMFIL CAP	1X10
TAMLET-4 TAB 3*10	1*10TAB
TAMLIN	1X10
TAMLIN D	1X10
TAMLOCEPT 0.2	1X10C
TAMLOCEPT 0.4	1X10C
TAMLOCEPT D	1X10T
TAMLOCEPT F	1X10C
TAMSIN D TAB	10'S
TAMSIN TAB	1*10
TAMTERO 10MG TAB	1X10
TANATRIL 10MG	1X10
TANATRIL 5MG	1X10
TANCODEP	1X10T
TANCODEP 2	1X10T
TANCOLIN SYP. 100 ML.	1 PH.
TANCOLIN SYP. 50 ML.	1 PH.
TANCOLIN TG SYP	1X100ML
TANTUM C GEL	30GM
TANTUM GEL	1TUB
TANTUM ORAL RINSE	100ML
TANVIT INJ 30 ML	30 ML
TAPCODRYL	100ML
TAPCODRYL SYP	100ML
TAPCYNTA 75	1X10TAB
TAPCYNTA PLUS	1X10T
TAPENAX ER 100	10'S
TAPENAX ER 50	10'S
TAPENTA 50	1X10T
TAPENTA-P	1X10 TAB.
TAPHEREX 100GM	1X100GM
TAPIC EM 4.5GM INJ	1 VAIL
TARCEF-S 375	VIAL
TARGET 30 ML	30 ML
TARGET 90 ML	90 ML
TARGIT 20 10*10	
TARGIT 40 10*10	1*10
TARGIT 80 10*10	1*10
TARGIT AM 10*10	1*10
TARGIT H 10*10	1*10
TARGIT M 10*10	1*10
TARGOCID INJ 200MG	1XV
TARGOCID INJ 400MG	1XV
TARIFLOX EYE/EAR	1PH
TARIFLOX IV	1PH
TARIFLOX OZ SYU 30ML	1PH
TARIFLOX SYU	30ml
TARIFLOX-OZ 60 ML SY	1x60 ML
TARIFLOX-OZ TAB	1X10
TARIFLOX.200MG.TAB	1X10.
TARIVER 200MG	1*10
TARIVER 60ML	1*60ML
TARIVER OZ 30ML	1*30ML
TARIVER TZ	1*10
TARIVID 200 I.V	100ML
TARIVID 200MG	1X5T
TARIVID 400 I.V.	200ML
TARIVID 400MG	1X5
TARNAXI-500 AMP	1AMP
TASCOVIT CAPS	1*10
TASCOVIT SYP	200ML
TASFER-XT SYP	200ML
TASFER-XT TAB	1*0
TASRAB-DSR CAP	1*10
TASTYPRO POW	200GM
TASUL O SUSP 200 ML	
TASUL SURP 200ML	
TATA TEA GOLD-250GM	1X250GM
TATKAL DS250 SUS	60ML
TATKAL TAB 1*10	1*10
TATKAL-650 TAB	1*10
TATVAC 2 ML AMP.	1 AMP.
TAURAS TAB	1*10
TAVANIC	1X100ML
TAXCEF 1000 VIAL	10ML
TAXCEF 250 VIAL	10ML
TAXCEF 500 VIAL	10ML
TAXCEF- S 1500 VIAL	10ML
TAXCEF- S 375 VIAL	10ML
TAXCEF- S 750 VIAL	10ML
TAXCLAV 100	1X10T
TAXCLAV 100MG DT	1X10T
TAXCLAV 200	1X10T
TAXCLAV 50MG DT	1X10T
TAXCLAV DRY SY	1X30ML
TAXEF 2 GR	2 GR
TAXEF 3GM	3GM
TAXFAX 200MG TAB	1x10
TAXFAX DRY SYP	1x30ML
TAXIM 125MG	1XV
TAXIM 1GM	1XV
TAXIM 250MG	1XV
TAXIM 500MG	1XV
TAXIM AZ 100MG	1X10T
TAXIM AZ 200MG	1X10T
TAXIM O 100DT	1*10
TAXIM O 200MG TAB	1*10
TAXIM O 400 TAB.	1X10 TAB.
TAXIM O FORTE D/S	1X30ML
TAXIM OZ	1X6T
TAXIM-O 50DT TAB	1*10
TAXIM-O CV 200MG	1X10T
TAXIM-O CV D/S	1X30ML
TAXIM-O DROP	10ML
TAXIM-O DRY SYRUP	30ML
TAXIM-OF	1X10T
TAXIMAX-1500 INJ	1XV
TAXIMAX-375 INJ	1XV
TAXIMAX-750	1XV
TAXITORIN 200MG	1X10T
TAXON O-200 TAB 10*10	1*10TAB
TAXONE 125MG INJ	1x1xVl.
TAXONE 1GM INJ	1x1xVl.
TAXONE 250MG INJ	1x1xVl.
TAXONE 500MG INJ	1x1xVl.
TAXONE XP 1.125GM	1x1xVl.
TAXONE XP 1GM INJ	1x1xVl.
TAXONE XP 250 INJ	1x1xVl.
TAXONE XP 281.25MG	1x1xVl.
TAXONE XP 500MG INJ	1*1VAIL
TAXONE XP 562.5MG	1x1xVl.
TAXONE XP-125MG INJ	1x1xVl.
TAXONE-L TAB 10*6	1*6TAB
TAXONE-O DROP	1x10xMl.
TAXONE-O SYP	1x30xMl.
TAXONE-O-100 TAB 10*10	1x10xTab
TAXONE-O-200 TAB 10*6	1x6xTab
TAXONE-OF TAB 10*10	1*10TAB
TAXPIC O 200 TAB 10*10	
TAXPIC O DRY SYRUP 30 ML	
TAXPOD 200 TABS	1*10
TAXPOD 50DRY SYP	30ML
TAYLOR BRACE L	1 PCS
TAYLOR BRACE S/M/L	1 PCS
TAYLOR'S BRACE S,M,L	1 PCS
TAYO 60K FP TAB 1*16	1*16*TAB
TAYO 60K TAB 10*4	1*4*TAB
TAYO TAB 10*10	1*10*TAB
TAZACT	4.5GM
TAZACT 1.125GR	1VAIL
TAZACT 2.25G	1VAIL
TAZACT 4.5GR	1VAIL
TAZAR INJ 1.125GM	1XV
TAZAR INJ 2.25 GM	1XV
TAZAR INJ 4.5GM	1XVIAL
TAZID 125MG INJ	VIAL
TAZID 1GM INJ	VIAL
TAZID 250MG INJ	1X1V
TAZID XP 1.125GM INJ	1XV
TAZLOC AM TAB 40MG 10*10	1*10*TAB
TAZLOC BETA TAB 25MG 10*10	1*10*TAB
TAZLOC BETA TAB 50MG 10*10	1*10*TAB
TAZLOC H TAB 10*10	1*10*TAB
TAZLOC TAB 20MG 10*10	1*10*TAB
TAZLOC TAB 40MG 10*10	1*10*TAB
TAZOCEF- O.5625GR	1'S
TAZOHEAL -4.5GM	4.5MG
TAZOHEAL PS	VAIL
TAZOMAC 2.25	1XV
TAZOMAC 4.50	1XV
TAZOMAC PS	1XV
TAZOMARC 4.5GM INJ	
TAZOMUST INJ 4.5GM	VIAL
TAZONEX 4.5GM	VIAL
TAZOP 4.5GM	1X1V
TAZOPRA 4.5	1XVIAL
TAZOSAM INJ.	1 VIA
TAZOTUM 1.125MG INJ	1XV
TAZOTUM 2.25GM INJ	VIAL
TAZOTUM 4.5 GM INJ	1XV
TAZOVAL	VIAL
TAZOX	1X1GM
TAZOX 250MG	1X1V
TAZRET FORTE CREAM 15G	1 TUBE
TAZZLE 10 TAB 10*10	1*10TAB
TAZZLE 20 TAB 10*10	1*10TAB
TBRAZINE 750MG	1X10
TBRAZINE-500MG	1X10
TBRAZINE-E	1X10
TEAR DROPS	1*5ML
TEARMAX DROP 10ML	1*10ML
TEARS NATURAL FORTE	10ML
TEARS NATURALE II 5ML	1*5ML
TEARS NATURALE II E/D	1*10ML
TEARS PLUS	10ML
TEBINA 125DT TAB 5*7	1x7xTab
TEBINA CREAM 15GM	1x15xGm.
TEBINA TAB 1*2*7	2*7TAB
TECBETA 25 TAB	1x15
TECBETA 50 TAB	1x15
TECBETA AM TAB	1x15
TECNIM MD 1*10	1*10
TECNIM P SYP 60ML	60ML
TECNIM-P 1*1	1*10
TECZINE AM CAP 10*10	1x10xCap
TECZINE AM CAP 10*10	1x10xCap
TECZINE INSTAB 5MG 10*10	1x10xTab
TECZINE INSTAB 5MG 10*10	1x10xTab
TECZINE SYP	1*30*ML
TECZINE SYP	1*30*ML
TECZINE TAB 10MG 5*10	1*10*TAB
TECZINE TAB 10MG 5*10	1*10*TAB
TECZINE TAB 5MG 15*10	1*10*TAB
TECZINE TAB 5MG 15*10	1*10*TAB
TEDRAL SA TAB	1x10
TEDRAL TAB	1x10
TEDYCAL FORT TAB	1x30
TEDYCAL TAB	1x90
TEDYCUF SYP 60ML	1*60ML
TEDYKOFF-LX SYP 60ML	1*60ML
TEEBURB BOLUS	1
TEEBURB CAP.	1x24CAP
TEFFROLI LIQID 5LT	1X5LT
TEFOL - Z CAP	1X15
TEFROLI FORTE SYP 100ML	100ML
TEFROLI VET SYP 500ML	500ML
TEFROLIV FORTE SYP	1x200xMl.
TEFROLIV FORTE TAB 3*20	1x20xTab
TEFROX 150 MG TAB	1x10
TEFROX 300 MG TAB	1x10
TEFROX 50 MG TAB	1x10
TEGADERM NO-1623	1 BOX
TEGADERM NO-3551	1 PCS
TEGADERM+PAD 3591 9CM X 25CM	1 PCS
TEGIBS-6	1X10T
TEGRITAL CR TAB 200MG 10*10	1x10xTab
TEGRITAL CR TAB 300MG 10*10	1x10xTab
TEGRITAL CR TAB 400MG 10*10	1x10xTab
TEGRITAL SYP	1x100xMl.
TEGRITAL TAB 100MG 10*10	1x10xTab
TEGRITAL TAB 200MG 10*10	1x10xTab
TEGRITAL TAB 400MG 10*10	1x10xTab
TEKNOFLEX TAB.	1x10
TEL REVELOL TAB 40/25 10*10	1*10*TAB
TEL REVELOL TAB 40/50 10*10	1*10*TAB
TELAST-80 TAB 5*10	1x10xTab
TELBLOK H TAB 10*10	1*10*TAB
TELBLOK TAB 20MG 10*10	1*10*TAB
TELBLOK TAB 40MG 10*10	1*10*TAB
TELDAY 20	1X10T
TELDAY 40	1X10T
TELDAY 80	1X10 TAB.
TELDAY 80 H	1X10 TAB.
TELDAY AM	1X10T
TELDAY H	1X10T
TELEKAST -A	1X10 TAB.
TELEKAST 10	1X10
TELEKAST 4 CHEW.TAB	1X10T
TELEKAST 5 CHEW.TAB	1X10T
TELEKAST L KID	1X10T
TELEKAST PLUS	1X10
TELEKAST-D	1X10T
TELEKAST-F	1X10T
TELEKAST-L	1X10T
TELEXIA 40HTAB	10'S
TELEXIA 40TAB	10'S
TELEXIA 80 TAB	10'S
TELEXIA 80H TAB	10'S
TELEXIA AM TAB	10'S
TELEXIA M25 TAB	10'S
TELEXIA M50 TAB	10'S
TELGIK-40	1*15
TELGIK-AM TAB	1*15
TELGIK-H TAB	1*15
TELI AM TAB 10*10	1*10*TAB
TELI AM TAB 80MG 10*10	1*10*TAB
TELI H TAB 10*10	1*10*TAB
TELI H TAB 80MG 10*10	1*10*TAB
TELI TAB 20MG 10*10	1*10*TAB
TELI TAB 40MG 10*10	1*10*TAB
TELI TAB 80MG 3*10	1*10*TAB
TELIMETRIN 60 MG. AMP.	1 AMP.
TELISTA -MT 25	1X10 TAB.
TELISTA -MT 50	1X10 TAB.
TELISTA 20MG TAB	1X10
TELISTA 40MG TAB	1X10
TELISTA AM	1X10T
TELISTA AM 2.5	1X10T
TELISTA AM-80	1X10T
TELISTA AMH	1X10T
TELISTA H 80	1X10T
TELISTA PLUS 20	1X10T
TELISTA PLUS 40	1X10T
TELISTA RM 2.5MG	1X10
TELISTA RM 5MG	1X10
TELISTA-80	1X10T
TELISTA-H	1X10T
TELKUM 20	1*10
TELKUM 40	1*10
TELKUM AM TAB	1*10
TELLZY AH TAB 10*10	1*10*TAB
TELLZY AM TAB 10*10	1*10*TAB
TELLZY AM TAB 80MG 10*10	1*109*TAB
TELLZY CH TAB 40MG 10*10	1*10*TAB
TELLZY CH TAB 80MG 10*10	1*10*TAB
TELLZY H TAB 10*10	1*10*TAB
TELLZY MT TAB 25MG 10*10	1*10*TAB
TELLZY MT TAB 50MG 10*10	1*10*TAB
TELLZY RS TAB 10*10	1*10*TAB
TELLZY TAB 20MG 10*10	1*10*TAB
TELLZY TAB 40MG 10*10	1*10*TAB
TELLZY TAB 80MG 10*10	1*10*TAB
TELLZY TAB 80MG 5*10	1*10*TAB
TELMA 20 TABLET	1X15
TELMA 20MG TAB	1X10
TELMA 40 TABLET	1X15
TELMA 80 MG TABLET	1X15
TELMA AM 80 TABLET	1X10
TELMA AM 80 TABLET	1X15
TELMA AM TAB	1X10
TELMA AM TABLET	1X15
TELMA AMH 40 TABLET	1X10
TELMA AMH 80 TABLET	1X10
TELMA CT 40 TABLET	1X10
TELMA H 80 MG TABLET	1X10
TELMA H 80 MG TBALET	1X15
TELMA H TAB	1X10
TELMA H TABLET	1X15
TELMA R 2.5 MG TABLET	1x10
TELMA R 5MG TAB	1X10
TELMAXX 25 MG TABLET	1X10
TELMAXX 25MG	1X10
TELMAXX 50 MG TABLET	1X10
TELMAXX 50MG	1X10
TELMED AH 80 TABS	10'S
TELMED AH TABS	10 'S
TELMED BETA 25 TABS	10'S
TELMED BETA 50	10'S
TELMED CT TABS	10'S
TELMED H 80 TABS	10'S
TELMED- 20 MG TABS	10'S
TELMED- 40 MG TABS	10'S
TELMED- 80 MG TABS	10'S
TELMED-AM TABS	10'S
TELMED-H TABS	10'S
TELMEDAY AM TAB	1x10
TELMEDAY H TAB	1x10
TELMICHEK 40	1*10
TELMIDAY 20 TAB	1x10
TELMIDAY 40 TAB	1x10
TELMIDAY H TAB	1x10
TELMIKAA 20	10*10
TELMIKAA 40 MG TABLET	1X10
TELMIKAA H TABLET	1X10
TELMIKIND 20 TAB 6*10	1*10*TAB
TELMIKIND-40 TAB 12*10	1*10TAB
TELMIKIND-80 TAB 6*10	1*10TAB
TELMIKIND-AM TAB 6*10	1*10TAB
TELMIKIND-AMH TAB 3*10	1*10TAB
TELMIKIND-H 80 TAB 3*10	1*10TAB
TELMIKIND-H TAB 6*10	1x10xTab
TELMINORM AM TAB 40/5 10*10	1x10xTab
TELMINORM H TAB 10*10	1x10xTab
TELMINORM TAB 20MG 10*10	1*10*TAB
TELMINORM TAB 40MG 10*10	1x10xTab
TELMITECH-H TAB	1*10
TELMIVAS 20 TABLET	1X10
TELMIVAS 40 TABLET	1X10
TELMIVAS 80 TABLET	1X10
TELMIVAS AM TABLET	1X10
TELMIVAS H TABLET	1X10
TELMIWEN-40TAB	1*10
TELMIWEN-H TAB	1*10
TELPRES AM TAB 10*10	1x10xTab
TELPRES AM TAB 80MG 10*10	1*10*TAB
TELPRES AMH TAB 10*10	1*10*TAB
TELPRES H 80 TAB 10*10	1*10*TAB
TELPRES H TAB 40MG 10*10	1x10xTab
TELPRES MT TAB 25MG 10*10	1*10*TAB
TELPRES MT TAB 50MG 10*10	1*10*TAB
TELPRES TAB 20MG 10*10	1x10xTab
TELPRES TAB 40MG 10*10	1x10xTab
TELROSE TAB 3*10	1*10*TAB
TELSAR 20	1X10
TELSAR 40	1X10
TELSAR 80	1X10
TELSAR 80 H	1X10
TELSAR A	1X10
TELSAR BETA 25	1X10
TELSAR BETA 50	1X10
TELSAR H	1X10
TELSARTAN ACTIV-20 1*30	1*30TAB
TELSARTAN ACTIV-40 1*30T	1*30TAB
TELSARTAN ACTIV-80 1*30T	1*30TAB
TELSARTAN ACTIV-AM 1*30T	1*30TAB
TELSARTAN ACTIV-AM80 1*30T	1*30TAB
TELSARTAN ACTIV-H TAB 1*30T	1*30TAB
TELSARTAN ACTIV-H80 1*30T	1*30TAB
TELSARTAN TRIO TAB 1*30	1*30TAB
TELSARTAN-20 TAB 10*15	1*15TAB
TELSARTAN-40 TAB 10*15	1*15TAB
TELSARTAN-80 TAB 10*10	1x10xTab
TELSARTAN-AM TAB 10*10	1x10xTab
TELSARTAN-AM80 TAB 10*10	1*10TAB
TELSARTAN-H 80 TAB 10*10	1x10xTab
TELSARTAN-H TAB 10*15	1*15TAB
TELSITE 20MG	1X10T
TELSITE 40MG	1X10T
TELSITE 80MG	1X10T
TELSITE AM TAB	1X10T
TELSITE H 40+12.5MG	1X10T
TELTOR AV TAB	1x10
TELUZINE TAB	1X10
TELVAS 3D	1X10T
TELVAS 40	1X10T
TELVAS 80MG	1X10T
TELVAS AM	1X10T
TELVAS AM 80/5MG	1X10 TAB.
TELVAS BETA 25	1X10 TAB.
TELVAS BETA 50	1X10 TAB.
TELVAS H 80/12.5MG	1X10T
TELVAS-20	1X10T
TELVAS-H 40/12.5MG	1X10T
TEMFIX D TAB 325/50MG 10*10	1*10*TAB
TEMPTAL 650MG TAB	1x10
TEMPTAL DROP	15ML
TEMPTAL FOTRE SYP	60ML
TEMPTAL PD SYP	60ML
TEMPTAL TAB	10'S
TEMSAN 20MG TAB	1x10
TEMSAN 40MG TAB	1x10
TEMSAN H TAB	1x10
TENNIS ELBOW	1 PCS
TENNIS ELBOW BRACE	1 PCS
TENNIS ELBOW(S/M/L)	1 PCS
TENO TAB 25MG 10*14	1x14xTab
TENO TAB 50MG 10*14	1x14xTab
TENOCAB TAB 50MG 10*10	1*10*TAB
TENOCHEK TAB 50MG 10*10	1x10xTab
TENOF TAB	1X10
TENOLOL AM TAB 25MG 10*10	1x10xTab
TENOLOL AM TAB 50MG 10*10	1x10xTab
TENOLOL TAB 100MG 10*14	1x14xTab
TENOLOL TAB 12.5MG 20*14	1x14xTab
TENOLOL TAB 25MG 20*14	1*14*TAB
TENOLOL TAB 50MG 20*14	1*14*TAB
TENOMAC 100	1X14T
TENOMAC 12.5 MG	1X14
TENOMAC 25 MG	1X14
TENOMAC 50 MG	1X14
TENORIC TAB 100MG 10*10	1x10xTab
TENORIC TAB 25MG 20*10	1*10*TAB
TENORIC TAB 50MG 20*10	1*10*TAB
TENORMIN TAB 100MG 10*14	1x14xTab
TENORMIN TAB 25MG 28*14	1x14xTab
TENORMIN TAB 25MG 60*14	1*14*TAB
TENORMIN TAB 50MG 60*14	1*14*TAB
TENOTIF 500MG	1*7
TENOVATE CREAM	15GM
TENOVATE NM CREAM	10GM
TENOVATE OINT	15GM
TENOVATE SKIN CREAM	30GM
TENOVATE-GN CREAM	10GM
TENOVATE-M CREAM	15GM
TENPOSE-40 SR TAB 4*10	1*10TAB
TENSYN AZ TAB	1X10
TENSYN PLUS TAB	1X10
TENTAX FORTE 10*10	1x10xCap
TENTAX ROYAL CAP 10*10	1x10xCap
TENVIR TAB	30'S
TENVIR-L	1X30
TERALFA-1MG TAB	1X10
TERBEST CREAM	15G
TERBEST DUSTING	15G
TERBEST TABS	7'S
TERBICIP CREAM	10GM
TERBICIP TAB	7'S
TERBIKEM 250MG	1X7T
TERBIKEM CREAM	1X10GM
TERBINAFORCE CREAM 10GM	1*10GM
TERBINAFORCE PLUS CREAM 15GM	1*15GM
TERBINAFORCE TAB 1*7	1*7TAB
TEREX ANTI COLD TAB	1X10
TEREX EXPCETORANT	100ML
TEREX KID 60ML	60ML
TEREX-B.S SYP	100ML
TERFEX SYP	100 ML
TERFEX TAB	1*10
TERFLOX 100DT TAB	1*10
TERFLOX 200MG TAB	1*10
TERFLOX 400MG TAB	1*10
TERFLOX 60ML SYP	1*60ML
TERFLOX EYE DROP	1*5ML
TERFLOX OZ SYP	1*30ML
TERFLOX OZ SYP 60ML	1*60ML
TERFLOX OZ TAB	1*10
TERICOX TAB.	1X10 TAB.
TERLISTAT INJ 1MG	10 ML
TERLYZ	VIAL
TERMIKIT TAB	1X4
TERMIN 10ML	1 VAL
TERMIPIL	1X1T
TEROL 1MG TAB	10'S
TEROL 2MG TAB	10'S
TEROL LA -4	10'S
TEROL LA-2 CAP.	10'S
TERPECT COLD EXP SYP 100 ML	1
TERPECT COLD TAD	1x10
TERPECT EXP	1x100ML
TERPHYLATE SYP	1X100ML
TERPHYLATE SYP	1X200ML
TERRACORT EYE OINT.	1x3 GM.
TERRAMYCIN 500MG	1*10
TERRMYCIN SF CAP.	1x4
TERVAN-250TAB	1*7
TERZO TAB	1X10
TESS OINT	1TUBE
TEST TUBE	
TEST TUBE	1 PCS
TEST TUBE (BOROSIL)	1 PCS
TEST TUBE HOLDER	
TEST TUBE HOLDER	1 PCS
TEST TUBE STAND	1 PCS
TESTOCAL TAB	1*10
TESTOVIRON DPT INJ 250MG	1x1xMl.
TETAN AM TAB 10*10	1*10*TAB
TETAN AV TAB 10*10	1*10*TAB
TETAN BETA TAB 25MG 10*10	1*10*TAB
TETAN BETA TAB 50MG 10*10	1*10*TAB
TETAN CT 12.5 MG TAB 10*10	1*10*TAB
TETAN CT 6.25MG TAB 10*10	10*10*TAB
TETAN H TAB 10*10	1*10*TAB
TETAN R TAB 2.5MG 1*10	1*10*TAB
TETAN R TAB 5MG 10*10	1*10*TAB
TETAN TAB 20MG 10*10	1*10*TAB
TETAN TAB 40MG 10*10	1*10*TAB
TETAN TAB 80MG 5*10	1*10*TAB
TETGLOB INJ 250MG	1x1xVl.
TETGLOB INJ 500MG	1x1xVl.
TETGLOB-1GM INJ	1*1VAIL
TETMOSOL SOAP 1'S	
TETNUS TOXIDE ING.IP (5ML VIL.)	1 BOX
TETRA	1 PCS
TETRA 30CM*30CM*12PLY T-17	1 PCS
TETRA BOLUS.	1x4B
TETRA(MOP)	1 PCS
TETRA-Z BOLUS	SE7-183
TETRA-Z INJ. 30ML	10X30ML
TETRACIN EYE OINT.	1x3 GM.
TETRACOX TAB.	1x10
TETRACYCLIN HCL W.S.100GM	1x5
TETRACYCLINE BOLUS	1x4B
TETRACYCLINE POWD 100 GR	100 GR
TETRACYCLINE.250MG.TAB	1X10
TETRAFOL PLUS TAB 5*10	1*10TAB
TETRAFOL TAB 3*10	1*10TAB
TETRAKAL FORTE BOLUS.	1x2B
TETRALID	30 GM
TETVAC DANO AMP	1*1
TETVAC VAIL	1*1
TEVANSI 2.5 GM.	VIAL
TEXAKIND INJ 4*5ml	1x5xMl.
TEXAKIND MF TAB 3*10	1x10xTab
TEXAKIND TAB 3*10	1x10xTab
TEXOPLAN INJ 400 MG	1 VIL
TG GOAL TAB 10*10	1x10xTab
TG GOAL TAB 5*10	1*10*TAB
TG-CARE TAB.	1X10
TG-TOR F	1X10
TG-TOR-10	1X10
TG-TOR-20	1X10
TG-TOR-40	1X10
TG-TOR-5	1X10
TG-TOR-EZ	1X10
TGCEF 125MG	VAIL
TGCEF 500MG	VAIL
TGCEF-TZ-1.125G	1X1VAIL
TGR TAB 5*10	1x10xTab
THALI-SET	1X1
THALITAL LS TAB 5*10	1*10TAB
THALITAL-40 TAB 5*10	1*10TAB
THANK OD CREAM	1x30 GM
THANK OD TAB	1x7
THARLIV 200ML	200ML
THARMAMETER DIGITAL	1PIEC
THARMAMETER HICKS (OVAL)	1
THEE WAY STOP COCK (POLYMED)	1 PCS
THEMIBUTOL 1000 (10*10)	1*10
THEMIBUTOL 200 TAB	1x10
THEMIBUTOL 400 (10*10)	1*10
THEMIBUTOL 600 MG. TAB.	1x10
THEMIBUTOL 800 MG.TAB	1x10
THEMIBUTOL PLUS TAB.	1x10
THEMIFLU 150	1X1
THEMIS CALCIAM	1*60
THEMIS MULTIVITAMIN	1*60
THEMOX BOLUS	1 STRIP
THEO ASTHA TAB	1X10
THEO ASTHALIN SR	10'S
THEO ASTHALIN TAB	1X30T
THEO-SAL TAB	1x10
THEOASTHALIN FORTE	10'S
THEOASTHALIN SYR	100ML
THEOASTHALIN TABS	10'S
THEOBID 200 TABS	15'S
THEOBID D TAB	10'S
THEODAY 400 TABS	10'S
THEORESP PLUS 400 TAB 10*10	1x10xTab
THEORESP PLUS 600 TAB 10*10	1x10xTab
THEOSELHEXIN SYP	1x100ML
THERMAL-S SYP	1x60xMl.
THERMO-BEST 50GM	50GM
THERMOKIND MOUTH WASH 100ML	1x100xMl.
THERMOKIND-F GEL 1*100GM	1x100xGm.
THERMOKIND-F GEL 1*50GM	1x50xGm.
THERMOKIND-F KID GEL 50GM	1*50GM
THERMOMETER ACCUSURE DIGITAL	1 PCS
THERMOMETER DIGITAL	1 PCS
THERMOMETER DIGITAL (ASPEN)	1 PCS
THERMOMETER DIGITAL MOREPEN	1 PCS
THERMOMETER OVAL	1 PCS
THERMOS FLASK [EAGLE]	1*1
THERMOVET 30ML	VAIL
THETOP 1200	1 VAIL
THI-OD TAB 5*10	1*10
THIABION AMP	5*2ML
THIACAL 450 ML	450 ML
THIAMIN	1X2ML
THIAZIDE 12.5MG	1X60S
THIAZIDE 25 MG	1X60S
THIAZIDE R	1X10T
THIOACT 4	1X10
THIOACT 8	1X10
THIOACT D4	1X10S
THIOACT D8	1X10T
THIOCECLO 4	1X10T
THIOCECLO 8	1X10T
THIOCECLO SR 16MG	1X5 TAB.
THIOCECLO SR 8MG	1X5T
THIOFREE-4	1X10
THIOFREE-8	1X10
THIOLEX 4MGTAB	1X10
THIOLEX-AP TAB	1X10
THIOLYN INJ 500MG	1 VIL
THIORELAX 4MG	1X10T
THIORELAX 8MG	1X10T
THIORIL-10	1X10T
THIORIL-25 TAB	1X10
THIORIL-50MG TAB	1X10
THIOSOL 500 MG	1 VIL
THIOX OD CAP 16MG 10*5	1*5*CAP
THIOX OD CAP 8MG 10*5	1*5*CAP
THIPEN 500 MG INJ	1 VIL
THOMOXX E/D	1*5ML
THORMONE 100	1X100T
THORMONE 25	1X100T
THORMONE 50	1X100T
THRE TABLETS	1x4 TAB
THREE WAY STOP COCK	1 PCS
THREOMOX-333LB CAP	60ML
THREPTIN DISKETS	1x275 GM
THREPTIN MICROMIX	1x200 GM
THREPTIN SYRUP	1x120 ML
THRILPIL	1X10T
THRIVE	1*10
THRIVE CV	1*10
THRIVE G CAP	1X10
THRIVE RD	1SAC
THROMBOFOB OINTMENT	1x20xGm.
THROMBOSOLV 15 LAC IU	1 VIL
THUMB SPICA SPLINT	1 PCS
THUMB SUPPORT	1 PCS
THUNDERBOLT 50 TAB 1*4	1*4
THYOBUILD 100	1X100 TAB.
THYROCAB TAB 10MG	1x100xTab
THYROCAB TAB 20MG	1x100xTab
THYROCAB TAB 5MG	1x100xTab
THYROCAL D3 TAB 1*30	1*30*TAB
THYRONORM TAB 100MG	1x100xTab
THYRONORM TAB 12.5MCG	1*50*TAB
THYRONORM TAB 125MG	1x100xTab
THYRONORM TAB 150MG	1*100*TAB
THYRONORM TAB 25MG	1x100xTab
THYRONORM TAB 50MG	1x100xTab
THYRONORM TAB 75MCG	1*100*TAB
THYRONORM TAB 88MCG	1*100*TAB
THYROPIL 100MCG	1X30T
THYROPIL 25MCG	1X30T
THYROPIL 50MCG	1X30T
THYROTOP TAB 100MG 3*30	1*30*TAB
THYROTOP TAB 25MG 3*30	1*30*TAB
THYROTOP TAB 50MG 3*30	1*30*TAB
THYROUP 100	1X100T
THYROUP 12.5MCG	1X50TAB
THYROUP 125	1X100T
THYROUP 150MCG	1X100
THYROUP 175MCG	1X100TAB
THYROUP 200MCG	1X100T
THYROUP 25	1X10T
THYROUP 50	1X100T
THYROUP 75	1X10T
THYROUP 88MCG	1X100T
THYROWEL CAP 10*10	1x10xCap
THYROX 100	1X100T
THYROX 12.5	1X100T
THYROX 125	1X100T
THYROX 150	1X100T
THYROX 200	1X100T
THYROX 25MCG	1X100T
THYROX 50MCG	1X100T
THYROX 75	1X100T
THYROX 88	1X100T
TIAPREX-100 TAB 10*10	1*10TAB
TIAPREX-25 TAB 10*10	1*10TAB
TIAPREX-50 TAB 10*10	1*10TAB
TIATE INHALER	1XINH
TIATE TRANSCAPS	1X15C
TIBOFEM TAB	14'S
TIBROLIN TAB.	1X10T
TICIN GEL 20GM	20gm
TICIN 250MG TAB	1X15
TICINEX KID.	1x10
TICINEX TAB.	1x10
TICKOUT 15 ML	15 ML
TICKOUT 50 ML	50 ML
TICOGEM 400 INJ	1XVIAL
TICOGINA GEL	1X5GM
TICSTOP TAB 3*10	1*10TAB
TIDE 10	1X10T
TIDE 20	1X10T
TIDE 5	1X10T
TIDE PLUS 10	1X10T
TIDE PLUS 20	1X10T
TIDILAN 10 MG. TAB	1x30
TIDILAN 20 MG. TAB	1x30
TIDILAN INJ.	1 AMP.
TIDILAN RETD. TAB	1x10
TIDO TAB 1*10	1*10
TIDOMET FORTE	1X10T
TIDOMET LS	1X10T
TIDOMET PLUS	1X10T
TIECAAZ	1 VIL
TIGEZ IV	1XV
TIGIPRIME	1 VAL
TIK-TIK TAB	1X1
TIK-TIK-SUSP	1X10
TIK-TIK.SUSP	1X10ML
TIKKIL 50ML	
TIKKIL-15ML	PH
TIKKIL-5GM	POWDER
TIKKIL-POWER 30ML	1X30ML
TIKOPREX TAB 250MG 1*10	1*10*TAB
TILOX 5GM.	TUBE
TILSTIGMIN AMP	1AMP
TILVIT INJ	10ML
TIMCYN 3.1GM INJ	1 VAIL
TIMO-5 E/D	1*5ML
TIMOBLU 0.5%	1X1
TIMOL-P	1*5ML
TIMOLAST 0.5% E/D	1*5ML
TIMOLET 0.05%	1*5ML
TIMOLET GFS 3ML DROP	1*3ML
TIMOLET OD DROP	1*5ML
TIMOLET PLUS DROP	1*5ML
TIMOPRESS DROP	5ML
TIMORITE E/D	1*5ML
TIMOX DP	1
TIMPOL 100 GM.	100 GM.
TIMPOL 100GM	PH
TINACAL DS	1 LTR
TINACAL DS 5LITERS	5LITERS
TINACAL INJ.	30ML
TINADERM M CREAM	1 TUBE
TINADERM SOLUTION	1X20 ML
TINAFIN GEL	1 TUB
TINAMIDE	1x10TAB
TINAPHOS 30ML	30 ML
TINCTURE BENZOIN 50 ML	50 ML.
TINCTURE IODINE 15ML	15 ML.
TINDIFLOX 30ML SYP	30ML
TINDIFLOX TAB 1*10	1*10
TINI-V	1X6
TINIBA I.V.400ML	1x400xMl.
TINIBA TAB 300MG 20*10	1x10xTab
TINIBA TAB 500MG 20*10	1x10xTab
TINICIP-DS TAB 10*10	1x10xTab
TINICLINE TAB 1*10	1*10
TINIDAZOLE TAB 500MG	1x10
TINIFAS TAB	1X10
TINILOX DS 1*10	1*10
TINILOX MPS SUP 60ML	60ML
TINILOX-MPS TAB	20*10
TINIPHOS 30ML	1X30ML
TINIPIDI ISOTONIC 400ML	400ML
TINKU TULSI SYU	100ML
TINNICAR CAP	1*10
TINOBAR TAB	1X10T
TIOGTAT 5 GM	
TIOGTAT 5 GM	
TIOGTAT 5 GM	
TIOMATE INHALER	1X1
TIOMATE TRANSCAPS	1X15C
TIOSTAT-5 GM	1*10
TIOVA INHALER	120MD
TIOVA MULTIHALER	30 DOSE
TIOVA ROTACAPS	15 CAP
TIPRIM SYP	
TIROFUSE INJ 5MG	1X100ML
TIROMAC	1X10S
TISOL 200 MG	1X10T
TISOL 400MG	1X10
TISOL EYE DROP	1PH
TITER SUSP.	1X220 ML.
TITROL OINT.	1X20GM
TIVEZ SUSP.	1*30ML
TIVEZ TAB	1*10
TIXOR - O 200 DT	1X10
TIXYLIX SYP 60ML	1x60xMl.
TIZADIC TAB	1X10
TIZALIDE	1X10S
TIZAN 2 TAB 10*10	1*10TAB
TIZIPA TAB.	1x10
TIZIPA-DP TAB.	1x10
TIZPA N TAB	1x10
TIZU TAB.	1x10
TOALIN - E	100 ML
TOBA DROP 5ML	1*5ML
TOBA-DM LOTION 5ML	1*5ML
TOBA-F DROP	1*5ML
TOBACIN 20MG INJ	VIAL
TOBACIN 60MG INJ	VIAL
TOBACIN 80	1XV
TOBACIN EYE/EAR DP	1X5ML
TOBACIN-F EYE DROP	5ML
TOBARACEF	1 VAL
TOBAREN-D	10ML
TOBASTAR DROP	1x5xMl.
TOBASTAR-F DROP	1x5xMl.
TOBRA-D..DROP	IPH
TOBRA.EYE.DROP	1PH
TOBRANEG 20MG INJ	1.5ML
TOBRANEG 60MG INJ	1.5ML
TOBRANEG 80MG INJ	1.5ML
TOBRANOIR E/E DROP	1x5ML
TOBRANOIR(D)E/E DROP	1x5ML
TOBRASONE E/D	1*5ML
TOBREX 2X E/D	1*5ML
TOBREX E/D	1*5ML
TOCEF - O DRY SYU	30ML
TOCIN D EYE DROP	1x5 ML.
TOCIN D OIT	1X5MG
TOCIN EYE DROP	1x5 ML.
TOCIN F DROP	1X5ML
TOCOFER-400 CAP	1X10C
TOCOTRIO CAP	1*10
TOFE C I CAP	1X10
TOFE C I SUSP	200ML
TOFF M 60ML SYU	1PH
TOFF T 30ML SYU	1PH
TOFF-M 30 ML SY	1
TOFF-OR 30ML	1
TOFF-OR 60ML	1
TOFF.30ML.SYU	1PH
TOFF.60ML.SYU	1PH
TOFLOX 200 TAB	1X10
TOFLOX-OZ TAB	1X10
TOKO TAB.	1x10
TOLAZ 10	1X10T
TOLAZ 2.5	1X10T
TOLAZ 5	1X10T
TOLAZ 7.5	1X10T
TOLAZ O.S.	1X60ML
TOLAZ SPRINKLE	1X1GM
TOLAZ-MD 10	1X10T
TOLAZ-MD 2.5	1X10T
TOLAZ-MD 5	1X10T
TOLAZ-MD 7.5	1X10T
TOLCONTIN-2 TAB 5*10	1*10TAB
TOLCONTIN-4 TAB 5*10	1*10TAB
TOLIFAST 150	1X10T
TOLIFAST SR 450MG	1X10T
TOLKEM	1X10 TAB.
TOLKEM 450 SR	1X6 TAB.
TOLKEM T	1X10 T
TOLOL AM 25MG	1X10
TOLOL AM 50	1X10
TOLOL H 50	1X10
TOLOL XR 100MG TAB	1X10
TOLOL XR 12.5MG TAB	1X10
TOLOL XR 25MG TAB	1X10
TOLOL XR 50MG TAB	1X10
TOLPERITAS-100 TAB 10*10	1*10TAB
TOLPERITAS-150 TAB 10*10	1*10 TAB
TOLPERITAS-50 TAB 10*10	1*10 TAB
TOLPERITAS-SR 450 TAB 3*10	1*10TAB
TOLPIDOL 150	1X10
TOLPIDOL PLUS	1*10
TOLZAN F 1 LIT.	1 LIT.
TOLZAN F 90 ML.	90 ML.
TOLZAN PLUS 1LITT	PH
TOLZAN-F BOLUS	1X3'S
TOMALOX INJ.3GM	1X3GM.
TOMALOX INJ.4GM	1X4GM
TONACT 10	1X15T
TONACT 10 MP	1X30T
TONACT 20	1X15T
TONACT 40	1X10T
TONACT 5	1X10T
TONACT 80	1X10T
TONACT ASP 75	1X10C
TONACT D	1X10 TAB.
TONACT D 20	1X10 TAB.
TONACT FORTE TAB	1X10
TONACT PLUS TAB	1X10
TONACT TG	1X10T
TONACT TG 20	1X10T
TONACT TM	1X10T
TONACT-ASP 75------------	1X10C
TONACT-EZ	1X10T
TONACT-Q CAP	1X10
TONCYP SYP 200ML	200ML
TONENGLO F/WASH 50GM	1*50GM
TONGUE DEPRESSOR LARGE	1 PCS
TONGUE DEPRESSURE SMALL	1 PCS
TONOFERON DROP	1 PH.
TONOFERON PED.100ML SYP.	100 ML.
TONOFERON SF CAP	1X10CAP
TONOFERON SYP.200 ML.	1 PH.
TONOFERRON 400 ML.	1 PH.
TONOLIV -DS SYP	1x200ML
TONOLIV DS	200ML
TONOLIV SYP	1x100ML
TONOLON INJ. 30ML	1X30ML
TONOPHOSPHAN 10 ML VIAL	1x10
TONOPHOSPHAN 30 ML VIAL	1x30
TONOPHOSPHAN 5ML AMP.	5X5ML
TONORICIN 30ML.	VIAL
TONOZYME-100ML	100ML
TONOZYME-SYP	200ML
TOOTH BRUSH	1X1
TOOTH/PLAN FORCEPS 4"	1 PCS
TOOTH/PLANE FORCEP 6"	1 PCS
TOOTH/PLANE FORCEP 8"	1 PCS
TOP-OR 30ML	1
TOP-S 40 TAB 10*10	1*10TAB
TOPAAZ-100 TAB 10*10	1x10xTab
TOPAAZ-200 TAB 10*10	1x10xTab
TOPAAZ-25 TAB 10*10	1x10xTab
TOPAAZ-50 TAB 10*10	1x10xTab
TOPACT-B 1*10	1*10
TOPCEF 100DT TAB	1X10
TOPCEF 200 DT	1X10T
TOPCEF CLAV 200	1X6T
TOPCEF INSTA-USE	1X30ML
TOPCEF-50 DT	1X10T
TOPCERIN	1X10C
TOPCID-20 TAB	1X14
TOPCID-40MG TAB	1X14
TOPCID-40MG TAB 14'S	
TOPDOM CAP 10*10	1x10xCap
TOPEMA-25	1X10T
TOPEMA-50	1X10T
TOPEX BR	1*1
TOPEX CS	1*1
TOPGEM	1X5T
TOPICURE GEL	10GM
TOPICURE GEL	50 GMS
TOPICURE SPRAY	250 ML
TOPICURE SPRAY	75 ML
TOPIFORT NX SOLN	1PH
TOPIN E/D	1*3ML
TOPINAC 100MG TAB	10'S
TOPINAC P TAB	10'S
TOPINATE OINT	30 GM
TOPINATE- GEL	1'S
TOPIROL 25 TAB 10*10	1*10TAB
TOPIROL 50 TAB 10*10	1*10TAB
TOPISAL 6% LOTION	30ML
TOPISAL OINT	1'S
TOPISAL-3% LOTION	30ML
TOPISAL-3% OINT	1'S
TOPKOF SYP	1 PH
TOPLIV 200 ML	200ML
TOPMIN SUPREME	11KG
TOPMIN SUPREME	1KG
TOPNAC - MR TABS	10'S
TOPNAC- SR TABS	10'S
TOPOL XL 100	1X10T
TOPOL XL 25	1X10T
TOPOL XL 50	1X10T
TOPQUIN OZ TAB 10*6	1x6xTab
TOPQUIN-200 TAB 10*10	1x10xTab
TOPRAZ 40MG	1 VAL
TOPUP-D TAB	1X10
TOR-10 TAB 10*10	1x10xTab
TOR-20 TAB 5*10	1x10xTab
TORBEX-T SYU	
TORCAL SYU	200ml
TORCH	1 PCS
TORCH-SHEL	1X1
TORCOF 100ML	1PH
TORCOXIA 120MG TAB	1X10
TORCOXIA 60MG TAB	1X10
TORCOXIA 90MG TAB	1X10
TORCOXIA BCD 90	1X10T
TORDEX 60ML SYU	60ml
TORDEX SUGAR FREE	100ml
TORDEX.100ML.SYU	1PH
TORDRYL 100ML COUH SY	1
TORDYL 150ML	150ml
TORDYL.50MLSYU	1PH
TOREST 25 TABLET	1X10
TOREST 50 TABLET	1X10
TOREX ACTIVE 100 ML	100ML
TOREX DROP	15ML
TOREX 150 ML	150ml
TOREX ACTIVE 150ML	150ml
TOREX BR 100ML	1x100ML
TOREX COLD TAB	1x10
TOREX MINT 100ML	1PH
TOREX SF	
TOREX TOTAL TAB	1X10
TOREX+COUGH 100ML	1PH
TOREX-AP 100ML	1 PH
TOREX-AP 50 ML	1 PH
TOREX.BR.50ML	1PH
TOREX.JUNIOR.60ML	1PH
TOREX.PLIN.100.ML	
TOREX.PLIN.50ML.	
TOREX.TAB	
TORGET PLUS TAB 10MG 3*10	1*10*TAB
TORGET TAB 100MG 3*10	1*10*TAB
TORGET TAB 10MG 10*10	1*10*TAB
TORGET TAB 20MG 10*10	1*10*TAB
TORGET TAB 5MG 3*10	1*10*TAB
TORGLY SYU	1PH
TORLACTONE 10 TAB 5*10	1*10TAB
TORLACTONE 5 TAB 5*10	1*10TAB
TORLEVA 250	1X10T
TORLEVA 500	1X10T
TORLEVA SY	1X100ML
TORLEVA XR 1000	1X10T
TORLEVA XR 500	1X10T
TORLIN-BR SYP	1x100ML
TORLINCTUS BM 100ML	100ml
TORLINTUS PD	30ml
TORLINTUS SYU	100ML
TORMINIC SYU	60ml
TOROSCET DROP	1PH
TOROSPAR-200MG TAB	1X6
TOROXX A TAB	1X10T
TOROXX AP TAB	1X10
TORSID 10	1X10T
TORSID 100MG TAB	1X10
TORSID 20MG TAB	1X10
TORSID 5MG TAB	1X10
TORSID INJ	2ML
TORSID PLUS 10/50	1X10T
TORSID PLUS 20/50	1X10T
TORSID PLUS 5/50	1X10T
TORSIKIND-10 TAB 6*10	1x10xTab
TORSIKIND-20 TAB 3*10	1x10xTab
TORVATE 200	1X10T
TORVATE 300	1X10T
TORVATE 500	1X10T
TORVATE CHRONO 200MG	1X10T
TORVATE CHRONO 300MG	1X10T
TORVATE CHRONO 500MG	1X10T
TORVIT DROPS 30 ML	1 PH
TORZYME SYP 200ML	1 PH
TORZYME SYRUP 100ML	1 PH
TORZYME.DROP.	1PH
TOSSEX DMR SYP	1x100xMl.
TOSSEX SYP	1x100xMl.
TOTALDERM CREAM	1X10GM
TOTALGEM DROPS	15ML
TOTALGEM TAB	1*10
TOTAVIT STONG 5KG	5KG
TOTAVIT STRONG CHELATED	1 KG
TOTLADERM PLUS CREAM	1X15GM
TOURNICATE	1 PCS
TOVAXO E/D	1*2.5ML
TOVAXO T	2.5ML
TOVOK CAP 10*10	1x10xCap
TOWEL (BIG)	1 PCS
TOWEL (SMALL)	1 PCS
TOWEL CLIP (FORCEP)	1 PCS
TOX TAB	1x10TAB
TOX EXP.	1X100ML
TOXILIV (FEED) 500ML	500ML JAR
TOXILIV 1LT	1x1lt
TOXIMAR 5 KG	5 KG
TOXOL 1LT	1LT
TOXOL 30ML	VAIL
TOXOL 500ML	500ML
TOXOL INJ.100ML	1X100ML
TOXOL-C 110ML	PH
TOZAAR 25	1X10T
TOZAAR H TAB	1X10
TOZAAR-50	1X10T
TOZAM TAB	1X10T
TPRIM SYP	1PH
TQNIN SYP	1X60ML
TQNIN300MG TAB	1X10
TR PHYLLIN 125MG	1X10C
TR PHYLLIN 250MG	1X10S
TRABEST	1X10T
TRABEST++++++++++++++++++	1X10T
TRAC 3	1X6T
TRAC 4	1X6S
TRACETA INJ	1X2ML
TRACETA TAB	1X10T
TRACFREE TAB 10*10	1*10*TAB
TRACHESTOMY TUBE 4.5	1 PCS
TRACHESTOMY TUBE 5	1 PCS
TRACHESTOMY TUBE 6	1 PCS
TRACHESTOMY TUBE(C) 7"	1 PCS
TRACHESTOMY TUBE(C) 7.5"	1 PCS
TRACHESTOMY TUBE(C) 8"	1 PCS
TRACHESTOMY TUBE(C) 9"	1 PCS
TRACTION HANGER	1 PCS
TRACTION KIT	1 PCS
TRALIN 50	1X10T
TRAM PROXYVON CAP 6*8	1*8CAP
TRAMADOL(DOLUS) 2ML	1 AMP
TRAMAGON AMP	1 AMP
TRAMAGON PLUS	1x10
TRAMAPEN FORTE	1X10S
TRAMASURE PLUS TAB 4*10	1*10TAB
TRAMASURE-100 INJ 4*2ML	1*2ML
TRAMATECH 100ING	1AMP
TRAMATECH PLUS TABLET	1*10
TRAMAZAC CAP 14*10	1x10xCap
TRAMAZAC INJ 100MG 2ML 50*2	1x2xMl.
TRAMAZAC INJ 50MG 1*7AMP	1x7xAmp
TRAMAZAC P TAB 10*10	1*10*TAB
TRAMAZAC PD TAB 10*10	1*10*TAB
TRAMAZAC TC TAB 10*10	1*10*TAB
TRAMCT TAB 20*10	1*10
TRAMOT CAP	1X10
TRAMOT ING 2ML AMP	1X2ML
TRAMOT PLUS TAB	1X10
TRANCODOL 10DT TAB 10*10	1x10xTab
TRANCODOL 5DT TAB 10*10	1x10xTab
TRANCODOL INJ 10*1ML	1x1xMl.
TRANCODOL-1.5DT TAB 10*10	1x10xTab
TRANCODOL-LA INJ 1ML	1x1xMl.
TRANEMIC INJ 500MG	5 ML.
TRANEXAMIC ACID INJ	1 AMP
TRANFIB 500MG INJ.	5ML
TRANGGULAR BANDAGE	1 PCS
TRANLOK 500MG INJ	5ML
TRANLOK 500MG TAB	1X10
TRANLOK-E TAB	1X10T
TRANLOK-M TAB	1X10T
TRANOMAC 500	1X10T
TRANOMAC INJ.	1X5 ML.
TRANOMAC MF	1X6TAB.
TRANOSTAT AMP	1AMP
TRANOSTAT INJ	1 AMP
TRANOSTAT MF TAB	1x6
TRANOSTAT TAB	1x10
TRANSDOL 100MG	1X10T
TRANSDOL 50MG.	1X10T
TRANSPACER	1X1
TRANSPACER-V	1XSET
TRANSPARENT PE TAPE3	1 PCS
TRANSPARENT TAPE 5.0CMX9.1M	1 PCS
TRANSPORE 1"	1 PCS
TRANSPORE 2"	1 PCS
TRANSPORE 3"	1 PCS
TRANXI TAB	1*10
TRAP INJ	1*2ML
TRAP INJ	1*2ML
TRAPAUS TAB	1X10
TRAPEX 2 TAB 20*10	1*10TAB
TRAPEX-1 TAB 10*10	1*10TAB
TRAPIC 500 TAB 10*10	1*10TAB
TRAPIC 500 TAB 5*10	1*10TAB
TRAPIC INJ 5*1ML	1*1ML
TRAPIC-E TAB 5*10	1*10TAB
TRAPIC-MF TAB 5*10	1*10TAB
TRASINA CAPSULES	1x10
TRAUMANIL Gel	1x30Gram
TRAUMANIL TAB	1X10
TRAVACOM E/D	1*10ML
TRAVATAN E/D	1*2.5ML
TRAVAXO E/D	1*2.5ML
TRAVO EYE DROPS	1X3 ML
TRAVOSUN EYE DROP	1*3ML
TRAX TAB	1x10
TRAXIN D SYP	100ML
TRAXIN JR. SYP	1X60ML
TRAXIN SYP	1X100ML
TRAXMEG INJECTION	5ML
TRAXOCEF O 500	1X4
TRAXOCEF-1GM INJ	VIAL
TRAXOCEF-250MG INJ	VIAL
TRAXOCEF-500MG INJ	VIAL
TRAXOCEF-CS INJ	1GM
TRAXOCEF-O 250MG TAB	1x10
TRAXOCEF-O TAB	1x10
TRAXOCEF-S 1.5GM INJ	VIAL
TRAXOF TAB 10*10	1*10*TAB
TRAXOL CV DRY SYP	1*30*ML
TRAXOL CV TAB 200MG 1*10	1*10*TAB
TRAXOL INJ 125MG	1x1xVl.
TRAXOL INJ 1GM	1x1xVl.
TRAXOL INJ 250MG	1x1xVl.
TRAXOL INJ 500MG	1x1xVl.
TRAXOL O DROP	1x10xMl.
TRAXOL O DT TAB 100MG 10*10	1*10*TAB
TRAXOL O SYP	1x30xMl.
TRAXOL O TAB 200MG 10*10	1x10xTab
TRAXOL S INJ 1500MG	1x1xVl.
TRAXOL S INJ 187.5MG	1x1xVl.
TRAXOL S INJ 375MG	1x1xVl.
TRAXOL S INJ 750MG	1x1xVl.
TRAXOL T HS INJ 500MG	1x1xVl.
TRAXOL T INJ 125MG	1*1*VIAL
TRAXOL T INJ 1GM	1x1xVl.
TRAXOL T KID 250MG INJ	1x1xVl.
TRAXTO 1.5GM	1XVIAL
TRAXTO 375	1XVIAL
TRAY 10*12	1 PCS
TRAZINE-H TAB 15*10	1*10TAB
TRAZINE-S TAB 10*10	1*10TAB
TRAZINE-SC TAB 10*10	1*10TAB
TRAZONIL-1OO TAB 10*10	1x10xTab
TRAZONIL-25 TAB 10*10	1x10xTab
TRAZONIL-50 TAB 10*10	1x10xTab
TRD-CONTIN OD-100 TAB 10*5	1*5TAB
TRD-CONTIN OD-200 TAB 10*5	1*5TAB
TRD-CONTIN TAB 5*10	1x10xTab
TRD-MD TAB 5*10	1x10xTab
TRD-P TAB 10*10	1x10xTab
TREATER 10MG	1X10T
TREATER L	1X10T
TREDAPTIVE-1000/20 TAB 2*7	1*2*7TAB
TREMENDUS-GEL	30GM
TREMENDUS-PLUS	10'S
TREMENDUS-SP TAB	10'S
TREMENDUS-SR TAB	10'S
TRENAXA 500	1X6S
TRENAXA INJ	1X5ML
TRENAXA MF	1X6
TREND XR 250	1X10T
TREND XR 500	1X10T
TRENTAL	5X15ML
TRENTAL 400	1X15T
TRESMOX CV TAB 10*6	1*6*TAB
TRESMOX LB D CAP 10*10	1x10xCap
TRETIVA-10 CAP 1*10	1x10xCap
TRETIVA-20 CAP 10*10	1x10xCap
TRETIVA-25 CAP 10*10	1*10CAP
TRETIVA-5 CAP 10*10	1x10xCap
TREWOR CREAM	1 TUBE
TREWOR PLUS CREAM	1 TUBE
TREX TABS 2.5 MG	10 TAB
TREZAM 1GM ING	1VAIL
TREZAM 2GM ING	1VAIL
TREZAM 500MG ING	1VAIL
TRI-DM-2 TAB	10*1
TRIAMINIC PLUS TAB	1X10
TRIANGULAR BANDAGE	1 PCS
TRIBACT 1.5G	1VIAL
TRIBACT 375	1X1
TRIBACT 750MG INJ	1
TRIBACT-P 1GM ING	1X1GM
TRIBACT-P-250	1X1
TRIBACT-P-500	1X1
TRIBEN TAB 20*10	
TRIBIVET 10 ML.	VIAL
TRIBIVET 30 ML.	VIAL
TRIBIVET 50ML	50 ML
TRIBS-D TAB 1*10	1*10
TRICAINE MPS GEL	1*200*ML
TRICEF XL-200 TAB 10*10	1*10TAB
TRICEF-200 CAP 10*10	1x10xCap
TRICEF-O TAB 10*10	1*10TAB
TRICLAZONE 40 TAB 5*10	1*10TAB
TRICOBAL CAP	10'S
TRICOBOL-OD	10'S
TRICOFIX (7.5CM*1.5)	1 PCS
TRICOFIX 5CM*1M	1 PCS
TRICOFIX JUMBO 7.5* 10 METER	1 ROL
TRICON T TAB	1x10TAB
TRICORT INJ 40MG	1x1xVl.
TRICORT TAB 30*10	1x10xTab
TRICOSILK	60ML
TRICOSILK MAX	1*60ML
TRICOTOL 200ML	1x200ML
TRICOTOL SYP 200ML	1*200ML
TRICOX TAB.	1x10
TRICOZOL DROP	1x5ML
TRIDERM.OIN	1PH
TRIEXER 1 MG TAB.	10'S
TRIEXER 2 MG TAB.	10'S
TRIEXER 3 TAB	10'S
TRIEXER FORT 1	1X10
TRIEXER FORT 2	1X10
TRIFER DROP	1x15xMl.
TRIFER SYP	1x150xMl.
TRIFER TAB 2*15	1x15xTab
TRIFLA CHURNA 120 GM	120 GMS
TRIFLA CHURNA 500 GM	500 GMS
TRIGABANTIN 100 TAB 10*10	1*10TAB
TRIGABANTIN 300 TAB 10*10	1*10TAB
TRIGEM- 1 MG	10'S
TRIGEM- 2 MG	10'S
TRIGLI 1 MG	1X10T
TRIGLI 2MG	1X10T
TRIGLIMESTAR-1 TAB 3*10	1*10TAB
TRIGLIMESTAR-2 TAB 3*10	1*10TAB
TRIGLIMIPREX 1/7.5	1X10T
TRIGLIMIPREX 1MG	1X10
TRIGLIMIPREX 2/7.5	1X10T
TRIGLIMIPREX 2MG	1X10
TRIGLIMISAVE LS 1 TAB 10*10	1*10*TAB
TRIGLIMISAVE LS 2 TAB 10*10	1*10*TAB
TRIGLIMISAVE TAB 1MG 10*10	1*10*TAB
TRIGLIMISAVE TAB 2MG 10*10	1*10*TAB
TRIGLUCORED FORTE TAB 10*10	1*10TAB
TRIGLUCORED-FORT-7.5 TAB 5*10	1*10TAB
TRIGLYCOMET TAB 10*10	1x10xTab
TRIGLYNASE TAB 2MG 10*10	1*10*TAB
TRIGLYNASE V1 TAB 5*10	1*10*TAB
TRIGLYNASE V2 TAB 5*10	1*10*TAB
TRIGUARD MOUTHWASH 100ML	1x100xMl.
TRIGUARD TOOTHPASTE 100GM	1x100xGm.
TRIGULIN 1 MG TABLET	1X15
TRIGULIN 2 MG TAB	1x10
TRIGULIN 2 MG TABLET	1X15
TRIGULIN LD 1 FORTE TAB	1X15
TRIGULIN LD 1MG TABLET	1X10
TRIGULIN LD 2 FORTE TAB	1X15
TRIGULIN LD 2MG TABLET	1X10
TRIGULIN- 1 MG TAB	1X10
TRIKA 0.25	1X15
TRIKA 0.5	1X15
TRIKA-1	1X15
TRIKASE 400MG TAB	1X10
TRIKASE TAB	1X10T
TRILECOLIN CAP	1*30
TRILOPACE TAB 10*10	1*10TAB
TRILOSAR 12.5 TAB	
TRILOSAR 6.25 TAB	1X10
TRILOW CREAM 15 GM	1X15 G
TRIMA 150 TAB 10*10	1*10TAB
TRIMACONTIN-35 TAB 10*10	1*10TAB
TRIMACONTIN-60 TAB 10*10	1*10TAB
TRIMACSART	1X10T
TRIMBANT	1X10T
TRIMEGABOSE 1 TAB.	1X10 TAB.
TRIMEGABOSE 2 TAB.	1X10 TAB.
TRIMEGAVOG 1	1X10 TAB.
TRIMEGAVOG 2	1X10 TAB.
TRIMENS SYP	1*225ML
TRIMENS SYP	1*450 ML
TRIMOL SYP 100ML	1*100ML
TRIMOLIV SYP	1*100ML
TRIMOLIV SYP	1*200ML
TRIMOLIVE CAP	1*30
TRIMOP FORTE TAB	1*10
TRIMOX CV-625 TAB 10*6	1*6TAB
TRIMOX SYP	1*100ML
TRIMOX-250 CAP 10*10	1x10xCap
TRIMOX-500 CAP 10*10	1x10xCap
TRIMOZYME SYP	1*200ML
TRIMSPA 200	1X6S
TRIMUKH SYP	1*100ML
TRIMZOLE.SS.TAB	1X10
TRINERGIC FORT TAB	1X10
TRINERGIC L CAP	1X10
TRINERV -LC	1X10T
TRINERVE FORTE	1X10C
TRINERVE INJ.	1X1ML
TRINERVE SOFT GEL	1X10C
TRINICALM FORTE	1X10T
TRINICALM PLUS	1X10T
TRINIL CREAM	1*10GM
TRINIL LOTION	1*15ML
TRINOPYRINE-D TAB	1x10
TRINORM CAP 3*10	1*10CAP
TRINUROSOL-H INJ 10*1ML	1x1xMl.
TRINUROSOL-H VIAL 5ML	1x5xMl.
TRIO KIT	1KIT
TRIO KIT VT	1X6
TRIOGEL CREAM	30GM
TRIOHALE INH	120MD
TRIOHALE R/C	1X15
TRIOKIT VG3	1X3
TRIOLMESAR 20	1X10T
TRIOLMESAR 40	1X10 TAB.
TRIOLMEZEST TAB 10*10	1*10TAB
TRIOLMEZEST-40 TAB 5*10	1*10TAB
TRIOLSAR 20 HS TAB	1X10
TRIOLSAR 20 MG TAB	1X10
TRIOMEGA	1X50
TRIOMEGA CD (SOFT GEL)	1X30C
TRIOMUNE 30 TAB	30'S
TRIOMUNE 40 TAB	30'S
TRIOPIL 1	1X10T
TRIOPIL 1/7.5	1X10 TAB.
TRIOPIL 2	1X10T
TRIOPIL 2/7.5	1X10 TAB.
TRIOPTAL SYP	1*60*ML
TRIOPTAL TAB 150MG 10*10	1x10xTab
TRIOPTAL TAB 300MG 10*10	1x10xTab
TRIOPTAL TAB 600MG 10*10	1x10xTab
TRIPAINTA-X CAP	1*10
TRIPANE TAB	1X10T
TRIPATH	1X10T
TRIPEPSA TAB	1X10
TRIPEPSA-D	1X10
TRIPHEN TAB 10*10	1*10TAB
TRIPILL 1	10'S
TRIPILL 2	10'S
TRIPINOM	1X10T
TRIPIOMED TAB 1MG 10*10	1*10*TAB
TRIPIOMED TAB 2MG 10*10	1*10*TAB
TRIPLE A CAL OS CAP 10*10	1*10*CAP
TRIPLEX SYP	1*225ML
TRIPOD STICK	1 PCS
TRIPOD-STICK	1 PCS
TRIPOL TABS	1*30
TRIPOL PLUS TABS	1*10
TRIPOSMEAL 1MG	1X10
TRIPOSMEAL 2MG	1X10
TRIPRIDE FORT TAB 1MG 3*10	1*10*TAB
TRIPRIDE FORT TAB 2MG 10*10	1*10*TAB
TRIPRIDE LP TAB 2MG 10*10	1*10*TAB
TRIPRIDE TAB 1MG 30*10	1*10*TAB
TRIPRIDE TAB 2MG 30*10	1*10*TAB
TRIPTOVA 10MG	1X10T
TRIPTOVA 25	1X10T
TRIPTY 10 TABLET	1X10
TRIPTY 25 TABLET	1X10
TRIPUSPA SYP	1*225ML
TRIPVAC(AD)0.5ML	1*0.5ML
TRIQUILAR TAB 10*21	1x21xTab
TRIQUIN 2.5GM.	VIAL
TRIQUIN-S 2GM.	VIAL
TRISHTINA 100ML SYU	1PH
TRISHTINA 50ML SYU	1PH
TRISORBIT SYP.	1x200 ML
TRISTINA SYP. 100 ML.	1 VIAL
TRISTINA SYP. 60 ML.	1 VIAL
TRISUKH 100ML OIL	1*100ML
TRISUKH 50ML OIL	1*50ML
TRISUZZOLE 100 GR	100 GR
TRIT0NACT	1X10T
TRIVAL CR 200 1*10	1*10
TRIVEDON 20MG TABS	10'S
TRIVEDON MR TAB	10'S
TRIVOBIT 1	1X10T
TRIVOBIT 2	1X10T
TRIVOLIB-1 TAB 5*10	1*10TAB
TRIVOLIB-2 TAB 3*10	1*10TAB
TRIVOSE TAB 1MG 10*10	1*10*TAB
TRIVOSE TAB 2MG 10*10	1*10*TAB
TRIXON 1GM INJ	1X1ML
TRIXON 375 INJ	1X1ML
TRIXON D/SYP	30ML
TRIXON O 100 TAB	1X10
TRIXON S 750 INJ	1X1
TRIXON-250 INJ	VIAL
TRIXON-500	1X500MG
TRIXON-O 200	1X10
TRIXON-S1.5GM INJ	1X1500MG
TRIZ TAB	1x10
TRIZORIL-1 TAB 10*10	1*10TAB
TRIZORIL-2 TAB 10*10	1*10TAB
TROCAR CATHATER FG 20	1 PCS
TROCAR CATHATER NO 28	1 PCS
TROCAR CATHETER FG 16	1 PCS
TROGYL- P OINT	15GM
TROGYL-DENTA GEL	15GM
TROMAX 75	1X3ML
TROMIDE PLUS E/D	1*5ML
TROPAC DROP	1X5ML
TROPAC P EYE DROP	1x3 ML.
TROPAN-2.5 TAB 5*10	1*10TAB
TROPAN-5 TAB 5*10	1*10TAB
TROPAN-XL 5 TAB 5*10	1*10TAB
TROPICACYL	1*5ML
TROPICACYL PLUS	1*3ML
TROPICON P E/D	1*3ML
TROX 120 GR	120 GR
TROX 60 GR	60 GR
TROXIP TAB	1X10T
TROXONE 250MG VIAL	1VIAL
TROXONE 500MG VIAL	1VIAL
TROXONE- 1 GM VIL	1 vil
TROXY 150MG TAB	1X10
TROXY KID TAB 75MG	1X10T
TROXY-A	1X10T
TROYCAL CT 3*10	3*10
TROYCAL PLUS TAB	1X10
TROYDANTIN CAP 10*10	1*10
TROYKA 750 INJ	1X1ML
TROYKA S 1.5GM INJ	1X1.5GM
TROYKA-1 GM INJ	1X1GM
TROYKA-INJ	1X125MG
TROYKA-INJ	1X250MG
TROYKA-INJ	1X500MG
TROYKA-O 200 TAB	1X10
TROYKA-O DRY SYP	12GM/30ML
TROYKA-O-100DT	1X10
TROYKA-S INJ	1X1.5GM
TROYKA-S INJ	1X375MG
TROYNOXA 40MG INJECTION	1 VAIL
TROYNOXA 60MG INJECTION	1 VAIL
TROYNURON SR TABLET	1X10
TROYNURON TABLET	1X10
TROYVIT D3	1*4
TRP bolus..	1x4
TRTRALID 5	5 GM
TRUE RESULT 10 STRIP	1 BOX
TRUE RESULT 25 STRIP	1 BOX
TRUE RESULT 50 STRIP	1 BOX
TRUE RESULT KIT	1 PCS
TRUE RESULT TWIST KIT	1 PCS
TRUEGERMINA SUSP	5ML
TRUEGEST-100MG	1X10
TRUEGEST-200	1X10
TRUFOL	1X10T
TRUGEST 100 1*10	1*10
TRUGEST 200 1*10	1*10
TRUGLYDE SN 2317	1 PCS
TRUGLYDE SN 2338	1 PCS
TRUGLYDE SN 2346	1 PCS
TRUGLYDE SN 2347	1 PCS
TRUGLYDE SN 2347 DA	1 PCS
TRUGLYDE SN 2347 VS	1 PCS
TRUGUT S 2215	1 PCS
TRUGUT S 2216	1 PCS
TRUGUT S 4226	1 PCS
TRUGUT S 4228	1 PCS
TRUGUT S 4241	1 PCS
TRUGUT S 4242	1 PCS
TRUGUT S 4244	1 PCS
TRUGUT SN 4259	1 PCS
TRULENE MESH 3X6	1 PCS
TRULENE MESH 6X11CM	1 PCS
TRULENE MESH 6X6	1 PCS
TRULENE SN 840	1 PCS
TRULENE SN 841	1 PCS
TRULENE SN 842	1 PCS
TRULENE SN 843	1 PCS
TRULIMAX 250MG	1x6cap
TRULIMAX 500MG	1x3cap
TRULON 3318	1 PCS
TRULON SN 3336	1 PCS
TRULON SN 3338	1 PCS
TRULON SN 3390	1 PCS
TRULYDE SN 2346 DA	1 PCS
TRUMECTIN 10 ML	10 ML
TRUMP D SYP.	1X100ML
TRUMP D SYP.	1X50ML
TRUMP-A	1X100ML
TRUNY KAIT WELCROW	1 PCS
TRUSILK B 822	1 PCS
TRUSILK B 823	1 PCS
TRUSILK B 824	1 PCS
TRUSILK B 825	1 PCS
TRUSILK B 826	1 PCS
TRUSILK B-822	1 PCS
TRUSILK B-823	1 PCS
TRUSILK B-825	1 PCS
TRUSILK B-826	1 PCS
TRUSILK SN 5001	1 PCS
TRUSILK SN 5002	1 PCS
TRUSILK SN 5028	1 PCS
TRUSILK SN 5036	1 PCS
TRUSILK SN 5037	1 PCS
TRUSILK SN 5333	1 PCS
TRUSILK SN 5334	1 PCS
TRUSTYL BR SYP 100ML	1*100*ML
TRUSTYL DM SYP	1*100*ML
TRUSTYL X SYP	1*100*ML
TRUXOFOL	1X24+4T
TRYBLUE	1ML
TRYCET L	60ML
TRYPROMER-10 TAB 15*10	1x10xTab
TRYPTOMER-25 TAB 15*10	1x10xTab
TRYPTOMER-75 TAB 10*10	1x10xTab
TRYPTOMER-SR TAB 10*15	1x14xTab
TSART 20 MG	1X10T
TSART 40 MG	1X10T
TSART 80	1X10T
TSART 80 AM	1X10T
TSART 80 H	1X10T
TSART H	1X10T
TSART R 2.5 MG	1X10T
TSART R 5MG TAB	1X10T
TSART-AM	1X10T
TSR-200 1*10	1*10
TSR-400 1*10	1*10
TT AMP DANO	1*1
TT-CEF VET INJ 0.5GM	500MG VIAL
TT-CEF VET INJ 3GMS	VIAL
TUBIFIX C	1 BOX
TUBIFIX D	1 BOX
TUBIFIX E	1 BOX
TUBIFIX F	1 BOX
TUDOFEN GEL	
TUELA TABS	8'S
TUFPOD 200DT	1X10
TUFPOD CV 200	1x10
TUFPOD DRY SYP	1X30ml
TUFTIL-250 TAB 10*10	1*10TAB
TUFTIL-500 TAB 10*6	1*6TAB
TUFTIL-CV 250 CAP 10*10	1*10CAP
TUFTIL-CV 500 CAP 10*6	1*6CAP
TUGAIN 10%	1PHI
TUGAIN 2%	60ML
TUGAIN 2% FOAM	1PHI
TUGAIN 5%	60ML
TUGYNA MF TAB	1*10
TUK-TUK SYP 200 ML	
TULICEF O TAB	1*10
TULIFER DROP	15ML
TULIFER SUSP	150ML
TULIXONE TZ 250	VIAL
TULIXONE TZ 500	VIAL
TULSI D.S 100ML	100ML[46]
TUNETIME	1x60ML
TUNETIME SYP 100ML	1x100ML
TUNING FORK SS	1 PCS
TURBO TAB	1X10
TURBOVAS TAB 10MG 10*10	1*10*TAB
TURBOVAS TAB 5MG 10*10	1*10*TAB
TURMICURE	1*10
TURMICURE-CZS TAB	1*15
TURMICURE-PLUS	1*15
TURMIX	1X10T
TUSCURE SUS	60 ML
TUSNA EXPECTORANT	100ML
TUSPEL PLUS SYP.	1PH.
TUSPEL PX SYP.	1 PH.
TUSPEN 100 ML	100 ML
TUSQ D SYP.	1 PH.
TUSQ LOZ.	1x10
TUSQ P ORAL DROP	1x15ML
TUSQ TAB.	1x10
TUSQ X SYP.	1 PH.
TUSQ-DM LIQ. 100ML	1x100ML
TUSQ-DX LIQUID	1x100ML
TUSSBERRY D SYP	1x100ML
TUSSBERRY N SYP	1x100ML
TUSSBERRY X SYP	1x100ML
TUSSBERRY-LS JR	60ML
TUSSBERRY-P SYP	100ML
TUSSMARK SYP 60ML	1*60ML
TUVACE TAB	1*10
TUVRAK TAIL 25ML	1 PH
TUVRAK TAIL 60ML	1PH
TUX D 100 ML	100ml
TUXIN FORT TAB	1X10
TUXYN FORTE SYP	1PH
TUXYNE SYP	1PH
TUXYNE TAB	1X10T
TVI AMP.	1 AMP.
TVP EYE DROP	1*3ML
TWEEN SUSP.	1*30ML
TWEEN SYP.60ML	1*60ML
TWEEN TAB	1*10
TWICYL 125 TAB	1x10
TYDOL TAB 100MG 10*10	1*10*TAB
TYDOL TAB 50MG 10*10	1*10*TAB
TYDOL TAB 75MG 3*10	1*10*TAB
TYFUNSIN-500 TAB.10'S	1X10
TYFUSIN-250 TAB.	1X10
TYLOMIX 50 100GM	100GM
TYMPALIN-C E/D	1*5ML
TYMPEX 100ml	PH
TYNAPT OD TAB 3*10	1*10TAB
TYREL 100ML	100ML
TYSURE TAB 10*10	1*10*TAB
Tazimide 1.125GM	Vail
U ROZ CREAM	1X15GRM
UASENTZYME 100ML	100ML
UASENTZYME DROPS	30ML
UASENTZYME SYP	200ML
UASLYCO DROPS	30ML
UBEXA 40	1X10T
UBEXA 80	1X10T
UBI Q 100MG	1X10
UBI Q 300	1X10
UBI Q PLUS	1X10
UBICAR CAP	1X10
UBINEXT LC TAB	1*10
UBIPHENE 100	1X10
UBIPHENE 50	1X10
UBIPHENE TAB	1X10
UBQUIL TABS	1*10
UCDEX 100ML SYP	1X100ML
UCECLIN TUBE	10GM
UCECORT TUBE	10GM
UCEMIC TUBE	20GM
UDACO-300	1*10
UDIBILE FORT TAB 10*10	1x10xTab
UDIBILE-150 TAB 10*10	1x10xTab
UDIBON TAB 5*10	1*10*TAB
UDICHAMP-150TAB 10*10	1*10TAB
UDICHAMP-300TAB 10*10	1*10TAB
UDIDIN 150 TAB.	1x10 TAB
UDIGRAND-300TAB	1*10
UDIGYL CT TAB	11STRIPS
UDIHEP FORTE TAB 1*10	1*10
UDIHEP TAB 1*10	1*10
UDILAN SR TABLET	1X10
UDILIV TAB 150MG 10*10	1*10*TAB
UDILIV TAB 300MG 15*10	1*10*TAB
UDILIV TAB 600MG 10*10	1*10*TAB
UDIPLEX LIQIUD	1x100ML
UFER XT SUP	200ML
UFLOX TAB	1x10
UGESIC TAB 20*10	1*10*TAB
ULCEPAN 40 MGTAB	1X10
ULCIKIT TAB	1X6KIT
ULCIPAN DSR CAP	1X10
ULGEL A SYP	1x170xMl.
ULGEL SYP 170ML	1x170xMl.
ULGEL SYP 450ML	1x450xMl.
ULGEL TAB 40*8	1*8*TAB
ULGEL TAB.	1x8
ULPAN D TAB 10*10	1*10*TAB
ULPAN DSR CAP 10*10	1*10*CAP
ULPAN GEL 1*170ML	1*170*ML
ULPAN INJ 1*1VAIL	1*1*VAIL
ULPAN TAB 10*10	1*10*TAB
ULSOMOX CAP	1x10
ULTICAN TAB 150MG 1*1	1*1*TAB
ULTICAN TAB 150MG 1*1	1*1*TAB
ULTICID GEL	1PH
ULTIFLOX 250MG	1*10
ULTIFLOX SYP	1*30ML
ULTIFLOX T SYP	1*30ML
ULTIFLOX TZ TAB	1*10
ULTIFLOX-500MG TAB	1*10
ULTIGEST 100MG CAP	1X10
ULTIGEST 100MG INJ	1XV
ULTIGEST 100MG SG	1X10C
ULTIGEST 200 MG INJ	1X2ML
ULTIGEST 200 SG	1X10C
ULTIGEST 200 SOFT GELATIN	1X10 CAP.
ULTIGEST 200MG TAB	1X10
ULTIGEST 300MG	1X10C
ULTIGEST SR 200	1X10 TAB.
ULTIGEST SR 300	1X10 TAB.
ULTIGUARD CAP	1x10
ULTIMOX CLAV 625 TAB	1x6
ULTIPIME O 250 4'T	05X4'T
ULTIPIME O 500 4'T	05X4'T
ULTIRICH CAP	1X10
ULTIWORM SYP 10ML	10ML
ULTIWORM TAB 1TAB	1TAB
ULTRA D3 4K CAP 1*30	1*30*CAP
ULTRA D3 DROP	1*30*ML
ULTRA D3 TAB 1*30	1*30*TAB
ULTRA GEL	1*10ML
ULTRACAL INJ	30 ML
ULTRACATH NOVO 20	1 PCS
ULTRACATH NOVO 24	1 PCS
ULTRACATH NOVO 28	1 PCS
ULTRACATH NOVO 32	1 PCS
ULTRACATH NOVO TROCAR 24	1 PCS
ULTRACATH NOVO TROCAR 28	1 PCS
ULTRACEF 1GM VIAL	1VIAL
ULTRACEF 250 MGVIL	1VIL
ULTRACEF 500MG.VIAL	1VIAL
ULTRACEF S 1.5GM	1.5gm
ULTRACET SEMI TAB 10*10	1*10*TAB
ULTRACET TAB 10*10	1x10xTab
ULTRACID SYP	1X100ML
ULTRACID-M	170ML
ULTRALAX SYP	1X100ML
ULTRAMED TAB	1X10
ULTRAMED-D TAB	1X10
ULTRAMIN-FORTE	10 KG
ULTRAMIN-FORTE	1KG
ULTRAMOL	1X10T
ULTRAMOL INJ 100MG	1XAMP
ULTRAMOL INJ 50MG	1XAMP
ULTRAMYCIN 500	1X10C
ULTRAMYCIN 750	1X10T
ULTRAMYCIN-250	1X10T
ULTRANAC-MR TAB	1X10
ULTRANAC-P TAB	1X10
ULTRANAC-SR TAB	1X10
ULTRAPHOS INJECTION	30 Ml.
ULTRASKEEN 15GRM	1TUB
ULTRASKIN OINT. 5GR	1X5GRAM
ULTRASKIN PLUS SOAP	1 PH.
ULTRASKIN SOAP	1 PH.
ULTRASOUND GEL 5KG	1 JAR
ULTRASPAS	1X10T
ULTRICH GR	1*200*GM
ULTROX LA INJ	30 ML
ULTROX-TOPICAL LIQ.	60ML
ULYSES 150MG	1X10T
ULYSES 300MG	1X10T
ULYSES PLUS	1X10 TAB.
UMANG CAP	1X4
UMANG OIL	1PH
UMOX DT BOLUS	6X4'S
UMOX PLUS 200DS	1x60ML
UMOX PLUS 375 TAB	1x10
UMOX PLUS SUSPENSION	1x30ML
UNDER PAD MALINA SHEET	5 PKT
UNDEZIRE-KIT	1*1KIT
UNDO TAB 3*1	1x1xTab
UNEEK OZ SUS	1*1
UNEEK OZ TAB 10*10	1*10
UNEEZYME 250GM POWDER	1x250GM
UNEEZYME 500GM POWDER	1x500GM
UNER-PAD MALINA SHEET	1 PKT
UNGENDOL INJ 2ML	2ML
UNGENDOL P TAB 1*10	1*10
UNIBOL.AMP	1AMP
UNIBROM E/D	1*5ML
UNICAL 250 GR GRANS	250 GR
UNICARBAZAN FORT 100	1X100
UNICARBAZAN FORT TAB.8'S	U
UNICARBAZAN TAB	1X10
UNICARBAZAN TAB.500'S/UN	U
UNICEPH 125MG DT	1x10
UNICEPH 500 10*10	1*10
UNICEPH DRY SYP	1x30ML
UNICONTIN-E 400 TAB 12*10	1x10xTab
UNICONTIN-E TAB 600MG 10*1	1x10xTab
UNIDIC A TAB	1X10
UNIENZYME DROP.15ML	15ML
UNIENZYME SYP.200ML/UN	U
UNIENZYME TAB.15'S/UN	1X15
UNIFIT SYP 100ML	1x100ML
UNIFIT CAP	1x10
UNIFIT DROP	1x15ML
UNIFIT M SYP	1x200ML
UNIFIT PLUS CUP	1*10
UNIFIT-M DROP	1x15ML
UNIFIT-M SYP	1x300ML
UNIFORMIN-1000	1X10
UNIFORMIN-500	1X10
UNIK 200MG TAB	1x10
UNIK OZ TAB	1X10
UNIK SYP 60ML	1PH
UNIK TZ TAB	1x10
UNIMYCIN 30ML.	VIAL
UNIMYCIN 50%PDR 20GM.	1x20GM
UNIMYCIN BOLUS.	1x4B
UNIPIRON FORTE SYP.	1x300 ML
UNISELIT TM PREMIX	10GM
UNISPAS TABS	10'S
UNISTAR 10CAP	1X10
UNISTAR 150	1X10
UNISTAR 20/150	1X10
UNISTAR 75	1X10
UNITHROMB	1 TUBE
UNITREAT FORT SYRUP	100ML[47]
UNIVER 4MG TAB.	1X10
UNIVER 8MG TAB.	1X10
UNIZYME.PLUS.100.ML	1PH
UNIZYME.PLUS.200.ML	1PH
UNO LUGAL'S B.P.VET	1X50ML
UNOFEN FORTE	1X10
UNOGEL SYP	170ml
UNOLUGALS 100ML	1X100ML
UNOMOL INJ. 30ML	1X30ML
UNOMOX 15GM	36X15GM
UNOR-OZ SUS	60ML
UNOZOL VET 30ML	PH
UNOZOL VET 60ML	PH
UNWANTED KIT 1"S	1*1KIT
UNWANTED PREGNANCY KIT	1x1xPc.
UNWANTED TAB 3*1	1x1xTab
UNWANTED-72 TAB 2 TAB	1x2xTab
UPAIN P	1*10
UPAINT DSR CAP	1*10
UPLEX L 100	100ML
UPLEX L SYP	200ML
UPMARK-D3 60K	1*4
UPRISE D3	1X10C
UPRISE D3 60K	1X4C
UPRISE D3 6L	1X1 VIAL
UPRISE D3 SYP	1X30ML
UPTAX 250MG VAIL	1X5ML
URDOHEP 150	1x10T
URDOHEP 300	1X10T
URDOHEP-SL	1X10T
URELY TAB 3*10	1x10xTab
URESTOR 150	1X10T
URETHERAL CATHETOR FG 12	1 PCS
URETHRAL CATHETER FG 14	1 PCS
URETHREAL DIALATER SET	1 PCS
URGENDOL P	1*10
URIBID TAB 10*10	1*10TAB
URIBID TAB 10*15	1*15TAB
URIC ACID KIT	1 BOX
URICOSTAT 40	10'S
URICOSTAT 80	10'S
URICYST-SYP	200ML
URIFAST CAP	10'S
URIFIX 40	1X10T
URIFIX 80	1X10T
URIFLAV TAB	1*10
URIFLOW-D CAP	1*10
URIFREE TAB 6*10	1*10TAB
URIFREE-O TAB 6*10	1*10TAB
URIKIND TAB 6*10	1x10xTab
URIKIND-K SYP 100ML	1x200xMl.
URILAV TAB 10*10TAB	1x10xTab
URILISER SYP	100ML
URILISER SYRUP	1x200 ML
URILOSIN D TAB	10'S
URIMAX 0.2 CAP	10'S
URIMAX 0.4 CAP	10'S
URIMAX 0.4 CAP	15'S
URIMAX D TAB	10'S
URIMAX-D	1X15
URIMAX-F CAPS	10'S
URIMIN 10 ML	10 ML
URIMIN 30 ML	VIAL
URIN BAG	1 PCS
URIN BAG (PREMIUM)	1 PCS
URIN BAG (R4)	1 PCS
URIN BAG (REGULAR)	1 PCS
URIN BAG TATA NAGAR	1 PCS
URIN COLECKT (MALE)	1
URIN POT PLASTIC	1 PCS
URINE BAG **	1 PC.
URISODA	4GM
URISOL TAB	1*10
URISPAS TABLET	1x10
URISTIX	1 VIA
URISURGE TAB	1*10
URISURGE-D CAP	1*10
URITHERAL CATHETAR 14	1 PCS
URITREAT FORT SYRUP 200ML	200ML[125]
URIVOID TAB	1X10
URIVOID TABS	10'S
URO BAG (ROMO-10)	1 PCS
URO BAG DELUXE	1 PCS
URO BAG ECHO	1 PCS
URO CATH FG 08	1 PCS
URO CATH FG 10	1 PCS
URO FLEX	1 PCS
UROCONKIT TAB	1X5
UROFIT SYP 100ML	1*100ML
UROFIT SYP 300ML	1*300ML
UROFLAMED TABS	1*10
UROMET BOLUS	24 BOLUS
UROMETER	1 PCS
UROSTAT	1X10
UROSTAT 40	1X10
UROTONE TAB	10 TAB
UROZA TAB 10*10	1*10*TAB
UROZA TAB 10*10	1*10*TAB
URSETOR 300	1X10T
URSOCOL 150 TAB 10*10	1*10TAB
URSOCOL 300 TAB 10*10	1*10TAB
URSOCOL SR 450 TAB 5*10	1*10TAB
URSOCOL SR 600 TAB 5*10	1*10TAB
URSODIL SR TAB 3*10	1*10*TAB
URSODIL SUSP	1*100*ML
URSODIL TAB 10*10	1x10xTab
URSOFIX-300	1*10
URSOKEM 150MG	1X10T
URSOKEM 300MG	1X10T
URSOKEM PLUS	1X10T
URSOMAR-300	1*10
URSOMARIN CAP	1*10
URSOMAX 150 MG	1X10T
URSOMAX 300 MG	1X10T
URSOV	1*6
URZEE 500MG TAB	1*3
US COFF	100ML
USHESAFE BOLUS	1x4
UT-TONE SY	1X200ML
UTAMIDE-50 TAB 3*10	1x10xTab
UTERCIN AMP	1AMP
UTERIGUARD I.U	4 GM
UTEROCLEAR PORDER	1x100GM
UTEROFIT BOLUS	1x4B
UTEROGYN 1 LIT.	PH
UTEROGYN 450 ML.	PH
UTEROTONE 900ML	900ML
UTEROTONE 225 ML.	PH
UTEROTONE 450ML.	PH
UTEROTONE 900ML.	PH
UTEROTONE CAPSULE	1x8CAP
UTICEPT	1X10T
UTILITY GLOVES S/M/L	1 PAR
UTIPRO	1X10S
UTIS SYRUP 1LT	JAR
UTIS 500ML	1X500ML
UTIS TAB	1X100TAB
UTODIN-10 TAB 5*10	1*10tab
UTRASAFE LIQ.	900ML
UTRASAFE LIQID	450ML
UTRIFIT 500 ML	500ML
UTRIFIT 500ml.	PH
UTRINE CLAMP	1 PCS
UTRINE ELEVATOR	1 PCS
UTRINE SOUND	1 PCS
UTRIST SY	1PHI
UTROCARE 500ML	1x500
UTROCARE POWDER	1x500GM
UTROCLEAR-0Z 30ML	30ML VIAL
UTROCLEAR-0Z I.U. 60ML	60ML
UTROGYNE 220 ML	220 ML
UTRONORM FORTE SYP	1x300xMl.
UTRONORM SYP	1x200xMl.
UTROPLUS SYP 1000 ML	1000 ML
UTROPLUS SYP 500 ML	500 ML
UV SOL B	200ML
UV-CORT-TM TAB	1*10
UVOX TAB 100MG 10*10	1*10*TAB
UVOX TAB 50MG 10*10	1*10*TAB
UVRID LOTION	1X60ML
UVRID-NF LOTION 100ML	1X100ML
UXPAIN P SYP	60ML
UXPAIN-P	1*10
UXPAIN-SP	1*10
UZYME SYP	200ML
UZYME SYRUP	100ML
V & M TAB	1X10T
V G KIT	1 KIT
V G KIT(FLU/TINI)3	1*3
V LONE EYE DROPS	1*5ML
V PAT EYE DROP	5 ML
V&M DROP	1X15ML
V&M SYRUP.	1X100ML
V-5 INJ.	5ML
V-BACT 500MG CAP	1*10
V-BACT DT 250MG	1*10
V-CEB 125MG TAB	1x10
V-CEB 250MG	1x4
V-CLAV DRY SYP	1*30ML
V-GEL CREAM	1x30xGm.
V-LAC	1X10
V-LAC S SY	1PHI
V-MYCTIN 250MG TAB	1*10
V-MYCTIN 500MG CAP	1*10
V-OXID CAP	1*10
V-PLES PLUS 450ML	1*450ML
V-PLEX PLUS 100ML SYP	1PH.
V-PLEX PLUS DROPS	1*15ML
V-PLEX PLUS SYP	1*200ML
V.B.C.10ML	1VIL
V.G.KIT(FLU/TINI)	1*3
V.T.TONE TAB	1X10
V.VAT CHINTAMANI RAS 1X5	1*5
V.VAT.CHINTAMANI RAS 1x10	1x10
VACCU SUCK	1 PCS
VAGINAL PIPE WITH ROUND TOP	1 PCS
VAGINOBACT KIT TAB	1KIT
VAGISIL ANTI ITCH CREAM	20GM
VAGISIL LUBRICANT	30GM.
VAGISIL WASH	100GM.
VAGONORM-MPS TAB.10'S	1X10
VAL-BCD 20MG TAB	1X10
VAL-BCD 40MG TAB	1X10
VALAMAC 1000	1X3
VALAMAC 500	1X3
VALAMATE 1ML INJ	1ML
VALBAZEN BOLUS	1x6B
VALBET	10GM
VALCAL 500	1x10
VALCAL TAB	1*10
VALCONTIN 200 TAB 10*10	1x10xTab
VALCONTIN 500 TAB 10*10	1x10xTab
VALCONTIN-300 TAB 10*10	1x10xTab
VALDIXX INJ.	2ML
VALED 10MG TAB	1X10
VALED 20MG TAB	1X10
VALED 40MG TAB	1X10
VALENT-H	1X10T
VALENZIA TAB 1*10	1*10
VALERON GEL 1*30GM	1*30*GM
VALEST 1 TAB	1x28
VALEST 2 TAB	1x28
VALFER TAB	1x10
VALIFLEX 10MG TAB	1X10
VALIFLEX 20MG TAB	1X10
VALIUM TAB 10MG 50*10	1x10xTab
VALIUM TAB 2MG 50*10	1x10xTab
VALIUM TAB 5MG 50*10	1x10xTab
VALKEM OD 750 MG.	1X10 TAB.
VALKEM-OD 250	1X10T
VALKEM-OD 500	1X10T
VALKOF SYP	100ml
VALKOFF SYP	1x100ML
VALMOX 250MG DT TAB	1x10
VALMOX 500MG CAP	1x10
VALMOX-500	1*10
VALNEX SYP	1x100ML
VALNIM DT TAB	1x10
VALODEX TABS 10MG	10 TAB
VALOF 200MG TAB	1x10
VALOPEPTINE SYRUP	60ML
VALORAB-LSR	1*10
VALOXY CAP	1x10CAP
VALOXY-FC CAP	1*10
VALPARIN 200	1X10T
VALPARIN 500	1X10T
VALPARIN CHRONO 200 TAB	1X10
VALPARIN CHRONO 300	1X10T
VALPARIN CHRONO 500	1X10T
VALPARIN-200 SYP	100ML
VALPEX SY	1X100ML
VALPEX-200 CR	1X10T
VALPEX-300 CR	1X10T
VALPEX-500 CR	1X10T
VALPR0-V POWDER	1x200GM
VALPROL CR-1000 TAB 5*10	1x10xTab
VALPROL CR-200 10*10	1x10xCap
VALPROL CR-300 10*10	1x10xCap
VALPROL CR-500 10*10	1x10xCap
VALPROL CR-750 TAB 5*10	1x10xTab
VALPROL SYP	1x100xMl.
VALRIC 200MG	
VALRIC CR 300 TAB 10*10	
VALRIC CR 500 TAB 10*10	
VALSAID 10MG	1X10
VALTHRAL 200MG SUS	1x15ML
VALUE TAB 10*10	1x10xTab
VALUS 10MG TAB	1X10
VALUS 20MG TAB	1X10
VALUS 40MG TAB	1X10
VALUS A TAB	1X10
VALUS A TABLET	1x10
VALUS AP TAB	1X10
VALUS GEL OINT	1TUBE
VALUS P 40MG ING	1VAIL
VALUS PLUS 20MG TAB	1X10
VALUS XT 20MG TAB	1X10
VALVIT-Z SYP	1x200ML
VALZ BCD 20 TAB	1X10
VALZ BCD-40 10'T	1X10
VALZAAR 40	1X10T
VALZAAR 80	1X10T
VALZAAR H TAB	1X10
VALZOLE 30MG CAP	1x10
VALZOX TAB	1x10TAB
VALZYME SYP	1x200ML
VAN FEED 1KG	1KG
VANCOGEN 500MG	1XV
VANCOLYN INJ 500 MG	1 VIL
VANFLOX-0Z TAB	1*10
VANGUADR*5 1ML	1X1ML
VANISH LIQUID	180ML
VANISH LIQUID	500ML
VANIZA GEL	1PH
VANLID INJ 10ML	1AMP
VANLIV 1LT	1X1LT
VANSAFE-CP 1G	1 VIL
VANTOP-D TABS	1*10
VANTOX-CP-500MG	500 MG.
VAPORIZER	1 PCS
VARBEND- 400MG TAB	1'S
VARBEND- SYRUP	10ML
VARBEX SYRUP	200ML
VARBEX-Z CAPSULES	15'S
VARCAL SYRUP	200 ML
VARCAL-FORTE TABS	10'S
VARCEF -INJ	1GR
VARCEF -S INJ	1'S
VARCEF-S 375 MG	1 VAIL
VARCET LV TABS	10'S
VARDASE-DP TAB	10'S
VARDHAN 60GM	
VARDINE OINT	15GM
VARDOL- PLUS TABS	10'S
VAREB TABLETS	10'S
VAREB-DSR CAPSULES	10'S
VAREX- AX SYRUP	100ML
VARGROW -CAP	10'S
VARIVAX 0.5ML	05ml
VARMIKA-500 INJ	2 ML
VARMOX- CL DRY SRYP	30ML.
VARMOX-CL 1.2GM INJ	1 VAIL
VARMOX-CL 375 TABS	10'S
VARMOX-CL 625 TABS	10'S
VARNURON -PLUS CAP	10'S
VARPEP SYRUP	200ML
VARPRO -SYP	200ML
VARPRO DHA	200 GM
VARPRO POWDER	200GM
VARSPAR -TABS	10'S
VARTONE SYRUP	200 ML
VARTRIP K TABS	10'S
VARYCEF-100 1*10	1*10
VARYCEF-200 1*10	1*10
VARYCEF-30ML SUP	30ML
VARZON-S INJ	1GM
VARZYME -SYP	200ML
VASA-77 100ML	100ML[49]
VASA-77 200ML	200ML[48]
VASAK 100GM	100GM
VASAVALEHA 100 GM	1 PH
VASAVALEHA 250 GMS	1 PH
VASAVALEHA PAK	125GMS
VASAVELEH 250GM	250GM[96]
VASC 10	1X10T
VASC 20 T	1X10 T
VASC F	1X10T
VASFREE-100 CAP 10*10	1*10CAP
VASOCON	1 PCS
VASOGRAIN TAB 15*14	1*14*TAB
VASOGRAIN TAB 21*14	1*14*TAB
VASOLIP TABS 10 MG	15'S
VASONEXT	1X10C
VASOPRIN 150	1X10T
VASOPRIN LS	1X10T
VASOTRATE-10 TAB	1X10T
VASOTRATE-20	1X10T
VASOTRATE-30 OD	1X7T
VATGAJANKUS RAS	1x40
VATIKA ALMOND 100ML	1*100ML
VATIKA ALMOND 200ML	1*200ML
VATIKA ANTI 100ML	1PH
VATIKA ANTI 200ML	1PH
VATIKA BLACK 100ML SAMPOO	1*100ML
VATIKA BLACK 200ML SAMPOO	1*200ML
VATIKA BLACK 6ML SAMPOO	1*6ML
VATIKA FAIRNESS CREAM	1TUBE
VATIKA H&S SOAP 100gm	1soap 3+1
VATIKA H&S SOAP 45GM	1*45GM
VATIKA HAIR OIL 30ML	1*30ML
VATIKA OIL 150ML HDPE	1PH
VATIKA OIL 300ML	1PH
VATIKA OIL 75ML	1*75ML
VATIKA SAMPOO 500ML	1*500ML
VATIKA SAMPOO 5ML POUCH	1*20
VATIKA SAMPOO ANTI 6ML	1*1
VATIKA SAMPOO R.S 6ML	1*6ML
VATIKA SHAMPOO 100ML	1PIS
VATIKA SHAMPOO 200ML	1PIS
VATIKA SHAMPOO 50ML	1PH
VATIKA SHAMPOO 8ML 25%EXT	1PIS
VATIKA SHAMPOO 8ML ANTI.	1PIS
VATIKA STOP LOSS 5ML	1*5ML
VATIKAN H&S SOAP 75GM	
VAXEM HIB	1X1V
VAXIRAB VIAL	1*1VIAL
VAZIKKARAN TILLA 30 ML	30ML[151]
VB-7 5MG TAB 10*10	1*10TAB
VB-7 FORTE TAB 10*10	1*10TAB
VCARE VEGITAB	1x4
VCD 10 MG TAB	1x10
VCD 20MG TAB	1x10
VD FIT 60K CAT 10*4	1*4CAP
VDC NATURALLY SAMPOO 5ML	1*5ML
VDM-KIT	1 KIT
VDRUF LOTION	1x60ML
VDX 20 TAB	M
VEBA-PLUS	1x15tab
VECET TAB	1*10
VECREDIL INJ 1*2PC.	1x2xPc.
VECTIN INJ.10ML	1X10ML
VECUBRO 10MG	1 VAL
VECUBRO 4MG	1 VAL
VEELAC CLASSIC	1x400 GM
VEEMAGANA DROP	15ML
VEESYNERAL DROP	1PH
VEET CWS EASYGRIP DRYSKN	IMP72
VEET CWS EASYGRIP SNTSKN	IMP72
VEET CWS MIXED	3VARNTS
VEET DRY SKIN	100GM
VEET DRY SKIN	25GM
VEET DRY SKIN	60GM
VEET HIB "SUPREM "	100GM
VEET HIB "SUPREM "	25GM
VEET HIB "SUPREM "	60GM
VEET NORMAL	100GM
VEET NORMAL	15 GM
VEET NORMAL	25GM
VEET NORMAL	60GM
VEET SENSETIVE	100GM
VEET SENSETIVE	15 GM
VEET SENSETIVE	25GM
VEET SENSETIVE	60GM
VEGADOL 25MG TABS	1X10
VEGADOL 50MG TABS	1X10
VEHYCAL TAB 10*10	1x10xTab
VEIN-GUARD	1 PCS
VELCOLD PLUS 60 ML	60 ML
VELGUT CAP 10*10	1*10*CAP
VELOCIT TAST 1PC	1x1xPc.
VELOZ 10MG TAB 10'S	
VELOZ 20 T	1X15
VELOZ D CAP	1X10
VELOZ FAST 20 TAB	1X10T
VELOZ INJ.20MG	1XV
VELOZ IT	1X10T
VELOZ M CAP	1X10T
VELSAID 20MG TAB	1X10
VELSAID 40MG TAB	1X10
VELSELUM FORCEP 10"	1 PCS
VELTAM (F) TAB 10*10	1x10xTab
VELTAM (F) TAB 10*15	1*15TAB
VELTAM 0.4 TAB 10*10	1x10xTab
VELTAM 0.4 TAB 10*15	1*15TAB
VELTAM PLUS TAB 10*15	1*15TAB
VELTRIDE TAB 10*10	1x10xTab
VENAX 300 TAB	10TAB
VENAX 500 TAB	10TAB
VENDEF-6 TAB	1*10
VENGUT CAP	1*10
VENIZ XR 37.5 TAB 10*10	1*10TAB
VENIZ XR 75 TAB 10*10	1*10TAB
VENKUF-DX SYP	100ML
VENKUF-LS SYP	100ML
VENLA XR CAP 150MG 10*10	1x10xCap
VENLA XR CAP 37.5MG 10*10	1x10xCap
VENLA XR CAP 75MG 10*10	1x10xCap
VENPOWER TAB 100MG 10*10	1*10*TAB
VENPOWER TAB 50MG 10*10	1*10*TAB
VENREX-OD CAP	1*10
VENREX-OD CAPS	1*10
VENSET-LC KID TAB	1*10
VENSET-LC SUS	60ML
VENSET-LC TAB	1*10
VENSY CAP	1X10
VENTAB DXT 50 TAB 10*10	1*10TAB
VENTAB DXT-100 TAB 10*10	1*10TAB
VENTAB XL-37.5 10*10	1x10xTab
VENTAB XL-75 TAB 10*10	1*10TAB
VENTAIR-LC TAB	1X10
VENTAMOX-CV TAB	1*10
VENTEX FORTE TAB.	1*10
VENTEX PED 100ML	
VENTIDOX-A CAP 3*10	1*10CAP
VENTIDOX-M TAB 3*10	1*10TAB
VENTIL EXP	1X120ML
VENTIPHYLINE FORTE TAB	50*10
VENTIPHYLLINE PD LIQUID	60ML
VENTIPHYLLINE TAB	50*10
VENTIREX A TAB	1X10
VENTIREX C SYP	1PH
VENTIREX LM	1X10
VENTIREX LM KID	1X10
VENTIREX PLUS SYP	1PH
VENTIS BOLUS	1x8BOLI
VENTISOL EXPECT SYP 100ML	100ML
VENTOOS (SILICON)	1 SET
VENTORLIN CR 4MG	10'S
VENTORLIN CR 8MG	10'S
VENTORLIN EXPT.	120ML
VENTORLIN INH	17GM
VENTORLIN SY	100ML
VENTROX-250	1X6
VENTROX-PD TAB	1X3
VENTROX.DS	1X6
VENTRYL D EXP	1*100*ML
VENTRYL EXP	1*100*ML
VENUSMIN 150 MG TAB	1x10
VENUSMIN 300 MG TAB	1x10
VEPAN 125MG REDIUSE SYP	1X30ML
VEPAN 125 DRY SYP	1PH
VEPAN 125 DT	1x10
VEPAN 250 DRYSYP	1PH
VEPAN 250 MG. DT	1x10
VEPAN 500 MG.	1x10
VEPAN DROP	1 PH.
VEPAN KID	1x10
VEPAN REDIUSE	1X30ML
VEPAN SYP.	1 PH.
VERASTAN 30 ML.	VIAL
VERBET 24 TAB 10*10	1*10TAB
VERBET-16 TAB 10*10	1x10xTab
VERBET-8 TAB 10*10	1x10xTab
VERGEST 100 ML.	PH
VERGO 25 MG	1X10T
VERICOF 100 ML	100ML
VERIFIX-D	10'S
VERIN D TAB 10*10	1*10*TAB
VERIN DROP 1*10ML	1*10*ML
VERIN INJ 10*1AMP	1*1*AMP
VERIN M TAB 10*10	1*10*TAB
VERIN P TAB 10*10	1*10*TAB
VERIZET 5MG	1X10T
VERIZET D	1X10
VERMACT PLUS TAB 10*1	1x1xTab
VERMACT PLUS-12 TAB 10*1	1*1TAB
VERMACT-12 TAB 5*1TAB	1x1xTab
VERMACT-6 TAB 5*1TAB	1x1xTab
VERMARID-FORTE	100 ML
VERMISOL 150 TAB.	1x1
VERMISOL SUSP.	1x10 ML
VERNACE TAB 5*10	1*10TAB
VERORAB	1XV
VERSTAN 100 ML	100 ML
VERSTAN PLUS 30 ML	30 ML
VERSTAN PLUS BOLUS 1X4	1 X 4
VERTICAL CAP	1x10
VERTICAL-P TAB	1x10
VERTIDOM TAB	10'S
VERTIFINE 16	1*10
VERTIFINE 24	1*10
VERTIFINE 8	1*10
VERTIGEM-16TAB	1*10
VERTIGEM-8 TAB	1*10
VERTIMINE 16 TABLET	1X10
VERTIMINE 24 TABLET	1X10
VERTIMINE 8 TABLET	1X10
VERTIMORE-16 TAB	1X10
VERTIN OD TAB 10*7	1*7*TAB
VERTIN OD TAB 24MG 10*7	1*7*TAB
VERTIN OD TAB 32MG 10*7	1*7*TAB
VERTIN TAB 16MG 10*10	1*10*TAB
VERTIN TAB 24MG 10*10	1*10*TAB
VERTIN TAB 8MG 10*10	1*10*TAB
VERTISEN-B 16 TAB	1*10
VERTISEN-B 8 TAB	1*10
VERTISTAR MD 16 TAB 6*10	1*10TAB
VERTISTAR MD-8 TAB 6*10	1*10
VERTISTAR PLUS-8 TAB 3*10	1*10TAB
VERTITECH-16 TABLET	1*10
VERTITECH-8 TABLET	1*10
VERTIZAC TAB	1*10
VERTIZOX 1*10 TAB	1*10
VERYCOSE VEIN STOCKINGS	1 PCS
VESBAL-16	1X10T
VESBAL-8	1X10T
VESIGARD-7.5 TAB	10'S
VESIGUARD 15 TAB	10'S
VESLIV INJ.30ML	VIAL
VESPHOS 30ML	VAIL
VESPLEX FORTE 30ML	VAIL
VESTOVA INJ	1XV
VETA-A 1LT	JAR
VETA-A INJ	5X2ML
VETACEPH 3gm	VAIL
VETACEPH 1 gm	VIAL
VETACEPH 500MG	1X500MG
VETACEPH Inj 2 gm.	VIAL
VETACEPH PLUS 3GM	VIAL
VETACEPH PLUS 4.5GM	VAIL
VETACIN 10 ML	VIAL
VETACIN INJ 30ML	VAIL
VETADE 10ML	VIAL
VETADEX 10 ML	10 ml
VETADEX 15 ML	15 ML
VETADEX 5 ML	5 ML
VETADEX INJ 10ML	10ML
VETADEX.INJ	1VIL
VETAKIND LIV	500ml
VETAKIND-LIV 1LIT	
VETAL-Z BOLUS	10X1'S
VETAL-Z SUS.100ML	1X100ML
VETAL-Z SUSP 30ML	1X30ML
VETALBEN SUSP.1LT	PH
VETALBEN- R 500ML	ML
VETALBEN-R 100ML	1x100 ML.
VETALGIN 30ml	VAIL
VETALOG 5ML	VIAL
VETAMIN 1 kg..	1 kg
VETAMIN 2.5 kg..	1 kg
VETAMIN 5 kg..	5 kg
VETAXIM 2 GR	2 GR
VETAXIM 500 MG	500 MG
VETAZO 2250	2.25GR
VETAZO 3375	3.375 GR
VETBACIN OINT.	TUBE
VETBEN SUSP	90ML
VETBEN-3GM BOLUS	1X5BOLUS
VETCCILLIN 100 GR	100 GR
VETCEF-2	2GM
VETCEF-3	3GM
VETCLOX FORTE 2GM	VIAL
VETCLOX PLUS.	TUBE
VETCORT 5ML.	VIAL
VETDIN-5 4'S	1X4'S
VETFEN 600	500GM
VETFEN-B	2'S
VETFLOX TZ BOLUS	1X2
VETFUR BOLUS	1X4
VETFUR TL BOLUS	1X4
VETISTIN DS	1VAIL
VETLIV FORTE 300ML	300ML PH
VETLIV FORTE 120ML	PH
VETLIV FORTE 1LT	JAR
VETLIV FORTE 500ML	PH
VETLIV FORTE 5LT.	1X5LT
VETMATE 20 ML	vial
VETMATE 2ml	VIAL
VETMILK BOLUS	1X20 BOLUS
VETMIN FORTE 1KG	1X1KG
VETMOX-2GM	VIAL
VETMOX-3	3GM
VETNORM TZ BOLUS	1 STRIP
VETOCID LIQUID 100ML	1X100ML
VETOPROFEN 15 ML	15 ML
VETOPROFEN INJ 100 ML	100 ML
VETORY MX TAB	1X10
VETORY P	1X10
VETORY SP	1X10
VETOSA CAP	1X10
VETOSA SYP	360 ML
VETOXY 100ML	1*100ML
VETRAL 500ML	1X500ML
VETROSE IV	500M
VETS CU-CO TAB	50TAB
VETVIL INJ.30ML	10X30ML
VETZOL 1.5GM	1X4S
VETZOLE 3GM BOLUS	1x2B
VETZOLE TAB 150MG	1x10S'
VEXTRA PLUS TAB	1X10
VEXX 10MG TAB 10'S	
VEXX 20MG TAB 10'S	
VEXX 40MG TAB 10'S	1X10
VG KIT	2
VH+H 120 500 DOSE	
VH+H-120 250 DS	250 DS
VH-3 TABS	1X3
VIATRAN 1.5G	1VAIL
VIBACT CAP 10*10	1x10xCap
VIBACT DRY SYP	1*50*ML
VIBACT DS CAP 10*10	1x10xCap
VIBACT IBS CAP 3*10	1*10*CAP
VIBACT SACHETS 1*15PC	1x15xPc.
VIBACT ZN SACHET 1*15PC	1*15*PC
VIBAZIE DUO 325	1*10
VIBAZIME 100 DT	1*10
VIBAZIME 200 DT	1*10
VIBEL FORTE CAPS	1x10CAP
VIBELAN 30ML.	VIAL
VIBEX SUSP 30 ML	30 ML
VICAL 500MG TAB	1x10
VICAL SYP. 200 ML.	1 PH.
VICAL-M TAB	1x10
VICKRIL 1/0	1 PCS
VICKRIL 2/0	1 PCS
VICOKAST-LC SYP	60ML
VICOX- 4 TAB	1x10
VICOX-2 KID	1x10
VICOX-2 TAB	1x10
VICOX-2 TAB 10*10	1*10
VICOX-2E TAB	1X6
VICOX-2E+ TAB 10*6	1*6TAB
VICOX-2KID TAB 10*10	1*10TAB
VICOX-2LW TAB 10*10	1*10TAB
VICOX-3 KID	1x10
VICOX-3 TAB	1x10
VICOX-3 TAB 10*10	1*10TAB
VICOX-3KID TAB 10*10	1*10TAB
VICOX-4 TAB 10*10	1*10TAB
VICOX-E TAB 6*10	1*10TAB
VICOX-EZ TAB	1x6
VICOX-EZ TAB 10*6	1*10TAB
VICOX-KID FORTE TAB 10*10	1*10TAB
VICTOZA FLEXPEN 1*1	1*1*PC
VIDA-25	1X10T
VIDA-50	1X10T
VIDA-H	1X10T
VIFEN GEL	1*30GRMS
VIFEN PLUS TAB	1*10
VIFEN-MR TAB	1*10
VIFEX SYP 100 ML.	1 PH.
VIGAMOX E/D	1*5ML
VIGIZYME DROP	1*15ML
VIGIZYME SYP	1*200ML
VIGLAST 30	1X4T
VIGOMAX FORTE	1X20T
VIGOMOX CAP	1X10
VILCAL TAB	1*10
VILCAR CAP	1*10
VILCO N/D (AD)	1*10ML
VILCO N/D (PD)	1*10ML
VILCO N/D (S)	1*10ML
VILCOFER TAB	1*10
VILCOLD LA	1*10
VILCOLD Z	1*10
VILCOLD-Z SYP	1x50ML
VILFLUX-IT	1*10
VILPAR 650MG	1*10
VILPROT POW	1*200GM
VILROX 150MG	1*10
VILSTON SYP	1*100ML
VILSTON TAB	1*3*10
VIMAGNA POWDER	200 GM
VIMCAL-Z CAP	1*10
VIMERAL 120ML	PH
VIMERAL 300ML	PH
VIMERAL 30ML	PH
VIMERAL 500ML	PH
VIMERAL 60ML	PH
VIMINTA CAP (NEW)	1X15C
VIMINTA D3-60K	1X4C
VIMINTA DROPS (NEW)	1X15ML
VIMINTA FORTE(NEW)	1X10C
VIMINTA GOLD	1x10C
VIMINTA INJ	1X1ML
VIMINTA POWDER (NEW)	1X150GM
VIMINTA SY	1X100ML
VIMINTA SYP(NEW)	1X200ML
VIMINTAZYME SY	1X200ML
VIMTAL	
VIMTAL	1X10
VINGOSE TAB 0.20MG 10*10	1*10*TAB
VINGOSE TAB 0.30MG 10*10	1*10*TAB
VINICEF DB SYP	30ML
VINICOR AM TAB 25/2.5 10*7	1*7*TAB
VINICOR AM TAB 25/5 10*10	1*7*TAB
VINICOR AM TAB 50/5MG 10*7	1*7*TAB
VINICOR D TAB 25MG 3*10	1*10*TAB
VINICOR D TAB 50MG 3*10	1*10*TAB
VINICOR XL TAB 25MG 10*10	1*10*TAB
VINICOR XL TAB 50MG 10*10	1*10*TAB
VINLEP 150MG	1X10S
VINLEP 300MG	1X10S
VINLEP 600MG	1X10S
VINUTRIN SYP.	200 ML.
VIPREX 0.25 MG TAB	1*10
VIRADAY TABS	30'S
VIRBAMAC 10 ML	10 ML
VIRECTA100TAB	1X4
VIRECTA50MGTAB	1X8
VIRILEX TAB 3*20	1x20xTab
VIROZ TAB 10MG 10*10	1*10*TAB
VIROZ TAB 5MG 10*10	1*10*TAB
VIRSON GEL	1*5GM
VIRUCID E/OINT	1*5GM
VISCO LIQ	200ML
VISCO TABS	1X10
VISCODYN D SYP.	1 PH.
VISCODYN S SYP.	1 PH.
VISCODYN SYP.	1 PH.
VISCODYN-LS SYP 100ML	1*100ML
VISCODYNE NATURAL SYP 100ML	1*100ML
VISCODYNE SYP 100ML	1x100xMl.
VISCODYNE-C SYP 100ML	1*100ML
VISCODYNE-D SYP 100ML	1x100xMl.
VISCODYNE-S SYP 100ML	1x100xMl.
VISCODYNE-S SYP 60ML	1x60xMl.
VISCODYNE-T SYP 100ML	1*100ML
VISELAM	200 ML.
VISELAM 200 ML	200 ML
VISELAM 500 ML	500 ML
VISHGARBH TAIL 60 ML	1 PH
VISICAIN	5ML
VISIFLOX DX	10ML
VISIGAT	5ML
VISIGRAIN-10	10'S
VISIGRAIN-5	10'S
VISILONE EYE DROP	5 ML
VISILUBE	10ML
VISILUBE DS EYE DROP	10ML
VISIONACE TAB 5*6	1*6*CAP
VISIOQUIN	5ML
VISIOQUIN KT	5ML
VISIPAT	5ML
VISIPRED EYE DROP	5 ML
VISIRON SYP	1*150ML
VISIRON TAB	1*10
VISIWET EYE DROP	10 ML
VISOCOX TAB 10*10	
VISOCOX TABS	1x10
VISTAMEGA	10'S
VISYNERAL DROP	1x15xMl.
VISYNERAL SYP 100ML	1x100xMl.
VISYNERAL Z DROP	1x15xMl.
VISYNERAL Z SYP	1x100xMl.
VIT-CDROP	1PH
VITA A CHEW TAB 25*10	1x10xTab
VITA PLUS DROP	1PH
VITA X GOLD CAP	1X10
VITA X GOLD CAP	1X30
VITA Z SYP	1X100ML
VITA-H	10ML
VITA-Z CAP 1X10	1X10
VITA-Z DROP	15ML
VITABEST 150 ML	150 ML
VITABLEND AD3 1KG	JAR
VITABLEND AD3 20GM	1X20
VITABLEND WM FORTE 100ML	PH
VITACARE BOLUS	1X4'S
VITACARE BOLUS	1x4
VITACEPT 10 ML	VIAL
VITACEPT 5 ML.	VIAL
VITACINTA GOLD CAPS	1*15
VITACINTA SYP	1x200ML
VITACINTA TAB	1x15
VITACINTA-L SYP	200ML
VITACRE 300ML	1X300ML
VITACURE 120ML	1X120ML
VITACURE 30ML	1X30ML
VITACURE 500ML	1X500ML
VITACURE 60ML	60ML PH
VITADHAN 300ML	PH
VITADHAN 60ML	PH
VITAFER SYP	1x200ML
VITAGUT CAPS	10'S
VITAGUT FORTE CAPS	10'S
VITAHEAD 05 ML	
VITAHEAD 05 ML	05 ML
VITAHEAD 30 ML	30 ML
VITAHEAD 90 ML	90 ML
VITAHEXT	1X10C
VITAHEXT SUSP	1X100ML
VITAKIND LIV 90ML	90ML
VITAKIND LIV 90ML	90ML
VITAKIND LIV SY	500ML
VITAKIND(I) CAP(3*10)	1*10CAP
VITAKIND-LIV	1LITERS
VITAKIND-LIV INJ.	30 ML
VITAKIND-LIV NF 30ML	30ML
VITALAC CAP.10'S/MC	M
VITALEM CAP	1x10
VITALFIT CAP.	1x10
VITALIFE DROP	1x30xMl.
VITALIFE SYP	1x200xMl.
VITALIFE-LP CAP 10*10	1*10CAP
VITALIFE-LP SYP 200ML	1*200ML
VITALIN 800	1X10T
VITALIN FORTE	1X10C
VITALUX PLUS TAB	30'S
VITALUX PLUS TAB 1*30	1*30*TAB
VITALYSIN DROP	1x15ML
VITALYSIN SYRUP	1x100 ML
VITALYTE	21G
VITALYTE-4.06GM	4.6GM
VITAM H 100ML	
VITAM-H	10ml
VITAM-H 250ML	
VITAM-H 5ML	
VITAM-H 5ML	
VITAMEG TAB.	1x10
VITAMER EA CAP 3*10	1*10*CAP
VITAMIC SYP	
VITAMIN A AMP 2 ML	5X2
VITAMIN A AMP.	1X1AMP
VITAMIN A AMP.	1x6AMP
VITAMIN.A/D.CAP	1X10
VITAMINAC TABLET	1X10
VITAMIX D 500ML	1X500ML
VITAMIX D 60ML.	1X60ML
VITAMIX GOLD 60ML	1X60ML
VITAMIX GOLD 60ML	60ml
VITAMIX POWDER 1KG	1X1KG
VITAMIX POWDER 5KG	1X5KG
VITANOVA SACHET	1X1GM
VITAP 3G CAP	10*10
VITAP CAP	1X10
VITAP SYP	1X200ML
VITAP SYRUP	200ML
VITAP XT TAB	1*10
VITAP-L CAP	1X10
VITAP-L LIQUID	200ml
VITAP-L SYP	200 ML
VITAP-XT	150ML
VITAP-XT SYP	150ml
VITAPET 150ML.	PH
VITARESP FX TAB 10*10	1*10*TAB
VITARESP TAB 10*10	1*10*TAB
VITASONIC TAB	1x10
VITASPEY SOFT GEL	1*10
VITASPEY SYP	100 ML
VITASPEY SYP	200ML
VITASYS 19 TAB	1x10
VITATONE LM 1 LITRE	1 LITRE
VITATONE LM 500 ML	500 ML
VITATOP DROP	1PH
VITATOP SYP 100ML	1PH
VITATOP SYP 200ml	200ML
VITATOP TAB	1X10
VITAZYME CAP.(E-INDIA)	1x10
VITAZYME DROP	1 PH.
VITAZYME SYP. 400 ML.	1 PH.
VITAZYME SYP.200 ML.	1 PH.
VITBILLS INJ	1x5ML
VITBILLS SYP	1x200ML
VITBILS CAPS	1x10
VITBILS JUNIOR	100ML
VITBILS SYP 300ML	1x300ML
VITCOFER DROP	1x15xMl.
VITCOFER SYP	1x150xMl.
VITCOFER TAB 3*10	1x10xTab
VITCOFOL CAP 5*30	1*30CAP
VITCOFOL INJ.	1x10xMl.
VITCOFOL SYP	1x180xMl.
VITCOFOL-C INJ 1*2AMP	1*2AMP
VITCON AX SYP	200ML
VITCON AX TAB	1x10
VITEL H TAB 40MG 10*10	1*10*TAB
VITEL TAB 40MG 10*10	1*10*TAB
VITEXID 150ML SYP	150ML
VITEXID PLUS CAP	1*10
VITILO LOTION	50ML
VITMINAC TABLET	1X10
VITNEURIN INJ	2ML
VITOMIN Z TAB	10'S
VITOMIN-Z DROPS	15ML
VITOMIN-Z SYRUP	200ML
VITOSEL 100GM.	SACHET
VITOSEL 250GM.	SACHET
VITOSEL2.5 KG.	2.5 KG.
VITOSOL 25 GR	25 GR
VITRNEURIN SYRUP	100ML
VITUM H 10ML	10ml
VITUM H 1LIT	
VITUM H 1LIT	1 LIT
VITUM-H 100ML	100 ML
VITUM-H 250ML	250 ML
VITUM-H 5ML	5 ML
VITWIN CAPS	1*10
VITWIN DROP	15ML
VITWIN M/W	100ML
VITWIN SYP 200ML	200ML
VIVA D DROP 1*15ML	1*15*ML
VIVA D POWDER 1*10*1GM	1*10*1GM
VIVADASE SYP	1x200xMl.
VIVADONA	1X5 TAB.
VIVAFER	1*10
VIVALOL 25MG TAB	1X10
VIVALOL 50MG TAB	1X10
VIVALOL AM 25 MG TABLET	1X10
VIVALOL AM 50 MG TABLET	1X10
VIVEO TAB 150MG 10*10	1*10
VIVETA CREAM	1*5GM
VIVIAN 75MG INJ	1X1ML
VIVIAN GEL	1x30GM
VIVIAN INJ	1ML
VIVIAN INJ	1X3ML
VIVIAN INJ	3ML
VIVIAN INJECTION 10ML	1X10ML
VIVIAN ROLL-ON GEL	1X40GM
VIVIAN-APLUS TAB	1X10
VIVOGESIC 3ML	3MLL
VIZYLAC CAP.10'S/UN	U
VIZYLAC DT TAB.	1X10
VIZYLAC SYP.60ML/UN	U
VM AO TAB.10'S/SAT	S
VOBINI GEL	30GM
VOBINI 10GM OIN	10GM
VOBIS 0.2 MG TABLET	1X10
VOBIS 0.3 MG TABLET	1X10
VOBIS M 0.2 TABLET	1X10
VOBIS M 0.3 TABLET	1X10
VOBIT 0.2MG	1X10T
VOBIT 0.3MG	1X10T
VOBIT M 0.2MG	1X10T
VOBIT M 0.3MG	1X10T
VOBIT MD 0.2MG	1X10T
VOBIT MD 0.3MG	1X10T
VODACOLD TAB	1*10
VOGLI 0.2MG TABS	10'S
VOGLI 0.3MG TABS	10'S
VOGLI GM1 TABS	10'S
VOGLI GM2 TABS	10'S
VOGLI M 0.2MG TABS	10'S
VOGLI M 0.3MG TABS	10'S
VOGLI TRIO 0.3	1*10
VOGLIKEM 0.2	1X10T
VOGLIKEM 0.3	1X10T
VOGLIKEM-M 0.2	1X10T
VOGLIKEM-M 0.3	1X10T
VOGLIMAC 0.2	1X10T
VOGLIMAC 0.3	1X10T
VOGLIMAC GM 1 TAB.	1X10 TAB.
VOGLIMAC GM 2 TAB.	1X10 TAB.
VOGLIMAC MF 0.2	1X10S
VOGLIMAC MF 0.3	1X10S
VOGLINORM GM TAB 1MG 5*10	1*10*TAB
VOGLINORM GM TAB 2MG 5*10	1*10*TAB
VOGLINORM TAB 0.2MG 10*10	1*10*TAB
VOGLINORM TAB 0.3MG 10*10	1*10*TAB
VOGLISTAR GM1 TAB 2*10	1*10TAB
VOGLISTAR GM2 TAB 2*10	1*10TAB
VOGLITAB 0.2 TAB 10*10	1*10TAB
VOGLITAB 0.3 TAB 10*10	1*10TAB
VOGLITAB-M 0.2 TAB 10*10	1*10TAB
VOGLITAB-M 0.3 TAB 10*10	1*10TAB
VOGLITAB-MD 0.2 TAB 10*10	1*10TAB
VOGLITAB-MD 0.3 TAB 10*10	1*10TAB
VOGLITOR MD 0.2	1X10T
VOGLITOR MD 0.3	1X10T
VOGO M TAB 0.20MG 10*10	1*10*TAB
VOGO M TAB 0.30MG 10*10	1*10*TAB
VOGO TAB 0.2MG 10*10	1x10xTab
VOGO TAB 0.3MG 10*10	1x10xTab
VOGSITE 0.2MG MD	1X10T
VOGSITE 0.3MG MD	1X10T
VOLABAY M TAB 0.20MG 10*10	1*10*TAB
VOLABAY M TAB 0.30MG 10*10	1*10*TAB
VOLABAY TAB 0.2MG 10*10	1*10*TAB
VOLABAY TAB 0.3MG 10*10	1*10*TAB
VOLAPRIDE INJ 5*2ML	1*2ML
VOLAPRIDE-25 TAB 3*10	1*10TAB
VOLIBO 0.2 TAB 10*10	1*10TAB
VOLIBO 0.3 TAB 10*10	1*10TAB
VOLIBO-M 0.2 TAB 5*10	1*10TAB
VOLIBO-M 0.3 TAB 5*10	1*10TAB
VOLIKING OIN	30GM
VOLINI ACTIVE	15GM
VOLINI ACTIVE	5GM
VOLINI DUO TAB	10TAB
VOLINI GEL	15GM
VOLINI GEL	3.5GM
VOLINI GEL	30GM
VOLINI GEL	50GM
VOLINI GEL	5GM
VOLINI SPRAY	35GM
VOLINI SPRAY	55GM
VOLIPHAGE .03	1X10
VOLIPHAGE 0.2MG	1X10
VOLITRA GEL 1*30GM	1*30*GM
VOLITRA GEL 1*30GM	1*30*GM
VOLITRA PLUS SPRAY	1*1*PC
VOLITRA PLUS SPRAY	1*1*PC
VOLOXIA 0.2 TAB	10'S
VOLOXIA 0.3 TAB	10'S
VOLOXIA M TAB	10'S
VOLTAFLAM TAB 50MG 10*10	1x10xTab
VOLTANEC PR TABS	10'S
VOLTANEC TABS	10'S
VOLUFIX	1 PCS
VOMETIL TAB	1X10
VOMIFORD 2ML	2ML
VOMIKIND FAST SACHET 1*12PC	1*12P
VOMIKIND INJ 4*2ML	1x2xMl.
VOMIKIND MD4 TAB 6*10	1*10TAB
VOMIKIND SYP 30ML	1x30xMl.
VOMIKIND VIAL 10ML	1x10xMl.
VOMIKIND-4 SACHET 1*12PC	1*12PC
VOMILAST TAB 10*10	1*10TAB
VOMILAST-OD TAB 3*10	1*10TAB
VOMINIL AMP	2ml
VOMINIL TABLET	1x10
VOMINIL SYU	30ml
VOMINORM TAB	1X10
VOMIOF INJ 2ML	2ML
VOMIOF SYP 30ML	30ML
VOMIPAX 2ML AMP	1X5
VOMIPAX SYP	1X30ML
VOMIPAX-MD	1*10
VOMIPAX-TAB	1X10
VOMIPEN	1X10T
VOMIPEN SY	1X30ML
VOMIPREG PLUS TAB	1X10TAB
VOMIPREG TAB	1x10
VOMISTOP DROP	30ml
VOMIT-10 100ML	100ML[51]
VOMITEB SY	1X60ML
VOMITEB TAB 100'S/CHARAK	
VOMITOF DROP	1x30ML
VOMITRON-4 TAB.10'S/MC	M
VOMITRON-8 TAB.10'S/MC	M
VOMIVERT TAB 3*10	1*10TAB
VONEX 500MG	1*10
VORITROL 200	1X4T
VORITROL 50	1X4T
VORTH SP TAB	1X10
VORTH-A TAB	1X10
VORTH-AP TAB	1X10
VORTH-SR TAB	1X10
VOSE MF TAB 10*10	1*10*TAB
VOSE TAB 0.2MG 10*10	1*10*TAB
VOSE TAB 0.3MG 10*10	1*10*TAB
VOVELED-3ML	3ML
VOVENI DS-30GM OIT	1TUB
VOVENI-GEL 30GM OIT	1 TUB
VOVERAN D TAB 10*10	1x10xTab
VOVERAN GE TAB 50MG 28*15	1*10*TAB
VOVERAN GEL 21GR	1*21*GM
VOVERAN GEL 30GM	1x30xGm.
VOVERAN INJ 50*3ML	1*3*ML
VOVERAN PLUS TAB 10*10TAB	1*10*TAB
VOVERAN SR TAB 100MG 25*15	1x15xTab
VOVERAN SR TAB 75MG 10*10	1x10xTab
VOVERAN TAB 50 25*15	1x15xTab
VOVERAN THERMAGEL	1x30xMl.
VOVILUP GEL	30GM
VOVIPYRIN TAB	1X10
VOXATE TAB 10*10	1*10TAB
VOXIMIN CR ST	1X10
VOZET-5MG TAB	10'S
VPL INJ. 5MG	1 AMP
VPRED	
VSL-3 CAP 1*10	1*10CAP
VYSOV-M 50MG TAB	
VYSOV-M 50MG TAB	1x14
VYSOV-M 50MG/1000MG TAB	1x10
VYSOV-M 50MG/500MG TAB	1x10
VZEE -250MG TAB	1*14
VZEE 15ML SYP	1*15ML
W.COLD PREMIUM HONEY	1*50GM
WAFER XT SYP 300 ML	1
WAFER-XT SUSP	1x150ML
WAL D3 CAP 10*4	1*4*CAP
WALACORT TAB 10*10	1*10*TAB
WALADERM CREAM	1*10*GM
WALADROX TAB 500MG 10*10	1*10*TAB
WALAMYCIN DS SYP	1*30*ML
WALAMYCIN SYP 30ML	1*30*ML
WALAPHAGE GP 1 TAB 10*10	1*10*TAB
WALAPHAGE GP 2 TAB 10*10	1*10*TAB
WALAPHAGE SR TAB 1GM 10*10	1*10*TAB
WALAPHAGE SR TAB 500MG 10*10	1*10*TAB
WALAPHAGE TAB 500MG 10*10	1*10*TAB
WALAPHAGE TAB 850MG 10*10	1*10*TAB
WALASA TAB 25*10	1*10*TAB
WALFORMIN TAB 10*10	1*10*TAB
WALKER "FOLDING"	1 PCS
WALKER FOLDING	1 PCS
WALKER FOLDING ALU (SMALL)	1 PCS
WALKER FOLDING ALU KARMA	1 PCS
WALKER FOLDING ALU WHEEL	1 PCS
WALKER FOLDING COMFORT	1 PCS
WALKER-FOLDING	1 PCS
WALKING STICK / CHAIR FS9111	1 PCS
WALTUZ BR SYP	1*100*ML
WALTUZ DX SYP 100ML	1*100*ML
WALYTE SACHET 1*21GM	1*21*GM
WALYTE SACHET 4.2GM 1*5PC	1*5*PC
WANISH CREAM	1 TUBE
WANISH LOTION	1X50ML
WANTO TAB	1x10
WARD SCREEN 3 FOLD	1 PCS
WARF 1 MG TABS	10'S
WARF 2 MG TABS	10'S
WARF 3 TABS	10'S
WARF 5 MG TABS	10'S
WARMO TAB	1*1
WASH BOTTLE	1 PCS
WATER BED PARAMOUNT	1 PCS
WATER BED.	1 PCS
WATER BOTTLE	1 PIS
WATER CONTAINER	1
WATER FOR INJ. 5ML	1 BOX
WATER FOR INJ. 5ML AXA	1 AMP
WATERBED	1 PCS
WATERBURYS RED LABEL	1X250ML
WATERBURYS RED LABLE	1X450ML
WAVOCEF-S 375MG INJ	1 VAIL
WAVOCEF-S 750	1 VAIL
WAX FREE EAR DROP	1*1
WAXCORT EAR DROP	10ML
WAXIL E/D	1*10ML
WAXONIL E/D	1*10ML
WEAK IODINE	1 ML.
WEBVITA 100ML SYP	1x100ML
WEBVITA CAP	1x10
WEBVITA DROP	1x15ML
WEBVITA M 500 INJ	1x1ML
WEBVITA PLUS CAPS	1x10
WEBVITA SYP 200ML	1x200ML
WEBVITA-ZM SYP	1x200ML
WECURE 250 TAB	10'S
WECURE 500 TAB	5'S
WECURE 750	10'S
WECURE O TAB	10'S
WEIGHING MACHINE(DIGITAL)	1 PCS
WEIGHT CUFF	1 PCS
WEIGHT MACHIN	1 PCS
WEIGHT MACHINE SERVICE	1 PCS
WEIGHT MACHINE SMARTCARE	1 PCS
WEIGHT MECHINE	1 PCS
WEIGHTGAIN POWDER 125GM	125GM[60]
WEING SCALE (PRESTIGE)	1 SET
WELARTAN 20 TAB	10,S
WELARTAN 40 TAB	10'S
WELARTAN 80 TAB	10'S
WELARTAN M 25 TAB	10'S
WELARTAN M 50 TAB	10'S
WELLBONE I.V	1X100ML
WELLMAN TAB 2*15	1*15*TAB
WELLWOMAN CAP 2*15	1*15*CAP
WELMOX-C 1*10	1*10
WELNAC 30ML VILE	30ML
WELPLEX 200ML	200ML
WELSET SUSP.60ML	1X60ML
WELTILL SR 1000	10'S
WELTILL SR 500	10'S
WENCLAV 625 TAB	1*10
WENCON-150TAB	1*1
WENLIV 100ML	100ML
WENLIV 200ML	200ML
WENPROVIT POWER	200GM
WHEEL 4"	1 PCS
WHEEL 8"	1 PCS
WHEEL 8" COMPLITE	1 PCS
WHEEL CHAIR AURORA	1 PCS
WHEEL CHAIR COMMODE	1 PCS
WHEEL CHAIR COMMODE RAINBOW 6	1 PCS
WHEEL CHAIR COMOD RAINBOW 7	1 PCS
WHEEL CHAIR COMOD RAINBOW-8	1 PCS
WHEEL CHAIR FIGHTER C BLACK	1 PCS
WHEEL CHAIR FIGHTER C PVC BLUE	1 PCS
WHEEL CHAIR FOLDING	1 PCS
WHEEL CHAIR FOLDING (FY 809)	1 SET
WHEEL CHAIR FOLDING (FY 809B)	1 SET
WHEEL CHAIR FS 609	1 PCS
WHEEL CHAIR PLAN	1 PCS
WHEEL CHAIR SEAT COMPLITE	1 PCS
WHEEL CHAIR TYRE SOLID	1 PCS
WHEEL CHAIR WHEEL 24"	1 PCS
WHEELCHAIR (STRETCHER TYPE)	1 SET
WHISPER	1X10PADS
WHISPER (L)	1X20 PADS
WHITE CLEAN	1 LTR
WHITE SHEET	1 PCS
WHOLE LIVER EXT.INJ	1x10xMl.
WIDCEF 250MG.	1X10
WIDECEF 500MG TAB	1X4
WIDERM 15 GM	1X15 GM
WIFI JR 2 SYP	60ML
WIFI JR SYP	60ML
WIFI TAB	10'S
WIFI-D SYRP	100ML
WIFI-MT TABLETS	10'S
WIFI-S SYRUP	100ML
WIKORYL AF DROP	10ML
WIKORYL TAB	1x10xTab
WILBOL.25MG.AMP	1PH
WILDEC 50MG AMP	1AMP
WILLGO TABLET	1x10
WIN BP MT TAB 25MG 10*10	1*10*TAB
WIN BP MT TAB 50MG 10*10	1*10*TAB
WIN-MPS SUS 200ML	200ML
WINACE TAB 1*10	1*10
WINACID GEL	1x200ML
WINAMIN	1X200ML
WINBP AM TAB 20MG 10*10	1*10*TAB
WINBP AM TAB 40MG 10*10	1*10*TAB
WINBP H TAB 20MG 10*10	1*10*TAB
WINBP H TAB 40MG 10*10	1*10
WINBP TAB 20MG 10*10	1*10*TAB
WINBP TAB 40MG 10*10	1*10*TAB
WINBP TRIO TAB 20MG 10*10	1*10*TAB
WINCEFT 1GRAM	1*1
WINCEFT 250MG VAIL	1VAIL
WINCOLD NOSAL DRP.	1*10ML
WINCOLD TAB	1*10
WINCOLD TAB	1x10
WINCREPE 4"	1 PCS
WINCREPE 6"	1 PCS
WINCUF COGH LOG.(WHITE)	1x250
WINDAMET 2MG	10'S
WINDIA 2MG	10'S
WINDIA 4MG	10'S
WINDLORA PLUS, 10'S	
WINDLORA SYRUP. 30ML	
WINDLORA-10MG. 10'S	
WINFIX 100MG TAB	1*10
WINFIX 200MG TAB	1*10
WINFIX 50 DT TAB	1*10
WINFIX SYP	1*60
WINGGESIC PLUS TAB	1*10
WINGS COGH LOG.(GREEN)	1x250
WINGS PASTEURISED HONEY	1*50GM
WINLIN.25MG.AMP	1AMP
WINLIN.DEC.100MG.AMP	1AMP
WINLIN.DEC.50MG.AMP	1AMP
WINLINDEC-25.AMP	
WINOBOOST DROPS,15ML	
WINOBOOST SYRUP,200ML	
WINOBOOST TAB,10'S	
WINOFIT CAP 10*15	1x15xCap
WINOFIT GX CAP 1*10	1*10CAP
WINOFIT SYP	1x150xMl.
WINOLAP DS DROP	1*5ML
WINVITAL CAP	1X10
WIPS.RUB.10GM	
WISER-10MG TAB. 10'S	
WISER-DK TAB. 10'S	
WISPREC 25 GMS	25 GM
WISPREC SPRAY	100 ML
WISPREC SPRAY	200 ML
WISPREC SPRAY 200 ML	
WIXIM DRY SYRUP. 30ML	
WIXIM-100DT,4'S	
WIXIM-200MG CAP. 4'S	
WIXIM-50DT 4'S	
WNR 150 SYP.	1*100ML
WNR IV INJ	1*2ML
WNRGOLD CAP	1*10
WOCEF 3 GR	3 GR
WOCEF XP 3.3756 GR	3.37556
WOCEFF 2.5 GR	2.5GR
WOCEFF 500 MG	500 MG
WOCKTROSE 450 ML	PH
WOFLAN 200MG,10'S	
WOFLAN-M SUSP.30ML.	
WOFLAN-TZ,10'S	
WOKADINE 10% LOT. 100ML	1x100xMl.
WOKADINE 100ML LOTION	1x100xMl.
WOKADINE 100ML.	PH
WOKADINE 500ML LOTION	1x500xMl.
WOKADINE GARGLE	1x50xMl.
WOKADINE GARGLE 100ML	1*100ML
WOKADINE I U 60 ML	60 ML
WOKADINE OINT	1x15xGm.
WOKADINE POWDER	1x10xGm.
WOKADINE SURG.SCRUB 500ML	1x500xMl.
WOKAGEST BOLUS	1X4
WOKAZOLE LOTION 30 GR	30 GR
WOKOCEF 325 TAB 5*10	1*10TAB
WOKOCEF-DS SYP 30ML	1*30ML
WOKOCEF-O TAB 10*10	1*10TAB
WOKTANT 500 ML	500 ML
WOLICYCLIN-DS 30ML	VIAL
WOMIBAN SUSP.	1 PH.
WOMIBAN TAB.	1x1
WORCEF 200MG	1X10
WORDEC-25	1AMP
WORM LESS 100GM	100GM
WORMECTOL SUSP	1*10*ML
WORMER 90 ML	90 ML
WORMER BOLUS 1.5 GR	1.5 GR
WORMER BOLUS 3.0 GR	3.00 GR
WORMER TABS 150 MG	150 MG
WORMER VETT 30 ML	30 ML
WORMER VETT 60 ML	60 ML
WORMER VETT 600 MG BOLUS	1X6
WORMIS L SUS	1x30ML
WORMIS L TAB	1x1
WORMIS-L TAB	1x1TAB
WORMPEL CAP	1X10
WORMPILLS TAB	1X10
WORNED 1.5gm	1X4
WORNED 100ML	PH
WORNED 30ML	PH
WORNED 3GM BOLUS	1x2B
WORNIL SUSP 10ML	
WORNIL TAB 1'S	
WOSULIN CARTAG(30/70) 5*3ML	1*1PC
WOSULIN CARTIDGE(R)	1*1P
WOSULIN DISPO PEN 30/70 INJ	1*1PC
WOSULIN INJ 30/70	1*1VAIL
WOSULIN ROYAL PEN	1*1P
WOSULIN-N INJ 1*10ML	1x10xMl.
WOSULIN-R INJ 1*10ML	1*1VAIL
WRIST BRACE (L)	1 PCS
WRIST BRACE (M)	1 PCS
WRIST BRACE WITH THUMB UNIV.	1 PCS
WRIST BRACE(S)	1 PCS
WRIST SPLINT LONG	1 PCS
WRIST SPLINT S ,M ,L	1 PCS
WRIST SUPPORT	1 PCS
WRIST WATCH	1X1
WUNDER EYE CREAM	1X15 GM
WYCOLD SYP	60ML
WYMOX 250MG	1 TAB
WYMOX CAP 500MG 10*15	1x15xCap
WYMOX SYP 30ML	1x30xMl.
WYMOX SYP 60ML	1x60xMl.
WYNODRIL SYP	60ML
WYSOLONE TAB 10MG 120*15	1*15*TAB
WYSOLONE TAB 20MG 105*10	1x10xTab
WYSOLONE TAB 5MG 120*15	1*15*TAB
X LON SAVLON SOLUTION	1 BOT
X-CIM 200LB	1*10
X-CIM 200TAB	1*10
X-LCF	1X10T
X-LON	1 ML.
X-PLUS	1x100ML
X-RAY VIEW BOX	1 SET
XADOO TABLET	1X10
XAMIC 500	1X10T
XAMIC INJ 5 ML	1X5ML
XAMIC MF.	1X10T
XANTHOFEX 40MG	1X10T
XCEFT 1 GR	1 GR
XCEFT 500 MG	500 MG
XCEFT TAB 200MG 10*10	1x10xTab
XCILIX 60ML	60ml
XCIM-CV TAB	1*10
XCIM-OF TAB	1*10
XCV-625 TAB	1*6
XECUTE AZ TAB 10*10	1*10*TAB
XECUTE CV TAB 162.5MG 10*10	1*10*TAB
XECUTE CV TAB 325MG 10*10	1*10*TAB
XECUTE DRY SYP 1*30ML	1*30*ML
XECUTE O TAB 10*10	1*10*TAB
XECUTE S INJ 1.5GM	1*1*VAIL
XECUTE S INJ 1GM	1*1*VAIL
XECUTE TAB 100MG 10*10	1*10*TAB
XECUTE TAB 200MG 10*10	1*10*TAB
XECUTE TAB 50MG 10*10	1*10*TAB
XECUTE TURBO TAB 10*6	1*6*TAB
XEED-2 TABLET	1x6
XEED-3E TABLET	1x6
XEED-4 TABLET	1x6
XEMOLATE.TAB	1X10
XENAR CR TAB	1X10
XENIA TAB 12.5MG 10*15	1*15*TAB
XENIA TAB 25MG 10*15	1x15xTab
XENIT SYP	1x10xMl.
XENIT TAB 3*10	1x10xTab
XENOCET TAB	1X10
XENOCET TABLET	1X10
XENOCOF 100 ML	1X100 ML
XENOCOF A SYRUP	1X100 ML
XENOCOF A SYRUP	1X100 ML
XENOCOF D SYRUP	1X100 ML
XENOCOF D SYRUP	1X100 ML
XENOCOF SYRUP	1X100 ML
XENODOL SP TABLET	1X10
XENODOL TABLET	1X10
XENORAB-DSR	1X10
XEROFLAM AMP	1X1
XEROFLAM GEL OINT	1X30G
XEROFLAM M TAB	1X10
XEROFLAM TAB	1X15
XEROFLAM-TP	1X10
XF-250	VIAL
XF-375MG ING	VIAL
XF-KID ING	VIAL
XGAIN SHAMPOO	1PHI
XIBACT 750MG. INJ.	1 VIL.
XIDA-N TABLETS	1*10
XILIA M1 TAB	1x10
XILIA M2 TAB	1x10
XILIA-M1 FORTE TAB	1x10
XILIA-M2 FORTE TAB	1x10
XILIA-MP 1 TAB	1x10
XILIA-MP 2 TAB	1x10
XIMCLAV 100MG	1x6
XIMCLAV 200MG	1x6
XIMCLAV 50MG TAB	1x6
XIMECEFF 200 TAB	1X10
XINEP DROP	1*5ML
XIRTAM 20 MG	1X10T
XIRTAM AM	1X10T
XIRTAM H	1X10T
XITH READYMIX SYP 200MG 1*15ML	1*15*ML
XITH TAB 100DT 10*3	1*10*TAB
XITH TAB 250MG 10*6TAB	1*6*TAB
XITH TAB 500MG 10*3TAB	1*3*TAB
XL 100 CAPS	1x6
XL 80 MG. SYP.	1 PH.
XL 90 MG. SYP.	1 PH.
XL ONE 1.5GM INJ	1 VAIL
XL ONE INJ.0.375GM	1 VAIL
XL ONE INJ.0.750GM	1 VAIL
XL-ZYMETAK SYP	200ML
XLT 4% 30 ML.	1 VIAL
XM BETA 25MG	1X10S
XM BETA 50MG	1X10S
XMET 500 TAB	1X10
XMET-SR 1000GM TAB	1X10
XMET-SR 500MG TAB	1X10
XNEL INJ 1GM	1GM
XOFDIM 200 TAB	1x10
XOFDIM SYRUP	1x60 ML
XOFEX XL 100 TAB	1x10
XOFEX XL 200 TAB	1x10
XOFEX XL DRY SYRUP	1x30 ML
XOLID IV	1*300*ML
XOLID TAB 1*6TAB	1*6*TAB
XOLYCEF INJ 1000MG	1 VIL
XOLYCEF-SB INJ 1.5GM	1 VIL
XOLYCEF-TZ INJ.	1 VAI
XONE 2GM	1XV
XONE CEFF 250MG IN	1X20
XONE CEFF 500MG INJ	1X20
XONE INJ 125MG	1XV
XONE INJ 1GM	1XV
XONE INJ 250MG	1XV
XONE INJ 500MG	1XV
XONE SB 1GM INJ	VIAL
XONE SB 500ING	VIAL
XONE-XP 1.125GM	1XV
XONE-XP 125MG	1XV
XONE-XP HS	1XV
XONE-XP KID 250	1XV
XONECEF 1GM	1*1000
XONECEF 250MG	1*250MG
XONECEF-S-1.5MG	1*1500
XONECEFF 1GM	1VIL
XONECEFF-S 1.5GM	1VIAL
XONEXEF 15 ML	3 GR
XONEXEF 1GM	1*1000
XONEXEF 2 GR	2 GR
XONEXEF 250 MG	250 MG
XONEXEF 250MG	1*250
XONEXEF 500 MG	500 MG
XONEXEF INJ	1*500MG
XONEXEF INJ 3GM	3GM
XONEXEF INJ.	1*250MG
XONEXEF S 1.5GM	1*1.5gm
XONEXEF S 3 GR	3 GR
XONEXEF S 750 MG	750 MG
XONEXEF-S-375	1*375MG
XONLINE 1GM	1GM
XONLINE 250MG	VIAL
XONLINE SB 1.5GM ING	VIAL
XONTAZ 1GM	1 VAL
XOVATRA EYE DROP	1PIC
XOXE TAB 500MG 5*10	1*10*TAB
XPAND 625	1*6
XPAND DRY SYP	1*1
XPECT-A SYP	1X100ML
XPECT-B SYRUP	1X100ML
XPECT-C SY	1X100ML
XPECT-PD SY	1X100ML
XPLOCEF 1.5GM INJ	1 VIAL
XPLOCEF 3GM INJ	1 VIAL
XPLODE TAB	1X10
XPRAB INJ	1*1*VL
XRATE SYP	1x100xMl.
XT PARA SYP 60ML	1X60ML
XT PARA TAB	1X10
XTHROCIN 150 MG. TAB	1x10
XTHROCIN 50 MG. KID TAB	1x10
XTHROCIN SYP.	1 PH.
XTOR EZ TAB 10MG 1*10	1x10xTab
XTOR F TAB 10*10	1*10*TAB
XTOR TAB 10MG 10*10	1x10xTab
XTOR TAB 20MG 10*10	1*10*TAB
XTOR TAB 40MG 10*10	1x10xTab
XTOR TAB 5MG 10*10	1*10*TAB
XTRA 100MG TAB	1X10
XTRA P	1X10
XTRA SP	1X10
XTRADOL 100 TAB.	1X10 TAB.
XTRADOL 50 TAB.	1X10 TAB.
XTUM INJ 1.5GM	1x1xVl.
XTUM INJ 187.5MG	1x1xVl.
XTUM INJ 375MG	1x1xVl.
XTUM INJ 750MG	1x1xVl.
XTUM O TAB 325MG 10*10	1*10*TAB
XUV 250	5'S
XUV 500	5'S
XYCLOCAN ADERNALIN 30ML	30ML
XYCLOFEN 100 ML	1VIAL
XYCLOFEN 30ML.	1 VIAL
XYCLOFEN P INJ 100ML	1x100ML
XYCLOFEN P INJ 30ML	1x30ML
XYDAP TAB	1X10
XYKAA RAPID 500	1*10
XYKAA RAPID 650 MG TABLET	1X10
XYKAA SUSPENSION	1X60 ML
XYLAXIN 10ML	VAIL
XYLAXIN 2ML	VIAL
XYLISTIN VAIL	1VAIL
XYLOCAINE 2 % VISCOUS	100ML
XYLOCAN 2% VILE	30ML
XYLOCANE 4% TOPICAL SOL	30ML
XYLOCANE 5% OINT 20GM	20GM
XYLOCANE JELLY	30GM
XYLOCHEK NASAL DROP	1*10ML.
XYLODAC 2 ML	2 ML
XYLODEC 10 ML	10 ML
XYLOFLO	1X10ML
XYLOMONAS 1 MIU	1X1 VIAL
XYLONUMB ADR INJ 30ML	1*30ML
XYLORIS NASAL DROP	1*10*ML
XYLOSTAR NASAL SPRAY	1*10ML
XYLOVIN 0.05% NASAL DROP	1X10ML
XYLOVIN 0.1% NASAL DROP	1X10ML
XYMEX -SYRUP	1PH
XYMEX DROP	1PHI
XYMEX MPS TABS	10'S
XYNOLUBE 0.1	1*10ML
XYNOLUBE 0.25	1 PH
XYNOLUBE 0.5	1PH
XYNOSE DROP 10ML	1X10ML
XYPAR RAPID 500 MG TABLET	1X10
XYPOD 100 1*10	1*10
XYPOD 200 1*10	1*10
XYPOD 50 1*10	1*10
XYPOD CV CAP 1*6	1*6
XYPOD DRY SYP	30ML
XYREX SYP 100ML	100ML
XYTROY EXTEND TABLET	1X10
XYTROY RAPID 500 MG TAB	1X10
XYTROY RAPID 650 MG TAB	1X10
XYZAL A	1X10C
XYZAL A SYP	1X60ML
XYZAL M	1X10T
XYZAL SY	1X60ML
XYZAL TAB	1X10
XYZAL-M KID DT	1X10T
Y2KAL SUSP	1X200ML
Y2KAL TAB	1X10
YAKRIFIT 250ML	PH
YAKRIFIT BOLUS.	1x4
YAMINI	1X21T
YAMINI LS	1X24T
YASH ZI 100MG	15ML
YASH ZI 200MG	15ML
YASH ZI 250 1*6	1*6
YASH ZI 500 1*3	1*3
YASHCOLD TAB 1*10	1*10
YASMIN FTB	1X21 IN
YAZ	1X28T
YEASAC BOLUS 1X4	1 X 4
YEES D CAP	1*10
YOCEF-100 1*10	1*10
YOCEF-200 1*10	1*10
YOFLOX 200 1*10	1*10
YOFLOX-OZ 1*10	1*10
YOGELWASH	1PH
YOGRAJ GUGGULU	1x60 TAB
YOGRAJ GUGGULU(MAHA)	1x10 TAB
YOGRAJ GUGGULU(MAHA)	1x40 TAB
YOGUT CAP 10*10	1x10xCap
YOUWETUS LS	100ML
YOUWETUS LS PLUS	100ML
YUTOPAR INJ 4*5ML	1x5xMl.
YUTOPAR TAB 5*10TAB	1x10xTab
Z & B CAP 10*15	1*15*CAP
Z 1-250	1X6T
Z 1-500 TAB.	1X3 TAB.
Z&D DS 20 SYP	1x15xMl.
Z-1	1X2GM
Z-BROM EYE DROP	1*5ML
Z-FLOX SUS	60ML
Z-STAT 10 MG	1X10T
Z-STAT 20	1X10T
Z-STAT 5 MG	1X10T
Z8-10 TAB 10*10	1*10TAB
Z8-5 TAB 10*10	1*10TAB
ZAAN SY 450ML	1PHI
ZAART 25MG TABS	10'S
ZAART 50MG TABS	10'S
ZAART-H TAB	10'S
ZACY SPAS TAB	1*10
ZACY-MR 4 TAB	1X10
ZACY-P TAB.	1X10
ZACY-SP TAB	1X10
ZACY-TH 4 TAB	1*10
ZADIMAC AS	1XVIAL
ZADIMAC HS	1XV
ZADIMAC PS	1XV
ZADORAB-DSR CAP	1X10
ZADRO 125MG SYP 30ML	1*30ML
ZADRO 250TAB 10*6	1*6TAB
ZADRO 500 TAB 10*10	1*6TAB
ZADRO CV 250 TAB 5*6	1*6*TAB
ZADRO CV 500 TAB 5*6	1*6*TAB
ZADRO CV250 SYP 30ML	1*30*ML
ZADRO-CV 250 DT 10*10	1*10TAB
ZADRO-CV 500 10*10	1*10TAB
ZADY READYMIX SYP 15ML	1x15xMl.
ZADY-100 TAB 4*3	1x3xTab
ZADY-250 TAB 2*6	1x6xTab
ZADY-500 TAB 6*3	1x10xTab
ZAFFERAN CAP	1X10
ZAFFERAN SY.	200ML.
ZAFIL 0 TBALET	1X10
ZAFIL 100 DT TBALET	1X10
ZAFIL- O DRY SYRUP	1X 30 ML
ZAHA E/D	1*3ML
ZAHA OINT.	1*5GM
ZALAIN CREAM	10GM
ZALAIN-PESSRIES	1
ZALTOKIN TAB 80MG 1*10	1*10*TAB
ZAMADOL	1X10S
ZAMADOL 100 INJ	1XV
ZAMADOL 50 INJ	1XV
ZAMADOL P	1X10S
ZANDRIL DROP	1X10ML
ZANDRIL PLUS SYP	1X60ML
ZANDRIL SUS.60ML/SB	S
ZANDRIL TAB.10'S/SB	S
ZANDU BALM	1*5GM
ZANDU BALM	10GR.
ZANFLOX SYP	1*30ML
ZANIDE BOLUS 4"S	1X4
ZANIDE TAB. 200 MG 10"S	10
ZANIL 100 ML.	PH
ZANIM TAB	1x10
ZANOCIN DS TAB 5*10	1x10xTab
ZANOCIN EYE DROP	1x10xMl.
ZANOCIN F TAB 10*10	1*10*TAB
ZANOCIN I.V.	1x100xMl.
ZANOCIN LIQ 100MG	1*60*ML
ZANOCIN LIQ.50MG	1x60xMl.
ZANOCIN OD 400MG 10*5	1x5xTab
ZANOCIN OZ I.V.	1*100*ML
ZANOCIN OZ SYP	1*60*ML
ZANOCIN OZ TAB 10*10	1x10xTab
ZANOCIN PLUS TAB 10*10	1*10*TAB
ZANOCIN TAB 200MG 20*10	1x10xTab
ZANOCIN TZ TAB 5*10	1x10xTab
ZANOFLOX OZ SYP	1*30ML
ZANOFLOX TZ TAB	1*10
ZANOPAR 60ML SYU	60ML
ZANOPAR 200 TAB	1x10
ZANOPAR 30 MLSYP	1PH
ZAPIZ-0.25 TAB 20*10	1x10xTab
ZAPIZ-0.5MG TAB 20*10	1x10xTab
ZAPIZ-1MG TAB 20*10	1x10xTab
ZAPIZ-2MG TAB 20*10	1x10xTab
ZAPTRA 12.5 TAB 10*10	1*10TAB
ZAPTRA 25 TAB 10*10	1*10TAB
ZARATE-20MG	1*6
ZARATE-D	1*6
ZATAK DEO MUSK	200ML
ZATHRIN-100 SYP	1x15xMl.
ZATHRIN-250 TAB 10*6	1x6xTab
ZATHRIN-500 TAB 10*3	1x3xTab
ZATSA TZ 1.125GM	1VAIL
ZAXPAM-10 TAB 10*10	1*10TAB
ZAXTER 1 GM	1X1 VIAL.
ZAXTER 125	1XV
ZAXTER 500MG	1XV
ZAXTER KIT 1GM	1XV
ZAXTRO 200MG	1X6C
ZCIP-TZ	6X4'S
ZE SPAS TAB	1*10
ZEALTUS 100ML	1PHI
ZEALTUS SY	1PHI
ZEBEND SUSP	10ML
ZEBEND TAB	1X1
ZEBITA-XT SUS	150ML
ZEBITA-XT TAB 1*10	1*10TAB
ZEBRA-20 INJ	VIAL
ZEBRA-20 TAB	1*10
ZEBRA-DSR CAP	1*10
ZEBRA-L CAP	1*10
ZEBRON INJ	1*1ML
ZEBRON OD TAB	1*10
ZECAL 40 PLUS	1*10
ZECAL 500 TAB 20*15	1x15xTab
ZECAL ACTIVE	1*15
ZECAL ACTIVE TAB	1*10
ZECAL SYP	1x100xMl.
ZECAL-GOLD TAB 1*30	1*30TAB
ZECEREIN GM TAB	1x10
ZECUF COUGH SY	100ML
ZEDBEN TAB	1x1
ZEDE-10MG TAB	1*10
ZEDEX NATURAL SYP 100ML	1*100ML
ZEDEX SYP	1x100xMl.
ZEDEX-P-SYP	1x60xMl.
ZEDFIT 10GM	1*1
ZEDFIT 150 GMS	
ZEDOCEF 100 MG D/S	1X30ML
ZEDOCEF 100-DT	1X10T
ZEDOCEF 200 TAB	1X10
ZEDOCEF 50DT	1X10
ZEDOCEF 50MG D/S	1X30ML
ZEDOCEF AZ	1X10T
ZEDOCEF CV 100DT	1X6T
ZEDOCEF CV 200	1X6T
ZEDOCEF CV 50 DT	1X6T
ZEDOCEF CV 50 SYP.	1X30ML
ZEDOCEF DROP	1X10ML
ZEDOCEF DXL 100	1X10T
ZEDOCEF DXL 200	1X10T
ZEDOCEF-O	1X10T
ZEDONAC TAB	1*10
ZEDONAC VIAL	1*30ML
ZEDOTT 1% 1GM SACH (BABY)	1POU
ZEDOTT 100MG CAP	1X10
ZEDOTT 3% 3GM SACH (KID)	1POU
ZEDOTT KID 3GM	
ZEE BEE SYP.	1 PH
ZEE BEE TAB.	1 TAB.
ZEET 10 ML.	VIAL
ZEET 100 ML	100 ML
ZEET 30 ML.	VIAL
ZEET EXP	1x100xMl.
ZEETHROM 250 TAB 10*6	1x6xTab
ZEETHROM 500 TAB 5*3	1x3xTab
ZEFCLAV 250	1X6S
ZEFCLAV 250 D/S	1X30ML
ZEFCLAV 500	1X6S
ZEFLOX TAB	1x5
ZEFS COUGH SYP	100ML
ZEFU CV 250 TAB 10*6	1*6TAB
ZEFU CV 500 10*6	1*6TAB
ZEFU CV SYP 1*30ML	1*30ML
ZEFU SYP	1x30xMl.
ZEFU-125 DT TAB 10*10	1*10TAB
ZEFU-250 TAB 10*10	1x10xTab
ZEFU-500 TAB 10*10	1*10TAB
ZEFUN 150 MG	2'S
ZEHIST	1X10T
ZELID PLUS TAB	1*10
ZELIPOD 50	30ML
ZELOCET MT SYP	60ML
ZEMCIFER TAB	1x10
ZEMCIFER INJ	1AMP
ZEMCIFER SUSP.	1x150ML
ZEMCIFER XT SUSP.	1X150ML
ZEMCIFER-XT	1X10T
ZEMETRIL-250MG TAB	6'S
ZEMETRIL-500MG TAB	6'S
ZEN 100 TAB 10*10	1x10xTab
ZEN RTD 200 TAB 10*10	1x10xTab
ZEN RTD 300 TAB 10*10	1x10xTab
ZEN RTD 400 TAB 10*10	1x10xTab
ZEN-200 TAB 10*10	1x10xTab
ZEND SYP	10ML
ZEND TAB	1*1
ZENDRYL.100ML.SYU	1PH
ZENEBEND SYU	10ml
ZENEBEND 400 TAB	1X1
ZENEGRA 50MG	1*4
ZENEGRA-100	1X4T
ZENEGRA-50	1X4T
ZENFLOX DROP	1x10xMl.
ZENFLOX I.V.	1x100xMl.
ZENFLOX PLUS SYP 30ML	1*30ML
ZENFLOX PLUS TAB 6*10	1*10TAB
ZENFLOX PLUS-100 TAB 3*10	1*10TAB
ZENFLOX SYP	1x60xMl.
ZENFLOX UTI TAB 3*10	1x10xTab
ZENFLOX-100 TAB 10*10	1x10xTab
ZENFLOX-200 TAB 12*10	1x10xTab
ZENFLOX-400 TAB 10*10	1x10xTab
ZENFLOX-D DROP	1x5xMl.
ZENFLOX-NT TAB 6*10	1x10xTab
ZENFLOX-OZ INFUSION	1*100ML
ZENFLOX-OZ SYP	1x30xMl.
ZENFLOX-OZ TAB 12*6	1x6xTab
ZENFLOX-SR TAB 10*6	1*6TAB
ZENGAT E/D	1*5ML
ZENGAT E/OINT	1*5GM
ZENGAT P E/D	1*5ML
ZENGAT-D E/D	1*5ML
ZENICA TAB	1x10
ZENIUS DROP	1X1
ZENIUS SYP	1X100ML
ZENIUS TAB	1X10
ZENLONG 8 MG TAB	1x10
ZENLONG SR TAB	1x10
ZENLONG T CAP	1x10
ZENOM-5 TAB	1x10
ZENOTIC VIAL 80MG	1x2xMl.
ZENOTIN SYP	1x30xMl.
ZENOXA 150 TAB 10*10	1x10xTab
ZENOXA 300 TAB 10*10	1x10xTab
ZENOXA 450 TAB 10*10	1*10TAB
ZENOXA 600 TAB 10*10	1x10xTab
ZENOXA OD 150 TAB 10*10	1x10xTab
ZENOXA OD 300 TAB 10*10	1x10xTab
ZENOXA OD 450 TAB 10*10	1x10xTab
ZENOXA OD 600 TAB 10*10	1x10xTab
ZENOXIM 125 TAB 25*4	1x4xTab
ZENOXIM 250 TAB 25*4	1x4xTab
ZENOXIM 500 TAB 25*4	1x4xTab
ZENOXIM XP INJ 1.125GM	1x1xVl.
ZENOXIM XP KID INJ 250MG	1x1xVl.
ZENOXIM-XP H.S INJ500MG	1x1xVl.
ZENPRIDE OD TAB 10*10	1*10*TAB
ZENPRIDE TAB 25MG 10*10	1*10*TAB
ZENROCIN PLUS INJ.30ML	10X30ML
ZENTEL SUSP	10ML
ZENTEL-400MG TAB	1'S
ZENTOP DROPS	1x15ML
ZENTOP SYP	1x200M
ZENTOP TAB	1x15
ZENTOR 250MG	1X10T
ZENTOR 500MG	1X5T
ZENVET 100ML	100 ml
ZENVET 30ML	30 ML
ZENVET 4 BOLUS	1*4
ZENVIT 200ML SYU	200ML
ZENZOLE.TAB	1X1
ZEOF O	1X10T
ZEOF-200 TAB	1X10
ZEOF-400	1X6T
ZEOX CAP	1*10
ZEOX SYP.(100ML)	1*100
ZEOX SYP.200ML	1*200ML
ZEPAMINE TAB	1X10
ZEPAMINE TAB	1X10
ZEPODOX 1.5G VIAL	1
ZEPODOX 100 MG TAB	1x10
ZEPODOX 200MG TAB	1X10
ZEPODOX 200MG TAB	1X6
ZEPODOX 375MG VIAL	1
ZEPODOX 50MG TAB	1X10
ZEPODOX-S750MGNAIL	VAIL
ZEPODOX-SYP	1X30ML
ZEPOXIN INJ 40MG	1 VIL
ZEPTAL 200 TAB 20*10	1*10TAB
ZEPTOL 100 TAB 10*10	1*10TAB
ZEPTOL 400 TAB 5*10	1*10TAB
ZEPTOL CR-200 TAB 20*10	1*10TAB
ZEPTOL CR-300 TAB 10*10	1*10TAB
ZEPTOL CR-400 TAB 10*10	1*10TAB
ZERICEF O TAB	1*10
ZERICEF-500 TAB	1*10
ZERICORT TAB	1*10
ZERINE G - OD TAB	1X10
ZERIZOLID-600 TAB	1*10
ZEROCOF LS SYP	60ML
ZEROCOF SYP	100ML
ZERODOL CR TAB 10*10	1x10xTab
ZERODOL MR TAB 10*10	1x10xTab
ZERODOL P TAB 10*10	1x10xTab
ZERODOL PT TAB 10*10	1x10xTab
ZERODOL S TAB 10*10	1x10xTab
ZERODOL SP TAB 10*10	1x10xTab
ZERODOL SPAS TAB 10*10	1*10*TAB
ZERODOL TAB 100MG 10*10	1x10xTab
ZERODOL TH OD TAB 8MG 10*5	1*5*TAB
ZERODOL TH TAB 4MG 10*10	1*10*TAB
ZERODOL TH TAB 8MG 10*10	1*10*TAB
ZEROGEN TAB	28'S
ZEROGRAIN PLUS TAB 3*10	1*10TAB
ZEROGRAIN-10 TAB 3*10	1x10xTab
ZEROLAC POWDER	1x200 GM
ZEROLAC POWDER	1x400 GM
ZEROLER M TAB	1*10
ZEROLER TAB	1*10
ZEROLER TAB	1X10
ZEROSCAB BAR	75GM
ZEROSCAB LOTION	30ML
ZEROSTAT SPACER	
ZEROSTAT VT SPACER	1UNIT
ZEROSTONE CAPS	30CAPS
ZEROSTONE SYP	200ML
ZEROTUSS SUSP	1X100ML
ZEROTUSS SYP.	1X60ML
ZEROTUSS XP DROP	15ML
ZEROX 150MG TAB	1x10
ZEROX 50MG TAB	1x10
ZEROX LB 150	1X10
ZEROX LB 50	1X10
ZEROX M SYP	1PH
ZEROX M TAB	1x10
ZEROX SYP	1PH
ZEROX-250 TAB 10*6	1*6
ZEROX-500 TAB 10*3	1*3
ZES 30 CAPSULES	1x10
ZESAM 200MG	1X10T
ZEST CAP.	1x30
ZEST DROP.	1 PH.
ZEST POWDER	1 PH.
ZEST SYP.	1 PH.
ZEST SYRUP DIETARY FOOD	1x200ML
ZEST-M CAPS	1x10
ZESTABOLIN 25 INJ	1x1xAmp
ZESTABOLIN 50 INJ	1x1xAmp
ZESTAT 10MG TAB	1X10
ZESTAT 20MG TAB 10'S	1X10
ZESTCAL SUS 200ML	200ML
ZESTCAL SUSPENSION	1x100ML
ZESTCAL-TAB	1X30
ZESTOGRA 100 MG	1X4
ZESTOL 150 MG TABLET	1X10
ZESTOL 300 TABLET	1X10
ZESTOVIT CAP	1 CAP
ZETAX- S 1.5GM	1'S
ZETISTAT TAB	1X10
ZETITOR 10 MG TAB	1X10
ZETIVAS 10	1X10
ZETIVAS 20	1X10T
ZETIVAS 5	1X10
ZETORIN 100MG SYP	15ml
ZETORIN 250 1*6	1*6
ZETORIN 500 1*3	1*3
ZETRI VIAL 1GM	1x1xVl.
ZETRI VIAL 250MG	1x1xVl.
ZEVA SYP	1X100ML
ZEVA TAB	1X10T
ZEVANURON	1X10
ZEVERAL FORTE CAPS	1x10
ZEVERAL PLUS DROP	1x15ML
ZEVERAL SYP.200 ML.	1 PH.
ZEVERT-16 TAB 5*10	1x10xTab
ZEVERT-8 TAB 5*10	1x10xTab
ZEVIT CAP	30'S
ZEVIT DROP	30ML
ZEVIT FORTE CAP	10'S
ZEVIT SY	100ML
ZEVITAL BOLUS	10X4'
ZFLOX SYRUP	60ML
ZICOLD TAB	1x10
ZIDCEF-125MG INJ	125MG IAL
ZIDCEF-250MG INJ	250MG VIAL
ZIDOLAM N TAB	1X10
ZIDOLAM TAB	1X10
ZIFEXIM TAB 10*10	1*10*TAB
ZIFI 100 SYP 30ML	1*30ML
ZIFI CV 100DT TAB 5*10	1*10TAB
ZIFI CV 200 TAB 5*10	1x10xTab
ZIFI CV 50 SYP	1x30xMl.
ZIFI CV 50 TAB 5*10	1x10xTab
ZIFI DROP 10ML	1*10ML
ZIFI LBX 100 TAB 10*10	1x10xTab
ZIFI LBX 200 TAB 10*10	1x10xTab
ZIFI LBX(+)200 TAB 10*10	1*10TAB
ZIFI SYP	1x30xMl.
ZIFI TURBO CAP 10*6	1*6CAP
ZIFI-100 TAB 10*10	1x10xTab
ZIFI-200 TAB 10*10	1x10xTab
ZIFI-50 TAB 10*10	1x10xTab
ZIFI-AZ KID DT TAB 10*10	1*10TAB
ZIFI-AZ TAB 10*10	1*10TAB
ZIFI-O 100 TAB 10*10	1*10TAB
ZIFI-O TAB 10*10	1*10TAB
ZIFI-X 100 TAB 10*10	1x10xTab
ZIFI-X 200 TAB 10*10	1x10xTab
ZIFILAC 200 TAB 10*10	1x10xTab
ZIFRA SYP	1*60*ML
ZIG-ZAG COTTON	300 GM
ZIGA-RAB D CAP	1*10
ZIGARAB 20 TAB	1*10
ZIGARAB LS CAP	1*10
ZIGAT 200 TAB 10*5	1x5xTab
ZIGAT 400 TAB 10*5	1x5xTab
ZIGAT EYE DROP	1x5xMl.
ZIGAT-D DROPS	1*5ML
ZIGBO BOLUS	BOLUS
ZIGBO LIQUID	1LITRE
ZIGBO LIQUID	300 ML
ZIGLIN M1 TAB 20*10	1x10xTab
ZIGLIN M2 TAB 20*10	1x10xTab
ZIGLIN-1 TAB 20*10	1x10xTab
ZIGLIN-2 TAB 20*10	1x10xTab
ZIGZAG COTTON	1 PKT
ZIKEM JR SUSP	1x7.5GM
ZIL O TAB.10*10	1x10xTab
ZILAMAC 125 MG	1X1 VIAL.
ZILAST TAB 100MG 3*10	1x10xTab
ZILAST TAB 50MG 3*10	1x10xTab
ZILEE 500 TAB 10*5	1x5xTab
ZILSA VAG GEL	1*5*GM
ZIMATINIC CAP 2*15	1*15CAP
ZIMATINIC SYP	1x200xMl.
ZIMATINIC-XT SYP 150ML	1*150ML
ZIMATINIC-XT TAB 10*10	1*10TAB
ZIMIG CREAM	10GM
ZIMIG-250MG	7'S
ZIMIGUT-200 TAB 10*10	1*10TAB
ZIMIGUT-400 TAB 10*10	1*10TAB
ZIMIVIR TABS 1000MG	3'S
ZIMIVIR TABS 500MG	3'S
ZIMNIC AZ TAB 12*10	1*10*TAB
ZIMNIC AZ TAB 250MG 12*10	1*10*TAB
ZIMNIC DX TAB 12*10	1*10*TAB
ZIMNIC O TAB 200MG 12*10	1*10*TAB
ZIMNIC SYP	1x30xMl.
ZIMNIC TAB 100MG 12*10	1x10xTab
ZINC UP 100ML SYP	1*100ML
ZINCERA SY.	1X50ML
ZINCLOVIL CREAM	1*15GM
ZINCMORE SYRUP	1x100ML
ZINCOCET COUGH SYP	1X100ML
ZINCOCET-A SYP	1X100ML
ZINCOCET-P SYP	60ML
ZINCOCET-P TAB	1X10
ZINCODERM OINT	1x15xGm.
ZINCODERM-G OINT	1x15xGm.
ZINCODERM-GM OINT	1x15xGm.
ZINCODERM-M OINT	1x15xGm.
ZINCOFER NUTURE TAB 3*30	1x30xTab
ZINCOFER SYP	1x200xMl.
ZINCOFER TAB 25*10	1x10xTab
ZINCOGRAND SYP	50ML
ZINCOLIFE SYP 50ML	1x50xMl.
ZINCOLINE SUP 60ML	60ML
ZINCOLINE-BCS TAB 1*15	1*15
ZINCONIA 50	1X10T
ZINCONIA SYP	1X100ML
ZINCONIA SYRUP	50ML
ZINCOREN E/D	1*5ML
ZINCOSHINE SYP	200ML
ZINCOSHINE TAB	1*101 VIAL
ZINCOTECH	100ML
ZINCOTECH SYRUP	100ML
ZINCOTOP 200ML	200ML
ZINCOVIT DROP	1x15xMl.
ZINCOVIT SYP	1x200xMl.
ZINCOVIT TAB 5*2*15	2*15TAB
ZINCRIS SYR	60ML
ZINDAC 150MG TAB	1*10
ZINE TAB	1*10
ZINETAC INJ	2ML
ZINETAC-150MG	10'S
ZINETAC-300MG	10'S
ZING SYP	1x200ML
ZINIR 125DT TAB 10*10	1*10TAB
ZINIR-4 TAB 10*4	1*4TAB
ZINK SYP 60 ML	60ML
ZINK-20 TAB 1*10	1*10
ZINKOLA EYE DROP	1 PH.
ZINTAC 150MG	30'S
ZIORAL ORAL SOL.	1x100xMl.
ZIP CAPS	1x10
ZIP PEAD SYP 100ML	1x100ML
ZIP SYRUP 200ML	1x200ML
ZIPANT-40 TAB 10*10	1*10TAB
ZIPANT-DSR TAB 10*10	1*10TAB
ZIPCET PLUS TABLET	1X10
ZIPCET SYP 30ML SYP	1X30ML
ZIPCET TABLET	1X10
ZIPOD 200 TAB 10*10	1*10TAB
ZIPOD 50DT TAB 10*10	1*10TAB
ZIPOD-50 SYP 30ML	1*30ML
ZIPRAX 100 DT	10'S
ZIPRAX 200 DT	10'S
ZIPRAX 50 DRY SYRUP	30ML
ZIPROX 100 SY	1PHI
ZIPSYDON-20 TAB 5*10	1*10TAB
ZIPSYDON-40 TAB 5*10	1*10TAB
ZIRLON L TAB	1x10
ZIRLON TAB	1x10
ZIRLON-AH SYP	1x60ML
ZIRLON-AH TAB	1x10
ZITA-MET 50/500 MG	1X10
ZITCARE TAB	1*10
ZITHIUM 100 DT TAB.	1X3 TAB.
ZITHIUM 250	1X6T
ZITHIUM 500	1X3T
ZITHIUM DS ORAL SYP.	1X15 ML
ZITHIUM O BD	1X10 TAB.
ZITHIUM O SYP.	1X30ML
ZITHIUM ORAL SYP.	1X15 ML
ZITHIUM XL 100	30ML
ZITHIUM XL 200SYRUP	30ML
ZITHIUM-O	1X5T
ZITHROLINE CF TAB 1*10	1*10
ZITHROLINE DROP 7.5ML	7.5ML
ZITHROLINE SYP 15ML	15ML
ZITHROLINE-CF LB TAB	1*10
ZITHROLINE-XL 100	30ML
ZITHROMYCIN 250	1X6S
ZITHROMYCIN 500	1X3S
ZITHROX 100 DT	1X3T
ZITHROX 100 SUSP	15ML
ZITHROX 200 SUSP	15ML
ZITHROX 250	1X6T
ZITHROX 500	1X3T
ZITHROX LX 250	1X15T
ZITHROX LX TAB.	1X15 TAB.
ZITHROX PLUS	1X10T
ZITHROX PLUS KID	1X10T
ZITHROX XL 100 SYP.	1X30ML
ZITHROX XL 200 SYP.	1X30ML
ZITOTEC 200 TAB 5*4	1*4TAB
ZITRIAX-S 1.5GM VAIL	1 VAIL
ZITROLINE 250 1*6	1*6
ZITROLINE 500 1*3	1*3
ZIVAST 10 TAB 10*10	1*10TAB
ZIVINIX SYP	200ML
ZIVINIX TAB	10'S
ZN 20 SYP 100ML	1*100*ML
ZN 20 SYP 50ML	1*50*ML
ZN-A DROP	15ML
ZN-A SYP	100ML
ZO EYE DROP	1x5xMl.
ZO-1OO TAB 10*10	1x10xTab
ZO-200 TAB 10*10	1x10xTab
ZO-400 TAB 10*10	1x10xTab
ZO-50 SYP 60ML	1*60ML
ZO-IV 100ML	1*100ML
ZO-SOLUTION 50ML	1*50ML
ZO-T TAB 10*10	1*10*TAB
ZO-T TAB 10*6	1x6xTab
ZOBACTIN 4.5GM INJ.	VAIL
ZOBID 100ML	1 PH
ZOBID 20 100 ML	
ZOBID 20 100 ML	100 ML
ZOBID 20 MG 10 ML	20 ML
ZOBID 30ML	VIAL
ZOBID BOLUS 1X4	1X4
ZOBID M 100 ML	100 ML
ZOBID M 15 ML	15 ML
ZOBID M 30 ML	30 ML
ZOBILATE CAP	1*10
ZOCEF 1.5GM INJ	VIAL
ZOCEF 125MG TAB	1X10
ZOCEF 250MG	1X10T
ZOCEF 250MG INJ	VIAL
ZOCEF 500MG	1X10T
ZOCEF 750MG INJ	VIAL
ZOCEF CV 250MG	1X6T
ZOCEF CV 500MG	1X6T
ZOCEF CV D/S	1X30 ML
ZOCEF D/SY	1X30ML
ZOCID 20MG	1X10
ZOCID DM CAP	1X10
ZOCID GEL	1PHI
ZOCON (T) KIT 10X1	1x1xTab
ZOCON AS KIT 10*1	1*1KIT
ZOCON EYE DROP 1*5ML	1x5xMl.
ZOCON LOTION	1*5ML
ZOCON LOTION 60ML	1*60ML
ZOCON POWDER	1*50GM
ZOCON-150 TAB 10X1	1x1xTab
ZOCON-200 TAB 5X2	1x2xTab
ZOCON-400 TAB 20*1	1*1TAB
ZOCON-50 TAB 5X4	1x4xTab
ZODAM 1.125G	VIAL
ZODAM KID INJ	VIAL
ZODERM CREAM	10GM
ZODERM E CREAM	30GM
ZODERM LOTION	30GM
ZODEX BOLUS	1x4B
ZOFER INJ	1X4ML
ZOFER INJ 2ML	1X2ML
ZOFER MD-4MG	1X10T
ZOFER MD-8MG TAB	1X10
ZOFIX CV TAB 200MG 10*10	1*10*TAB
ZOFIX O TAB 10*10	1*10*TAB
ZOFIX TAB 200MG 10*10	1x10xTab
ZOFLUT CREAM	10GR.
ZOFLUT CREAM	5GR
ZOFLUT LOTION	10ML
ZOFLUT OINT.	10GR
ZOFTAMIC 100 MG	2ML
ZOFTAMIC 250 MG	2ML
ZOGLI 1MG	1X30T
ZOGLI 2MG	1X30T
ZOKILL 2.5GM	2.5GM
ZOLAM 0.25 1*10	1*10
ZOLAM 0.50 1*10	1*10
ZOLBEND 400 MG	1X1
ZOLE F SKIN OINT	1*15*GM
ZOLE-Z 1.5BOLUS	10X2'S
ZOLE-Z 3GM	10X1'S
ZOLEN 150	1*1
ZOLEX 0.25 TAB 21*10	1x10xTab
ZOLEX 0.5 TAB 21*10	1x10xTab
ZOLEX-SR 0.5 TAB 10*10	1x10xTab
ZOLFRESH TAB 10*10	1x10xTab
ZOLFRESH TAB 5MG 10*10	1*10*TAB
ZOLIN EYE DROP	1x10 ML.
ZOLINE PLUS DROP	1PH
ZOLMECTIN SUSP.	1*10ML
ZOLMIST NASAL SPRAY	70MD
ZOLNITE 1	1X10T
ZOLNITE 2	1X10T
ZOLPITECH-5 TABLET	1*10
ZOMAR SUSP. 30 ML	30 ML
ZOMARK P	1X10
ZOMARK PM	1X10
ZOMET EYE DROP	1PH
ZOMET NASAL DROP	1PH
ZOMET PEDIATIC DROP	1PH
ZOMITAC DSR	1x10
ZOMITAC TAB	1x10
ZOMNIA	1X10T
ZOMYT-100 SYP	15ML
ZOMYT-250TAB	1X10TAB
ZOMYT-500TAB	1X3TAB
ZONA 0.25 TABLET	1X10
ZONA 0.5 TABLET	1X10
ZONA 1 TABLET	1X10
ZONA 2 TABLET	1X10
ZONAMAX ES	1XV
ZONAMAX INJ 1GM	1X1
ZONAMAX PS	1X1V
ZONAT DROP	5ML
ZONAXID	1X6
ZONAXID DT TAB	1X6
ZONAXID SUSP	1X30ML
ZONAZEP 0.25 MG TBALET	1X10
ZONAZEP 0.50 MG TBALET	1X10
ZONAZEP 1 MG TBALET	1X10
ZONAZEP 2 MG TBALET	1X10
ZONISEP 100 TAB 5*10	1*10TAB
ZONISEP 25 TAB 5*10	1*10TAB
ZONISEP 50 TAB 5*10	1*10TAB
ZOOM OIT 25 GM	1 tub
ZOPENT-DSR CAP	1x10
ZOPENTA ER 12.5	1X10T
ZOPENTA ER 6.25 MG.	1X10 TAB.
ZORDOX TAB	10'S
ZOREM 2.5 CAP 10*10	1x10xCap
ZOREM 2.5 CAP 10*15	1*15CAP
ZOREM 5 CAP 10*10	1x10xCap
ZOREM 5 CAP 10*15	1*15CAP
ZOREM HT-2.5 TAB 10*10	1x10xTab
ZOREM HT-5 TAB 12*10	1x10xTab
ZOREM LT 2.5 TAB 10*10	1x10xTab
ZOREM LT 5 TAB 10*10	1x10xTab
ZOREM PLUS-2.5 CAP 10*10	1x10xCap
ZOREM PLUS-5 CAP 10*10	1x10xCap
ZOREM-TH TAB 5*10	1x10xTab
ZORIL M1 10*15 TAB	1*15TAB
ZORIL M1 FORT TAB 10*10	1x10xTab
ZORIL M2 10*15	I*15TAB
ZORIL M2 FORT TAB 10*10	1x10xTab
ZORIL M3 10*10	1*10TAB
ZORIL M4 10*10	1*10TAB
ZORIL M4 FORT TAB 10*10	1*10TAB
ZORIL MP1 TAB 10*10	1x10xTab
ZORIL MP1 TAB 10*15	1*15TAB
ZORIL MP2 TAB 10*10	1x10xTab
ZORIL MP2 TAB 10*15	1*15TAB
ZORIL MV-1 TAB 10*10	1*10TAB
ZORIL MV-2 TAB 10*10	1*10TAB
ZORIL-1 MG TAB 20*15	1*15TAB
ZORIL-2 MG TAB 20*15	1*15TAB
ZORIL-3 MG TAB 20*15	1x15xTab
ZORIL-4 MG TAB 20*15	1x15xTab
ZORIL-MP-LD1 10*10	1*10TAB
ZORIL-MP-LD2 10*10	1*10TAB
ZORIL-MP2 10*15TAB	1*15TAB
ZORIL-MP2 FORTE 10*10	1*10TAB
ZORIP-DSR 1*10	1*10
ZORNO SYP 30ML	1*30ML
ZORNO TAB 10*10	1*10TAB
ZOSEC S 40MG TAB	1X10
ZOSEC-PRO CAP	1X10
ZOSECTA DSR	1x10
ZOSECTA TAB	1x10
ZOSERT 100 TAB 10*10	1*10TAB
ZOSERT 25 TAB 10*10	1*10TAB
ZOSERT 50 TAB 10*10	1*10TAB
ZOSPAR-100 TAB 10*6	1x6xTab
ZOSPAR-200 TAB 10X6	1x6xTab
ZOSTUM 1.5 GM	1XV
ZOSTUM 2GM INJ.	1XVIAL
ZOSTUM 3GM	1XV
ZOSTUM 500MG INJ	VIAL
ZOSTUM INJ 1GM	1XVIAL
ZOSTUM-O TAB	1X6T
ZOTADIN INJ	1 VIAL
ZOTRA 200 MG	1*10
ZOTRA SUSP.	1*60ML
ZOTRA-OZ SYP	1*30ML
ZOTRA-OZ TAB	1*10
ZOTUM 250 TAB	1*10
ZOTUM 500 TAB	1*10
ZOVANTA-40 TAB 5*10	1*10TAB
ZOVANTA-D CAP 5*10	1*10CAP
ZOVAX 250 TAB	1x10
ZOVAX 500 TAB	1x10
ZOVIRAX OPTH.OINT.	5GM
ZOVIRAX SUSP	100ML
ZOVIRAX-200MG	5'S
ZOVIRAX-400MG	10'S
ZOVIRAX-800MG	5'S
ZOVULES SYP	1X60ML
ZOXAKIND-O SYP 1*30ML	1x30xMl.
ZOXAN (D) DROP	1x10xMl.
ZOXAN 500 TAB 20*10	1x10xTab
ZOXAN EYE DROP	1x5xMl.
ZOXAN EYE OINT.	1x3xGm.
ZOXAN(TZ) TAB 10*10	1*10TAB
ZOXAN(TZ)TAB 5*10	1x10xTab
ZOXAN-250 TAB 20*10	1x10xTab
ZOXAVIT PLUS TAB	1X10
ZOXAVIT SYP	1X200ML
ZOXAVIT TAB	1X10
ZOXAVIT-DROP	1X30ML
ZOXIN 1GM INJ	1 VAIL
ZOXIN S 1.5GM INJ	1VAIL
ZOXIN S 375MG INJ	1VAIL
ZTK CL DEO SPRAY	200ML
ZTK SPICY DEO SPRAY	200ML
ZUBACEF 250MG	1VIAL
ZUBION 20ML	20ML
ZUBION 2ML	2ML
ZUCAMAR M 500	1*10
ZUCOX 4	1x4
ZUFLO 200 MG	1X10
ZUFLO D EYE EAR DROP	10 ML
ZUFLO EYE/EAR DROP	10 ML
ZUGMACAL 5LT	1X4X5LT
ZUGMACEF 2GM INJ.	VIAL
ZUGMACEF 3GM INJ.	VIAL
ZUGMAGENT 30ML INJ.	1X30ML
ZUGMATONE 3ML INJ.	1X3ML
ZUGMAVIT 60ML.	1*60ML
ZUGMIN GOLD 3KG	1X3KG BAG
ZUGMINGOLD 1KG	1X1KG
ZUGMOX 2GM INJ.	COBIPACK
ZUGMOX 3GM INJ.	COMBIPACK
ZUGMOX 4GM INJ.	COMBIPACK
ZUKAMIN DROP	10ML
ZUKAMIN SYP	1*60ML
ZUKAMIN TAB	1*10
ZULU TAB	1X10
ZULU TAB	1X10
ZUPAR SUSP	60ML
ZUPAR TAB	10'S
ZUPION SR TAB 10*10	1*10TAB
ZURI SYP	100ML
ZUVOG 0.2	1X10T
ZUVOG 0.3	1X10T
ZUVOG M 0.2	1X10T
ZUVOG M 0.3	1X10T
ZXYLO 1.5GM	VIAL
ZXYLO 1GM	VIAL
ZXYLO 250MG ING	VIAL
ZXYLO 500MG	VIAL
ZXYLO-375MG	VIAL
ZXYLO-T250	VIAL
ZY 10 ACTIVE	1*10
ZY-10 FORTE TAB 10*10	1x10xTab
ZYCIUM TAB 10*10	1*10*TAB
ZYCLIN NNOGEL	1*1
ZYCLOZ BOLUS	1x4B
ZYDACEF 4 GR	4 GR
ZYDAQUIN 100 GR	100 GR
ZYDAQUIN 25 GR	25 GR
ZYGOCEF O TAB	1X10T
ZYGOCEF-AZ	1X10
ZYLEM SYP.	1X100ML
ZYLENO FORTE TAB 10*10	1*10TAB
ZYLERA M TAB 10*10	1*10*TAB
ZYLERA TAB 20*10	1x10xTab
ZYLINTUS BM DROP	1PH
ZYLINTUS BM SYP	1PH
ZYLINTUS SYP	1*100ML
ZYLOCAL CAP	1*10
ZYLOCAL-D3 NEW	1*15
ZYLODENT MOUTH WASH	100ML
ZYLOFENAC-PLUS	1*10
ZYLOFENAC-SP	1*10
ZYLOLIV S CAP	1*10
ZYLOMENTIN 375	1*6
ZYLOPRED	5ML
ZYLORIC TAB 300MG	10'S
ZYLORIC-100MG	10'S
ZYLOTAL	1*10
ZYLTAN 25 TAB	1*10
ZYLTAN 50 MG TABLET	1x10
ZYLTAN AM TABLET	1X10
ZYLTAN H TABLET	1x10
ZYMACE	200ML
ZYMAR 0.3%	5ML
ZYMAR OINT	5GM
ZYMASER SYP	1X200ML
ZYMASER TAB	1X10
ZYMAXID 0.5%	2.5ML
ZYMEGA-100ML	1x100ML
ZYMEGA-200ML	1x200ML
ZYMEX DROP	15ml
ZYMIN DRY SYP	30GM/60ML
ZYMNET 100 ML	100 ML
ZYMNET 200 ML	200 ML
ZYMNET DROP 60ML	60ML
ZYMOCAL CAP	1X10CAP
ZYMOCON SUS	200ML
ZYMOFLAM	1X10T
ZYMOFLAM D	1X10T
ZYMOFLAM FORTE	1X10T
ZYMOGEM DROP 15 ML.	1 PH.
ZYMOGEM MANGO SYP	200 ML.
ZYMOGESIC TAB 24*10	1*10*TAB
ZYMOHEAL SYP	200ML
ZYMOLIFE DROP	30ML
ZYMOLIFE SYP	200ML
ZYMOLYSIN 100ML SYP	1 PH
ZYMOLYSIN 200ML SYP	1x200ML
ZYMOLYSIN DROP	15 ML
ZYMOVENT SUP	200ML
ZYMOVENT SYP	100ML
ZYMOWEN SYP	100ML
ZYNAC GEL	1x30xGm.
ZYNAC INJ	1x5xAmp
ZYNAC P TAB 10*10	1x10xTab
ZYNAC SP TAB 10*10	1x10xTab
ZYNAC SR TAB 10*10	1x10xTab
ZYNCET SYP.60ML/UN	U
ZYNCET TAB.10'S/UN	U
ZYPON SYU	200ML
ZYPON- 200ML SYP	200ML
ZYRCOF SYP	100ML
ZYRCOLD COUGH SYP	1X100ML
ZYRCOLD TAB	1X10
ZYROF AMP	5x2ML
ZYROP 2K VIAL	
ZYROP INJ 2000	1x1xVl.
ZYROP INJ 3000	1*1*PC
ZYROP INJ 4000	1x1xVl.
ZYROTRAM 100 INJECTION	1X2 ML
ZYRTEC D	1X10C
ZYRTEC DROPS	1X10ML
ZYRTEC SYP	60ML
ZYRTEC TAB	1X10
ZYRTEC-OD	1X10T
ZYRULINA 10'T	
ZYSEPT 100 ML	1
ZYSEPT 500 ML	1
ZYSIM DROP	1X15ML
ZYSIM SYP	1X100ML
ZYSIM-P SYP	1X100ML
ZYTEE GEL	1x10 ML
ZYTEE LOTION	1x10 ML
ZeeNatal Capsules	1x15
Zione DS L tab	1x10
Zione DS O20 tab.	1x10
Zione DS O40 tab.	1x10
Zione L tab	1x10
Zione O20 tab	1x10
clomox d3gm	
collaflex tab	1x10t
dezacor 12	1x10t
ducon 200mg	1X10
ecef-of tab 1*10	1*10
febucip 40	1x10
fineheal tab	1x10
kemcef-200	1*10
kufma syp	1ph
oceft-s	1vial
pregadoc sr 75	1x10t
pregalin sr 150	1x10
pregalin sr 75	1x10
relysin-z	15ml
torget 20	1x10t
valzyme syp	200ml
yasmin	1x10t
zolmectin tab	1*1
INDOCAP SR CAP	1X10
REGESTRONE Tab	1X10
VELOZ D CAP	1X10
VIZYLAC CAP	1X15
NITRO 2.6 Tab	1X30
ROSUVAS 10 MG Tab	1X15
DOLO 250 SYP	60ML
GLUFORMIN G2 Tab	1X15
DUPHALAC 450 ML SYP	1X450ML
SELIQUA 300IU PEN	1X1
TELMA-20 Tab	1X15
KARVOL PLUS CAP	1X10
EVION 400 MG CAP	1X10
AUGMENTIN 625 MG Tab	1X10
CCM Tab	1X30
TAXIM-O 200 Tab	1X10
PANKREOFLAT Tab	1X15
DIOVOL LA SYP	1X170M
URIMAX-D Tab	1X15
JANUMET 50/500 MG Tab	1X15
ACILOC 300 Tab	1X20
ZIFI 100 MG SYP	30ML
LACTOGEN-4 R.P	1X400
AMULSPRAY 500 TIN	1X500
ALZIL M 5 MG TAB	1X10
I-KUL PLUS 15 ML DROP	1X10ML
BORO-PLUS 9ML CREAM	1X9ML
CETANIL T TAB	1X10
HEPTAGON TAB	1X10
FUBOX 40MG TAB	1X15
VILPOWER DM 500 TAB	1X10
RAPEED L PLUS CAP	1X10
UNWANTED KIT KIT	1KIT
GRINLICTUS SYP	100ML
D.SAT ISABGOL 100 	1X100
D.SAT ISABGOL 50 	1X50
HAJMOLA JAR 6 	1X1
Wysolone 10 MG DT TAB	1X15
VYLDA M 500 MG TAB	1X10
UNISTAR 20/75MG CAP	1X10
ARBITEL TRIO 50 TAB	1X10
GLYCOMET TABS TAB	1X10
LIPITABE GOLD 20 TAB	1X10
TRIGLIMICURE TAB	1X10
NEURO CDE TAB	1X10
ONABET-CREAM 30GM CREAM	1X30GM
TELMA-H TAB	1X15
ACECLO MR TAB	1X10
PERCIN TAB	1X5
MAXRICH E Lotion	1x100ML
ASOMEX 5MG TAB	1X15
ASOMEX TAB	1X15
ASOMEX TAB	1X15
LIBRIUM 10MG TAB	35X15
ECOSPIRIN GOLD 10 CAP	1X15
ECOSPIRIN GOLD 20 CAP	1X15
ULTRACET TAB	32X10
PAN-40 INJ	1VIAL
MIKACIN 500MG INJ	1X7ML
HEPTAGON SYP	1X100
TOREX 100 ML SYP	12X10
UNIENZYME 200ML SYP	36X20
CHESTON COLD TAB	25X10
RAXIPRESS 5 TAB	1X10
ASTHAN IN 2 TAB	1X30
O2 TAB	1X10
TELMED 20 TAB	1X10
TELI 20 TAB	1X10
JANUVIA 100 MG TAB	1X7
CLAVAM 625 TAB	1X10
CLAVAM DRY SYP	30ML
CLAVAM BID SYP	30ML
TAXIM-O SYP	30ML
NEWCITA LITE TAB	1X10
VOGLI 0.2 TAB	1X10
OPTIVE 10ML EYE DROP	1X10ML
RANOLAZ 500MG TAB	1X15
DEPLATT A 75MG TAB	1X15
MET-XL 25MG TAB	1X20
ROSUVAS 40MG TAB	1X10
PREVA GOLD TAB	1X15
MONTINA L 30ML SYP	1X30ML
DILZEM SR TAB	1X15
CHYMORAL FORTE TAB	1X20
OROFER XT TAB	1X15
MEGAPEN 500MG CAP	1X10
ARISTOZYME LIQUID	200ML
GALVUS 50MG TAB	1X15
ASCORIL LS SYP	1X100ML
POLYBION ACTIVE 150ML SYP	1X150ML
PANTOP DSR CAP	1X15
PANTOP 40MG TAB	1X15
DO-RE-ME 25MG TAB	1X10
WALAPHAGE SR 500MG TAB	1X15
ASOMEX AT 2.MG TAB	1X15
CLONOTRIL 0.25MG TAB	1X15
REVELOL-XL 25 TAB	1X10
NICARDIA-XL 30 TAB	10X10
MONIT GTN 2.6 VIAL	1PH
PILEX TAB	1PH
PEXEP PLUS 12.5 TAB	1X10
ONDEM MD4 TAB	1X10
ZYVEN OD 50MG TAB	1X10
SEROFLO 250 INHALER	1PH
TOVAXO E/D	1PH
GEPRIDE M-D4 FORTE TAB	1X10
PAN 40 TAB	1X15
REMISTAR 5 TAB	1X15
TELMA 40 TAB	1X30
LIV 52 DS LIQUID	1X200
COBADEX CZS TAB	1X15
SILYBON 140 TAB	1X10
REJUNEX CD3 NF TAB	1X10
OMEZ DSR CAP	1X15
ONDEM MD4 TAB	50X10
AMARYL 1MG TAB	1X30
ONDEM MD4 TAB	1X10
GEPRIDE M-D4 FORTE TAB	1X10
FERONIA XT TAB	1X15
MONTINA L TAB	1X10
LEVOCET TAB	1X10
CILACAR 10MG TAB	1X15
HAPPI D TAB	1X10
METOLAR XR 25MG TAB	1X15
AZITHRAL 500MG TAB	1X5
RABLET D CAP	10X10
AP DROP	1PH
TAXIM-O 200 TAB	1X10
FEBUTAZ 40MG TAB	1X15
REPACE 25MG TAB	1X10
PRAZOPRESS-XL 2.5MG TAB	1X30
CLOPILET A 75MG TAB	1X15
URIMAX 0.4MG CAP	1X20
AZTOR 10MG TAB	1X15
ZERODOL SP TAB	1X10
AZTOR 20MG TAB	1X15
GLUCONORM PG2 FORTE TAB	1X15
GLUCONORM PG 2MG TAB	1X15
MAXTRA SYP	60ML
AMIXIDE H TAB	1X10
SEROFLO 250 INHALER	1PC
AZITHRAL 500MG TAB	1X5
LONAZEP 0.25MG TAB	1X15
ISTAMET 50/1000MG TAB	1X15
NEXITO PLUS TAB	1X10
KORANDIL 5MG TAB	1X10
PROLOMET XL 50MG TAB	1X15
VOAGE M 10/500MG TAB	1X10
RANOLAZ TAB	1X15
JANUVIA 100 MG TAB	1X7
GEMER DS 2MG TAB	1X15
AMARYL MP 2MG TAB	1X15
STATOR 20 TAB	1X15
Flagyl 400 MG TAB	40X15
CETRIZ 60 ML SYP	1X60ML
TRINERVE LC CAP	10X10
ACILOC 150MG TAB	30X30
Azee 500 TAB	1X5
CIPLACTIN 4MG TAB	1X15
CIPLOX 500 TAB	1X10
THEO ASTHALIN TAB	60X30
DUOLIN ROTOCAP CAP	1X60
MONTAIR LC TAB	1X15
AEROCORT FORTE CAP	1X30
GRINLICTUS BM SYP	1X100ML
IODEX 16GM BALM	1X16GM
NEW CROCIN 650MG ADV TAB	25X15
OSTOCALCIUM PLUS TAB	1X30
THYROX 62.5 TAB	1X100
ETIZOLA PLUS TAB	1X10
TELIMAC-20 TAB	1X10
BEVON SYP	1X200ML
MAXTRA P SYP	1X60ML
AMLODAC 2.5MG TAB	1X30
ALTHROCIN 500MG TAB	1X10
URIMAX 0.4MG CAP	1X20
ROZAT F 10MG TAB	1X10
ROZAT F 10MG TAB	1X10
STAMLO 5MG TAB	1X30
GRINLINCTUS DX SYP	1X100ML
BETNOVATE N CREAM	1X25GM
TENLIMAC-M 500 TAB	1X15
MAPRAZYME LIQUID	1X200ML
INFLUVAC TETRA SH INJ	1X0.5M
DISPO 05ML INJ	1X1
LASILACTINE 50 TAB	1X10
BETADINE 100ML SOL	1X1
ALKACITRON 100ML SYP	1X1
SORBITRATE 5MG TAB	1X50
MULTIVITE FM OMEGA TAB	1X30
NOVOMIX 30 PENFILL	5X30ML
PENTIIDS 800 TAB	1X10
THEO ASTHALIN TAB	1X30
REMIPRES 5 TAB	1X10
NICARDIA-XL 30 TAB	1X10
THYROX 50 TAB	1X20
ARBITEL-20 TAB	1X10
VOGIL-M 0.3 TAB	1X10
VOBOSE-0.3 TAB	1X10
WALAPHAGE SR 500MG TAB	1X10
EUCLIDE-M 30 OD	1X10
CANESTEN CREAM	1X30GM
UDILIV 300MG TAB	1X15
GEMER FORTE 1MG TAB	1X10
DONAMEM 10MG TAB	1X10
ADMENTA 5MG TAB	1X10
RANIDOM RD TAB	1X10
TAXIM-O SYP	30ML
Neosprin Oin	5 GM
Flagyl 400 MG Tab	1 Box
Ciplox D Eye D	1 Pcs
A to Z 200 ML Syp	1 PHY
A to Z 100 ML Syp	1 PHY
Benadryl 150 Liq	1 PHY
Digene Gel	1
Aptivate Syp	1 PHY
Cypon Syp	200ML
Vertin 8 MG Tab	1 BOX
Betnovate C Oin	30 GM
Asthakind Syp	1 PHY
Flagyl 60 ML Syp	1x60
Vertin 16 Tab	1x15
Cetriz 60 ML Syp	1x60
Aristozyme Cap	10x15
Azee 500 Tab	1x5
Grilinctus BM Syp	1x100
T-Bact 5 GM Oin	1x5
Brozedex SF Syp	1x100
Grilinctus P Syp	1x60
Betnovate GM Cream	1x20
Trenaxa Cream	5x5
Glycomet GP 3 Forte Tab	1x10
Betadine Gargle	1x100
PAN MPS SYP	1 PH
MEGAPEN 500 MG CAP	1BOX
BECOSULES CAP	1BOX
DEXONA 2 ML VIAL	1VIAL
UNIENZYME Tab	1BOX
OROFER XT Tab	1BOX
ZERODOL MR Tab	1BOX
CREMAFIN SYP	200ML
MVI AMP	1BOX
DUPHALAC 150 ML SYP	1PHY
CLAVAM DRY SYP	1X30
VIDAS D M 50/1000 Tab	1X10
Dolo-650 Tab	1
Meftal Spas Tab	1x10
P-40 DSR Cap	20x10
Telmed AM Tab	1x10
Telmed 40 Tab	1x10
Grilinctus Syp	100 ML
Asthakind DX Syp	100 ML
GEPRIDE R2 Tab	1X10
Aristozym Syrup	1X200 ML
Combliflam Tablet	
Thyrox 62.5 Tablet	1X100
Clavam Dry Syrup Syrup	1X30
Clavam BID D/S Syrup	1X30
Sinarest New Tablet	1X15
Betadine Gargle	1X100
Roxid-150 Tablet	1X10
Aciloc AD-20 Tablet	1X24
Manforce-100 Tablet	1X4
Uprise D3 Drop	1X15
Dolo-120 Suspension	1X100
Livogen CapTab	1X30
Bicosules Syrup	1X200 ML
Arkamin Tablet	1X30
Ultracet Tablet	1X15
Urimax-D Tablet	1X15
Ursocol-300 MG Tablet	1X15
Gluconorm G-2 Tablet	1X15
Piriton CS Syrup	1X100 ML
Levoflox 500 MG Tablet	1X10
Atarax 10 MG Tablet	1X10
Augmentin Duo Syrup	1X30 ML
Gabaneuron NT 400 Tablet	1X10
Glipon MF 20/500 Tablet	1X10
Folinext Tablet	1X10
Gluconorm G-2 Tablet	1X15
Thromrophob Ointment	1 Tube
Amlosafe 5 Tablet	1X15
Vertin 16 Tablet	1 Box
Dolo 650 Tablet	1 Box
Benadryl 50 ML Syrup	1 Phyl
Dexorange Capsule	1 Phyl
Pantocid 40 Tablet	1 Box
Ornof Tablet	1 Box
Aceclo Plus Tablet	1 Box
Amlosafe 2.5 Tablet	1 Box
Ambrodil S Syrup	1 Phyl
Asthalin Inhaler	1 Phyl
Benadryl 150 ML Syrup	1 Phyl
Pantop-D SR Capsule	1 Box
Betnovate-N Ointment	20 GM
Almox 500 Tablet	20X15
Cyston Tablet	1 Box
Volini Gel	1 Tube
T-Bact 5 GM Ointment	1 Tube
Kayam-Churan 100 GM powder	1 Bottle
Vicks Inhaler	1 Tube
Moov 20 GM Ointment	1 Tube
Saridon Tablet	1 Box
Becosules Capsule	1 Box
Electral B Powder powder	1 Box
Zincovit Capsule	1 Box
Mycoderm Powder	1 Box
Ascabiol 50 ML Emulsion	1 Phyl
Calpol 250 MG Syrup	1 Bottle
Lukol Tablet	1 Box
Meganeuron Od Plus Capsule	10x10
Bett Ampoules (Be) Injection	120x0.5ml
Osteofos 70 Tab	1x10
Zedex Syrup	1x100ml
Grilinctus Ls Syrup	1x100ml
Grilinctus Dx Syrup	1x100ml
Neosporin Powder	1x10gm
Zentel Tab	100x1
Betnovate Gm Cream	1x20gm
Neosporin Ointment	1x10gm
Tenovate Gn Cream	1x20gm
Tenovate M Cream	1x15gm
Growmed Ad Syrup	1x100ml
Benadryl 150Ml Syrup	1x150ml
Saridon T Tab	22x1 (21+1 strip)
Clot Xl-500 MG Tab	10x10
Ursocol 150 MG Tab	1x15
Unienzyme Tab	20x15
Digene Syrup	1x200ml
Duphalac 150Ml Syrup	1x150ml
Thyronorm 50 Tab	1x100
Clavam Dry Syrup	1x30ml
Ondem 4 Mg Tab	50x10
Pan D Capsule	10x15
A To Z 200Ml Syrup	1x200ml
Noworm Suspension	1x10ml
Taxim-O Dry Syrup	1x30ml
Pantop D Capsule	10x15
Flexon Mr Tab	10x10
Gabaneuron Nt 400 Tab	1x10
Telvas Am Tab	10x15
Glimiprex Mf Tab	10x15
Dulcoflex Tab	45x10
Levolin Syrup	1x100ml
Cresar 40Mg Tab	1x10
Foracort 400 Inhaler	1x1
Montair LC Tab	1x15
Asthalin Inhaler	1x1
Amlopres 5 Mg Tab	1x30
Dexorange Syrup	30x200ml
Grilinctus BM Syrup	1x100ml
Crocin Drops	1x15ml
Eno Lemon Powder	60x5gm
Iodex-8 GM Ointment	1x8gm
Mucaine Gel Mint Gel	1x200ml
Zerodol P Tab	10x10
Thyrox 100 Tab	1x100
Thyrox 50 MG Tab	1x100
Telmikind 40 Tab	12x10
Unwanted Kit Kit	1
Vomikind Md 4 Tab	10x10
Vomikind Md 2 Tab	6x10
Vomikind Syrup	1x30ml
Betamil GM Cream	1x30gm
Ring Gard 12 GM Ointment	1x12gm
Shelcal Syrup	1x200ml
Azithral 200 Syrup	1x15ml
New Livfit Syrup	1x200ml
Zincovit Tab	1x15
Amlosafe 2.5 Tab	20x10
Prosgard D8 Syrup	1x60
Geminor M1 Forte Tablet	1x10
Renolog Tablet	1x15
Lonazep-0.5 Tablet	1x15
Pentid 400 MG Tablet	1x10
Ultracet Tablet	1x15
Combliflam Tablet	1x20
Azithral 200 MG Syrup	1x15
Karvol Plus Capsule	1x15
Aciloc 300 MG Tablet	1x20
Taxim O CV 200 MG Tablet	10 Tab
Taxim O Forte Syrup	60 ML
Zerodol SP Tablet	10 Tab
Zyloric 100 MG Tablet	10 Tab
A to Z Syrup	200 ML
Noworm Suspension	10 ML
Lantus Cartridge	3 ML
Ondem MD4 Tablet	10 Tab
Lumerax 80 Tablet	6 Tab
Crocin 120 Suspension	60 ML
Lantus Solostar Cartridge	3 ML
Betadine Solution	100 ML
Human Mixtard 40 Suspension	10 ML
Stayfree 6-XL Pads	1X1
Stayfree 18-XL Pads	1X1
Whisper 6-XL Pads	1X1
Whisper 18-XL Pads	1X1
BD Pen Needle 4 MM Needle	1X1
Amitone 10 MG Tablet	1X10
Candid 120 GM Powder	1X120 GM
Rosuvas 5 MG Tablet	1X15
Candibiotic Plus Ear Drop	1X5 ML
Rosuvas 10 MG Tablet	1X15
Decolic Suspension	1X50 ML
Azithral 100 MG Syrup	15 ML
Azithral 200 MG Syrup	15 ML
Glycomet GP 3 Fort Tablet	10 Tab
Glycomet GP 3 Fort Tablet	10 Tab
MVI Ampoule	1X10
Meftal Spas 60 ML Syrup	60 ML
Meftal Spas Tablet	1X10
Rosulip 5 Tablet	1X15
R.B Tone Syrup	200 ML
KZ Lotion Lotion	50 ML
Montair LC Kid Syrup	60 ML
Vidaglo M 50/1000 Tablet	1X10
Strepsils Lozenges	12X25
Veet Cream Dry Cream	25
Aptamil Gold 2R Powder	1X24
Vicks Jar 275 Lozenges	32X275
Dettol 60 ML Liquid	6X25
Karvol Plus Capsule	36X18
Zandu Balm 10 GM Balm	20X20
Savlon 50 ML Liquid	12X12
Dexolac 2 Powder	30X400 GM
Aptamil Gold 1R Powder	24 Pcs
Lal Tail 100 ML Oil	60100 ML
Himalaya Baby Powder Powder	72X1
Montair LC Tablet	1X10
Volini Gel 30 GM Gel	1X30
Ciplox Eye/Ear Drop	1X1
Monocef-O 100 Syrup	1X30
Betnovate-N Ointment	1X1
Betnovate-C Ointment	1X1
Allegra M Tablet	1X10
Gabaneuron SR Tablet	1X10
Voveran Emulgel Gel	1X30 GM
Clavam 375 MG Tablet	1X10
Nevelon Tablet	1X21
Zifi Dry Syrup	1X30 ML
Bilafav 20 MG Tablet	1X10
Monocef-O 50 Dry Syrup	1X30 ML
Telmed AM Tablet	1X10
Ciplox-D Eye Drop	5X5
Waxort Ear Drop	10X10
Calpol Ped Drops	1X15 ML
Tryptometer 25 MG Tablet	1X30
CCM Tablet	1X40
Telma 40 Tablet	1X30
Trenaxa MF Tablet	1X6
Geminor-MP2 Tablet	1X15
Johnson Baby Oil	1X1
Dr. Ortho 60 ML Oil	1X1
Cetcip Tablet	10X10
Medisalic Soap	100X1
Ketocip Soap	12X10
Medisalic Ointment	12X20
Bilast FBS-20 Tablet	10X10
Azithral 200 ml Syrup	1x60
Montina L Syrup	1x10
Avomin Tab Tablet	1x10
Mifigest Kit Kit	1
Pan 40 Tablet	1x15
A to Z Syrup	1x200 ml
Bilypsa Tablet	1X10
ZendXA-300 MG Tablet	1x10
ZendXA-600 MG Tablet	1X10
Levera 750 MG Tablet	1X10
Gepride M1 Tablet	1X10
Rifagut 500 MG Tablet	1X10
Istamet XR 100/1000 Tablet	1X10
Amlong MT-50 Tablet	1x15
Nexito Forte Tablet	1x10
Montina L Tablet	1X10
Predmet 4 MG Tablet	1
Carilium Tab	10X1X15
Zerodol P Tab Tab	10x10
Shelcal 500 Syrup	1x15
Nucoxia 90 Tab Tab	1x10
Ultracet NRX Tab	1X15
Taxim-O 200 MG Tab	1x10
Itradila 200 Cap	1x10
Itradila100 Cap	1x10
Alkacitrol 100 ML Syrup	1x100
Montas-L Tab	1x10
Ascoril D Plus Syrup	1x100
PANTOP - D SR CAP	1 BOX
ROXID 150MG TAB	1 x 10
COREX DX ( L )	100ML
MONTICOPE TAB	1BOX
MEGAPEN 500MB CAP	1 B0X
LOMOFEN TAB	1 B0X
AMLOSAFE AT TAR	1 B0X
THROMBOPHOB DINT	1 TUBE
CLAVAM 625 TAB	1 x 10
MINICYCLIN CAPS	1BOX
BENADRYL - 150 ML	1 PH
NIFTAS TAB Tab	1X10
DRUTIN - M TAB Tab	1X10
THYROX 100MG Tab	1X100
THYROX 75MG Tab	1X30
MONTINA L TAB Tab	1x10
QUADRIDERM RF CREAM Cream	1x10
DOXINATE Tab	1x30
CIPLAR LA 20 Tab	1X15
CIPLAR LA 40 Tab	1X15
GEPRIDE R2 Tab	1X10
VIDAS D M 50/1000 Tab	1X10
Dolo-650 Tab	1
Meftal Spas Tab	1x10
P-40 DSR Cap	20x10
Telmed AM Tab	1x10
Telmed 40 Tab	1x10
Grilinctus Syp	100 ML
Asthakind DX Syp	100 ML
Neosprin Oin	5 GM
Flagyl 400 MG Tab	1 Box
Ciplox D Eye D	1 Pcs
A to Z 200 ML Syp	1 PHY
A to Z 100 ML Syp	1 PHY
Benadryl 150 Liq	1 PHY
Digene Gel	1
Aptivate Syp	1 PHY
Cypon Syp	200ML
Vertin 8 MG Tab	1 BOX
Betnovate C Oin	30 GM
Asthakind Syp	1 PHY
Flagyl 60 ML Syp	1x60
Vertin 16 Tab	1x15
Cetriz 60 ML Syp	1x60
Aristozyme Cap	10x15
Azee 500 Tab	1x5
Grilinctus BM Syp	1x100
T-Bact 5 GM Oin	1x5
Brozedex SF Syp	1x100
Grilinctus P Syp	1x60
Betnovate GM Cream	1x20
Trenaxa Cream	5x5
Glycomet GP 3 Forte Tab	1x10
Betadine Gargle	1x100
PAN MPS SYP	1 PH
MEGAPEN 500 MG CAP	1BOX
BECOSULES CAP	1BOX
DEXONA 2 ML VIAL	1VIAL
UNIENZYME Tab	1BOX
OROFER XT Tab	1BOX
ZERODOL MR Tab	1BOX
CREMAFIN SYP	200ML
MVI AMP	1BOX
DUPHALAC 150 ML SYP	1PHY
CLAVAM DRY SYP	1X30
INDOCAP SR CAP	1X10
REGESTRONE Tab	1X10
VELOZ D CAP	1X10
VIZYLAC CAP	1X15
ROSUVAS 10 MG Tab	1X15
DOLO 250 SYP	60ML
GLUFORMIN G2 Tab	1X15
DUPHALAC 450 ML SYP	1X450ML
SELIQUA 300IU PEN	1X1
TELMA-20 Tab	1X15
KARVOL PLUS CAP	1X10
EVION 400 MG CAP	1X10
AUGMENTIN 625 MG Tab	1X10
CCM Tab	1X30
TAXIM-O 200 Tab	1X10
PANKREOFLAT Tab	1X15
DIOVOL LA SYP	1X170M
URIMAX-D Tab	1X15
JANUMET 50/500 MG Tab	1X15
ACILOC 300 Tab	1X20
ZIFI 100 MG SYP	30ML
LACTOGEN-4 R.P	1X400
AMULSPRAY 500 TIN	1X500
AMULSPRAY 500 TIN	1X500
ALZIL M 5 MG TAB	1X10
I-KUL PLUS 15 ML DROP	1X10ML
BORO-PLUS 9ML CREAM	1X9ML
CETANIL T TAB	1X10
HEPTAGON TAB	1X10
FUBOX 40MG TAB	1X15
VILPOWER DM 500 TAB	1X10
RAPEED L PLUS CAP	1X10
UNWANTED KIT KIT	1KIT
GRINLICTUS SYP	100ML
D.SAT ISABGOL 100	1X100
D.SAT ISABGOL 50	1X50
HAJMOLA JAR 6	1X1
Wysolone 10 MG DT TAB	1X15
VYLDA M 500 MG TAB	1X10
UNISTAR 20/75MG CAP	1X10
ARBITEL TRIO 50 TAB	1X10
GLYCOMET TABS TAB	1X10
LIPITABE GOLD 20 TAB	1X10
TRIGLIMICURE TAB	1X10
NEURO CDE TAB	1X10
ONABET-CREAM 30GM CREAM	1X30GM
TELMA-H TAB	1X15
ACECLO MR TAB	1X10
PERCIN TAB	1X5
MAXRICH E Lotion	1x100ML
ASOMEX 5MG TAB	1X15
ASOMEX TAB	1X15
ASOMEX TAB	1X15
LIBRIUM 10MG TAB	35X15
ECOSPIRIN GOLD 10 CAP	1X15
ECOSPIRIN GOLD 20 CAP	1X15
ULTRACET TAB	32X10
PAN-40 INJ	1VIAL
MIKACIN 500MG INJ	1X7ML
HEPTAGON SYP	1X100
TOREX 100 ML SYP	12X10
UNIENZYME 200ML SYP	36X20
CHESTON COLD TAB	25X10
RAXIPRESS 5 TAB	1X10
ASTHAN IN 2 TAB	1X30
O2 TAB	1X10
TELMED 20 TAB	1X10
TELI 20 TAB	1X10
JANUVIA 100 MG TAB	1X7
CLAVAM 625 TAB	1X10
CLAVAM DRY SYP	30ML
CLAVAM BID SYP	30ML
TAXIM-O SYP	30ML
NEWCITA LITE TAB	1X10
VOGLI 0.2 TAB	1X10
OPTIVE 10ML EYE DROP	1X10ML
RANOLAZ 500MG TAB	1X15
DEPLATT A 75MG TAB	1X15
MET-XL 25MG TAB	1X20
ROSUVAS 40MG TAB	1X10
PREVA GOLD TAB	1X15
MONTINA L 30ML SYP	1X30ML
DILZEM SR TAB	1X15
CHYMORAL FORTE TAB	1X20
OROFER XT TAB	1X15
MEGAPEN 500MG CAP	1X10
ARISTOZYME LIQUID	200ML
GALVUS 50MG TAB	1X15
ASCORIL LS SYP	1X100ML
POLYBION ACTIVE 150ML SYP	1X150ML
PANTOP DSR CAP	1X15
PANTOP 40MG TAB	1X15
DO-RE-ME 25MG TAB	1X10
WALAPHAGE SR 500MG TAB	1X15
ASOMEX AT 2.MG TAB	1X15
CLONOTRIL 0.25MG TAB	1X15
REVELOL-XL 25 TAB	1X10
NICARDIA-XL 30 TAB	10X10
MONIT GTN 2.6 VIAL	1PH
PILEX TAB	1PH
PEXEP PLUS 12.5 TAB	1X10
ONDEM MD4 TAB	1X10
ZYVEN OD 50MG TAB	1X10
SEROFLO 250 INHALER	1PH
TOVAXO E/D	1PH
GEPRIDE M-D4 FORTE TAB	1X10
PAN 40 TAB	1X15
REMISTAR 5 TAB	1X15
TELMA 40 TAB	1X30
LIV 52 DS LIQUID	1X200
COBADEX CZS TAB	1X15
SILYBON 140 TAB	1X10
REJUNEX CD3 NF TAB	1X10
OMEZ DSR CAP	1X15
ONDEM MD4 TAB	50X10
AMARYL 1MG TAB	1X30
ONDEM MD4 TAB	1X10
GEPRIDE M-D4 FORTE TAB	1X10
FERONIA XT TAB	1X15
MONTINA L TAB	1X10
LEVOCET TAB	1X10
CILACAR 10MG TAB	1X15
HAPPI D TAB	1X10
METOLAR XR 25MG TAB	1X15
AZITHRAL 500MG TAB	1X5
RABLET D CAP	10X10
AP DROP	1PH
TAXIM-O 200 TAB	1X10
FEBUTAZ 40MG TAB	1X15
REPACE 25MG TAB	1X10
PRAZOPRESS-XL 2.5MG TAB	1X30
CLOPILET A 75MG TAB	1X15
URIMAX 0.4MG CAP	1X20
AZTOR 10MG TAB	1X15
ZERODOL SP TAB	1X10
AZTOR 20MG TAB	1X15
GLUCONORM PG2 FORTE TAB	1X15
GLUCONORM PG 2MG TAB	1X15
MAXTRA SYP	60ML
AMIXIDE H TAB	1X10
SEROFLO 250 INHALER	1PC
AZITHRAL 500MG TAB	1X5
LONAZEP 0.25MG TAB	1X15
ISTAMET 50/1000MG TAB	1X15
NEXITO PLUS TAB	1X10
KORANDIL 5MG TAB	1X10
PROLOMET XL 50MG TAB	1X15
VOAGE M 10/500MG TAB	1X10
RANOLAZ TAB	1X15
JANUVIA 100 MG TAB	1X7
GEMER DS 2MG TAB	1X15
AMARYL MP 2MG TAB	1X15
STATOR 20 TAB	1X15
Flagyl 400 MG TAB	40X15
CETRIZ 60 ML SYP	1X60ML
TRINERVE LC CAP	10X10
ACILOC 150MG TAB	30X30
Azee 500 TAB	1X5
CIPLACTIN 4MG TAB	1X15
CIPLOX 500 TAB	1X10
THEO ASTHALIN TAB	60X30
DUOLIN ROTOCAP CAP	1X60
MONTAIR LC TAB	1X15
AEROCORT FORTE CAP	1X30
GRINLICTUS BM SYP	1X100ML
IODEX 16GM BALM	1X16GM
NEW CROCIN 650MG ADV TAB	25X15
OSTOCALCIUM PLUS TAB	1X30
THYROX 62.5 TAB	1X100
ETIZOLA PLUS TAB	1X10
TELIMAC-20 TAB	1X10
BEVON SYP	1X200ML
MAXTRA P SYP	1X60ML
AMLODAC 2.5MG TAB	1X30
ALTHROCIN 500MG TAB	1X10
URIMAX 0.4MG CAP	1X20
ROZAT F 10MG TAB	1X10
ROZAT F 10MG TAB	1X10
STAMLO 5MG TAB	1X30
GRINLINCTUS DX SYP	1X100ML
BETNOVATE N CREAM	1X25GM
TENLIMAC-M 500 TAB	1X15
MAPRAZYME LIQUID	1X200ML
INFLUVAC TETRA SH INJ	1X0.5M
DISPO 05ML INJ	1X1
LASILACTINE 50 TAB	1X10
BETADINE 100ML SOL	1X1
ALKACITRON 100ML SYP	1X1
SORBITRATE 5MG TAB	1X50
MULTIVITE FM OMEGA TAB	1X30
NOVOMIX 30 PENFILL	5X30ML
PENTIIDS 800 TAB	1X10
THEO ASTHALIN TAB	1X30
REMIPRES 5 TAB	1X10
NICARDIA-XL 30 TAB	1X10
THYROX 50 TAB	1X20
ARBITEL-20 TAB	1X10
VOGIL-M 0.3 TAB	1X10
VOBOSE-0.3 TAB	1X10
WALAPHAGE SR 500MG TAB	1X10
EUCLIDE-M 30 OD	1X10
CANESTEN CREAM	1X30GM
UDILIV 300MG TAB	1X15
GEMER FORTE 1MG TAB	1X10
DONAMEM 10MG TAB	1X10
ADMENTA 5MG TAB	1X10
RANIDOM RD TAB	1X10
TAXIM-O SYP	30ML
Liv 52 DS TAB	1PHY
TELMA BETA 25MG	1X10
CYSTONE TAB	1PHY
LEVOCET-M	1X10
TELLZY 40	1X15
LIV 52 TAB	1PHY
LIV 52 SYP	1X100
NULONG 5	1X15
Telmed 40 Tab	10X10
PAN-40 INJ	1VIAL
SILYBON 140 TAB	1X10
CLOBA 5MG	1X5
MEGAHEAL GEL 50	50GM
G R D POWDER	200GM
GEMCAL P	150ML
TSART 40	1X15
BACTRIM SYP	1X50ML
BETONIN AST 400ML	1PCS
BETADINE POWDER	1X10GM
TRAJENTA DUO 500MG	1X10
SEACOD CAP	1X110
WALYTE ORANGE FLAV	225GM
LAMEZ OD 150 TAB	1X10
BRITZILAM 75MG TAB	1X15
ESLIZEN 800MG	1X10
SPENZO DEPOT 20 INJ	1X1
DILONA FORTE TAB	50X10
CANDID 50GM POWDER	1PCS
UNWANTED 72 TAB	30X1
Candibiotic Plus Ear Drop Drop	5 ML
MONTINA L SYRUP 60 ML Syrup	60ML
OLSERTAIN H 40 MG Tablet	1x15
AZTOR ASP 75 Tablet	1x10
REXID Tablet	10 S
A ABSOLUT 3G CAP. Capsule	1X10
PROLOMET XL25	1X15
KEMLACTIN 200ML SYP	1X200
OMEE MPS 200ML	1X1
AMOXYCLAV 625	1X10
AMOXYCLAV 625	1X10
LIPISULIDE P TAB	1X10
SPASTONE RM TAB	1X10
AMOXYCLAV 625	1X10
AKURIT 4 TAB	1X10
MECGLA CAP	1X10
ASOMEX 5MG TAB	1X15
IFLOMAX GEL	1X5GM
OXRA 10 TAB	1X14
ACOSPIRIN AV 75 CAP	1X15
AKURIT 3 TAB	1X10
ANDRE I-KUL EYE DROP	1PHL
ANDRE I-KUL EYE DROP	1PHL
VISTAMEGA CAP	3X10
MAXMOIST EYE DROP	10ML
CALPOL TAB	1X15
TAXIM-O 200	1X10
QUADRIDERM RF CREAM	1X10GM
QUADRIDERM RF CREAM	1X5GM
ZEVERT MD 16 TAB	1X15
DUOLIN 3 RESPULE	3ML
Calpol 250 MG Syrup	60ML
Calpol 250 MG Syrup	60ML
FLODACART TAB	1X10
BANDY PLUS	1X1
AMLOSAFE 5MG	1X15
AMLOSAFE AT	1X15
AMLOKIND 5MG	1X15
TAXIM-O 100 DT	1X10
CB-12 INJ	1X1
ARISTOZYME SYP	1X200
TRENAXA INJ	1X5
A TO Z NS	1X15
AMLOKIND AT	1X15
BENADRYL 150 ML	1X150M
SOLVIN EX SYP	1X100ML
BIOCOFMINT 100ML	1X100ML
GULFADRYL 100ML SYP	1X100ML
TOREX SYP 100ML	1X100ML
ASCODEX LS JUNIOR 60ML	1X60ML
CEFIX DS 30ML SYP	1X1
AMLOX DRY SYP 60ML	1X60ML
PAMAGIN GOLD 60ML SYP	60X1
DOLOCOLD DS 60ML SYP	1X1
CHERICOF 100ML SYP	1X100ML
OVRAL G TAB	1x20
NEXPRO IT CAP	1 x10
OLMESAR CH 40 TAB	1X15
MACSART BETA 50 TAB	1X10
SOLVIN EX SYP	1X100ML
TAZLOC BETA 50 MG	
DIGERAFT SYRUP	1X150
ROSUCREST - AS 20MG TAB	1X10
NASVISION CHILD DROP	1X10ML
ADVENT SYP	1X30ML
ADVENT FORTE SYP	1X30ML
ALSITA MP 500	1X10ML
LIPITAS 20MG	1X15ML
AMTAS 5MG	1X30ML
SMUTH SYP	1X70ML
ENERZAL ORANGE	1X75GM
SORBACID GEL	1X200ML
ALKACITRON SYP	
STOLIN R ACTIVE	1X70GM
PROLOMET XL-25	1X15
BIO D3 PLUS CAP	1X15
SOFT TEARS EYE DROP	1X10ML
LUBISTAR EYE DROP	1X5ML
KIDDODENT PASTE	1X75GM
KIDDODENT PASTE	1X75GM
EVION 400 MG CAP	1X10
MOXIKIND CV 625 TAB	1X10
HUCOG-5000 HP	1VIAL
PIOZ 7.5MG TAB	1X10
KRACK OINTMENT	1X5GM
COMBIFLAM TAB	1X20
AVIL AMP 2ML	1X2ML
FLODACART PLUS CAP	
WALACORT TAB	1X20
ANAFORTAN TAB	1X10
A TO Z SYP	1X200ML
RISDONE PLUS	1X10
GLUCRETA 10 TAB	1X10
AMOXYCLAV 625	10X10
ORCERIN GM TAB	1X15
MONOCEF O 200 TAB	1X10
MACPRED 4 TAB	1X10
AMLOSAFE 5 TAB	1X15
ASTHAKIND SYRUP	1X100
SHELCAL 500	1X 15
A TO Z GOL D	1X 15C
TELMA-H	1X 15
NULONG 10	1X 10T
NAPROSY N 500	1X 15T
UNIENZYME TAB	1X15
VOBIT 0.2 TAB	1X15
MONTAIR LC TAB	1x15
ASCORIL D+ syp	100M
ZORYL M2 TAB	1X20
A to Z NS DROP	15M
MUCINAC 600 TA	1X10
TELMA AM TAB	1X30
PAN MPS SYP	200M
MONTEX LC	1X15
ALPRAX 0.25	1X15
CLOPILET A 75	1X15
NISE TAB	1X15
ZERODOL P TABS	1X10
ZERODOL SP TABS	1X10
TENLIMAC 20 TAB	1X10
AMLOKIND 5 MG TABS	10X15
AMLOKIND AT TABS	10X15
BANDY PLUS TABS	40X1
LIPIKIND F TAB	4X10
TELMIKIND H TAB	6X10
AVIL AMPOULES	10X2ML
GRILINCTUS DX SYRP	1x100 M
Zedex Syrup	1x100ml
Clot Xl-500 MG Tab	10x10
Dexorange Syrup	30x200ml
Montair LC Tablet	1X10
THEO ASTHALIN TAB	60X30
AMBROLITE-S SYRUP	1X100ML
TONACT TG TAB	1X 15T
AVAS-10	1X 10T
GABAPIN 100 CAP	1X 10
WARF 3	1X 10T
IVABID 5 TAB	10X 10
RELEDOL GEL	1 X30GM
DILNIP 20MG TAB	1 X15
ACITROM 2MG TABS	1 X30
FLAVIDON MR TABS	1X10
GLUCORYL M2 FORTE TAB	1x15
CLAVAM BID SYP	30 ML
MONTINA L TAB	1x10
AMLOPRES AT TAB	1x15
TONOFERON DROP	15ML
EVECARE FORTE LIQUID 200ML	1 X200M
VELOZ D CAP	1 x10
BECOSULES WOMEN CAP	1x15
HIMCOCID SUSP SF SAUNF FLAV	1X200ML
SAMLODAY 2.5MG TAB	1x10
COSCOPIN PLUS SYP new	1 X100M
SOLVIN LS SYRP	1X60ML
MACSART BETA 50 TAB .	1X10
TELMIKIND 20 TAB .	12X10
TENOLOL 25MG TABS	1X14
GP - 2 TAB .	1X10
BETACAP TR 60	1x10
ROZAVEL A	1x10
URSOCOL 300	1x15
SAT ISABGOL 50 GM	
D HONEY 250 GM	
TELMA-H	1X 15
PAN D CAPS	1X 15
QUTAN-50MG TAB	1X 10
FLUNIL 20	1X 10
TENEBITE M 20 / 1000MG TAB	1 x15
CARTIGEN FORTE + TAB	1x10
RESTEK FOTRE MD	1x10
ZUKANORM - 50 TAB	1X10
ALZIL M 5MG TAB	1x10
ODICEF S 1.5GM	1x1.5gm
SWICH CV 325	1X10
GOSPAS TAB	1X10
INSTARAFT 200ML	200ML
NEXITO PLUS	1X10
DIGERAFT SYRUP	1X150M
DOT ACE 2.5MG TAB	1x10
BETT AMPOULES ( BE )	120X0 .
INVOKANA 100 MG	3X10
NEFROSAVE TAB	10X10
HAPID CAP	10CAP
CLOPILET A 75	1X15
GLIMIPREX MF 2 / 500MG TAB	1x15
TELMA CT 40 / 6.25MG TAB	1x15
CREON 25000	1X10
THYROX 12.5 TAB	1X100
PILEX TAB	1PHY
HEMEER SYP	225M
AKURIT 4 TAB	1X10
TENOHEP AF	1PHY
URSOCOL 300	1x15
GRANDPRIDE MV 1	1X10
ROSEDAY 10 MG TAB .	1X15
GABAPIN NT 300 TAB	1x15
ATCHOL GOLD 20MG CAP	1x15
DOTZIDE MR 60MG TAB	1x10
LIZOLID - 600	1X10
COBADEX CZS	1X15
PANTOP D CAP	1x10
ASCORIL SYP	100ML
ZEDEX COUGH SYP	1X100M
CYCLOPAM SYP	1X30ML
RESTEK PLUS	10X10
ROZAVEL 20	1X10
NEXITO -10	5X2X10
DUPHALAC SYP 250 ML	1X250ML
DUPHALAC SYP 450 ML	1X450ML
JALRA M 50/500MG	1X15
METZOK 12.5MG TABS	1X10
MYSOLINE 250MG TAB	1X10
PARNIL 2MG TAB	1x10
OLMIN 20 MG TAB	1x10
DAPAVEL 10	1X10
FRISIUM 10	1X10PI
ECOSPRIN GOLD 20	1X15
UPRISE D3 60K 15ML DROP	1X15ML
MAXTRA SYP.	60ML
ISTAMET 50MG/1000MG	1X15
OTIFLOX EAR DROPS	5ML
GLYCOMET SR 850 TAB	1X10
D3 MUST DROP	1x15ML
SHELMOIST E/D	1X1
NEPANAC E/D	1X1
DAPLO-M	1X10
FEBUTAZ 40MG TAB	
REPACE-AF	1X10
PANTOCID-DSR	1X15
FREEDASE 30 TAB	1X21
ECONORM POWDER	1X765GM
GEMER-P2	1X10
NEXITO PLUS	1X10
PENTIDS 800 TAB	1X10
PENTIDS 400 TAB	1X10
HUMALOG MIX 50 CARTIGE	1X3ML
OTRIVIN FAST RELIEF	1X10
METROGYL 400MG	1X15
GLUCONORM-G1 TAB	1X15
TONACT EZ 20	1X10
MACPOD 50 DRY SYRUP	1X30ML
SURBITRATE 10MG TAB	1X50
VONEFI 20MG TAB	1X10
DUPHALAC SYP 250 ML	1X250ML
ENTEROGERMINA ORAL SUSP	10X3ML
DAFLON 1000MG TAB	1X20
HUMALOG MIX 50 CARTIGE	1X3ML
DAFLON 1000MG TAB	1X20
DOXINATE PL US	1X 30T
ZORYL 4MG TAB	1X15
LYSOFLAM TAB	1 X10
CREMAFIN PLUS SYP	1X225ML
ELIQUIS 5 MG TAB.	1X10
CIFRAN CT TAB	1X10
MIXTARD 30 HM PENFILL	1X3ML
MAXMOIST EYE DROP	1X10ML
CYCLOMUNE EYE DROP	1X3ML
TELVAS 40MG TAB	1X15
REXIPRA-10	10X 10
OXRA 10 TAB	1X14
GLYCOMET 1 GM TAB	1X15
ZOMELIS 50 MG TAB	1X15
VORXAR TAB	1X10
AZULIX 3 MF FORTE TAB	1X10
ENTEROGERMINA ORAL SUSP	10X3ML
NEUROBION FORTE TAB	1X30
NORFLOX TZ RF TAB	1X10
REVITAL H CAP	1X10
BETAMIL GM CREAM	30GM
THREPTIN DISKETTES 275 GM	1X275G
OTRIVIN FAST RELIEF	1X10
DUPHALAC 150ML SYP.	1X150
KETOROL DT TAB	1X 10T
TRAVOPUR EYE DROPS	10ML
DORTAS T E/D	1PH
CALCIROL GRANUL ES	1SACHE
RAMCOR 5	1X 10
SEROFL O 250 RC	1PH
AZIDERM 10%	1 T UBE
MOMATE -CREAM	1X 20GM
TRETIVA 20	1X 10T
TRETIVA 20	1X 10T
SWICH CV 325	1X 10
DEECEE FORTE	1X 10
PULMOCLEAR TAB	1X 10T
PILEX TAB	1PHY
OMEZ 20MG CAP	1X15
DILONA FORTE TAB	50X10
DILONA SP TAB	1X10
DILONA PLUS TAB	1X10
SOLVIN NASAL SPRAY	1X20ML
CANDIFORCE 200 CAP	1X10
BETNOVATE N OINT.	25GM
MONOCEF 250 INJ	VAIL
PANTOP DSR CAP	1X10
ONDEM VIAL 2ML	2 ML
TELVAS 40MG TAB	1X15
TELVAS AM TAB	1X10
ONDEM VIAL 2ML	2 ML
ELTROXIN 50 TAB	100 S
DYNURO D CAP	1X10
ALFUSIN D TAB	1X15
MONOCEF 500 INJ	VAIL
DAPANORM M 10 TAB	1X10
GLIMIPREX MF 2/500 MG	1X10
AMLOSAFE 5 TAB	1X10
TRINERVE-LC TAB	1X10
ATEN 50 TAB	1X14
OSTEOFOS 70 TAB	1X4
SMUTH SYP	170ML
OLMY A TAB	1X10
PYRIMON D E/DROP	1X10ML
MONTAIR LC KID SYP	60ML
TELVAS 40MG TAB	1X15
DOXOVENT 400 TAB	1X10
RASHFREE CREAM	1X30GM
THYRONORM 25 TAB	1X100T
IODEX-8GM SMALL	1X8GM
CALPOL DROPS.	1X15ML
THYROX 100 TABS.	1X100
BETNOVATE N SKIN CREAM	1X25GM
OTRIVIN ADT. N/SPRAY	1 PHYL
ECOSPRIN AV 75 CAP	1X15
GLYCOMET 1 GM TAB	1X15
JALRA M 50/500 MG TAB	1X15
TRIGLYNASE 2 TAB	1X10
BLADMIR 50MG TAB	1X10
PIRITION CS SYP	100ML
LIZOFORCE DRY SYRUP	1X30ML
ZENFLOX OZ TAB	1X10
DILONA INJ	1X1
DILONA AQUA INJ	1X1
PRULASTIN M TAB	1X10
BECOSULES + SYRUP	1X200M
METPURE XL 25MG TAB	1X10
SELOKEN XL 50MG TAB	1X30
ALNITRO 2.6 TAB	1X30
VELOZ D CAP	1X10
OLOPAT OD DROP	1X3ML
SHELCAL 500 MG TAB	1X15
PRUVICT 2MG TAB	1X10
MUCAINE GEL MINT FLAV 200M	1X200ML
HETRAZAN 100MG TAB	1X30
ORNOF 700MG TAB	1X10
BECOSULES PERFORMANCE	1X15
POTKOR SYRUP	1X200ML
MEFTAL SPAS TAB	1X 10T
DILONA FORTE TAB	50X10
DILONA SP TAB	1X10
DILONA PLUS TAB	1X10
PENTIDS 400 TAB	1X10
CLAVAM 625 TAB	1X10
MONOCEF 250 INJ	VAIL
PANTOP DSR CAP	1X10
A TO Z NS DROP	15 ML
ONDEM VIAL 2ML	2 ML
ACILOC 150 TAB	1X30
ACILOC 300 TAB	1X20
ZERODOL SP TABS.	10X10
ANAFORTAN TABS.	12X15
BETT AMPOULES (BE)	120X0.5ML
CB-12 AMPOULES	1.5ML+1ML
BECOSULES + SYRUP	1X200M
DILONA INJ	1X1
PENTIDS 800 TAB	1X10
NUROKIND FORTE INJ	4X2M
OMNACORTIL FORTE SY	1X60ML
TRAMADIN 100 INJ	12X2ML
RAPEED L PLUS CAP	1X10
COREX T SYP	100ML
NITRO 6.4 MG TAB	1X30
PREGALIN NT TAB	1X10
UNISTAR 20/75MG CAP	1X10
ANDRE I-KUL EYE DROP 10ML	1PHL
DONAMEN-10	
ULTRACET TAB	1X15
TRYPTOMER 10	1X 30T
TRYPTOMER 25MG	1X 15
NEOSPORIN POWDER	10GM
ZERODOL P TABS.	10X10
ZERODOL SP TABS.	10X10
AMTAS AT TAB	1X15
BILASURE M TAB	1X10
ROSUVAS 5MG TAB	1X15
FOLVITE MB CAP	1X15
BETNOVATE N SKIN CREAM	1X25GM
PIPZO 4.5	1VAIL
UPRISE D3 60K CAP	1X8
TELMED 80 TAB	1X10
Liv 52 DS TAB	1PHY
ALKACITRON 100ML SYP	1X1
REGESTRONE TAB	1 X10
ROSULESS 10MG TAB	1 X15
GABAPIN NT 300 TAB	1X15
TRETIVA 20MG CAP	1X10
PANTOSEC DSR CAP	1X10
TENDOCARE FORTE	1X15
TELVAS H 40/12.5MG	1X10
ATEN AM TAB	1X14
MOXIKIND CV 625 TAB	1X10
DOLODUST TABLET	1X10
STIMULIV SYP(S)	100ML
AMLOSAFE TM 40MG TAB	1X10
DERIPHYLLIN RETARD 300 TAB	1X30
NASOCLEAR NASAL SPRAY 20ML	1 X20ML
ALEX LOZENGES TAB	1X10
CALPOL 120MG SYRUP	60ML
VINGLYN M 1000	1X 15
OCID 20MG CAPS	1X 15
PARAXIN 500MG CAP	1X10
PARAXIN 200MG CAP	1X10
DUONASE NASAL SPRAY	1X7GM
MAXIFLO 250 INHALER	1X120
BEIPOS EYE DROP	1X5ML
GLADOR M1 TAB	1X15
CLOPITAB	1X15
THYROX 50 TAB	1X120
OMNACORTIL 20 TAB	1X10
OMNACORTIL 10 TAB	1X10
ARBITEL 20 TAB	1X10
NEO-MARCAZOLE 10MG TAB	1X120
CREMAFIN MIXED FRUIT	1X225ML
CREMAFIN PLUS SYP	1X225ML
CETAPIN V 0.3MG	1X10
FESTAL N TAB	1X10
COMBIFLAM TAB	1X20
DUCOFLEX TAB	1X10
TAZLOC CT 625 TAB	1X10
GLYCOMET TAB	1X10
D RISE 60K CAP	1X4
GLYCOMET GP1 TAB	1X15
GLYCOMET GP2 TAB	1X15
PHLOGAM TAB	1X10
MOISTUREX CREAM	1X100GM
ZEDEX COUGH SYP	1X100
ETOSHINE-MR	1X10
DIZITAC TAB	2X5X10
REVOSTAT 10	1X10
SYNDOPA PLUS	1X15
REGESTRONE TAB	1 X10
ROSULESS 10MG TAB	1 X15
GABAPIN NT 300 TAB	1X15
TRETIVA 20MG CAP	1X10
PANTOSEC DSR CAP	1X10
TENDOCARE FORTE	1X15
TELVAS H 40/12.5MG	1X10
ATEN AM TAB	1X14
MOXIKIND CV 625 TAB	1X10
DOLOJUST TABLET	1X10
STIMULIV SYP(S)	100ML
AMLOSAFE TM 40MG TAB	1X10
DERIPHYLLIN RETARD 300 TAB	1X30
NASOCLEAR NASAL SPRAY 20ML	1 X20ML
ALEX LOZENGES TAB	1X10
CALPOL 120MG SYRUP	60ML
VINGLYN M 1000	1X 15
OCID 20MG CAPS	1X 15
PARAXIN 500MG CAP	1X10
PARAXIN 200MG CAP	1X10
DUONASE NASAL SPRAY	1X7GM
MAXIFLO 250 INHALER	1X120
CREMAFIN MIXED FRUIT	1X225ML
CREMAFIN PLUS SYP	1X225ML
DUCOFLEX TAB	1X10
TAZLOC CT 625 TAB	1X10
GLYCOMET TAB	1X10
GLYCOMET GP1 TAB	1X15
GLYCOMET GP2 TAB	1X15
ZEDEX COUGH SYP	1X100
ETOSHINE-MR	1X10
DIZITAC TAB	2X5X10
REVOSTAT 10	1X10
SYNDOPA PLUS	1X15
DUCOFLEX TAB	1X10
ARBITEL 20 TAB	1X10
CANDIBIOTIC EAR PLUS DROP	5ML
LIV - 52 HB CAP	1X10
NITRO 6.4MG TAB	1 X30
PHLOGAM TAB	1X10
DYNAPAR AQ AMP	1AMP
UNWANTED KIT STRIPS	1 TAB
MOXICIP D D DROP	1PH
BEIPOS EYE DROP	1X5ML
THYROX 50 TAB	1X120
CILAHEART-10MG TAB	1X15
	
REGESTRONE TAB	1 X10
ROSULESS 10MG TAB	1 X15
GABAPIN NT 300 TAB	1X15
TENDOCARE FORTE	1X15
TELVAS H 40/12.5MG	1X10
ATEN AM TAB	1X14
MOXIKIND CV 625 TAB	1X10
DOLOJUST TABLET	1X10
AMLOSAFE TM 40MG TAB	1X10
DERIPHYLLIN RETARD 300 TAB	1X30
NASOCLEAR NASAL SPRAY 20ML	1 X20ML
ALEX LOZENGES TAB	1X10
CALPOL 120MG SYRUP	60ML
VINGLYN M 1000	1X 15
OCID 20MG CAPS	1X 15
PARAXIN 500MG CAP	1X10
PARAXIN 200MG CAP	1X10
DUONASE NASAL SPRAY	1X7GM
MAXIFLO 250 INHALER	1X120
CREMAFIN MIXED FRUIT	1X225ML
CREMAFIN PLUS SYP	1X225ML
TAZLOC CT 625 TAB	1X10
GLYCOMET TAB	1X10
GLYCOMET GP1 TAB	1X15
GLYCOMET GP2 TAB	1X15
ZEDEX COUGH SYP	1X100
ETOSHINE-MR	1X10
DIZITAC TAB	2X5X10
SYNDOPA PLUS	1X15
TRAVOPUR EYE DROPS	10ML
DORTAS T E/D	1PH
CALCIROL GRANUL ES	1SACHE
SEROFL O 250 RC	1PH
MOMATE -CREAM	1X 20GM
SWICH CV 325	1X 10
PULMOCLEAR TAB	1X 10T
PILEX TAB	1PHY
OMEZ 20MG CAP	1X15
SOLVIN NASAL SPRAY	1X20ML
CANDIFORCE 200 CAP	1X10
BETNOVATE N OINT.	25GM
ONDEM VIAL 2ML	2 ML
TELVAS 40MG TAB	1X15
TELVAS AM TAB	1X10
ONDEM VIAL 2ML	2 ML
ELTROXIN 50 TAB	100 S
DYNURO D CAP	1X10
ALFUSIN D TAB	1X15
MONOCEF 500 INJ	VAIL
DAPANORM M 10 TAB	1X10
GLIMIPREX MF 2/500 MG	1X10
AMLOSAFE 5 TAB	1X10
TRINERVE-LC TAB	1X10
ATEN 50 TAB	1X14
OSTEOFOS 70 TAB	1X4
SMUTH SYP	170ML
OLMY A TAB	1X10
MONTAIR LC KID SYP	60ML
TELVAS 40MG TAB	1X15
DOXOVENT 400 TAB	1X10
RASHFREE CREAM	1X30GM
THYRONORM 25 TAB	1X100T
IODEX-8GM SMALL	1X8GM
CALPOL DROPS.	1X15ML
THYROX 100 TABS.	1X100
BETNOVATE N SKIN CREAM	1X25GM
OTRIVIN ADT. N/SPRAY	1 PHYL
ECOSPRIN AV 75 CAP	1X15
JALRA M 50/500 MG TAB	1X15
TRIGLYNASE 2 TAB	1X10
BLADMIR 50MG TAB	1X10
PIRITION CS SYP	100ML
LIZOFORCE DRY SYRUP	1X30ML
ZENFLOX OZ TAB	1X10
DILONA INJ	1X1
DILONA AQUA INJ	1X1
PRULASTIN M TAB	1X10
METPURE XL 25MG TAB	1X10
SELOKEN XL 50MG TAB	1X30
ALNITRO 2.6 TAB	1X30
VELOZ D CAP	1X10
OLOPAT OD DROP	1X3ML
TELMA-CT 40	1X15
PRULASTIN M TAB	1X10
DEFCORT 6 MG TAB	1x10
BILAZEST M TAB	1X10
MONOCEF 2 200MG TAB	1X10
FLUVOXIN CR 100	1X10
FLUVOXIN CR 50	1X10
TRIXIDE H TAB	1X10
METMAX TAB	1X10
NEWCITA PLUS	1X10
LIMCEE TAB	20X15
FLAGYL 400 MG TAB	40X15
CREMAFIN PLUS SYP	1X225M
TELVAS 40 TAB	1X15
DEXONA VAIL	2ML
BRINZOTIM EYE DROP	
TRIKA 0.5 TAB	1X15
SINAREST TSAB	1X10
METROG 400MG TAB	1X15
ARBITEL 20 TABS	1X10
FEBUMAC 40	1X10
GLADOR M1 TAB	1X15
CLOPITAB	1X15
OMNACORTIL 20 TAB	1X10
OMNACORTIL 10 TAB	1X10
NEO-MARCAZOLE 10MG TAB	1X120
CETAPIN V 0.3MG	1X10
COMBIFLAM TAB	1X20
D RISE 60K CAP	1X4
BIMAT LS DROP	1X3ML
GELUSIL MPS 400ML	1X400ML
REFRESH TEARS DROP	1X10ML
FEBURIC 40MG TAB	1 X15
MIRFAST 30MG TAB	1 X10
ASOMEX TM TAB	1X15
MET XL AM 25/5 TAB	1 X20
HYDENT K TOOTH PASTE 100GM	1X100GM
METOSARTAN-50 TAB	1X10
SOMPRAZ-D40 CAP	1X15
LOSAR 50MG TAB	1X15
CILAHEART-5MG TAB	1X15
GLIMESTAR 2MG TAB	1X10
BECOSULES PERFORMANCE CAPS	1X15
NEUROBION PLUS TAB.	1X15
CLOCIT 5MG TAB	1 X15
PAN 40 TAB	1X 15
EVION 400MG	1X 10
PAN D CAPS	1X 15
CANDID B 20GM	1X 20GM
VIGAMOX E /D	1PH
CILACART 40	1X 10T
UGESIC TAB	1X 10T
OMEZ DSR	1X 15
SOLTUS-50	1X 10
BUDACORT 05 REPS	1BOX
MONIT GTN 2.6	1PH
MONIT 20	1X 15
SURBEX X T TAB	1X 10T
A TO Z GOL D	1X 15C
TONACT TG TAB	1X 15T
CALCIROL GRANUL ES	1SACHET
SOLTUS-50	1X 10
DUOLIN RESPULES	1BOX
SOFTDROP E/D	1PHY
FERONIA X TX T TAB	1X 15
MELMET SR-1000 TAB	1X 10T
GLIMY MV2	1X 10
SILY BONN 140	1X 10
PAN D CAPS	1X 15
GLIMIPREX MF 2/500 MG	1x10
ELTROXIN 100 TAB	120s
OLIMELT 20MG TAB	1x10
TELVAS H 40/12.5MG TAB	1x10
DROTIN DS TAB	1x15
NORFLOX TZ RF TAB	1x10
ALSITA M 50 MG TAB	1x10
FORACORT 200 SYNCHROBREATHE	120MD
TELMA 40TAB	3x30
AMLOSAFE 2.5 TAB	1x10
GLIMIPREX 1 MG	1x10
FLODART PLUS	1x10
TIXYLIX SYRUPS	1X60ML
X TOR 10 MG TAB	1X10
FOLITRAX 5 TAB	1X10
GEMINOR M1 FORTE TAB	1X15
THYROX 125MG TAB	1X100
D3 MUST DROPS.	1X15ML
LIPIKIND-F TAB.	4X10
Clavam 625 MG	1X10
Montina L	10x10
Gabaneuron SR 600	5x10
Foracort 400	1x1
Asthalin	1x1
Bandy Plus	40x1
Deplatt CV 20	1x10
Rhumacort	20x10
Ursocol 150 MG	1x15
Ursocol 300 MG	1X10
Thyronorm 100	1X100
Thyronorm 75	1x100
Aciloc 150	30x30
Telmed 80	1x10
Neopeptin D	1x15
Neopeptin D	1x60
Maxtra P	1x60
Soframycin	1x30
Brozedex SF	1x100
Grinlinctus P	1x60
Otrivin ADT	1
Minipress XL 5 MG	1x15
Chericof Junior	1x60
Chericof LS	1x100
Betadine Gargle	1x100
ALLEGRA 120	1x10PI
HEPAMERZ OA 100 ML	1x1LIT
PHENARGAN SY	1x1PIE
MAXTRA P DROPS	1x1PIE
PANTOP - D SR CAP	1 BOX
ROXID 150MG TAB	1 x 10
COREX DX ( L )	100ML
MONTICOPE TAB	1BOX
MEGAPEN 500MB CAP	1B0X
LOMOFEN TAB	1B0X
AMLOSAFE AT TAB	1B0X
THROMBOPHOB DINT	1TUBE
ALKACITRON SY 100 M	1x1PIE
MINICYCLIN CAPS	1BOX
BENADRYL - 150 ML	1 PH
DRUTIN - M TAB	1X10
THYROX 100MG	1X100
THYROX 75MG	1X30
CIPLAR LA 20	1X15
CIPLAR LA 40	1X15
GEPRIDE M2	1X10
VIDAS D M 50/1000	1X10
NIFTAS TAB	1X10
QUADRIDERM RF CREAM	1x10
DOXINATE	1x30
Dolo-650	1
Meftal Spas	1x10
P-40 DSR	20x10
Telmed AM	1x10
Telmed 40	1x10
Grilinctus	100 ML
Asthakind DX	100 ML
Neosprin	5 GM
Flagyl 400 MG	1 Box
Ciplox D	1 Pcs
A to Z 200 ML	1 PHY
A to Z 100 ML	1 PHY
Benadryl 150	1 PHY
Digene	1
Aptivate	1 PHY
Cypon	200ML
Vertin 8 MG	1 BOX
Betnovate C	30 GM
Asthakind	1 PHY
Flagyl 60 ML	1x60
Vertin 16	1x15
Cetriz 60 ML	1x60
Aristozyme	10x15
Azee 500	1x5
Grilinctus BM	1x100
T-Bact 5 GM	1x5
Brozedex SF	1x100
Grilinctus P	1x60
Betnovate GM	1x20
Trenaxa	5x5
Glycomet GP 3 Forte	1x10
Betadine	1x100
`;

export const parseMedicineExcelData = () => {
    const rows = MEDICINE_LIST.trim().split('\n'); // Split by new lines
    const headers = rows.shift().split('\t'); // Extract headers
    const result = rows.map((row, index) => {
        const [ProductName, PackagingSize] = row.split('\t'); // Split by tabs
        return {
            _id: index + 1,
            ProductName,
            PackagingSize
        };
    });
    return result;
}

export const BRANDED_MEDICINE_LIST = `
Product Name	Product Type
0 MILE	Dry Syrup
0MILE 100 MG	Tablet
0MILE 200MG	Tablet
1/6 MOLARLACTATE	Infusion
10 ML DISPOVAN	Syringe
10 ML DISPOVAN	Syringe
10 ML HI-TEC	Syringe
10 ML STERIVAN	Syringe
1ML INSULINE	Syringe
1ML MULTIPAC DISPOVAN	Syringe
1ST AID	Plaster
1ST-AID 100ML	Liquid
2 ML STERIVAN	Syringe
20ML DISPOVAN	Syringe
2ML	Syringe
2ML DISPOVAN	Syringe
3 CEF NOVO 1.5	Injection
3 CEF NOVO 375	Injection
3 CEF NOVO 750	Injection
3 LAX	Suspension
3 MIX	Cream
3 ML STERIVAN	Syringe
3-CARE	Bolus
3-CEF 250MG	Injection
3-CEF 500MG	Injection
3-NITE	Tablet
3336 HILON	Suture
3389 HILON	Suture
3D-VET 100 ml	Injection
3D-VET 30 ML.	Injection
3D-VET PLUS	Bolus
3D-VET PLUS	Bolus
3ML(24 G)	Syringe
3ML SYRINGE	Syringe
`;

export const GENERIC_MEDICINE_LIST = `
Product Name	Product Type
0 MILE	Dry Syrup
0MILE 100 MG	Tablet
0MILE 200MG	Tablet
1/6 MOLARLACTATE	Infusion
10 ML DISPOVAN	Syringe
10 ML DISPOVAN	Syringe
10 ML HI-TEC	Syringe
10 ML STERIVAN	Syringe
1ML INSULINE	Syringe
1ML MULTIPAC DISPOVAN	Syringe
1ST AID	Plaster
1ST-AID 100ML	Liquid
2 ML STERIVAN	Syringe
20ML DISPOVAN	Syringe
2ML	Syringe
2ML DISPOVAN	Syringe
3 CEF NOVO 1.5	Injection
3 CEF NOVO 375	Injection
3 CEF NOVO 750	Injection
3 LAX	Suspension
3 MIX	Cream
3 ML STERIVAN	Syringe
3-CARE	Bolus
3-CEF 250MG	Injection
3-CEF 500MG	Injection
3-NITE	Tablet
3336 HILON	Suture
3389 HILON	Suture
3D-VET 100 ml	Injection
3D-VET 30 ML.	Injection
3D-VET PLUS	Bolus
3D-VET PLUS	Bolus
3ML(24 G)	Syringe
3ML SYRINGE	Syringe
`;

export const parseBrandedMedicineExcelData = () => {
    const rows = BRANDED_MEDICINE_LIST.trim().split('\n'); // Split by new lines
    const headers = rows.shift().split('\t'); // Extract headers
    const result = rows.map((row, index) => {
        const [ProductName, ProductType] = row.split('\t'); // Split by tabs
        return {
            _id: index + 1,
            ProductName,
            ProductType
        };
    });
    return result;
}

export const parsegenericMedicineExcelData = () => {
    const rows = GENERIC_MEDICINE_LIST.trim().split('\n'); // Split by new lines
    const headers = rows.shift().split('\t'); // Extract headers
    const result = rows.map((row, index) => {
        const [ProductName, ProductType] = row.split('\t'); // Split by tabs
        return {
            _id: index + 1,
            ProductName,
            ProductType
        };
    });
    return result;
}

// Input data as a single string (you might read this from a file in an actual use case)
const branded = `
Aristozym
Combliflam
Thyrox 62.5
Clavam Dry Syrup
Clavam BID D/S
Sinarest New
Betadine
Roxid-150
Aciloc AD-20
Manforce-100
Uprise D3
Dolo-120
Livogen
Bicosules
Arkamin
Ultracet
Urimax-D
Ursocol-300 MG
Gluconorm G-2
Piriton CS
Levoflox 500 MG
Atarax 10 MG
Augmentin Duo
Gabaneuron NT 400
Glipon MF 20/500
Folinext
Gluconorm G-2
Thromrophob
Amlosafe 5
Vertin 16
Dolo 650
Benadryl 50 ML
Dexorange
Pantocid 40
Ornof
Aceclo Plus
Amlosafe 2.5
Ambrodil S
Asthalin
Benadryl 150 ML
Pantop-D SR
Betnovate-N
Almox 500
Cyston
Volini
T-Bact 5 GM
Kayam-Churan 100 GM
Vicks
Moov 20 GM
Saridon
Becosules
Electral B Powder
Zincovit
Mycoderm
Ascabiol 50 ML
Calpol 250 MG
Lukol
Taxim O CV 200 MG
Taxim O Forte
Zerodol SP
Zyloric 100 MG
A to Z
Noworm
Lantus
Ondem MD4
Lumerax 80
Crocin 120
Lantus Solostar
Betadine
Human Mixtard 40
Stayfree 6-XL
Stayfree 18-XL
Whisper 6-XL
Whisper 18-XL
BD Pen Needle 4 MM
Amitone 10 MG
Candid 120 GM
Rosuvas 5 MG
Candibiotic Plus
Rosuvas 10 MG
Decolic
Azithral 100 MG
Azithral 200 MG
Glycomet GP 3 Fort
Glycomet GP 3 Fort
MVI
Meftal Spas 60 ML
Meftal Spas
Rosulip 5
R.B Tone
KZ Lotion
Montair LC Kid
Vidaglo M 50/1000
Strepsils
Veet Cream Dry
Aptamil Gold 2R
Vicks Jar 275
Dettol 60 ML
Karvol Plus
Zandu Balm 10 GM
Savlon 50 ML
Dexolac 2
Aptamil Gold 1R
Lal Tail 100 ML
Himalaya Baby Powder
Montair LC
Volini Gel 30 GM
Ciplox
Monocef-O 100
Betnovate-N
Betnovate-C
Allegra M
Gabaneuron SR
Voveran Emulgel
Clavam 375 MG
Nevelon
Zifi
Bilafav 20 MG
Monocef-O 50
Telmed AM
Ciplox-D
Waxort
Calpol
Tryptometer 25 MG
CCM
Telma 40
Trenaxa MF
Geminor-MP2
Johnson Baby
Dr. Ortho 60 ML
Cetcip
Medisalic
Ketocip
Medisalic
`;

// Input data as a single string (you might read this from a file in an actual use case)
const generic = `
Aristozym
Combliflam
Thyrox 62.5
Clavam Dry Syrup
Clavam BID D/S
Sinarest New
Betadine
Roxid-150
Aciloc AD-20
Manforce-100
Uprise D3
Dolo-120
Livogen
Bicosules
Arkamin
Ultracet
Urimax-D
Ursocol-300 MG
Gluconorm G-2
Piriton CS
Levoflox 500 MG
Atarax 10 MG
Augmentin Duo
Gabaneuron NT 400
Glipon MF 20/500
Folinext
Gluconorm G-2
Thromrophob
Amlosafe 5
Vertin 16
Dolo 650
Benadryl 50 ML
Dexorange
Pantocid 40
Ornof
Aceclo Plus
Amlosafe 2.5
Ambrodil S
Asthalin
Benadryl 150 ML
Pantop-D SR
Betnovate-N
Almox 500
Cyston
Volini
T-Bact 5 GM
Kayam-Churan 100 GM
Vicks
Moov 20 GM
Saridon
Becosules
Electral B Powder
Zincovit
Mycoderm
Ascabiol 50 ML
Calpol 250 MG
Lukol
Taxim O CV 200 MG
Taxim O Forte
Zerodol SP
Zyloric 100 MG
A to Z
Noworm
Lantus
Ondem MD4
Lumerax 80
Crocin 120
Lantus Solostar
Betadine
Human Mixtard 40
Stayfree 6-XL
Stayfree 18-XL
Whisper 6-XL
Whisper 18-XL
BD Pen Needle 4 MM
Amitone 10 MG
Candid 120 GM
Rosuvas 5 MG
Candibiotic Plus
Rosuvas 10 MG
Decolic
Azithral 100 MG
Azithral 200 MG
Glycomet GP 3 Fort
Glycomet GP 3 Fort
MVI
Meftal Spas 60 ML
Meftal Spas
Rosulip 5
R.B Tone
KZ Lotion
Montair LC Kid
Vidaglo M 50/1000
Strepsils
Veet Cream Dry
Aptamil Gold 2R
Vicks Jar 275
Dettol 60 ML
Karvol Plus
Zandu Balm 10 GM
Savlon 50 ML
Dexolac 2
Aptamil Gold 1R
Lal Tail 100 ML
Himalaya Baby Powder
Montair LC
Volini Gel 30 GM
Ciplox
Monocef-O 100
Betnovate-N
Betnovate-C
Allegra M
Gabaneuron SR
Voveran Emulgel
Clavam 375 MG
Nevelon
Zifi
Bilafav 20 MG
Monocef-O 50
Telmed AM
Ciplox-D
Waxort
Calpol
Tryptometer 25 MG
CCM
Telma 40
Trenaxa MF
Geminor-MP2
Johnson Baby
Dr. Ortho 60 ML
Cetcip
Medisalic
Ketocip
Medisalic
`;


const brandedProductArray = branded?.trim()?.split('\n')?.filter(line => line.trim() !== '');
export const BRANDED_PRODUCT_RECORDS = brandedProductArray?.map((productName, index) => ({
    _id: index + 1,
    ProductName: productName.trim()
}));


const genericProductArray = generic?.trim()?.split('\n')?.filter(line => line.trim() !== '');
export const GENERIC_PRODUCT_RECORDS = genericProductArray?.map((productName, index) => ({
    _id: index + 1,
    ProductName: productName.trim()
}));

export const WHOLESALERS = [
    { id: 1, name: 'Anand Pharmaceuticals' },
    { id: 2, name: 'Anipra Medicare' },
    { id: 3, name: 'Ankit Pharma' },
    { id: 4, name: 'Arya Agency' },
    { id: 5, name: 'Bansal Pharma' },
    { id: 6, name: 'Durga Drug Distributor' },
    { id: 7, name: 'Generic India' },
    { id: 8, name: 'Jai Shree Enterprises' },
    { id: 9, name: 'Jaya Pharma' },
    { id: 10, name: 'Jyoti Pharma' },
    { id: 11, name: 'Kalyani Pharma' },
    { id: 12, name: 'Khanna Pharma' },
    { id: 13, name: 'Maa Bhagwati' },
    { id: 14, name: 'Maa Gayatri Medico' },
    { id: 15, name: 'Naman Pharma' },
    { id: 16, name: 'New Baijnath Enterprises' },
    { id: 17, name: 'New Baijnath Pharma' },
    { id: 18, name: 'New Bansi Pharma' },
    { id: 19, name: 'New Somnath Distributor' },
    { id: 20, name: 'Raj Agency' },
    { id: 21, name: 'Rajdhani Agency' },
    { id: 22, name: 'Rajiv Pharma' },
    { id: 23, name: 'Rajni Pharma' },
    { id: 24, name: 'Ransh Pharma' },
    { id: 25, name: 'Shree Jwala Jee Agency' },
    { id: 26, name: 'Shree Pharma (Branch)' }
]

export const GOODS_RETURN_REASON = [
    { id: 1, name: 'Incorrect scheme' },
    { id: 2, name: 'Different Product' },
    { id: 3, name: 'Damaged Product' },
    { id: 4, name: 'Expired Item' },
    { id: 5, name: 'Extra Quantities' }
]

// Helper to remove duplicates
export const removeDuplicates = (data) => {
    const uniqueData = [];
    const productNames = new Set();

    data.forEach((item) => {
        const name = item.ProductName?.toLowerCase()?.trim();
        if (name && !productNames.has(name)) {
            productNames.add(name);
            uniqueData.push(item);
        }
    });

    return uniqueData;
};

export const extractNumber = (inputString) => {
    // Use a regular expression to match digits
    const match = inputString?.match(/\d+/);
    
    // If a match is found, return the number as an integer, otherwise return 0
    return match ? parseInt(match[0], 10) : 0;
}

